import { rsBranding, logosTiles, logos, verticals as verticals$q, ixlBranding, social, images, productSample, animations, productUnits } from '@resourcehub/resourcehub-assets';
import * as React from 'react';
import React__default from 'react';

const marketSharedAnalytics = {
    gtm_id: "GTM-TLH67WS"
};

var headerRsLogo = ({ strings }) => ({
    visible: true,
    image: {
        type: "static",
        src: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
    },
    link: {
        destination: "/",
        external: false,
        new_window: false
    }
});

var nav_primary_config$8 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: "https://blog.rosettastone.com/",
        external: true,
        new_window: true,
        label: ""
    },
    contact: {
        visible: false,
        destination: "/contact/",
        external: true,
        new_window: true,
        label: strings.nav_primary_contact_label
    },
    rs_logo: headerRsLogo({ strings }),
    phone: {
        visible: true,
        external: false,
        new_window: false,
        destination: "tel:+861056341576",
        label: strings.nav_primary_phone_label,
        number: strings.nav_primary_phone_number
    },
    select_language: {
        visible: false,
        external: false,
        new_window: false,
        language_options_featured: [
            {
                url: "/buy-spanish/",
                title: strings.locale_es_la_label_primary,
                small: strings.locale_es_la_label_secondary
            },
            {
                url: "/buy-french/",
                title: strings.locale_fr_fr_label_primary,
                small: strings.locale_fr_fr_label_secondary
            },
            {
                url: "/buy-italian/",
                title: strings.locale_it_it_label_primary,
                small: strings.locale_it_it_label_secondary
            },
            {
                url: "/buy-german/",
                title: strings.locale_de_de_label_primary,
                small: strings.locale_de_de_label_secondary
            },
            {
                url: "/buy-english/",
                title: strings.locale_en_us_label_primary,
                small: strings.locale_en_us_label_secondary
            }
        ],
        language_options_other: [
            {
                url: "/buy-arabic/",
                title: strings.locale_ar_ar_label_primary,
                small: strings.locale_ar_ar_label_secondary
            },
            {
                url: "/buy-chinese/",
                title: strings.locale_zn_cn_label_primary,
                small: strings.locale_zn_cn_label_secondary
            },
            {
                url: "/buy-dutch/",
                title: strings.locale_nl_nl_label_primary,
                small: strings.locale_nl_nl_label_secondary
            },
            {
                url: "/buy-english-british/",
                title: strings.locale_en_gb_label_primary,
                small: strings.locale_en_gb_label_secondary
            },
            {
                url: "/buy-tagalog/",
                title: strings.locale_tl_ph_label_primary,
                small: strings.locale_tl_ph_label_secondary
            },
            {
                url: "/buy-greek/",
                title: strings.locale_el_gr_label_primary,
                small: strings.locale_el_gr_label_secondary
            },
            {
                url: "/buy-hebrew/",
                title: strings.locale_he_il_label_primary,
                small: strings.locale_he_il_label_secondary
            },
            {
                url: "/buy-hindi/",
                title: strings.locale_hi_in_label_primary,
                small: strings.locale_hi_in_label_secondary
            },
            {
                url: "/buy-irish/",
                title: strings.locale_ga_ie_label_primary,
                small: strings.locale_ga_ie_label_secondary
            },
            {
                url: "/buy-japanese/",
                title: strings.locale_ja_jp_label_primary,
                small: strings.locale_ja_jp_label_secondary
            },
            {
                url: "/buy-korean/",
                title: strings.locale_ko_kr_label_primary,
                small: strings.locale_ko_kr_label_secondary
            },
            {
                url: "/buy-latin/",
                title: strings.locale_ko_kr_label_primary,
                small: strings.locale_ko_kr_label_secondary
            },
            {
                url: "/buy-farsi/",
                title: strings.locale_fa_ir_label_primary,
                small: strings.locale_fa_ir_label_secondary
            },
            {
                url: "/buy-polish/",
                title: strings.locale_pl_pl_label_primary,
                small: strings.locale_pl_pl_label_secondary
            },
            {
                url: "/buy-portuguese/",
                title: strings.locale_pt_br_label_primary,
                small: strings.locale_pt_br_label_secondary
            },
            {
                url: "/buy-russian/",
                title: strings.locale_ru_ru_label_primary,
                small: strings.locale_ru_ru_label_secondary
            },
            {
                url: "/buy-spanish-spain/",
                title: strings.locale_es_es_label_primary,
                small: strings.locale_es_es_label_secondary
            },
            {
                url: "/buy-swedish/",
                title: strings.locale_sv_se_label_primary,
                small: strings.locale_sv_se_label_secondary
            },
            {
                url: "/buy-turkish/",
                title: strings.locale_tr_tr_label_primary,
                small: strings.locale_tr_tr_label_secondary
            },
            {
                url: "/buy-vietnamese/",
                title: strings.locale_vi_vn_label_primary,
                small: strings.locale_vi_vn_label_secondary
            }
        ],
        select_language_label: strings.nav_primary_catalog_select_language_label,
        label: strings.nav_primary_catalog_label,
        homeschool_label: strings.nav_primary_vertical_education_homeschool_label,
        homeschool_destination: "/homeschool/",
        product_title: strings.global_brand_name
    },
    sign_in: {
        visible: false,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_primary_sign_in_label
    },
    switch_language: {
        visible: false,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_primary_switch_language
    },
    support: {
        visible: false,
        destination: "https://support.rosettastone.com/cn/",
        external: true,
        new_window: false,
        label: strings.nav_primary_support_label
    },
    vertical_consumer: {
        visible: false,
        destination: "/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
        visible: false,
        destination: "/homeschool/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
        visible: true,
        destination: "/education/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
        visible: true,
        destination: "/training-centers/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
        visible: false,
        destination: "/students/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
        visible: true,
        destination: "/business/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_enterprise_label
    }
});

var awards$8 = ({ strings }) => [
    {
        image: {
            type: "static",
            alt: strings.awards_twitter,
            src: logosTiles.logosTilesTwitterSvg
        }
    },
    {
        image: {
            type: "static",
            alt: strings.awards_bmw,
            src: logosTiles.logosTilesBmwSvg
        }
    },
    {
        image: {
            type: "static",
            alt: strings.awards_uber,
            src: logosTiles.logosTilesUberSvg
        }
    },
    {
        image: {
            type: "static",
            alt: strings.awards_williams_sonoma,
            src: logosTiles.logosTilesWsSvg
        }
    }
];

var copyData$8 = () => ({
    about_us: null,
    about_us_url: null,
    agreements: "协议",
    agreements_url: "https://www.rosettastone.com/legal/agreements",
    almost_there: "快要完成了！",
    american: "（美国）",
    anti_piracy: "反盗版",
    anti_piracy_url: "https://www.rosettastone.com/anti-piracy",
    arabic: "阿拉伯",
    award_section_header: "顶级组织信任25+年。",
    blog_url: null,
    brasil: "Brasil",
    brasil_url: "https://www.rosettastonebrasil.com/",
    brazil: "（巴西）",
    british: "（英国）",
    business_contact_title: "业务 - 请求定价",
    careers: "职业发展",
    careers_url: "https://www.rosettastone.com/careers",
    cart_checkout: null,
    cart_checkout_url: null,
    cart_discount: null,
    cart_empty: null,
    cart_in_your_cart: null,
    cart_subtotal: null,
    cart_summary: null,
    cart_total: null,
    cart_you_have: null,
    change_region: "变更地区：",
    china: "中国",
    china_url: "http://www.rosettastone.cn/",
    combined_resources_url: "/business/resources/",
    company: "关于我们",
    connect: null,
    consumer_home: null,
    contact: "联系我们",
    contact_description: "要求定价表",
    contact_ee_url: "/contact/",
    contact_url: "https://www.rosettastone.cn/business/contact/",
    cta_bar: "准备好下一步了吗？",
    cta_h2: "准备好下一步了吗？",
    cta_text: `价格 `,
    currency: null,
    demo_pricing_subtitle_business: "了解我们的业务解决方案如何帮助您的公司吸引人才并提高生产力。 填写下面的表格，我们会尽快与您联系。",
    demo_pricing_subtitle_hed: "了解我们的高级解决方案如何帮助您的学习者自信地讲一门新语言。 填写下面的表格，我们会尽快与您联系。",
    demo_pricing_subtitle_k12: "了解我们的教育解决方案如何帮助您的英语和世界语言学习者充满自信地说话。 填写下面的表格，我们会尽快与您联系。",
    demo_pricing_subtitle_pub: "了解我们的公共部门解决方案如何改善与您服务对象的沟通。 填写下面的表格，我们会尽快与您联系。",
    demo_pricing_title: "获得免费咨询",
    deutschland: "Deutschland",
    deutschland_url: "https://www.rosettastone.de/",
    download_pdf: "下载PDF",
    dutch: "荷兰人",
    english: "英语",
    espana: "España",
    espana_url: "https://www.rosettastone.es/",
    europe: "Europa",
    europe_url: "https://www.rosettastone.eu/",
    facebook_url: null,
    faq_url: null,
    faqs: null,
    farsi: "（波斯语）",
    filipino: "菲律宾",
    for_business: "企业",
    for_business_resources_url: "/business/resources/",
    for_business_solutions_url: "/business/language-solutions/",
    for_business_url: "/business/home/",
    for_educators: "培训中心",
    for_educators_resources_url: "/business/resources",
    for_educators_solutions_url: "/training-centers/language-solutions/",
    for_educators_url: "/training-centers/home",
    for_hed: "高等教育",
    for_homeschool: null,
    for_homeschool_url: null,
    for_individuals: null,
    for_individuals_url: null,
    for_organizations: "组织",
    for_public_sector: null,
    for_public_sector_url: null,
    for_you: "为了你",
    form_100: "100或更少",
    form_500: "101 - 500",
    form_1000: "501 - 1,000",
    form_5000: "1,001 - 5,000",
    form_10000: "5,001 - 10,000",
    form_25000: "10,001 - 25,000",
    form_50000: "25,001 - 50,000",
    form_boardmember: "董事会成员",
    form_curriculumdirector: "课程总监/指导协调员",
    form_director: "主管",
    form_email: "电子邮箱（学校）",
    form_executive: "经理",
    form_firstname: "名",
    form_how_blog: null,
    form_how_email: "电子邮件",
    form_how_event: "事件",
    form_how_online: "线上",
    form_how_other: "其他",
    form_how_referral: "推荐",
    form_how_search: "搜索引擎",
    form_how_social: "社交媒体",
    form_how_title: "您是怎么知道我们的？ （可选的）",
    form_how_webinar: "网络研讨会",
    form_individualcontributor: "独立工作员工",
    form_lastname: "姓",
    form_manager: "总经理",
    form_more: "50,001  - 更多",
    form_organization: "企业／机构名称",
    form_organizationsize: "组织规模",
    form_phone: "电话 （可选的）",
    form_principal: "校长",
    form_privacy1: "通过确认，我同意接收有关Rosetta Stone产品和服务的新闻，更新以及Rosetta Stone活动邀请的信息和营销，我理解并同意Rosetta Stone可以处理并将我的信息传输给全球的附属公司 以及根据Rosetta Stone的规定，为Rosetta Stone提供服务的第三方实体",
    form_privacy2: "隐私政策",
    form_privacy3: "我了解我可以随时通过点击通讯中提供的链接或联系Rosetta Stone来选择退出此类通讯。",
    form_privacy4: "。",
    form_privacyUrl: "https://www.rosettastone.com/privacy",
    form_privacyemail: "privacyofficer@rosettastone.com",
    form_role: "角色（或头衔）",
    form_submit: "免费咨询",
    form_superintendent: "学监/区行政长官",
    form_teacher: "老师",
    form_techcoordinator: "技术协调员",
    form_updateagreement1: "是! 我想收到Rosetta Stone的产品更新和营销。",
    form_updateagreement2: "更多信息在這裡。",
    form_updateagreement3: null,
    form_vicepresident: "副总裁",
    france: "France",
    france_url: "https://www.rosettastone.fr/",
    google_plus_url: null,
    greek: "希腊语",
    gtm_id: null,
    has_combined_resources: true,
    has_resources: null,
    hebrew: "希伯来语",
    helpful_links: "请检查您的网址或使用以下有用链接之一进行关联：",
    hide_cart: true,
    hide_contact: true,
    hide_espanol: true,
    hide_language: true,
    hide_search: true,
    hide_support: true,
    hindi: "印地语",
    home: "主页",
    home_link: "/home/",
    home_url: "http://www.rosettastone.cn/",
    instagram_url: null,
    investors: "投资者关系",
    investors_url: "http://investors.rosettastone.com/",
    irish: "爱尔兰的",
    italia: "Italia",
    italia_url: "https://www.rosettastone.it/",
    item: null,
    item_plural: null,
    japan: "日本",
    japan_url: "http://www.rosettastone.co.jp",
    japanese: "日本",
    k12_contact_title: "培训中心 - 定价",
    keep_exploring: "继续探索",
    korea: "대한민국",
    korea_url: "https://www.rosettakorea.com/",
    korean: "朝鲜的",
    latin: null,
    latin_america: "（拉丁美洲）",
    latin_america_region: "America Latina",
    latin_america_region_url: "https://espanol.rosettastone.com/",
    learn_arabic_url: null,
    learn_chinese: "中文",
    learn_chinese_url: null,
    learn_dutch_url: null,
    learn_english: "学英语",
    learn_english_british_url: null,
    learn_english_url: null,
    learn_french: "学习法语",
    learn_french_url: null,
    learn_german: "学习德语",
    learn_german_url: null,
    learn_greek_url: null,
    learn_hebrew_url: null,
    learn_hindi_url: null,
    learn_irish_url: null,
    learn_italian: "学习意大利语",
    learn_italian_url: null,
    learn_japanese_url: null,
    learn_korean_url: null,
    learn_latin_url: null,
    learn_more: "了解更多",
    learn_persian_url: null,
    learn_polish_url: null,
    learn_portuguese_url: null,
    learn_russian_url: null,
    learn_spanish: "学西班牙语",
    learn_spanish_spain_url: null,
    learn_spanish_url: null,
    learn_swedish_url: null,
    learn_tagalog_url: null,
    learn_turkish_url: null,
    learn_vietnamese_url: null,
    lexia_learning: "阅读解决方案",
    lexia_learning_url: "http://www.lexialearning.com/",
    listen_now: "了解更多",
    madarin: "（普通话）",
    market: ["CN"],
    media_quote_1: "“我喜欢Rosetta Stone的软件，",
    media_quote_1_bold: "我认为他们学习语言的方法很有效。",
    media_quote_1_end: "”",
    media_quote_2: "“凭借其出色的用户界面，清晰的指令，各种各样的游戏和挑战......",
    media_quote_2_bold: "Rosetta Stone提供了这么多。",
    media_quote_2_end: "”",
    media_quote_3: "“基于计算机的语言学习的",
    media_quote_3_bold: "黄金标准。",
    media_quote_3_end: "”",
    more_resources_title: "其他资源",
    more_specify: "学到更多",
    no_support_dropdown: true,
    persian: "波斯语",
    polish: "抛光",
    portuguese: "葡萄牙语",
    press: "新闻",
    press_url: "http://pr.rosettastone.com/phoenix.zhtml?c=228009&p=irol-overview",
    pricing_subtitle: "请完成，我们会立即与您联系。",
    pricing_thanks: "感谢您对Rosetta Stone的关注！ 有人会尽快与您联系并提供有用的信息。",
    pricing_title: `了解您所需要的价格信息。 `,
    privacy_policy: "隐私政策",
    privacy_policy_url: "https://www.rosettastone.com/privacy/",
    products: "从哪里开始？",
    questions_call: "你有问题吗？ 打电话给我们",
    read_article: "了解更多",
    read_case_study: "了解更多",
    read_ebook: "了解更多",
    read_fact_sheet: "了解更多",
    read_guide: "了解更多",
    read_more: "了解更多",
    read_report: "了解更多",
    read_white_paper: "了解更多",
    related_resources_title: "相关资源",
    request_pricing: `价格 `,
    resources: "资源",
    resources_link: "/resources/",
    rosetta_copyright: "1999-2020 Rosetta Stone LLC.保留所有权利。 本网站使用cookies。 继续使用本网站即表示同意使用cookie。京ICP备09009396号-7",
    rosetta_stone: "Rosetta Stone",
    russian: "俄语",
    search: "搜索...",
    search_rosetta_url: null,
    select_lang: "选择一种语言：",
    services: null,
    services_url: null,
    shop_now: null,
    sign_in: null,
    sign_in_url: null,
    similar_resources: "类似的资源",
    site_not_found: "找不到网站 -  404",
    sitemap: null,
    sitemap_url: null,
    solutions: "语言解决方案",
    solutions_link: "/language-solutions/",
    spain: "（西班牙）",
    spanish: "西班牙语",
    support: "支持",
    support_business_url: "https://support.rosettastone.com/cn/business",
    support_chat: "实时技术支持聊天",
    support_chat_live: "实时技术支持聊天",
    support_chat_live_url: "https://rosettastone.secure.force.com/apex/PreLiveChatForm",
    support_chat_url: "https://support.rosettastone.com/cn/chat",
    support_classrooms: "支持教室和企业",
    support_faq_btn: null,
    support_faq_title: null,
    support_faq_url_1: null,
    support_faq_url_1_title: null,
    support_faq_url_2: null,
    support_faq_url_2_title: null,
    support_faq_url_3: null,
    support_faq_url_3_title: null,
    support_faq_url_4: null,
    support_faq_url_4_title: null,
    support_for_you: "支持你：",
    support_home: "帮助",
    support_site: "支持网站",
    support_site_url: "http://support.rosettastone.com/zh-CN/",
    swedish: "瑞典",
    switch_lang: null,
    switch_lang_url: null,
    system_reqs: null,
    system_reqs_url: null,
    tagalog: "（他加禄语）",
    telephone_atr: "Beijing (+86 10 5634 1576)",
    telephone_text: "Beijing (+86 10 5634 1576)",
    terms_conditions: "条款和条件",
    terms_conditions_url: "https://www.rosettastone.com/terms/",
    title: "cn-copy",
    turkish: "土耳其",
    twitter_url: null,
    united_kingdom: "United Kingdom",
    united_kingdom_url: "https://www.rosettastone.co.uk/",
    united_states: "United States",
    united_states_url: "https://www.rosettastone.com",
    use_new_header: null,
    vertical: ["recECBjZxFEWVVls8"],
    vertical_business: "企业",
    vertical_business_link: "/business/home/",
    vertical_healthcare: null,
    vertical_healthcare_link: null,
    vertical_hed: "高等教育",
    vertical_hed_link: "/education/home/",
    vertical_k12: "培训中心 ",
    vertical_k12_link: "/training-centers/home/",
    vertical_pub: null,
    vertical_pub_link: null,
    verticals_subtitle: "我们屡获殊荣的语言解决方案适用于所有类型的学习者。",
    verticals_title: "你是什么类型的学习者？",
    vietnamese: "越南",
    view_infographic: "了解更多",
    watch_video: "了解更多",
    watch_webinar: "了解更多",
    youtube_url: null
});

var branded_quotes$8 = ({ strings }) => [
    {
        name: strings.branded_quotes_macworld_name,
        type: strings.branded_quotes_macworld_type,
        quote: strings.branded_quotes_macworld_quote,
        logo: {
            type: "static",
            src: logos.logoMacworldSvg
        },
        backdrop: logos.logoMacworldBgSvg
    },
    {
        name: strings.branded_quotes_techcrunch_name,
        type: strings.branded_quotes_techcrunch_type,
        quote: strings.branded_quotes_techcrunch_quote,
        logo: {
            type: "static",
            src: logos.logoTechcrunchSvg
        },
        backdrop: logos.logoTechcrunchBgSvg
    },
    {
        name: strings.branded_quotes_cnn_name,
        type: strings.branded_quotes_cnn_type,
        quote: strings.branded_quotes_cnn_quote,
        logo: {
            type: "static",
            src: logos.logoCnnSvg
        },
        backdrop: logos.logoCnnBgSvg
    }
];

var lead_generation_bar$m = () => {
    return {
        visible: true,
        dataQa: "lead generation bar",
        lead_generation_button: {
            schedule_appointment: false,
            completion_redirect: null,
            button: {
                destination: "/business/pricing-request/",
                new_window: false,
                size: "regular",
                text: "价格",
                theme: "yellow_black"
            }
        },
        subtitle: {
            content: "",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        title: {
            content: "准备好下一步了吗？",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        }
    };
};

var verticals$p = ({ strings }) => [
    {
        image: {
            type: "static",
            alt: strings.verticals_education_primary,
            src: verticals$q.educationPrimaryCirclePng
        },
        link: {
            destination: "/training-centers/"
        },
        name: strings.verticals_education_primary,
        title: {
            content: strings.verticals_education_primary,
            type: "card-title"
        }
    },
    {
        image: {
            type: "static",
            alt: strings.verticals_education_secondary,
            src: verticals$q.educationSecondaryCirclePng
        },
        link: {
            destination: "/education/"
        },
        name: strings.verticals_education_secondary,
        title: {
            content: strings.verticals_education_secondary,
            type: "card-title"
        }
    },
    {
        image: {
            type: "static",
            alt: strings.verticals_enterprise,
            src: verticals$q.enterpriseCirclePng
        },
        link: {
            destination: "/business/"
        },
        name: strings.verticals_enterprise,
        title: {
            content: strings.verticals_enterprise,
            type: "card-title"
        }
    }
];

const consumer_page_config = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "dynamic-content") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "zh"
            },
            content: {
                copyData: copyData$8(),
                awards: awards$8({ strings }),
                branded_quotes: branded_quotes$8({ strings }),
                verticals: verticals$p({ strings })
            }
        };
    }
    if (page === "dynamic-resources") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "zh"
            },
            content: {
                hero: {
                    layout: "list",
                    panels: [
                        {
                            dataQa: "2",
                            layout: "image-right",
                            image: {
                                asset_static: null
                            },
                            title: {
                                content: "Enterprise Resources"
                            },
                            body: {
                                content: "Let Employees Speak For Themselves"
                            },
                            custom: {
                                cta: {
                                    destination: "/pricing-request/",
                                    theme: "yellow_black",
                                    internal: true,
                                    text: "价格"
                                }
                            }
                        }
                    ]
                },
                copyData: copyData$8(),
                awards: awards$8({ strings }),
                branded_quotes: branded_quotes$8({ strings }),
                verticals: verticals$p({ strings })
            }
        };
    }
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "企业语言培训 | Rosetta Stone",
                meta_description: "企业语言培训 | Rosetta Stone: Rosetta Stone语言培训方案帮助员工提高商务英语和其它业务相关外语的语言能力。咨询价格",
                canonical_url: "https://www.rosettastone.cn/",
                lang: "zh"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                dataQa: "1",
                                layout: "list",
                                direction: "image-right",
                                title: {
                                    align: "left",
                                    content: "为企业、教育机构和培训中心提供全面的外语培训解决方案",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                image: {
                                    asset_fluid: null
                                },
                                body: {
                                    content: "您的员工和学生可在任何时间和地点通过Rosetta Stone 云计算外语学习平台开展专属的个性化外语学习。我们的移动应用全面针对当代学生的信息获取习惯，即使是繁忙的企业员工也能轻松在碎片时间里感受外语学习的魅力。电脑、平板或智能手机，都是您的连线学习的好伙伴。"
                                }
                            }
                        ]
                    }
                ],
                awards: awards$8({ strings }),
                branded_quotes: branded_quotes$8({ strings }),
                verticals: verticals$p({ strings }),
                lead_generation_bar: lead_generation_bar$m()
            }
        };
    }
    if (page === "pricing-request") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "定价请求 | Rosetta Stone",
                meta_description: "全球专业服务和咨询公司都面临着语言障碍，这限制了他们为客户提供服务、招聘员工以及在全球范围内发展业务的能力。 语言培训解决方案可帮助专业咨询公司更大限度地提高每位员工的计费时间，证明我们在整个组织的语言培训投资回报率富有意义。",
                canonical_url: "https://www.rosettastone.cn/business/pricing-request/",
                lang: "zh"
            },
            content: {
                title: {
                    type: "section-title",
                    theme: "yellow",
                    content: "立即与语言学习专家预约时间。"
                },
                sub_title: {
                    type: "section-sub-title",
                    theme: "white",
                    content: "请填写下面的表格，安排合适的时间来讨论我们如何为您提供帮助。"
                },
                lead_generation_form: {
                    title: {
                        theme: "blue",
                        type: "section-title",
                        content: "即将完成！"
                    },
                    fields: {
                        first_name: {
                            field_name: "first_name",
                            field_type: "text",
                            label: "名字",
                            required: true,
                            required_error: "请输入您的名字。"
                        },
                        last_name: {
                            field_name: "last_name",
                            type: "text",
                            label: "姓氏",
                            required: true,
                            required_error: "请输入您的姓氏。"
                        },
                        email: {
                            field_name: "email",
                            field_type: "email",
                            label: "电子邮件地址",
                            required: true,
                            required_error: "请输入您的电子邮件地址。",
                            validation_error: "Please enter a valid Email Address."
                        },
                        phone: {
                            field_name: "phone",
                            field_type: "tel",
                            label: "电话号码",
                            required: true,
                            required_error: null
                        },
                        organization_name: {
                            field_name: "organization_name",
                            field_type: "text",
                            label: "公司",
                            required: true,
                            required_error: "请输入您的公司名称。"
                        },
                        organization_size: {
                            field_name: "organization_size",
                            field_type: "text",
                            label: "公司规模",
                            required: true,
                            required_error: "请输入您的公司规模。",
                            options: [
                                { value: "", label: "" },
                                { value: "100 人或更少", label: "100 人或更少" },
                                { value: "101 - 500", label: "101 - 500" },
                                {
                                    value: "501 - 1,000",
                                    label: "501 - 1,000"
                                },
                                { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                {
                                    value: "10,001 - 25,000",
                                    label: "10,001 - 25,000"
                                },
                                {
                                    value: "25,001 - 50,000",
                                    label: "25,001 - 50,000"
                                },
                                {
                                    value: "100 人或更多",
                                    label: "100 人或更多"
                                }
                            ]
                        },
                        role: {
                            field_name: "title",
                            field_type: "select",
                            label: "职位",
                            required: true,
                            required_error: "请输入您的角色。"
                        }
                    },
                    button: {
                        as: "button",
                        type: "submit",
                        size: "regular",
                        text: "请求定价"
                    },
                    labels: {
                        form_privacy1: "通过确认，我同意接收有关Rosetta Stone产品和服务的新闻，更新以及Rosetta Stone活动邀请的信息和营销，我理解并同意Rosetta Stone可以处理并将我的信息传输给全球的附属公司 以及根据Rosetta Stone的规定，为Rosetta Stone提供服务的第三方实体",
                        form_privacy2: "隐私政策",
                        form_privacy3: "我了解我可以随时通过点击通讯中提供的链接或联系Rosetta Stone来选择退出此类通讯。",
                        form_privacy4: "。",
                        form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
                        form_privacyemail: "privacyofficer@rosettastone.com",
                        form_updateagreement1: "是! 我想收到Rosetta Stone的产品更新和营销。",
                        form_updateagreement2: "更多信息在這裡。",
                        form_updateagreement3: null
                    },
                    domain: ".cn",
                    dataQaLocation: "page"
                },
                awards: awards$8({ strings }),
                branded_quotes: branded_quotes$8({ strings }),
                verticals: verticals$p({ strings })
            }
        };
    }
    if (page === "pricing-request-complete") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "定价请求 | Rosetta Stone",
                meta_description: "全球专业服务和咨询公司都面临着语言障碍，这限制了他们为客户提供服务、招聘员工以及在全球范围内发展业务的能力。 语言培训解决方案可帮助专业咨询公司更大限度地提高每位员工的计费时间，证明我们在整个组织的语言培训投资回报率富有意义。",
                canonical_url: "https://www.rosettastone.cn/pricing-request-complete/",
                lang: "zh"
            },
            content: {
                title: {
                    align: "center",
                    content: "感谢您的关注！",
                    heading: "h1",
                    theme: "blue",
                    type: "page-title"
                },
                sub_title: {
                    align: "center",
                    heading: "h2",
                    content: "在会议开始之前查看一些其他资源！",
                    type: "page-sub-title"
                },
                resources_link: {
                    destination: "/resources/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "资源",
                    theme: "blue_white"
                },
                awards: awards$8({ strings }),
                branded_quotes: branded_quotes$8({ strings }),
                verticals: verticals$p({ strings })
            }
        };
    }
    if (page === "pricing-request-schedule") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.cn/pricing-request-schedule/",
                lang: "zh"
            },
            content: {
                awards: awards$8({ strings }),
                branded_quotes: branded_quotes$8({ strings }),
                verticals: verticals$p({ strings })
            }
        };
    }
    return pageConfig;
};

var footerIxlLogo = ({ strings }) => ({
    visible: true,
    image: {
        type: "static",
        src: ixlBranding.ixlLogoSvg,
        height: "45px",
        width: "110px",
        alt: strings.footer_meta_copyright_alt
    },
    link: {
        destination: "https://www.ixl.com/",
        external: false,
        new_window: false
    }
});

var footerRsLogo = ({ strings }) => ({
    visible: true,
    image: {
        type: "static",
        src: rsBranding.rsIconWhiteSvg,
        height: "45px",
        width: "50px",
        alt: strings.footer_meta_copyright_alt
    },
    link: {
        destination: "/",
        external: false,
        new_window: false
    }
});

var consumer_footer_config$3 = ({ strings }) => ({
    visible: true,
    cta: {
        visible: true,
        contact_modal: true,
        email_capture: false,
        market: "cn",
        domain: ".cn",
        vertical: "hed",
        page: "home",
        main_label: strings.footer_cta_pricing_label,
        sub_label: null,
        button_label: strings.footer_cta_pricing_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        form_firstname: strings.footer_cta_form_firstname,
        form_lastname: strings.footer_cta_form_lastname,
        form_email: strings.footer_cta_form_email,
        form_phone: strings.footer_cta_form_phone,
        form_country: strings.footer_cta_form_country,
        form_organization: strings.footer_cta_form_organization,
        form_organizationsize_100: strings.footer_cta_form_organizationsize_100,
        form_organizationsize_500: strings.footer_cta_form_organizationsize_500,
        form_organizationsize_1000: strings.footer_cta_form_organizationsize_1000,
        form_organizationsize_5000: strings.footer_cta_form_organizationsize_5000,
        form_organizationsize_10000: strings.footer_cta_form_organizationsize_10000,
        form_organizationsize_25000: strings.footer_cta_form_organizationsize_25000,
        form_organizationsize_50000: strings.footer_cta_form_organizationsize_50000,
        form_organizationsize_more: strings.footer_cta_form_organizationsize_more,
        form_organizationsize: strings.footer_cta_form_organizationsize,
        form_role: strings.footer_cta_form_role,
        form_role_individualcontributor: strings.footer_cta_form_role_individualcontributor,
        form_role_manager: strings.footer_cta_form_role_manager,
        form_role_executive: strings.footer_cta_form_role_executive,
        form_role_vicepresident: strings.footer_cta_form_role_vicepresident,
        form_role_director: strings.footer_cta_form_role_director,
        form_role_teacher: strings.footer_cta_form_role_teacher,
        form_role_techcoordinator: strings.footer_cta_form_role_techcoordinator,
        form_role_curriculumdirector: strings.footer_cta_form_role_curriculumdirector,
        form_role_principal: strings.footer_cta_form_role_principal,
        form_role_boardmember: strings.footer_cta_form_role_boardmember,
        form_role_superintendent: strings.footer_cta_form_role_superintendent,
        form_comments: strings.footer_cta_form_comments,
        footer_opt_in_text_before_button: strings.footer_cta_opt_in_text_before_button,
        footer_opt_in_learn_more_button_text: strings.footer_cta_opt_in_learn_more_button_text,
        footer_opt_in_text_after_button: strings.footer_cta_opt_in_text_after_button,
        footer_opt_in_learn_more_text_1: strings.footer_cta_opt_in_learn_more_text_1,
        footer_opt_in_learn_more_link_text_1: strings.footer_cta_opt_in_learn_more_link_text_1,
        footer_opt_in_learn_more_text_2: strings.footer_cta_opt_in_learn_more_text_2,
        footer_opt_in_learn_more_text_3: strings.footer_cta_opt_in_learn_more_text_3,
        footer_opt_in_learn_more_privacyemail: strings.footer_cta_opt_in_learn_more_privacyemail,
        footer_opt_in_learn_more_privacyUrl: strings.footer_cta_opt_in_learn_more_privacyUrl,
        footer_how_hear_blog: strings.footer_cta_how_hear_blog,
        footer_how_hear_email: strings.footer_cta_how_hear_email,
        footer_how_hear_event: strings.footer_cta_how_hear_event,
        footer_how_hear_online: strings.footer_cta_how_hear_online,
        footer_how_hear_referral: strings.footer_cta_how_hear_referral,
        footer_how_hear_title: strings.footer_cta_how_hear_title,
        footer_how_hear_search: strings.footer_cta_how_hear_search,
        footer_how_hear_social: strings.footer_cta_how_hear_social,
        footer_how_hear_webinar: strings.footer_cta_how_hear_webinar,
        footer_how_hear_other: strings.footer_cta_how_hear_other,
        form_submit: strings.footer_cta_form_submit,
        form_pricing_thanks: strings.footer_cta_form_pricing_thanks
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/training-centers/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_secondary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/education/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/business/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room?c=228009&p=irol-overview",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/business/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/cn",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            icpLabel: strings.footer_meta_icp_label,
            icpLink: strings.footer_meta_icp_link,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: false,
            label: "",
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: false,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStoneLatino/",
                    image: {
                        type: "static",
                        src: social.facebookDarkSvg
                    }
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/RosettaStoneUK",
                    image: {
                        type: "static",
                        src: social.twitterDarkSvg
                    }
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: {
                        type: "static",
                        src: social.instagramDarkSvg
                    }
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: {
                        src: social.youtubeDarkSvg
                    }
                }
            ]
        }
    }
});

var education_primary_nav_secondary_config$8 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: null,
        external: true,
        new_window: true,
        label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
        visible: true,
        destination: "/education/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
        visible: true,
        destination: "/resources/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
        visible: false,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_solutions_label,
        options: null
    },
    vertical_header: {
        visible: true,
        destination: "/education/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_label
    }
});

var verticals$o = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_education_primary,
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/training-centers/"
            },
            name: strings.verticals_education_primary,
            title: {
                content: strings.verticals_education_primary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_education_secondary,
                src: verticals$q.educationSecondaryCirclePng
            },
            link: {
                destination: "/education/"
            },
            name: strings.verticals_education_secondary,
            title: {
                content: strings.verticals_education_secondary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_enterprise,
                src: verticals$q.enterpriseCirclePng
            },
            link: {
                destination: "/business/"
            },
            name: strings.verticals_enterprise,
            title: {
                content: strings.verticals_enterprise,
                type: "card-title"
            }
        }
    ]
});

var education_primary_pages_config$8 = ({ page, strings }) => {
    switch (page) {
        case "home":
            return {
                page,
                helmet: {
                    meta_title: "高等教育在线语言学习 | Rosetta Stone",
                    meta_description: "Rosetta Stone 高等教育语言学习解决方案可以使学生随时在线学习英语和其它语言。具体价格请咨询。",
                    canonical_url: "https://www.rosettastone.cn/education/",
                    lang: "zh"
                },
                content: {
                    sections: [
                        {
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-right",
                                    video: {
                                        currentVideoUrl: "https://vimeo.com/591688104",
                                        controls: true
                                    },
                                    title: {
                                        content: "让语言学习对于每一个学生都触手可及。",
                                        align: "left",
                                        heading: "h2",
                                        type: "section-title"
                                    },
                                    justifyContent: "space-between",
                                    body: {
                                        content: "学生使用他们的智能手机就能与全世界连接。然而，学校都面临着语言项目的预算限制。这限制了学生潜在的学业和职业选择，以及他们的世界观。在全球化的经济体系中，外语能力是二十一世纪的工作所必需的。"
                                    },
                                    custom: {
                                        lead_generation_button: {
                                            schedule_appointment: false,
                                            completion_redirect: null,
                                            button: {
                                                destination: "/education/pricing-request/",
                                                new_window: false,
                                                size: "regular",
                                                text: "请求定价",
                                                theme: "yellow_black"
                                            }
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    visible: true,
                                    dataQa: "2",
                                    layout: "list",
                                    title: {
                                        dataQa: "2",
                                        content: "助力中国大学生外语学习。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    panels: [
                                        {
                                            left_option: {
                                                is_correct: true,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            right_option: {
                                                is_correct: false,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            challenge_text: "Una bicicleta azul"
                                        },
                                        {
                                            left_option: {
                                                is_correct: true,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            right_option: {
                                                is_correct: false,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            challenge_text: "Dos bicicletas azules"
                                        },
                                        {
                                            left_option: {
                                                is_correct: true,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            right_option: {
                                                is_correct: false,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            challenge_text: "Dos bicicletas azules por un día por favor"
                                        }
                                    ],
                                    body: {
                                        dataQa: "2",
                                        content: "很多高校学生能够高分通过传统的外语能力测试，但是实际语用能力还有待加强。Rosetta Stone语言学习方案通过外语浸泡的方式，帮助中国学生建立他们对于外语的自信心，并为他们的成功做好准备。"
                                    },
                                    data_qa: "2",
                                    direction: "image-left",
                                    link: {
                                        theme: "black",
                                        destination: "https://resources.rosettastone.com/CDN/cn/videos/RST-China-User-Testimonial-1.mp4",
                                        align: "left"
                                    },
                                    quote: "“它是一种沉浸式的学习过程，将听说读写相互结合”",
                                    attribution: "-- 浙江使用Rosetta Stone学习西班牙语的大学生"
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-right",
                                    title: {
                                        dataQa: "3",
                                        content: "沈阳大学——混合式英语教学使学生和老师受益。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    body: {
                                        dataQa: "3",
                                        content: "沈阳大学国际学院在接下来的教学中，会继续深化罗塞塔石平台在外语课堂教学中的应用。通过线上学习扩展课堂学习的时间和空间，结合教师端体现的学习数据，引导学生养成更好的外语学习方式。此外，将平台中的相关课程主题以及师生互动功能融入到课堂探究和讨论中，进一步结合线上自主学习和线下外语教学。"
                                    },
                                    image: {
                                        src: null
                                    },
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/shenyang-university-case-study/",
                                        align: "left"
                                    },
                                    quote: "“通过大量实际生活的图像、文字及声音，模拟真实的语言环境，将词汇和预压的学习完全融会在听、说、读、写思想能力的训练之中，并在训练过程中培养外语思维的能力。”",
                                    attribution: "--沈阳大学英语阅读与词汇课程授课教师"
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-left",
                                    title: {
                                        dataQa: "4",
                                        content: "真人在线面授课让语言学习者轻松张口表达。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    body: {
                                        dataQa: "4",
                                        content: "学生、老师和员工都想能够轻松地说一门新的外语。从语言学习转向现实世界则需要实践。在安全网络的空间中进行的在线面授课学习是一种明智高效的学习方式，学习者可以按照自己的外语级别与以此为母语的老师一起练习。"
                                    },
                                    image: {
                                        src: null
                                    },
                                    quote: "“Rosetta Stone语言学习方案是一项非常好的工具，它能帮助使用者评估他们的水平，并且提供了大量的交互式和多样化的学习体验，以促进个人的进步。”",
                                    attribution: "--坎特伯雷基督教会大学 课程协调老师 ",
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/case-study-canterbury-christ-church-university",
                                        align: "left"
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-right",
                                    title: {
                                        dataQa: "5",
                                        content: "云端语言实验室",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    body: {
                                        dataQa: "5",
                                        content: "移动应用程序的开发使得语言学习可以随时随地进行。学生拥有了更多接触课程材料的灵活性，而教学人员则可以专注于课堂内的一对一指导和协作性学习活动。"
                                    },
                                    image: {
                                        src: null
                                    },
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/case-study-humboldt-state-university",
                                        align: "left"
                                    },
                                    quote: "“在学期开始时和结束时进行的自适应性语言测试使得学生能够了解他们的起始水平以及他们通过这样的语言学习过程所取得的进步。”",
                                    attribution: "--洪堡州立大学 世界语言和文化实验室 主任"
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    pageData: {
                                        learner_feature_1_icon_name: "icon_24",
                                        learner_feature_1_subtitle: "英语和其它外语可满足学生的要求。",
                                        learner_feature_1_title: "24种语言",
                                        learner_feature_2_icon_name: "icon_dynamic",
                                        learner_feature_2_subtitle: "让学生沉浸在目标语言环境中以加速学习。",
                                        learner_feature_2_title: "沉浸式自主学习",
                                        learner_feature_3_icon_name: "icon_games",
                                        learner_feature_3_subtitle: "学生通过有趣的方式来强化他们所学习的内容。",
                                        learner_feature_3_title: "游戏社区",
                                        learner_feature_4_icon_name: "icon_truaccent",
                                        learner_feature_4_subtitle: "任何学生都可以使用的发音助手。",
                                        learner_feature_4_title: "TruAccent™语音识别",
                                        learner_feature_5_icon_name: "icon_tutoring",
                                        learner_feature_5_subtitle: "在安全的网络空间，针对每一个学生个体级别设置的课程。",
                                        learner_feature_5_title: "真人在线面授课程",
                                        learner_feature_6_icon_name: "icon_mobile",
                                        learner_feature_6_subtitle: "将学习资源放到每个学生的手中。",
                                        learner_feature_6_title: "移动应用",
                                        learner_feature_title: null
                                    }
                                }
                            ]
                        }
                    ],
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$o({ strings }),
                    lead_generation_bar: lead_generation_bar$m()
                }
            };
        case "pricing-request":
            return {
                page,
                helmet: {
                    meta_title: "定价请求 | Rosetta Stone",
                    meta_description: "全球专业服务和咨询公司都面临着语言障碍，这限制了他们为客户提供服务、招聘员工以及在全球范围内发展业务的能力。 语言培训解决方案可帮助专业咨询公司更大限度地提高每位员工的计费时间，证明我们在整个组织的语言培训投资回报率富有意义。",
                    canonical_url: "https://www.rosettastone.cn/education/pricing-request/",
                    lang: "zh"
                },
                content: {
                    title: {
                        type: "section-title",
                        theme: "yellow",
                        content: "立即与语言学习专家预约时间。"
                    },
                    sub_title: {
                        type: "section-sub-title",
                        theme: "white",
                        content: "请填写下面的表格，安排合适的时间来讨论我们如何为您提供帮助。"
                    },
                    lead_generation_form: {
                        title: {
                            theme: "blue",
                            type: "section-title",
                            content: "即将完成！"
                        },
                        fields: {
                            first_name: {
                                field_name: "first_name",
                                field_type: "text",
                                label: "名字",
                                required: true,
                                required_error: "请输入您的名字。"
                            },
                            last_name: {
                                field_name: "last_name",
                                type: "text",
                                label: "姓氏",
                                required: true,
                                required_error: "请输入您的姓氏。"
                            },
                            email: {
                                field_name: "email",
                                field_type: "email",
                                label: "电子邮件地址",
                                required: true,
                                required_error: "请输入您的电子邮件地址。",
                                validation_error: "Please enter a valid Email Address."
                            },
                            phone: {
                                field_name: "phone",
                                field_type: "tel",
                                label: "电话号码",
                                required: true,
                                required_error: null
                            },
                            organization_name: {
                                field_name: "organization_name",
                                field_type: "text",
                                label: "公司",
                                required: true,
                                required_error: "请输入您的公司名称。"
                            },
                            organization_size: {
                                field_name: "organization_size",
                                field_type: "text",
                                label: "公司规模",
                                required: true,
                                required_error: "请输入您的公司规模。",
                                options: [
                                    { value: "", label: "" },
                                    { value: "100 人或更少", label: "100 人或更少" },
                                    { value: "101 - 500", label: "101 - 500" },
                                    {
                                        value: "501 - 1,000",
                                        label: "501 - 1,000"
                                    },
                                    { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                    { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                    {
                                        value: "10,001 - 25,000",
                                        label: "10,001 - 25,000"
                                    },
                                    {
                                        value: "25,001 - 50,000",
                                        label: "25,001 - 50,000"
                                    },
                                    {
                                        value: "100 人或更多",
                                        label: "100 人或更多"
                                    }
                                ]
                            },
                            role: {
                                field_name: "title",
                                field_type: "select",
                                label: "职位",
                                required: true,
                                required_error: "请输入您的角色。"
                            }
                        },
                        button: {
                            as: "button",
                            type: "submit",
                            size: "regular",
                            text: "请求定价"
                        },
                        labels: {
                            form_privacy1: "通过确认，我同意接收有关Rosetta Stone产品和服务的新闻，更新以及Rosetta Stone活动邀请的信息和营销，我理解并同意Rosetta Stone可以处理并将我的信息传输给全球的附属公司 以及根据Rosetta Stone的规定，为Rosetta Stone提供服务的第三方实体",
                            form_privacy2: "隐私政策",
                            form_privacy3: "我了解我可以随时通过点击通讯中提供的链接或联系Rosetta Stone来选择退出此类通讯。",
                            form_privacy4: "。",
                            form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
                            form_privacyemail: "privacyofficer@rosettastone.com",
                            form_updateagreement1: "是! 我想收到Rosetta Stone的产品更新和营销。",
                            form_updateagreement2: "更多信息在這裡。",
                            form_updateagreement3: null
                        },
                        domain: ".cn",
                        dataQaLocation: "page"
                    },
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$o({ strings })
                }
            };
        case "pricing-request-complete":
            return {
                page,
                helmet: {
                    meta_title: "定价请求 | Rosetta Stone",
                    meta_description: "全球专业服务和咨询公司都面临着语言障碍，这限制了他们为客户提供服务、招聘员工以及在全球范围内发展业务的能力。 语言培训解决方案可帮助专业咨询公司更大限度地提高每位员工的计费时间，证明我们在整个组织的语言培训投资回报率富有意义。",
                    canonical_url: "https://www.rosettastone.cn/education/pricing-request-complete/",
                    lang: "zh"
                },
                content: {
                    title: {
                        align: "center",
                        content: "感谢您的关注！",
                        heading: "h1",
                        theme: "blue",
                        type: "page-title"
                    },
                    sub_title: {
                        align: "center",
                        heading: "h2",
                        content: "在会议开始之前查看一些其他资源！",
                        type: "page-sub-title"
                    },
                    resources_link: {
                        destination: "/resources/",
                        internal: true,
                        new_window: false,
                        size: "regular",
                        text: "资源",
                        theme: "blue_white"
                    },
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$o({ strings })
                }
            };
        case "pricing-request-schedule":
            return {
                page,
                helmet: {
                    meta_title: "Pricing Request | Rosetta Stone",
                    meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.cn/education/pricing-request-schedule/",
                    lang: "zh"
                },
                content: {
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$o({ strings })
                }
            };
        default:
            return null;
    }
};

var education_primary_footer_config$8 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/training-centers/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_secondary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/education/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/business/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room?c=228009&p=irol-overview",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/business/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/cn",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            icpLabel: strings.footer_meta_icp_label,
            icpLink: strings.footer_meta_icp_link,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: false,
            label: "",
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: false,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStoneLatino/",
                    image: {
                        src: social.facebookDarkSvg
                    }
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/RosettaStoneUK",
                    image: {
                        type: "static",
                        src: social.twitterDarkSvg
                    }
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: {
                        type: "static",
                        src: social.instagramDarkSvg
                    }
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: {
                        type: "static",
                        src: social.youtubeDarkSvg
                    }
                }
            ]
        }
    }
});

var education_secondary_nav_secondary_config$6 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: null,
        external: true,
        new_window: true,
        label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
        visible: true,
        destination: "/training-centers/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
        visible: true,
        destination: "/resources/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
        visible: true,
        destination: "/training-centers/language-solutions/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
        visible: true,
        destination: "/training-centers/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_label
    }
});

var verticals$n = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_education_primary,
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/training-centers/"
            },
            name: strings.verticals_education_primary,
            title: {
                content: strings.verticals_education_primary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_education_secondary,
                src: verticals$q.educationSecondaryCirclePng
            },
            link: {
                destination: "/education/"
            },
            name: strings.verticals_education_secondary,
            title: {
                content: strings.verticals_education_secondary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_enterprise,
                src: verticals$q.enterpriseCirclePng
            },
            link: {
                destination: "/business/"
            },
            name: strings.verticals_enterprise,
            title: {
                content: strings.verticals_enterprise,
                type: "card-title"
            }
        }
    ]
});

var education_secondary_pages_config$6 = ({ page, strings }) => {
    switch (page) {
        case "home":
            return {
                page,
                helmet: {
                    meta_title: "K-12在线语言学习 | Rosetta Stone",
                    meta_description: "Rosetta Stone K-12混合式语言学习解决方案包含了教师教案指导，学生可随时使用，以帮助学习或提高英语或其他语种的语言技能。",
                    canonical_url: "https://www.rosettastone.cn/training-centers/",
                    lang: "zh"
                },
                content: {
                    sections: [
                        {
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-right",
                                    video: {
                                        currentVideoUrl: "https://vimeo.com/591688104",
                                        controls: true
                                    },
                                    title: {
                                        content: "将语言学习搬到线上。",
                                        align: "left",
                                        heading: "h2",
                                        type: "section-title"
                                    },
                                    justifyContent: "space-between",
                                    body: {
                                        content: "为帮助学生掌握一门新的语言，老师知道这需要学生进行充分的练习。Rosetta Stone拥有一套独特的方法，使您的学生从零基础开始，练习说英语或其它外语。帮助他们满怀信心和准备充分地在教室内外去自信表达自己。"
                                    },
                                    custom: {
                                        lead_generation_button: {
                                            schedule_appointment: false,
                                            completion_redirect: null,
                                            button: {
                                                destination: "/training-centers/pricing-request/",
                                                new_window: false,
                                                size: "regular",
                                                text: "请求定价",
                                                theme: "yellow_black"
                                            }
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    visible: true,
                                    dataQa: "2",
                                    layout: "list",
                                    title: {
                                        dataQa: "2",
                                        content: "给学生更多学习的方式。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    panels: [
                                        {
                                            left_option: {
                                                is_correct: true,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            right_option: {
                                                is_correct: false,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            challenge_text: "Una bicicleta azul"
                                        },
                                        {
                                            left_option: {
                                                is_correct: true,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            right_option: {
                                                is_correct: false,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            challenge_text: "Dos bicicletas azules"
                                        },
                                        {
                                            left_option: {
                                                is_correct: true,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            right_option: {
                                                is_correct: false,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            challenge_text: "Dos bicicletas azules por un día por favor"
                                        }
                                    ],
                                    body: {
                                        dataQa: "2",
                                        content: "从第一课开始，学生听、说和读的每一个词都是用他们所学习的新语言。这就是最自然的语言学习方式：沉浸式。从单词到词组到句子，无所畏惧。所以当到了问答环节时，老师可以有充分的信心，学生已经做好了准备。"
                                    },
                                    data_qa: "2",
                                    direction: "image-left",
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/case-study-pueblo-city-schools",
                                        align: "left"
                                    },
                                    quote: "“孩子们都是技术驱动的，所以他们喜爱使用这个项目。Advantage让我们能够接触到以其它方式无法触及的学生。”",
                                    attribution: "——普韦布洛市学校 外国语言联络人"
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-right",
                                    title: {
                                        dataQa: "3",
                                        content: "和羞于开口说再见。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    body: {
                                        dataQa: "3",
                                        content: "说一种新的语言在一开始的时候可能会听起来怪怪的。在课堂里害怕犯错可能会让学生羞于开口说话。我们的TruAccent™语音识别引擎可以不带任何偏见地指导发音，提升学生的自信心，从而加速语言的学习。"
                                    },
                                    image: {
                                        src: null
                                    },
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/case-study-corona-norco-unified-school-district",
                                        align: "left"
                                    },
                                    quote: "“Rosetta Stone通过提供用自己的发音进行听力练习的机会和对情感过滤因素的降低，增强了口语表达的信心。”",
                                    attribution: "——科洛纳-诺科联合学区英语学习部教育服务管理员"
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-left",
                                    title: {
                                        dataQa: "4",
                                        content: "真人在线面授课让对话保持真实。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    body: {
                                        dataQa: "4",
                                        content: "老师们想要他们的学生可以轻松地讲一门新的语言，但是语言学习和真实世界之间有着一条巨大的鸿沟。我们的真人在线课堂让学生可以基于自己的外语级别与以此为母语的老师一起练习语言。这使得在我们的安全网络空间中进行的辅导课程成为一种明智高效的学习方式。"
                                    },
                                    image: {
                                        src: null
                                    },
                                    quote: "“学生对于这个项目的反馈出乎意料地好。我们的协作课堂感觉更像是一个大家庭……”",
                                    attribution: "——贝塞尔高中 课程协调和西班牙语老师",
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/customer-spotlight-bethel-public-schools",
                                        align: "left"
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-right",
                                    title: {
                                        dataQa: "5",
                                        content: "学生可以在任何地方进行的语言学习。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    body: {
                                        dataQa: "5",
                                        content: "课堂学习依然是学生们的日常标准。但是学校正在使得课堂外的学习变得更加简单。我们的移动应用程序使您的学生可以在任何方便的时候学习课程并参与活动。他们从而拥有了将任何时刻转变为学习时刻的自由。"
                                    },
                                    image: {
                                        src: null
                                    },
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/customer-spotlight-phoenix-union-high-school-district",
                                        align: "left"
                                    },
                                    quote: "“我们看到那些跟着Rosetta Stone学习的学生变得更加有动力更加有信心，更愿意参与到课堂活动中，并且学习词汇的速度也快了很多。”",
                                    attribution: "——凤凰城联合高中 英语老师"
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    pageData: {
                                        learner_feature_1_icon_name: "icon_24",
                                        learner_feature_1_subtitle: "英语和其它外语以满足学生的目标。",
                                        learner_feature_1_title: "24种语言",
                                        learner_feature_2_icon_name: "icon_dynamic",
                                        learner_feature_2_subtitle: "让学生沉浸在语言环境中以加速学习。",
                                        learner_feature_2_title: "沉浸式自主学习",
                                        learner_feature_3_icon_name: "icon_games",
                                        learner_feature_3_subtitle: "学生通过有趣的方式来强化他们所学习的内容。",
                                        learner_feature_3_title: "游戏社区",
                                        learner_feature_4_icon_name: "icon_truaccent",
                                        learner_feature_4_subtitle: "任何学生都可以使用的发音助手。",
                                        learner_feature_4_title: "TruAccent™语音识别",
                                        learner_feature_5_icon_name: "icon_tutoring",
                                        learner_feature_5_subtitle: "在安全的网络空间，针对每一个学生的不同级别而设计。",
                                        learner_feature_5_title: "真人在线课程",
                                        learner_feature_6_icon_name: "icon_mobile",
                                        learner_feature_6_subtitle: "将学习资源放到每个学生的手中。",
                                        learner_feature_6_title: "移动应用程序",
                                        learner_feature_title: "无论在线与否，我们屡获殊荣的应用都是不言而喻的"
                                    }
                                }
                            ]
                        }
                    ],
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$n({ strings }),
                    lead_generation_bar: lead_generation_bar$m()
                }
            };
        case "solutions":
            return {
                page,
                helmet: {
                    meta_title: "K-12在线语言学习方案| Rosetta Stone",
                    meta_description: "Rosetta Stone在线语言学习方案激励英语学习者和其它语种的学习者充满自信地开口说话。具体价格请咨询。",
                    canonical_url: "https://www.rosettastone.cn/training-centers/solutions/",
                    lang: "zh"
                },
                content: {
                    sections: [
                        {
                            layout: "list",
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-right",
                                    video: {
                                        currentVideoUrl: "https://vimeo.com/594888236",
                                        controls: true
                                    },
                                    title: {
                                        content: "我们的K-12学习解决方案支持任何的语言学习者。",
                                        align: "left",
                                        heading: "h2",
                                        type: "section-title"
                                    },
                                    justifyContent: "space-between",
                                    body: {
                                        content: "对于学习一门新的语言，不同的学生有不同的目的。有的学生是英语学习的初学者，期待能和同伴们用英语交谈。有的学生学习外语，希望将来能体验和感受另一种文化。无论他们的语言目标是什么，学生们都可以通过我们屡获殊荣的K-12学习方案来提升他们的口语自信心。"
                                    },
                                    custom: {
                                        lead_generation_button: {
                                            schedule_appointment: false,
                                            completion_redirect: null,
                                            button: {
                                                destination: "/pricing-request/",
                                                new_window: false,
                                                size: "regular",
                                                text: "请求定价",
                                                theme: "yellow_black"
                                            }
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    body: {
                                        dataQa: "2",
                                        content: "那些只能说一点或完全不能说英语的学生会在教室门口犹豫。直到他们能学会自信地讲英语，那种被孤立的感觉才会消失。Rosetta Stone® English for Education包含了英语学习者、他们的老师和家人所需要的全部资源。这符合平等教育项目的目标：给予每一位学生同等的机会去享有获得学业成功所需的学习工具。"
                                    },
                                    data_qa: "2",
                                    direction: "image-left",
                                    layout: "list",
                                    title: {
                                        dataQa: "2",
                                        content: "为英语学习者提供公平的教育资源。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    image: {
                                        src: null
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    body: {
                                        dataQa: "3",
                                        content: "对语言的兴趣可能来自一部电影、一本书、一个网友或者身边的朋友。无论学生们是如何变得具备全球意识，最有用的下一步就是让他们学一门外语。选择Rosetta Stone学校项目能够帮助学生提高语言技能，让他们的全球意识带他们走得更高、更远。"
                                    },
                                    data_qa: "3",
                                    direction: "image-right",
                                    layout: "list",
                                    title: {
                                        dataQa: "3",
                                        content: "将学生和语言与文化相连接。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    image: {
                                        src: null
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    body: {
                                        dataQa: "4",
                                        content: "当学生渴望学习时，每一天在课堂的学习都非常宝贵。对于那些同时还在学习英语的学生来说，要保持进度就非常重要。Rosetta Stone® English for Education使得家人有机会参与到学生的英语学习中。这样全方位的支持，使得学生能够快速与老师和同学连接，从而获得更大的学业成就。"
                                    },
                                    data_qa: "4",
                                    direction: "image-left",
                                    layout: "list",
                                    title: {
                                        dataQa: "4",
                                        content: "让学习英语成为一家人的努力。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    image: {
                                        src: null
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    data_qa: "5",
                                    img_bg_top: images.solSection_7StoneBlueSvg,
                                    img_bg_bottom: images.solSection_7StoneYellowSvg,
                                    data: {
                                        feature_1_img: "icon_dynamic",
                                        feature_1_subtitle: "通过让学生沉浸在一门新语言的环境中，进行自主学习，帮助学生提升听说读写能力，培养全新的思维方式，",
                                        feature_1_title: "动态沉浸式。",
                                        feature_2_img: "icon_truaccent",
                                        feature_2_subtitle: "即时发音反馈能够指导学生正确说出新的语言，使学生感受到及时的学习回馈，增强口语自信心。",
                                        feature_2_title: "TruAccent语音识别。",
                                        feature_3_img: "icon_tutoring",
                                        feature_3_subtitle: "基于学生当前的语言水平和学习内容，与母语使用者进行针对性练习和对话，帮助他们更适应讲新的语言。",
                                        feature_3_title: "真人在线课。",
                                        feature_4_img: "icon_24",
                                        feature_4_subtitle: "将英语和其它外语整合到任何语言项目中，帮助任何语言水平的学生发展并提高语言技能。",
                                        feature_4_title: "24种语言。",
                                        feature_5_img: "icon_assessments",
                                        feature_5_subtitle: "English for Education可提供帮助全家人一起提高英语能力的每周学习资源，以及针对学习英语的西班牙语家庭设计每月网络课程。",
                                        feature_5_title: "连接家庭的资源。",
                                        feature_6_img: "icon_placement",
                                        feature_6_subtitle: "离线教师教案指导、练习册和课堂活动指导为老师们提供了支持课堂教学和完成在线课程的资源。",
                                        feature_6_title: "课堂教学支持。",
                                        feature_7_img: "icon_proficiency",
                                        feature_7_subtitle: "English for Education包括适用于6到12 年级的定级测试和进度测试，使得老师可以确定每一个学生开始学习英语的起点。",
                                        feature_7_title: "测试。",
                                        feature_8_img: "icon_foundational",
                                        feature_8_subtitle: "丰富的内容很容易吸引学生的参与，可以适应每一个学生的学习节奏和进度，在一个互动的空间专注于提高学生口语能力。",
                                        feature_8_title: "基础内容和高阶内容。",
                                        feature_9_img: "icon_games",
                                        feature_9_subtitle: "通过好玩而又有吸引力的方式强化词汇、语法和发音，提高学生阅读、听力和口语能力。",
                                        feature_9_title: "游戏与活动。",
                                        feature_10_img: "icon_reading",
                                        feature_10_subtitle: "对于每一个学习级别都有针对性的活动，包括提供即时语音回馈的大声朗读，特定目的的写作练习，以及听力与阅读理解。",
                                        feature_10_title: "阅读和写作。",
                                        feature_11_img: "icon_mobile",
                                        feature_11_subtitle: "学生能够在课堂内外使用智能手机和平板电脑获取课程内容和活动，从而增强对于技巧的练习和词汇的记忆。",
                                        feature_11_title: "移动应用。",
                                        feature_12_img: "icon_reporting",
                                        feature_12_subtitle: "通过使用进步和完成情况学习报告，即时查看个人、小组和班级表现，帮助老师和管理员方便地了解学生情况。",
                                        feature_12_title: "报告工具。 ",
                                        feature_13_img: "icon_transferable",
                                        feature_13_subtitle: "简化的授权管理使得老师和管理员可以快速地重新安排学生，以确保充分利用所有的账号授权，从而提高项目的回报率。",
                                        feature_13_title: "灵活的账号类型。",
                                        feature_14_img: "icon_implementation",
                                        feature_14_subtitle: "我们的团队将语言学习目标结合到有效的模型中，并帮助学校和学区规划、实施和推广项目。",
                                        feature_14_title: "实施支持。",
                                        feature_15_img: "icon_training",
                                        feature_15_subtitle: "提供对于管理员和老师不同级别的培训，有助于成功开展混合式学习项目。",
                                        feature_15_title: "培训服务。",
                                        feature_section_title: "您需要的每个资源都可用"
                                    }
                                }
                            ]
                        }
                    ],
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$n({ strings }),
                    lead_generation_bar: lead_generation_bar$m()
                }
            };
        case "pricing-request":
            return {
                page,
                helmet: {
                    meta_title: "定价请求 | Rosetta Stone",
                    meta_description: "全球专业服务和咨询公司都面临着语言障碍，这限制了他们为客户提供服务、招聘员工以及在全球范围内发展业务的能力。 语言培训解决方案可帮助专业咨询公司更大限度地提高每位员工的计费时间，证明我们在整个组织的语言培训投资回报率富有意义。",
                    canonical_url: "https://www.rosettastone.cn/training-centers/pricing-request/",
                    lang: "zh"
                },
                content: {
                    title: {
                        type: "section-title",
                        theme: "yellow",
                        content: "立即与语言学习专家预约时间。"
                    },
                    sub_title: {
                        type: "section-sub-title",
                        theme: "white",
                        content: "请填写下面的表格，安排合适的时间来讨论我们如何为您提供帮助。"
                    },
                    lead_generation_form: {
                        title: {
                            theme: "blue",
                            type: "section-title",
                            content: "即将完成！"
                        },
                        fields: {
                            first_name: {
                                field_name: "first_name",
                                field_type: "text",
                                label: "名字",
                                required: true,
                                required_error: "请输入您的名字。"
                            },
                            last_name: {
                                field_name: "last_name",
                                type: "text",
                                label: "姓氏",
                                required: true,
                                required_error: "请输入您的姓氏。"
                            },
                            email: {
                                field_name: "email",
                                field_type: "email",
                                label: "电子邮件地址",
                                required: true,
                                required_error: "请输入您的电子邮件地址。",
                                validation_error: "Please enter a valid Email Address."
                            },
                            phone: {
                                field_name: "phone",
                                field_type: "tel",
                                label: "电话号码",
                                required: true,
                                required_error: null
                            },
                            organization_name: {
                                field_name: "organization_name",
                                field_type: "text",
                                label: "公司",
                                required: true,
                                required_error: "请输入您的公司名称。"
                            },
                            organization_size: {
                                field_name: "organization_size",
                                field_type: "text",
                                label: "公司规模",
                                required: true,
                                required_error: "请输入您的公司规模。",
                                options: [
                                    { value: "", label: "" },
                                    { value: "100 人或更少", label: "100 人或更少" },
                                    { value: "101 - 500", label: "101 - 500" },
                                    {
                                        value: "501 - 1,000",
                                        label: "501 - 1,000"
                                    },
                                    { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                    { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                    {
                                        value: "10,001 - 25,000",
                                        label: "10,001 - 25,000"
                                    },
                                    {
                                        value: "25,001 - 50,000",
                                        label: "25,001 - 50,000"
                                    },
                                    {
                                        value: "100 人或更多",
                                        label: "100 人或更多"
                                    }
                                ]
                            },
                            role: {
                                field_name: "title",
                                field_type: "select",
                                label: "职位",
                                required: true,
                                required_error: "请输入您的角色。"
                            }
                        },
                        button: {
                            as: "button",
                            type: "submit",
                            size: "regular",
                            text: "请求定价"
                        },
                        labels: {
                            form_privacy1: "通过确认，我同意接收有关Rosetta Stone产品和服务的新闻，更新以及Rosetta Stone活动邀请的信息和营销，我理解并同意Rosetta Stone可以处理并将我的信息传输给全球的附属公司 以及根据Rosetta Stone的规定，为Rosetta Stone提供服务的第三方实体",
                            form_privacy2: "隐私政策",
                            form_privacy3: "我了解我可以随时通过点击通讯中提供的链接或联系Rosetta Stone来选择退出此类通讯。",
                            form_privacy4: "。",
                            form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
                            form_privacyemail: "privacyofficer@rosettastone.com",
                            form_updateagreement1: "是! 我想收到Rosetta Stone的产品更新和营销。",
                            form_updateagreement2: "更多信息在這裡。",
                            form_updateagreement3: null
                        },
                        domain: ".cn",
                        dataQaLocation: "page"
                    },
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$n({ strings })
                }
            };
        case "pricing-request-complete":
            return {
                page,
                helmet: {
                    meta_title: "定价请求 | Rosetta Stone",
                    meta_description: "全球专业服务和咨询公司都面临着语言障碍，这限制了他们为客户提供服务、招聘员工以及在全球范围内发展业务的能力。 语言培训解决方案可帮助专业咨询公司更大限度地提高每位员工的计费时间，证明我们在整个组织的语言培训投资回报率富有意义。",
                    canonical_url: "https://www.rosettastone.cn/training-centers/pricing-request-complete/",
                    lang: "zh"
                },
                content: {
                    title: {
                        align: "center",
                        content: "感谢您的关注！",
                        heading: "h1",
                        theme: "blue",
                        type: "page-title"
                    },
                    sub_title: {
                        align: "center",
                        heading: "h2",
                        content: "在会议开始之前查看一些其他资源！",
                        type: "page-sub-title"
                    },
                    resources_link: {
                        destination: "/resources/",
                        internal: true,
                        new_window: false,
                        size: "regular",
                        text: "资源",
                        theme: "blue_white"
                    },
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$n({ strings })
                }
            };
        case "pricing-request-schedule":
            return {
                page,
                helmet: {
                    meta_title: "Pricing Request | Rosetta Stone",
                    meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.cn/training-centers/pricing-request-schedule/",
                    lang: "zh"
                },
                content: {
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$n({ strings })
                }
            };
        default:
            return null;
    }
};

var education_secondary_footer_config$6 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/training-centers/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_secondary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/education/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/business/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room?c=228009&p=irol-overview",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/business/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/zh-CN/work",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            icpLabel: strings.footer_meta_icp_label,
            icpLink: strings.footer_meta_icp_link,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: false,
            label: "",
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: false,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStoneLatino/",
                    image: {
                        type: "static",
                        src: social.facebookDarkSvg
                    }
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/RosettaStoneUK",
                    image: {
                        type: "static",
                        src: social.twitterDarkSvg
                    }
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: {
                        type: "static",
                        src: social.instagramDarkSvg
                    }
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: {
                        type: "static",
                        src: social.youtubeDarkSvg
                    }
                }
            ]
        }
    }
});

var enterprise_nav_secondary_config$8 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: null,
        external: true,
        new_window: true,
        label: strings.nav_secondary_enterprise_blog_label,
        title: strings.nav_secondary_enterprise_blog_label
    },
    home: {
        visible: true,
        destination: "/business/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_home_label,
        title: strings.nav_secondary_enterprise_home_label
    },
    resources: {
        visible: true,
        destination: "/resources/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_resources_label,
        title: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
        visible: true,
        destination: "/business/language-solutions/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_solutions_label,
        title: strings.nav_secondary_enterprise_solutions_label
    },
    vertical_header: {
        visible: true,
        destination: "/business/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_label
    }
});

var verticals$m = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_education_primary,
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/training-centers/"
            },
            name: strings.verticals_education_primary,
            title: {
                content: strings.verticals_education_primary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_education_secondary,
                src: verticals$q.educationSecondaryCirclePng
            },
            link: {
                destination: "/education/"
            },
            name: strings.verticals_education_secondary,
            title: {
                content: strings.verticals_education_secondary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_enterprise,
                src: verticals$q.enterpriseCirclePng
            },
            link: {
                destination: "/business/"
            },
            name: strings.verticals_enterprise,
            title: {
                content: strings.verticals_enterprise,
                type: "card-title"
            }
        }
    ]
});

var enterprise_pages_config$8 = ({ page, strings }) => {
    switch (page) {
        case "home":
            return {
                page,
                helmet: {
                    meta_title: "企业语言培训 | Rosetta Stone",
                    meta_description: "Rosetta Stone语言培训方案帮助员工提高商务英语和其它业务相关外语的语言能力。咨询价格。",
                    canonical_url: "https://www.rosettastone.cn/business/",
                    lang: "zh"
                },
                content: {
                    sections: [
                        {
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-right",
                                    video: {
                                        currentVideoUrl: "https://vimeo.com/591688104",
                                        controls: true
                                    },
                                    title: {
                                        content: "了解商务语言，让员工勇于开口。",
                                        align: "left",
                                        heading: "h2",
                                        type: "section-title"
                                    },
                                    justifyContent: "space-between",
                                    body: {
                                        content: "学习新的商务语言需要充分的练习。Rosetta Stone可以让员工迅速使用外语交流，并不断完善他们的发音。这样他们就可以随时准备好为自己和企业进行有效沟通。"
                                    },
                                    custom: {
                                        lead_generation_button: {
                                            schedule_appointment: false,
                                            completion_redirect: null,
                                            button: {
                                                destination: "/business/pricing-request/",
                                                new_window: false,
                                                size: "regular",
                                                text: "请求定价",
                                                theme: "yellow_black"
                                            }
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    visible: true,
                                    dataQa: "2",
                                    layout: "list",
                                    title: {
                                        dataQa: "2",
                                        content: "自然习得法。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    panels: [
                                        {
                                            left_option: {
                                                is_correct: true,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            right_option: {
                                                is_correct: false,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            challenge_text: "Una bicicleta azul"
                                        },
                                        {
                                            left_option: {
                                                is_correct: true,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            right_option: {
                                                is_correct: false,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            challenge_text: "Dos bicicletas azules"
                                        },
                                        {
                                            left_option: {
                                                is_correct: true,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            right_option: {
                                                is_correct: false,
                                                image: {
                                                    src: null
                                                }
                                            },
                                            challenge_text: "Dos bicicletas azules por un día por favor"
                                        }
                                    ],
                                    body: {
                                        dataQa: "2",
                                        content: "员工在他们听、说、读、写都是用新的一门语言时才能学得最好。这也是我们的Dynamic Immersion®方法所做的，从第一课开始就建立对一门新的语言的信心。"
                                    },
                                    data_qa: "2",
                                    direction: "image-left",
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/hitachi-data-systems-case-study",
                                        align: "left"
                                    },
                                    quote: "“Rosetta Stone帮助我们克服障碍，并且提升员工的敬业度。”",
                                    attribution: " --日立数据系统学习与协作 副总裁"
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-right",
                                    title: {
                                        dataQa: "3",
                                        content: "勇于开口。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    body: {
                                        dataQa: "3",
                                        content: "害怕出错会使得语言学习者羞于讲一门新的语言。我们的TruAccent™语音识别引擎助力员工改善他们的发音，以便他们在需要谈论业务时更有信心。"
                                    },
                                    image: {
                                        src: null
                                    },
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/e-on",
                                        align: "left"
                                    },
                                    quote: "“Rosetta Stone语言学习的最大优势是可以在任何时间、任何地点，以你自己的节奏进行学习……”",
                                    attribution: "——E.ON集团人力资源与全球学习部 主管"
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-left",
                                    title: {
                                        dataQa: "4",
                                        content: "被倾听。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    body: {
                                        dataQa: "4",
                                        content: "从参加课程到和同事以及客户说话之间还有很大的差距。由母语使用者进行的在线面授课程提供对话练习，从而使得学习者可以自然地使用新的语言说话。"
                                    },
                                    image: {
                                        src: null
                                    },
                                    quote: "“通过投入一项全公司的项目，我们看到了明显的成本节约……”",
                                    attribution: "——金百利克拉克公司 高级人才管理顾问",
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/case-study-kimberly-clark-corporation",
                                        align: "left"
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-right",
                                    title: {
                                        dataQa: "5",
                                        content: "移动应用助力。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    body: {
                                        dataQa: "5",
                                        content: "腾出时间去教室上课是很难的。我们的移动应用程序让学习者可以在任何方便的时候登录课程和活动。这样，任何时刻都可以变成学习时间。"
                                    },
                                    image: {
                                        src: null
                                    },
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/tripadvisor-com-case-study",
                                        align: "left"
                                    },
                                    quote: "“超喜欢！Rosetta Stone让我可以在工作之余按照自己的学习进度自学一门新的语言。”",
                                    attribution: "——猫途鹰公司新加坡员工"
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    pageData: {
                                        learner_feature_1_icon_name: "icon_24",
                                        learner_feature_1_subtitle: "总有一种语言会匹配员工的目标。",
                                        learner_feature_1_title: "24种语言",
                                        learner_feature_2_icon_name: "icon_dynamic",
                                        learner_feature_2_subtitle: "沉浸在语言环境中是最快的学习语言的方式。",
                                        learner_feature_2_title: "沉浸式自主学习",
                                        learner_feature_3_icon_name: "icon_foundational",
                                        learner_feature_3_subtitle: "课程与学习者的实际需要紧密相关。",
                                        learner_feature_3_title: "引人入胜的内容",
                                        learner_feature_4_icon_name: "icon_truaccent",
                                        learner_feature_4_subtitle: "员工可以随时检查他们的发音。",
                                        learner_feature_4_title: "TruAccent™语音识别",
                                        learner_feature_5_icon_name: "icon_tutoring",
                                        learner_feature_5_subtitle: "与母语使用者对话，绝对是成功的标志。",
                                        learner_feature_5_title: "真人在线面授课程",
                                        learner_feature_6_icon_name: "icon_mobile",
                                        learner_feature_6_subtitle: "学习与练习只在一指之遥。",
                                        learner_feature_6_title: "移动应用程序",
                                        learner_feature_title: "无论在线与否，我们屡获殊荣的应用都是不言而喻的"
                                    }
                                }
                            ]
                        }
                    ],
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$m({ strings }),
                    lead_generation_bar: lead_generation_bar$m()
                }
            };
        case "pricing-request":
            return {
                page,
                helmet: {
                    meta_title: "定价请求 | Rosetta Stone",
                    meta_description: "全球专业服务和咨询公司都面临着语言障碍，这限制了他们为客户提供服务、招聘员工以及在全球范围内发展业务的能力。 语言培训解决方案可帮助专业咨询公司更大限度地提高每位员工的计费时间，证明我们在整个组织的语言培训投资回报率富有意义。",
                    canonical_url: "https://www.rosettastone.cn/business/pricing-request/",
                    lang: "zh"
                },
                content: {
                    title: {
                        type: "section-title",
                        theme: "yellow",
                        content: "立即与语言学习专家预约时间。"
                    },
                    sub_title: {
                        type: "section-sub-title",
                        theme: "white",
                        content: "请填写下面的表格，安排合适的时间来讨论我们如何为您提供帮助。"
                    },
                    lead_generation_form: {
                        title: {
                            theme: "blue",
                            type: "section-title",
                            content: "即将完成！"
                        },
                        fields: {
                            first_name: {
                                field_name: "first_name",
                                field_type: "text",
                                label: "名字",
                                required: true,
                                required_error: "请输入您的名字。"
                            },
                            last_name: {
                                field_name: "last_name",
                                type: "text",
                                label: "姓氏",
                                required: true,
                                required_error: "请输入您的姓氏。"
                            },
                            email: {
                                field_name: "email",
                                field_type: "email",
                                label: "电子邮件地址",
                                required: true,
                                required_error: "请输入您的电子邮件地址。",
                                validation_error: "Please enter a valid Email Address."
                            },
                            phone: {
                                field_name: "phone",
                                field_type: "tel",
                                label: "电话号码",
                                required: true,
                                required_error: null
                            },
                            organization_name: {
                                field_name: "organization_name",
                                field_type: "text",
                                label: "公司",
                                required: true,
                                required_error: "请输入您的公司名称。"
                            },
                            organization_size: {
                                field_name: "organization_size",
                                field_type: "text",
                                label: "公司规模",
                                required: true,
                                required_error: "请输入您的公司规模。",
                                options: [
                                    { value: "", label: "" },
                                    { value: "100 人或更少", label: "100 人或更少" },
                                    { value: "101 - 500", label: "101 - 500" },
                                    {
                                        value: "501 - 1,000",
                                        label: "501 - 1,000"
                                    },
                                    { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                    { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                    {
                                        value: "10,001 - 25,000",
                                        label: "10,001 - 25,000"
                                    },
                                    {
                                        value: "25,001 - 50,000",
                                        label: "25,001 - 50,000"
                                    },
                                    {
                                        value: "100 人或更多",
                                        label: "100 人或更多"
                                    }
                                ]
                            },
                            role: {
                                field_name: "title",
                                field_type: "select",
                                label: "职位",
                                required: true,
                                required_error: "请输入您的角色。"
                            }
                        },
                        button: {
                            as: "button",
                            type: "submit",
                            size: "regular",
                            text: "请求定价"
                        },
                        labels: {
                            form_privacy1: "通过确认，我同意接收有关Rosetta Stone产品和服务的新闻，更新以及Rosetta Stone活动邀请的信息和营销，我理解并同意Rosetta Stone可以处理并将我的信息传输给全球的附属公司 以及根据Rosetta Stone的规定，为Rosetta Stone提供服务的第三方实体",
                            form_privacy2: "隐私政策",
                            form_privacy3: "我了解我可以随时通过点击通讯中提供的链接或联系Rosetta Stone来选择退出此类通讯。",
                            form_privacy4: "。",
                            form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
                            form_privacyemail: "privacyofficer@rosettastone.com",
                            form_updateagreement1: "是! 我想收到Rosetta Stone的产品更新和营销。",
                            form_updateagreement2: "更多信息在這裡。",
                            form_updateagreement3: null
                        },
                        domain: ".cn",
                        dataQaLocation: "page"
                    },
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$m({ strings })
                }
            };
        case "pricing-request-complete":
            return {
                page,
                helmet: {
                    meta_title: "定价请求 | Rosetta Stone",
                    meta_description: "全球专业服务和咨询公司都面临着语言障碍，这限制了他们为客户提供服务、招聘员工以及在全球范围内发展业务的能力。 语言培训解决方案可帮助专业咨询公司更大限度地提高每位员工的计费时间，证明我们在整个组织的语言培训投资回报率富有意义。",
                    canonical_url: "https://www.rosettastone.cn/business/pricing-request-complete/",
                    lang: "zh"
                },
                content: {
                    title: {
                        align: "center",
                        content: "感谢您的关注！",
                        heading: "h1",
                        theme: "blue",
                        type: "page-title"
                    },
                    sub_title: {
                        align: "center",
                        heading: "h2",
                        content: "在会议开始之前查看一些其他资源！",
                        type: "page-sub-title"
                    },
                    resources_link: {
                        destination: "/resources/",
                        internal: true,
                        new_window: false,
                        size: "regular",
                        text: "资源",
                        theme: "blue_white"
                    },
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$m({ strings })
                }
            };
        case "pricing-request-schedule":
            return {
                page,
                helmet: {
                    meta_title: "Pricing Request | Rosetta Stone",
                    meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.cn/business/pricing-request-schedule/",
                    lang: "zh"
                },
                content: {
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$m({ strings })
                }
            };
        case "solutions":
            return {
                page,
                helmet: {
                    meta_title: "全球企业语言培训 | Rosetta Stone Catalyst",
                    meta_description: "Rosetta Stone Catalyst企业语言培训，提供顶级的全球商务语言培训方案，满足企业员工随时随地学习要求。详情请咨询企业版价格。",
                    canonical_url: "https://www.rosettastone.cn/business/solutions/",
                    lang: "zh"
                },
                content: {
                    sections: [
                        {
                            layout: "list",
                            panels: [
                                {
                                    layout: "list",
                                    direction: "image-right",
                                    video: {
                                        currentVideoUrl: "https://vimeo.com/594888918",
                                        controls: true
                                    },
                                    title: {
                                        content: "新的商务语言技能使得共同工作成为可能。",
                                        align: "left",
                                        heading: "h2",
                                        type: "section-title"
                                    },
                                    justifyContent: "space-between",
                                    body: {
                                        content: "语言障碍导致好的想法无法被表达或者被表达清楚。通过Rosetta Stone® Catalyst™，员工们获取了新的语言技能，帮助转变复杂的信息转变为与同事和客户之间清晰的沟通。"
                                    },
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/amgen-client-spotlight",
                                        align: "left"
                                    },
                                    align: "left",
                                    quote: "“我真的相信这对于学习者以及像安进这样的全球性公司都带来了巨大的好处。”",
                                    attribution: "——安进公司 业务表现经理",
                                    custom: {
                                        lead_generation_button: {
                                            schedule_appointment: false,
                                            completion_redirect: null,
                                            button: {
                                                destination: "/pricing-request/",
                                                new_window: false,
                                                size: "regular",
                                                text: "请求定价",
                                                theme: "yellow_black"
                                            }
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    body: {
                                        dataQa: "2",
                                        content: "和同事沟通是非常重要的。通过Catalyst的培训，说明会变得清晰，员工可以听到并明白方向，从而减少错误的发生。这也就意味着更多的工作得以完成。"
                                    },
                                    data_qa: "2",
                                    direction: "image-left",
                                    layout: "list",
                                    title: {
                                        dataQa: "2",
                                        content: "提高生产力。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/language-training-productivity-ebook-snapshot",
                                        align: "left"
                                    },
                                    align: "left",
                                    quote: "学到更多",
                                    attribution: "——",
                                    image: {
                                        src: null
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    body: {
                                        dataQa: "3",
                                        content: "依赖本地的各种语言学习提供商不但花费高昂，而且还会造成参差不齐的结果。Catalyst可以全天候地在任何地点向您的员工提供同等质量的屡获殊荣的学习体验。"
                                    },
                                    data_qa: "3",
                                    direction: "image-right",
                                    layout: "list",
                                    title: {
                                        dataQa: "3",
                                        content: "走向全球。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/meet-global-challenges",
                                        align: "left"
                                    },
                                    quote: "查看详情说明",
                                    align: "left",
                                    attribution: "——",
                                    image: {
                                        src: null
                                    },
                                    icon: {
                                        src: null
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    body: {
                                        dataQa: "4",
                                        content: "大多数求职者都在寻求一个提升自己到更高层次的机会。使用Catalyst学习一门新的语言对于员工选择一份新的工作或者继续留在您的企业中是一个很重要的因素。"
                                    },
                                    data_qa: "4",
                                    direction: "image-left",
                                    layout: "list",
                                    link: {
                                        theme: "black",
                                        destination: "https://www.rosettastone.cn/business/resources/content/rosetta-playbook-september-2017-final-web/",
                                        align: "left"
                                    },
                                    quote: "学到更多",
                                    attribution: "——",
                                    align: "left",
                                    title: {
                                        dataQa: "4",
                                        content: "吸引人才。",
                                        type: "section-title",
                                        heading: "h2",
                                        theme: "black",
                                        align: "left"
                                    },
                                    image: {
                                        src: null
                                    },
                                    icon: {
                                        src: null
                                    }
                                }
                            ]
                        },
                        {
                            panels: [
                                {
                                    data_qa: "5",
                                    img_bg_top: images.solSection_7StoneBlueSvg,
                                    img_bg_bottom: images.solSection_7StoneYellowSvg,
                                    data: {
                                        feature_1_img: "icon_dynamic",
                                        feature_1_subtitle: "通过让学生沉浸在一门新语言的环境中，进行自主学习，帮助学生提升听说读写能力，培养全新的思维方式，",
                                        feature_1_title: "动态沉浸式。",
                                        feature_2_img: "icon_truaccent",
                                        feature_2_subtitle: "即时发音反馈能够指导学生正确说出新的语言，使学生感受到及时的学习回馈，增强口语自信心。",
                                        feature_2_title: "TruAccent语音识别。",
                                        feature_3_img: "icon_tutoring",
                                        feature_3_subtitle: "基于学生当前的语言水平和学习内容，与母语使用者进行针对性练习和对话，帮助他们更适应讲新的语言。",
                                        feature_3_title: "真人在线课。",
                                        feature_4_img: "icon_24",
                                        feature_4_subtitle: "总有一种语言会匹配员工的目标。",
                                        feature_4_title: "24种语言",
                                        feature_5_img: "icon_assessments",
                                        feature_5_subtitle: "了解员工的语言水平才能最好地开始。",
                                        feature_5_title: "测试",
                                        feature_6_img: "icon_placement",
                                        feature_6_subtitle: "不论学习者想要多快达到目标。",
                                        feature_6_title: "个性化分级",
                                        feature_7_img: "icon_proficiency",
                                        feature_7_subtitle: "在学习开始和过程中使用以了解进步程度。",
                                        feature_7_title: "英语能力测试",
                                        feature_8_img: "icon_foundational",
                                        feature_8_subtitle: "课程与学习者的实际需要紧密相关。",
                                        feature_8_title: "引人入胜的内容",
                                        feature_9_img: "icon_games",
                                        feature_9_subtitle: "通过好玩而又有吸引力的方式强化词汇、语法和发音，提高学生阅读、听力和口语能力。",
                                        feature_9_title: "游戏与活动。",
                                        feature_10_img: "icon_reading",
                                        feature_10_subtitle: "对于每一个学习级别都有针对性的活动，包括提供即时语音回馈的大声朗读，特定目的的写作练习，以及听力与阅读理解。",
                                        feature_10_title: "阅读和写作。",
                                        feature_11_img: "icon_mobile",
                                        feature_11_subtitle: "学生能够在课堂内外使用智能手机和平板电脑获取课程内容和活动，从而增强对于技巧的练习和词汇的记忆。",
                                        feature_11_title: "移动应用。",
                                        feature_12_img: "icon_reporting",
                                        feature_12_subtitle: "通过使用进步和完成情况学习报告，即时查看个人、小组和班级表现，帮助老师和管理员方便地了解学生情况。",
                                        feature_12_title: "报告工具。 ",
                                        feature_13_img: "icon_transferable",
                                        feature_13_subtitle: "简化的授权管理使得老师和管理员可以快速地重新安排学生，以确保充分利用所有的账号授权，从而提高项目的回报率。",
                                        feature_13_title: "灵活的账号类型。",
                                        feature_14_img: "icon_implementation",
                                        feature_14_subtitle: "我们的团队将语言学习目标结合到有效的模型中，并帮助学校和学区规划、实施和推广项目。",
                                        feature_14_title: "实施支持。",
                                        feature_15_img: "icon_training",
                                        feature_15_subtitle: "提供对于管理员和老师不同级别的培训，有助于成功开展混合式学习项目。",
                                        feature_15_title: "培训服务。",
                                        feature_section_title: "您需要的每个资源都可用"
                                    }
                                }
                            ]
                        }
                    ],
                    awards: awards$8({ strings }),
                    branded_quotes: branded_quotes$8({ strings }),
                    verticals: verticals$m({ strings }),
                    lead_generation_bar: lead_generation_bar$m()
                }
            };
        default:
            return null;
    }
};

var enterprise_footer_config$8 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/training-centers/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_secondary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/education/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/business/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room?c=228009&p=irol-overview",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.cn/business/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/zh-CN/work",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            icpLabel: strings.footer_meta_icp_label,
            icpLink: strings.footer_meta_icp_link,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: false,
            label: "",
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: false,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStoneLatino/",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/RosettaStoneUK",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var cn = ({ market, site, page, locale, strings }) => {
    let nav_secondary = null;
    let page_config = null;
    let footer_config = null;
    switch (site) {
        case "consumer":
            page_config = consumer_page_config({ page, strings });
            footer_config = consumer_footer_config$3({ strings });
            break;
        case "business":
        case "enterprise":
            nav_secondary = enterprise_nav_secondary_config$8({ strings });
            page_config = enterprise_pages_config$8({ page, strings });
            footer_config = enterprise_footer_config$8({ strings });
            break;
        case "k12":
        case "education-primary":
            nav_secondary = education_primary_nav_secondary_config$8({ strings });
            page_config = education_primary_pages_config$8({ page, strings });
            footer_config = education_primary_footer_config$8({ strings });
            break;
        case "hed":
        case "education-secondary":
            nav_secondary = education_secondary_nav_secondary_config$6({ strings });
            page_config = education_secondary_pages_config$6({ page, strings });
            footer_config = education_secondary_footer_config$6({ strings });
            break;
    }
    const nav_primary = nav_primary_config$8({ strings });
    return {
        market,
        site,
        vertical: site,
        locale,
        analytics: marketSharedAnalytics,
        nav: {
            visible: true,
            primary: nav_primary || null,
            secondary: nav_secondary || null
        },
        footer: footer_config,
        page: page_config
    };
};

var analytics$9 = {
    gtm_id: "GTM-NDSR53K"
};

var nav_primary_config$7 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: true,
        destination: "https://www.rosettastone.de/magazine/",
        external: true,
        new_window: true,
        label: strings.nav_primary_blog_label
    },
    contact: {
        visible: false,
        destination: "/contact/",
        external: true,
        new_window: true,
        label: strings.nav_primary_contact_label
    },
    rs_logo: {
        visible: true,
        image: {
            type: "static",
            src: rsBranding.rsLogoBlackSvg,
            height: "40px",
            width: "93px",
            alt: strings.nav_primary_logo_alt
        },
        link: {
            destination: "/",
            external: false,
            new_window: false
        }
    },
    phone: {
        visible: true,
        external: false,
        new_window: false,
        destination: "tel:08007240778",
        label: strings.nav_primary_phone_label,
        number: strings.nav_primary_phone_number
    },
    select_language: {
        visible: true,
        external: false,
        new_window: false,
        language_options_featured: [
            {
                url: "/englisch/",
                title: strings.locale_en_gb_label_primary,
                small: strings.locale_en_gb_label_secondary
            },
            {
                url: "/franzoesisch/",
                title: strings.locale_fr_fr_label_primary,
                small: strings.locale_fr_fr_label_secondary
            },
            {
                url: "/japanisch/",
                title: strings.locale_ja_jp_label_primary,
                small: strings.locale_ja_jp_label_secondary
            },
            {
                url: "/spanisch/",
                title: strings.locale_es_es_label_primary,
                small: strings.locale_es_es_label_secondary
            },
            {
                url: "/italienisch/",
                title: strings.locale_it_it_label_primary,
                small: strings.locale_it_it_label_secondary
            },
            {
                url: "/deutsch/",
                title: strings.locale_de_de_label_primary,
                small: strings.locale_de_de_label_secondary
            }
        ],
        language_options_other: [
            {
                url: "/arabisch/",
                title: strings.locale_ar_ar_label_primary,
                small: strings.locale_ar_ar_label_secondary
            },
            {
                url: "/chinesisch/",
                title: strings.locale_zn_cn_label_primary,
                small: strings.locale_zn_cn_label_secondary
            },
            {
                url: "/englisch-amerikanisch/",
                title: strings.locale_en_us_label_primary,
                small: strings.locale_en_us_label_secondary
            },
            {
                url: "/griechisch/",
                title: strings.locale_el_gr_label_primary,
                small: strings.locale_el_gr_label_secondary
            },
            {
                url: "/hebraeisch/",
                title: strings.locale_he_il_label_primary,
                small: strings.locale_he_il_label_secondary
            },
            {
                url: "/hindi/",
                title: strings.locale_hi_in_label_primary,
                small: strings.locale_hi_in_label_secondary
            },
            {
                url: "/irisch/",
                title: strings.locale_ga_ie_label_primary,
                small: strings.locale_ga_ie_label_secondary
            },
            {
                url: "/koreanisch/",
                title: strings.locale_ko_kr_label_primary,
                small: strings.locale_ko_kr_label_secondary
            },
            {
                url: "/niederlaendisch/",
                title: strings.locale_nl_nl_label_primary,
                small: strings.locale_nl_nl_label_secondary
            },
            {
                url: "/persisch/",
                title: strings.locale_fa_ir_label_primary,
                small: strings.locale_fa_ir_label_secondary
            },
            {
                url: "/philippinisch/",
                title: strings.locale_tl_ph_label_primary,
                small: strings.locale_tl_ph_label_secondary
            },
            {
                url: "/polnisch/",
                title: strings.locale_pl_pl_label_primary,
                small: strings.locale_pl_pl_label_secondary
            },
            {
                url: "/portugiesisch/",
                title: strings.locale_pt_br_label_primary,
                small: strings.locale_pt_br_label_secondary
            },
            {
                url: "/russisch/",
                title: strings.locale_ru_ru_label_primary,
                small: strings.locale_ru_ru_label_secondary
            },
            {
                url: "/spanisch-lateinamerika/",
                title: strings.locale_es_la_label_primary,
                small: strings.locale_es_la_label_secondary
            },
            {
                url: "/schwedisch/",
                title: strings.locale_sv_se_label_primary,
                small: strings.locale_sv_se_label_secondary
            },
            {
                url: "/tuerkisch/",
                title: strings.locale_tr_tr_label_primary,
                small: strings.locale_tr_tr_label_secondary
            },
            {
                url: "/vietnamesisch/",
                title: strings.locale_vi_vn_label_primary,
                small: strings.locale_vi_vn_label_secondary
            }
        ],
        select_language_label: strings.nav_primary_catalog_select_language_label,
        label: strings.nav_primary_catalog_label,
        product_title: strings.global_brand_name
    },
    sign_in: {
        visible: true,
        destination: "https://www.rosettastone.com/login",
        external: true,
        new_window: false,
        label: strings.nav_primary_sign_in_label
    },
    switch_language: {
        visible: false,
        destination: "https://espanol.rosettastone.com/",
        external: true,
        new_window: false,
        label: strings.nav_primary_switch_language
    },
    support: {
        visible: true,
        destination: "https://support.rosettastone.com/de/",
        external: true,
        new_window: false,
        label: strings.nav_primary_support_label
    },
    vertical_consumer: {
        visible: false,
        destination: "/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
        visible: false,
        destination: "/homeschool/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
        visible: true,
        destination: "/bildung/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
        visible: false,
        destination: "/hochschulen/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
        visible: false,
        destination: "/students/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
        visible: true,
        destination: "/unternehmen/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_enterprise_label
    }
});

var education_primary_nav_secondary_config$7 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: "null",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
        visible: true,
        destination: "/ressourcen/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
        visible: true,
        destination: "/loesungen/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_solutions_label
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_label
    }
});

var awards$7 = ({ strings }) => {
    return {
        visible: true,
        title: {
            content: strings.awards_header_label,
            align: "center",
            type: "section-title"
        },
        panels: [
            {
                image: {
                    type: "static",
                    alt: strings.awards_twitter,
                    src: logosTiles.logosTilesTwitterSvg
                }
            },
            {
                image: {
                    type: "static",
                    alt: strings.awards_bmw,
                    src: logosTiles.logosTilesBmwSvg
                }
            },
            {
                image: {
                    type: "static",
                    alt: strings.awards_uber,
                    src: logosTiles.logosTilesUberSvg
                }
            },
            {
                image: {
                    type: "static",
                    alt: strings.awards_williams_sonoma,
                    src: logosTiles.logosTilesWsSvg
                }
            }
        ]
    };
};

var copyData$7 = () => ({
    about_us: "Über Uns",
    about_us_url: "http://www.rosettastone.de/ueber-uns",
    agreements: "Vereinbarungen",
    agreements_url: "http://www.rosettastone.de/vereinbarungen",
    almost_there: "Fast fertig!",
    american: "(Amerikanisch)",
    anti_piracy: "Cookie-Einstellungen",
    anti_piracy_url: "https://www.rosettastone.de/cookies",
    arabic: "Arabisch",
    award_section_header: "Seit 25+ Jahren von Top-Organisationen genutzt",
    blog_url: "https://www.rosettastone.de/magazine",
    brasil: "Brasil",
    brasil_url: "https://www.rosettastonebrasil.com/",
    brazil: "(Brasilien)",
    british: "(Britisch)",
    business_contact_title: "Unternehmen - Angebot Anfordern",
    careers: "Karriere",
    careers_url: "https://www.rosettastone.com/careers",
    cart_checkout: "Weiter Einkaufen",
    cart_checkout_url: "https://secure.rosettastone.de/de_store_view/checkout/cart/",
    cart_discount: "Rabatt",
    cart_empty: "Ihr Warenkorb ist leer.",
    cart_in_your_cart: "in Ihrem Warenkorb",
    cart_subtotal: "Zwischensumme",
    cart_summary: "Bestellübersicht ",
    cart_total: "Gesamt",
    cart_you_have: "Sie haben",
    change_region: "Region ändern:",
    china: "中国",
    china_url: "http://www.rosettastone.cn/",
    combined_resources_url: "https://www.rosettastone.de/unternehmen/ressourcen/",
    company: "Unternehmen",
    connect: "Folgen Sie uns auf:",
    consumer_home: "Verbraucher Home",
    contact: "Kontakt",
    contact_description: "Angebotsformular anfordern",
    contact_ee_url: "/kontakt/",
    contact_url: "http://www.rosettastone.de/kontakt/",
    cta_bar: "Bereit für den nächsten Schritt?",
    cta_h2: "Bereit für den nächsten Schritt?",
    cta_text: "Angebot Anfordern",
    currency: "€",
    demo_pricing_subtitle_business: "Entdecken Sie, wie unsere Lösungen Ihrem Unterthemen dabei helfen können, die Produktivität zu steigern und Talente zu gewinnen. Füllen Sie das Formular aus und wir werden uns in Kürze bei Ihnen melden.",
    demo_pricing_subtitle_hed: "Mit den Lösungen von Rosetta Stone lernen Ihre Schüler und Studierenden anhand individueller Lernpfade besonders effektiv, motiviert und flexibel. Erfahren Sie mehr, füllen Sie das Formular aus und wir werden uns in Kürze bei Ihnen melden.",
    demo_pricing_subtitle_k12: "Mit den Lösungen von Rosetta Stone lernen Ihre Schüler und Studierenden anhand individueller Lernpfade besonders effektiv, motiviert und flexibel. Erfahren Sie mehr, füllen Sie das Formular aus und wir werden uns in Kürze bei Ihnen melden.",
    demo_pricing_subtitle_pub: "Finden Sie heraus, wie unsere Lösungen für den öffentlichen Sektor die Integration und Kommunikation verbessern können. Füllen Sie das Formular aus und wir werden uns in Kürze bei Ihnen melden.",
    demo_pricing_title: "Erhalten Sie eine kostenlose Beratung",
    deutschland: "Deutschland",
    deutschland_url: "https://www.rosettastone.de/",
    download_pdf: "PDF Herunterladen",
    dutch: "Niederländisch",
    english: "Englisch",
    espana: "España",
    espana_url: "https://www.rosettastone.es/",
    europe: "Europa",
    europe_url: "https://www.rosettastone.eu/",
    facebook_url: "http://www.facebook.com/RosettaStoneDE",
    faq_url: "/faq",
    faqs: "FAQs",
    farsi: "(Farsi)",
    filipino: "Philippinisch",
    for_business: "Unternehmen",
    for_business_resources_url: "https://www.rosettastone.de/unternehmen/ressourcen/",
    for_business_solutions_url: "https://www.rosettastone.de/unternehmen/loesungen/",
    for_business_url: "https://www.rosettastone.de/unternehmen/home/",
    for_educators: "Bildungseinrichtungen",
    for_educators_resources_url: "https://www.rosettastone.de/unternehmen/ressourcen/",
    for_educators_solutions_url: "https://www.rosettastone.de/bildung/loesungen/",
    for_educators_url: "https://www.rosettastone.de/bildung/home/",
    for_hed: "Für Hochschullehrer",
    for_homeschool: null,
    for_homeschool_url: null,
    for_individuals: "Für Einzelpersonen",
    for_individuals_url: "/",
    for_organizations: "Organisationen",
    for_public_sector: "Öffentlicher Sektor",
    for_public_sector_url: "/oeffentlichersektor/",
    for_you: "Privatkunden",
    form_100: "100 oder weniger",
    form_500: "101 - 500",
    form_1000: "501 - 1,000",
    form_5000: "1,001 - 5,000",
    form_10000: "5,001 - 10,000",
    form_25000: "10,001 - 25,000",
    form_50000: "25,001 - 50,000",
    form_boardmember: "Vorstandsmitglied",
    form_curriculumdirector: "Lehrplanleiter / Instruktionskoordinator",
    form_director: "Direktor",
    form_email: "E-Mail",
    form_executive: "Geschäftsführung / Executive",
    form_firstname: "Vorname",
    form_how_blog: "Blog",
    form_how_email: "Email",
    form_how_event: "Veranstaltung",
    form_how_online: "Online",
    form_how_other: "Andere",
    form_how_referral: "Verweisung",
    form_how_search: "Suchmaschine",
    form_how_social: "Sozialen Medien",
    form_how_title: "Woher haben Sie von uns gehört? (optional)",
    form_how_webinar: "Webinar",
    form_individualcontributor: "Einzelner Mitwirkender",
    form_lastname: "Nachname",
    form_manager: "Manager",
    form_more: "50,001 - Mehr",
    form_organization: "Unternehmen",
    form_organizationsize: "Organisationsgröße",
    form_phone: "Telefonnummer (optional)",
    form_principal: "Auftraggeber / Vizepräsident",
    form_privacy1: "Ich stimme dem Erhalt von Info- und Marketingmaterial über Produktneuigkeiten, Angebote oder Einladungen zu Veranstaltungen von Rosetta Stone zu. Es ist mir bewusst, dass meine Daten mit internationalen Partnern, die Dienstleistungen für Rosetta Stone anbieten im Rahmen der",
    form_privacy2: "Datenschutzrichtlinie von Rosetta Stone ",
    form_privacy3: "teilen darf. Es ist mir ebenfalls bewusst, dass ich mich jederzeit von jeglicher Kommunikation abmelden kann, indem ich den \"Abmelden\" Link im Info- und Marketingmaterial klicke oder indem ich Rosetta Stone unter ",
    form_privacy4: " kontaktiere.",
    form_privacyUrl: "https://www.rosettastone.de/datenschutzrichtlinie",
    form_privacyemail: "privacyofficer@rosettastone.com ",
    form_role: "Rolle (oder Titel)",
    form_submit: "Jetzt Angebot anfordern",
    form_superintendent: "Superintendent / District Administrator",
    form_teacher: "Lehrer",
    form_techcoordinator: "Technologiekoordinator",
    form_updateagreement1: "Ja, ich möchte Produktneuigkeiten und Angebote von Rosetta Stone erhalten. ",
    form_updateagreement2: "Mehr erfahren",
    form_updateagreement3: " ",
    form_vicepresident: "Vizepräsident",
    france: "France",
    france_url: "https://www.rosettastone.fr/",
    google_plus_url: "https://plus.google.com/105195149850491722010",
    greek: "Griechisch",
    gtm_id: "GTM-T9H4L7",
    has_combined_resources: true,
    has_resources: null,
    hebrew: "Hebräisch",
    helpful_links: "Bitte korrigieren Sie die URL oder probieren Sie einen dieser nützlichen Links:",
    hide_cart: true,
    hide_contact: true,
    hide_espanol: true,
    hide_language: null,
    hide_search: true,
    hide_support: null,
    hindi: "Hindi",
    home: "Home",
    home_link: "/home/",
    home_url: "https://www.rosettastone.de/",
    instagram_url: "https://www.instagram.com/rosettastone",
    investors: "Investor Relations",
    investors_url: "https://investors.rosettastone.com/",
    irish: "Irisch",
    italia: "Italia",
    italia_url: "https://www.rosettastone.it/",
    item: "Artikel",
    item_plural: "Artikel",
    japan: "日本",
    japan_url: "http://www.rosettastone.co.jp",
    japanese: "Japanisch",
    k12_contact_title: "Bildung - Angebot Anfordern",
    keep_exploring: "Weiter erforschen",
    korea: "대한민국",
    korea_url: "https://www.rosettakorea.com/",
    korean: "Koreanisch",
    latin: null,
    latin_america: "(Latinamerika)",
    latin_america_region: "America Latina",
    latin_america_region_url: "https://espanol.rosettastone.com/",
    learn_arabic_url: "/arabisch-lernen/",
    learn_chinese: "Chinesisch",
    learn_chinese_url: "/chinesisch-lernen/",
    learn_dutch_url: "/niederlandisch-lernen/",
    learn_english: "Englisch lernen",
    learn_english_british_url: "/englisch-lernen/",
    learn_english_url: "/englisch-amerikanisch-lernen/",
    learn_french: "Französisch lernen",
    learn_french_url: "/franzoesisch-lernen/",
    learn_german: "Deutsch lernen",
    learn_german_url: "/deutsch-lernen/",
    learn_greek_url: "/griechisch-lernen/",
    learn_hebrew_url: "/hebraeisch-lernen/",
    learn_hindi_url: "/hindi-lernen/",
    learn_irish_url: "/irisch-lernen/",
    learn_italian: "Italienisch lernen",
    learn_italian_url: "/italienisch-lernen/",
    learn_japanese_url: "/japanisch-lernen/",
    learn_korean_url: "/koreanisch-lernen/",
    learn_latin_url: null,
    learn_more: "Erfahren Sie mehr",
    learn_persian_url: "/farsi-lernen/",
    learn_polish_url: "/polnisch-lernen/",
    learn_portuguese_url: "/portugiesisch-lernen/",
    learn_russian_url: "/russisch-lernen/",
    learn_spanish: "Spanisch lernen",
    learn_spanish_spain_url: "/spanisch-lernen/",
    learn_spanish_url: "/spanisch-lateinamerika-lernen/",
    learn_swedish_url: "/schwedisch-lernen/",
    learn_tagalog_url: "/tagalog-lernen/",
    learn_turkish_url: "/turkisch-lernen/",
    learn_vietnamese_url: "/vietnamesisch-lernen/",
    lexia_learning: "Bewertungen",
    lexia_learning_url: "http://www.rosettastone.de/bewertungen",
    listen_now: "Jetzt anhören",
    madarin: null,
    market: ["DE"],
    media_quote_1: "”Ich bin von der Rosetta Stone Sprachlernlösung begeistert und fest davon überzeugt, ",
    media_quote_1_bold: "dass der Lernansatz funktioniert.",
    media_quote_1_end: "\"",
    media_quote_2: "“Mit den benutzerfreundlichen Interfaces, klaren Anweisungen sowie der großen Auswahl an Spielen und sonstigen Lern-Tools hat es ",
    media_quote_2_bold: "Rosetta Stone einfach drauf.",
    media_quote_2_end: "\"",
    media_quote_3: "“Der ",
    media_quote_3_bold: "Gold-Status",
    media_quote_3_end: "an computerbasiertem Sprachenlernen.”",
    more_resources_title: "Mehr Ressourcen",
    more_specify: "Bitte angeben",
    no_support_dropdown: true,
    persian: "Persisch",
    polish: "Polnisch",
    portuguese: "Portugiesisch",
    press: "Presse",
    press_url: "http://www.rosettastone.de/presse",
    pricing_subtitle: "Bitte ausfüllen und wir melden uns umgehend bei Ihnen.",
    pricing_thanks: "Danke für Ihr Interesse! In Kürze wird sich jemand mit Ihnen in Verbindung setzen.",
    pricing_title: "Haben wir Ihr Interesse geweckt? Fordern Sie Ihr individuelles Angebot an.",
    privacy_policy: "Datenschutzrichtlinie",
    privacy_policy_url: "https://www.rosettastone.de/datenschutzrichtlinie",
    products: "Überblick",
    questions_call: "Fragen? Ruf Sie uns an:",
    read_article: "Artikel lesen",
    read_case_study: "Fallstudie lesen",
    read_ebook: "eBook lesen",
    read_fact_sheet: "Infoblatt lesen",
    read_guide: "Anleitung lesen",
    read_more: "Weiterlesen",
    read_report: "Bericht lesen",
    read_white_paper: "Whitepaper lesen",
    related_resources_title: "Ähnliche Resourcen",
    request_pricing: "Angebot Anfordern",
    resources: "Ressourcen",
    resources_link: "/ressourcen/",
    rosetta_copyright: "1999-2019 Rosetta Stone GmbH. Alle Rechte vorbehalten. Diese Webseite verwendet Cookies. Durch die weitere Nutzung unserer Webseite stimmen Sie der Verwendung von Cookies zu. Mehr erfahren",
    rosetta_stone: "Rosetta Stone",
    russian: "Russisch",
    search: "Suche...",
    search_rosetta_url: "XXX",
    select_lang: "Wähle eine Sprache:",
    services: "Soziales Engagement",
    services_url: "http://www.rosettastone.de/soziales-engagement",
    shop_now: null,
    sign_in: "Login",
    sign_in_url: "https://www.rosettastone.de/login",
    similar_resources: "Ähnliche Ressourcen",
    site_not_found: "Site nicht gefunden - 404",
    sitemap: "Seitenübersicht",
    sitemap_url: "http://www.rosettastone.de/seitenuebersicht",
    solutions: "Lösungen",
    solutions_link: "/loesungen/",
    spain: "(Spanien)",
    spanish: "Spanisch",
    support: "Support",
    support_business_url: "https://support.rosettastone.com/de/unternehmen",
    support_chat: "Live technischer Support-Chat",
    support_chat_live: "Live technischer Support-Chat",
    support_chat_live_url: "https://rosettastone.secure.force.com/apex/PreLiveChatForm",
    support_chat_url: "https://support.rosettastone.com/de/chat",
    support_classrooms: "Unterstützung für Klassenzimmer und Unternehmen:",
    support_faq_btn: "Alle FAQ anzeigen",
    support_faq_title: "Häufig gestellte Fragen (FAQ)",
    support_faq_url_1: "/faq#q1",
    support_faq_url_1_title: "Was ist die Rosetta Stone® Methode?",
    support_faq_url_2: "/faq#q2",
    support_faq_url_2_title: "Was ist alles in der Rosetta Stone Online-Zugang Lösung enthalten?",
    support_faq_url_3: "/faq#q3",
    support_faq_url_3_title: "Wie bekomme ich mobile Apps für mein iPhone®, iPad® oder Android-Geräte?",
    support_faq_url_4: "/faq#q4",
    support_faq_url_4_title: "Wie funktioniert die Rosetta Stone® Methode?",
    support_for_you: "Support:",
    support_home: "Support",
    support_site: "Support Site",
    support_site_url: "https://support.rosettastone.com/de/",
    swedish: "Schwedish",
    switch_lang: "Español",
    switch_lang_url: "https://espanol.rosettastone.com/",
    system_reqs: "Systemanforderungen",
    system_reqs_url: "/systemanforderungen",
    tagalog: " (Tagalog)",
    telephone_atr: "tel:+08007240778",
    telephone_text: "0800 724 0778",
    terms_conditions: "Nutzungsbedingungen",
    terms_conditions_url: "https://www.rosettastone.de/nutzungsbedingungen",
    title: "de-copy",
    turkish: "Türkisch",
    twitter_url: "https://twitter.com/rosettastone",
    united_kingdom: "United Kingdom",
    united_kingdom_url: "https://www.rosettastone.co.uk/",
    united_states: "United States",
    united_states_url: "https://www.rosettastone.com",
    use_new_header: null,
    vertical: ["recECBjZxFEWVVls8"],
    vertical_business: "Unternehmen",
    vertical_business_link: "/unternehmen/home/",
    vertical_healthcare: null,
    vertical_healthcare_link: null,
    vertical_hed: "Hochschulen",
    vertical_hed_link: "/hochschulen/",
    vertical_k12: "Schulen",
    vertical_k12_link: "/schulen/",
    vertical_pub: "Öffentlicher Sektor",
    vertical_pub_link: "/oeffentlichersektor/",
    verticals_subtitle: "Unsere preisgekrönten Sprachlernlösungen: Das passende Training für alle Bedürfnisse. ",
    verticals_title: "Welche Art von Lerner bist du?",
    vietnamese: "Vietnamesisch",
    view_infographic: "Infografik anzeigen",
    watch_video: "Video ansehen",
    watch_webinar: "Webinar ansehen",
    youtube_url: "http://www.youtube.com/user/RosettaStoneDE"
});

var branded_quotes$7 = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.branded_quotes_header_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            name: strings.branded_quotes_macworld_name,
            type: strings.branded_quotes_macworld_type,
            quote: strings.branded_quotes_macworld_quote,
            logo: {
                type: "static",
                src: logos.logoMacworldSvg
            },
            backdrop: logos.logoMacworldBgSvg
        },
        {
            name: strings.branded_quotes_techcrunch_name,
            type: strings.branded_quotes_techcrunch_type,
            quote: strings.branded_quotes_techcrunch_quote,
            logo: {
                type: "static",
                src: logos.logoTechcrunchSvg
            },
            backdrop: logos.logoTechcrunchBgSvg
        },
        {
            name: strings.branded_quotes_cnn_name,
            type: strings.branded_quotes_cnn_type,
            quote: strings.branded_quotes_cnn_quote,
            logo: {
                type: "static",
                src: logos.logoCnnSvg
            },
            backdrop: logos.logoCnnBgSvg
        }
    ]
});

var lead_generation_bar$l = () => {
    return {
        visible: true,
        dataQa: "lead generation bar",
        lead_generation_button: {
            schedule_appointment: false,
            button: {
                destination: "/preisanfrage/",
                new_window: false,
                size: "regular",
                text: "Preis anfragen",
                theme: "yellow_black"
            }
        },
        subtitle: {
            content: "",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        title: {
            content: "Bereit für den nächsten Schritt?",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        }
    };
};

var verticals$l = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_education_primary,
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/bildung/"
            },
            name: strings.verticals_education_primary,
            title: {
                content: strings.verticals_education_primary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_enterprise,
                src: verticals$q.enterpriseCirclePng
            },
            link: {
                destination: "/unternehmen/"
            },
            name: strings.verticals_enterprise,
            title: {
                content: strings.verticals_enterprise,
                type: "card-title"
            }
        }
    ]
});

const education_primary_pages_config$7 = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "dynamic-content") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "de"
            },
            content: {
                copyData: copyData$7(),
                awards: awards$7({ strings }),
                branded_quotes: branded_quotes$7({ strings }),
                verticals: verticals$l({ strings }),
                lead_generation_bar: lead_generation_bar$l()
            }
        };
    }
    if (page === "dynamic-resources") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "de"
            },
            content: {
                hero: {
                    layout: "list",
                    panels: [
                        {
                            layout: "image-right",
                            alignItems: "center",
                            image: {
                                src: null
                            },
                            title: {
                                content: "Ressourcen"
                            },
                            body: {
                                content: "Lassen Sie die Lernenden für sich selbst sprechen"
                            },
                            custom: {
                                lead_generation_button: {
                                    destination: "/preisanfrage/",
                                    theme: "yellow_black",
                                    internal: true,
                                    text: "Preis anfragen"
                                }
                            }
                        }
                    ]
                },
                copyData: copyData$7(),
                awards: awards$7({ strings }),
                branded_quotes: branded_quotes$7({ strings }),
                verticals: verticals$l({ strings }),
                lead_generation_bar: lead_generation_bar$l()
            }
        };
    }
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Online-Sprachunterricht für die Bildung | Rosetta Stone",
                meta_description: "Die Sprachlernlösungen von Rosetta Stone für K-12 passen in den Unterricht der Lehrer und sind jederzeit verfügbar, wenn die Schüler Englisch- oder Weltsprachkenntnisse lernen oder verbessern möchten.",
                canonical_url: "https://www.rosettastone.de/bildung/",
                lang: "de"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                align: "list",
                                direction: "image-right",
                                video: {
                                    currentVideoUrl: "https://resources.rosettastone.com/CDN/us/videos/International_Markets/German/Catalyst_2_German.mp4",
                                    controls: true
                                },
                                title: {
                                    content: "Die Zukunftsplanung beginnt heute.",
                                    align: "left",
                                    heading: "h2",
                                    type: "section-title"
                                },
                                justifyContent: "space-between",
                                body: {
                                    content: "Als Vorbereitung auf eine Karriere im internationalen Umfeld ist das Erlernen von Fremdsprachen heute fester Bestandteil der Bildung an Schulen und Hochschulen. Mit den Lösungen von Rosetta Stone lernen Ihre Schüler und Studierenden anhand individueller Lernpfade besonders effektiv, motiviert und flexibel. Wir ermöglichen das eigenständige Lernen oder die Einbindung in Blended Learning-Konzepte. Unser immersiver Ansatz trainiert das Hören, Sprechen und Lesen einer Fremdsprache von der ersten Sekunde an."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/preisanfrage/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Preis anfragen",
                                            theme: "yellow_black"
                                        }
                                    }
                                }
                            }
                        ]
                    },
                    {
                        data_qa: "section2_productSample",
                        panels: [
                            {
                                title: {
                                    align: "left",
                                    content: "Vielseitige Trainingsformen fördern Effizienz.",
                                    type: "section-title",
                                    heading: "h2"
                                },
                                body: {
                                    content: "Wir von Rosetta Stone verfolgen das Ziel, allen Lernern das bestmögliche Training zu bieten. Rosetta Stone Foundations ist die perfekte Lösung für alle Sprachanfänger, Rosetta Stone Advantage vertieft erste Grundkenntnisse besonders effizient. Dabei spielt es keine Rolle, ob Sie das Sprachtraining für Schüler, Studierende oder Mitarbeiter an Ihrer Bildungseinrichtung anbieten möchten – die Trainingseinheiten werden gezielt auf den Kenntnisstand des individuellen Lerners abgestimmt."
                                },
                                panels: [
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.bicicletaAzulPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.bicicletaAmarillaPng
                                            }
                                        },
                                        challenge_text: "Una bicicleta azul"
                                    },
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.dosBicicletasAzulesPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.dosBicicletasDiferentesPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules"
                                    },
                                    {
                                        left_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.verdesPorUnDiaPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.azulesPorUnDiaPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules por un día por favor"
                                    }
                                ]
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section3_image",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "An Schulen und Hochschulen treffen heute verschiedenste Sprachen und Kulturen aufeinander. Das Sprachtraining von Rosetta Stone fördert den verbalen Austausch sowie das Verständnis für andere Kulturen. Fördern Sie Toleranz und Verständnis auf dem Schulhof oder dem Campus und zeigen Sie Ihren Schülern und Studierenden die Vorteile eines offenen und verständnisvollen Miteinanders auf."
                                },
                                direction: "image-right",
                                image: {},
                                title: {
                                    align: "left",
                                    content: "Verbesserte interkulturelle Kompetenz.",
                                    theme: "black",
                                    type: "section-title",
                                    heading: "h2"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "4",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Blended Learning-Konzepte finden heute bereits an vielen Schulen und Hochschulen Anwendung. Mit Blended Learning gestalten Sie die verfügbare Unterrichtszeit besonders abwechslungsreich und effektiv. Wir bieten die technologische Grundlage für einen optimierten Unterricht, der sich flexibel in Ihren Lehrplan integrieren lässt und dem jeder Schüler folgen kann."
                                },
                                direction: "image-left",
                                title: {
                                    content: "Mehr Abwechslung für Ihren Unterricht.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                image: {
                                    src: null
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section5",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Aufgrund zeitlicher und räumlicher Flexibilität eignet sich E-Learning hervorragend für die Hochschulbildung. Doch auch an Schulen ist der technologische Fortschritt längst nicht mehr wegzudenken, denn die Anforderungen der Digital Natives wandeln sich. Mit den mobilen Apps von Rosetta Stone motivieren Sie Ihre Schüler zum Erlernen einer Fremdsprache und geben den Studierenden Ihrer Hochschule die Möglichkeit, flexibel zu lernen – wann und wo sie möchten."
                                },
                                direction: "image-right",
                                title: {
                                    content: "Motivation pur für Digital Natives.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                image: {
                                    src: null
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section6_features",
                        layout: "list",
                        panels: [
                            {
                                pageData: {
                                    learner_feature_1_icon_name: "icon_24",
                                    learner_feature_1_subtitle: "Für gezielte Fortschritte in kürzester Zeit. ",
                                    learner_feature_1_title: "Individueller Lernpfad",
                                    learner_feature_2_icon_name: "icon_dynamic",
                                    learner_feature_2_subtitle: "Eintauchen in eine völlig neue Welt. ",
                                    learner_feature_2_title: "Immersive Methode",
                                    learner_feature_3_icon_name: "icon_foundational",
                                    learner_feature_3_subtitle: "Sprachen lernen, Länder entdecken. ",
                                    learner_feature_3_title: "Kulturelles Wissen",
                                    learner_feature_4_icon_name: "icon_truaccent",
                                    learner_feature_4_subtitle: "Für mehr Selbstbewusstsein beim Sprechen. ",
                                    learner_feature_4_title: "Spracherkennung",
                                    learner_feature_5_icon_name: "icon_tutoring",
                                    learner_feature_5_subtitle: "Mit Abwechslung und Spaß zu neuem Wissen.",
                                    learner_feature_5_title: "Vielseitige Trainingsmethoden",
                                    learner_feature_6_icon_name: "icon_mobile",
                                    learner_feature_6_subtitle: "Lernen wann und wo es gerade passt.",
                                    learner_feature_6_title: "Mobile Apps",
                                    learner_feature_title: "Ob on- oder offline - unsere preisgekrönte App spricht für sich selbst!"
                                }
                            }
                        ],
                        visible: true
                    }
                ],
                awards: awards$7({ strings }),
                branded_quotes: branded_quotes$7({ strings }),
                verticals: verticals$l({ strings }),
                lead_generation_bar: lead_generation_bar$l()
            }
        };
    }
    if (page === "preisanfrage") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Preisanfrage | Rosetta Stone",
                meta_description: "Sprachbarrieren schränken die Fähigkeit globaler Dienstleistungs- und Beratungsunternehmen ein, Kunden zu bedienen, mit Mitarbeitern zu interagieren und das Wachstum des Geschäfts weltweit zu fördern. Sprachtrainingslösungen helfen Dienstleistungs- und Beratungsunternehmen, den Anteil der abrechenbaren Arbeitszeit zu maximieren – ein Beleg für den relevanten ROI, den unsere Sprachtrainings organisationsweit erzielen.",
                canonical_url: "https://www.rosettastone.de/bildung/preisanfrage",
                lang: "de"
            },
            content: {
                title: {
                    type: "section-title",
                    theme: "yellow",
                    content: "Vereinbaren Sie noch heute einen Termin mit einem Sprachexperten."
                },
                sub_title: {
                    type: "section-sub-title",
                    theme: "white",
                    content: "Bitte füllen Sie das Formular unten aus, um einen Termin für ein Gespräch darüber zu vereinbaren, wie wir Ihnen helfen können."
                },
                lead_generation_form: {
                    explicitOptIn: {
                        content: "Ja, ich stimme dem Erhalt von Informations- und Marketingmaterial über Produktneuigkeiten, Angebote und Veranstaltungen von Rosetta Stone zu. Mit meiner Zustimmung bestätige ich die Verarbeitung meiner Daten gemäß der Datenschutzrichtlinie von Rosetta Stone."
                    },
                    title: {
                        theme: "blue",
                        type: "section-title",
                        content: "Fast geschafft!"
                    },
                    fields: {
                        first_name: {
                            field_name: "first_name",
                            field_type: "text",
                            label: "Vorname",
                            required: true,
                            required_error: "Bitte geben Sie Ihren Vornamen ein."
                        },
                        last_name: {
                            field_name: "last_name",
                            type: "text",
                            label: "Nachname",
                            required: true,
                            required_error: "Bitte geben Sie Ihren Nachnamen ein."
                        },
                        email: {
                            field_name: "email",
                            field_type: "email",
                            label: "E-Mail-Adresse",
                            required: true,
                            required_error: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
                            validation_error: "Please enter a valid Email Address."
                        },
                        phone: {
                            field_name: "phone",
                            field_type: "tel",
                            label: "Telefonnummer",
                            required: true,
                            required_error: null
                        },
                        organization_name: {
                            field_name: "organization_name",
                            field_type: "text",
                            label: "Unternehmen*",
                            required: true,
                            required_error: "Bitte geben Sie den Namen Ihres Unternehmens ein."
                        },
                        organization_size: {
                            field_name: "organization_size",
                            field_type: "text",
                            label: "Unternehmensgröße",
                            required: true,
                            required_error: "Bitte geben Sie die Größe Ihres Unternehmens ein.",
                            options: [
                                { value: "", label: "" },
                                { value: "100 oder Weniger", label: "100 oder Weniger" },
                                { value: "101 - 500", label: "101 - 500" },
                                {
                                    value: "501 - 1,000",
                                    label: "501 - 1,000"
                                },
                                { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                {
                                    value: "10,001 - 25,000",
                                    label: "10,001 - 25,000"
                                },
                                {
                                    value: "25,001 - 50,000",
                                    label: "25,001 - 50,000"
                                },
                                {
                                    value: "50,001 oder Mehr",
                                    label: "50,001 oder Mehr"
                                }
                            ]
                        },
                        role: {
                            field_name: "title",
                            field_type: "select",
                            label: "Titel",
                            required: true,
                            required_error: "Bitte geben Sie Ihre Funktion ein."
                        },
                        explicitOptIn: {
                            field_name: "explicitOptIn",
                            required: false
                        }
                    },
                    button: {
                        as: "button",
                        type: "submit",
                        size: "regular",
                        text: "Preis anfragen"
                    },
                    labels: {
                        form_principal: "Auftraggeber / Vizepräsident",
                        form_privacy1: "Ich stimme dem Erhalt von Info- und Marketingmaterial über Produktneuigkeiten, Angebote oder Einladungen zu Veranstaltungen von Rosetta Stone zu. Es ist mir bewusst, dass meine Daten mit internationalen Partnern, die Dienstleistungen für Rosetta Stone anbieten im Rahmen der",
                        form_privacy2: "Datenschutzrichtlinie von Rosetta Stone ",
                        form_privacy3: "teilen darf. Es ist mir ebenfalls bewusst, dass ich mich jederzeit von jeglicher Kommunikation abmelden kann, indem ich den" +
                            "Abmelden" +
                            "Link im Info- und Marketingmaterial klicke oder indem ich Rosetta Stone unter ",
                        form_privacy4: " kontaktiere.",
                        form_privacyUrl: "https://www.rosettastone.de/datenschutzrichtlinie",
                        form_privacyemail: "privacyofficer@rosettastone.com",
                        form_techcoordinator: "Technologiekoordinator",
                        form_updateagreement1: "Ja, ich möchte Produktneuigkeiten und Angebote von Rosetta Stone erhalten. ",
                        form_updateagreement2: "Mehr erfahren",
                        form_updateagreement3: " "
                    },
                    domain: ".de",
                    dataQaLocation: "page"
                },
                awards: awards$7({ strings }),
                branded_quotes: branded_quotes$7({ strings }),
                verticals: verticals$l({ strings })
            }
        };
    }
    if (page === "preisanfrage-abgeschlossen") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Preisanfrage abgeschlossen | Rosetta Stone",
                meta_description: "Sprachbarrieren schränken die Fähigkeit globaler Dienstleistungs- und Beratungsunternehmen ein, Kunden zu bedienen, mit Mitarbeitern zu interagieren und das Wachstum des Geschäfts weltweit zu fördern. Sprachtrainingslösungen helfen Dienstleistungs- und Beratungsunternehmen, den Anteil der abrechenbaren Arbeitszeit zu maximieren – ein Beleg für den relevanten ROI, den unsere Sprachtrainings organisationsweit erzielen.",
                canonical_url: "https://www.rosettastone.de/bildung/preisanfrage-abgeschlossen/",
                lang: "de"
            },
            content: {
                title: {
                    align: "center",
                    content: "Vielen Dank für Ihr Interesse!",
                    heading: "h1",
                    theme: "blue",
                    type: "page-title"
                },
                sub_title: {
                    align: "center",
                    heading: "h2",
                    content: "Sehen Sie sich vor dem Gespräch einige zusätzliche Ressourcen an!",
                    type: "page-sub-title"
                },
                resources_link: {
                    destination: "/ressourcen/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Ressourcen",
                    theme: "blue_white"
                },
                awards: awards$7({ strings }),
                branded_quotes: branded_quotes$7({ strings }),
                verticals: verticals$l({ strings })
            }
        };
    }
    if (page === "solutions") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Online-Sprachlernprogramme für den Bildungsbereich | Rosetta Stone",
                meta_description: "Die Online-Sprachlernprogramme von Rosetta Stone motivieren Englischlernende und Sprachschüler aus aller Welt, selbstsicher zu sprechen. Fragen Sie nach den Preisen.",
                canonical_url: "https://www.rosettastone.de/bildung/loesungen/",
                lang: "de"
            },
            content: {
                sections: [
                    {
                        data_qa: "section1",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Die Globalisierung sorgt für eine zunehmende Anzahl internationaler Kooperationen, doch Sprachbarrieren erschweren die Erschließung neuer Märkte. Rosetta Stone bietet Ihnen ein standardisiertes digitales Sprachtraining für alle Ihre Mitarbeiter an allen Standorten. Setzen Sie auf schnelle Erfolge mit unseren bewährten Trainingsmethoden und fördern Sie die interkulturelle Kompetenz Ihrer Mitarbeiter."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/preisanfrage/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Preis anfragen",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                image: { src: null },
                                title: {
                                    content: "Optimieren Sie Ihre globale Expansion.",
                                    align: "left",
                                    heading: "h2",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section2",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Schüler und Studierende von heute sind mit mobilen Geräten wie Smartphones und Tablets großgeworden. Mit flexiblem E-Learning sorgen Sie bei Digital Natives für Begeisterung. Sie schaffen eine zeitgemäße Erweiterung Ihres Unterrichts, ohne Ihren eigenen Aufwand zu erhöhen. Gruppentrainings, individuelle Lerninhalte und Fortschrittskontrollen fördern die Motivation Ihrer Schüler und Studierenden zusätzlich."
                                },
                                direction: "image-left",
                                title: {
                                    content: "Motivieren Sie Digital Natives mit modernen Trainingsmethoden.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                image: {
                                    src: null
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Das Sprechen einer zweiten oder dritten Sprache ist heute absolute Grundvoraussetzung für eine Karriere im internationalen Umfeld. Dennoch fehlt es aufgrund organisatorischer oder finanzieller Aspekte an vielen Schulen und Hochschulen an ausreichender Förderung. Mit den Sprachlernlösungen von Rosetta Stone stellen Sie sich dieser Entwicklung entgegen und positionieren sich als attraktive Bildungseinrichtung."
                                },
                                direction: "image-right",
                                image: { src: null },
                                title: {
                                    content: "Fördern Sie die Zukunft Ihrer Schüler und Studierenden.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section4",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Das Erlernen einer Fremdsprache erfordert viel Engagement und Durchhaltevermögen. Als Teil einer Gruppe lernen Ihre Schüler und Studierenden schneller und motivierter. Verantwortliche von Bildungseinrichtungen können diese Entwicklung unterstützen, indem sie die richtigen Online- und Offline-Tools zum gemeinsamen Lernen bereitstellen. Blended Learning-Konzepte und mobile Apps bereichern nicht nur den Unterricht, sondern schaffen auf allen Seiten mehr Freiräume."
                                },
                                direction: "image-left",
                                title: {
                                    content: "Etablieren Sie Sprachtraining als gemeinschaftliche Aktivität.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                image: {
                                    src: null
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        panels: [
                            {
                                data_qa: "4",
                                img_bg_top: images.solSection_7StoneBlueSvg,
                                img_bg_bottom: images.solSection_7StoneYellowSvg,
                                data: {
                                    feature_1_img: "icon_dynamic",
                                    feature_1_subtitle: "Wir lassen Ihre Schüler und Studierenden vollkommen in eine neue Sprachumgebung eintauchen, um das Sprechen, Lesen, Schreiben und Hören spielend und effizient zu trainieren. ",
                                    feature_1_title: "Immersiver Lernansatz.",
                                    feature_2_img: "icon_truaccent",
                                    feature_2_subtitle: "Mit direktem Feedback zur Aussprache unterbinden wir Fehler von Beginn an. Ihre Schüler und Studierenden erlernen die korrekte Diktion und haben mehr Selbstvertrauen beim Sprechen. ",
                                    feature_2_title: "Training der Aussprache.",
                                    feature_3_img: null,
                                    feature_3_subtitle: null,
                                    feature_3_title: null,
                                    feature_4_img: "icon_24",
                                    feature_4_subtitle: "Mit Rosetta Stone erlernen Ihre Schüler und Studierenden eine von bis zu 24 Sprachen – unabhängig davon, ob bereits erste Grundkenntnisse vorhanden sind oder nicht. ",
                                    feature_4_title: "24 Sprachen.",
                                    feature_5_img: "icon_assessments",
                                    feature_5_subtitle: "Wir bieten spezielle Offline-Übungsbücher und Materialien, die Ihren Unterricht erweitern und sämtliche Online-Übungen gezielt vertiefen. ",
                                    feature_5_title: "Unterrichtsergänzung.",
                                    feature_6_img: null,
                                    feature_6_subtitle: null,
                                    feature_6_title: null,
                                    feature_7_img: "icon_proficiency",
                                    feature_7_subtitle: "Mit einem Einstufungstest vor Trainingsbeginn identifizieren wir die individuellen Bedürfnisse und Fähigkeiten Ihrer Schüler, um herausfordernde aber dennoch machbare Aufgaben zu stellen. ",
                                    feature_7_title: "Einstufungstest.",
                                    feature_8_img: "icon_foundational",
                                    feature_8_subtitle: "Egal ob eine Sprache von Grund auf erlernt werden muss oder ob bereits Grundkenntnisse vorhanden sind: Mit Rosetta Stone Foundations und Rosetta Stone Advantage erhält jeder Schüler das passende Training. ",
                                    feature_8_title: "Anfänger und Fortgeschrittene.",
                                    feature_9_img: "icon_games",
                                    feature_9_subtitle: "Ob Vokabeln, Grammatik oder Aussprache: Wir setzen auf spezielle Trainingsmethoden, mit denen Ihrer Schüler und Studierenden ihre Lese-, Hör- und Sprachfertigkeiten spielend weiterentwickeln.",
                                    feature_9_title: "Games und Activities.",
                                    feature_10_img: "icon_reading",
                                    feature_10_subtitle: "Unsere Trainings beinhalten spezielle Lese- und Schreibübungen mit sofortigem Feedback. Auf diese Weise werden die wesentlichen Sprachfähigkeiten Hören, Lesen und Schreiben effizient trainiert.  ",
                                    feature_10_title: "Lese- und Schreibübungen.",
                                    feature_11_img: "icon_mobile",
                                    feature_11_subtitle: "Mit unseren mobilen Apps lernen Ihre Schüler und Studierenden an mobilen Endgeräten – wann und wo sie möchten. Dadurch erfüllen unsere flexiblen Lösungen auch die Anforderungen von Digital Natives.",
                                    feature_11_title: "Mobile Apps.",
                                    feature_12_img: "icon_reporting",
                                    feature_12_subtitle: "Unsere Reporting Tools zeigen die Lernfortschritte einzelner Schüler, Lerngruppen oder Klassen transparent auf und erleichtern es Ihren Lehrkräften, den Überblick zu bewahren.",
                                    feature_12_title: "Reporting Tools.",
                                    feature_13_img: "icon_transferable",
                                    feature_13_subtitle: "Mit unserem flexiblen Lizenzsystem können Sie schnell neue Schüler oder Studierende für das Training freischalten oder nicht genutzte Lizenzen übertragen.",
                                    feature_13_title: "Übertragbare Lizenzen",
                                    feature_14_img: "icon_implementation",
                                    feature_14_subtitle: "Unser erfahrenes Team stellt effektive Trainingsmodelle für Sie zusammen und unterstützt Sie bei der technischen und organisatorischen Umsetzung des Sprachtrainings in Ihrer Bildungseinrichtung.",
                                    feature_14_title: "Implementierungs-Support.",
                                    feature_15_img: "icon_training",
                                    feature_15_subtitle: "Wir unterstützen Sie dabei, dass die Einbindung unserer Sprachlernlösungen für alle Beteiligten ein voller Erfolg wird und schulen die verantwortlichen Personen an Ihrer Bildungseinrichtung.",
                                    feature_15_title: "Training-Services.",
                                    feature_section_title: "Jede Ressource, die Sie benötigen, steht Ihnen zur Verfügung",
                                    meta_description: "Die Online-Sprachlernprogramme von Rosetta Stone motivieren Englischlernende und Sprachschüler aus aller Welt, selbstsicher zu sprechen. Fragen Sie nach den Preisen.",
                                    meta_title: "Online-Sprachlernprogramme für den Bildungsbereich | Rosetta Stone",
                                    pricing_subtitle: null,
                                    pricing_title: null,
                                    section_1_body: "Fremdsprachenunterricht ist fester Bestandteil der Bildung an Schulen und Hochschulen. Mitunter entscheiden sich Schüler und Studierende auch freiwillig dazu, eine weitere Fremdsprache zu erlernen, um sich beispielsweise auf einen Auslandsaufenthalt vorzubereiten. Egal woher die Motivation Ihrer Schüler stammt: Mit Rosetta Stone bieten Sie an Ihrer Bildungseinrichtung das passende Training für alle Bedürfnisse. ",
                                    section_1_cta_caption: null,
                                    section_1_link: null,
                                    section_1_logo: null,
                                    section_1_play_text: null,
                                    section_1_quote: null,
                                    section_1_secondary_cta: "Angebot anfordern",
                                    section_1_title: "Erfüllen Sie individuelle Bedürfnisse mit nur einer Lösung. ",
                                    section_1_video_url: null,
                                    section_2_body: "Schüler und Studierende von heute sind mit mobilen Geräten wie Smartphones und Tablets großgeworden. Mit flexiblem E-Learning sorgen Sie bei Digital Natives für Begeisterung. Sie schaffen eine zeitgemäße Erweiterung Ihres Unterrichts, ohne Ihren eigenen Aufwand zu erhöhen. Gruppentrainings, individuelle Lerninhalte und Fortschrittskontrollen fördern die Motivation Ihrer Schüler und Studierenden zusätzlich.",
                                    section_2_link: null,
                                    section_2_logo: null,
                                    section_2_quote: null,
                                    section_2_title: "Motivieren Sie Digital Natives mit modernen Trainingsmethoden.",
                                    section_3_body: "Das Sprechen einer zweiten oder dritten Sprache ist heute absolute Grundvoraussetzung für eine Karriere im internationalen Umfeld. Dennoch fehlt es aufgrund organisatorischer oder finanzieller Aspekte an vielen Schulen und Hochschulen an ausreichender Förderung. Mit den Sprachlernlösungen von Rosetta Stone stellen Sie sich dieser Entwicklung entgegen und positionieren sich als attraktive Bildungseinrichtung. ",
                                    section_3_link: null,
                                    section_3_logo: null,
                                    section_3_play_text: null,
                                    section_3_quote: null,
                                    section_3_title: "Fördern Sie die Zukunft Ihrer Schüler und Studierenden. ",
                                    section_3_video_url: null,
                                    section_4_body: "Das Erlernen einer Fremdsprache erfordert viel Engagement und Durchhaltevermögen. Als Teil einer Gruppe lernen Ihre Schüler und Studierenden schneller und motivierter. Verantwortliche von Bildungseinrichtungen können diese Entwicklung unterstützen, indem sie die richtigen Online- und Offline-Tools zum gemeinsamen Lernen bereitstellen. Blended Learning-Konzepte und mobile Apps bereichern nicht nur den Unterricht, sondern schaffen auf allen Seiten mehr Freiräume.\n",
                                    section_4_link: null,
                                    section_4_logo: null,
                                    section_4_quote: null,
                                    section_4_title: "Etablieren Sie Sprachtraining als gemeinschaftliche Aktivität. ",
                                    title: "de-edu-solutions"
                                }
                            }
                        ]
                    }
                ],
                awards: awards$7({ strings }),
                branded_quotes: branded_quotes$7({ strings }),
                verticals: verticals$l({ strings }),
                lead_generation_bar: lead_generation_bar$l()
            }
        };
    }
    return pageConfig;
};

var education_primary_footer_config$7 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_consumer_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/bildung/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/hochschulen/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_products_education_secondary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/unternehmen/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/oeffentlichersektor/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_publicsector_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/ueber-uns",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/magazine",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_blog_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/kontakt/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/de/work",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/faq",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/systemanforderungen",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_system_requirements_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/lp/ccpa"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.de/vereinbarungen"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.de/nutzungsbedingungen"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.de/datenschutzrichtlinie/"
        },
        dataPrivacyAndSecurity: {
            visible: false,
            label: "",
            destination: ""
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStoneDE",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastoneDE",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var enterprise_nav_secondary_config$7 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: "",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_blog_label,
        title: strings.nav_secondary_enterprise_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_home_label,
        title: strings.nav_secondary_enterprise_home_label
    },
    resources: {
        visible: true,
        destination: "/ressourcen/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_resources_label,
        title: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
        visible: true,
        destination: "/loesungen/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_solutions_label
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_label
    }
});

var lead_generation_bar$k = () => {
    return {
        visible: true,
        dataQa: "lead generation bar",
        lead_generation_button: {
            schedule_appointment: false,
            button: {
                destination: "/preisanfrage/",
                new_window: false,
                size: "regular",
                text: "Preis anfragen",
                theme: "yellow_black"
            }
        },
        subtitle: {
            content: "",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        title: {
            content: "Bereit für den nächsten Schritt?",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        }
    };
};

var verticals$k = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_education_primary,
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/bildung/"
            },
            name: strings.verticals_education_primary,
            title: {
                content: strings.verticals_education_primary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_enterprise,
                src: verticals$q.enterpriseCirclePng
            },
            link: {
                destination: "/unternehmen/"
            },
            name: strings.verticals_enterprise,
            title: {
                content: strings.verticals_enterprise,
                type: "card-title"
            }
        }
    ]
});

const enterprise_pages_config$7 = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "dynamic-content") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "de"
            },
            content: {
                copyData: copyData$7(),
                awards: awards$7({ strings }),
                branded_quotes: branded_quotes$7({ strings }),
                verticals: verticals$k({ strings }),
                lead_generation_bar: lead_generation_bar$k()
            }
        };
    }
    if (page === "dynamic-resources") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "de"
            },
            content: {
                hero: {
                    layout: "list",
                    panels: [
                        {
                            layout: "image-right",
                            alignItems: "center",
                            image: {
                                src: null
                            },
                            title: {
                                content: "Ressourcen"
                            },
                            body: {
                                content: "Lassen Sie die Lernenden für sich selbst sprechen"
                            },
                            custom: {
                                lead_generation_button: {
                                    destination: "/preisanfrage/",
                                    theme: "yellow_black",
                                    internal: true,
                                    text: "Preis anfragen"
                                }
                            }
                        }
                    ]
                },
                copyData: copyData$7(),
                awards: awards$7({ strings }),
                branded_quotes: branded_quotes$7({ strings }),
                verticals: verticals$k({ strings }),
                lead_generation_bar: lead_generation_bar$k()
            }
        };
    }
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Geschäftssprachentraining, das funktioniert | Rosetta Stone",
                meta_description: "Die Schulungslösungen von Rosetta Stone helfen den Mitarbeitern, Sprachkenntnisse in Englisch für Unternehmen und viele gefragte Geschäftssprachen zu entwickeln. Preis anfragen",
                canonical_url: "https://www.rosettastone.de/unternehmen/",
                lang: "de"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                align: "list",
                                direction: "image-right",
                                video: {
                                    currentVideoUrl: "https://resources.rosettastone.com/CDN/us/videos/International_Markets/German/Catalyst_2_German.mp4",
                                    controls: true
                                },
                                title: {
                                    align: "left",
                                    content: "Effizientes Training ab der ersten Minute",
                                    heading: "h1",
                                    type: "page-title"
                                },
                                justifyContent: "space-between",
                                body: {
                                    content: "Eine neue Sprache zu erlernen, ist mit viel Aufwand verbunden und verlangt Durchhaltevermögen. Rosetta Stone hat einen einzigartigen Ansatz entwickelt, bei dem die Kenntnisse von Beginn an besonders effizient aufgebaut werden. Ihre Mitarbeiter wählen branchenspezifische Inhalte aus, die für sie besonders relevant sind und lernen auf Grundlage eines Einstufungstests. Erste Kenntnisse können schon bald im Arbeitsalltag eingesetzt werden."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/preisanfrage/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Preis anfragen",
                                            theme: "yellow_black"
                                        }
                                    }
                                }
                            }
                        ]
                    },
                    {
                        data_qa: "section2_productSample",
                        panels: [
                            {
                                title: {
                                    align: "left",
                                    content: "Gezieltes Lernen mit Muttersprachlern",
                                    type: "section-title",
                                    heading: "h2"
                                },
                                body: {
                                    content: "Eine Fremdsprache zu erlernen, ist eine Sache. Die Kenntnisse in der realen Welt anzuwenden, eine ganz andere. Mit unseren speziell konzipierten Trainingsmethoden stärken wir das Selbstbewusstsein Ihrer Mitarbeiter beim Sprechen. Großer Beliebtheit erfreuen sich dabei die Live-Tutorings mit Muttersprachlern, die Fragen beantworten oder die Aussprache verbessern. Dank flexibler Terminauswahl lässt sich das Live-Tutoring wunderbar in den Alltag integrieren."
                                },
                                panels: [
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.bicicletaAzulPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.bicicletaAmarillaPng
                                            }
                                        },
                                        challenge_text: "Una bicicleta azul"
                                    },
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.dosBicicletasAzulesPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.dosBicicletasDiferentesPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules"
                                    },
                                    {
                                        left_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.verdesPorUnDiaPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.azulesPorUnDiaPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules por un día por favor"
                                    }
                                ]
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Eine Fremdsprache zu erlernen, ist eine Sache. Die Kenntnisse in der realen Welt anzuwenden, eine ganz andere. Mit unseren speziell konzipierten Trainingsmethoden stärken wir das Selbstbewusstsein Ihrer Mitarbeiter beim Sprechen. Großer Beliebtheit erfreuen sich dabei die Live-Tutorings mit Muttersprachlern, die Fragen beantworten oder die Aussprache verbessern. Dank flexibler Terminauswahl lässt sich das Live-Tutoring wunderbar in den Alltag integrieren."
                                },
                                direction: "image-right",
                                image: {
                                    src: null
                                },
                                title: {
                                    content: "Gezieltes Lernen mit Muttersprachlern",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section4",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Ob vor der Arbeit, zwischen zwei Terminen oder nach Feierabend: Mit den mobilen Apps von Rosetta Stone lernen Ihre Mitarbeiter wann und wo sie möchten. Unsere Trainingsmethoden sind für mobile Endgeräte wie Tablets oder Smartphones optimiert und somit auch ideal auf die Zielgruppe der Digital Natives abgestimmt. Geben Sie Ihren Mitarbeitern die Flexibilität, die sie sich wünschen und positionieren Sie sich als attraktiver Arbeitgeber."
                                },
                                direction: "image-left",
                                image: {
                                    src: null
                                },
                                title: {
                                    content: "Flexibles Lernen – immer und überall auch Offline",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section5",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Hören, sprechen, lesen: Mit Rosetta Stone tauchen Ihre Mitarbeiter direkt in eine völlig neue Sprachwelt ein. Unser immersiver Lernansatz ist darauf ausgerichtet, dass die neuen Sprachkenntnisse Ihrer Mitarbeiter im Arbeitsalltag sofort Anwendung finden. Die vermittelten Inhalte sind relevant; jede investierte Minute zahlt sich aus – das wirkt sich positiv auf Ihren Return on Investment aus."
                                },
                                direction: "image-right",
                                image: {
                                    src: null
                                },
                                title: {
                                    content: "Fremdsprachen-Kenntnisse sofort einsetzen",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section6_features",
                        layout: "list",
                        panels: [
                            {
                                pageData: {
                                    learner_feature_1_icon_name: "icon_24",
                                    learner_feature_1_subtitle: "Übertragbar auf andere Mitarbeiter mit 24 Sprachen in einer Lizenz.",
                                    learner_feature_1_title: "Flexible Lizenzen",
                                    learner_feature_2_icon_name: "icon_dynamic",
                                    learner_feature_2_subtitle: "Die Lernfortschritte von Lernern sind transparent.",
                                    learner_feature_2_title: "Reporting Tools",
                                    learner_feature_3_icon_name: "icon_foundational",
                                    learner_feature_3_subtitle: "Ideal auf Vorkenntnisse und Ziele abgestimmt.",
                                    learner_feature_3_title: "Individuelle Inhalte",
                                    learner_feature_4_icon_name: "icon_truaccent",
                                    learner_feature_4_subtitle: "Mitarbeiter erhalten direktes Feedback.",
                                    learner_feature_4_title: "Training der Aussprache",
                                    learner_feature_5_icon_name: "icon_tutoring",
                                    learner_feature_5_subtitle: "Unbegrenztes Training mit Muttersprachlern.",
                                    learner_feature_5_title: "Live-Tutoring",
                                    learner_feature_6_icon_name: "icon_mobile",
                                    learner_feature_6_subtitle: "Flexibles Lernen - immer und überall auch Offline",
                                    learner_feature_6_title: "Mobile App",
                                    learner_feature_title: "Ob on- oder offline - unsere preisgekrönte App spricht für sich selbst!"
                                }
                            }
                        ],
                        visible: true
                    }
                ],
                awards: awards$7({ strings }),
                branded_quotes: branded_quotes$7({ strings }),
                verticals: verticals$k({ strings }),
                lead_generation_bar: lead_generation_bar$k()
            }
        };
    }
    if (page === "preisanfrage") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Preisanfrage | Rosetta Stone",
                meta_description: "Sprachbarrieren schränken die Fähigkeit globaler Dienstleistungs- und Beratungsunternehmen ein, Kunden zu bedienen, mit Mitarbeitern zu interagieren und das Wachstum des Geschäfts weltweit zu fördern. Sprachtrainingslösungen helfen Dienstleistungs- und Beratungsunternehmen, den Anteil der abrechenbaren Arbeitszeit zu maximieren – ein Beleg für den relevanten ROI, den unsere Sprachtrainings organisationsweit erzielen.",
                canonical_url: "https://www.rosettastone.de/unternehmen/preisanfrage/",
                lang: "de"
            },
            content: {
                title: {
                    type: "section-title",
                    theme: "yellow",
                    content: "Vereinbaren Sie noch heute einen Termin mit einem Sprachexperten."
                },
                sub_title: {
                    type: "section-sub-title",
                    theme: "white",
                    content: "Bitte füllen Sie das Formular unten aus, um einen Termin für ein Gespräch darüber zu vereinbaren, wie wir Ihnen helfen können."
                },
                lead_generation_form: {
                    explicitOptIn: {
                        content: "Ja, ich stimme dem Erhalt von Informations- und Marketingmaterial über Produktneuigkeiten, Angebote und Veranstaltungen von Rosetta Stone zu. Mit meiner Zustimmung bestätige ich die Verarbeitung meiner Daten gemäß der Datenschutzrichtlinie von Rosetta Stone."
                    },
                    title: {
                        theme: "blue",
                        type: "section-title",
                        content: "Fast geschafft!"
                    },
                    fields: {
                        first_name: {
                            field_name: "first_name",
                            field_type: "text",
                            label: "Vorname",
                            required: true,
                            required_error: "Bitte geben Sie Ihren Vornamen ein."
                        },
                        last_name: {
                            field_name: "last_name",
                            type: "text",
                            label: "Nachname",
                            required: true,
                            required_error: "Bitte geben Sie Ihren Nachnamen ein."
                        },
                        email: {
                            field_name: "email",
                            field_type: "email",
                            label: "E-Mail-Adresse",
                            required: true,
                            required_error: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
                            validation_error: "Please enter a valid Email Address."
                        },
                        phone: {
                            field_name: "phone",
                            field_type: "tel",
                            label: "Telefonnummer",
                            required: true,
                            required_error: null
                        },
                        organization_name: {
                            field_name: "organization_name",
                            field_type: "text",
                            label: "Unternehmen*",
                            required: true,
                            required_error: "Bitte geben Sie den Namen Ihres Unternehmens ein."
                        },
                        organization_size: {
                            field_name: "organization_size",
                            field_type: "text",
                            label: "Unternehmensgröße",
                            required: true,
                            required_error: "Bitte geben Sie die Größe Ihres Unternehmens ein.",
                            options: [
                                { value: "", label: "" },
                                { value: "100 oder Weniger", label: "100 oder Weniger" },
                                { value: "101 - 500", label: "101 - 500" },
                                {
                                    value: "501 - 1,000",
                                    label: "501 - 1,000"
                                },
                                { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                {
                                    value: "10,001 - 25,000",
                                    label: "10,001 - 25,000"
                                },
                                {
                                    value: "25,001 - 50,000",
                                    label: "25,001 - 50,000"
                                },
                                {
                                    value: "50,001 oder Mehr",
                                    label: "50,001 oder Mehr"
                                }
                            ]
                        },
                        role: {
                            field_name: "title",
                            field_type: "select",
                            label: "Titel",
                            required: true,
                            required_error: "Bitte geben Sie Ihre Funktion ein."
                        },
                        explicitOptIn: {
                            field_name: "explicitOptIn",
                            required: false
                        }
                    },
                    button: {
                        as: "button",
                        type: "submit",
                        size: "regular",
                        text: "Preis anfragen"
                    },
                    labels: {
                        form_principal: "Auftraggeber / Vizepräsident",
                        form_privacy1: "Ich stimme dem Erhalt von Info- und Marketingmaterial über Produktneuigkeiten, Angebote oder Einladungen zu Veranstaltungen von Rosetta Stone zu. Es ist mir bewusst, dass meine Daten mit internationalen Partnern, die Dienstleistungen für Rosetta Stone anbieten im Rahmen der",
                        form_privacy2: "Datenschutzrichtlinie von Rosetta Stone ",
                        form_privacy3: `teilen darf. Es ist mir ebenfalls bewusst, dass ich mich jederzeit von jeglicher Kommunikation abmelden kann, indem ich den "Abmelden" Link im Info- und Marketingmaterial klicke oder indem ich Rosetta Stone unter `,
                        form_privacy4: " kontaktiere.",
                        form_privacyUrl: "https://www.rosettastone.de/datenschutzrichtlinie",
                        form_privacyemail: "privacyofficer@rosettastone.com",
                        form_techcoordinator: "Technologiekoordinator",
                        form_updateagreement1: "Ja, ich möchte Produktneuigkeiten und Angebote von Rosetta Stone erhalten. ",
                        form_updateagreement2: "Mehr erfahren",
                        form_updateagreement3: " "
                    },
                    domain: ".de",
                    dataQaLocation: "page"
                },
                awards: awards$7({ strings }),
                branded_quotes: branded_quotes$7({ strings }),
                verticals: verticals$k({ strings })
            }
        };
    }
    if (page === "preisanfrage-abgeschlossen") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Preisanfrage abgeschlossen | Rosetta Stone",
                meta_description: "Sprachbarrieren schränken die Fähigkeit globaler Dienstleistungs- und Beratungsunternehmen ein, Kunden zu bedienen, mit Mitarbeitern zu interagieren und das Wachstum des Geschäfts weltweit zu fördern. Sprachtrainingslösungen helfen Dienstleistungs- und Beratungsunternehmen, den Anteil der abrechenbaren Arbeitszeit zu maximieren – ein Beleg für den relevanten ROI, den unsere Sprachtrainings organisationsweit erzielen.",
                canonical_url: "https://www.rosettastone.de/unternehmen/preisanfrage-abgeschlossen/",
                lang: "de"
            },
            content: {
                title: {
                    align: "center",
                    content: "Vielen Dank für Ihr Interesse!",
                    heading: "h1",
                    theme: "blue",
                    type: "page-title"
                },
                sub_title: {
                    align: "center",
                    heading: "h2",
                    content: "Sehen Sie sich vor dem Gespräch einige zusätzliche Ressourcen an!",
                    type: "page-sub-title"
                },
                resources_link: {
                    destination: "/ressourcen/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Ressourcen",
                    theme: "blue_white"
                },
                awards: awards$7({ strings }),
                branded_quotes: branded_quotes$7({ strings }),
                verticals: verticals$k({ strings })
            }
        };
    }
    if (page === "solutions") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Globales Geschäftssprachentraining  | Rosetta Stone Catalyst",
                meta_description: "Das weltweite Geschäftssprachentraining mit Rosetta Stone Catalyst bietet die Top-Geschäftssprachen, die Mitarbeiter von überall aus lernen können. Firmenpreis anfordern",
                canonical_url: "https://www.rosettastone.de/unternehmen/loesungen/",
                lang: "de"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                align: "list",
                                direction: "image-right",
                                video: {
                                    currentVideoUrl: "https://resources.rosettastone.com/CDN/us/videos/International_Markets/German/Catalyst_2_German.mp4",
                                    controls: true
                                },
                                title: {
                                    content: "Optimieren Sie Ihre globale Expansion.",
                                    align: "left",
                                    heading: "h2",
                                    type: "section-title"
                                },
                                justifyContent: "space-between",
                                body: {
                                    content: "Die Globalisierung sorgt für eine zunehmende Anzahl internationaler Kooperationen, doch Sprachbarrieren erschweren die Erschließung neuer Märkte. Rosetta Stone bietet Ihnen ein standardisiertes digitales Sprachtraining für alle Ihre Mitarbeiter an allen Standorten. Setzen Sie auf schnelle Erfolge mit unseren bewährten Trainingsmethoden und fördern Sie die interkulturelle Kompetenz Ihrer Mitarbeiter."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/preisanfrage/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Preis anfragen",
                                            theme: "yellow_black"
                                        }
                                    }
                                }
                            }
                        ]
                    },
                    {
                        data_qa: "section2",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Digitales Sprachtraining wird auf Management-Ebene immer beliebter, doch die Ausgaben müssen skalier- und messbar sein. Rosetta Stone steht Ihnen bei der Implementierung des kosteneffizienten Trainings zur Seite. Minimieren Sie Ihren administrativen Aufwand, geben Sie Ihren Mitarbeitern die Möglichkeit flexible zu lernen und behalten Sie mit unseren Reporting Tools stets den Überblick über Ihren ROI."
                                },
                                direction: "image-left",
                                title: {
                                    content: "Setzen Sie auf skalierbares digitales Training.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                image: {
                                    src: null
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Standortübergreifendes Arbeiten wird immer wichtiger, doch Kommunikationsprobleme sorgen für ärgerliche Fehler. Mit den Sprachlernlösungen von Rosetta Stone optimieren Sie die interne Kommunikation über verschiedene Standorte hinweg. Ihre Mitarbeiter wählen für sie relevante Inhalte aus, lernen vollkommen flexibel und gewinnen Selbstvertrauen beim Sprechen. Das verbessert die Performance, die Produktivität und die Zusammenarbeit im Team."
                                },
                                direction: "image-right",
                                image: { src: null },
                                title: {
                                    content: "Verbessern Sie die interne Kommunikation und Produktivität.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section4",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Viele Unternehmen bieten bereits Sprachtraining an, doch klassischer Unterricht kann die Anforderungen der Mitarbeiter nicht mehr erfüllen. Mit den flexiblen digitalen Sprachlernlösungen von Rosetta Stone steigern Sie die Lernmotivation und Zufriedenheit Ihrer Mitarbeiter. Erfüllen Sie die Bedürfnisse von Digital Natives und positionieren Sie sich als attraktiver Arbeitgeber."
                                },
                                direction: "image-left",
                                title: {
                                    content: "Steigern Sie die Zufriedenheit Ihrer Mitarbeiter.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                image: {
                                    src: null
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        panels: [
                            {
                                data_qa: "4",
                                img_bg_top: images.solSection_7StoneBlueSvg,
                                img_bg_bottom: images.solSection_7StoneYellowSvg,
                                data: {
                                    feature_1_img: "icon_dynamic",
                                    feature_1_subtitle: "Ihre Mitarbeiter entscheiden, welche Inhalte für sie besonders relevant sind und lernen anhand eines individuellen Lernpfads. Gelerntes findet im Berufsalltag direkt Anwendung. ",
                                    feature_1_title: "Individuelle Inhalte.",
                                    feature_2_img: "icon_truaccent",
                                    feature_2_subtitle: "Mit direktem Feedback zur Aussprache Ihrer Mitarbeiter unterbinden wir Fehler von Beginn an. Ihre Mitarbeiter erlernen die korrekte Diktion und haben mehr Selbstvertrauen beim Sprechen. ",
                                    feature_2_title: "Training der Aussprache.",
                                    feature_3_img: "icon_tutoring",
                                    feature_3_subtitle: "Unsere 1:1-Trainings mit Muttersprachlern dienen der gezielten Verbesserung der Aussprache und steigern das Selbstbewusstsein Ihrer Mitarbeiter bei der Anwendung neuer Kenntnisse.",
                                    feature_3_title: "Live-Tutoring.",
                                    feature_4_img: "icon_24",
                                    feature_4_subtitle: "Mit Rosetta Stone erlernen Ihre Mitarbeiter eine von bis zu 24 Sprachen – unabhängig davon, ob bereits erste Grundkenntnisse vorhanden sind oder die Sprache vollkommen neu erlernt werden muss. ",
                                    feature_4_title: "24 Sprachen.",
                                    feature_5_img: null,
                                    feature_5_subtitle: null,
                                    feature_5_title: null,
                                    feature_6_img: null,
                                    feature_6_subtitle: null,
                                    feature_6_title: null,
                                    feature_7_img: "icon_proficiency",
                                    feature_7_subtitle: "Mit einem Einstufungstest vor Trainingsbeginn identifizieren wir die individuellen Bedürfnisse und Fähigkeiten Ihrer Mitarbeiter, um herausfordernde aber dennoch machbare Aufgaben zu stellen. ",
                                    feature_7_title: "Einstufungstest.",
                                    feature_8_img: null,
                                    feature_8_subtitle: null,
                                    feature_8_title: null,
                                    feature_9_img: "icon_games",
                                    feature_9_subtitle: "Ob Vokabeln, Grammatik oder Aussprache: Wir setzen auf spezielle Trainingsmethoden, mit denen Ihre Mitarbeiter ihre Lese-, Hör- und Sprachfertigkeiten spielend weiterentwickeln.",
                                    feature_9_title: "Games und Activities.",
                                    feature_10_img: "icon_reading",
                                    feature_10_subtitle: "Unsere Trainings beinhalten spezielle Lese- und Schreibübungen mit sofortigem Feedback. Auf diese Weise werden die wesentlichen Sprachfähigkeiten Hören, Lesen und Schreiben effizient trainiert.  ",
                                    feature_10_title: "Lese- und Schreibübungen.",
                                    feature_11_img: "icon_mobile",
                                    feature_11_subtitle: "Mit unseren mobilen Apps lernen Ihre Mitarbeiter an mobilen Endgeräten – wann und wo sie möchten. Die flexiblen Lösungen bedienen dadurch auch die Anforderungen von Digital Natives.",
                                    feature_11_title: "Mobile Apps.",
                                    feature_12_img: "icon_reporting",
                                    feature_12_subtitle: "Unsere Reporting Tools zeigen die Lernfortschritte von Personen oder Gruppen sowie an einzelnen Standorten transparent auf, damit Sie jederzeit den Überblick über Ihren ROI behalten.",
                                    feature_12_title: "Reporting Tools.",
                                    feature_13_img: "icon_transferable",
                                    feature_13_subtitle: "Mit unserem flexiblen Lizenzsystem können Sie schnell neue Mitarbeiter für das Training freischalten oder nicht genutzte Lizenzen übertragen, was sich positiv auf den ROI auswirkt. ",
                                    feature_13_title: "Übertragbare Lizenzen.",
                                    feature_14_img: "icon_implementation",
                                    feature_14_subtitle: "Unser erfahrenes Team stellt effektive Trainingsmodelle für Sie zusammen und unterstützt Sie bei der technischen und organisatorischen Umsetzung des Sprachtrainings in Ihrem Unternehmen. ",
                                    feature_14_title: "Implementierungs-Support.",
                                    feature_15_img: "icon_training",
                                    feature_15_subtitle: "Wir unterstützen Sie dabei, dass die Einbindung unserer Sprachlernlösungen für alle Beteiligten ein voller Erfolg wird und schulen die verantwortlichen Personen in Ihrem Unternehmen. ",
                                    feature_15_title: "Training-Services.",
                                    feature_section_title: "Jede Ressource, die Sie benötigen, steht Ihnen zur Verfügung",
                                    meta_description: "Das weltweite Geschäftssprachentraining mit Rosetta Stone Catalyst bietet die Top-Geschäftssprachen, die Mitarbeiter von überall aus lernen können. Firmenpreis anfordern",
                                    meta_title: "Globales Geschäftssprachentraining  | Rosetta Stone Catalyst",
                                    pricing_subtitle: null,
                                    pricing_title: null,
                                    section_1_body: "Die Globalisierung sorgt für eine zunehmende Anzahl internationaler Kooperationen, doch Sprachbarrieren erschweren die Erschließung neuer Märkte. Rosetta Stone bietet Ihnen ein standardisiertes digitales Sprachtraining für alle Ihre Mitarbeiter an allen Standorten. Setzen Sie auf schnelle Erfolge mit unseren bewährten Trainingsmethoden und fördern Sie die interkulturelle Kompetenz Ihrer Mitarbeiter. ",
                                    section_1_cta_caption: null,
                                    section_1_link: null,
                                    section_1_logo: null,
                                    section_1_play_text: "Video abspielen",
                                    section_1_quote: null,
                                    section_1_secondary_cta: "Angebot anfordern",
                                    section_1_title: "Optimieren Sie Ihre globale Expansion.",
                                    section_1_video_url: "https://resources.rosettastone.com/CDN/us/videos/International_Markets/German/Catalyst_2_German.mp4",
                                    section_2_body: "Digitales Sprachtraining wird auf Management-Ebene immer beliebter, doch die Ausgaben müssen skalier- und messbar sein. Rosetta Stone steht Ihnen bei der Implementierung des kosteneffizienten Trainings zur Seite. Minimieren Sie Ihren administrativen Aufwand, geben Sie Ihren Mitarbeitern die Möglichkeit flexible zu lernen und behalten Sie mit unseren Reporting Tools stets den Überblick über Ihren ROI. ",
                                    section_2_link: null,
                                    section_2_logo: null,
                                    section_2_quote: null,
                                    section_2_title: "Setzen Sie auf skalierbares digitales Training. ",
                                    section_3_body: "Standortübergreifendes Arbeiten wird immer wichtiger, doch Kommunikationsprobleme sorgen für ärgerliche Fehler. Mit den Sprachlernlösungen von Rosetta Stone optimieren Sie die interne Kommunikation über verschiedene Standorte hinweg. Ihre Mitarbeiter wählen für sie relevante Inhalte aus, lernen vollkommen flexibel und gewinnen Selbstvertrauen beim Sprechen. Das verbessert die Performance, die Produktivität und die Zusammenarbeit im Team. ",
                                    section_3_link: null,
                                    section_3_logo: null,
                                    section_3_play_text: "Video abspielen",
                                    section_3_quote: null,
                                    section_3_title: "Verbessern Sie die interne Kommunikation und Produktivität.",
                                    section_3_video_url: "https://resources.rosettastone.com/CDN/us/videos/International_Markets/German/Catalyst_2_German.mp4",
                                    section_4_body: "Viele Unternehmen bieten bereits Sprachtraining an, doch klassischer Unterricht kann die Anforderungen der Mitarbeiter nicht mehr erfüllen. Mit den flexiblen digitalen Sprachlernlösungen von Rosetta Stone steigern Sie die Lernmotivation und Zufriedenheit Ihrer Mitarbeiter. Erfüllen Sie die Bedürfnisse von Digital Natives und positionieren Sie sich als attraktiver Arbeitgeber. \n",
                                    section_4_link: null,
                                    section_4_logo: null,
                                    section_4_quote: null,
                                    section_4_title: "Steigern Sie die Zufriedenheit Ihrer Mitarbeiter. ",
                                    title: "de-corp-solutions"
                                }
                            }
                        ]
                    }
                ],
                awards: awards$7({ strings }),
                branded_quotes: branded_quotes$7({ strings }),
                verticals: verticals$k({ strings }),
                lead_generation_bar: lead_generation_bar$k()
            }
        };
    }
    return pageConfig;
};

var enterprise_footer_config$7 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_consumer_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/bildung/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/hochschulen/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_products_education_secondary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/unternehmen/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/oeffentlichersektor/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_publicsector_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/ueber-uns",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/magazine",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_blog_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/kontakt/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/de/work",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/faq",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.de/systemanforderungen",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_system_requirements_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/lp/ccpa"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.de/vereinbarungen"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.de/nutzungsbedingungen"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.de/datenschutzrichtlinie/"
        },
        dataPrivacyAndSecurity: {
            visible: false,
            label: "",
            destination: ""
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStoneDE",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastoneDE",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var consumer_product_activation_footer_config$7 = (function (_ref) {
  var strings = _ref.strings;
  return {
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.de/vereinbarungen"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.de/nutzungsbedingungen"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.de/datenschutzrichtlinie/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneDE",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneDE",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var consumer_product_activation_pages_config$7 = (function (_ref) {
  var page = _ref.page;

  switch (page) {
    case "product-activation":
      return {
        page: page,
        helmet: {
          meta_title: "Rosetta Stone® - Online Subscription Product Activation",
          meta_description: "Activate your Rosetta Stone® language learning online subscription products.",
          canonical_url: "https://rosettastone.com/product/product-activation/",
          lang: "de"
        }
      };

    default:
      return null;
  }
});

var de = ({ market, site, page, locale, strings }) => {
    let nav_secondary = null;
    let page_config = null;
    let footer_config = null;
    switch (site) {
        case "business":
        case "enterprise":
            nav_secondary = enterprise_nav_secondary_config$7({ strings });
            page_config = enterprise_pages_config$7({ page, strings });
            footer_config = enterprise_footer_config$7({ strings });
            break;
        case "k12":
        case "education-primary":
            nav_secondary = education_primary_nav_secondary_config$7({ strings });
            page_config = education_primary_pages_config$7({ page, strings });
            footer_config = education_primary_footer_config$7({ strings });
            break;
        case "consumer-product-activation":
            footer_config = consumer_product_activation_footer_config$7({ strings });
            page_config = consumer_product_activation_pages_config$7({ page });
            break;
    }
    const nav_primary = nav_primary_config$7({ strings });
    return {
        market,
        site,
        vertical: site,
        locale,
        analytics: analytics$9,
        nav: {
            visible: true,
            primary: nav_primary || null,
            secondary: nav_secondary || null
        },
        footer: Object.assign({ visible: true }, footer_config),
        page: page_config
    };
};

var analytics$8 = {
    gtm_id: "GTM-NDSR53K"
};

var nav_primary_config$6 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: true,
        destination: "https://www.rosettastone.co.uk/magazine/",
        external: true,
        new_window: true,
        label: strings.nav_primary_blog_label
    },
    contact: {
        visible: false,
        destination: "/contact/",
        external: true,
        new_window: true,
        label: strings.nav_primary_contact_label
    },
    rs_logo: {
        visible: true,
        image: {
            type: "static",
            src: rsBranding.rsLogoBlackSvg,
            height: "40px",
            width: "93px",
            alt: strings.nav_primary_logo_alt
        },
        link: {
            destination: "/",
            external: false,
            new_window: false
        }
    },
    phone: {
        visible: true,
        external: false,
        new_window: false,
        destination: "tel:18003063467",
        label: strings.nav_primary_phone_label,
        number: strings.nav_primary_phone_number
    },
    select_language: {
        visible: true,
        external: false,
        new_window: false,
        language_options_featured: [
            {
                url: "/spanish/",
                title: strings.locale_es_es_label_primary,
                small: strings.locale_es_es_label_secondary
            },
            {
                url: "/french/",
                title: strings.locale_fr_fr_label_primary,
                small: strings.locale_fr_fr_label_secondary
            },
            {
                url: "/italian/",
                title: strings.locale_it_it_label_primary,
                small: strings.locale_it_it_label_secondary
            },
            {
                url: "/german/",
                title: strings.locale_de_de_label_primary,
                small: strings.locale_de_de_label_secondary
            },
            {
                url: "/english/",
                title: strings.locale_en_gb_label_primary,
                small: strings.locale_en_gb_label_secondary
            },
            {
                url: "/japanese/",
                title: strings.locale_ja_jp_label_primary,
                small: strings.locale_ja_jp_label_secondary
            }
        ],
        language_options_other: [
            {
                url: "/arabic/",
                title: strings.locale_ar_ar_label_primary,
                small: strings.locale_ar_ar_label_secondary
            },
            {
                url: "/chinese/",
                title: strings.locale_zn_cn_label_primary,
                small: strings.locale_zn_cn_label_secondary
            },
            {
                url: "/dutch/",
                title: strings.locale_nl_nl_label_primary,
                small: strings.locale_nl_nl_label_secondary
            },
            {
                url: "/english-american/",
                title: strings.locale_en_us_label_primary,
                small: strings.locale_en_us_label_secondary
            },
            {
                url: "/tagalog/",
                title: strings.locale_tl_ph_label_primary,
                small: strings.locale_tl_ph_label_secondary
            },
            {
                url: "/greek/",
                title: strings.locale_el_gr_label_primary,
                small: strings.locale_el_gr_label_secondary
            },
            {
                url: "/hebrew/",
                title: strings.locale_he_il_label_primary,
                small: strings.locale_he_il_label_secondary
            },
            {
                url: "/hindi/",
                title: strings.locale_hi_in_label_primary,
                small: strings.locale_hi_in_label_secondary
            },
            {
                url: "/irish/",
                title: strings.locale_ga_ie_label_primary,
                small: strings.locale_ga_ie_label_secondary
            },
            {
                url: "/korean/",
                title: strings.locale_ko_kr_label_primary,
                small: strings.locale_ko_kr_label_secondary
            },
            {
                url: "/farsi/",
                title: strings.locale_fa_ir_label_primary,
                small: strings.locale_fa_ir_label_secondary
            },
            {
                url: "/polish/",
                title: strings.locale_pl_pl_label_primary,
                small: strings.locale_pl_pl_label_secondary
            },
            {
                url: "/portuguese/",
                title: strings.locale_pt_br_label_primary,
                small: strings.locale_pt_br_label_secondary
            },
            {
                url: "/russian/",
                title: strings.locale_ru_ru_label_primary,
                small: strings.locale_ru_ru_label_secondary
            },
            {
                url: "/spanish-latin-america/",
                title: strings.locale_es_la_label_primary,
                small: strings.locale_es_la_label_secondary
            },
            {
                url: "/swedish/",
                title: strings.locale_sv_se_label_primary,
                small: strings.locale_sv_se_label_secondary
            },
            {
                url: "/turkish/",
                title: strings.locale_tr_tr_label_primary,
                small: strings.locale_tr_tr_label_secondary
            },
            {
                url: "/vietnamese/",
                title: strings.locale_vi_vn_label_primary,
                small: strings.locale_vi_vn_label_secondary
            }
        ],
        select_language_label: strings.nav_primary_catalog_select_language_label,
        label: strings.nav_primary_catalog_label,
        product_title: strings.global_brand_name
    },
    sign_in: {
        visible: true,
        destination: "https://www.rosettastone.com/login",
        external: true,
        new_window: false,
        label: strings.nav_primary_sign_in_label
    },
    switch_language: {
        visible: false,
        destination: "https://espanol.rosettastone.com/",
        external: true,
        new_window: false,
        label: ""
    },
    support: {
        visible: true,
        destination: "https://support.rosettastone.com/en/",
        external: true,
        new_window: false,
        label: strings.nav_primary_support_label
    },
    vertical_consumer: {
        visible: false,
        destination: "/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
        visible: false,
        destination: "/homeschool/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
        visible: true,
        destination: "/schools/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
        visible: false,
        destination: "/highereducation/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
        visible: false,
        destination: "/students/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
        visible: true,
        destination: "/enterprise/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_enterprise_label
    }
});

var education_primary_nav_secondary_config$6 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: "https://educationblog.rosettastone.com/",
        external: true,
        new_window: true,
        label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
        visible: true,
        destination: "/enterprise/resources/education/",
        external: true,
        new_window: false,
        label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
        visible: true,
        destination: "/solutions/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_solutions_label
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_label
    }
});

var awards$6 = ({ strings }) => {
    return {
        visible: true,
        title: {
            content: strings.awards_header_label,
            align: "center",
            type: "section-title"
        },
        panels: [
            {
                image: {
                    type: "static",
                    alt: strings.awards_twitter,
                    src: logosTiles.logosTilesTwitterSvg
                }
            },
            {
                image: {
                    type: "static",
                    alt: strings.awards_bmw,
                    src: logosTiles.logosTilesBmwSvg
                }
            },
            {
                image: {
                    type: "static",
                    alt: strings.awards_uber,
                    src: logosTiles.logosTilesUberSvg
                }
            },
            {
                image: {
                    type: "static",
                    alt: strings.awards_williams_sonoma,
                    src: logosTiles.logosTilesWsSvg
                }
            }
        ]
    };
};

var branded_quotes$6 = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.branded_quotes_header_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            name: strings.branded_quotes_macworld_name,
            type: strings.branded_quotes_macworld_type,
            quote: strings.branded_quotes_macworld_quote,
            logo: {
                type: "static",
                src: logos.logoMacworldSvg
            },
            backdrop: logos.logoMacworldBgSvg
        },
        {
            name: strings.branded_quotes_techcrunch_name,
            type: strings.branded_quotes_techcrunch_type,
            quote: strings.branded_quotes_techcrunch_quote,
            logo: {
                type: "static",
                src: logos.logoTechcrunchSvg
            },
            backdrop: logos.logoTechcrunchBgSvg
        },
        {
            name: strings.branded_quotes_cnn_name,
            type: strings.branded_quotes_cnn_type,
            quote: strings.branded_quotes_cnn_quote,
            logo: {
                type: "static",
                src: logos.logoCnnSvg
            },
            backdrop: logos.logoCnnBgSvg
        }
    ]
});

var lead_generation_bar$j = () => {
    return {
        visible: true,
        dataQa: "lead generation bar",
        lead_generation_button: {
            schedule_appointment: false,
            button: {
                destination: "/pricing-request/",
                new_window: false,
                size: "regular",
                text: "Price Enquiry",
                theme: "yellow_black"
            }
        },
        subtitle: {
            content: "",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        title: {
            content: "Ready to begin your organisation’s complete language journey?",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        }
    };
};

var verticals$j = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_enterprise,
                src: verticals$q.enterpriseCirclePng
            },
            link: {
                destination: "/enterprise/"
            },
            name: strings.verticals_enterprise,
            title: {
                content: strings.verticals_enterprise,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: "Schools",
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/schools"
            },
            name: "Schools",
            title: {
                content: strings.verticals_education_primary,
                type: "card-title"
            }
        }
    ]
});

var copyData$6 = () => ({
    about_us: "About Us",
    about_us_url: "/about",
    agreements: "Agreements",
    agreements_url: "https://www.rosettastone.co.uk/agreements",
    almost_there: "Nearly finished!",
    american: "(American)",
    anti_piracy: "Cookie Settings",
    anti_piracy_url: "https://www.rosettastone.co.uk/#",
    arabic: "Arabic",
    award_section_header: "Trusted for 25+ years by top organisations.",
    blog_url: "https://www.rosettastone.co.uk/magazine",
    brasil: "Brasil",
    brasil_url: "https://www.rosettastonebrasil.com/",
    brazil: "(Brazil)",
    british: " (British)",
    business_contact_title: "Business - Request Pricing",
    careers: "Careers",
    careers_url: "https://www.rosettastone.com/careers",
    cart_checkout: "Checkout",
    cart_checkout_url: "https://secure.rosettastone.co.uk/uk_en_store_view/checkout/cart/",
    cart_discount: "Discount:",
    cart_empty: "Your cart is currently empty.",
    cart_in_your_cart: "in your cart.",
    cart_subtotal: "Subtotal:",
    cart_summary: "Order Summary:",
    cart_total: "Total (pre-tax):",
    cart_you_have: "You have",
    change_region: "Change Region:",
    china: "中国",
    china_url: "http://www.rosettastone.cn/",
    combined_resources_url: "https://www.rosettastone.co.uk/business/resources/education",
    company: "Company",
    connect: "Connect with us:",
    consumer_home: "Consumer Home",
    contact: "Contact",
    contact_description: "Request Pricing Form",
    contact_ee_url: "/contact/",
    contact_url: "https://www.rosettastone.co.uk/contact",
    cta_bar: "Ready for the next step?",
    cta_h2: "Ready for the next step?",
    cta_text: "Request Pricing",
    currency: "£",
    demo_pricing_subtitle_business: "Discover how our business solutions can help your company attract talent and improve productivity. Fill out the form below and we'll be in touch soon.",
    demo_pricing_subtitle_hed: "Discover how our higher ed solutions can help your learners speak a new language with confidence. Fill out the form below and we'll be in touch soon.",
    demo_pricing_subtitle_k12: "Discover how our K-12 solutions can help your English and World Language learners speak with confidence. Fill out the form below and we'll be in touch soon.",
    demo_pricing_subtitle_pub: "Discover how our public sector solutions can improve communications with those you serve. Fill out the form below and we'll be in touch soon.",
    demo_pricing_title: "Get a free consultation",
    deutschland: "Deutschland",
    deutschland_url: "https://www.rosettastone.de/",
    download_pdf: "Download PDF",
    dutch: "Dutch",
    english: "English",
    espana: "España",
    espana_url: "https://www.rosettastone.es/",
    europe: "Europe",
    europe_url: "https://www.rosettastone.eu/",
    facebook_url: "http://www.facebook.com/RosettaStoneEU",
    faq_url: "/faq",
    faqs: "FAQs",
    farsi: " (Farsi)",
    filipino: "Filipino",
    for_business: "For Business",
    for_business_resources_url: "https://www.rosettastone.co.uk/business/resources/",
    for_business_solutions_url: "https://www.rosettastone.co.uk/business/solutions/",
    for_business_url: "https://www.rosettastone.co.uk/business/home/",
    for_educators: "For Educators",
    for_educators_resources_url: "https://www.rosettastone.co.uk/business/resources/",
    for_educators_solutions_url: "https://www.rosettastone.co.uk/schools/solutions/",
    for_educators_url: "https://www.rosettastone.co.uk/schools/home/",
    for_hed: "For Higher Education",
    for_homeschool: null,
    for_homeschool_url: null,
    for_individuals: "Try it Free",
    for_individuals_url: "/demo",
    for_organizations: "For Organisations",
    for_public_sector: "Mobile Apps",
    for_public_sector_url: "/mobile-apps",
    for_you: "For You",
    form_100: "100 or Less",
    form_500: "101 - 500",
    form_1000: "501 - 1,000",
    form_5000: "1,001 - 5,000",
    form_10000: "5,001 - 10,000",
    form_25000: "10,001 - 25,000",
    form_50000: "25,001 - 50,000",
    form_boardmember: "Board Member",
    form_curriculumdirector: "Curriculum Director/Instruction Coordinator",
    form_director: "Director",
    form_email: "Email Address",
    form_executive: "General Management/Executive",
    form_firstname: "First Name",
    form_how_blog: "Blog",
    form_how_email: "Email",
    form_how_event: "Event",
    form_how_online: "Online",
    form_how_other: "Other",
    form_how_referral: "Referral",
    form_how_search: "Search Engine",
    form_how_social: "Social Media",
    form_how_title: "How did you hear about us? (Optional)",
    form_how_webinar: "Webinar",
    form_individualcontributor: "Individual Contributor",
    form_lastname: "Surname",
    form_manager: "Manager",
    form_more: "50,001 - More",
    form_organization: "Institution",
    form_organizationsize: "Organisation Size",
    form_phone: "Phone Number (Optional)",
    form_principal: "Principal/Vice Principal",
    form_privacy1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's",
    form_privacy2: "Privacy Policy",
    form_privacy3: "I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at",
    form_privacy4: ".",
    form_privacyUrl: "https://www.rosettastone.co.uk/docs/terms/RS-UK_Website%20Privacy%20Policy_05252018.pdf",
    form_privacyemail: "privacyofficer@rosettastone.com",
    form_role: "Role (or title)",
    form_submit: "Submit",
    form_superintendent: "Superintendent/District Administrator",
    form_teacher: "Teacher",
    form_techcoordinator: "Technology Coordinator",
    form_updateagreement1: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
    form_updateagreement2: "here",
    form_updateagreement3: "for more information.",
    form_vicepresident: "Vice President",
    france: "France",
    france_url: "https://www.rosettastone.fr/",
    google_plus_url: "https://plus.google.com/105195149850491722010",
    greek: "Greek",
    gtm_id: "GTM-5NKD8Z",
    has_combined_resources: true,
    has_resources: null,
    hebrew: "Hebrew",
    helpful_links: "Please check your URL or connect with one of these helpful links:",
    hide_cart: true,
    hide_contact: true,
    hide_espanol: true,
    hide_language: null,
    hide_search: true,
    hide_support: null,
    hindi: "Hindi",
    home: "Home",
    home_link: "/home/",
    home_url: "https://www.rosettastone.co.uk/",
    instagram_url: "https://www.instagram.com/rosettastone",
    investors: "Investor Relations",
    investors_url: "https://investors.rosettastone.com/",
    irish: "Irish",
    italia: "Italia",
    italia_url: "https://www.rosettastone.it/",
    item: "item",
    item_plural: "items",
    japan: "日本",
    japan_url: "http://www.rosettastone.co.jp",
    japanese: "Japanese",
    k12_contact_title: "Schools - Request Pricing",
    keep_exploring: "Keep Exploring",
    korea: "대한민국",
    korea_url: "https://www.rosettakorea.com/",
    korean: "Korean",
    latin: null,
    latin_america: " (Latin America)",
    latin_america_region: "America Latina",
    latin_america_region_url: "https://espanol.rosettastone.com/",
    learn_arabic_url: "/learn-arabic/",
    learn_chinese: "Chinese",
    learn_chinese_url: "/learn-chinese",
    learn_dutch_url: "/learn-dutch/",
    learn_english: "Learn English",
    learn_english_british_url: "/learn-english-british/",
    learn_english_url: "/learn-english-american/",
    learn_french: "Learn French",
    learn_french_url: "/learn-french/",
    learn_german: "Learn German",
    learn_german_url: "/learn-german/",
    learn_greek_url: "/learn-greek/",
    learn_hebrew_url: "/learn-hebrew/",
    learn_hindi_url: "/learn-hindi/",
    learn_irish_url: "/learn-irish/",
    learn_italian: "Learn Italian",
    learn_italian_url: "/learn-italian/",
    learn_japanese_url: "/learn-japanese/",
    learn_korean_url: "/learn-korean/",
    learn_latin_url: null,
    learn_more: "Learn More",
    learn_persian_url: "/learn-farsi/",
    learn_polish_url: "/learn-polish/",
    learn_portuguese_url: "/learn-portuguese/",
    learn_russian_url: "/learn-russian/",
    learn_spanish: "Learn Spanish",
    learn_spanish_spain_url: "/learn-spanish/",
    learn_spanish_url: "/learn-spanish-latin-america/",
    learn_swedish_url: "/learn-swedish/",
    learn_tagalog_url: "/learn-tagalog/",
    learn_turkish_url: "/learn-turkish/",
    learn_vietnamese_url: "/learn-vietnamese/",
    lexia_learning: "Reviews",
    lexia_learning_url: "/reviews",
    listen_now: "Listen Now",
    madarin: " (Mandarin)",
    market: ["UK"],
    media_quote_1: "”I love Rosetta Stone's software, and I think ",
    media_quote_1_bold: "the approach to learning languages works.",
    media_quote_1_end: "”",
    media_quote_2: "“With its excellent user interface, clear instructions, wide variety of games and challenges... ",
    media_quote_2_bold: "Rosetta Stone has got it going on.",
    media_quote_2_end: "”",
    media_quote_3: "“The ",
    media_quote_3_bold: "gold standard ",
    media_quote_3_end: "of computer-based language learning.”",
    more_resources_title: "Additional Resources",
    more_specify: "Please specify",
    no_support_dropdown: true,
    persian: "Persian",
    polish: "Polish",
    portuguese: "Portuguese",
    press: "Press",
    press_url: "https://www.rosettastone.co.uk/press/overview",
    pricing_subtitle: "Please fill out the form below and we'll follow up with you right away.",
    pricing_thanks: "Thanks for your interest! Someone will follow up with you shortly.",
    pricing_title: "Get the pricing answers you need.",
    privacy_policy: "Privacy Policy",
    privacy_policy_url: "https://www.rosettastone.co.uk/docs/terms/RS-UK_Website%20Privacy%20Policy_05252018.pdf",
    products: "Where To Start",
    questions_call: "Questions? Call us:",
    read_article: "Read Article",
    read_case_study: "Read Case Study",
    read_ebook: "Read eBook",
    read_fact_sheet: "Read Fact Sheet",
    read_guide: "Read Guide",
    read_more: "Read More",
    read_report: "Read Report",
    read_white_paper: "Read White Paper",
    related_resources_title: "Related Resources",
    request_pricing: "Request Pricing",
    resources: "Resources",
    resources_link: "/resources/",
    rosetta_copyright: "1999-2019 Rosetta Stone LLC. All Rights Reserved. This site uses cookies. Continued use of this website gives consent to cookies being used.",
    rosetta_stone: "Rosetta Stone",
    russian: "Russian",
    search: "Search...",
    search_rosetta_url: "https://search.rosettastone.com/en",
    select_lang: "Select a language:",
    services: "Services",
    services_url: null,
    shop_now: "Shop Now",
    sign_in: "Sign In",
    sign_in_url: "https://www.rosettastone.co.uk/lp/login",
    similar_resources: "Similar Resources",
    site_not_found: "Site not found - 404",
    sitemap: "Sitemap",
    sitemap_url: "/sitemap",
    solutions: "Solutions",
    solutions_link: "/solutions/",
    spain: "(Spain)",
    spanish: "Spanish",
    support: "Support",
    support_business_url: "https://rosettastone.secure.force.com/apex/PreLiveChatForm",
    support_chat: "Live technical support chat",
    support_chat_live: "Live technical support chat",
    support_chat_live_url: "https://rosettastone.secure.force.com/apex/PreLiveChatForm",
    support_chat_url: "https://support.rosettastone.com/en/chat",
    support_classrooms: "Support for Classrooms & Enterprises",
    support_faq_btn: "View All FAQs",
    support_faq_title: "Frequently Asked Questions:",
    support_faq_url_1: "/faq#q1",
    support_faq_url_1_title: "What is the Rosetta Stone® solution?",
    support_faq_url_2: "/faq#q2",
    support_faq_url_2_title: "What's included with the Rosetta Stone online subscription course?",
    support_faq_url_3: "/faq#q3",
    support_faq_url_3_title: "How and where can I get mobile apps for my iPhone, iPad, or Android device?",
    support_faq_url_4: "/faq#q4",
    support_faq_url_4_title: "What is speech-recognition technology, and how can it help me?",
    support_for_you: "Support for you:",
    support_home: "Support Site",
    support_site: "Support Site",
    support_site_url: "https://support.rosettastone.com/en/",
    swedish: "Swedish",
    switch_lang: "Español",
    switch_lang_url: "https://espanol.rosettastone.com/",
    system_reqs: "System Requirements",
    system_reqs_url: "/system-requirements",
    tagalog: " (Tagalog)",
    telephone_atr: "+ 44 (0) 20 7 749 2979",
    telephone_text: "0800 085 3492",
    terms_conditions: "Terms & Conditions",
    terms_conditions_url: "https://www.rosettastone.com/terms/",
    title: "uk-copy",
    turkish: "Turkish",
    twitter_url: "https://twitter.com/RosettaStoneUK",
    united_kingdom: "United Kingdom",
    united_kingdom_url: "https://www.rosettastone.co.uk/",
    united_states: "United States",
    united_states_url: "https://www.rosettastone.com",
    use_new_header: true,
    vertical: ["recECBjZxFEWVVls8"],
    vertical_business: "Business",
    vertical_business_link: "/business/home/",
    vertical_healthcare: null,
    vertical_healthcare_link: null,
    vertical_hed: "Higher Education",
    vertical_hed_link: "/higher-education/home/",
    vertical_k12: "Schools",
    vertical_k12_link: "/schools/home/",
    vertical_pub: "Public Sector",
    vertical_pub_link: "/publicsector/",
    verticals_subtitle: "Our award-winning language solutions work for all types of learners.",
    verticals_title: "What type of learner are you?",
    vietnamese: "Vietnamese",
    view_infographic: "View Infographic",
    watch_video: "Watch Video",
    watch_webinar: "Watch Webinar",
    youtube_url: "http://www.youtube.com/user/RosettaStoneUK"
});

const education_primary_pages_config$6 = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "dynamic-content") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "en"
            },
            content: {
                copyData: copyData$6(),
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$j({ strings }),
                lead_generation_bar: lead_generation_bar$j()
            }
        };
    }
    if (page === "dynamic-resources") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "en"
            },
            content: {
                copyData: copyData$6(),
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$j({ strings }),
                lead_generation_bar: lead_generation_bar$j()
            }
        };
    }
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Digital Language Learning for Schools | Rosetta Stone",
                meta_description: "Rosetta Stone digital language learning for schools integrates easily into classrooms and any language programme. Ask us about pricing.",
                canonical_url: "https://www.rosettastone.co.uk/schools/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                align: "list",
                                direction: "image-right",
                                video: {
                                    controls: true,
                                    currentVideoUrl: "https://player.vimeo.com/video/591688104"
                                },
                                title: {
                                    align: "left",
                                    content: "Move language learning online.",
                                    heading: "h1",
                                    type: "page-title"
                                },
                                justifyContent: "space-between",
                                body: {
                                    content: "Rosetta Stone offers a unique approach that has students speaking from the start. Our online language learning method prepares students to speak for themselves, anywhere their new language takes them."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/pricing-request/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Price Enquiry",
                                            theme: "yellow_black"
                                        }
                                    }
                                }
                            }
                        ]
                    },
                    {
                        data_qa: "section2",
                        panels: [
                            {
                                title: {
                                    content: "Learn naturally.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                body: {
                                    content: "Every word your students hear, speak, and read is in their new language, beginning with the first lesson. Immersion is the natural way to learn a language, so when it's time to speak, students will be ready."
                                },
                                custom: {
                                    cta: {
                                        button: {
                                            destination: "https://www.rosettastone.co.uk/enterprise/resources/content/classroom-solutions-measurable-language-learning-success/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Watch Video",
                                            theme: "blue_white"
                                        }
                                    }
                                },
                                panels: [
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.bicicletaAzulPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.bicicletaAmarillaPng
                                            }
                                        },
                                        challenge_text: "Una bicicleta azul"
                                    },
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.dosBicicletasAzulesPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.dosBicicletasDiferentesPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules"
                                    },
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.verdesPorUnDiaPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.azulesPorUnDiaPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules por un día por favor"
                                    }
                                ]
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Speaking a new language in the classroom isn’t easy at first. Mistakes can make students shy. Our TruAccent™ speech engine guides pronunciation until students feel confident speaking on their own."
                                },
                                direction: "image-right",
                                image: {
                                    alt: "Promoting the power of bilingualism",
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    content: "Speak confidently.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                custom: {
                                    quote: {
                                        align: "left",
                                        attribution: "Faculty Leader, Harrogate Grammar School",
                                        quote: "Rosetta Stone provides our students with the opportunity to study almost any language they want. That allows us to personalise language learning in a really powerful way.",
                                        link: {
                                            destination: "https://www.rosettastone.co.uk/enterprise/resources/content/harrogate-grammar-school",
                                            theme: "black"
                                        }
                                    }
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "4",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Live Tutoring sessions allow students to practice conversation at their proficiency level, with native-speaking certified coaches. That makes tutoring in our safe space another smart way to learn."
                                },
                                direction: "image-left",
                                image: {
                                    alt: "Promoting the power of bilingualism",
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    content: "Make conversation.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                custom: {
                                    quote: {
                                        align: "left",
                                        attribution: "Head Teacher, Norlington School for Boys",
                                        quote: "The solution is very simple in its use, but very powerful at the same time. Students can access it quickly and learn fast...",
                                        link: {
                                            destination: "https://www.rosettastone.co.uk/enterprise/resources/content/norlington-school-for-boys/",
                                            theme: "black"
                                        }
                                    }
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "5",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Our mobile app lets your students log in to their language learning program and activities whenever the time is right. That way, they have the freedom to turn any moment into a teachable one."
                                },
                                direction: "image-right",
                                image: {
                                    alt: "Promoting the power of bilingualism",
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    content: "Access anywhere.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                custom: {
                                    quote: {
                                        align: "left",
                                        attribution: "Assistant Headteacher, Belle Vue Girls",
                                        quote: "We use Rosetta Stone to support our teaching of ALL languages, because the students love the feeling of independence the programme offers.",
                                        link: {
                                            destination: "https://www.rosettastone.co.uk/enterprise/resources/content/belle-vue-girls-immersion/",
                                            theme: "black"
                                        }
                                    }
                                }
                            }
                        ],
                        visible: true
                    }
                ],
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$j({ strings }),
                lead_generation_bar: lead_generation_bar$j()
            }
        };
    }
    if (page === "solutions") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Online Language Learning Education Programs  | Rosetta Stone",
                meta_description: "Rosetta Stone online programs support language learners in schools, higher education, and teacher training. Learn how, and ask about education pricing.",
                canonical_url: "https://www.rosettastone.co.uk/schools/solutions/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        data_qa: "Section 1",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Our self-paced approach to language learning helps all students to start speaking right away. So whether they are learning English or a world language, they’ll build their speaking confidence from the start."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Price Enquiry",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                title: {
                                    align: "left",
                                    content: "Inspire learners to speak a new language.",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                image: {
                                    alt: "Promoting the power of bilingualism",
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section2",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Students speaking little or no local language may hesitate at the classroom door. Rosetta Stone offers online and offline resources to help learners and teachers achieve their language and curriculum goals."
                                },
                                direction: "image-left",
                                title: {
                                    align: "left",
                                    content: "Put students at ease.",
                                    heading: "h2",
                                    type: "page-title",
                                    theme: "black"
                                },
                                image: {
                                    alt: "Promoting the power of bilingualism",
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                custom: {
                                    cta: {
                                        destination: "/enterprise/resources/content/edtech-solutions-for-your-language-classroom/",
                                        size: "regular",
                                        theme: "blue_white",
                                        text: "Watch Video"
                                    }
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "No matter how students become globally aware, an important next step is to learn a world language. Online learning accelerates students’ ability to develop new speaking skills and use them confidently."
                                },
                                direction: "image-right",
                                image: {
                                    alt: "Promoting the power of bilingualism",
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Serve higher education.",
                                    heading: "h2",
                                    type: "page-title",
                                    theme: "black"
                                },
                                custom: {
                                    cta: {
                                        destination: "/enterprise/resources/content/university-of-barcelona-critical-language-skills/",
                                        size: "regular",
                                        theme: "blue_white",
                                        text: "Read Case Study"
                                    }
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 4",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Educators can access Rosetta Stone solutions whenever and wherever it suits their busy schedules. Our online program gives teachers added flexibility in their personal and professional development."
                                },
                                direction: "image-left",
                                image: {
                                    alt: "Promoting the power of bilingualism",
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Reach out to teachers.",
                                    heading: "h2",
                                    type: "page-title",
                                    theme: "black"
                                },
                                custom: {
                                    cta: {
                                        destination: "/enterprise/resources/content/north-east-tsst-customer-spotlight/",
                                        size: "regular",
                                        theme: "blue_white",
                                        text: "Learn More"
                                    }
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        panels: [
                            {
                                data_qa: "section5",
                                img_bg_top: images.solSection_7StoneBlueSvg,
                                img_bg_bottom: images.solSection_7StoneYellowSvg,
                                data: {
                                    feature_1_img: "icon_dynamic",
                                    feature_1_subtitle: "Surrounding students with one language speeds up learning. ",
                                    feature_1_title: "Self-paced Immersion",
                                    feature_2_img: "icon_truaccent",
                                    feature_2_subtitle: "It’s the pronunciation helper any student can use.",
                                    feature_2_title: "TruAccent™ Speech Recognition",
                                    feature_3_img: "icon_tutoring",
                                    feature_3_subtitle: "Offered in a safe, online space at each student’s proficiency level.",
                                    feature_3_title: "Live Tutoring",
                                    feature_4_img: "icon_24",
                                    feature_4_subtitle: "English and world languages to match student goals.",
                                    feature_4_title: "24 Languages",
                                    feature_5_img: "icon_assessments",
                                    feature_5_subtitle: "Including staff language training meets a growing need.",
                                    feature_5_title: "Professional Development",
                                    feature_6_img: "icon_placement",
                                    feature_6_subtitle: "Offline resources to support teachers and students. ",
                                    feature_6_title: "Classroom Builders",
                                    feature_7_img: null,
                                    feature_7_subtitle: null,
                                    feature_7_title: null,
                                    feature_8_img: "icon_foundational",
                                    feature_8_subtitle: "Lessons keep up with students, not the other way around.",
                                    feature_8_title: "Engaging Content",
                                    feature_9_img: "icon_games",
                                    feature_9_subtitle: "Students have fun while reinforcing lessons they’ve learned.",
                                    feature_9_title: "Games and Activities",
                                    feature_10_img: null,
                                    feature_10_subtitle: null,
                                    feature_10_title: null,
                                    feature_11_img: "icon_mobile",
                                    feature_11_subtitle: "Puts learning access in each student’s hand.",
                                    feature_11_title: "Mobile App",
                                    feature_12_img: "icon_reporting",
                                    feature_12_subtitle: "Access up-to-date details on learner progress anytime.",
                                    feature_12_title: "Reporting",
                                    feature_13_img: "icon_transferable",
                                    feature_13_subtitle: "Education online customer community for sharing ideas and best practices.",
                                    feature_13_title: "The Bridge",
                                    feature_14_img: "icon_implementation",
                                    feature_14_subtitle: "Expert services make sure getting started is smooth sailing.",
                                    feature_14_title: "Implementation Support",
                                    feature_15_img: "icon_training",
                                    feature_15_subtitle: "Tailored to your school’s size and needs.",
                                    feature_15_title: "Training Services",
                                    feature_section_title: "Every resource you need is at your fingertips.",
                                    meta_description: "Rosetta Stone online programs support language learners in schools, higher education, and teacher training. Learn how, and ask about education pricing.",
                                    meta_title: "Online Language Learning Education Programs  | Rosetta Stone",
                                    pricing_subtitle: null,
                                    pricing_title: null,
                                    section_1_body: "Our self-paced approach to language learning helps all students to start speaking right away. So whether they are learning English or a world language, they’ll build their speaking confidence from the start.",
                                    section_1_cta_caption: null,
                                    section_1_link: null,
                                    section_1_logo: null,
                                    section_1_play_text: null,
                                    section_1_quote: null,
                                    section_1_secondary_cta: "Pricing Enquiry",
                                    section_1_title: "Inspire learners to speak a new language.",
                                    section_1_video_url: null,
                                    section_2_body: "Students speaking little or no local language may hesitate at the classroom door. Rosetta Stone offers online and offline resources to help learners and teachers achieve their language and curriculum goals. ",
                                    section_2_link: "https://www.rosettastone.co.uk/enterprise/resources/content/edtech-solutions-for-your-language-classroom",
                                    section_2_logo: null,
                                    section_2_quote: "Watch Video",
                                    section_2_title: "Put students at ease.",
                                    section_3_body: "No matter how students become globally aware, an important next step is to learn a world language. Online learning accelerates students’ ability to develop new speaking skills and use them confidently. ",
                                    section_3_link: "https://www.rosettastone.co.uk/enterprise/resources/content/university-of-barcelona-critical-language-skills",
                                    section_3_logo: null,
                                    section_3_play_text: null,
                                    section_3_quote: "Read Case Study",
                                    section_3_title: "Serve higher education.",
                                    section_3_video_url: null,
                                    section_4_body: "Educators can access Rosetta Stone solutions whenever and wherever it suits their busy schedules. Our online program gives teachers added flexibility in their personal and professional development.\n",
                                    section_4_link: "https://www.rosettastone.co.uk/enterprise/resources/content/north-east-tsst-customer-spotlight",
                                    section_4_logo: null,
                                    section_4_quote: "Learn More",
                                    section_4_title: "Reach out to teachers.",
                                    title: "uk-edu-solutions"
                                }
                            }
                        ]
                    }
                ],
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$j({ strings }),
                lead_generation_bar: lead_generation_bar$j()
            }
        };
    }
    if (page === "pricing-request") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.co.uk/schools/pricing-request/",
                lang: "en"
            },
            content: {
                title: {
                    type: "section-title",
                    theme: "yellow",
                    content: "Complete the Form Below to Request Pricing for Your Classroom or School"
                },
                sub_title: {
                    type: "section-sub-title",
                    theme: "white",
                    content: "Please fill out the form below to schedule time to discuss how we can help."
                },
                lead_generation_form: {
                    title: {
                        theme: "blue",
                        type: "section-title",
                        content: "Almost there!"
                    },
                    fields: {
                        first_name: {
                            field_name: "first_name",
                            field_type: "text",
                            label: "First Name",
                            required: true,
                            required_error: "Please enter your First Name."
                        },
                        last_name: {
                            field_name: "last_name",
                            type: "text",
                            label: "Last Name",
                            required: true,
                            required_error: "Please enter your Last Name."
                        },
                        email: {
                            field_name: "email",
                            field_type: "email",
                            label: "Email Address",
                            required: true,
                            required_error: "Please enter your Email Address.",
                            validation_error: "Please enter a valid Email Address."
                        },
                        phone: {
                            field_name: "phone",
                            field_type: "tel",
                            label: "Phone Number",
                            required: true,
                            required_error: null
                        },
                        organization_name: {
                            field_name: "organization_name",
                            field_type: "text",
                            label: "Company",
                            required: true,
                            required_error: "Please enter your Company Name."
                        },
                        organization_size: {
                            field_name: "organization_size",
                            field_type: "text",
                            label: "Company Size",
                            required: true,
                            required_error: "Please enter your Company Size.",
                            options: [
                                { value: "", label: "" },
                                { value: "100 or Less", label: "100 or Less" },
                                { value: "101 - 500", label: "101 - 500" },
                                {
                                    value: "501 - 1,000",
                                    label: "501 - 1,000"
                                },
                                { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                {
                                    value: "10,001 - 25,000",
                                    label: "10,001 - 25,000"
                                },
                                {
                                    value: "25,001 - 50,000",
                                    label: "25,001 - 50,000"
                                },
                                {
                                    value: "50,001 or More",
                                    label: "50,001 or More"
                                }
                            ]
                        },
                        role: {
                            field_name: "title",
                            field_type: "select",
                            label: "Title",
                            required: true,
                            required_error: "Please enter your Role."
                        },
                        explicitOptIn: {
                            field_name: "explicitOptIn",
                            required: false
                        }
                    },
                    button: {
                        as: "button",
                        type: "submit",
                        size: "regular",
                        text: "Price Enquiry"
                    },
                    labels: {
                        form_privacy1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's",
                        form_privacy2: "Privacy Policy",
                        form_privacy3: "I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at",
                        form_privacy4: ".",
                        form_privacyUrl: "https://www.rosettastone.com/privacy",
                        form_privacyemail: "privacyofficer@rosettastone.com",
                        form_updateagreement1: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
                        form_updateagreement2: "here",
                        form_updateagreement3: "for more information."
                    },
                    domain: ".co.uk",
                    dataQaLocation: "page"
                },
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$j({ strings })
            }
        };
    }
    if (page === "pricing-request-complete") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.co.uk/schools/pricing-request/",
                lang: "en"
            },
            content: {
                lead_generation_bar: {
                    visible: false
                },
                title: {
                    align: "center",
                    content: "Thanks for your interest!",
                    heading: "h1",
                    theme: "blue",
                    type: "page-title"
                },
                sub_title: {
                    align: "center",
                    heading: "h2",
                    content: "Check out some additional resources before your meeting!",
                    type: "page-sub-title"
                },
                resources_link: {
                    destination: "/enterprise/resources/education",
                    internal: false,
                    new_window: false,
                    size: "regular",
                    text: "Resources",
                    theme: "blue_white"
                },
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$j({ strings })
            }
        };
    }
    if (page === "pricing-request-schedule") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.co.uk/schools/pricing-request/",
                lang: "en"
            },
            content: {
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$j({ strings }),
                lead_generation_bar: {
                    visible: false
                }
            }
        };
    }
    return pageConfig;
};

var education_primary_footer_config$6 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_consumer_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/schools/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/higher-education/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_secondary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/enterprise/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/about/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/magazine",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_blog_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/en/work/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/product/faq/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_faqs_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/lp/ccpa"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.co.uk/agreements"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "www.rosettastone.co.uk/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: false,
            label: "",
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStoneEU",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/RosettaStoneUK",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastoneUK",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var enterprise_nav_secondary_config$6 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: true,
        destination: "https://enterpriseblog.rosettastone.com/",
        external: true,
        new_window: true,
        label: strings.nav_secondary_enterprise_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_home_label
    },
    resources: {
        visible: true,
        destination: "/resources/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
        visible: true,
        destination: null,
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_solutions_label,
        options: [
            {
                link: "/industry/consulting/",
                label: strings.nav_secondary_enterprise_solutions_consulting_label,
                title: strings.nav_secondary_enterprise_solutions_consulting_label
            },
            {
                link: "/industry/financial/",
                label: strings.nav_secondary_enterprise_solutions_financial_label,
                title: strings.nav_secondary_enterprise_solutions_financial_label
            },
            {
                link: "/industry/logistics/",
                label: strings.nav_secondary_enterprise_solutions_logistics_label,
                title: strings.nav_secondary_enterprise_solutions_logistics_label
            },
            {
                link: "/industry/manufacturing/",
                label: strings.nav_secondary_enterprise_solutions_manufacturing_label,
                title: strings.nav_secondary_enterprise_solutions_manufacturing_label
            },
            {
                link: "/industry/pharmaceutical/",
                label: strings.nav_secondary_enterprise_solutions_pharmaceutical_label,
                title: strings.nav_secondary_enterprise_solutions_pharmaceutical_label
            },
            {
                link: "/industry/retail/",
                label: strings.nav_secondary_enterprise_solutions_retail_label,
                title: strings.nav_secondary_enterprise_solutions_retail_label
            }
        ]
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_label
    }
});

var lead_generation_bar$i = () => {
    return {
        visible: true,
        dataQa: "lead generation bar",
        lead_generation_button: {
            schedule_appointment: false,
            button: {
                destination: "/pricing-request/",
                new_window: false,
                size: "regular",
                text: "Price Enquiry",
                theme: "yellow_black"
            }
        },
        subtitle: {
            content: "",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        title: {
            content: "Ready to begin your organisation’s complete language journey?",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        }
    };
};

var verticals$i = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_education_primary,
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/schools"
            },
            name: strings.verticals_education_primary,
            title: {
                content: strings.verticals_education_primary,
                type: "card-title"
            }
        }
    ]
});

const enterprise_pages_config$6 = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "dynamic-content") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "en"
            },
            content: {
                copyData: copyData$6(),
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$i({ strings }),
                lead_generation_bar: lead_generation_bar$i()
            }
        };
    }
    if (page === "dynamic-resources") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Resources for Online Language Learning for Enterprise | Rosetta Stone",
                meta_description: "",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/resources/",
                lang: "en"
            },
            content: {
                hero: {
                    layout: "list",
                    panels: [
                        {
                            layout: "image-right",
                            alignItems: "center",
                            image: {
                                src: null
                            },
                            title: {
                                content: "Enterprise Resources"
                            },
                            body: {
                                content: "Let Employees Speak For Themselves"
                            },
                            custom: {
                                cta: {
                                    destination: "/pricing-request/",
                                    internal: true,
                                    theme: "yellow_black",
                                    text: "REQUEST PRICING"
                                }
                            }
                        }
                    ]
                },
                copyData: copyData$6(),
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$i({ strings }),
                lead_generation_bar: lead_generation_bar$i()
            }
        };
    }
    if (page === "experience-audit-language-costs") {
        pageConfig = {
            page,
            eloquaPage: "webpage",
            helmet: {
                meta_title: "Audit Language Costs | Rosetta Stone Enterprise",
                meta_description: "It’s time to choose a language training program. Do you go old school with face-to-face instruction or empower your employees to learn online? Here’s how to make a strong business case for online language training.",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/experience/audit-language-costs/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        data_qa: "Section 0 - Hero",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: `
                                        A language cost audit can help keep learning and development (L&D) vendor costs down. Auditing your procurement process can be overwhelming, so we’ve put together this handy three-step checklist to help you through the process.
                                        `
                                },
                                custom: {
                                    cta: {
                                        destination: "/experience/making-the-case/",
                                        internal: true,
                                        size: "regular",
                                        theme: "yellow_black",
                                        text: "Learn More"
                                    }
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Audit Your Language Training Costs in 3 Easy Steps!",
                                    heading: "h1",
                                    theme: "blue",
                                    type: "page-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 1",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "What’s your process for selecting language training solutions and other related L&D software products? Do you have a standardized way to identify language training programs? Have members of your regional procurement team purchased language services in the past? Be sure you fully grasp how your department purchases language training products."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "115px",
                                    width: "115px"
                                },
                                title: {
                                    align: "left",
                                    content: "1. Start with your own procurement team and region.",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 2",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: `
                            Language training can be billed in a variety of ways depending on who requested the vendor, and why they need the solution. Confirm L&D purchasing policies with each category manager in your region.
                            `
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "115px",
                                    width: "115px"
                                },
                                title: {
                                    align: "left",
                                    content: "Pro tip:",
                                    theme: "blue",
                                    type: "sub-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    align: "left",
                                    content: `
                            Look for patterns in language training spending over the past few years. Have language expenses increased from year-to-year? How are these costs billed? Are these language solutions sourced from multiple vendors or a single vendor? You’ll also want to take a look at corporate credit card accounts, and employee benefit initiatives, like tuition reimbursement programs.   
                            `
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "115px",
                                    width: "115px"
                                },
                                title: {
                                    align: "left",
                                    content: "2. Review departmental language training expenses.",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 4",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    align: "left",
                                    content: "L&D expenses can vary from year to year, so you’ll need to look back a few years. Be sure to also look beyond L&D use cases. Some department heads will use language tools for specific use cases, often going unnoticed in a general cost audit. "
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "115px",
                                    width: "115px"
                                },
                                title: {
                                    align: "left",
                                    content: "Pro tip:",
                                    theme: "blue",
                                    type: "sub-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 5",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    align: "left",
                                    content: "If purchasing is decentralized or broken out by region, you may need to do a little more legwork. A good place to start is by asking regional leaders to identify department heads responsible for tracking L&D, HR, software, and related spends. Then have those department heads identify which language costs are billed as direct or indirect expenses."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "115px",
                                    width: "115px"
                                },
                                title: {
                                    align: "left",
                                    content: "3. Zero in on region-specific language training expenses.",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 6",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    align: "left",
                                    content: "If you have a global language policy, start by asking regional leaders if they’re using that policy to purchase new language solutions. "
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "115px",
                                    width: "115px"
                                },
                                title: {
                                    align: "left",
                                    content: "Pro tip:",
                                    theme: "blue",
                                    type: "sub-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 7",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    align: "left",
                                    content: `
                            Rosetta Stone Enterprise helps some of the world’s leading brands realize big cost savings by helping them streamline procurement by consolidating their language spend to a single, award-winning enterprise language training solution. 
                            `
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "60%",
                                    width: "60%"
                                },
                                title: {
                                    align: "left",
                                    content: "So you’re overspending on language training... Now what?",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 8",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: ""
                                },
                                custom: {
                                    cta: {
                                        destination: "/pricing-request/",
                                        internal: true,
                                        size: "regular",
                                        theme: "yellow_black",
                                        text: "Talk To A Language Expert"
                                    }
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Join thousands of leading organizations saving big on language training with Rosetta Stone Enterprise!",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    }
                ],
                lead_generation_bar: lead_generation_bar$i()
            }
        };
    }
    if (page === "experience-making-the-case") {
        pageConfig = {
            page,
            eloquaPage: "webpage",
            helmet: {
                meta_title: "Making the Case | Rosetta Stone Enterprise",
                meta_description: "It’s time to choose a language training program. Do you go old school with face-to-face instruction or empower your employees to learn online? Here’s how to make a strong business case for online language training.",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/experience/making-the-case/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        data_qa: "Section 1",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: `
                                        It’s time to choose a language training programme. Do you go old school with face-to-face instruction or empower your employees to learn online? 
                                        <br/>
                                        <br/>
                                        Here’s how to make a strong business case for online language training.
                            `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Making the case for online language training.",
                                    heading: "h1",
                                    theme: "blue",
                                    type: "page-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 2",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Face-to-face training requires additional expenses beyond the cost of a learning module. But when your employees learn a language online, many of those costs vanish.",
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "60%",
                                    width: "60%"
                                },
                                sub_body: {
                                    content: "Converting your language spend from many local providers to one global platform is a clear cost-saver.",
                                    dangerous: true
                                },
                                sub_title: {
                                    align: "left",
                                    content: "Consolidate vendors.",
                                    theme: "black",
                                    type: "sub-title"
                                },
                                title: {
                                    align: "left",
                                    content: "Start with cost savings.",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    align: "left",
                                    content: "One of the world’s largest consulting companies serves clients in over <strong>100</strong> countries and invests in language training on a global scale. After partnering with Rosetta Stone, the company reduced its vendor network and realised first-year cost savings of more than <strong>$500,00</strong>.",
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "75%",
                                    width: "75%"
                                },
                                title: null
                            },
                            {
                                body: {
                                    content: "A global manufacturing leader was able to increase its language offering from 2,000 employees to <strong>77,000</strong> while still saving over <strong>$3 million</strong> annually by simply switching from an international array of vendors to our single-source solution.",
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "75%",
                                    width: "75%"
                                },
                                title: null
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 4",
                        layout: "duo",
                        panels: [
                            {
                                body: {
                                    align: "center",
                                    content: "Verifying new candidates’ language proficiency levels can be critical. Now your talent development team can conduct  language assessments available with your existing licences.",
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "toggle-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "center",
                                    content: "Spend less on talent testing.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "card-title"
                                },
                                toggle: {
                                    body: {
                                        align: "left",
                                        content: "A global professional services firm has tested more than 10,000 candidates through online assessments. An alternative was to use an outside language service at a cost of  $40 per person. Instead, the company chose the online CEFR-based Rosetta Stone assessment in the programme, at no additional cost.",
                                        dangerous: true
                                    },
                                    title: null
                                }
                            },
                            {
                                body: {
                                    align: "center",
                                    content: "Moving away from a dedicated training space achieves another level of cost savings."
                                },
                                data_qa: null,
                                direction: "toggle-right",
                                image: {
                                    src: null,
                                    height: "250px",
                                    width: "250px"
                                },
                                title: {
                                    align: "center",
                                    content: "Act sustainably.",
                                    heading: "h3",
                                    theme: "black",
                                    type: "card-title"
                                },
                                toggle: {
                                    body: {
                                        align: "left",
                                        content: `
                                <ul>
                                    <li>Eliminating employee and instructor travel</li>
                                    <li>Cutting classroom space and maintenance</li>
                                    <li>Replacing printed materials with online lessons</li>
                                    <li>Allowing learners to use their personal devices</li>
                                </ul>
                            `,
                                        dangerous: true
                                    },
                                    title: {
                                        align: "left",
                                        content: "Achieve more savings by:",
                                        heading: "h3",
                                        theme: "black",
                                        type: "sub-title"
                                    }
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 5 - Know your learners.",
                        layout: "carousel",
                        panels: [
                            {
                                body: {
                                    content: "Just as today’s learners curate their own content experiences in their personal lives on social media, they expect the same experience at work."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Curators of their own experience.",
                                    heading: "h3",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            },
                            {
                                body: {
                                    content: "They want to give and receive feedback on the learning process—how to improve as a learner, and how the organisation can help them succeed in their own online learning experiences."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Employer empowerment helps them thrive.",
                                    heading: "h3",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            },
                            {
                                body: {
                                    content: "Modern employees are also more likely to invest in their careers at organisations invested in their skill development—lowering your own retention spend in the process."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Loyal to organisations that invest in skill development.",
                                    heading: "h3",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            }
                        ],
                        title: {
                            align: "center",
                            content: "Know your learners.",
                            heading: "h2",
                            theme: "blue",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        data_qa: "Section 6",
                        layout: "carousel",
                        panels: [
                            {
                                body: {
                                    content: "Seamless, immersive learning experiences guide learners from assessment to proficiency employing a proven, unified method on any device."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Flexible. Mobile. Easy to use.",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            },
                            {
                                body: {
                                    content: "Learn from native speakers 24/7. Employees access tutoring sessions from virtually anywhere in the world to fit their own schedules."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Online Tutoring from native speakers.",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            },
                            {
                                body: {
                                    content: "Access an integrated reporting dashboard where you can track and monitor each employee’s learning progress."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Smart dashboards.",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            },
                            {
                                body: {
                                    content: `Choose from 24 languages.<br/>
                               Switch at any time.<br/> 
                               The only limit? Hours in the day.
                              `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Access all our languages.",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            }
                        ],
                        title: {
                            align: "center",
                            content: "Choose our award-winning enterprise solution.",
                            theme: "blue",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        data_qa: "Section 7",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Rosetta Stone is dedicated to using the power of language and literacy education to change people's lives. Millions of inspired learners have used our online and mobile solutions at home, in the workplace, and in schools around the world."
                                },
                                custom: {
                                    cta: {
                                        destination: "/pricing-request/",
                                        internal: true,
                                        size: "regular",
                                        theme: "yellow_black",
                                        text: "Talk To A Language Expert"
                                    }
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Join thousands of fellow industry leaders",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 8",
                        layout: "list",
                        panels: [
                            {
                                data_qa: null,
                                banner: {
                                    src: null
                                }
                            }
                        ],
                        visible: true
                    }
                ],
                lead_generation_bar: lead_generation_bar$i()
            }
        };
    }
    if (page === "experience-nine-warning-signs") {
        pageConfig = {
            page,
            eloquaPage: "webpage",
            helmet: {
                meta_title: "Nine Warning Signs | Rosetta Stone Enterprise",
                meta_description: "Communication lives right at the heart of every business. It fuels everything you do from strategy to execution. Without clear communication your entire organization may suffer a business loss.",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/experience/nine-warning-signs/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        data_qa: "Section 1 - Header",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Communication lives right at the heart of every business. It fuels everything you do from strategy to execution. Without clear communication your entire organisation may suffer a business loss:"
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "9 warning signs your employees need language training.",
                                    heading: "h1",
                                    theme: "blue",
                                    type: "page-title"
                                },
                                custom: {
                                    body: {
                                        content: `
                                            When you add a language barrier to the equation, things get even more complicated. What if you’re communicating to a coworker, boss, or customers in a language you don’t speak very well?
                                            <br />
                                            <br />
                                            If you’re worried your organisation might have a language problem, it’s time to do an honest assessment. 
                                        `,
                                        dangerous: true
                                    },
                                    list: [
                                        "A loss of revenue.",
                                        "A loss of productivity.",
                                        "A loss of a customer.",
                                        "A loss of an employee.",
                                        "A loss of credibility."
                                    ],
                                    title: {
                                        align: "left",
                                        content: "These are losses no organisation can afford.",
                                        theme: "black",
                                        type: "sub-title"
                                    }
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 2 - 9 Bullets",
                        layout: "list",
                        title: {
                            align: "center",
                            content: "9 signs you may have a language problem.",
                            heading: "h2",
                            theme: "blue",
                            type: "page-title"
                        },
                        panels: [
                            {
                                body: {
                                    content: `
                                A diverse, multilingual workforce is definitely worth celebrating. Keeping everyone informed about their roles, basic responsibilities, policies, and safety protocols is both a liability and a major challenge for productivity across the organisation. 
                                <br/>
                                <br/>
                                Solving this challenge involves a focused effort across your entire business to shift employees’ perception of language training.
                                `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "1. You have a diverse workforce",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                            Do multilingual employees fully understand safety policies and protocols? How does that impact their daily tasks and your ability to retain them?  
                                            <br/>
                                            <br/>
                                            Safety compliance in a multilingual workplace is a critical and expensive problem to solve. Depending on the severity of the incident, miscommunicating a seemingly simple safety protocol can cost hundreds of thousands in compliance penalties.
                                        `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "2. On-the-job safety incidents have increased",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                            Are you fully aware of the languages your customers speak? Have you ever lost a customer due to a language barrier that provided a bad experience? Do you understand the role of communication in each of your customers’ local cultures?
                                            <br/>
                                            <br/>
                                            Your answers to these questions may reveal a clear need for language training that truly immerses your employees in daily speaking practice with native speakers to truly understand the preferences of your customers.
                                        `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "3. Customer service is compromised",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                Research shows that 60% of employees will stick with an employer if they provide language training as part of their professional development programmes. Meanwhile, only 30% of companies actively make that investment.
                                <br/>
                                <br/>
                                A holistic retention strategy includes language training as an additional element of professional development across your business.
                            `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "4. Employee turnover is on the rise",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                            Language barriers are presented in many forms on-the-job. One common result of miscommunication comes in the form of misunderstood job expectations.
                                            <br/>
                                            <br/>
                                            This often means lowered productivity, more mistakes on the job, and general frustration from your broader teams. Operationally, you may default to lowering expectations for Limited English Proficiency (LEP) employees, which can damage morale and result in higher turnover.
                                        `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "5. Lowered job expectations",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                            Since you’re already investing time and resources into training LEP employees, it makes perfect sense to retain those employees. Adding language training to your employee development plan can go a long way to show every employee you are invested in their future with your company.
                                        `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "6. Employee onboarding takes longer",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "When language barriers are a hurdle for career advancement, your employees will be less engaged in their work and are less likely to pursue advancement within your organisation. Create a win-win situation for your employees. Use language training to help them take the next best step for their career.",
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "7. Multilingual team members' careers have stalled",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                            Do you have a collaboration and productivity problem across your global teams? Language barriers could be at play, while your employees look to you for an effective training solution.   
                                            <br/>
                                            <br/>
                                            A recent survey of Rosetta Stone Enterprise users showed two of the most desired outcomes include teamwide collaboration (66% of respondents) and improved verbal communication (68% of respondents) with teammates.
                                        `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "8. Collaboration is an ongoing challenge",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                            Is your hiring strategy impacted by language challenges across your business? As you look to fill future roles and grow your business abroad, it’s critical to take stock of how language barriers will impact employee performance, compliance, retention and growth.
                                        `
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "9. Future employees face similar obstacles",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 3 - Brand Images",
                        layout: "list",
                        panels: [
                            {
                                destination: "",
                                image: {
                                    type: "static",
                                    alt: "Sony Pictures",
                                    src: logos.logoSonyPicturesPng,
                                    height: "100px",
                                    width: "100px"
                                },
                                name: "Sony Pictures"
                            },
                            {
                                destination: "",
                                image: {
                                    type: "static",
                                    alt: "Twitter",
                                    src: logos.logoTwitterPng,
                                    height: "100px",
                                    width: "100px"
                                },
                                name: "Twitter"
                            },
                            {
                                destination: "",
                                image: {
                                    type: "static",
                                    alt: "Vodafone",
                                    src: logos.logoVodafonePng,
                                    width: "150px"
                                },
                                name: "Vodafone"
                            },
                            {
                                destination: "",
                                image: {
                                    type: "static",
                                    alt: "EON",
                                    src: logos.logoEonPng,
                                    width: "100px"
                                },
                                name: "EON"
                            }
                        ],
                        title: {
                            align: "center",
                            content: "Leading brands use language solutions from Rosetta Stone Enterprise",
                            heading: "h2",
                            theme: "blue",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        data_qa: "Section 4 - Enterprise Solutions",
                        layout: "carousel",
                        panels: [
                            {
                                body: null,
                                custom: {
                                    body: {
                                        content: "Regardless of industry, language barriers present a complex problem to solve for any organisation. The good news is that flexible, immersive language tools help set your team up for success by maximising collaboration and employee engagement in a way that aligns with your larger business strategy."
                                    },
                                    cta: {
                                        destination: "/",
                                        internal: true,
                                        size: "regular",
                                        theme: "yellow_black",
                                        text: "Learn More"
                                    },
                                    list: [
                                        "Drive down language training costs across your organisation",
                                        "Attract and retain top-tier talent",
                                        "Improve communication and collaboration",
                                        "Foster a customer-obsessed work culture"
                                    ]
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Curators of their own experience.",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            }
                        ],
                        title: {
                            align: "center",
                            content: "With enterprise language solutions from Rosetta Stone you can:",
                            heading: "h2",
                            theme: "blue",
                            type: "section-title"
                        },
                        visible: true
                    }
                ],
                lead_generation_bar: lead_generation_bar$i()
            }
        };
    }
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Rosetta Stone for Enterprise | Rosetta Stone",
                meta_description: "12,000+ leading brands engage their employees with Rosetta Stone Enterprise.",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        lead_generation_button: {
                            schedule_appointment: false,
                            completion_redirect: null,
                            button: {
                                destination: "/pricing-request/",
                                internal: true,
                                new_window: false,
                                size: "regular",
                                text: "Price Enquiry",
                                theme: "yellow_black"
                            }
                        },
                        data_qa: "Header",
                        sub_title: {
                            align: "center",
                            content: "12,000+ leading brands engage their employees with Rosetta Stone Enterprise.",
                            theme: "white",
                            type: "page-sub-title"
                        },
                        title: {
                            align: "center",
                            content: "Language training for enterprise teams.",
                            heading: "h1",
                            theme: "white",
                            type: "page-title"
                        },
                        visible: true
                    },
                    {
                        title: {
                            align: "center",
                            content: "A proven enterprise language solution.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        data_qa: "Section 2 - Cards",
                        layout: "carousel",
                        panels: [
                            {
                                body: {
                                    align: "center",
                                    content: "Invest in employee success. Help them learn a new language on any device—online or offline.",
                                    type: "card"
                                },
                                video: {
                                    src: animations.usEnterpriseTopTalentMp4,
                                    type: "video/mp4"
                                },
                                title: {
                                    align: "center",
                                    content: "Retain Top Talent",
                                    heading: "h3",
                                    type: "card-title",
                                    theme: "blue"
                                }
                            },
                            {
                                body: {
                                    align: "center",
                                    content: "Save big when you switch from face-to-face instructors to online language tutors.",
                                    type: "card"
                                },
                                video: {
                                    src: animations.usEnterpriseCutCostsMp4,
                                    type: "video/mp4"
                                },
                                title: { content: "Cut Costs", heading: "h3", type: "card-title", theme: "blue" }
                            },
                            {
                                body: {
                                    align: "center",
                                    content: "Help your employees speak and work confidently across language barriers.",
                                    type: "card"
                                },
                                video: {
                                    src: animations.usEnterpriseWorkBetterMp4,
                                    type: "video/mp4"
                                },
                                title: {
                                    content: "Work Better Together",
                                    heading: "h3",
                                    type: "card-title",
                                    theme: "blue"
                                }
                            },
                            {
                                body: {
                                    align: "center",
                                    content: "Track, measure, and optimize your language training programs for learner success with detailed learner dashboards. ",
                                    type: "card"
                                },
                                video: {
                                    src: animations.usEnterpriseLearnerSuccessMp4,
                                    type: "video/mp4"
                                },
                                title: {
                                    content: "Enable Learner Success",
                                    heading: "h3",
                                    type: "card-title",
                                    theme: "blue"
                                }
                            }
                        ]
                    },
                    {
                        data_qa: "Section 3 - Animation Text",
                        layout: "list",
                        panels: [
                            {
                                animation: {
                                    asset_static: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "center",
                                    content: "Making the case for online training.",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "page-title"
                                },
                                body: {
                                    content: "Going from many language providers to a single, proven online platform is a clear cost-saver. Give your employees flexible language learning tools that help immerse them in everyday speaking at the pace and place of their choosing."
                                },
                                custom: {
                                    cta_1: {
                                        destination: "https://www.rosettastone.co.uk/enterprise/experience/making-the-case/?eeid=oo-e1-co&campaignid=7010W0000027w78&utm_campaign=US-CORP-content-traffic&utm_source=content&utm_content=",
                                        internal: false,
                                        new_window: false,
                                        size: "regular",
                                        text: "Show me the guide",
                                        theme: "yellow_black"
                                    }
                                },
                                data_qa: null,
                                direction: "image-right"
                            }
                        ],
                        visible: true
                    },
                    {
                        custom: {
                            cta_1: {
                                destination: "/resources/content/a-decade-of-language-training-success/",
                                internal: true,
                                new_window: false,
                                size: "regular",
                                theme: "yellow_black",
                                text: "Read the latest customer story"
                            }
                        },
                        data_qa: "Section 4 - Brand Images",
                        layout: "list",
                        panels: awards$6({ strings }).panels,
                        title: {
                            align: "center",
                            content: "Join 12,000+ leading organizations.",
                            heading: "h2",
                            theme: "blue",
                            type: "page-title"
                        },
                        visible: true
                    }
                ],
                lead_generation_bar: lead_generation_bar$i()
            }
        };
    }
    if (page === "industry-consulting") {
        pageConfig = {
            page,
            eloquaPage: "consulting",
            helmet: {
                meta_title: "Language Training for Consulting | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/consulting/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        dataQa: "1",
                        panels: [
                            {
                                body: {
                                    content: "There are plenty of barriers that limit consulting firms from expanding into new markets—chief among them is the language barrier. By providing your entire organization with language training you greatly improve the prospects of profitable expansion into new regions."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/consulting/",
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Price Enquiry",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                hasCtaRedirect: true,
                                image: {
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                direction: "content-right",
                                title: {
                                    align: "left",
                                    content: "Speak every new client’s language.",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                video: {
                                    controls: true,
                                    playing: false,
                                    currentVideoUrl: "https://player.vimeo.com/video/591202724"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "2",
                        layout: "list",
                        title: {
                            align: "center",
                            content: "Proven language solutions for leading hospitality organizations.",
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    },
                    {
                        dataQa: "3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Your organization may have some of the industry’s brightest consultants, but a lack of language skills may be causing significant work inefficiencies. Improve productivity with a broader multilingual talent pool."
                                },
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Collaborate globally.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "The best and brightest are hard to retain because top talent in the professional consulting industry is on every firm’s radar. Adding language training to your professional development mix can help you differentiate from your competitors and alleviate the strain of turnover costs."
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Drive down turnover.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Corporations lose millions each year from employee turnover, making it a top organisational challenge. Investing in language training for employees can enhance your retention initiatives by enabling your staff to grow in their careers."
                                },
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Attract and retain top talent.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: "Keep Exploring",
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$i({ strings }),
                lead_generation_bar: lead_generation_bar$i()
            }
        };
    }
    if (page === "industry-financial") {
        pageConfig = {
            page,
            eloquaPage: "financial",
            helmet: {
                meta_title: "Language Training for Financial Services | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/financial",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        dataQa: "1",
                        panels: [
                            {
                                body: {
                                    content: "Money matters don’t stop at a border. And not all business is conducted in the same language. Learning your customer’s language helps to establish the personal trust that leads to profitable relationships."
                                },
                                custom: {
                                    cta_1: {
                                        destination: "/resources/content/language-skills-critical-to-business-goals/",
                                        internal: true,
                                        new_window: false,
                                        size: "regular",
                                        text: "Read the Report",
                                        theme: "blue_white"
                                    },
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/financial/",
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Price Enquiry",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Invest in your client’s language.",
                                    heading: "h1",
                                    theme: "black",
                                    type: "page-title"
                                }
                            },
                            {
                                dataQa: "2",
                                body: {
                                    content: "Finances are personal. Customers want to be sure you understand their needs. If there is a language gap, employees have to navigate the conversation. Including language training in your professional development program can close that gap and increase employee loyalty toward your business."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Attract business, retain employees.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                dataQa: "3",
                                body: {
                                    content: "Working well together is one place employee productivity starts. When language barriers get in the way, collaboration suffers and good ideas remain unspoken. Online language training gives your employees a proven path to better communication."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Collaboration connects colleagues.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                copyData: copyData$6(),
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$i({ strings }),
                lead_generation_bar: lead_generation_bar$i()
            }
        };
    }
    if (page === "industry-logistics") {
        pageConfig = {
            page,
            eloquaPage: "logistics",
            helmet: {
                meta_title: "Transport and Logistics | Rosetta Stone",
                meta_description: "Throughout your supply chain network, employees encounter multiple languages spoken by partners and customers. Communication gaps can hinder the flow of goods you trust to move efficiently and on schedule. Language training gets employees up to speed so your shipments don’t slow down.",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/logistics",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                dataQa: "1",
                                body: {
                                    content: "Throughout your supply chain network, employees encounter multiple languages spoken by partners and customers. Communication gaps can hinder the flow of goods you trust to move efficiently and on schedule. Language training gets employees up to speed so your shipments don’t slow down."
                                },
                                custom: {
                                    cta_1: {
                                        destination: "/resources/content/5-step-guide-to-successful-language-training-british-eng/",
                                        internal: true,
                                        new_window: true,
                                        size: "regular",
                                        text: "Read Report",
                                        theme: "blue_white"
                                    },
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/logistics/",
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Price Enquiry",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Keep lines of communication open.",
                                    heading: "h1",
                                    theme: "black",
                                    type: "page-title"
                                }
                            },
                            {
                                dataQa: "2",
                                body: {
                                    content: "Every employees’ job comes with some degree of safety risk. For transport and logistics companies, those risks ramp up considerably given the sheer volume of shipments and deliveries. Improving employees’ language skills helps them avoid miscommunications that contribute to costly safety incidents."
                                },
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Reduce risk.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                dataQa: "3",
                                body: {
                                    content: "Successful logistics depend on Point A having confidence that shipments will reach Point B as expected. When language barriers get in the way, it’s easy for collaboration to break down. Language training equips employees to better navigate today’s multinational transactions."
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Collaborate worldwide.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                dataQa: "4",
                                body: {
                                    content: "Speaking with co-workers is essential, whether working side-by-side or on a global team. With Catalyst training, language obstacles come down, clarity replaces confusion, and work quality goes up."
                                },
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Build a stronger team.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                copyData: copyData$6(),
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$i({ strings }),
                lead_generation_bar: lead_generation_bar$i()
            }
        };
    }
    if (page === "industry-manufacturing") {
        pageConfig = {
            page,
            eloquaPage: "manufacturing",
            helmet: {
                meta_title: "Speak the global language of manufacturing.",
                meta_description: "There are plenty of barriers that limit manufacturing firms from expanding into a new market—chief among them is the language barrier. Providing your entire organisation with language training goes a long way toward a profitable expansion into new regions.",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/manufacturing",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                dataQa: "1",
                                body: {
                                    content: "There are plenty of barriers that limit manufacturing firms from expanding into a new market—chief among them is the language barrier. Providing your entire organization with language training goes a long way toward a profitable expansion into new regions."
                                },
                                custom: {
                                    cta_1: {
                                        destination: "/resources/content/5-step-guide-to-successful-language-training-british-eng/",
                                        internal: true,
                                        new_window: false,
                                        size: "regular",
                                        text: "Read Report",
                                        theme: "blue_white"
                                    },
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/manufacturing/",
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Price Enquiry",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Speak the global language of manufacturing.",
                                    heading: "h1",
                                    theme: "black",
                                    type: "page-title"
                                }
                            },
                            {
                                dataQa: "2",
                                body: {
                                    content: "Safety is on the mind of every manufacturing firm’s HR leader. While not all safety-related incidents are fatal, they are all expensive. One small misinterpretation of a safety protocol can lead to significant losses in just a single incident. Ensure you’re doing all you can to keep each employee safe. Equip them with flexible language training."
                                },
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Make safety a priority.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                dataQa: "3",
                                body: {
                                    content: "Language barriers across the modern warehouse can lead to loss of productivity and drops in quality when a multi-lingual workforce cannot communicate clearly. See the best work from everyone on the production line with language training."
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Reduce productivity barriers.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                dataQa: "4",
                                body: {
                                    content: "Voluntary turnover costs the manufacturing industry millions of dollars each year. Add language training to your professional development programme to attract and retain the industry’s very best."
                                },
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Drive down retention costs.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                copyData: copyData$6(),
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$i({ strings }),
                lead_generation_bar: lead_generation_bar$i()
            }
        };
    }
    if (page === "industry-pharmaceutical") {
        pageConfig = {
            page,
            eloquaPage: "pharmaceutical",
            helmet: {
                meta_title: "Rosetta Stone | Pharmaceutical",
                meta_description: "In pharmaceuticals, it’s common to find that research, development, and manufacturing aren’t always confined to a single region, or even to one language. Increasing your employees’ ability to collaborate across departments and borders closes an important loop in your operations.",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/pharmacuetical",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                dataQa: "1",
                                body: {
                                    content: "In pharmaceuticals, it’s common to find that research, development, and manufacturing aren’t always confined to a single region, or even to one language. Increasing your employees’ ability to collaborate across departments and borders closes an important loop in your operations."
                                },
                                custom: {
                                    cta_1: {
                                        destination: "/resources/content/norgine-spotlight/",
                                        internal: true,
                                        new_window: true,
                                        size: "regular",
                                        text: "Read Case Study",
                                        theme: "blue_white"
                                    },
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/pharmaceutical/",
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Price Enquiry",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Add language to your formula for success.",
                                    heading: "h1",
                                    theme: "black",
                                    type: "page-title"
                                }
                            },
                            {
                                dataQa: "2",
                                body: {
                                    content: "Global businesses are layered with communication challenges. Consider the range of languages your employees are likely to encounter, from internal teams to supply chain partners. Getting internal and external communications right supports your company’s complex and precise work."
                                },
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Close communication gaps.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                dataQa: "3",
                                body: {
                                    content: "Working smart also applies to language training. Having different training providers scattered around the globe is inefficient and costly. Offering your employees 24/7 global access to one language training platform ensures a consistent learning experience that’s shared with colleagues everywhere."
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Consolidate training.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                dataQa: "4",
                                body: {
                                    content: "Language barriers highlight the need for better interpersonal communication. Your employees’ ability to speak and understand more than one language supports operational excellence. Pharmaceutical employers providing online language training enable their employees to learn anytime, anywhere."
                                },
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Develop talent.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                copyData: copyData$6(),
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$i({ strings }),
                lead_generation_bar: lead_generation_bar$i()
            }
        };
    }
    if (page === "industry-retail") {
        pageConfig = {
            page,
            eloquaPage: "retail",
            helmet: {
                meta_title: "Language Training for Retail | Rosetta Stone",
                meta_description: "Thoughtful, engaging conversation is the hallmark of award-winning retail experiences. It’s the first line of relationship-building that leads to trust and customer satisfaction. Flexible language training helps retailers reduce language differences that get in the way of great customer experiences.",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/retail",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                dataQa: "1",
                                body: {
                                    content: "Thoughtful, engaging conversation is the hallmark of award-winning retail experiences. It’s the first line of relationship-building that leads to trust and customer satisfaction. Flexible language training helps retailers reduce language differences that get in the way of great customer experiences."
                                },
                                custom: {
                                    cta_1: {
                                        destination: "/resources/content/customer-spotlight-stella-mccartney/",
                                        internal: true,
                                        new_window: true,
                                        size: "regular",
                                        text: "Read Case Study",
                                        theme: "blue_white"
                                    },
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/retail/",
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Price Enquiry",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Speak the universal language of customer service.",
                                    heading: "h1",
                                    theme: "black",
                                    type: "page-title"
                                }
                            },
                            {
                                dataQa: "2",
                                body: {
                                    content: "Retention is a top issue facing all retail establishments. Hourly Limited English Proficiency employees are among the most difficult and costly to attract and retain. Investing in language training for these employees can go a long way to bolster retention initiatives within your organization—setting you apart as an industry leader."
                                },
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Attract and retain the best staff.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                dataQa: "3",
                                body: {
                                    content: "Removing language barriers is essential for driving productivity, collaboration, and streamlined operations at each of your physical locations. Close the communication gaps between your employees with language training solutions from Rosetta Stone."
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Bridge the communication gap.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                dataQa: "4",
                                body: {
                                    content: "Whether your retail operations are regional, national, or global, customers like personal service. Language training helps employees make customers who are speakers of other languages feel comfortable in any of your retail settings."
                                },
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Keep retail personal.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                copyData: copyData$6(),
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$i({ strings }),
                lead_generation_bar: lead_generation_bar$i()
            }
        };
    }
    if (page === "pricing-request") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/pricing-request/",
                lang: "en"
            },
            content: {
                title: {
                    type: "section-title",
                    theme: "yellow",
                    content: "Book time with a Language Expert today"
                },
                sub_title: {
                    type: "section-sub-title",
                    theme: "white",
                    content: "Please fill out the form below to schedule time to discuss how we can help."
                },
                lead_generation_form: {
                    title: {
                        theme: "blue",
                        type: "section-title",
                        content: "Almost there!"
                    },
                    fields: {
                        first_name: {
                            field_name: "first_name",
                            field_type: "text",
                            label: "First Name",
                            required: true,
                            required_error: "Please enter your First Name."
                        },
                        last_name: {
                            field_name: "last_name",
                            type: "text",
                            label: "Last Name",
                            required: true,
                            required_error: "Please enter your Last Name."
                        },
                        email: {
                            field_name: "email",
                            field_type: "email",
                            label: "Email Address",
                            required: true,
                            required_error: "Please enter your Email Address.",
                            validation_error: "Please enter a valid Email Address."
                        },
                        phone: {
                            field_name: "phone",
                            field_type: "tel",
                            label: "Phone Number",
                            required: true,
                            required_error: null
                        },
                        organization_name: {
                            field_name: "organization_name",
                            field_type: "text",
                            label: "Company",
                            required: true,
                            required_error: "Please enter your Company Name."
                        },
                        organization_size: {
                            field_name: "organization_size",
                            field_type: "text",
                            label: "Company Size",
                            required: true,
                            required_error: "Please enter your Company Size.",
                            options: [
                                { value: "", label: "" },
                                { value: "100 or Less", label: "100 or Less" },
                                { value: "101 - 500", label: "101 - 500" },
                                {
                                    value: "501 - 1,000",
                                    label: "501 - 1,000"
                                },
                                { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                {
                                    value: "10,001 - 25,000",
                                    label: "10,001 - 25,000"
                                },
                                {
                                    value: "25,001 - 50,000",
                                    label: "25,001 - 50,000"
                                },
                                {
                                    value: "50,001 or More",
                                    label: "50,001 or More"
                                }
                            ]
                        },
                        role: {
                            field_name: "title",
                            field_type: "select",
                            label: "Title",
                            required: true,
                            required_error: "Please enter your Role."
                        },
                        explicitOptIn: {
                            field_name: "explicitOptIn",
                            required: false
                        }
                    },
                    button: {
                        as: "button",
                        type: "submit",
                        size: "regular",
                        text: "Price Enquiry"
                    },
                    labels: {
                        form_privacy1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's",
                        form_privacy2: "Privacy Policy",
                        form_privacy3: "I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at",
                        form_privacy4: ".",
                        form_privacyUrl: "https://www.rosettastone.com/privacy",
                        form_privacyemail: "privacyofficer@rosettastone.com",
                        form_updateagreement1: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
                        form_updateagreement2: "here",
                        form_updateagreement3: "for more information."
                    },
                    domain: ".co.uk",
                    dataQaLocation: "page"
                },
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$i({ strings })
            }
        };
    }
    if (page === "pricing-request-complete") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.co.uk/k12/pricing-request/",
                lang: "en"
            },
            content: {
                title: {
                    align: "center",
                    content: "Thanks for your interest!",
                    heading: "h1",
                    theme: "blue",
                    type: "page-title"
                },
                sub_title: {
                    align: "center",
                    heading: "h2",
                    content: "Check out some additional resources before your meeting!",
                    type: "page-sub-title"
                },
                resources_link: {
                    destination: "/resources/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Resources",
                    theme: "blue_white"
                },
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$i({ strings })
            }
        };
    }
    if (page === "pricing-request-schedule") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.co.uk/enterprise/pricing-request/",
                lang: "en"
            },
            content: {
                awards: awards$6({ strings }),
                branded_quotes: branded_quotes$6({ strings }),
                verticals: verticals$i({ strings })
            }
        };
    }
    return pageConfig;
};

var enterprise_footer_config$6 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_consumer_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/schools/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/higher-education/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_secondary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/enterprise/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/about/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/magazine",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_blog_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.co.uk/contact",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/en/work/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/faq",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_faqs_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.co.uk/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "www.rosettastone.co.uk/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: false,
            label: "",
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "twitter",
                    destination: "https://twitter.com/RosettaStoneUK",
                    image: social.twitterDarkSvg
                },
                {
                    service: "linkedin",
                    destination: "https://www.linkedin.com/company/rosettastone/",
                    image: social.linkedinDarkPng
                }
            ]
        }
    }
});

var uk = ({ market, site, page, locale, strings }) => {
    let nav_secondary = null;
    let page_config = null;
    let footer_config = null;
    switch (site) {
        case "enterprise":
            nav_secondary = enterprise_nav_secondary_config$6({ strings });
            page_config = enterprise_pages_config$6({ page, strings });
            footer_config = enterprise_footer_config$6({ strings });
            break;
        case "education-primary":
            nav_secondary = education_primary_nav_secondary_config$6({ strings });
            page_config = education_primary_pages_config$6({ page, strings });
            footer_config = education_primary_footer_config$6({ strings });
            break;
    }
    const nav_primary = nav_primary_config$6({ strings });
    return {
        market,
        site,
        vertical: site,
        locale,
        analytics: analytics$8,
        nav: {
            visible: true,
            primary: nav_primary || null,
            secondary: nav_secondary || null
        },
        footer: Object.assign({ visible: true }, footer_config),
        page: page_config
    };
};

var analytics$7 = {
    gtm_id: "GTM-TLH67WS"
};

var nav_primary_config$5 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: true,
        destination: "https://blog.rosettastone.com/",
        external: true,
        new_window: true,
        label: strings.nav_primary_blog_label
    },
    contact: {
        visible: true,
        destination: "/contact/",
        external: true,
        new_window: true,
        label: strings.nav_primary_contact_label
    },
    rs_logo: {
        visible: true,
        image: {
            type: "static",
            src: rsBranding.rsLogoBlackSvg,
            height: "40px",
            width: "93px",
            alt: strings.nav_primary_logo_alt
        },
        link: {
            destination: "/",
            external: false,
            new_window: false
        }
    },
    phone: {
        visible: true,
        external: false,
        new_window: false,
        destination: "tel:18007673882",
        label: strings.nav_primary_phone_label,
        number: strings.nav_primary_phone_number
    },
    select_language: {
        visible: true,
        external: false,
        new_window: false,
        language_options_featured: [
            {
                url: "/buy-spanish/",
                title: strings.locale_es_la_label_primary,
                small: strings.locale_es_la_label_secondary
            },
            {
                url: "/buy-french/",
                title: strings.locale_fr_fr_label_primary,
                small: strings.locale_fr_fr_label_secondary
            },
            {
                url: "/buy-italian/",
                title: strings.locale_it_it_label_primary,
                small: strings.locale_it_it_label_secondary
            },
            {
                url: "/buy-german/",
                title: strings.locale_de_de_label_primary,
                small: strings.locale_de_de_label_secondary
            },
            {
                url: "/buy-english/",
                title: strings.locale_en_us_label_primary,
                small: strings.locale_en_us_label_secondary
            }
        ],
        language_options_other: [
            {
                url: "/buy-arabic/",
                title: strings.locale_ar_ar_label_primary,
                small: strings.locale_ar_ar_label_secondary
            },
            {
                url: "/buy-chinese/",
                title: strings.locale_zn_cn_label_primary,
                small: strings.locale_zn_cn_label_secondary
            },
            {
                url: "/buy-dutch/",
                title: strings.locale_nl_nl_label_primary,
                small: strings.locale_nl_nl_label_secondary
            },
            {
                url: "/buy-english-british/",
                title: strings.locale_en_gb_label_primary,
                small: strings.locale_en_gb_label_secondary
            },
            {
                url: "/buy-tagalog/",
                title: strings.locale_tl_ph_label_primary,
                small: strings.locale_tl_ph_label_secondary
            },
            {
                url: "/buy-greek/",
                title: strings.locale_el_gr_label_primary,
                small: strings.locale_el_gr_label_secondary
            },
            {
                url: "/buy-hebrew/",
                title: strings.locale_he_il_label_primary,
                small: strings.locale_he_il_label_secondary
            },
            {
                url: "/buy-hindi/",
                title: strings.locale_hi_in_label_primary,
                small: strings.locale_hi_in_label_secondary
            },
            {
                url: "/buy-irish/",
                title: strings.locale_ga_ie_label_primary,
                small: strings.locale_ga_ie_label_secondary
            },
            {
                url: "/buy-japanese/",
                title: strings.locale_ja_jp_label_primary,
                small: strings.locale_ja_jp_label_secondary
            },
            {
                url: "/buy-korean/",
                title: strings.locale_ko_kr_label_primary,
                small: strings.locale_ko_kr_label_secondary
            },
            {
                url: "/buy-farsi/",
                title: strings.locale_fa_ir_label_primary,
                small: strings.locale_fa_ir_label_secondary
            },
            {
                url: "/buy-polish/",
                title: strings.locale_pl_pl_label_primary,
                small: strings.locale_pl_pl_label_secondary
            },
            {
                url: "/buy-portuguese/",
                title: strings.locale_pt_br_label_primary,
                small: strings.locale_pt_br_label_secondary
            },
            {
                url: "/buy-russian/",
                title: strings.locale_ru_ru_label_primary,
                small: strings.locale_ru_ru_label_secondary
            },
            {
                url: "/buy-spanish-spain/",
                title: strings.locale_es_es_label_primary,
                small: strings.locale_es_es_label_secondary
            },
            {
                url: "/buy-swedish/",
                title: strings.locale_sv_se_label_primary,
                small: strings.locale_sv_se_label_secondary
            },
            {
                url: "/buy-turkish/",
                title: strings.locale_tr_tr_label_primary,
                small: strings.locale_tr_tr_label_secondary
            },
            {
                url: "/buy-vietnamese/",
                title: strings.locale_vi_vn_label_primary,
                small: strings.locale_vi_vn_label_secondary
            }
        ],
        select_language_label: strings.nav_primary_catalog_select_language_label,
        label: strings.nav_primary_catalog_label,
        product_title: strings.global_brand_name
    },
    sign_in: {
        visible: true,
        destination: "https://www.rosettastone.com/login",
        external: true,
        new_window: false,
        label: strings.nav_primary_sign_in_label
    },
    switch_language: {
        visible: true,
        destination: "https://espanol.rosettastone.com/",
        external: true,
        new_window: false,
        label: strings.nav_primary_switch_language
    },
    support: {
        visible: true,
        destination: "https://support.rosettastone.com/en/",
        external: true,
        new_window: false,
        label: strings.nav_primary_support_label
    },
    vertical_consumer: {
        visible: false,
        destination: "/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
        visible: false,
        destination: "/homeschool/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
        visible: true,
        destination: "/k12/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
        visible: false,
        destination: "/highereducation/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
        visible: false,
        destination: "/students/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
        visible: true,
        destination: "/enterprise/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_enterprise_label
    }
});

var awards$5 = ({ strings }) => {
    return {
        visible: true,
        title: {
            content: strings.awards_header_label,
            align: "center",
            type: "section-title"
        },
        panels: [
            {
                image: {
                    type: "static",
                    alt: strings.awards_twitter,
                    src: logosTiles.logosTilesTwitterSvg
                }
            },
            {
                image: {
                    type: "static",
                    alt: strings.awards_bmw,
                    src: logosTiles.logosTilesBmwSvg
                }
            },
            {
                image: {
                    type: "static",
                    alt: strings.awards_uber,
                    src: logosTiles.logosTilesUberSvg
                }
            },
            {
                image: {
                    type: "static",
                    alt: strings.awards_williams_sonoma,
                    src: logosTiles.logosTilesWsSvg
                }
            }
        ]
    };
};

var branded_quotes$5 = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.branded_quotes_header_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            name: strings.branded_quotes_macworld_name,
            type: strings.branded_quotes_macworld_type,
            quote: strings.branded_quotes_macworld_quote,
            logo: {
                type: "static",
                src: logos.logoMacworldSvg
            },
            backdrop: logos.logoMacworldBgSvg
        },
        {
            name: strings.branded_quotes_techcrunch_name,
            type: strings.branded_quotes_techcrunch_type,
            quote: strings.branded_quotes_techcrunch_quote,
            logo: {
                type: "static",
                src: logos.logoTechcrunchSvg
            },
            backdrop: logos.logoTechcrunchBgSvg
        },
        {
            name: strings.branded_quotes_cnn_name,
            type: strings.branded_quotes_cnn_type,
            quote: strings.branded_quotes_cnn_quote,
            logo: {
                type: "static",
                src: logos.logoCnnSvg
            },
            backdrop: logos.logoCnnBgSvg
        }
    ]
});

var email_collection_bar$c = () => {
    return {
        visible: true,
        dataQa: "email collection bar",
        website: "US_WEBSITE",
        demo_type: "offer_signup",
        newsletter_type: "footer_signup",
        language: "ENG",
        button: {
            text: "Sign up",
            theme: "yellow_black",
            size: "mini"
        },
        email_field: {
            placeholder: "Email Address",
            id: "email",
            name: "email"
        },
        subtitle: {
            content: "Get Rosetta Stone news and offers.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        success_message: {
            content: "Thanks for signing up.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        error_message: {
            content: "E-mail is invalid.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        title: {
            content: "Sign up to stay in touch.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        legal: {
            content: "By signing up, I agree to the",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        legal_link: {
            destination: "",
            label: "terms and conditions",
            theme: "white",
            underline: "on"
        },
        privacy_tooltip: {
            title: {
                type: "card-title",
                theme: "white",
                content: "Terms and Conditions",
                align: "center"
            },
            body: {
                align: "left",
                theme: "white",
                dangerous: false,
                content: (React.createElement("div", null,
                    "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\u00A0",
                    React.createElement("a", { href: "https://www.rosettastone.com/privacy", title: "Privacy Policy", target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy"),
                    ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \u00A0",
                    React.createElement("a", { href: "mailto: privacyofficer@rosettastone.com", title: "privacyofficer@rosettastone.com", target: "_blank", rel: "noopener noreferrer" }, "privacyofficer@rosettastone.com"),
                    "."))
            }
        }
    };
};

const consumer_pages_config$2 = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Official Rosetta Stone® - Language Learning - Learn a Language",
                meta_description: "Rosetta Stone is the best way to learn a foreign language. The award-winning language solution combines proven learning methods with the world's best speech recognition technology.",
                canonical_url: "https://www.rosettastone.com/",
                lang: "en"
            },
            content: {
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                email_collection_bar: email_collection_bar$c()
            }
        };
    }
    if (page === "leadership") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Official Rosetta Stone® Leadership",
                meta_description: "Find out more about Rosetta Stone's Leadership.",
                canonical_url: "https://www.rosettastone.com/leadership/",
                lang: "en"
            },
            content: {
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                email_collection_bar: email_collection_bar$c()
            }
        };
    }
    if (page === "opdemo2") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Official Rosetta Stone® - Try Our Free Demo",
                meta_description: "Learn a new language with Rosetta Stone, the #1 language learning platform. Try a free online interactive demo today.",
                canonical_url: "https://www.rosettastone.com/demo/",
                lang: "en"
            },
            content: {
                hero: {
                    heading: {
                        type: "section-title",
                        align: "center",
                        heading: "h1",
                        content: strings.opdemo2_hero_heading
                    },
                    subHeading: {
                        type: "page-sub-title",
                        align: "center",
                        heading: "p",
                        content: strings.opdemo2_hero_subheading
                    },
                    buttonHeading: {
                        align: "center"
                    },
                    button: {
                        custom: {
                            cta: {
                                destination: "https://www.rosettastone.com/lp/tryitnow",
                                new_window: true,
                                size: "regular",
                                text: strings.opdemo2_button_custom_cta_text,
                                theme: "blue_white"
                            }
                        }
                    }
                },
                topImageTextSections: {
                    panels: [
                        {
                            dataQa: "1",
                            layout: "list",
                            direction: "image-right",
                            title: {
                                align: "left",
                                content: strings.opdemo2_top_section_one_title_content,
                                heading: "h3",
                                type: "card-title",
                                theme: "black"
                            },
                            body: {
                                content: strings.opdemo2_top_section_one_body_content,
                                align: "left",
                                theme: "black"
                            },
                            image: {
                                asset_static: images.opdemo2ProvenMethodPng
                            }
                        },
                        {
                            dataQa: "2",
                            layout: "list",
                            justifyContent: "space-between",
                            direction: "image-left",
                            title: {
                                align: "left",
                                content: strings.opdemo2_top_section_two_title_content,
                                heading: "h3",
                                type: "card-title",
                                theme: "black"
                            },
                            body: {
                                content: strings.opdemo2_top_section_one_body_content,
                                align: "left",
                                theme: "black"
                            },
                            image: {
                                asset_static: images.opdemo2TruaccentPng
                            }
                        },
                        {
                            dataQa: "3",
                            layout: "list",
                            justifyContent: "space-between",
                            direction: "image-right",
                            title: {
                                align: "left",
                                content: strings.opdemo2_top_section_three_title_content,
                                heading: "h3",
                                type: "card-title",
                                theme: "black"
                            },
                            body: {
                                content: strings.opdemo2_top_section_three_body_content,
                                align: "left",
                                theme: "black"
                            },
                            image: {
                                asset_static: images.opdemo2TutorScreenPng
                            }
                        },
                        {
                            dataQa: "4",
                            layout: "list",
                            direction: "image-left",
                            title: {
                                align: "left",
                                content: strings.opdemo2_top_section_four_title_content,
                                heading: "h3",
                                type: "card-title",
                                theme: "black"
                            },
                            body: {
                                content: strings.opdemo2_top_section_four_body_content,
                                align: "left",
                                theme: "black"
                            },
                            image: {
                                asset_static: images.opdemo2AudioCompanionPng
                            }
                        },
                        {
                            dataQa: "5",
                            layout: "list",
                            direction: "image-right",
                            title: {
                                align: "left",
                                content: strings.opdemo2_top_section_five_title_content,
                                heading: "h3",
                                type: "card-title",
                                theme: "black"
                            },
                            body: {
                                content: strings.opdemo2_top_section_five_body_content,
                                align: "left",
                                theme: "black"
                            },
                            image: {
                                asset_static: images.opdemo2OnlineLockupPng
                            }
                        }
                    ]
                },
                bottomImageSection: {
                    panels: [
                        {
                            dataQa: "6",
                            layout: "list",
                            direction: "image-left",
                            titleHeading: strings.opdemo2_bottom_section_title_heading,
                            image: {
                                asset_static: images.opdemo2PhonePng
                            },
                            sectionFeatureBullets: [
                                {
                                    heading: strings.opdemo2_bottom_section_feature_bullet_one_heading,
                                    subHeading: strings.opdemo2_bottom_section_feature_bullet_one_subheading
                                },
                                {
                                    heading: strings.opdemo2_bottom_section_feature_bullet_two_heading,
                                    subHeading: strings.opdemo2_bottom_section_feature_bullet_two_subheading
                                },
                                {
                                    heading: strings.opdemo2_bottom_section_feature_bullet_three_heading,
                                    subHeading: strings.opdemo2_bottom_section_feature_bullet_three_subheading
                                },
                                {
                                    subHeading: strings.opdemo2_bottom_section_feature_bullet_four_subheading
                                },
                                {
                                    subHeading: strings.opdemo2_bottom_section_feature_bullet_five_subheading
                                },
                                {
                                    subHeading: strings.opdemo2_bottom_section_feature_bullet_six_subheading
                                }
                            ]
                        }
                    ]
                },
                productUnitCards: {
                    panels: [
                        {
                            label: strings.opdemo2_unit_card_one_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_one_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_one_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_1ApplePng
                            },
                            color: "#FBC000"
                        },
                        {
                            label: strings.opdemo2_unit_card_two_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_two_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_two_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_2TeaPng
                            },
                            color: "#A9CB1F"
                        },
                        {
                            label: strings.opdemo2_unit_card_three_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_three_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_three_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_3PencilPng
                            },
                            color: "#ED360B"
                        },
                        {
                            label: strings.opdemo2_unit_card_four_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_four_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_four_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_4WalletPng
                            },
                            color: "#84CCDD"
                        },
                        {
                            label: strings.opdemo2_unit_card_five_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_five_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_five_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_5PassportPng
                            },
                            color: "#FBC000"
                        },
                        {
                            label: strings.opdemo2_unit_card_six_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_six_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_six_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_6PastFuturePng
                            },
                            color: "#A9CB1F"
                        },
                        {
                            label: strings.opdemo2_unit_card_seven_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_seven_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_seven_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_7MobilePng
                            },
                            color: "#ED360B"
                        },
                        {
                            label: strings.opdemo2_unit_card_eight_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_eight_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_eight_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_8DiningPng
                            },
                            color: "#84CCDD"
                        },
                        {
                            label: strings.opdemo2_unit_card_nine_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_nine_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_nine_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_9HealthPng
                            },
                            color: "#FBC000"
                        },
                        {
                            label: strings.opdemo2_unit_card_ten_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_ten_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_ten_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_10LifePng
                            },
                            color: "#A9CB1F"
                        },
                        {
                            label: strings.opdemo2_unit_card_eleven_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_eleven_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_eleven_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_11EverydayThingsPng
                            },
                            color: "#ED360B"
                        },
                        {
                            label: strings.opdemo2_unit_card_twelve_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_twelve_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_twelve_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_12PlacesEventsPng
                            },
                            color: "#84CCDD"
                        },
                        {
                            label: strings.opdemo2_unit_card_thirteen_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_thirteen_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_thirteen_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_13TourismPng
                            },
                            color: "#FBC000"
                        },
                        {
                            label: strings.opdemo2_unit_card_fourteen_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_fourteen_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_fourteen_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_14ProfessionPng
                            },
                            color: "#A9CB1F"
                        },
                        {
                            label: strings.opdemo2_unit_card_fifteen_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_fifteen_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_fifteen_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_15AtHomePng
                            },
                            color: "#ED360B"
                        },
                        {
                            label: strings.opdemo2_unit_card_sixteen_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_sixteen_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_sixteen_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_16StylePng
                            },
                            color: "#84CCDD"
                        },
                        {
                            label: strings.opdemo2_unit_card_seventeen_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_seventeen_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_seventeen_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_17BusinessPng
                            },
                            color: "#FBC000"
                        },
                        {
                            label: strings.opdemo2_unit_card_eighteen_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_eighteen_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_eighteen_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_18ArtPng
                            },
                            color: "#A9CB1F"
                        },
                        {
                            label: strings.opdemo2_unit_card_nineteen_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_nineteen_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_nineteen_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_19EmergencyPng
                            },
                            color: "#ED360B"
                        },
                        {
                            label: strings.opdemo2_unit_card_twenty_unit_content,
                            unit: {
                                content: strings.opdemo2_unit_card_twenty_unit_content,
                                type: "unit-card-title"
                            },
                            description: {
                                content: strings.opdemo2_unit_card_twenty_description_content,
                                type: "unit-card-sub-title"
                            },
                            icon: {
                                asset_static: productUnits.productUnit_20FamilyPng
                            },
                            color: "#84CCDD"
                        }
                    ]
                },
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                email_collection_bar: email_collection_bar$c()
            }
        };
    }
    return pageConfig;
};

var consumer_footer_config$2 = ({ strings }) => ({
    visible: true,
    cta: {
        visible: false,
        contact_modal: false,
        email_capture: true,
        market: "us",
        domain: ".com",
        vertical: "consumer",
        page: "home",
        main_label: strings.footer_cta_email_main_label,
        sub_label: strings.footer_cta_email_sub_label,
        button_label: strings.footer_cta_email_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        email_placeholder: strings.footer_cta_email_button
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_buy_label,
                links: [
                    {
                        visible: true,
                        destination: "/buy-spanish/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_spanish_label
                    },
                    {
                        visible: true,
                        destination: "/buy-french/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_french_label
                    },
                    {
                        visible: true,
                        destination: "/buy-italian/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_italian_label
                    },
                    {
                        visible: true,
                        destination: "/buy-german/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_german_label
                    },
                    {
                        visible: true,
                        destination: "/buy-english/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_english_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/idiomas/comprar-ingles/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_ingles_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_espanol_label
                    },
                    {
                        visible: true,
                        destination: "/homeschool/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_homeschool_label
                    },
                    {
                        visible: true,
                        destination: "https://pt.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_portugues_label
                    }
                ]
            },
            {
                label: strings.footer_menu_start_label,
                links: [
                    {
                        visible: true,
                        destination: "/tryitnow/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_demo_label
                    },
                    {
                        visible: true,
                        destination: "/product-activation/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_activation_label
                    },
                    {
                        visible: true,
                        destination: "/product/mobile-apps/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_mobile_label
                    },
                    {
                        visible: true,
                        destination: "/product/reviews/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_reviews_label
                    },
                    {
                        visible: true,
                        destination: "/enterprise/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "//blog.rosettastone.com",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_blog_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "/about/company/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_k12_reading_label
                    },
                    {
                        visible: true,
                        destination: "/careers/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "//support.rosettastone.com/en/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "/product/faq/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "/contact/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_contact_us_label
                    },
                    {
                        visible: false,
                        destination: "/legal/accessibility/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_accessibility_statement_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "https://www.rosettastone.com/anti-piracy/"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    label: "Facebook",
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    label: "Twitter",
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    label: "Instagram",
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    label: "^YouTube",
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var consumer_about_nav_config = () => ({
    visible: true,
    home: {
        visible: true,
        destination: "/company/",
        external: false,
        new_window: false,
        label: "About"
    },
    contact: {
        visible: true,
        destination: "/contact/",
        external: false,
        new_window: false,
        label: "Contact"
    },
    careers: {
        visible: true,
        destination: "/careers/",
        external: false,
        new_window: false,
        label: "Careers"
    }
});

var email_collection_bar$b = () => {
    return {
        visible: true,
        dataQa: "email collection bar",
        website: "US_WEBSITE",
        demo_type: "offer_signup",
        newsletter_type: "footer_signup",
        language: "ENG",
        button: {
            text: "Sign up",
            theme: "yellow_black",
            size: "mini"
        },
        email_field: {
            placeholder: "Email Address",
            id: "email",
            name: "email"
        },
        subtitle: {
            content: "Get Rosetta Stone news and offers.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        success_message: {
            content: "Thanks for signing up.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        error_message: {
            content: "E-mail is invalid.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        title: {
            content: "Sign up to stay in touch.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        legal: {
            content: "By signing up, I agree to the",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        legal_link: {
            destination: "",
            label: "terms and conditions",
            theme: "white",
            underline: "on"
        },
        privacy_tooltip: {
            title: {
                type: "card-title",
                theme: "white",
                content: "Terms and Conditions",
                align: "center"
            },
            body: {
                align: "left",
                theme: "white",
                dangerous: false,
                content: (React.createElement("div", null,
                    "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\u00A0",
                    React.createElement("a", { href: "https://www.rosettastone.com/privacy", title: "Privacy Policy", target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy"),
                    ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \u00A0",
                    React.createElement("a", { href: "mailto: privacyofficer@rosettastone.com", title: "privacyofficer@rosettastone.com", target: "_blank", rel: "noopener noreferrer" }, "privacyofficer@rosettastone.com"),
                    "."))
            }
        }
    };
};

const consumer_about_pages_config = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "company") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Official Rosetta Stone® About Us",
                meta_description: "Rosetta Stone Inc. is dedicated to changing people's lives through the power of language and literacy education. Learn more about us.",
                canonical_url: "https://www.rosettastone.com/about/company/",
                lang: "en"
            },
            content: {
                strings: {
                    aboutUs: {
                        h1: strings.consumer_pages_company_about_us_h1,
                        p1: strings.consumer_pages_company_about_us_p1,
                        p2: strings.consumer_pages_company_about_us_p2
                    },
                    historySectionOne: {
                        h2: strings.consumer_pages_company_history_section_one_h2,
                        p1: strings.consumer_pages_company_history_section_one_p1,
                        p2: strings.consumer_pages_company_history_section_one_p2
                    },
                    historySectionTwo: {
                        p1: strings.consumer_pages_company_history_section_two_p1,
                        p2_1: strings.consumer_pages_company_history_section_two_p2_1,
                        p2_a_1: strings.consumer_pages_company_history_section_two_p2_a_1,
                        p2_2: strings.consumer_pages_company_history_section_two_p2_2,
                        p2_a_2: strings.consumer_pages_company_history_section_two_p2_a_2,
                        p2_a_3: strings.consumer_pages_company_history_section_two_p2_a_3,
                        p2_a_4: strings.consumer_pages_company_history_section_two_p2_a_4,
                        p2_3: strings.consumer_pages_company_history_section_two_p2_3,
                        p2_a_5: strings.consumer_pages_company_history_section_two_p2_a_5,
                        p3: strings.consumer_pages_company_history_section_two_p3
                    }
                },
                linkURLs: {
                    ixlLearning: "https://www.ixl.com/company/",
                    ixl: "https://www.ixl.com/",
                    vocabularyDotCom: "https://www.vocabulary.com/",
                    educationDotCom: "https://www.education.com/",
                    wyzant: "https://www.wyzant.com/"
                },
                email_collection_bar: email_collection_bar$b()
            }
        };
    }
    if (page === "contact") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Rosetta Stone® | Contact & Customer Support Information",
                meta_description: "Contact Rosetta Stone. Whether you're looking for answers about buying a product, technical support, FAQs or just learning more about us, getting in touch is a click away.",
                canonical_url: "https://www.rosettastone.com/contact/",
                lang: "en"
            },
            content: {
                strings: {
                    topSection: {
                        mainHeading: strings.consumer_pages_about_h1,
                        subtext: strings.consumer_pages_about_subtext
                    },
                    contactSupport: {
                        heading: strings.consumer_pages_about_contact_support_h2,
                        paragraph1: strings.consumer_pages_about_contact_support_paragraph_1_part_1,
                        link: strings.consumer_pages_about_contact_support_paragraph_1_link_1,
                        paragraph2: strings.consumer_pages_about_contact_support_paragraph_2,
                        us: {
                            header: strings.consumer_pages_about_contact_support_us_header,
                            hours: strings.consumer_pages_about_contact_support_us_hours,
                            subtext: strings.consumer_pages_about_contact_support_us_subtext,
                        },
                        uk: {
                            header: strings.consumer_pages_about_contact_support_uk_header,
                            hours: strings.consumer_pages_about_contact_support_uk_hours,
                            subtext: strings.consumer_pages_about_contact_support_uk_subtext,
                        },
                        collections: {
                            header: strings.consumer_pages_about_contact_support_collections_header,
                            hours: strings.consumer_pages_about_contact_support_collections_hours,
                        },
                    },
                    personalHomeschool: {
                        heading: strings.consumer_pages_about_personal_homeschool_h2,
                        paragraphPart1: strings.consumer_pages_about_personal_homeschool_paragraph_part_1,
                        link1: strings.consumer_pages_about_personal_homeschool_paragraph_link_1,
                        paragraphPart2: strings.consumer_pages_about_personal_homeschool_paragraph_part_2,
                        link2: strings.consumer_pages_about_personal_homeschool_paragraph_link_2,
                        paragraphPart3: strings.consumer_pages_about_personal_homeschool_paragraph_part_3,
                        link3: strings.consumer_pages_about_personal_homeschool_paragraph_link_3
                    },
                    enterpriseEducation: {
                        heading: strings.consumer_pages_about_enterprise_education_h2,
                        paragraphPart1: strings.consumer_pages_about_enterprise_education_paragraph_part_1,
                        link1: strings.consumer_pages_about_enterprise_education_paragraph_link_1,
                        link2: strings.consumer_pages_about_enterprise_education_paragraph_link_2,
                        paragraphPart2: strings.consumer_pages_about_enterprise_education_paragraph_part_2,
                        link3: strings.consumer_pages_about_enterprise_education_paragraph_link_3,
                        paragraphPart3: strings.consumer_pages_about_enterprise_education_paragraph_part_3
                    }
                },
                linkURLs: {
                    contactSupport: {
                        supportEmail: "https://support.rosettastone.com/s/contactsupport?language=en_US",
                    },
                    personalHomeschool: {
                        frequentlyAskedQuestions: "/'product/faq/",
                        customerSupportPortal: "https://support.rosettastone.com/",
                        supportAtRosettaStoneDotCom: "mailto:support@rosettastone.com"
                    },
                    enterpriseEducation: {
                        k12: "/k12/pricing-request/",
                        higherEducation: "/highereducation/pricing-request/",
                        organizations: "/enterprise/pricing-request/"
                    }
                },
                email_collection_bar: email_collection_bar$b()
            }
        };
    }
    if (page === "careers") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Careers | Rosetta Stone",
                meta_description: "A career at Rosetta Stone means that your opportunities are limitless. We change people's lives through the power of language and literacy. Join us on our journey!",
                canonical_url: "https://www.rosettastone.com/careers/",
                lang: "en"
            },
            content: {
                panels: [
                    {
                        heading: "We are Rosetta Stone",
                        subtext: "We are changing the way the world learns. <strong>Want to join us?</strong>",
                        cta: {
                            currentOpenings: {
                                text: "search current openings",
                                destination: "https://rosettastone.wd5.myworkdayjobs.com/Rosetta_Stone"
                            },
                            shareYourInterest: {
                                span: "Not seeing an opening that's right for you?",
                                link: {
                                    text: "share your interest",
                                    destination: "https://rosettastone.wd5.myworkdayjobs.com/Opportunities"
                                }
                            }
                        }
                    },
                    {
                        lifeAtRosetta: {
                            heading: "Life at Rosetta Stone",
                            paragraph: "With a work environment that encourages and nurtures creativity, great idea take flight. Working for Rosetta Stone gives you the resources, motivation and ability to grow your career."
                        },
                        missionAtRosetta: {
                            heading: "Our mission",
                            paragraph: "We change people's lives through the power of language and literacy education."
                        },
                        ourValues: [
                            {
                                image: images.careersCustomerSucessSvg,
                                heading: "Customer Success.",
                                paragraph: "We enrich lives by delivering best-in-class learning products and services."
                            },
                            {
                                image: images.careersEmpowermentIconSvg,
                                heading: "Empowerment.",
                                paragraph: "We foster the growth and development of our people, trusting and empowering each other to excel."
                            },
                            {
                                image: images.careersIntegrityIconSvg,
                                heading: "Integrity.",
                                paragraph: "We work honestly and fairly, holding ourselves to high ethical standards with our learners, customers, colleagues, and partners."
                            },
                            {
                                image: images.careersInnovationIconSvg,
                                heading: "Innovation.",
                                paragraph: "We invest in our people and products, speaking up and taking risks in our ongoing pursuit of innovation."
                            }
                        ]
                    },
                    {
                        customTestimonialPanels: [
                            {
                                id: 1,
                                profileName: "Olga Rodriguez",
                                profileImgSrc: {
                                    src: null
                                },
                                profileSummary: "“I love working for Rosetta Stone because teaching my native language is a fulfilling experience. I get to speak, teach and share my language and culture with people from around the world, and all of this from the comfort of my home. Rosetta Stone is a huge part of my life. Being part of Rosetta Stone makes me feel valued and appreciated, not only by the learners, but my co-workers. The work environment is amazing!”",
                                profileSignature: images.careersOlgaSignatureSvg,
                                profileOccupation: "Supervisor, Live Tutoring",
                                occupationPanel: true
                            },
                            {
                                id: 2,
                                profileName: "Nina Dugersuren",
                                profileImgSrc: {
                                    src: null
                                },
                                profileSummary: "“Being raised and employed abroad until my late twenties, I did not know much about the American corporate world. Over the last eight years, being promoted three times, Rosetta Stone has given me the opportunity to continuously grow my career and learn from bright and inspiring people. Joining the right company and culture was very important to me and I am confident I made the right choice with Rosetta.”",
                                profileSignature: images.careersNinaSignatureSvg,
                                profileOccupation: "Executive Assistant",
                                occupationPanel: true
                            },
                            {
                                id: 3,
                                profileName: "George Mensah",
                                profileImgSrc: {
                                    src: null
                                },
                                profileSummary: "“I never thought I’d be in such a fun and collaborative work environment. I work with a great team, respectful and understanding of each other’s roles, needs, and even personal lives. I see the leadership team’s genuine desire to provide a great work-life balance for all employees and truly understand the impact we have on our customers.  I believe that the culture here is the #1 reason many people stay for over 10 years – a culture of professional/personal growth, collaboration, servant leadership, and ambition for product innovation.”",
                                profileSignature: images.careersGeorgeSignatureSvg,
                                profileOccupation: "Senior Compensation Analyst",
                                occupationPanel: true
                            }
                        ]
                    },
                    {
                        heading: "Employee Spotlight:",
                        employeeSignature: images.careersHillaryMunozSignatureSvg,
                        employeeParagraphs: [
                            "Four years ago, I was drawn towards Rosetta Stone's mission of empowering people to learn a new language through innovative digital learning solutions. Today, I am honored to be leading the CRM team and as such be the first voice that our users hear as they start their learning journey as well as the motivating coach that keeps them engaged along the way.",
                            "In my role, I lead an incredibly smart, talented, and passionate group of individuals focused on developing impactful messages for our prospective and current customers. My work offers me new challenges every day and I am always impressed by my team’s focus on data-driven decision making and delivering an excellent customer experience. I feel ownership in the direction of our business since leadership decisions were grounded in insights that my team delivered.",
                            "Rosetta Stone has allowed me significant growth opportunities in my career and offered me many chances to broaden my skill set and gain new experiences. Four years ago, I started out managing our promotional email program with the help of one direct report and today I oversee a group of four CRM marketers who own our messaging strategy through email, push, in-app, etc. across the entire user journey.",
                            "Rosetta Stone invests in continued learning for all employees. As such I've been able to attend different types of training sessions, gain new perspectives at marketing conferences and broaden my coaching & feedback skills through management training.",
                            "\n" +
                                "Rosetta Stone has been a fantastic place to work, and I believe it’s truly a privilege to work for such an amazing mission-driven organization, literally changing people's lives with everything we do."
                        ],
                        employeeImg: {
                            src: null
                        }
                    },
                    {
                        heading: "Benefits and Perks",
                        benefitParagraphs: [
                            "At Rosetta Stone, you'll have the best of all worlds... the opportunity to work with passionate, talented people who are the best in their fields along with a flexible schedule that lets you work remotely* (because a work/life balance is important). Rosetta Stone employees also enjoy an unlimited vacation policy, outstanding health and financial benefits, and much more.",
                            "Employee well-being is first and foremost at Rosetta Stone, because we believe that professional success depends on personal health and happiness. We empower you with benefits you can use to succeed in every area of your life, including**:"
                        ],
                        benefitAsterisks: [
                            "*Remote work varies by position",
                            "**Select benefits are only available for full-time US employees. Please contact HR for additional information."
                        ],
                        benefitCards: [
                            {
                                image: images.careersHealthcareIconSvg,
                                text: "Comprehensive <br /> healthcare"
                            },
                            {
                                image: images.careers_401kIconSvg,
                                text: "401(K)"
                            },
                            {
                                image: images.careersVacationIconSvg,
                                text: "Unlimited vacation policy and 9 paid holidays"
                            },
                            {
                                image: images.careersTuitionIconSvg,
                                text: "Tuition <br /> reimbursement"
                            },
                            {
                                image: images.careersTransitIconSvg,
                                text: "Parking and <br /> transit benefits"
                            },
                            {
                                image: images.careersCaregivingIconSvg,
                                text: "Caregiver and <br /> family support"
                            },
                            {
                                image: images.careersAdoptionIconSvg,
                                text: "Adoption assistance"
                            },
                            {
                                image: images.careersPetInsuranceIconSvg,
                                text: "Pet insurance"
                            }
                        ]
                    },
                    {
                        heading: "Where we are",
                        locations: ["United States", "United Kingdom", "Germany"],
                        awardText: "Awards"
                    },
                    {
                        heading: "Diverse teams perform better.",
                        diversitySpans: "Race • Religion • Gender • LGBTQA+ • National origin • Age • Differing abilities • Parental status • Veteran status",
                        diversityParagraph: "They’re more creative, more dynamic, and compete more effectively. By approaching diversity as an integral piece of our business, we are better poised to serve our community of users, learners and colleagues. Together, we continue to build an equitable and inclusive workplace where everyone can thrive."
                    }
                ],
                email_collection_bar: email_collection_bar$b()
            }
        };
    }
    return pageConfig;
};

var consumer_about_footer_config = ({ strings }) => ({
    visible: true,
    cta: {
        visible: false,
        contact_modal: false,
        email_capture: true,
        market: "us",
        domain: ".com",
        vertical: "consumer",
        page: "home",
        main_label: strings.footer_cta_email_main_label,
        sub_label: strings.footer_cta_email_sub_label,
        button_label: strings.footer_cta_email_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        email_placeholder: strings.footer_cta_email_button
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_buy_label,
                links: [
                    {
                        visible: true,
                        destination: "/buy-spanish/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_spanish_label
                    },
                    {
                        visible: true,
                        destination: "/buy-french/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_french_label
                    },
                    {
                        visible: true,
                        destination: "/buy-italian/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_italian_label
                    },
                    {
                        visible: true,
                        destination: "/buy-german/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_german_label
                    },
                    {
                        visible: true,
                        destination: "/buy-english/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_english_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/idiomas/comprar-ingles/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_ingles_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_espanol_label
                    },
                    {
                        visible: true,
                        destination: "/homeschool/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_homeschool_label
                    },
                    {
                        visible: true,
                        destination: "https://pt.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_portugues_label
                    }
                ]
            },
            {
                label: strings.footer_menu_start_label,
                links: [
                    {
                        visible: true,
                        destination: "/tryitnow/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_demo_label
                    },
                    {
                        visible: true,
                        destination: "/product-activation/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_activation_label
                    },
                    {
                        visible: true,
                        destination: "/product/mobile-apps/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_mobile_label
                    },
                    {
                        visible: true,
                        destination: "/product/reviews/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_reviews_label
                    },
                    {
                        visible: true,
                        destination: "/enterprise/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "//blog.rosettastone.com",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_blog_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "/about/company/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_k12_reading_label
                    },
                    {
                        visible: true,
                        destination: "/careers/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "/endangered/",
                        external: false,
                        new_window: true,
                        label: strings.footer_menu_about_endangered_languages_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "//support.rosettastone.com/en/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "/product/faq/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "/contact/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_contact_us_label
                    },
                    {
                        visible: false,
                        destination: "/legal/accessibility/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_accessibility_statement_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "https://www.rosettastone.com/anti-piracy/"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    label: "Facebook",
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    label: "Twitter",
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    label: "Instagram",
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    label: "^YouTube",
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

const consumer_discounts_pages_config = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "military") {
        pageConfig = {
            page,
            helmet: {
                meta_title: strings.pages_consumer_discounts_military_meta_title,
                meta_description: strings.pages_consumer_discounts_military_meta_title,
                canonical_url: "https://www.rosettastone.com/discounts/military/",
                lang: "en"
            },
            content: {
                strings: {
                    masthead: {
                        h1: strings.pages_consumer_discounts_military_masthead_h1,
                        p: strings.pages_consumer_discounts_military_masthead_p
                    },
                    centerSection: {
                        h2: strings.pages_consumer_discounts_military_centersection_h2,
                        p: strings.pages_consumer_discounts_military_centersection_p
                    }
                },
                urls: {
                    idmeHosted: "https://hosted-pages.id.me/offers/rosetta-stone"
                }
            }
        };
    }
    return pageConfig;
};

var consumer_discounts_footer_config = ({ strings }) => ({
    visible: true,
    cta: {
        visible: false,
        contact_modal: false,
        email_capture: false,
        market: "us",
        domain: ".com",
        vertical: "consumer",
        page: "home",
        main_label: strings.footer_cta_email_main_label,
        sub_label: strings.footer_cta_email_sub_label,
        button_label: strings.footer_cta_email_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        email_placeholder: strings.footer_cta_email_button
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_buy_label,
                links: [
                    {
                        visible: true,
                        destination: "/buy-spanish/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_spanish_label
                    },
                    {
                        visible: true,
                        destination: "/buy-french/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_french_label
                    },
                    {
                        visible: true,
                        destination: "/buy-italian/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_italian_label
                    },
                    {
                        visible: true,
                        destination: "/buy-german/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_german_label
                    },
                    {
                        visible: true,
                        destination: "/buy-english/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_english_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/idiomas/comprar-ingles/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_ingles_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_espanol_label
                    },
                    {
                        visible: true,
                        destination: "/homeschool/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_homeschool_label
                    },
                    {
                        visible: true,
                        destination: "https://pt.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_portugues_label
                    }
                ]
            },
            {
                label: strings.footer_menu_start_label,
                links: [
                    {
                        visible: true,
                        destination: "/tryitnow/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_demo_label
                    },
                    {
                        visible: true,
                        destination: "/product-activation/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_activation_label
                    },
                    {
                        visible: true,
                        destination: "/product/mobile-apps/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_mobile_label
                    },
                    {
                        visible: true,
                        destination: "/product/reviews/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_reviews_label
                    },
                    {
                        visible: true,
                        destination: "/enterprise/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "//blog.rosettastone.com",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_blog_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "/about/company/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_k12_reading_label
                    },
                    {
                        visible: true,
                        destination: "/careers/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "//support.rosettastone.com/en/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "/product/faq/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "/contact/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_contact_us_label
                    },
                    {
                        visible: false,
                        destination: "/legal/accessibility/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_accessibility_statement_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "https://www.rosettastone.com/anti-piracy/"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    label: "Facebook",
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    label: "Twitter",
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    label: "Instagram",
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    label: "^YouTube",
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var email_collection_bar$a = () => {
    return {
        visible: true,
        dataQa: "email collection bar",
        website: "US_WEBSITE",
        demo_type: "offer_signup",
        newsletter_type: "footer_signup",
        language: "ENG",
        button: {
            text: "Sign up",
            theme: "yellow_black",
            size: "mini"
        },
        email_field: {
            placeholder: "Email Address",
            id: "email",
            name: "email"
        },
        subtitle: {
            content: "Get Rosetta Stone news and offers.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        success_message: {
            content: "Thanks for signing up.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        error_message: {
            content: "E-mail is invalid.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        title: {
            content: "Sign up to stay in touch.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        legal: {
            content: "By signing up, I agree to the",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        legal_link: {
            destination: "",
            label: "terms and conditions",
            theme: "white",
            underline: "on"
        },
        privacy_tooltip: {
            title: {
                type: "card-title",
                theme: "white",
                content: "Terms and Conditions",
                align: "center"
            },
            body: {
                align: "left",
                theme: "white",
                dangerous: false,
                content: (React.createElement("div", null,
                    "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\u00A0",
                    React.createElement("a", { href: "https://www.rosettastone.com/privacy", title: "Privacy Policy", target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy"),
                    ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \u00A0",
                    React.createElement("a", { href: "mailto: privacyofficer@rosettastone.com", title: "privacyofficer@rosettastone.com", target: "_blank", rel: "noopener noreferrer" }, "privacyofficer@rosettastone.com"),
                    "."))
            }
        }
    };
};

const consumer_feature_pages_config = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "https://www.rosettastone.com/",
                lang: "en"
            },
            content: {
                email_collection_bar: email_collection_bar$a()
            }
        };
    }
    if (page === "audio-companion") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Audio Companion - Rosetta Stone",
                meta_description: "",
                canonical_url: "https://www.rosettastone.com/feature/audio-companion/",
                lang: "en"
            },
            content: {
                sections: {
                    hero: {
                        h1: strings.consumer_features_ac_hero_h1,
                        p_1: strings.consumer_features_ac_hero_p_1
                    },
                    lang_selector: {
                        p_1: strings.consumer_features_ac_lang_selector_p_1,
                        p_2: strings.consumer_features_ac_lang_selector_p_2,
                        p_3: strings.consumer_features_ac_lang_selector_p_3,
                        mp3_p_1: strings.consumer_features_ac_lang_selector_mp3_p_1,
                        select_language_p: strings.consumer_features_ac_lang_selector_select_language,
                        languages: [
                            {
                                name: strings.consumer_features_ac_languages_arabic_name,
                                value: strings.consumer_features_ac_languages_arabic_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_chinese_name,
                                value: strings.consumer_features_ac_languages_chinese_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_dutch_name,
                                value: strings.consumer_features_ac_languages_dutch_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_american_english_name,
                                value: strings.consumer_features_ac_languages_american_english_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_british_english_name,
                                value: strings.consumer_features_ac_languages_british_english_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_farsi_name,
                                value: strings.consumer_features_ac_languages_farsi_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_filipino_name,
                                value: strings.consumer_features_ac_languages_filipino_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_french_name,
                                value: strings.consumer_features_ac_languages_french_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_german_name,
                                value: strings.consumer_features_ac_languages_german_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_greek_name,
                                value: strings.consumer_features_ac_languages_greek_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_hebrew_name,
                                value: strings.consumer_features_ac_languages_hebrew_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_hindi_name,
                                value: strings.consumer_features_ac_languages_hindi_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_irish_name,
                                value: strings.consumer_features_ac_languages_irish_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_italian_name,
                                value: strings.consumer_features_ac_languages_italian_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_japanese_name,
                                value: strings.consumer_features_ac_languages_japanese_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_korean_name,
                                value: strings.consumer_features_ac_languages_korean_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_latin_name,
                                value: strings.consumer_features_ac_languages_latin_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_polish_name,
                                value: strings.consumer_features_ac_languages_polish_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_portuguese_name,
                                value: strings.consumer_features_ac_languages_portuguese_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_russian_name,
                                value: strings.consumer_features_ac_languages_russian_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_latam_espanol_name,
                                value: strings.consumer_features_ac_languages_latam_espanol_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_spain_espanol_name,
                                value: strings.consumer_features_ac_languages_spain_espanol_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_swedish_name,
                                value: strings.consumer_features_ac_languages_swedish_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_turkish_name,
                                value: strings.consumer_features_ac_languages_turkish_value
                            },
                            {
                                name: strings.consumer_features_ac_languages_vietnamese_name,
                                value: strings.consumer_features_ac_languages_vietnamese_value
                            }
                        ]
                    },
                    columns: {
                        fundamentals: {
                            heading: strings.consumer_features_ac_fundamentals_column_heading,
                            text: strings.consumer_features_ac_fundamentals_column_text
                        },
                        exploration_and_clarity: {
                            heading: strings.consumer_features_ac_exploration_column_heading,
                            text: strings.consumer_features_ac_exploration_column_text
                        },
                        conversation: {
                            heading: strings.consumer_features_ac_conversation_column_heading,
                            text: strings.consumer_features_ac_conversation_column_text
                        }
                    },
                    levels: {
                        1: {
                            text: strings.consumer_features_ac_level_1_text,
                            units_text: strings.consumer_features_ac_level_1_units_text,
                            unit_01_text: strings.consumer_features_ac_level_1_language_basics_text,
                            unit_02_text: strings.consumer_features_ac_level_1_greetings_and_introductions_text,
                            unit_03_text: strings.consumer_features_ac_level_1_work_and_school_text,
                            unit_04_text: strings.consumer_features_ac_level_1_shopping_text
                        },
                        2: {
                            text: strings.consumer_features_ac_level_2_text,
                            units_text: strings.consumer_features_ac_level_2_units_text,
                            unit_01_text: strings.consumer_features_ac_level_2_travel_text,
                            unit_02_text: strings.consumer_features_ac_level_2_past_and_future_text,
                            unit_03_text: strings.consumer_features_ac_level_2_friends_and_social_text,
                            unit_04_text: strings.consumer_features_ac_level_2_dining_and_vacation_text
                        },
                        3: {
                            text: strings.consumer_features_ac_level_3_text,
                            units_text: strings.consumer_features_ac_level_3_units_text,
                            unit_01_text: strings.consumer_features_ac_level_3_home_and_health_text,
                            unit_02_text: strings.consumer_features_ac_level_3_life_and_world_text,
                            unit_03_text: strings.consumer_features_ac_level_3_everyday_things_text,
                            unit_04_text: strings.consumer_features_ac_level_3_places_and_events_text
                        },
                        4: {
                            text: strings.consumer_features_ac_level_4_text,
                            units_text: strings.consumer_features_ac_level_4_units_text,
                            unit_01_text: strings.consumer_features_ac_level_4_tourism_and_recreation_text,
                            unit_02_text: strings.consumer_features_ac_level_4_professions_and_hobbies_text,
                            unit_03_text: strings.consumer_features_ac_level_4_home_around_town_text,
                            unit_04_text: strings.consumer_features_ac_level_4_style_and_wellness_text
                        },
                        5: {
                            text: strings.consumer_features_ac_level_5_text,
                            units_text: strings.consumer_features_ac_level_5_units_text,
                            unit_01_text: strings.consumer_features_ac_level_5_business_and_industry_text,
                            unit_02_text: strings.consumer_features_ac_level_5_art_and_academics_text,
                            unit_03_text: strings.consumer_features_ac_level_5_emergency_situations_text,
                            unit_04_text: strings.consumer_features_ac_level_5_family_and_community_text
                        }
                    }
                },
                email_collection_bar: email_collection_bar$a()
            }
        };
    }
    return pageConfig;
};

var consumer_feature_footer_config = ({ strings }) => ({
    visible: true,
    cta: {
        visible: false,
        contact_modal: false,
        email_capture: true,
        market: "us",
        domain: ".com",
        vertical: "consumer",
        page: "home",
        main_label: strings.footer_cta_email_main_label,
        sub_label: strings.footer_cta_email_sub_label,
        button_label: strings.footer_cta_email_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        email_placeholder: strings.footer_cta_email_button
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_buy_label,
                links: [
                    {
                        visible: true,
                        destination: "/buy-spanish/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_spanish_label
                    },
                    {
                        visible: true,
                        destination: "/buy-french/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_french_label
                    },
                    {
                        visible: true,
                        destination: "/buy-italian/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_italian_label
                    },
                    {
                        visible: true,
                        destination: "/buy-german/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_german_label
                    },
                    {
                        visible: true,
                        destination: "/buy-english/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_english_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/idiomas/comprar-ingles/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_ingles_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_espanol_label
                    },
                    {
                        visible: true,
                        destination: "/homeschool/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_homeschool_label
                    },
                    {
                        visible: true,
                        destination: "https://pt.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_portugues_label
                    }
                ]
            },
            {
                label: strings.footer_menu_start_label,
                links: [
                    {
                        visible: true,
                        destination: "/tryitnow/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_demo_label
                    },
                    {
                        visible: true,
                        destination: "/product-activation/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_activation_label
                    },
                    {
                        visible: true,
                        destination: "/product/mobile-apps/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_mobile_label
                    },
                    {
                        visible: true,
                        destination: "/product/reviews/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_reviews_label
                    },
                    {
                        visible: true,
                        destination: "/enterprise/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "//blog.rosettastone.com",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_blog_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "/about/company/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_k12_reading_label
                    },
                    {
                        visible: true,
                        destination: "/careers/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "//support.rosettastone.com/en/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "/faq/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "/contact/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_contact_us_label
                    },
                    {
                        visible: false,
                        destination: "/legal/accessibility/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_accessibility_statement_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "https://www.rosettastone.com/anti-piracy/"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    label: "Facebook",
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    label: "Twitter",
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    label: "Instagram",
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    label: "^YouTube",
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var email_collection_bar$9 = () => {
    return {
        visible: true,
        dataQa: "email collection bar",
        website: "US_WEBSITE",
        demo_type: "offer_signup",
        newsletter_type: "footer_signup",
        language: "ENG",
        button: {
            text: "Sign up",
            theme: "yellow_black",
            size: "mini"
        },
        email_field: {
            placeholder: "Email Address",
            id: "email",
            name: "email"
        },
        subtitle: {
            content: "Get Rosetta Stone news and offers.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        success_message: {
            content: "Thanks for signing up.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        error_message: {
            content: "E-mail is invalid.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        title: {
            content: "Sign up to stay in touch.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        legal: {
            content: "By signing up, I agree to the",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        legal_link: {
            destination: "",
            label: "terms and conditions",
            theme: "white",
            underline: "on"
        },
        privacy_tooltip: {
            title: {
                type: "card-title",
                theme: "white",
                content: "Terms and Conditions",
                align: "center"
            },
            body: {
                align: "left",
                theme: "white",
                dangerous: false,
                content: (React__default.createElement("div", null,
                    "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\u00A0",
                    React__default.createElement("a", { href: "https://www.rosettastone.com/privacy", title: "Privacy Policy", target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy"),
                    ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \u00A0",
                    React__default.createElement("a", { href: "mailto: privacyofficer@rosettastone.com", title: "privacyofficer@rosettastone.com", target: "_blank", rel: "noopener noreferrer" }, "privacyofficer@rosettastone.com"),
                    "."))
            }
        }
    };
};

const consumer_lausd_pages_config = ({ page }) => {
    let pageConfig = null;
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Official Rosetta Stone® - Language Learning - Learn a Language",
                meta_description: "Rosetta Stone is the best way to learn a foreign language. The award-winning language solution combines proven learning methods with the world's best speech recognition technology.",
                canonical_url: "https://www.rosettastone.com/lausd/",
                lang: "en"
            },
            content: {
                heading: {
                    layout: "list",
                    wrapper: {
                        backgroundColor: null,
                        backgroundImage: null,
                        gutter: "double"
                    },
                    panels: [
                        {
                            body: {
                                content: ""
                            },
                            data_qa: null,
                            direction: "image-right",
                            image: {
                                type: "static",
                                src: logos.lausdLogoPng,
                                height: null,
                                width: null
                            },
                            justifyContent: "center",
                            title: {
                                align: "center",
                                content: "Welcome to the LAUSD Rosetta Stone Hub",
                                heading: "h1",
                                theme: "white",
                                type: "page-title"
                            }
                        }
                    ]
                },
                contacts: {
                    layout: "list",
                    wrapper: {
                        backgroundColor: null,
                        backgroundImage: null,
                        gutter: true
                    },
                    custom: {
                        title: {
                            content: "Your dedicated Rosetta Stone team is here to help!",
                            type: "section-sub-title"
                        },
                        contact_1_label: {
                            content: "For sign-in support:"
                        },
                        contact_1_link: {
                            theme: "blue",
                            label: "supportLAUSD@rosettastone.com",
                            destination: "mailto:supportLAUSD@rosettastone.com"
                        },
                        contact_2_label: {
                            content: "For implementation and product support:"
                        },
                        contact_2_link: {
                            theme: "blue",
                            label: "LAUSD@rosettastone.com",
                            destination: "mailto:LAUSD@rosettastone.com"
                        }
                    }
                },
                getting_started: {
                    layout: "list",
                    wrapper: {
                        backgroundColor: "#EFFAFC",
                        gutter: "double"
                    },
                    panels: [
                        {
                            body: null,
                            custom: {
                                list_button_1: {
                                    theme: "white_blue",
                                    text: "Install Rosetta Stone with Schoology",
                                    destination: "https://resources.rosettastone.com/CDN/us/pdfs/lausd/lausd-schoology-integration-guide-rs.pdf",
                                    list_item_number: 1
                                },
                                list_button_2: {
                                    theme: "white_blue",
                                    text: "Sign in to Rosetta Stone through Schoology",
                                    list_item_number: 2,
                                    destination: "https://lausdschoology.azurewebsites.net/?&domain=lms.lausd.net&timestamp=1626272930",
                                    new_window: true
                                }
                            },
                            data_qa: null,
                            direction: "image-right",
                            video: {
                                currentVideoUrl: "https://player.vimeo.com/video/579936506",
                                spanishVideoUrl: "https://vimeo.com/601142865",
                                playing: false,
                                controls: true
                            },
                            justifyContent: "space-between",
                            title: {
                                align: "left",
                                content: "Getting Started",
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            }
                        }
                    ]
                },
                helpful_resources: {
                    layout: "list",
                    wrapper: {
                        backgroundColor: null,
                        gutter: "double"
                    },
                    panels: [
                        {
                            body: null,
                            custom: {
                                li_1: '<a target="_blank" rel="noopener noreferrer" href="https://faculty-lausd.rosettastoneclassroom.com/en-US/">Experience the student side of Rosetta Stone</a> and model how to use the program for your students.',
                                li_2: '<a target="_blank" rel="noopener noreferrer" href="https://resources.rosettastone.com/CDN/us/pdfs/LAUSD-Rosetta-Stone-custom-lists-guide.pdf">Create custom lists</a> to view data for a specified group of students.',
                                li_3: 'Need more help? Check out these <a target="_blank" rel="noopener noreferrer" href="https://resources.rosettastone.com/CDN/us/pdfs/lausd/lausd-rst-faq-troubleshooting.pdf">FAQs</a>.'
                            },
                            data_qa: null,
                            direction: "image-right",
                            justifyContent: "split",
                            video: {
                                playing: false,
                                currentVideoUrl: "https://player.vimeo.com/video/579936632",
                                controls: true
                            },
                            title: {
                                align: "left",
                                content: "Helpful Resources",
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            }
                        }
                    ]
                },
                teacher_resources: {
                    layout: "list",
                    wrapper: {
                        backgroundColor: "#EFFAFC",
                        gutter: "double",
                        title: {
                            align: "left",
                            content: "Teacher Resources for English Language Learners",
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        }
                    },
                    panels: [
                        {
                            body: null,
                            custom: {
                                li_1: `<span>Use Rosetta Stone’s <a target="_blank" rel="noopener noreferrer" href="https://resources.rosettastone.com/support/SF/Resources/ScopeAndSequence.pdf">Scope and Sequence</a> to see what students are learning in each unit.</span>`,
                                li_2: `<span>Explore a variety of <a target="_blank" rel="noopener noreferrer" href="https://support.rosettastone.com/s/article/Supplemental-Resources-English-Learners?language=en_US">printable resources</a> for teaching English Language Learners.</span>`,
                                li_3: `<span>Need help placing learners with previous language experience? Check out these <a target="_blank" rel="noopener noreferrer" href="https://support.rosettastone.com/s/article/Getting-Started-in-Foundations-with-Previous-Experience?language=en_US">helpful tips</a>.</span>`
                            },
                            data_qa: null,
                            direction: "image-right",
                            image: {
                                src: null,
                                alt: "Teacher Resources for English Language Learners"
                            },
                            justifyContent: "split"
                        }
                    ]
                },
                parent_resources: {
                    layout: "list",
                    wrapper: {
                        backgroundColor: null,
                        gutter: "double"
                    },
                    panels: [
                        {
                            body: null,
                            custom: {
                                li_1: `Learn how students can access <a target="_blank" rel="noopener noreferrer" href="https://resources.rosettastone.com/CDN/us/pdfs/lausd/lausd-accessing-rs-from-home.pdf">Rosetta Stone at home</a>.`,
                                li_2: `Descubra cómo los estudiantes pueden acceder a <a target="_blank" rel="noopener noreferrer" href="https://resources.rosettastone.com/CDN/us/pdfs/lausd/lausd-spanish-accessing-rs-from-home.pdf">Rosetta Stone en casa</a>.`
                            },
                            data_qa: null,
                            direction: "image-left",
                            image: {
                                src: null,
                                alt: "Parent Resources"
                            },
                            justifyContent: "split",
                            title: {
                                align: "left",
                                content: "Parent Resources",
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            }
                        }
                    ]
                },
                professional_development: {
                    layout: "list",
                    wrapper: {
                        backgroundColor: "#EFFAFC",
                        gutter: "double"
                    },
                    panels: [
                        {
                            body: null,
                            custom: {
                                li_1: `<a target="_blank" rel="noopener noreferrer" href="/lausd/webinars/">Discover expert insights in live webinars just for LAUSD.</a>`,
                                li_2: "Get Professional Development at no added cost for your school or district!",
                                cta_1: {
                                    destination: "https://docs.google.com/forms/d/e/1FAIpQLSdB-pFfk3zw_CjcNQ2MVnn0KDVDk2JTOrpf7YENr4QM4ZnC7g/viewform",
                                    internal: false,
                                    new_window: true,
                                    size: "regular",
                                    text: "Request PD",
                                    theme: "yellow_black"
                                }
                            },
                            data_qa: null,
                            direction: "image-right",
                            image: {
                                src: null,
                                alt: "Professional Development"
                            },
                            justifyContent: "split",
                            title: {
                                align: "left",
                                content: "Professional Development",
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            }
                        }
                    ]
                },
                email_collection_bar: email_collection_bar$9()
            }
        };
    }
    if (page === "webinars") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Official Rosetta Stone® - Attend a Webinar",
                meta_description: "Whether you're new to the program or a seasoned veteran, our free webinars will help you get the most out of Rosetta Stone.",
                canonical_url: "https://www.rosettastone.com/lausd/webinars/",
                lang: "en"
            },
            content: {
                heading: {
                    layout: "list",
                    wrapper: {
                        backgroundColor: null,
                        backgroundImage: null,
                        gutter: "double"
                    },
                    panels: [
                        {
                            body: {
                                content: ""
                            },
                            data_qa: null,
                            direction: "image-right",
                            image: {
                                type: "static",
                                src: null
                            },
                            justifyContent: "center",
                            title: {
                                align: "center",
                                content: "LAUSD Webinar Schedule",
                                heading: "h1",
                                theme: "white",
                                type: "page-title"
                            }
                        }
                    ]
                },
                webinar_content: {
                    heading: "Upcoming Webinars",
                    timezone: "Pacific",
                    cta_button_text: "Sign Up"
                },
                email_collection_bar: {
                    visible: true,
                    dataQa: "email collection bar",
                    website: "US_WEBSITE",
                    demo_type: "offer_signup",
                    newsletter_type: "footer_signup",
                    language: "ENG",
                    button: {
                        text: "Sign up",
                        theme: "yellow_black",
                        size: "mini"
                    },
                    email_field: {
                        placeholder: "Email Address",
                        id: "email",
                        name: "email"
                    },
                    subtitle: {
                        content: "Get Rosetta Stone news and offers.",
                        align: "left",
                        theme: "white",
                        heading: "div",
                        type: "banner-sub-title"
                    },
                    success_message: {
                        content: "Thanks for signing up.",
                        align: "left",
                        theme: "white",
                        heading: "div",
                        type: "banner-title"
                    },
                    error_message: {
                        content: "E-mail is invalid.",
                        align: "left",
                        theme: "white",
                        heading: "div",
                        type: "banner-title"
                    },
                    title: {
                        content: "Sign up to stay in touch.",
                        align: "left",
                        theme: "white",
                        heading: "div",
                        type: "banner-title"
                    },
                    legal: {
                        content: "By signing up, I agree to the",
                        align: "left",
                        theme: "white",
                        heading: "div",
                        type: "banner-sub-title"
                    },
                    legal_link: {
                        destination: "https://www.rosettastone.com/terms/",
                        label: "terms and conditions",
                        theme: "white",
                        underline: "on"
                    }
                }
            }
        };
    }
    return pageConfig;
};

var consumer_lausd_footer_config = ({ strings }) => ({
    visible: true,
    cta: {
        visible: false,
        contact_modal: false,
        email_capture: true,
        market: "us",
        domain: ".com",
        vertical: "consumer",
        page: "home",
        main_label: strings.footer_cta_email_main_label,
        sub_label: strings.footer_cta_email_sub_label,
        button_label: strings.footer_cta_email_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        email_placeholder: strings.footer_cta_email_button
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_buy_label,
                links: [
                    {
                        visible: true,
                        destination: "/buy-spanish/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_spanish_label
                    },
                    {
                        visible: true,
                        destination: "/buy-french/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_french_label
                    },
                    {
                        visible: true,
                        destination: "/buy-italian/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_italian_label
                    },
                    {
                        visible: true,
                        destination: "/buy-german/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_german_label
                    },
                    {
                        visible: true,
                        destination: "/buy-english/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_english_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/idiomas/comprar-ingles/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_ingles_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_espanol_label
                    },
                    {
                        visible: true,
                        destination: "/homeschool/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_homeschool_label
                    },
                    {
                        visible: true,
                        destination: "https://pt.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_portugues_label
                    }
                ]
            },
            {
                label: strings.footer_menu_start_label,
                links: [
                    {
                        visible: true,
                        destination: "/tryitnow/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_demo_label
                    },
                    {
                        visible: true,
                        destination: "/product-activation/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_activation_label
                    },
                    {
                        visible: true,
                        destination: "/product/mobile-apps/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_mobile_label
                    },
                    {
                        visible: true,
                        destination: "/product/reviews/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_reviews_label
                    },
                    {
                        visible: true,
                        destination: "/enterprise/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "//blog.rosettastone.com",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_blog_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "/about/company/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_k12_reading_label
                    },
                    {
                        visible: true,
                        destination: "/careers/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "//support.rosettastone.com/en/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "/product/faq/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "/contact/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_contact_us_label
                    },
                    {
                        visible: false,
                        destination: "/legal/accessibility/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_accessibility_statement_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "https://www.rosettastone.com/anti-piracy/"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    label: "Facebook",
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    label: "Twitter",
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    label: "Instagram",
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    label: "^YouTube",
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var email_collection_bar$8 = () => {
    return {
        visible: true,
        dataQa: "email collection bar",
        website: "US_WEBSITE",
        demo_type: "offer_signup",
        newsletter_type: "footer_signup",
        language: "ENG",
        button: {
            text: "Sign up",
            theme: "yellow_black",
            size: "mini"
        },
        email_field: {
            placeholder: "Email Address",
            id: "email",
            name: "email"
        },
        subtitle: {
            content: "Get Rosetta Stone news and offers.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        success_message: {
            content: "Thanks for signing up.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        error_message: {
            content: "E-mail is invalid.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        title: {
            content: "Sign up to stay in touch.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        legal: {
            content: "By signing up, I agree to the",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        legal_link: {
            destination: "",
            label: "terms and conditions",
            theme: "white",
            underline: "on"
        },
        privacy_tooltip: {
            title: {
                type: "card-title",
                theme: "white",
                content: "Terms and Conditions",
                align: "center"
            },
            body: {
                align: "left",
                theme: "white",
                dangerous: false,
                content: (React__default.createElement("div", null,
                    "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\u00A0",
                    React__default.createElement("a", { href: "https://www.rosettastone.com/privacy", title: "Privacy Policy", target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy"),
                    ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \u00A0",
                    React__default.createElement("a", { href: "mailto: privacyofficer@rosettastone.com", title: "privacyofficer@rosettastone.com", target: "_blank", rel: "noopener noreferrer" }, "privacyofficer@rosettastone.com"),
                    "."))
            }
        }
    };
};

const consumer_legal_pages_config = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Official Rosetta Stone® - Language Learning - Learn a Language",
                meta_description: "Rosetta Stone is the best way to learn a foreign language. The award-winning language solution combines proven learning methods with the world's best speech recognition technology.",
                canonical_url: "https://www.rosettastone.com/lausd/",
                lang: "en"
            },
            content: {
                email_collection_bar: email_collection_bar$8()
            }
        };
    }
    if (page === "ccpa") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Rosetta Stone® CALIFORNIA DO NOT SELL MY PERSONAL INFORMATION PAGE",
                meta_description: "",
                canonical_url: "https://www.rosettastone.com/legal/ccpa/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        hero_heading: strings.consumer_legal_ccpa_heading,
                        hero_p_1: strings.consumer_legal_ccpa_heading_p_1,
                        hero_p_2: strings.consumer_legal_ccpa_heading_p_2
                    },
                    {
                        cookie_heading: strings.consumer_legal_ccpa_cookie_heading,
                        cookie_paragraphs: [
                            strings.consumer_legal_ccpa_cookie_p_1,
                            strings.consumer_legal_ccpa_cookie_p_2,
                            strings.consumer_legal_ccpa_cookie_p_3,
                            strings.consumer_legal_ccpa_cookie_p_4,
                            strings.consumer_legal_ccpa_cookie_p_5,
                            strings.consumer_legal_ccpa_cookie_p_6,
                            strings.consumer_legal_ccpa_cookie_p_7
                        ]
                    }
                ],
                email_collection_bar: email_collection_bar$8()
            }
        };
    }
    if (page === "privacy-shield") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Rosetta Stone® EU-US and SWISS Privacy Policy",
                meta_description: "",
                canonical_url: "https://www.rosettastone.com/legal/privacy-shield/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        hero_heading: strings.consumer_legal_privacy_shield_heading,
                        hero_heading_p_1: strings.consumer_legal_privacy_shield_heading_p_1,
                        hero_body_p_1: strings.consumer_legal_privacy_shield_body_p_1,
                        hero_heading_p_2: strings.consumer_legal_privacy_shield_heading_p_2,
                        hero_body_p_2_1: strings.consumer_legal_privacy_shield_body_p_2_1,
                        hero_body_p_2_2: strings.consumer_legal_privacy_shield_body_p_2_2,
                        hero_body_p_2_3: strings.consumer_legal_privacy_shield_body_p_2_3,
                        hero_heading_p_3: strings.consumer_legal_privacy_shield_heading_p_3,
                        hero_body_p_3_1: strings.consumer_legal_privacy_shield_body_p_3_1,
                        hero_body_p_3_2: strings.consumer_legal_privacy_shield_body_p_3_2,
                        hero_heading_p_4: strings.consumer_legal_privacy_shield_heading_p_4,
                        hero_body_p_4_1: strings.consumer_legal_privacy_shield_body_p_4_1,
                        hero_heading_p_5: strings.consumer_legal_privacy_shield_heading_p_5,
                        hero_body_p_5_1: strings.consumer_legal_privacy_shield_body_p_5_1,
                        hero_body_p_5_2: strings.consumer_legal_privacy_shield_body_p_5_2,
                        hero_heading_p_6: strings.consumer_legal_privacy_shield_heading_p_6,
                        hero_body_p_6_1: strings.consumer_legal_privacy_shield_body_p_6_1
                    }
                ],
                email_collection_bar: email_collection_bar$8()
            }
        };
    }
    if (page === "dpas") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Rosetta Stone® - Data Privacy and Security",
                meta_description: "Rosetta Stone® - Data Privacy and Security",
                canonical_url: "https://www.rosettastone.com/legal/ccpa/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        hero_heading: strings.consumer_legal_dpas_hero_heading,
                        hero_heading_body: strings.consumer_legal_dpas_hero_heading_body,
                        our_commitment_title: strings.consumer_legal_dpas_our_commitment_title,
                        our_commitment_body: strings.consumer_legal_dpas_our_commitment_body,
                        info_tech_title: strings.consumer_legal_dpas_info_tech_title,
                        info_tech_body_1: strings.consumer_legal_dpas_info_tech_body_1,
                        info_tech_body_2: strings.consumer_legal_dpas_info_tech_body_2,
                        info_tech_body_3: strings.consumer_legal_dpas_info_tech_body_3,
                        info_tech_body_4: strings.consumer_legal_dpas_info_tech_body_4,
                        training_title: strings.consumer_legal_dpas_training_title,
                        training_body: strings.consumer_legal_dpas_training_body_1,
                        oversight_title: strings.consumer_legal_dpas_oversight_title,
                        oversight_body: strings.consumer_legal_dpas_oversight_body_1
                    },
                    {
                        faq_items: [
                            {
                                title: strings.consumer_legal_dpas_faq_item_1_title,
                                image: images.usConsumerLegalDpasResourcesLogoSvg,
                                content: [
                                    strings.consumer_legal_dpas_faq_item_1_content_title,
                                    strings.consumer_legal_dpas_faq_item_1_content_1_body
                                ]
                            },
                            {
                                title: strings.consumer_legal_dpas_faq_item_2_title,
                                image: images.usConsumerLegalDpasSarLogoSvg,
                                content: [
                                    strings.consumer_legal_dpas_faq_item_2_content_1_body,
                                    strings.consumer_legal_dpas_faq_item_2_content_2_body
                                ]
                            },
                            {
                                title: strings.consumer_legal_dpas_faq_item_3_title,
                                image: images.usConsumerLegalDpasEntAccountsLogoSvg,
                                content: [
                                    strings.consumer_legal_dpas_faq_item_3_content_1_body,
                                    strings.consumer_legal_dpas_faq_item_3_content_2_title,
                                    strings.consumer_legal_dpas_faq_item_3_content_2_body,
                                    strings.consumer_legal_dpas_faq_item_3_content_3_title,
                                    strings.consumer_legal_dpas_faq_item_3_content_3_body
                                ]
                            },
                            {
                                title: strings.consumer_legal_dpas_faq_item_4_title,
                                image: images.usConsumerLegalDpasGirLogoSvg,
                                content: [
                                    strings.consumer_legal_dpas_faq_item_4_content_1_body,
                                    strings.consumer_legal_dpas_faq_item_4_content_2_body,
                                    strings.consumer_legal_dpas_faq_item_4_content_3_body
                                ]
                            },
                            {
                                title: strings.consumer_legal_dpas_faq_item_5_title,
                                image: images.usConsumerLegalDpasTipsLogoSvg,
                                content: [
                                    strings.consumer_legal_dpas_faq_item_5_content_1_body,
                                    strings.consumer_legal_dpas_faq_item_5_content_2_title,
                                    strings.consumer_legal_dpas_faq_item_5_content_2_body,
                                    strings.consumer_legal_dpas_faq_item_5_content_3_title,
                                    strings.consumer_legal_dpas_faq_item_5_content_3_body,
                                    strings.consumer_legal_dpas_faq_item_5_content_4_body,
                                    strings.consumer_legal_dpas_faq_item_5_content_5_body,
                                    strings.consumer_legal_dpas_faq_item_5_content_6_body
                                ]
                            },
                            {
                                title: strings.consumer_legal_dpas_faq_item_6_title,
                                image: images.usConsumerLegalDpasContactLogoSvg,
                                content: [
                                    strings.consumer_legal_dpas_faq_item_6_title,
                                    strings.consumer_legal_dpas_faq_item_6_content_1_body
                                ]
                            }
                        ]
                    }
                ],
                email_collection_bar: email_collection_bar$8()
            }
        };
    }
    if (page === "accessibility") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Website Accessibility Statement",
                meta_description: "",
                canonical_url: "https://www.rosettastone.com/legal/accessibility/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        hero_title: strings.consumer_legal_accessibility_title,
                        paragraph_1: strings.consumer_legal_accessibility_content_1,
                        paragraph_2: strings.consumer_legal_accessibility_content_2,
                        paragraph_3: strings.consumer_legal_accessibility_content_3
                    }
                ],
                email_collection_bar: email_collection_bar$8()
            }
        };
    }
    if (page === "cookie-policy") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Rosetta Stone Cookie Policy",
                meta_description: "",
                canonical_url: "https://www.rosettastone.com/legal/cookie-policy/",
                lang: "en"
            },
            content: {
                email_collection_bar: email_collection_bar$8()
            }
        };
    }
    if (page === "agreements") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Official Rosetta Stone® Agreements",
                meta_description: "Please read through the Rosetta Stone Agreements, Guidelines, Terms & Conditions, Privacy Policy, and Terms of Use.",
                canonical_url: "https://www.rosettastone.com/legal/agreements/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        hero_heading: strings.consumer_legal_agreements_hero_heading,
                        hero_p_1: strings.consumer_legal_agreements_hero_p_1,
                        agreement_sections: [
                            {
                                title: strings.consumer_legal_agreements_section_1_title,
                                agreement_links: [
                                    {
                                        title: strings.consumer_legal_agreements_section_1_link_1_title,
                                        link: strings.consumer_legal_agreements_section_1_link_1_url
                                    },
                                    {
                                        title: strings.consumer_legal_agreements_section_1_link_2_title,
                                        link: strings.consumer_legal_agreements_section_1_link_2_url
                                    },
                                    {
                                        title: strings.consumer_legal_agreements_section_1_link_3_title,
                                        link: strings.consumer_legal_agreements_section_1_link_3_url
                                    },
                                    {
                                        title: strings.consumer_legal_agreements_section_1_link_4_title,
                                        link: strings.consumer_legal_agreements_section_1_link_4_url
                                    },
                                    {
                                        title: strings.consumer_legal_agreements_section_1_link_5_title,
                                        link: strings.consumer_legal_agreements_section_1_link_5_url
                                    },
                                    {
                                        title: strings.consumer_legal_agreements_section_1_link_6_title,
                                        link: strings.consumer_legal_agreements_section_1_link_6_url
                                    }
                                ]
                            },
                            {
                                title: strings.consumer_legal_agreements_section_2_title,
                                agreement_links: [
                                    {
                                        title: strings.consumer_legal_agreements_section_2_link_1_title,
                                        link: strings.consumer_legal_agreements_section_2_link_1_url
                                    },
                                    {
                                        title: strings.consumer_legal_agreements_section_2_link_2_title,
                                        link: strings.consumer_legal_agreements_section_2_link_2_url
                                    },
                                    {
                                        title: strings.consumer_legal_agreements_section_2_link_3_title,
                                        link: strings.consumer_legal_agreements_section_2_link_3_url
                                    },
                                    {
                                        title: strings.consumer_legal_agreements_section_2_link_4_title,
                                        link: strings.consumer_legal_agreements_section_2_link_4_url
                                    },
                                    {
                                        title: strings.consumer_legal_agreements_section_2_link_5_title,
                                        link: strings.consumer_legal_agreements_section_2_link_5_url
                                    },
                                    {
                                        title: strings.consumer_legal_agreements_section_2_link_6_title,
                                        link: strings.consumer_legal_agreements_section_2_link_6_url
                                    },
                                    {
                                        title: strings.consumer_legal_agreements_section_2_link_7_title,
                                        link: strings.consumer_legal_agreements_section_2_link_7_url
                                    }
                                ]
                            }
                        ]
                    }
                ],
                email_collection_bar: email_collection_bar$8()
            }
        };
    }
    return pageConfig;
};

var consumer_legal_footer_config = ({ strings }) => ({
    visible: true,
    cta: {
        visible: false,
        contact_modal: false,
        email_capture: true,
        market: "us",
        domain: ".com",
        vertical: "consumer",
        page: "home",
        main_label: strings.footer_cta_email_main_label,
        sub_label: strings.footer_cta_email_sub_label,
        button_label: strings.footer_cta_email_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        email_placeholder: strings.footer_cta_email_button
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_buy_label,
                links: [
                    {
                        visible: true,
                        destination: "/buy-spanish/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_spanish_label
                    },
                    {
                        visible: true,
                        destination: "/buy-french/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_french_label
                    },
                    {
                        visible: true,
                        destination: "/buy-italian/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_italian_label
                    },
                    {
                        visible: true,
                        destination: "/buy-german/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_german_label
                    },
                    {
                        visible: true,
                        destination: "/buy-english/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_english_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/idiomas/comprar-ingles/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_ingles_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_espanol_label
                    },
                    {
                        visible: true,
                        destination: "/homeschool/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_homeschool_label
                    },
                    {
                        visible: true,
                        destination: "https://pt.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_portugues_label
                    }
                ]
            },
            {
                label: strings.footer_menu_start_label,
                links: [
                    {
                        visible: true,
                        destination: "/tryitnow/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_demo_label
                    },
                    {
                        visible: true,
                        destination: "/product-activation/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_activation_label
                    },
                    {
                        visible: true,
                        destination: "/product/mobile-apps/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_mobile_label
                    },
                    {
                        visible: true,
                        destination: "/product/reviews/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_reviews_label
                    },
                    {
                        visible: true,
                        destination: "/enterprise/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "//blog.rosettastone.com",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_blog_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "/about/company/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_k12_reading_label
                    },
                    {
                        visible: true,
                        destination: "/careers/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "//support.rosettastone.com/en/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "/faq/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "/contact/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_contact_us_label
                    },
                    {
                        visible: false,
                        destination: "/legal/accessibility/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_accessibility_statement_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "https://www.rosettastone.com/anti-piracy/"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    label: "Facebook",
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    label: "Twitter",
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    label: "Instagram",
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    label: "^YouTube",
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var email_collection_bar$7 = () => {
    return {
        visible: true,
        dataQa: "email collection bar",
        website: "US_WEBSITE",
        demo_type: "offer_signup",
        newsletter_type: "footer_signup",
        language: "ENG",
        button: {
            text: "Sign up",
            theme: "yellow_black",
            size: "mini"
        },
        email_field: {
            placeholder: "Email Address",
            id: "email",
            name: "email"
        },
        subtitle: {
            content: "Get Rosetta Stone news and offers.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        success_message: {
            content: "Thanks for signing up.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        error_message: {
            content: "E-mail is invalid.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        title: {
            content: "Sign up to stay in touch.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        legal: {
            content: "By signing up, I agree to the",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        legal_link: {
            destination: "",
            label: "terms and conditions",
            theme: "white",
            underline: "on"
        },
        privacy_tooltip: {
            title: {
                type: "card-title",
                theme: "white",
                content: "Terms and Conditions",
                align: "center"
            },
            body: {
                align: "left",
                theme: "white",
                dangerous: false,
                content: (React__default.createElement("div", null,
                    "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\u00A0",
                    React__default.createElement("a", { href: "https://www.rosettastone.com/privacy", title: "Privacy Policy", target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy"),
                    ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \u00A0",
                    React__default.createElement("a", { href: "mailto: privacyofficer@rosettastone.com", title: "privacyofficer@rosettastone.com", target: "_blank", rel: "noopener noreferrer" }, "privacyofficer@rosettastone.com"),
                    "."))
            }
        }
    };
};

const consumer_product_pages_config = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Official Rosetta Stone® - Language Learning - Learn a Language",
                meta_description: "Rosetta Stone is the best way to learn a foreign language. The award-winning language solution combines proven learning methods with the world's best speech recognition technology.",
                canonical_url: "https://www.rosettastone.com/lausd/",
                lang: "en"
            },
            content: {
                email_collection_bar: email_collection_bar$7()
            }
        };
    }
    if (page === "mobile-apps") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Language Learning Mobile Apps &mdash; Rosetta Stone",
                meta_description: "Learn to speak a new language with the official Rosetta Stone: Learn Languages mobile app.",
                canonical_url: "https://www.rosettastone.com/mobile-apps/",
                lang: "en"
            },
            content: {
                topImageTextSections: {
                    panels: [
                        {
                            dataQa: "1",
                            layout: "list",
                            justifyContent: "space-between",
                            alignItems: {
                                mobile: "center"
                            },
                            direction: "image-right",
                            maxWidth: 60,
                            padding: "150px 0",
                            body: {
                                dangerous: false,
                                content: strings.mobile_apps_top_section_one_body_content,
                                align: "left"
                            },
                            title: {
                                align: "left",
                                content: strings.mobile_apps_top_section_one_title_content,
                                heading: "h1",
                                type: "section-title",
                                theme: "black"
                            },
                            image: {
                                type: "static",
                                src: images.mobileAppsImage_1Jpg
                            },
                            custom: {
                                cta: {
                                    destination: "https://www.rosettastone.com/freetrial/",
                                    new_window: true,
                                    size: "regular",
                                    text: strings.mobile_apps_top_section_one_custom_cta_text,
                                    theme: "blue_white"
                                }
                            }
                        },
                        {
                            dataQa: "2",
                            layout: "list",
                            justifyContent: "space-between",
                            alignItems: {
                                mobile: "center"
                            },
                            direction: "image-left",
                            maxWidth: 60,
                            padding: "50px 0",
                            title: {
                                align: "left",
                                content: strings.mobile_apps_top_section_two_title_content,
                                heading: "h2",
                                type: "section-title",
                                theme: "black"
                            },
                            body: {
                                content: strings.mobile_apps_top_section_two_body_content,
                                align: "left"
                            },
                            image: {
                                type: "static",
                                src: images.mobileAppsImage_2Jpg
                            },
                            sectionFeatureBullets: [
                                {
                                    heading: strings.mobile_apps_top_section_two_feature_heading_content_one,
                                    subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_one
                                },
                                {
                                    heading: strings.mobile_apps_top_section_two_feature_heading_content_two,
                                    subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_two
                                },
                                {
                                    heading: strings.mobile_apps_top_section_two_feature_heading_content_three,
                                    subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_three
                                },
                                {
                                    heading: strings.mobile_apps_top_section_two_feature_heading_content_four,
                                    subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_four
                                },
                                {
                                    heading: strings.mobile_apps_top_section_two_feature_heading_content_five,
                                    subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_five
                                },
                                {
                                    subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_six
                                }
                            ]
                        },
                        {
                            dataQa: "3",
                            layout: "list",
                            justifyContent: "space-between",
                            alignItems: {
                                mobile: "center"
                            },
                            direction: "image-right",
                            maxWidth: 60,
                            padding: "50px 0",
                            title: {
                                align: "left",
                                content: strings.mobile_apps_top_section_three_title_content,
                                heading: "h2",
                                type: "section-title",
                                theme: "black"
                            },
                            body: {
                                content: strings.mobile_apps_top_section_three_body_content,
                                align: "left"
                            },
                            image: {
                                type: "static",
                                src: images.mobileAppsImage_3Png
                            },
                            sectionFeatureBullets: [
                                {
                                    heading: strings.mobile_apps_top_section_three_feature_heading_content_one,
                                    subHeading: strings.mobile_apps_top_section_three_feature_subheading_content_one
                                },
                                {
                                    heading: strings.mobile_apps_top_section_three_feature_heading_content_two,
                                    subHeading: strings.mobile_apps_top_section_three_feature_subheading_content_two
                                },
                                {
                                    heading: strings.mobile_apps_top_section_three_feature_heading_content_three,
                                    subHeading: strings.mobile_apps_top_section_three_feature_subheading_content_three
                                }
                            ]
                        }
                    ]
                },
                mobileOsLogos: {
                    layout: "list",
                    title: {
                        align: "center",
                        theme: "black",
                        type: "section-title",
                        content: strings.mobile_apps_os_logos_title_content,
                        heading: "h2"
                    },
                    subtitle: {
                        align: "center",
                        theme: "black",
                        type: "section-title",
                        content: strings.mobile_apps_os_logos_subtitle_content
                    },
                    padding: "25px 0 100px",
                    panels: [
                        {
                            image: {
                                type: "static",
                                alt: "",
                                src: logos.logoIosSvg,
                                destination: "https://rosettastone.onelink.me/zwaO/f670c3a0",
                                new_window: true
                            }
                        },
                        {
                            image: {
                                type: "static",
                                alt: "",
                                src: logos.logoAppleWatchSvg
                            }
                        },
                        {
                            image: {
                                type: "static",
                                alt: "",
                                src: logos.logoAndroidSvg,
                                destination: "https://play.google.com/store/apps/details?id=air.com.rosettastone.mobile.CoursePlayer&hl=en_US&gl=US",
                                new_window: true
                            }
                        },
                        {
                            image: {
                                type: "static",
                                alt: "",
                                src: logos.logoSamsungSvg
                            }
                        }
                    ]
                },
                bottomImageTextSection: {
                    panels: [
                        {
                            dataQa: "4",
                            layout: "list",
                            justifyContent: "space-between",
                            alignItems: {
                                mobile: "center"
                            },
                            direction: "image-left",
                            maxWidth: 60,
                            title: {
                                align: "left",
                                content: strings.mobile_apps_bottom_section_one_title_content,
                                heading: "h2",
                                type: "section-title",
                                theme: "black"
                            },
                            body: {
                                content: strings.mobile_apps_bottom_section_one_body_content,
                                align: "left"
                            },
                            image: {
                                type: "static",
                                src: images.mobileAppsImage_4Jpg
                            }
                        }
                    ]
                },
                cyberweek_banner: {
                    visible: false,
                    text: "Cyber Week only! Get a lifetime subscription in any language for just $149",
                    button: {
                        destination: "https://rosettastone.com/lp/sbsr/sitewide",
                        text: "Buy Now"
                    }
                },
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                email_collection_bar: email_collection_bar$7()
            }
        };
    }
    if (page === "rosetta-stone-for-kids") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Rosetta Stone Kids® &mdash; Rosetta Stone",
                meta_description: "Rosetta Stone Kids® makes language learning fun for kids with interactive reading, listening, speaking, and writing activities.  Choose from over 24 languages to begin your language learning adventure.",
                canonical_url: "https://www.rosettastone.com/product/rosettastonekids/",
                lang: "en"
            },
            content: {
                topImageTextSections: {
                    panels: [
                        {
                            dataQa: "1",
                            layout: "list",
                            justifyContent: "space-between",
                            alignItems: {
                                mobile: "center"
                            },
                            direction: "image-left",
                            maxWidth: 60,
                            padding: "150px 0",
                            body: {
                                dangerous: true,
                                content: strings.rosetta_stone_for_kids_top_section_one_body_content,
                                align: "left"
                            },
                            title: {
                                align: "left",
                                content: strings.rosetta_stone_for_kids_top_section_one_title_content,
                                heading: "h1",
                                type: "section-title",
                                theme: "black"
                            },
                            image: {
                                type: "static",
                                src: images.rosettaStoneKidsPng
                            },
                            custom: {
                                cta: {
                                    destination: "https://www.rosettastone.com/tryitnow/",
                                    new_window: true,
                                    size: "regular",
                                    text: strings.rosetta_stone_for_kids_top_section_one_custom_cta_text,
                                    theme: "blue_white"
                                }
                            }
                        }
                    ]
                },
                disclaimer: {
                    visible: true,
                    content: `<p>${strings.rosetta_stone_for_kids_disclaimer_statement}<br/><br/>${strings.rosetta_stone_for_kids_ixl_address}</p>`
                }
            }
        };
    }
    if (page === "reviews") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Official Rosetta Stone® Reviews",
                meta_description: "We teach language learners to speak for themselves, but don’t take our word for it. Read reviews of Rosetta Stone from the people who know us best–our customers.",
                canonical_url: "https://www.rosettastone.com/reviews",
                lang: "en"
            },
            content: {
                topImagePageSection: [
                    {
                        panels: [
                            {
                                title: {
                                    align: "left",
                                    content: "Rosetta Stone Reviews",
                                    type: "page-title",
                                    heading: "h1"
                                },
                                maxWidth: 60,
                                padding: "50px 0",
                                direction: "image-right",
                                image: {
                                    type: "static",
                                    src: images.mobileAppsImage_1Jpg
                                },
                                body: {
                                    align: "left",
                                    content: "We love it when people speak up. Here, you can read reviews from people who have used Rosetta Stone firsthand."
                                },
                                custom: {
                                    appStoreRatings: {
                                        app_store: {
                                            destination: "",
                                            label: "App Store",
                                            url: "/"
                                        },
                                        labels: {
                                            check_it_out: "Check it out in the",
                                            out_of: "out of",
                                            ratings: "ratings"
                                        },
                                        ratings: {
                                            graphBars: [
                                                { stars: 5, percentage: 84 },
                                                { stars: 4, percentage: 11 },
                                                { stars: 3, percentage: 2 },
                                                { stars: 2, percentage: 1 },
                                                { stars: 1, percentage: 2 }
                                            ],
                                            customerRatings: "4.8",
                                            totalRatings: "108.7K"
                                        }
                                    }
                                }
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                direction: "image-left",
                                title: {
                                    content: "Read Rosetta Stone reviews from real customers.",
                                    type: "section-title",
                                    heading: "h2",
                                    align: "left"
                                },
                                body: {
                                    content: "One glance at reviews of Rosetta Stone, and you’ll see we pride ourselves on our ability to help language learners thrive in real-world conversations. With dynamic, immersive bite-sized lessons and an award-winning mobile app, you can learn anytime and anywhere with language that never leaves your side.\n" +
                                        "\n" +
                                        "However, rather than monopolizing the conversation with our accolades, we’ll do what Rosetta Stone does best—encourage our customers to speak for themselves.",
                                    align: "left"
                                },
                                image: {
                                    type: "static",
                                    src: images.mobileAppsImage_2Jpg
                                },
                                maxWidth: 60,
                                padding: "50px 0",
                                dataQa: "QA"
                            }
                        ]
                    }
                ],
                videoPlayerPageSection: {
                    heading: "Looking for videos of real learners?",
                    paragraph: "Watch Rosetta Stone empower life-changing decisions, compassionate service, purposeful exploration, and much more in the lives of real language learners.",
                    videos: [
                        {
                            video_url: "https://www.youtube.com/embed/-zXupH0XmmY",
                            asset_url: images.reviewsVideoAntoniaPng
                        },
                        {
                            video_url: "https://www.youtube.com/embed/ZOwb57bx4mA",
                            asset_url: images.reviewsVideoChrisPng
                        },
                        {
                            video_url: "https://www.youtube.com/embed/g6WEYqaMFsk",
                            asset_url: images.reviewsVideoGracePng
                        },
                        {
                            video_url: "https://www.youtube.com/embed/KwFphr58e94",
                            asset_url: images.reviewsVideoDelainePng
                        },
                        {
                            video_url: "https://www.youtube.com/embed/kp8VyQmDGdE",
                            asset_url: images.reviewsVideoMarkPng
                        },
                        {
                            video_url: "https://www.youtube.com/embed/X7zcMsQ9fSI",
                            asset_url: images.reviewsVideoNunoPng
                        }
                    ]
                },
                bottomImagePageSection: {
                    panels: [
                        {
                            direction: "image-right",
                            maxWidth: 60,
                            padding: "50px 0",
                            title: {
                                align: "left",
                                content: "Need another reason?",
                                type: "section-title",
                                heading: "h2"
                            },
                            body: {
                                content: "There are countless reasons why people learn new languages. Have you thought of why you should learn another language? Or even wondered where to start when starting a new language? Or simply wonder just how long will it take to get conversational? All we can promise is that the longer you wait the longer it’ll take. So, consider setting a language-learning goal. <br /> <br />Whether you practice for a day, a month or years, having a language goal–and a weekly routine to hold yourself accountable– goes a long way when learning to speak a new language well. Whether your reason for speaking a new language is a simple as traveling somewhere new or deeper than wanting to feel how your heritage sounds coming off your own lips, Rosetta Stone is committed to helping you confidently speak another language for yourself.",
                                align: "left",
                                dangerous: true
                            },
                            image: {
                                type: "static",
                                src: images.mobileAppsImage_4Jpg
                            },
                            dataQa: "QA"
                        }
                    ]
                },
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                email_collection_bar: email_collection_bar$7()
            }
        };
    }
    if (page === "awards") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Awards earned by Rosetta Stone | Rosetta Stone",
                meta_description: "Check out awards earned by Rosetta Stone and why our app is loved by learners. Speak one of 24 languages for yourself.",
                canonical_url: "https://www.rosettastone.com/awards/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        title: {
                            align: "left",
                            content: strings.consumer_product_awards_title_content,
                            heading: "h2",
                            theme: "white",
                            type: "page-title"
                        },
                        body: {
                            content: strings.consumer_product_awards_body_content,
                            theme: "white"
                        }
                    },
                    {
                        pcmag: {
                            imageLink: strings.consumer_product_awards_pcmag_imageLink,
                            text: strings.consumer_product_awards_pcmag_text,
                            yearsInARow: strings.consumer_product_awards_pcmag_yearsInARow
                        }
                    },
                    {
                        awardContent: {
                            h2: strings.consumer_product_awards_awardContent_h2,
                            h3: strings.consumer_product_awards_awardContent_h3,
                            p: strings.consumer_product_awards_awardContent_p
                        }
                    },
                    {
                        awardBoxes: [
                            {
                                image: images.consumerAwardsEdtechBreakthroughPng,
                                redirect: strings.consumer_product_awards_awardBoxes_redirect1,
                                text: strings.consumer_product_awards_awardBoxes_text1
                            },
                            {
                                image: images.consumerAwardsBmaGenericPng,
                                redirect: strings.consumer_product_awards_awardBoxes_redirect2,
                                text: strings.consumer_product_awards_awardBoxes_text2
                            },
                            {
                                image: images.consumerAwardsBma_2018Png,
                                redirect: strings.consumer_product_awards_awardBoxes_redirect3,
                                text: strings.consumer_product_awards_awardBoxes_text3
                            },
                            {
                                image: images.consumerAwardsEdtechBreakthroughPng,
                                redirect: strings.consumer_product_awards_awardBoxes_redirect4,
                                text: strings.consumer_product_awards_awardBoxes_text4
                            },
                            {
                                image: images.consumerAwardsBma_2018Png,
                                redirect: strings.consumer_product_awards_awardBoxes_redirect5,
                                text: strings.consumer_product_awards_awardBoxes_text5
                            },
                            {
                                image: images.consumerAwardsTabby_2018Png,
                                redirect: strings.consumer_product_awards_awardBoxes_redirect6,
                                text: strings.consumer_product_awards_awardBoxes_text6
                            }
                        ]
                    }
                ],
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                email_collection_bar: email_collection_bar$7()
            }
        };
    }
    if (page === "faq") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Rosetta Stone® - FAQ",
                meta_description: "Rosetta Stone® - FAQ",
                canonical_url: "https://www.rosettastone.com/awards/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        heroFaq: {
                            h1: "FAQ <span>s</span>",
                            p: "<div>Everything you need to know so you can be a Rosetta Stone pro. <br>Don’t see your question here? Give us a shout at <a target='_blank' href='mailto:help@rosettastone.com'>help@rosettastone.com</a>.</div>"
                        },
                        faqButtonCopy: {
                            theBasics: "The Basics",
                            freeTrial: "Free Trial",
                            pricingAndReturns: "Pricing and Returns",
                            technical: "Technical"
                        },
                        faqItems: {
                            basics: [
                                {
                                    heading: strings.basics_faq_box_bullet_1_heading,
                                    subtext: strings.basics_faq_box_bullet_1_content
                                },
                                {
                                    heading: strings.basics_faq_box_bullet_2_heading,
                                    subtext: strings.basics_faq_box_bullet_2_content
                                },
                                {
                                    heading: strings.basics_faq_box_bullet_3_heading,
                                    subtext: strings.basics_faq_box_bullet_3_content
                                },
                                {
                                    heading: strings.basics_faq_box_bullet_4_heading,
                                    subtext: strings.basics_faq_box_bullet_4_content
                                },
                                {
                                    heading: strings.basics_faq_box_bullet_5_heading,
                                    subtext: strings.basics_faq_box_bullet_5_content
                                },
                                {
                                    heading: strings.basics_faq_box_bullet_6_heading,
                                    subtext: strings.basics_faq_box_bullet_6_content
                                },
                                {
                                    heading: strings.basics_faq_box_bullet_7_heading,
                                    subtext: strings.basics_faq_box_bullet_7_content
                                },
                                {
                                    heading: strings.basics_faq_box_bullet_8_heading,
                                    subtext: strings.basics_faq_box_bullet_8_content
                                },
                                {
                                    heading: strings.basics_faq_box_bullet_9_heading,
                                    subtext: strings.basics_faq_box_bullet_9_content
                                },
                                {
                                    heading: strings.basics_faq_box_bullet_10_heading,
                                    subtext: strings.basics_faq_box_bullet_10_content
                                },
                                {
                                    heading: strings.basics_faq_box_bullet_11_heading,
                                    subtext: strings.basics_faq_box_bullet_11_content
                                },
                                {
                                    heading: strings.basics_faq_box_bullet_12_heading,
                                    subtext: strings.basics_faq_box_bullet_12_content
                                },
                                {
                                    heading: strings.basics_faq_box_bullet_13_heading,
                                    subtext: strings.basics_faq_box_bullet_13_content
                                }
                            ],
                            freeTrial: [
                                {
                                    heading: strings.free_trial_faq_box_bullet_1_heading,
                                    subtext: strings.free_trial_faq_box_bullet_1_content
                                },
                                {
                                    heading: strings.free_trial_faq_box_bullet_2_heading,
                                    subtext: strings.free_trial_faq_box_bullet_2_content
                                },
                                {
                                    heading: strings.free_trial_faq_box_bullet_3_heading,
                                    subtext: strings.free_trial_faq_box_bullet_3_content
                                },
                                {
                                    heading: strings.free_trial_faq_box_bullet_4_heading,
                                    subtext: strings.free_trial_faq_box_bullet_4_content
                                },
                                {
                                    heading: strings.free_trial_faq_box_bullet_5_heading,
                                    subtext: strings.free_trial_faq_box_bullet_5_content
                                },
                                {
                                    heading: strings.free_trial_faq_box_bullet_6_heading,
                                    subtext: strings.free_trial_faq_box_bullet_6_content
                                },
                                {
                                    heading: strings.free_trial_faq_box_bullet_7_heading,
                                    subtext: strings.free_trial_faq_box_bullet_7_content
                                }
                            ],
                            pricingAndReturns: [
                                {
                                    heading: strings.pricingAndReturns_faq_box_bullet_1_heading,
                                    subtext: strings.pricingAndReturns_faq_box_bullet_1_content
                                },
                                {
                                    heading: strings.pricingAndReturns_faq_box_bullet_2_heading,
                                    subtext: strings.pricingAndReturns_faq_box_bullet_2_content
                                },
                                {
                                    heading: strings.pricingAndReturns_faq_box_bullet_3_heading,
                                    subtext: strings.pricingAndReturns_faq_box_bullet_3_content
                                },
                                {
                                    heading: strings.pricingAndReturns_faq_box_bullet_4_heading,
                                    subtext: strings.pricingAndReturns_faq_box_bullet_4_content
                                },
                                {
                                    heading: strings.pricingAndReturns_faq_box_bullet_5_heading,
                                    subtext: strings.pricingAndReturns_faq_box_bullet_5_content
                                },
                                {
                                    heading: strings.pricingAndReturns_faq_box_bullet_6_heading,
                                    subtext: strings.pricingAndReturns_faq_box_bullet_6_content
                                }
                            ],
                            technical: [
                                {
                                    heading: strings.technical_faq_box_bullet_1_heading,
                                    subtext: strings.technical_faq_box_bullet_1_content
                                },
                                {
                                    heading: strings.technical_faq_box_bullet_2_heading,
                                    subtext: strings.technical_faq_box_bullet_2_content
                                },
                                {
                                    heading: strings.technical_faq_box_bullet_3_heading,
                                    subtext: strings.technical_faq_box_bullet_3_content
                                },
                                {
                                    heading: strings.technical_faq_box_bullet_4_heading,
                                    subtext: strings.technical_faq_box_bullet_4_content
                                },
                                {
                                    heading: strings.technical_faq_box_bullet_5_heading,
                                    subtext: strings.technical_faq_box_bullet_5_content
                                },
                                {
                                    heading: strings.technical_faq_box_bullet_6_heading,
                                    subtext: strings.technical_faq_box_bullet_6_content
                                },
                                {
                                    heading: strings.technical_faq_box_bullet_7_heading,
                                    subtext: strings.technical_faq_box_bullet_7_content
                                },
                                {
                                    heading: strings.technical_faq_box_bullet_8_heading,
                                    subtext: strings.technical_faq_box_bullet_8_content
                                },
                                {
                                    heading: strings.technical_faq_box_bullet_9_heading,
                                    subtext: strings.technical_faq_box_bullet_9_content
                                },
                                {
                                    heading: strings.technical_faq_box_bullet_10_heading,
                                    subtext: strings.technical_faq_box_bullet_10_content
                                }
                            ]
                        }
                    }
                ],
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                email_collection_bar: email_collection_bar$7()
            }
        };
    }
    return pageConfig;
};

var consumer_product_footer_config = ({ strings }) => ({
    visible: true,
    cta: {
        visible: false,
        contact_modal: false,
        email_capture: true,
        market: "us",
        domain: ".com",
        vertical: "consumer",
        page: "home",
        main_label: strings.footer_cta_email_main_label,
        sub_label: strings.footer_cta_email_sub_label,
        button_label: strings.footer_cta_email_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        email_placeholder: strings.footer_cta_email_button
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_buy_label,
                links: [
                    {
                        visible: true,
                        destination: "/buy-spanish/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_spanish_label
                    },
                    {
                        visible: true,
                        destination: "/buy-french/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_french_label
                    },
                    {
                        visible: true,
                        destination: "/buy-italian/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_italian_label
                    },
                    {
                        visible: true,
                        destination: "/buy-german/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_german_label
                    },
                    {
                        visible: true,
                        destination: "/buy-english/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_english_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/idiomas/comprar-ingles/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_ingles_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_espanol_label
                    },
                    {
                        visible: true,
                        destination: "/homeschool/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_homeschool_label
                    },
                    {
                        visible: true,
                        destination: "https://pt.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_portugues_label
                    }
                ]
            },
            {
                label: strings.footer_menu_start_label,
                links: [
                    {
                        visible: true,
                        destination: "/tryitnow/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_demo_label
                    },
                    {
                        visible: true,
                        destination: "/product-activation/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_activation_label
                    },
                    {
                        visible: true,
                        destination: "/product/mobile-apps/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_mobile_label
                    },
                    {
                        visible: true,
                        destination: "/product/reviews/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_reviews_label
                    },
                    {
                        visible: true,
                        destination: "/enterprise/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "//blog.rosettastone.com",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_blog_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "/about/company/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_k12_reading_label
                    },
                    {
                        visible: true,
                        destination: "/careers/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "//support.rosettastone.com/en/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "/product/faq/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "/contact/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_contact_us_label
                    },
                    {
                        visible: false,
                        destination: "/legal/accessibility/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_accessibility_statement_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "https://www.rosettastone.com/anti-piracy/"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    label: "Facebook",
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    label: "Twitter",
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    label: "Instagram",
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    label: "^YouTube",
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var email_collection_bar$6 = () => {
    return {
        visible: true,
        dataQa: "email collection bar",
        website: "US_WEBSITE",
        demo_type: "offer_signup",
        newsletter_type: "footer_signup",
        language: "ENG",
        button: {
            text: "Sign up",
            theme: "yellow_black",
            size: "mini"
        },
        email_field: {
            placeholder: "Email Address",
            id: "email",
            name: "email"
        },
        subtitle: {
            content: "Get Rosetta Stone news and offers.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        success_message: {
            content: "Thanks for signing up.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        error_message: {
            content: "E-mail is invalid.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        title: {
            content: "Sign up to stay in touch.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        legal: {
            content: "By signing up, I agree to the",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        legal_link: {
            destination: "",
            label: "terms and conditions",
            theme: "white",
            underline: "on"
        },
        privacy_tooltip: {
            title: {
                type: "card-title",
                theme: "white",
                content: "Terms and Conditions",
                align: "center"
            },
            body: {
                align: "left",
                theme: "white",
                dangerous: false,
                content: (React__default.createElement("div", null,
                    "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\u00A0",
                    React__default.createElement("a", { href: "https://www.rosettastone.com/privacy", title: "Privacy Policy", target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy"),
                    ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \u00A0",
                    React__default.createElement("a", { href: "mailto: privacyofficer@rosettastone.com", title: "privacyofficer@rosettastone.com", target: "_blank", rel: "noopener noreferrer" }, "privacyofficer@rosettastone.com"),
                    "."))
            }
        }
    };
};

const consumer_seo_pages_config$2 = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "seo-basic") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                trustpilot: true,
                lang: "en"
            },
            content: {
                free_trial_banner: {
                    visible: true,
                    button: {
                        theme: "blue_white",
                        destination: "https://www.rosettastone.com/buy",
                        text: "BUY NOW"
                    }
                },
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                email_collection_bar: email_collection_bar$6()
            }
        };
    }
    return pageConfig;
};

var consumer_seo_footer_config$2 = ({ strings }) => ({
    visible: true,
    cta: {
        visible: false,
        contact_modal: false,
        email_capture: true,
        market: "us",
        domain: ".com",
        vertical: "consumer",
        page: "home",
        main_label: strings.footer_cta_email_main_label,
        sub_label: strings.footer_cta_email_sub_label,
        button_label: strings.footer_cta_email_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        email_placeholder: strings.footer_cta_email_button
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_buy_label,
                links: [
                    {
                        visible: true,
                        destination: "/buy-spanish/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_spanish_label
                    },
                    {
                        visible: true,
                        destination: "/buy-french/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_french_label
                    },
                    {
                        visible: true,
                        destination: "/buy-italian/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_italian_label
                    },
                    {
                        visible: true,
                        destination: "/buy-german/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_german_label
                    },
                    {
                        visible: true,
                        destination: "/buy-english/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_english_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/idiomas/comprar-ingles/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_ingles_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_espanol_label
                    },
                    {
                        visible: true,
                        destination: "/homeschool/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_homeschool_label
                    },
                    {
                        visible: true,
                        destination: "https://pt.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_portugues_label
                    }
                ]
            },
            {
                label: strings.footer_menu_start_label,
                links: [
                    {
                        visible: true,
                        destination: "/tryitnow/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_demo_label
                    },
                    {
                        visible: true,
                        destination: "/product-activation/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_activation_label
                    },
                    {
                        visible: true,
                        destination: "/product/mobile-apps/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_mobile_label
                    },
                    {
                        visible: true,
                        destination: "/product/reviews/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_reviews_label
                    },
                    {
                        visible: true,
                        destination: "/enterprise/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "//blog.rosettastone.com",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_blog_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "/about/company/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_k12_reading_label
                    },
                    {
                        visible: true,
                        destination: "/careers/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "//support.rosettastone.com/en/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "/product/faq/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "/contact/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_contact_us_label
                    },
                    {
                        visible: false,
                        destination: "/legal/accessibility/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_accessibility_statement_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "https://www.rosettastone.com/anti-piracy/"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    label: "Facebook",
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    label: "Twitter",
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    label: "Instagram",
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    label: "^YouTube",
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var consumer_product_activation_footer_config$6 = (function (_ref) {
  var strings = _ref.strings;
  return {
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: false,
        label: strings.footer_meta_cookie_settings_label,
        destination: "https://www.rosettastone.com/anti-piracy/"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.com/terms/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.com/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: true,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      // region was deleted
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          label: "Facebook",
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          label: "Twitter",
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          label: "Instagram",
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          label: "^YouTube",
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var consumer_product_activation_pages_config$6 = (function (_ref) {
  var page = _ref.page;

  switch (page) {
    case "product-activation":
      return {
        page: page,
        helmet: {
          meta_title: "Rosetta Stone® - Online Subscription Product Activation",
          meta_description: "Activate your Rosetta Stone® language learning online subscription products.",
          canonical_url: "https://rosettastone.com/product/product-activation/",
          lang: "en"
        }
      };

    default:
      return null;
  }
});

var education_homeschool_nav_secondary_config = ({ strings }) => ({
    visible: false,
    blog: {
        visible: true,
        destination: "https://educationblog.rosettastone.com/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_homeschool_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_homeschool_home_label
    },
    resources: {
        visible: false,
        destination: "/resources/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_homeschool_resources_label
    },
    solutions: {
        visible: false,
        destination: "/solutions/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_homeschool_solutions_label
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_homeschool_label
    }
});

var email_collection_bar$5 = () => {
    return {
        visible: true,
        dataQa: "email collection bar",
        website: "US_WEBSITE",
        formUrl: "HOMESCHOOL_HOMEPAGE_FOOTER",
        demo_type: "lead_gen_popup",
        newsletter_type: "Top_Homeschool_Footer",
        language: "ENG",
        button: {
            text: "Sign up",
            theme: "yellow_black",
            size: "mini"
        },
        email_field: {
            placeholder: "Email Address",
            id: "email",
            name: "email"
        },
        subtitle: {
            content: "and promotional emails to receive homeschooling tips.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        success_message: {
            content: "Thanks for signing up.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        error_message: {
            content: "E-mail is invalid.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        title: {
            content: "Sign up for our e‑Newsletter",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        legal: {
            content: "By signing up, I agree to the",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        legal_link: {
            destination: "https://www.rosettastone.com/terms/",
            label: "terms and conditions",
            theme: "white",
            underline: "on"
        },
        privacy_tooltip: {
            title: {
                type: "card-title",
                theme: "white",
                content: "Terms and Conditions",
                align: "center"
            },
            body: {
                align: "left",
                theme: "white",
                dangerous: false,
                content: (React__default.createElement("div", null,
                    "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\u00A0",
                    React__default.createElement("a", { href: "https://www.rosettastone.com/privacy", title: "Privacy Policy", target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy"),
                    ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \u00A0",
                    React__default.createElement("a", { href: "mailto: privacyofficer@rosettastone.com", title: "privacyofficer@rosettastone.com", target: "_blank", rel: "noopener noreferrer" }, "privacyofficer@rosettastone.com"),
                    "."))
            }
        }
    };
};

const education_homeschool_pages_config = ({ page }) => {
    let pageConfig = null;
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Homeschool Curriculum | Rosetta Stone® Homeschool",
                meta_description: "Rosetta Stone® Homeschool is the #1 language-learning tool for homeschooling. Add English to your homeschoolers language arts curriculum & lesson plans!",
                canonical_url: "https://www.rosettastone.com/homeschool/",
                trustpilot: true,
                lang: "en"
            },
            content: {
                hero: {
                    title: {
                        theme: "green",
                        type: "page-title",
                        align: "left",
                        content: "Built for Homeschoolers"
                    },
                    subtitle: {
                        theme: "black",
                        type: "page-sub-title",
                        align: "left",
                        content: "Language learning that fits into your curriculum"
                    },
                    body: {
                        content: `Designed with your child's success in mind, Rosetta Stone Homeschool is the effective way to bring a
                    foreign language curriculum home, providing long-term retention and a critical lifelong skill in
                    today's world.`
                    },
                    cta_1: {
                        destination: "https://www.rosettastone.com/tryitnow?homeschool",
                        internal: false,
                        theme: "yellow_black",
                        text: "Start Practicing"
                    },
                    cta_2: {
                        destination: "https://www.rosettastone.com/lp/sbsr/sitewide-hs/",
                        internal: false,
                        theme: "black_yellow",
                        text: "Buy Now"
                    }
                },
                features: {
                    layout: "list",
                    panels: [
                        {
                            body: {
                                content: "Rosetta Stone Homeschool is designed with your child's success in mind. Trusted around the world, our technology promotes long-term retention and correct pronunciation—without memorization or drills."
                            },
                            custom: {
                                list: [
                                    {
                                        heading: "An immersion method that works.",
                                        content: "Rosetta Stone teaches language the natural way—no translation required."
                                    },
                                    {
                                        heading: "The most advanced speech technology.",
                                        content: "TruAccent® speech-recognition technology listens, analyzes, and corrects your child's speech throughout the learning process."
                                    },
                                    {
                                        heading: "Enhanced reporting and monitoring tools.",
                                        content: "Keep your child on track with printable reports and lesson progress data."
                                    },
                                    {
                                        heading: "Access across devices and offline.",
                                        content: "Your child can learn from a computer, tablet, or mobile phone. When an Internet connection isn't available, you can easily download lessons with the Audio Companion feature."
                                    }
                                ]
                            },
                            data_qa: null,
                            direction: "image-left",
                            image: {
                                alt: "Rosetta Stone Homeschool",
                                src: null,
                                height: "100%",
                                width: "100%"
                            },
                            title: {
                                content: "Rosetta Stone Homeschool",
                                type: "section-title",
                                heading: "h2",
                                theme: "black",
                                align: "left"
                            }
                        }
                    ]
                },
                cyberweek_banner: {
                    visible: false,
                    text: "Cyber Week only! Get a lifetime subscription in any language for just $149",
                    button: {
                        destination: "https://rosettastone.com/lp/sbsr/sitewide-hs-holiday",
                        text: "Buy Now"
                    }
                },
                email_collection_bar: email_collection_bar$5()
            }
        };
    }
    return pageConfig;
};

var education_homeschool_footer_config = ({ strings }) => ({
    visible: true,
    cta: {
        visible: false,
        contact_modal: true,
        email_capture: false,
        market: "us",
        domain: ".com",
        vertical: "k12",
        page: "home",
        main_label: "Get the language learning support you need. Connect with us today.",
        sub_label: "Please fill out the form below and we'll follow up with you right away.",
        button_label: strings.footer_cta_pricing_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        form_firstname: strings.footer_cta_form_firstname,
        form_lastname: strings.footer_cta_form_lastname,
        form_email: strings.footer_cta_form_email,
        form_phone: strings.footer_cta_form_phone,
        form_country: strings.footer_cta_form_country,
        form_organization: strings.footer_cta_form_organization,
        form_organizationsize_100: strings.footer_cta_form_organizationsize_100,
        form_organizationsize_500: strings.footer_cta_form_organizationsize_500,
        form_organizationsize_1000: strings.footer_cta_form_organizationsize_1000,
        form_organizationsize_5000: strings.footer_cta_form_organizationsize_5000,
        form_organizationsize_10000: strings.footer_cta_form_organizationsize_10000,
        form_organizationsize_25000: strings.footer_cta_form_organizationsize_25000,
        form_organizationsize_50000: strings.footer_cta_form_organizationsize_50000,
        form_organizationsize_more: strings.footer_cta_form_organizationsize_more,
        form_organizationsize: strings.footer_cta_form_organizationsize,
        form_role: strings.footer_cta_form_role,
        form_role_individualcontributor: strings.footer_cta_form_role_individualcontributor,
        form_role_manager: strings.footer_cta_form_role_manager,
        form_role_executive: strings.footer_cta_form_role_executive,
        form_role_vicepresident: strings.footer_cta_form_role_vicepresident,
        form_role_director: strings.footer_cta_form_role_director,
        form_role_teacher: strings.footer_cta_form_role_teacher,
        form_role_techcoordinator: strings.footer_cta_form_role_techcoordinator,
        form_role_curriculumdirector: strings.footer_cta_form_role_curriculumdirector,
        form_role_principal: strings.footer_cta_form_role_principal,
        form_role_boardmember: strings.footer_cta_form_role_boardmember,
        form_role_superintendent: strings.footer_cta_form_role_superintendent,
        form_comments: strings.footer_cta_form_comments,
        form_submit: strings.footer_cta_form_submit,
        form_pricing_thanks: strings.footer_cta_form_pricing_thanks
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_learn_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/languages/online-homeschool-curriculum/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_online_curriculum_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/languages/online-homeschool-curriculum-foreign-language/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_foreign_curriculum_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/languages/online-homeschool-program/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_homeschool_program_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/languages/homeschool-travel/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_homeschool_travel_label
                    }
                ]
            },
            {
                label: strings.footer_menu_start_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/lp/sbsr/sitewide-hs/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_buy_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/languages/resellers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_start_homeschool_retailers_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_contact_us_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/product/faq/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/en/personal/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: false,
                        destination: "https://www.rosettastone.com/legal/accessibility/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_accessibility_statement_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

const education_students_pages_config = ({ page }) => {
    let pageConfig = null;
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Rosetta Stone for Students | Rosetta Stone®",
                meta_description: "Make your kids' language learning easy and convenient while they're at home. Learn a language on your family's schedule with the flexibility you need, from anywhere.",
                canonical_url: "https://www.rosettastone.com/students/",
                trustpilot: true,
                lang: "en"
            },
            content: {
                hero: {
                    title: {
                        theme: "black",
                        type: "page-title",
                        align: "left",
                        content: "Rosetta Stone for Students"
                    },
                    subtitle: {
                        theme: "black",
                        type: "page-sub-title",
                        align: "left",
                        content: "Real language learning, with the flexibility you need."
                    },
                    body: {
                        content: `Boost your kids' language skills while they're at home. Our 25+ years of online language education experience makes their at-home learning easy and convenient.`
                    },
                    cta_1: {
                        destination: "https://www.rosettastone.com/students/freetrial/",
                        internal: false,
                        theme: "transparent_black",
                        text: "START A 3‑DAY FREE TRIAL"
                    },
                    cta_2: {
                        destination: "https://www.rosettastone.com/lp/sbsr/students/",
                        internal: false,
                        theme: "blue_white",
                        text: "Buy Now"
                    }
                },
                features: {
                    layout: "list",
                    panels: [
                        {
                            custom: {
                                listOneTitle: "What does this subscription include?",
                                listOne: [
                                    {
                                        heading: "",
                                        content: "Progress monitoring tools, so you can see how your student is advancing"
                                    },
                                    {
                                        heading: "",
                                        content: "Offline connectivity for distraction-free learning"
                                    },
                                    {
                                        heading: "",
                                        content: "Learn on your family's own schedule, from any device"
                                    }
                                ],
                                listTwoTitle: "What does this subscription include?",
                                listTwo: [
                                    {
                                        heading: "",
                                        content: "Progress monitoring tools, so you can see how your student is advancing"
                                    },
                                    {
                                        heading: "",
                                        content: "Offline connectivity for distraction-free learning"
                                    },
                                    {
                                        heading: "",
                                        content: "Learn on your family's own schedule, from any device"
                                    }
                                ]
                            },
                            data_qa: null,
                            direction: "image-left",
                            image: {
                                alt: "Rosetta Stone Students",
                                src: null,
                                height: "100%",
                                width: "100%"
                            },
                            title: {
                                content: "Rosetta Stone Students",
                                type: "section-title",
                                heading: "h2",
                                theme: "black",
                                align: "left"
                            }
                        }
                    ]
                },
                quotes: {
                    sectionTitle: "What school districts are saying:",
                    quote: [
                        {
                            content: `" The Rosetta Stone solution allows us to provide the perfect opportunity for our learners to experience self-paced language learning and monitoring for success. Additionally, it allowed the integration of technology and capitalized on student interests."`,
                            attribute: "–Dr. Karen Broadnax, Director ESL Program, Little Rock School District, AK"
                        },
                        {
                            content: `"We can serve any learner anywhere as long as we have an internet connection, and that's exciting!"`,
                            attribute: "–Summer Reel, Lead Teacher, Guthrie Virtual School, TX"
                        },
                        {
                            content: `"Good, quality foreign language educators are few and far between in a rural district, but in today's world, it's essential to understand other languages. Because of this deficit, we needed a program that could create and maximize language learning opportunities for our students."`,
                            attribute: "–Trenton Tallman, Learning Lab Instructor, Scotland County R-1 School District"
                        }
                    ]
                },
                cyberweek_banner: {
                    visible: false,
                    text: "Cyber Week only! Get a lifetime subscription in any language for just $149",
                    button: {
                        destination: "https://rosettastone.com/lp/sbsr/sitewide-hs-holiday",
                        text: "Buy Now"
                    }
                }
            }
        };
    }
    return pageConfig;
};

var education_students_footer_config = ({ strings }) => ({
    visible: true,
    cta: {
        visible: false,
        contact_modal: false,
        email_capture: true,
        market: "us",
        domain: ".com",
        vertical: "consumer",
        page: "home",
        main_label: strings.footer_cta_email_main_label,
        sub_label: strings.footer_cta_email_sub_label,
        button_label: strings.footer_cta_email_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        email_placeholder: strings.footer_cta_email_button
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_buy_label,
                links: [
                    {
                        visible: true,
                        destination: "/buy-spanish/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_spanish_label
                    },
                    {
                        visible: true,
                        destination: "/buy-french/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_french_label
                    },
                    {
                        visible: true,
                        destination: "/buy-italian/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_italian_label
                    },
                    {
                        visible: true,
                        destination: "/buy-german/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_german_label
                    },
                    {
                        visible: true,
                        destination: "/buy-english/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_buy_english_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/comprar-ingles/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_ingles_label
                    },
                    {
                        visible: true,
                        destination: "//espanol.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_espanol_label
                    },
                    {
                        visible: true,
                        destination: "/homeschool/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_homeschool_label
                    },
                    {
                        visible: true,
                        destination: "https://pt.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_buy_portugues_label
                    }
                ]
            },
            {
                label: strings.footer_menu_start_label,
                links: [
                    {
                        visible: true,
                        destination: "/tryitnow/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_demo_label
                    },
                    {
                        visible: true,
                        destination: "/product-activation/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_activation_label
                    },
                    {
                        visible: true,
                        destination: "/product/mobile-apps/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_mobile_label
                    },
                    {
                        visible: true,
                        destination: "/product/reviews/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_reviews_label
                    },
                    {
                        visible: true,
                        destination: "/enterprise/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "//blog.rosettastone.com",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_start_blog_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "/about/company/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "/k12/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_k12_reading_label
                    },
                    {
                        visible: true,
                        destination: "/careers/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "//support.rosettastone.com/en/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "/product/faq/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "/contact/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_contact_us_label
                    },
                    {
                        visible: false,
                        destination: "/legal/accessibility/",
                        external: false,
                        new_window: false,
                        label: strings.footer_menu_support_accessibility_statement_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "https://www.rosettastone.com/anti-piracy/"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    label: "Facebook",
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    label: "Twitter",
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    label: "Instagram",
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    label: "^YouTube",
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var email_collection_bar$4 = () => {
    return {
        visible: true,
        dataQa: "email collection bar",
        website: "US_WEBSITE",
        formUrl: "HOMESCHOOL_HOMEPAGE_FOOTER",
        demo_type: "offer_signup",
        newsletter_type: "Top_Homeschool_Footer",
        language: "ENG",
        button: {
            text: "Sign up",
            theme: "yellow_black",
            size: "mini"
        },
        email_field: {
            placeholder: "Email Address",
            id: "email",
            name: "email"
        },
        subtitle: {
            content: "and promotional emails to receive homeschooling tips.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        success_message: {
            content: "Thanks for signing up.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        error_message: {
            content: "E-mail is invalid.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        title: {
            content: "Sign up for our e‑Newsletter",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        },
        legal: {
            content: "By signing up, I agree to the",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        legal_link: {
            destination: "https://www.rosettastone.com/terms/",
            label: "terms and conditions",
            theme: "white",
            underline: "on"
        },
        privacy_tooltip: {
            title: {
                type: "card-title",
                theme: "white",
                content: "Terms and Conditions",
                align: "center"
            },
            body: {
                align: "left",
                theme: "white",
                dangerous: false,
                content: (React__default.createElement("div", null,
                    "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\u00A0",
                    React__default.createElement("a", { href: "https://www.rosettastone.com/privacy", title: "Privacy Policy", target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy"),
                    ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \u00A0",
                    React__default.createElement("a", { href: "mailto: privacyofficer@rosettastone.com", title: "privacyofficer@rosettastone.com", target: "_blank", rel: "noopener noreferrer" }, "privacyofficer@rosettastone.com"),
                    "."))
            }
        }
    };
};

var verticals$h = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_enterprise,
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/enterprise/"
            },
            name: strings.verticals_enterprise,
            title: {
                content: strings.verticals_enterprise,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_education_secondary,
                src: verticals$q.educationSecondaryCirclePng
            },
            link: {
                destination: "/highereducation/"
            },
            name: strings.verticals_education_secondary,
            title: {
                content: strings.verticals_education_secondary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_publicsector,
                src: verticals$q.publicsectorCirclePng
            },
            link: {
                destination: "/publicsector/"
            },
            name: strings.verticals_publicsector,
            title: {
                content: strings.verticals_publicsector,
                type: "card-title"
            }
        }
    ]
});

const education_homeschool_seo_pages_config = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "seo-basic") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Homeschool Curriculum | Rosetta Stone® Homeschool",
                meta_description: "Rosetta Stone® Homeschool is the #1 language-learning tool for homeschooling. Add English to your homeschoolers language arts curriculum & lesson plans!",
                canonical_url: "https://www.rosettastone.com/homeschool/",
                trustpilot: true,
                lang: "en"
            },
            content: {
                free_trial_banner: {
                    visible: true,
                    button: {
                        theme: "blue_white",
                        destination: "https://www.rosettastone.com/homeschool/free-trial/?ocid=seo-stickyhs",
                        text: "Start Free Trial"
                    }
                },
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$h({ strings }),
                email_collection_bar: email_collection_bar$4()
            }
        };
    }
    return pageConfig;
};

var education_homeschool_seo_footer_config = ({ strings }) => ({
    visible: true,
    cta: {
        visible: false,
        contact_modal: true,
        email_capture: false,
        market: "us",
        domain: ".com",
        vertical: "k12",
        page: "home",
        main_label: "Get the language learning support you need. Connect with us today.",
        sub_label: "Please fill out the form below and we'll follow up with you right away.",
        button_label: strings.footer_cta_pricing_button,
        form_title: strings.footer_cta_pricing_title,
        form_subtitle: strings.footer_cta_pricing_subtitle,
        form_firstname: strings.footer_cta_form_firstname,
        form_lastname: strings.footer_cta_form_lastname,
        form_email: strings.footer_cta_form_email,
        form_phone: strings.footer_cta_form_phone,
        form_country: strings.footer_cta_form_country,
        form_organization: strings.footer_cta_form_organization,
        form_organizationsize_100: strings.footer_cta_form_organizationsize_100,
        form_organizationsize_500: strings.footer_cta_form_organizationsize_500,
        form_organizationsize_1000: strings.footer_cta_form_organizationsize_1000,
        form_organizationsize_5000: strings.footer_cta_form_organizationsize_5000,
        form_organizationsize_10000: strings.footer_cta_form_organizationsize_10000,
        form_organizationsize_25000: strings.footer_cta_form_organizationsize_25000,
        form_organizationsize_50000: strings.footer_cta_form_organizationsize_50000,
        form_organizationsize_more: strings.footer_cta_form_organizationsize_more,
        form_organizationsize: strings.footer_cta_form_organizationsize,
        form_role: strings.footer_cta_form_role,
        form_role_individualcontributor: strings.footer_cta_form_role_individualcontributor,
        form_role_manager: strings.footer_cta_form_role_manager,
        form_role_executive: strings.footer_cta_form_role_executive,
        form_role_vicepresident: strings.footer_cta_form_role_vicepresident,
        form_role_director: strings.footer_cta_form_role_director,
        form_role_teacher: strings.footer_cta_form_role_teacher,
        form_role_techcoordinator: strings.footer_cta_form_role_techcoordinator,
        form_role_curriculumdirector: strings.footer_cta_form_role_curriculumdirector,
        form_role_principal: strings.footer_cta_form_role_principal,
        form_role_boardmember: strings.footer_cta_form_role_boardmember,
        form_role_superintendent: strings.footer_cta_form_role_superintendent,
        form_comments: strings.footer_cta_form_comments,
        form_submit: strings.footer_cta_form_submit,
        form_pricing_thanks: strings.footer_cta_form_pricing_thanks
    },
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_learn_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/languages/online-homeschool-curriculum/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_online_curriculum_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/languages/online-homeschool-curriculum-foreign-language/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_foreign_curriculum_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/languages/online-homeschool-program/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_homeschool_program_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/languages/homeschool-travel/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_homeschool_travel_label
                    }
                ]
            },
            {
                label: strings.footer_menu_start_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/lp/sbsr/sitewide-hs/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_buy_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/languages/resellers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_start_homeschool_retailers_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_contact_us_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/product/faq/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/en/personal/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: false,
                        destination: "https://www.rosettastone.com/legal/accessibility/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_accessibility_statement_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var education_primary_nav_secondary_config$5 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: true,
        destination: "https://educationblog.rosettastone.com/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
        visible: true,
        destination: "/resources/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
        visible: true,
        destination: "/solutions/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_solutions_label,
        options: [
            {
                link: "/solutions/k12-english-language/",
                label: strings.nav_secondary_education_primary_solutions_k12_english_language
            },
            {
                link: "/solutions/world-languages/",
                label: strings.nav_secondary_education_primary_solutions_world_languages
            }
        ]
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_label
    }
});

var lead_generation_bar$h = () => {
    return {
        visible: true,
        dataQa: "lead generation bar",
        lead_generation_button: {
            schedule_appointment: false,
            button: {
                destination: "/pricing-request/",
                new_window: false,
                size: "regular",
                text: "Request Pricing",
                theme: "yellow_black"
            }
        },
        subtitle: {
            content: "",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        title: {
            content: "Get the language learning support you need. Connect with us today.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        }
    };
};

var quote_carousel = () => {
    return {
        data_qa: "Section 6 - Quotes",
        visible: true,
        layout: "carousel",
        title: {
            align: "center",
            content: "Trusted for 25+ years by schools nationwide",
            heading: "h2",
            theme: "black",
            type: "section-title"
        },
        panels: [
            {
                quote: "Rosetta Stone English meets my students’ needs by allowing them to practice and get immediate feedback in a safe setting. When students are struggling, the lessons are terrific.",
                attribution: "Mary Doerr, ESL Specialist at Lincoln Elementary, Wenatchee Public Schools, WA"
            },
            {
                quote: "Students were surprised to see such a diversity of characters they could select. They can relate to the characters, yet it’s interesting to see they are choosing characters of different backgrounds—not just their own.",
                attribution: "Caitlin McHugh, Director of English as a Second Language, Boston Collegiate Charter School, MA"
            },
            {
                quote: "I would definitely recommend Rosetta Stone English to other educators! We’ve been searching for ways to provide more engaging, targeted lessons to our English learners, and I believe Rosetta Stone English achieves that.",
                attribution: "Courtney Bradley, Culture and Data Coordinator, Soleil Academy, CA"
            }
        ]
    };
};

var copyData$5 = () => ({
    about_us: "About Us",
    about_us_url: "/about",
    agreements: "Agreements",
    agreements_url: "https://www.rosettastone.com/legal/agreements",
    almost_there: "Almost there!",
    american: " (American)",
    anti_piracy: "Anti-Piracy",
    anti_piracy_url: "https://www.rosettastone.com/anti-piracy",
    arabic: "Arabic",
    award_section_header: "Trusted for 25+ years by top organizations.",
    blog_url: "https://blog.rosettastone.com/",
    brasil: "Brasil",
    brasil_url: "https://www.rosettastonebrasil.com/",
    brazil: "(Brazil)",
    british: " (British)",
    business_contact_title: "Enterprise - Request Pricing",
    careers: "Careers",
    careers_url: "https://www.rosettastone.com/careers",
    cart_checkout: "Checkout",
    cart_checkout_url: "https://secure.rosettastone.com/us_en_store_view/checkout/cart/",
    cart_discount: "Discount:",
    cart_empty: "Your cart is currently empty.",
    cart_in_your_cart: "in your cart.",
    cart_subtotal: "Subtotal:",
    cart_summary: "Order Summary:",
    cart_total: "Total (pre-tax):",
    cart_you_have: "You have",
    change_region: "Change Region:",
    china: "中国",
    china_url: "http://www.rosettastone.cn/",
    combined_resources_url: "https://www.rosettastone.com/business/resources/",
    company: "Company",
    connect: "Connect with us:",
    consumer_home: "Consumer Home",
    contact: "Contact",
    contact_description: "Request Pricing Form",
    contact_ee_url: "/contact/",
    contact_url: "https://www.rosettastone.com/contact/",
    cta_bar: "Ready to begin your organization’s complete language journey?",
    cta_h2: "Ready to begin your organization’s complete language journey?",
    cta_text: "Request Pricing",
    currency: "$",
    demo_pricing_subtitle_business: "Discover how our enterprise solutions can help your company attract talent and improve productivity. Fill out the form below and we'll be in touch soon.",
    demo_pricing_subtitle_hed: "Discover how our higher ed solutions can help your learners speak a new language with confidence. Fill out the form below and we'll be in touch soon.",
    demo_pricing_subtitle_k12: "Discover how our K-12 solutions can help your English and World Language learners speak with confidence. Fill out the form below and we'll be in touch soon.",
    demo_pricing_subtitle_pub: "Discover how our public sector solutions can improve communications with those you serve. Fill out the form below and we'll be in touch soon.",
    demo_pricing_title: "Get a free consultation",
    deutschland: "Deutschland",
    deutschland_url: "https://www.rosettastone.de/",
    download_pdf: "Download PDF",
    dutch: "Dutch",
    english: "English",
    espana: "España",
    espana_url: "https://www.rosettastone.es/",
    europe: "Europe",
    europe_url: "https://www.rosettastone.eu/",
    facebook_url: "https://www.facebook.com/RosettaStone",
    faq_url: "/faq",
    faqs: "FAQs",
    farsi: " (Farsi)",
    filipino: "Filipino",
    for_business: "For Enterprise",
    for_business_resources_url: "https://www.rosettastone.com/business/resources/",
    for_business_solutions_url: "https://www.rosettastone.com/business/solutions/",
    for_business_url: "https://www.rosettastone.com/business/home/",
    for_educators: "For Schools",
    for_educators_resources_url: "https://www.rosettastone.com/k12/resources",
    for_educators_solutions_url: "https://www.rosettastone.com/k12/solutions/",
    for_educators_url: "https://www.rosettastone.com/k12/home/",
    for_hed: "For Higher Education",
    for_homeschool: "For Homeschool",
    for_homeschool_url: "https://www.rosettastone.com/homeschool/",
    for_individuals: "For Individuals",
    for_individuals_url: "/",
    for_organizations: "For Organizations",
    for_public_sector: "For Public Sector",
    for_public_sector_url: "/publicsector",
    for_you: "For You",
    form_100: "100 or Less",
    form_500: "101 - 500",
    form_1000: "501 - 1,000",
    form_5000: "1,001 - 5,000",
    form_10000: "5,001 - 10,000",
    form_25000: "10,001 - 25,000",
    form_50000: "25,001 - 50,000",
    form_boardmember: "Board Member",
    form_curriculumdirector: "Curriculum Director/Instruction Coordinator",
    form_director: "Director",
    form_email: "Email Address",
    form_executive: "General Management/Executive",
    form_firstname: "First Name",
    form_how_blog: "Blog",
    form_how_email: "Email",
    form_how_event: "Event",
    form_how_online: "Online Ad",
    form_how_other: "Other",
    form_how_referral: "Referral",
    form_how_search: "Search Engine",
    form_how_social: "Social Media",
    form_how_title: "How did you hear about us? (Optional)",
    form_how_webinar: "Webinar",
    form_individualcontributor: "Individual Contributor",
    form_lastname: "Last Name",
    form_manager: "Manager",
    form_more: "50,001 - More",
    form_organization: "Organization Name",
    form_organizationsize: "Organization Size",
    form_phone: "Phone Number (Optional)",
    form_principal: "Principal/Vice Principal",
    form_privacy1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's",
    form_privacy2: "Privacy Policy",
    form_privacy3: "I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at",
    form_privacy4: ".",
    form_privacyUrl: "https://www.rosettastone.com/privacy",
    form_privacyemail: "privacyofficer@rosettastone.com",
    form_role: "Role (or title)",
    form_submit: "Submit",
    form_superintendent: "Superintendent/District Administrator",
    form_teacher: "Teacher",
    form_techcoordinator: "Technology Coordinator",
    form_updateagreement1: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
    form_updateagreement2: "here",
    form_updateagreement3: "for more information.",
    form_vicepresident: "Vice President",
    france: "France",
    france_url: "https://www.rosettastone.fr/",
    google_plus_url: "https://plus.google.com/+RosettaStone",
    greek: "Greek",
    gtm_id: null,
    has_combined_resources: null,
    has_resources: true,
    hebrew: "Hebrew",
    helpful_links: "Please check your URL or connect with one of these helpful links:",
    hide_cart: null,
    hide_contact: null,
    hide_espanol: null,
    hide_language: null,
    hide_search: null,
    hide_support: null,
    hindi: "Hindi",
    home: "Home",
    home_link: "/home/",
    home_url: "https://www.rosettastone.com/",
    instagram_url: "https://www.instagram.com/rosettastone",
    investors: "Investors",
    investors_url: "https://investors.rosettastone.com/",
    irish: "Irish",
    italia: "Italia",
    italia_url: "https://www.rosettastone.it/",
    item: "item",
    item_plural: "items",
    japan: "日本",
    japan_url: "http://www.rosettastone.co.jp",
    japanese: "Japanese",
    k12_contact_title: "K12 Request Pricing",
    keep_exploring: "Keep Exploring",
    korea: "대한민국",
    korea_url: "https://www.rosettakorea.com/",
    korean: "Korean",
    latin: "Latin",
    latin_america: " (Latin America)",
    latin_america_region: "America Latina",
    latin_america_region_url: "https://espanol.rosettastone.com/",
    learn_arabic_url: "/buy-arabic/",
    learn_chinese: "Chinese",
    learn_chinese_url: "/buy-chinese",
    learn_dutch_url: "/buy-dutch/",
    learn_english: "Learn English",
    learn_english_british_url: "/buy-english-british/",
    learn_english_url: "/buy-english/",
    learn_french: "Learn French",
    learn_french_url: "/buy-french/",
    learn_german: "Learn German",
    learn_german_url: "/buy-german/",
    learn_greek_url: "/buy-greek/",
    learn_hebrew_url: "/buy-hebrew/",
    learn_hindi_url: "/buy-hindi/",
    learn_irish_url: "/buy-irish/",
    learn_italian: "Learn Italian",
    learn_italian_url: "/buy-italian/",
    learn_japanese_url: "/buy-japanese/",
    learn_korean_url: "/buy-korean/",
    learn_latin_url: "/buy-latin/",
    learn_more: "Learn More",
    learn_persian_url: "/buy-farsi/",
    learn_polish_url: "/buy-polish/",
    learn_portuguese_url: "/buy-portuguese/",
    learn_russian_url: "/buy-russian/",
    learn_spanish: "Learn Spanish",
    learn_spanish_spain_url: "/buy-spanish-spain/",
    learn_spanish_url: "/buy-spanish/",
    learn_swedish_url: "/buy-swedish/",
    learn_tagalog_url: "/buy-tagalog/",
    learn_turkish_url: "/buy-turkish/",
    learn_vietnamese_url: "/buy-vietnamese/",
    lexia_learning: "Lexia Learning",
    lexia_learning_url: "https://www.lexialearning.com/",
    listen_now: "Listen Now",
    madarin: " (Mandarin)",
    market: ["US"],
    media_quote_1: "“I love Rosetta Stone's software, and I think",
    media_quote_1_bold: "the approach to learning languages works.",
    media_quote_1_end: "”",
    media_quote_2: "“With its excellent user interface, clear instructions, wide variety of games and challenges... ",
    media_quote_2_bold: "Rosetta Stone has got it going on.",
    media_quote_2_end: "”",
    media_quote_3: "“The ",
    media_quote_3_bold: "gold standard",
    media_quote_3_end: "of computer-based language learning.”",
    more_resources_title: "Additional Resources",
    more_specify: "Please specify",
    no_support_dropdown: true,
    persian: "Persian",
    polish: "Polish",
    portuguese: "Portuguese",
    press: "Press",
    press_url: "https://pr.rosettastone.com/",
    pricing_subtitle: "Please fill out the form below and we'll follow up with you right away.",
    pricing_thanks: "Thanks for your interest! Someone will follow up with you shortly.",
    pricing_title: "Get the pricing answers you need.",
    privacy_policy: "Privacy Policy",
    privacy_policy_url: "https://www.rosettastone.com/privacy/",
    products: "Products",
    questions_call: "Questions? Call us:",
    read_article: "Read Article",
    read_case_study: "Read Case Study",
    read_ebook: "Read eBook",
    read_fact_sheet: "Read Fact Sheet",
    read_guide: "Read Guide",
    read_more: "Read More",
    read_report: "Read Report",
    read_white_paper: "Read White Paper",
    related_resources_title: "Related Resources",
    request_pricing: "Request Pricing",
    resources: "Resources",
    resources_link: "/resources/",
    rosetta_copyright: "Rosetta Stone LLC. All Rights Reserved.",
    rosetta_stone: "Rosetta Stone",
    russian: "Russian",
    search: "Search...",
    search_rosetta_url: "https://search.rosettastone.com/",
    select_lang: "Select a language:",
    services: "Services",
    services_url: "https://serviceshub.rosettastone.com/",
    shop_now: "Shop Now",
    sign_in: "Sign In",
    sign_in_url: "https://www.rosettastone.com/login",
    similar_resources: "Similar Resources",
    site_not_found: "Site not found - 404",
    sitemap: "Sitemap",
    sitemap_url: "/sitemap",
    solutions: "Solutions",
    solutions_link: "/solutions/",
    spain: "(Spain)",
    spanish: "Spanish",
    support: "Support",
    support_business_url: "https://support.rosettastone.com/en/business",
    support_chat: "Live technical support chat",
    support_chat_live: "Live technical support chat",
    support_chat_live_url: "https://rosettastone.secure.force.com/apex/PreLiveChatForm",
    support_chat_url: "https://support.rosettastone.com/en/chat",
    support_classrooms: "Support for Classrooms and Enterprises:",
    support_faq_btn: "View All FAQs",
    support_faq_title: "Frequently Asked Questions:",
    support_faq_url_1: "/faq#what-is-the-30-day-no-risk-money-back",
    support_faq_url_1_title: "What is the 30 day, no-risk, money-back guarantee?",
    support_faq_url_2: "/faq#how-does-the-rosetta-stone-language-learning",
    support_faq_url_2_title: "How does the Rosetta Stone language learning method work?",
    support_faq_url_3: "/faq#what-is-the-rosetta-stone-online-subscription",
    support_faq_url_3_title: "What is included in the Online Subscription?",
    support_faq_url_4: "/faq#how-can-i-cancel-automatic-subscription-renewal",
    support_faq_url_4_title: "How do I cancel my Online Subscription?",
    support_for_you: "Support for you:",
    support_home: "Support Site",
    support_site: "Support Site",
    support_site_url: "https://support.rosettastone.com/en/",
    swedish: "Swedish",
    switch_lang: "Español",
    switch_lang_url: "https://espanol.rosettastone.com/",
    system_reqs: "System Reqs",
    system_reqs_url: "/system-requirements",
    tagalog: " (Tagalog)",
    telephone_atr: "tel:+18007673882",
    telephone_text: "1-(800)-ROSETTA",
    terms_conditions: "Terms & Conditions",
    terms_conditions_url: "https://www.rosettastone.com/terms/",
    title: "us-copy",
    turkish: "Turkish",
    twitter_url: "https://twitter.com/rosettastone",
    united_kingdom: "United Kingdom",
    united_kingdom_url: "https://www.rosettastone.co.uk/",
    united_states: "United States",
    united_states_url: "https://www.rosettastone.com",
    use_new_header: true,
    vertical: ["recECBjZxFEWVVls8"],
    vertical_business: "Enterprise",
    vertical_business_link: "/business/home/",
    vertical_healthcare: "Healthcare",
    vertical_healthcare_link: "/healthcare/",
    vertical_hed: "Higher Education",
    vertical_hed_link: "/highereducation/",
    vertical_k12: "Schools",
    vertical_k12_link: "/k12/home/",
    vertical_pub: "Public Sector",
    vertical_pub_link: "/publicsector/",
    verticals_subtitle: "Our award-winning language solutions work for all types of learners.",
    verticals_title: "What type of learner are you?",
    vietnamese: "Vietnamese",
    view_infographic: "View Infographic",
    watch_video: "Watch Video",
    watch_webinar: "Watch Webinar",
    youtube_url: "https://www.youtube.com/user/rosettastone"
});

const education_primary_pages_config$5 = ({ page }) => {
    let pageConfig = null;
    if (page === "dynamic-content") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "en"
            },
            content: {
                copyData: copyData$5(),
                quote_carousel: quote_carousel(),
                lead_generation_bar: lead_generation_bar$h()
            }
        };
    }
    if (page === "dynamic-resources") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "en"
            },
            content: {
                hero: {
                    layout: "list",
                    panels: [
                        {
                            layout: "image-right",
                            alignItems: "center",
                            image: {
                                src: null
                            },
                            title: {
                                content: ""
                            },
                            body: {
                                content: ""
                            },
                            custom: {
                                cta: {
                                    destination: "/pricing-request/",
                                    theme: "yellow_black",
                                    internal: true,
                                    text: "REQUEST PRICING"
                                }
                            }
                        }
                    ]
                },
                copyData: copyData$5(),
                quote_carousel: quote_carousel(),
                lead_generation_bar: lead_generation_bar$h()
            }
        };
    }
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "K-12 Online Language Learning | Rosetta Stone",
                meta_description: "Rosetta Stone online language learning for education complements classroom instruction in both English and world languages. Learn about customer successes.",
                canonical_url: "https://www.rosettastone.com/k12/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        data_qa: "Section 1",
                        panels: [
                            {
                                body: {
                                    content: "Language connects us all, laying the groundwork for learning and growth. For an increasingly diverse student population, language can also be the key to achievement, in school and beyond. "
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                title: {
                                    align: "left",
                                    content: "Where will language take your students?",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                video: {
                                    controls: true,
                                    currentVideoUrl: "https://player.vimeo.com/video/591207204"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        visible: true,
                        data_qa: "Section 2 - Image Text",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "As communities diversify and global connections increase, the need for K–12 students to develop language skills grows. Compared to children who speak only one language, bilingual students benefit from better working memories, greater mental flexibility, and the ability to more easily grasp abstract concepts."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    alt: "Promoting the power of bilingualism",
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    content: "Promoting the power of bilingualism",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                }
                            },
                            {
                                body: {
                                    content: "Every student is different. That’s why our programs personalize language learning through the Adaptive Blended Learning Model, while incorporating scaffolded instruction and Speech Recognition Engine technology. Individualized learning paths empower students to take ownership of their own language development."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    alt: "Addressing individual needs for language learning",
                                    height: "100%",
                                    src: null,
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Addressing individual needs for language learning",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Speaking with purposeful repetition and listening practice is a key attribute of our solutions, and the embedded Speech Recognition Engine provides immediate feedback. Our TruAccent™ speech recognition helps guide pronunciation, without judging, while educators can monitor student progress."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    alt: "Advancing proficiency with immediate feedback",
                                    height: "100%",
                                    src: null,
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Advancing proficiency with immediate feedback",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "We support, engage, and encourage students throughout their learning journeys by using pedagogies that respect a diversity of cultures and languages. Our programs and lessons are designed to celebrate student achievement every step of the way."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    alt: "Culturally respectful for more inclusive classrooms",
                                    height: "100%",
                                    src: null,
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Culturally respectful for more inclusive classrooms",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "We empower educators to enhance academic outcomes with programs aligned with multiple language proficiency standards. And we combine language learning with subject knowledge to support career readiness, while helping administrators meet district and state goals."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    alt: "Improving student outcomes for greater academic achievement",
                                    height: "100%",
                                    src: null,
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Improving student outcomes for greater academic achievement",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Students can learn anywhere. Our language learning solutions enable both students and educators to access language lessons and activities virtually. That way, any moment can become a teachable one."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    alt: "Opportunities for learning anywhere, anytime",
                                    height: "100%",
                                    src: null,
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Opportunities for learning anywhere, anytime",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ]
                    },
                    {
                        visible: true,
                        data_qa: "Section 3 - Contact",
                        layout: "list",
                        panels: [
                            {
                                data_qa: null,
                                sub_title: {
                                    align: "center",
                                    content: "Please fill out the form below and we'll follow up with you right away.",
                                    theme: "white",
                                    type: "sub-title"
                                },
                                thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                title: {
                                    align: "center",
                                    content: "Get the language learning support you need. Connect with us today.",
                                    heading: "h2",
                                    theme: "white",
                                    type: "section-title"
                                }
                            }
                        ]
                    }
                ],
                quote_carousel: quote_carousel(),
                lead_generation_bar: lead_generation_bar$h()
            }
        };
    }
    if (page === "pricing-request") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.com/k12/pricing-request/",
                lang: "en"
            },
            content: {
                title: {
                    type: "section-title",
                    theme: "black",
                    content: "Complete the form below to request pricing for your classroom or school"
                },
                sub_title: {
                    type: "section-sub-title",
                    theme: "white",
                    content: "Please fill out the form below to schedule time to discuss how we can help."
                },
                lead_generation_form: {
                    title: {
                        theme: "blue",
                        type: "section-title",
                        content: "Almost there!"
                    },
                    fields: {
                        first_name: {
                            field_name: "first_name",
                            field_type: "text",
                            label: "First Name",
                            required: true,
                            required_error: "Please enter your First Name."
                        },
                        last_name: {
                            field_name: "last_name",
                            type: "text",
                            label: "Last Name",
                            required: true,
                            required_error: "Please enter your Last Name."
                        },
                        email: {
                            field_name: "email",
                            field_type: "email",
                            label: "Email Address",
                            required: true,
                            required_error: "Please enter your Email Address.",
                            validation_error: "Please enter a valid Email Address."
                        },
                        phone: {
                            field_name: "phone",
                            field_type: "tel",
                            label: "Phone Number",
                            required: true,
                            required_error: null
                        },
                        organization_name: {
                            field_name: "organization_name",
                            field_type: "text",
                            label: "Company",
                            required: true,
                            required_error: "Please enter your Company Name."
                        },
                        organization_size: {
                            field_name: "organization_size",
                            field_type: "text",
                            label: "Company Size",
                            required: true,
                            required_error: "Please enter your Company Size.",
                            options: [
                                { value: "", label: "" },
                                { value: "100 or Less", label: "100 or Less" },
                                { value: "101 - 500", label: "101 - 500" },
                                {
                                    value: "501 - 1,000",
                                    label: "501 - 1,000"
                                },
                                { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                {
                                    value: "10,001 - 25,000",
                                    label: "10,001 - 25,000"
                                },
                                {
                                    value: "25,001 - 50,000",
                                    label: "25,001 - 50,000"
                                },
                                {
                                    value: "50,001 or More",
                                    label: "50,001 or More"
                                }
                            ]
                        },
                        role: {
                            field_name: "title",
                            field_type: "select",
                            label: "Title",
                            required: true,
                            required_error: "Please enter your Role."
                        }
                    },
                    button: {
                        as: "button",
                        type: "submit",
                        size: "regular",
                        text: "Request Pricing"
                    },
                    labels: {
                        form_privacy1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's",
                        form_privacy2: "Privacy Policy",
                        form_privacy3: "I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at",
                        form_privacy4: ".",
                        form_privacyUrl: "https://www.rosettastone.com/privacy",
                        form_privacyemail: "privacyofficer@rosettastone.com",
                        form_updateagreement1: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
                        form_updateagreement2: "here",
                        form_updateagreement3: "for more information."
                    },
                    domain: ".com",
                    dataQaLocation: "page"
                },
                quote_carousel: quote_carousel(),
                lead_generation_bar: {
                    visible: false
                }
            }
        };
    }
    if (page === "pricing-request-complete") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.com/k12/pricing-request/",
                lang: "en"
            },
            content: {
                title: {
                    align: "center",
                    content: "Thanks for your interest!",
                    heading: "h1",
                    theme: "blue",
                    type: "page-title"
                },
                sub_title: {
                    align: "center",
                    heading: "h2",
                    content: "Check out some additional resources before your meeting!",
                    type: "page-sub-title"
                },
                resources_link: {
                    destination: "/resources/",
                    new_window: false,
                    internal: true,
                    size: "regular",
                    text: "Resources",
                    theme: "blue_white"
                },
                quote_carousel: quote_carousel(),
                lead_generation_bar: {
                    visible: false
                }
            }
        };
    }
    if (page === "pricing-request-schedule") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.com/k12/pricing-request/",
                lang: "en"
            },
            content: {
                quote_carousel: quote_carousel(),
                lead_generation_bar: {
                    visible: false
                }
            }
        };
    }
    if (page === "solutions-K12-english-language") {
        pageConfig = {
            page,
            eloquaPage: "webpage",
            helmet: {
                meta_title: "Language Training Solutions | Rosetta Stone",
                meta_description: "Rosetta Stone English for grades K–6 is an adaptive blended learning program that supports students’ English language development through academic conversations. The program integrates speaking, listening, and grammar in the subjects of math, science, social studies, general knowledge, and biographies.",
                canonical_url: "https://www.rosettastone.com/k12/solutions/K12-english-language/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        dataQa: "1",
                        panels: [
                            {
                                body: {
                                    content: "Rosetta Stone Foundations is a scalable e-learning solution designed for beginner to intermediate students to build fundamental English language skills. Students develop their skills through learning activities, stories, and live online conversations."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/pricing-request/",
                                            new_window: false,
                                            internal: true,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                title: {
                                    align: "left",
                                    content: "Lay the groundwork for success with Rosetta Stone® Foundations",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                video: {
                                    currentVideoUrl: "https://player.vimeo.com/video/591207236",
                                    playing: false,
                                    controls: true
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "2",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "For your emergent bilingual students, or English language learners, in grades 7–12, producing spoken language is key. You need an immersive solution that allows students to build their language skills naturally, accelerating speaking confidence."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    alt: "Building skills for conversational proficiency",
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Building skills for conversational proficiency",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Speaking with purposeful repetition and listening practice is a key attribute of the software, and the embedded Speech Recognition Engine provides immediate feedback. Our TruAccent™ speech recognition helps guide pronunciation without judging, while educators can monitor student progress."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    alt: "Speech Recognition Engine with immediate feedback",
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Speech Recognition Engine with immediate feedback",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "With live tutoring, students can talk with native speakers in a safe, controlled online environment. Meanwhile, teachers receive support materials, including workbooks, guides, and quizzes, as well as reports that can assist in class planning and one-on-one instruction."
                                },
                                custom: {},
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    alt: "Support for students and educators every step of the way",
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Support for students and educators every step of the way",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "See the greater gains in year-over-year AZELLA scores for English language learners."
                                },
                                custom: {
                                    cta: {
                                        theme: "blue_white",
                                        size: "regular",
                                        text: "Download White Paper",
                                        destination: "https://resources.rosettastone.com/CDN/us/pdfs/EL-Controlled-Study-White-Paper.pdf",
                                        internal: false,
                                        new_window: true
                                    }
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    alt: "Rosetta Stone Foundations gets results",
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Rosetta Stone Foundations gets results",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Access these additional resources to learn more about Rosetta Stone Foundations."
                                },
                                custom: {
                                    li_1: {
                                        destination: "https://resources.rosettastone.com/assets/lp/9999999998/resources/little-rock-school-district-case-study.pdf",
                                        label: "Rosetta Stone Foundations Case Study"
                                    },
                                    li_2: {
                                        destination: "https://resources.rosettastone.com/assets/lp/9999999998/resources/technology-to-promote-ell-student-family-success.pdf",
                                        label: "Promoting EL Student Success with Technology"
                                    },
                                    li_3: {
                                        destination: "https://resources.rosettastone.com/assets/lp/9999999998/resources/six-steps-toward-ell-success.pdf",
                                        label: "Six Steps Toward ELL Success"
                                    }
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    alt: "Build a strong foundation",
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Build a strong foundation",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "5",
                        layout: "list",
                        panels: [
                            {
                                data_qa: null,
                                sub_title: {
                                    align: "center",
                                    content: "Please fill out the form below and we'll follow up with you right away.",
                                    theme: "white",
                                    type: "sub-title"
                                },
                                thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                title: {
                                    align: "center",
                                    content: "Get the language learning support you need. Connect with us today.",
                                    heading: "h2",
                                    theme: "white",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    }
                ],
                quote_carousel: quote_carousel(),
                lead_generation_bar: lead_generation_bar$h()
            }
        };
    }
    if (page === "solutions-world-languages") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Language Training Solutions | Rosetta Stone",
                meta_description: "Rosetta Stone English for grades K–6 is an adaptive blended learning program that supports students’ English language development through academic conversations. The program integrates speaking, listening, and grammar in the subjects of math, science, social studies, general knowledge, and biographies.",
                canonical_url: "https://www.rosettastone.com/k12/solutions/elementary-english-language/",
                lang: "en"
            },
            content: {
                hero: {
                    dataQa: "1",
                    layout: "list",
                    panels: [
                        {
                            body: {
                                content: "The Rosetta Stone Foundations for World Languages K–12 solution provides a range of language instruction, incorporating speaking, listening, grammar, and writing lessons. The program allows for flexibility and personalized study, enabling students to learn at their own pace."
                            },
                            custom: {
                                lead_generation_button: {
                                    schedule_appointment: false,
                                    completion_redirect: null,
                                    button: {
                                        destination: "/pricing-request/",
                                        new_window: false,
                                        size: "regular",
                                        text: "Request Pricing",
                                        theme: "yellow_black"
                                    }
                                }
                            },
                            dataQa: "1",
                            direction: "image-right",
                            image: {
                                alt: "Make a world of difference with Rosetta Stone® Foundations for World Languages",
                                height: "100%",
                                src: null,
                                width: "100%"
                            },
                            title: {
                                align: "left",
                                content: "Make a world of difference with Rosetta Stone® Foundations for World Languages",
                                heading: "h1",
                                theme: "black",
                                type: "page-title"
                            },
                            hasCtaRedirect: true
                        }
                    ],
                    visible: true
                },
                image_text_list: {
                    dataQa: "2",
                    layout: "list",
                    panels: [
                        {
                            body: {
                                content: "Today, more of the world’s population is bilingual than monolingual, and the demand for bilingual workers is rising. Your students need a learning solution that can help them develop speaking and listening skills in a wide range of languages, for greater success in school and beyond."
                            },
                            dataQa: "2",
                            direction: "image-left",
                            image: {
                                alt: "Meeting a range of diverse language learning needs",
                                height: "80%",
                                src: null,
                                width: "80%"
                            },
                            title: {
                                align: "left",
                                content: "Meeting a range of diverse language learning needs",
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            }
                        },
                        {
                            body: {
                                content: "Speaking with purposeful repetition and listening practice is a key attribute of the software, and the embedded Speech Recognition Engine provides immediate feedback. Our TruAccent™ speech recognition helps guide pronunciation without judging, while educators can monitor student progress."
                            },
                            dataQa: "3",
                            direction: "image-right",
                            image: {
                                alt: "Immersing students in language so they’re prepared to speak",
                                height: "80%",
                                src: null,
                                width: "80%"
                            },
                            title: {
                                align: "left",
                                content: "Immersing students in language so they’re prepared to speak",
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            }
                        },
                        {
                            body: {
                                content: "Students build confidence by practicing their conversational skills under the direction of one of our experienced live tutors, a native speaker of the language being studied. Each session takes place in a real-time group setting with other students for even more opportunities to converse. Students also have access to children’s stories, history, and cultural resources."
                            },
                            dataQa: "4",
                            direction: "image-left",
                            image: {
                                alt: "Creating opportunities for more speaking and listening practice",
                                height: "80%",
                                src: null,
                                width: "80%"
                            },
                            title: {
                                align: "left",
                                content: "Creating opportunities for more speaking and listening practice",
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            }
                        },
                        {
                            body: {
                                content: "Extensive, repetitive speaking and listening practice is a key attribute of the software, and the embedded Speech Recognition Engine provides immediate feedback. Our TruAccent™ speech recognition helps guide pronunciation, without judging, while educators can monitor student progress."
                            },
                            dataQa: "5",
                            direction: "image-right",
                            image: {
                                alt: "Speech Recognition Engine with immediate feedback",
                                src: null,
                                height: "80%",
                                width: "80%"
                            },
                            title: {
                                align: "left",
                                content: "Speech Recognition Engine with immediate feedback",
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            }
                        },
                        {
                            body: {
                                content: "Access these additional resources to learn more about Rosetta Stone World Languages."
                            },
                            custom: {
                                li_1: {
                                    destination: "https://resources.rosettastone.com/CDN/us/pdfs/education-primary/new-foundations-product-factsheet.pdf",
                                    label: "Rosetta Stone Foundations Grades K–12 World Languages Flyer"
                                },
                                li_2: {
                                    destination: "https://resources.rosettastone.com/assets/lp/9999999998/resources/lifelong-learning.pdf",
                                    label: "Language is a Lifelong Skill eBook"
                                },
                                li_3: {
                                    destination: "https://resources.rosettastone.com/CDN/us/pdfs/education-primary/world-language-case-study-2020.pdf",
                                    label: "World Language Case Study"
                                },
                                li_4: {
                                    destination: "https://resources.rosettastone.com/assets/lp/9999999998/resources/closing-the-world-language-education-gap-2016.pdf",
                                    label: "Closing the World Language Gap eBook"
                                }
                            },
                            image: {
                                alt: "Provide a world of opportunities",
                                height: "80%",
                                src: null,
                                width: "80%"
                            },
                            dataQa: "6",
                            direction: "image-left",
                            title: {
                                content: "Provide a world of opportunities",
                                type: "section-title",
                                heading: "h2",
                                theme: "black",
                                align: "left"
                            }
                        }
                    ],
                    visible: true
                },
                quote_carousel: quote_carousel(),
                lead_generation_bar: lead_generation_bar$h()
            }
        };
    }
    return pageConfig;
};

var education_primary_footer_config$5 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_consumer_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_homeschool_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/k12/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/enterprise/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/about/company/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "https://educationblog.rosettastone.com/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_blog_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/en/work/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/product/faq/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_faqs_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var education_secondary_nav_secondary_config$5 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: null,
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
        visible: true,
        destination: "/resources/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
        visible: false,
        destination: "/solutions/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_label
    }
});

var lead_generation_bar$g = () => {
    return {
        visible: true,
        dataQa: "lead generation bar",
        lead_generation_button: {
            schedule_appointment: false,
            button: {
                destination: "/pricing-request/",
                new_window: false,
                size: "regular",
                text: "Request Pricing",
                theme: "yellow_black"
            }
        },
        subtitle: {
            content: "",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        title: {
            content: "Get the language learning support you need. Connect with us today.",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        }
    };
};

var verticals$g = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_enterprise,
                src: verticals$q.enterpriseCirclePng
            },
            link: {
                destination: "/enterprise/"
            },
            name: strings.verticals_enterprise,
            title: {
                content: strings.verticals_enterprise,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_education_primary,
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/k12/"
            },
            name: strings.verticals_education_primary,
            title: {
                content: strings.verticals_education_primary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_publicsector,
                src: verticals$q.publicsectorCirclePng
            },
            link: {
                destination: "/publicsector/"
            },
            name: strings.verticals_publicsector,
            title: {
                content: strings.verticals_publicsector,
                type: "card-title"
            }
        }
    ]
});

const education_secondary_pages_config$5 = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "dynamic-content") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "en"
            },
            content: {
                copyData: copyData$5(),
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$g({ strings }),
                lead_generation_bar: lead_generation_bar$g()
            }
        };
    }
    if (page === "dynamic-resources") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "en"
            },
            content: {
                hero: {
                    layout: "list",
                    panels: [
                        {
                            layout: "image-right",
                            alignItems: "center",
                            image: {
                                src: null
                            },
                            title: {
                                content: ""
                            },
                            body: {
                                content: ""
                            },
                            custom: {
                                cta: {
                                    destination: "/pricing-request/",
                                    theme: "yellow_black",
                                    internal: true,
                                    text: "REQUEST PRICING"
                                }
                            }
                        }
                    ]
                },
                copyData: copyData$5(),
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$g({ strings }),
                lead_generation_bar: lead_generation_bar$g()
            }
        };
    }
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Online Language Learning for Higher Ed | Rosetta Stone",
                meta_description: "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
                canonical_url: "https://www.rosettastone.com/highereducation/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        data_qa: "section1_hero",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Students create global connections with a swipe on their smartphone. Yet, schools face world language budget constraints. This limits students’ potential academic and career choices, and their worldview. In a global economy, world language skills are a 21st century job requirement."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/pricing-request/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    width: "50vw"
                                },
                                title: {
                                    align: "left",
                                    content: "Put language learning within every student’s reach",
                                    theme: "black",
                                    type: "page-title",
                                    heading: "h1"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section2_productSample",
                        panels: [
                            {
                                title: {
                                    align: "left",
                                    content: "Accelerate English language learning.",
                                    type: "section-title",
                                    heading: "h2"
                                },
                                body: {
                                    content: "Many higher education students can pass a standardized English-language proficiency test; however, the language skills required to be successful in academia are often much different. Rosetta Stone language learning solutions help build international students' English confidence and prepare them for success."
                                },
                                panels: [
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.azulPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.verdePng
                                            }
                                        },
                                        challenge_text: "Azul"
                                    },
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.bicicletaAzulPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.bicicletaAmarillaPng
                                            }
                                        },
                                        challenge_text: "Una bicicleta azul"
                                    },
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.dosBicicletasAzulesPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.dosBicicletasDiferentesPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules"
                                    },
                                    {
                                        left_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.verdesPorUnDiaPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.azulesPorUnDiaPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules por un día por favor"
                                    }
                                ],
                                custom: {
                                    quote_attribution_1: {
                                        quote: "In this Internet era, English being the global language, students need to master this language to be confident and to stay competitive in their studies now and later in their profession.",
                                        attribution: "Dean, Deanship of Preparatory Year & Supportive Studies, Northern Border University",
                                        size: "small",
                                        align: "left",
                                        link: {
                                            align: "left",
                                            theme: "black",
                                            destination: "https://www.rosettastone.com/k12/resources/content/case-study-northern-border-university/"
                                        }
                                    }
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section3_image",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "That’s no surprise. Culture, entertainment, sports, and literature are only a click away. Blending award-winning e-learning into your language curriculum gives students online access to unlimited pronunciation guidance and speaking practice that’s not possible during classroom hours."
                                },
                                custom: {
                                    quote_attribution_1: {
                                        quote: "After we piloted our conversational language courses, our students took the American Council on the Teaching of Foreign Languages’ (ACTFL) Oral Proficiency Interview (OPIc). After just one semester of study, students in the 101 courses scored at the Novice-Mid level or higher on the OPIc.",
                                        attribution: "Department Chair, College of General Studies, Liberty University",
                                        align: "left",
                                        size: "small",
                                        link: {
                                            align: "left",
                                            theme: "black",
                                            destination: "https://www.rosettastone.com/k12/resources/content/case-study-liberty-university/"
                                        }
                                    }
                                },
                                direction: "image-right",
                                image: {},
                                title: {
                                    align: "left",
                                    content: "Online is students’ home away from home",
                                    theme: "black",
                                    type: "section-title",
                                    heading: "h2"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section4_image",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Students, instructors, and staff all want to feel at ease speaking a new language. Moving from language learning to the real world takes practice. With our 1:1 and small group tutoring sessions, learners converse with native speakers. That makes tutoring in our friendly online space a smart way to learn."
                                },
                                custom: {
                                    quote_attribution_1: {
                                        quote: "Rosetta Stone solutions have been a great tool to help the participants assess their levels and access a range of interactive and diversified learning experiences which promotes independent progress.",
                                        attribution: "Course Coordinator, Canterbury Christ Church University",
                                        link: {
                                            align: "left",
                                            theme: "black",
                                            destination: "https://www.rosettastone.com/k12/resources/content/case-study-canterbury-christ-church-university/"
                                        },
                                        align: "left",
                                        size: "small"
                                    }
                                },
                                direction: "image-left",
                                image: {},
                                title: {
                                    align: "left",
                                    content: "Unlimited Live Tutoring gets learners talking",
                                    theme: "black",
                                    type: "section-title",
                                    heading: "h2"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section5_image",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Class schedules are still the norm for students. But schools are also making it easier to learn away from the classroom. Our mobile app lets your students access lessons and activities whenever the time is right. Giving them the freedom to turn any moment into a teachable one."
                                },
                                custom: {
                                    quote_attribution_1: {
                                        quote: "We see those students who follow the Rosetta Stone® program become motivated and confident, more willing to participate in classroom activities, and acquire vocabulary at a much faster rate.",
                                        attribution: "ELL Teacher, Phoenix Union High School District",
                                        align: "left",
                                        size: "small",
                                        link: {
                                            align: "left",
                                            theme: "black",
                                            destination: "https://www.rosettastone.com/k12/resources/content/customer-spotlight-phoenix-union-high-school-district/"
                                        }
                                    }
                                },
                                direction: "image-right",
                                image: {},
                                title: {
                                    align: "left",
                                    content: "Mobile learning, online or off",
                                    theme: "black",
                                    type: "section-title",
                                    heading: "h2"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section6_contact",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        data_qa: "section7_features",
                        layout: "list",
                        panels: [
                            {
                                pageData: {
                                    learner_feature_1_icon_name: "icon_24",
                                    learner_feature_1_subtitle: "English and World Languages to match student goals.",
                                    learner_feature_1_title: "24 Languages",
                                    learner_feature_2_icon_name: "icon_dynamic",
                                    learner_feature_2_subtitle: "Surrounding students with one language speeds up learning.",
                                    learner_feature_2_title: "Self-paced Immersion",
                                    learner_feature_3_icon_name: "icon_foundational",
                                    learner_feature_3_subtitle: "Students have fun while reinforcing lessons they’ve learned.",
                                    learner_feature_3_title: "Games and Activities",
                                    learner_feature_4_icon_name: "icon_truaccent",
                                    learner_feature_4_subtitle: "It’s the pronunciation helper any student can use.",
                                    learner_feature_4_title: "TruAccent™ Speech Recognition",
                                    learner_feature_5_icon_name: "icon_tutoring",
                                    learner_feature_5_subtitle: "Offered in a safe, online space at each student’s level.",
                                    learner_feature_5_title: "Live Tutoring",
                                    learner_feature_6_icon_name: "icon_mobile",
                                    learner_feature_6_subtitle: "Puts learning access in each student's hand.",
                                    learner_feature_6_title: "Mobile App",
                                    learner_feature_title: ""
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "section8_relatedResources",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "recqx7Gp85JxbWVUk",
                            "recmZCtDOwebYHRXw",
                            "reclyhXd1Wt8SDAkv",
                            "recBdyJF9DHfMJX4Y"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            theme: "black",
                            type: "section-title"
                        },
                        visible: true
                    }
                ],
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$g({ strings }),
                lead_generation_bar: lead_generation_bar$g()
            }
        };
    }
    if (page === "pricing-request") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.com/highereducation/pricing-request/",
                lang: "en"
            },
            content: {
                title: {
                    type: "section-title",
                    theme: "yellow",
                    content: "Book time with a Language Expert today"
                },
                sub_title: {
                    type: "section-sub-title",
                    theme: "white",
                    content: "Please fill out the form below to schedule time to discuss how we can help."
                },
                lead_generation_form: {
                    title: {
                        theme: "blue",
                        type: "section-title",
                        content: "Almost there!"
                    },
                    fields: {
                        first_name: {
                            field_name: "first_name",
                            field_type: "text",
                            label: "First Name",
                            required: true,
                            required_error: "Please enter your First Name."
                        },
                        last_name: {
                            field_name: "last_name",
                            type: "text",
                            label: "Last Name",
                            required: true,
                            required_error: "Please enter your Last Name."
                        },
                        email: {
                            field_name: "email",
                            field_type: "email",
                            label: "Email Address",
                            required: true,
                            required_error: "Please enter your Email Address.",
                            validation_error: "Please enter a valid Email Address."
                        },
                        phone: {
                            field_name: "phone",
                            field_type: "tel",
                            label: "Phone Number",
                            required: true,
                            required_error: null
                        },
                        organization_name: {
                            field_name: "organization_name",
                            field_type: "text",
                            label: "Company",
                            required: true,
                            required_error: "Please enter your Company Name."
                        },
                        organization_size: {
                            field_name: "organization_size",
                            field_type: "text",
                            label: "Company Size",
                            required: true,
                            required_error: "Please enter your Company Size.",
                            options: [
                                { value: "", label: "" },
                                { value: "100 or Less", label: "100 or Less" },
                                { value: "101 - 500", label: "101 - 500" },
                                {
                                    value: "501 - 1,000",
                                    label: "501 - 1,000"
                                },
                                { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                {
                                    value: "10,001 - 25,000",
                                    label: "10,001 - 25,000"
                                },
                                {
                                    value: "25,001 - 50,000",
                                    label: "25,001 - 50,000"
                                },
                                {
                                    value: "50,001 or More",
                                    label: "50,001 or More"
                                }
                            ]
                        },
                        role: {
                            field_name: "title",
                            field_type: "select",
                            label: "Title",
                            required: true,
                            required_error: "Please enter your Role."
                        }
                    },
                    button: {
                        as: "button",
                        type: "submit",
                        size: "regular",
                        text: "Request Pricing"
                    },
                    labels: {
                        form_privacy1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's",
                        form_privacy2: "Privacy Policy",
                        form_privacy3: "I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at",
                        form_privacy4: ".",
                        form_privacyUrl: "https://www.rosettastone.com/privacy",
                        form_privacyemail: "privacyofficer@rosettastone.com",
                        form_updateagreement1: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
                        form_updateagreement2: "here",
                        form_updateagreement3: "for more information."
                    },
                    domain: ".com",
                    dataQaLocation: "page"
                },
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$g({ strings }),
                lead_generation_bar: {
                    visible: false
                }
            }
        };
    }
    if (page === "pricing-request-complete") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.com/highereducation/pricing-request/",
                lang: "en"
            },
            content: {
                title: {
                    align: "center",
                    content: "Thanks for your interest!",
                    heading: "h1",
                    theme: "blue",
                    type: "page-title"
                },
                sub_title: {
                    align: "center",
                    heading: "h2",
                    content: "Check out some additional resources before your meeting!",
                    type: "page-sub-title"
                },
                resources_link: {
                    destination: "/resources/",
                    new_window: false,
                    internal: true,
                    size: "regular",
                    text: "Resources",
                    theme: "blue_white"
                },
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$g({ strings }),
                lead_generation_bar: {
                    visible: false
                }
            }
        };
    }
    if (page === "pricing-request-schedule") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.com/highereducation/pricing-request/",
                lang: "en"
            },
            content: {
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$g({ strings }),
                lead_generation_bar: lead_generation_bar$g()
            }
        };
    }
    return pageConfig;
};

var education_secondary_footer_config$5 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_consumer_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_homeschool_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/k12/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/enterprise/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/about/company/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "https://educationblog.rosettastone.com/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_blog_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/en/work/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/product/faq/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_faqs_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var enterprise_nav_secondary_config$5 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: true,
        destination: "https://enterpriseblog.rosettastone.com/",
        external: true,
        new_window: true,
        label: strings.nav_secondary_enterprise_blog_label,
        title: strings.nav_secondary_enterprise_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_home_label,
        title: strings.nav_secondary_enterprise_home_label
    },
    resources: {
        visible: true,
        destination: "/resources/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_resources_label,
        title: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
        visible: true,
        destination: "/solutions/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_solutions_label,
        options: [
            {
                link: "/industry/construction/",
                label: strings.nav_secondary_enterprise_solutions_construction_label,
                title: strings.nav_secondary_enterprise_solutions_construction_label
            },
            {
                link: "/industry/consulting/",
                label: strings.nav_secondary_enterprise_solutions_consulting_label,
                title: strings.nav_secondary_enterprise_solutions_consulting_label
            },
            {
                link: "/industry/foodservice/",
                label: strings.nav_secondary_enterprise_solutions_foodservice_label,
                title: strings.nav_secondary_enterprise_solutions_foodservice_label
            },
            {
                link: "/industry/government/",
                label: strings.nav_secondary_enterprise_solutions_government_label,
                title: strings.nav_secondary_enterprise_solutions_government_label
            },
            {
                link: "/industry/healthcare/",
                label: strings.nav_secondary_enterprise_solutions_healthcare_label,
                title: strings.nav_secondary_enterprise_solutions_healthcare_label
            },
            {
                link: "/industry/hospitality/",
                label: strings.nav_secondary_enterprise_solutions_hospitality_label,
                title: strings.nav_secondary_enterprise_solutions_hospitality_label
            },
            {
                link: "/industry/manufacturing/",
                label: strings.nav_secondary_enterprise_solutions_manufacturing_label,
                title: strings.nav_secondary_enterprise_solutions_manufacturing_label
            },
            {
                link: "/industry/retail/",
                label: strings.nav_secondary_enterprise_solutions_retail_label,
                title: strings.nav_secondary_enterprise_solutions_retail_label
            }
        ]
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_label
    }
});

var lead_generation_bar$f = () => {
    return {
        visible: true,
        dataQa: "lead generation bar",
        lead_generation_button: {
            schedule_appointment: false,
            button: {
                destination: "/pricing-request/",
                new_window: false,
                size: "regular",
                text: "Request Pricing",
                theme: "yellow_black"
            }
        },
        subtitle: {
            content: "",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        title: {
            content: "Ready to begin your organization’s complete language journey?",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        }
    };
};

var verticals$f = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_publicsector,
                src: verticals$q.publicsectorCirclePng
            },
            link: {
                destination: "/publicsector/"
            },
            name: strings.verticals_publicsector,
            title: {
                content: strings.verticals_publicsector,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_education_primary,
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/k12/"
            },
            name: strings.verticals_education_primary,
            title: {
                content: strings.verticals_education_primary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_education_secondary,
                src: verticals$q.educationSecondaryCirclePng
            },
            link: {
                destination: "/highereducation/"
            },
            name: strings.verticals_education_secondary,
            title: {
                content: strings.verticals_education_secondary,
                type: "card-title"
            }
        }
    ]
});

const enterprise_pages_config$5 = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "dynamic-content") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "en"
            },
            content: {
                copyData: copyData$5(),
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings }),
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "dynamic-resources") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Resources for Online Language Learning for Enterprise | Rosetta Stone",
                meta_description: "",
                canonical_url: "https://www.rosettastone.com/enterprise/resources/",
                lang: "en"
            },
            content: {
                hero: {
                    layout: "list",
                    panels: [
                        {
                            layout: "image-right",
                            alignItems: "center",
                            image: {
                                src: null
                            },
                            title: {
                                content: "Enterprise Resources"
                            },
                            body: {
                                content: "Let Employees Speak For Themselves"
                            },
                            custom: {
                                cta: {
                                    destination: "/pricing-request/",
                                    internal: true,
                                    theme: "yellow_black",
                                    text: "REQUEST PRICING"
                                }
                            }
                        }
                    ]
                },
                copyData: copyData$5(),
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings }),
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "experience-audit-language-costs") {
        pageConfig = {
            page,
            eloquaPage: "webpage",
            helmet: {
                meta_title: "Audit Language Costs | Rosetta Stone Enterprise",
                meta_description: "It’s time to choose a language training program. Do you go old school with face-to-face instruction or empower your employees to learn online? Here’s how to make a strong business case for online language training.",
                canonical_url: "https://www.rosettastone.com/enterprise/experience/audit-language-costs/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        data_qa: "Section 0 - Hero",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: `
                            A language cost audit can help keep learning and development (L&D) vendor costs down. Auditing your procurement process can be overwhelming, so we’ve put together this handy three-step checklist to help you through the process.
                            `
                                },
                                custom: {
                                    cta: {
                                        destination: "/enterprise/experience/making-the-case/",
                                        internal: true,
                                        size: "regular",
                                        theme: "yellow_black",
                                        text: "Learn More"
                                    }
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Audit Your Language Training Costs in 3 Easy Steps!",
                                    heading: "h1",
                                    theme: "blue",
                                    type: "page-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 1",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "What’s your process for selecting language training solutions and other related L&D software products? Do you have a standardized way to identify language training programs? Have members of your regional procurement team purchased language services in the past? Be sure you fully grasp how your department purchases language training products."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "115px",
                                    width: "115px"
                                },
                                title: {
                                    align: "left",
                                    content: "1. Start with your own procurement team and region.",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 2",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Language training can be billed in a variety of ways depending on who requested the vendor, and why they need the solution. Confirm L&D purchasing policies with each category manager in your region. "
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "115px",
                                    width: "115px"
                                },
                                title: {
                                    align: "left",
                                    content: "Pro tip:",
                                    theme: "blue",
                                    type: "sub-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    align: "left",
                                    content: "Look for patterns in language training spending over the past few years. Have language expenses increased from year-to-year? How are these costs billed? Are these language solutions sourced from multiple vendors or a single vendor? You’ll also want to take a look at corporate credit card accounts, and employee benefit initiatives, like tuition reimbursement programs. "
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "115px",
                                    width: "115px"
                                },
                                title: {
                                    align: "left",
                                    content: "2. Review departmental language training expenses.",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 4",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    align: "left",
                                    content: "L&D expenses can vary from year to year, so you’ll need to look back a few years. Be sure to also look beyond L&D use cases. Some department heads will use language tools for specific use cases, often going unnoticed in a general cost audit. "
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "115px",
                                    width: "115px"
                                },
                                title: {
                                    align: "left",
                                    content: "Pro tip:",
                                    theme: "blue",
                                    type: "sub-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 5",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    align: "left",
                                    content: "If purchasing is decentralized or broken out by region, you may need to do a little more legwork. A good place to start is by asking regional leaders to identify department heads responsible for tracking L&D, HR, software, and related spends. Then have those department heads identify which language costs are billed as direct or indirect expenses."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "115px",
                                    width: "115px"
                                },
                                title: {
                                    align: "left",
                                    content: "3. Zero in on region-specific language training expenses.",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 6",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    align: "left",
                                    content: "If you have a global language policy, start by asking regional leaders if they’re using that policy to purchase new language solutions. "
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "115px",
                                    width: "115px"
                                },
                                title: {
                                    align: "left",
                                    content: "Pro tip:",
                                    theme: "blue",
                                    type: "sub-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 7",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    align: "left",
                                    content: "Rosetta Stone Enterprise helps some of the world’s leading brands realize big cost savings by helping them streamline procurement by consolidating their language spend to a single, award-winning enterprise language training solution. "
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "60%",
                                    width: "60%"
                                },
                                title: {
                                    align: "left",
                                    content: "So you’re overspending on language training... Now what?",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 8",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: ""
                                },
                                custom: {
                                    cta: {
                                        destination: "/pricing-request/",
                                        internal: true,
                                        size: "regular",
                                        theme: "yellow_black",
                                        text: "Talk To A Language Expert"
                                    }
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Join thousands of leading organizations saving big on language training with Rosetta Stone Enterprise!",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    }
                ],
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "experience-making-the-case") {
        pageConfig = {
            page,
            eloquaPage: "webpage",
            helmet: {
                meta_title: "Making the Case | Rosetta Stone Enterprise",
                meta_description: "It’s time to choose a language training program. Do you go old school with face-to-face instruction or empower your employees to learn online? Here’s how to make a strong business case for online language training.",
                canonical_url: "https://www.rosettastone.com/enterprise/experience/making-the-case/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        data_qa: "Section 1",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: `
                                        It’s time to choose a language training program. Do you go old school with face-to-face instruction or empower your employees to learn online?
                                        <br/>
                                        <br/>
                                        Here’s how to make a strong business case for online language training.
                            `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Making the case for online language training.",
                                    heading: "h1",
                                    theme: "blue",
                                    type: "page-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 2",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Face-to-face training requires additional expenses beyond the cost of a learning module. But when your employees learn a language online, many of those costs vanish.",
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "60%",
                                    width: "60%"
                                },
                                sub_body: {
                                    content: "Converting your language spend from many local providers to one global platform is a clear cost-saver.",
                                    dangerous: true
                                },
                                sub_title: {
                                    align: "left",
                                    content: "Consolidate vendors.",
                                    theme: "black",
                                    type: "sub-title"
                                },
                                title: {
                                    align: "left",
                                    content: "Start with cost savings.",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    align: "left",
                                    content: "One of the world’s largest consulting companies serves clients in over <strong>100</strong> countries and invests in language training on a global scale. After partnering with Rosetta Stone, the company reduced its vendor network and realized first-year cost savings of more than <strong>$500,00</strong>.",
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "75%",
                                    width: "75%"
                                },
                                title: null
                            },
                            {
                                body: {
                                    content: "A global manufacturing leader was able to increase its language offering from 2,000 employees to <strong>77,000</strong> while still saving over <strong>$3 million</strong> annually by simply switching from an international array of vendors to our single-source solution.",
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "75%",
                                    width: "75%"
                                },
                                title: null
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 4",
                        layout: "duo",
                        panels: [
                            {
                                body: {
                                    align: "center",
                                    content: "Verifying new candidates’ language proficiency levels can be critical. Now your talent development team can rely on language assessments available with your existing licenses.",
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "toggle-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "center",
                                    content: "Start with cost savings.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "card-title"
                                },
                                toggle: {
                                    body: {
                                        align: "left",
                                        content: "A global professional services firm has tested more than 10,000 candidates through online assessments. An alternative was to use an outside language service at a cost of  $40 per person. Instead, the company chose the online CEFR-based Rosetta Stone assessment in the program, at no additional cost.",
                                        dangerous: true
                                    },
                                    title: null
                                }
                            },
                            {
                                body: {
                                    align: "center",
                                    content: "Moving away from a dedicated training space achieves another level of cost savings."
                                },
                                data_qa: null,
                                direction: "toggle-right",
                                image: {
                                    src: null,
                                    height: "250px",
                                    width: "250px"
                                },
                                title: {
                                    align: "center",
                                    content: "Act sustainably.",
                                    heading: "h3",
                                    theme: "black",
                                    type: "card-title"
                                },
                                toggle: {
                                    body: {
                                        align: "left",
                                        content: `
                                <ul>
                                    <li>Eliminating employee and instructor travel</li>
                                    <li>Cutting classroom space and maintenance</li>
                                    <li>Replacing printed materials with online lessons</li>
                                    <li>Allowing learners to use their personal devices</li>
                                </ul>
                            `,
                                        dangerous: true
                                    },
                                    title: {
                                        align: "left",
                                        content: "Achieve more savings by:",
                                        heading: "h3",
                                        theme: "black",
                                        type: "sub-title"
                                    }
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 5 - Know your learners.",
                        layout: "carousel",
                        panels: [
                            {
                                body: {
                                    content: "Just as today’s learners curate their own content experiences in their personal lives on social media, they expect the same experience at work."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Curators of their own experience.",
                                    heading: "h3",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            },
                            {
                                body: {
                                    content: "They want to give and receive feedback on the learning process—how to improve as a learner, and how the organization can help them succeed in their own online learning experiences."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Employer empowerment helps them thrive.",
                                    heading: "h3",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            },
                            {
                                body: {
                                    content: "Modern employees are also more likely to invest in their careers at organizations invested in their skill development—lowering your own retention spend in the process."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Loyal to organizations that invest in skill development. ",
                                    heading: "h3",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            }
                        ],
                        title: {
                            align: "center",
                            content: "Know your learners.",
                            heading: "h2",
                            theme: "blue",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        data_qa: "Section 6",
                        layout: "carousel",
                        panels: [
                            {
                                body: {
                                    content: "Seamless, immersive learning experiences guide learners from assessment to proficiency employing a proven, unified method on any device."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Flexible. Mobile. Easy to use.",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            },
                            {
                                body: {
                                    content: "Learn from native speakers 24/7. Employees access tutoring sessions from virtually anywhere in the world to fit their own schedules."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Online Tutoring from native speakers.",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            },
                            {
                                body: {
                                    content: "Access an integrated reporting dashboard where you can track and monitor each employee’s learning progress."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Smart dashboards.",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            },
                            {
                                body: {
                                    content: `Choose from 24 languages.<br/>
                               Switch at any time.<br/>
                               The only limit? Hours in the day.
                              `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Access all our languages.",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            }
                        ],
                        title: {
                            align: "center",
                            content: "Choose our award-winning enterprise solution.",
                            theme: "blue",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        data_qa: "Section 7",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Rosetta Stone is dedicated to using the power of language and literacy education to change people's lives. Millions of inspired learners have used our online and mobile solutions at home, in the workplace, and in schools around the world."
                                },
                                custom: {
                                    cta: {
                                        destination: "/pricing-request/",
                                        internal: true,
                                        size: "regular",
                                        theme: "yellow_black",
                                        text: "Talk To A Language Expert"
                                    }
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Join thousands of fellow industry leaders",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 8",
                        layout: "list",
                        panels: [
                            {
                                data_qa: null,
                                banner: {
                                    src: null
                                }
                            }
                        ],
                        visible: true
                    }
                ],
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "experience-nine-warning-signs") {
        pageConfig = {
            page,
            eloquaPage: "webpage",
            helmet: {
                meta_title: "Nine Warning Signs | Rosetta Stone Enterprise",
                meta_description: "Communication lives right at the heart of every business. It fuels everything you do from strategy to execution. Without clear communication your entire organization may suffer a business loss.",
                canonical_url: "https://www.rosettastone.com/enterprise/experience/nine-warning-signs/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        data_qa: "Section 1 - Header",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Communication lives right at the heart of every business. It fuels everything you do from strategy to execution. Without clear communication your entire organization may suffer a business loss:"
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "9 warning signs your employees need language training.",
                                    heading: "h1",
                                    theme: "blue",
                                    type: "page-title"
                                },
                                custom: {
                                    body: {
                                        content: `
                                            When you add a language barrier to the equation, things get even more complicated. What if you’re communicating to a coworker, boss, or customers in a language you don’t speak very well?
                                            <br />
                                            <br />
                                            If you’re worried your organization might have a language problem, it’s time to do an honest assessment.
                                        `,
                                        dangerous: true
                                    },
                                    list: [
                                        "A loss of revenue.",
                                        "A loss of productivity.",
                                        "A loss of a customer.",
                                        "A loss of an employee.",
                                        "A loss of credibility."
                                    ],
                                    title: {
                                        align: "left",
                                        content: "These are losses no organization can afford. ",
                                        theme: "black",
                                        type: "sub-title"
                                    }
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 2 - 9 Bullets",
                        layout: "list",
                        title: {
                            align: "center",
                            content: "9 signs you may have a language problem.",
                            heading: "h2",
                            theme: "blue",
                            type: "page-title"
                        },
                        panels: [
                            {
                                body: {
                                    content: `
                                A diverse, multilingual workforce is definitely worth celebrating. Keeping everyone informed about their roles, basic responsibilities, policies, and safety protocols is both a liability and a major challenge for productivity across the organization.
                                <br/>
                                <br/>
                                Solving this challenge involves a focused effort across your entire business to shift employees’ perception of language training.
                                `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "1. You have a diverse workforce",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                            Do multilingual employees fully understand safety policies and protocols? How does that impact their daily tasks and your ability to retain them?
                                            <br/>
                                            <br/>
                                            Safety compliance in a multilingual workplace is a critical and expensive problem to solve. Depending on the severity of the incident, miscommunicating a seemingly simple safety protocol can cost hundreds of thousands in compliance penalties.
                                        `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "2. On-the-job safety incidents have increased",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                            Are you fully aware of the languages your customers speak? Have you ever lost a customer due to a language barrier that provided a bad experience? Do you understand the role of communication in each of your customers’ local cultures?
                                            <br/>
                                            <br/>
                                            Your answers to these questions may reveal a clear need for language training that truly immerses your employees in daily speaking practice with native speakers to truly understand the preferences of your customers.
                                        `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "3. Customer service is compromised",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                Research shows that 60% of employees will stick with an employer if they provide language training as part of their professional development programs. Meanwhile, only 30% of companies actively make that investment.
                                <br/>
                                <br/>
                                A holistic retention strategy includes language training as an additional element of professional development across your business.
                            `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "4. Employee turnover is on the rise",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                            Language barriers are presented in many forms on-the-job. One common result of miscommunication comes in the form of misunderstood job expectations.
                                            <br/>
                                            <br/>
                                            This often means lowered productivity, more mistakes on the job, and general frustration from your broader teams. Operationally, you may default to lowering expectations for Limited English Proficiency (LEP) employees, which can damage morale and result in higher turnover.
                                        `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "5. Lowered job expectations",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                            Since you’re already investing time and resources into training LEP employees, it makes perfect sense to retain those employees. Adding language training to your employee development plan can go a long way to show every employee you are invested in their future with your company.
                                        `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "6. Employee onboarding takes longer",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "When language barriers are a hurdle for career advancement, your employees will be less engaged in their work and are less likely to pursue advancement within your organization. Create a win-win situation for your employees. Use language training to help them take the next best step for their career.",
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "7. LEP team members' careers have stalled",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: `
                                            Do you have a collaboration and productivity problem across your global teams? Language barriers could be at play, while your employees look to you for an effective training solution.
                                            <br/>
                                            <br/>
                                            A recent survey of Rosetta Stone Enterprise users showed two of the most desired outcomes include teamwide collaboration (66% of respondents) and improved verbal communication (68% of respondents) with teammates.
                                        `,
                                    dangerous: true
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "8. Collaboration is an ongoing challenge",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Is your hiring strategy impacted by language challenges across your business? As you look to fill future roles and grow your business abroad, it’s critical to take stock of how language barriers will impact employee performance, compliance, retention and growth."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100px",
                                    width: "100px"
                                },
                                title: {
                                    align: "left",
                                    content: "9. Future employees face similar obstacles",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        data_qa: "Section 3 - Brand Images",
                        layout: "list",
                        panels: [
                            {
                                destination: "",
                                image: {
                                    type: "static",
                                    alt: "Sony Pictures",
                                    src: logos.logoSonyPicturesPng,
                                    height: "100px",
                                    width: "100px"
                                },
                                name: "Sony Pictures"
                            },
                            {
                                destination: "",
                                image: {
                                    type: "static",
                                    alt: "Twitter",
                                    src: logos.logoTwitterPng,
                                    height: "100px",
                                    width: "100px"
                                },
                                name: "Twitter"
                            },
                            {
                                destination: "",
                                image: {
                                    type: "static",
                                    alt: "Amgen",
                                    src: logos.logoAmgenPng,
                                    width: "150px"
                                },
                                name: "Amgen"
                            },
                            {
                                destination: "",
                                image: {
                                    type: "static",
                                    alt: "FICO",
                                    src: logos.logoFicoPng,
                                    width: "150px"
                                },
                                name: "FICO"
                            }
                        ],
                        title: {
                            align: "center",
                            content: "Leading brands use language solutions from Rosetta Stone Enterprise",
                            heading: "h2",
                            theme: "blue",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        data_qa: "Section 4 - Enterprise Solutions",
                        layout: "carousel",
                        panels: [
                            {
                                body: null,
                                custom: {
                                    body: {
                                        content: "Regardless of industry, language barriers present a complex problem to solve for any organization. The good news is that flexible, immersive language tools help set your team up for success by maximizing collaboration and employee engagement in a way that aligns with your larger business strategy."
                                    },
                                    cta: {
                                        destination: "/",
                                        internal: true,
                                        size: "regular",
                                        theme: "yellow_black",
                                        text: "Learn More"
                                    },
                                    list: [
                                        "Drive down language training costs across your organization",
                                        "Attract and retain top-tier talent",
                                        "Improve communication and collaboration",
                                        "Foster a customer-obsessed work culture"
                                    ]
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Curators of their own experience.",
                                    theme: "black",
                                    type: "sub-title"
                                }
                            }
                        ],
                        title: {
                            align: "center",
                            content: "With enterprise language solutions from Rosetta Stone you can:",
                            heading: "h2",
                            theme: "blue",
                            type: "section-title"
                        },
                        visible: true
                    }
                ],
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Rosetta Stone for Enterprise | Rosetta Stone",
                meta_description: "12,000+ leading brands engage their employees with Rosetta Stone Enterprise.",
                canonical_url: "https://www.rosettastone.com/enterprise/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        lead_generation_button: {
                            schedule_appointment: false,
                            completion_redirect: null,
                            button: {
                                destination: "/pricing-request/",
                                internal: true,
                                new_window: false,
                                size: "regular",
                                text: "Request Pricing",
                                theme: "yellow_black"
                            }
                        },
                        data_qa: "Header",
                        sub_title: {
                            align: "center",
                            content: "12,000+ leading brands engage their employees with Rosetta Stone Enterprise.",
                            theme: "white",
                            type: "page-sub-title"
                        },
                        title: {
                            align: "center",
                            content: "Language training for enterprise teams.",
                            heading: "h1",
                            theme: "white",
                            type: "page-title"
                        },
                        visible: true
                    },
                    {
                        title: {
                            align: "center",
                            content: "A proven enterprise language solution.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        data_qa: "Section 2 - Cards",
                        layout: "carousel",
                        panels: [
                            {
                                body: {
                                    align: "center",
                                    content: "Invest in employee success. Help them learn a new language on any device—online or offline.",
                                    type: "card"
                                },
                                video: {
                                    src: animations.usEnterpriseTopTalentMp4,
                                    type: "video/mp4"
                                },
                                title: {
                                    align: "center",
                                    content: "Retain Top Talent",
                                    heading: "h3",
                                    type: "card-title",
                                    theme: "blue"
                                }
                            },
                            {
                                body: {
                                    align: "center",
                                    content: "Save big when you switch from face-to-face instructors to online language tutors.",
                                    type: "card"
                                },
                                video: {
                                    src: animations.usEnterpriseCutCostsMp4,
                                    type: "video/mp4"
                                },
                                title: { content: "Cut Costs", heading: "h3", type: "card-title", theme: "blue" }
                            },
                            {
                                body: {
                                    align: "center",
                                    content: "Help your employees speak and work confidently across language barriers.",
                                    type: "card"
                                },
                                video: {
                                    src: animations.usEnterpriseWorkBetterMp4,
                                    type: "video/mp4"
                                },
                                title: {
                                    content: "Work Better Together",
                                    heading: "h3",
                                    type: "card-title",
                                    theme: "blue"
                                }
                            },
                            {
                                body: {
                                    align: "center",
                                    content: "Track, measure, and optimize your language training programs for learner success with detailed learner dashboards. ",
                                    type: "card"
                                },
                                video: {
                                    src: animations.usEnterpriseLearnerSuccessMp4,
                                    type: "video/mp4"
                                },
                                title: {
                                    content: "Enable Learner Success",
                                    heading: "h3",
                                    type: "card-title",
                                    theme: "blue"
                                }
                            }
                        ]
                    },
                    {
                        data_qa: "Section 3 - Animation Text",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Going from many language providers to a single, proven online platform is a clear cost-saver. Give your employees flexible language learning tools that help immerse them in everyday speaking at the pace and place of their choosing."
                                },
                                custom: {
                                    cta_1: {
                                        destination: "https://www.rosettastone.com/enterprise/experience/making-the-case/?eeid=oo-e1-co&campaignid=7010W0000027w78&utm_campaign=US-CORP-content-traffic&utm_source=content&utm_content=",
                                        internal: false,
                                        new_window: false,
                                        size: "regular",
                                        text: "Show me the guide",
                                        theme: "yellow_black"
                                    }
                                },
                                data_qa: null,
                                direction: "image-right",
                                animation: {
                                    asset_static: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Making the case for online training.",
                                    heading: "h2",
                                    theme: "blue",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        custom: {
                            cta_1: {
                                destination: "/resources/content/a-decade-of-language-training-success/",
                                internal: true,
                                new_window: false,
                                size: "regular",
                                theme: "yellow_black",
                                text: "Read the latest customer story"
                            }
                        },
                        data_qa: "Section 4 - Brand Images",
                        layout: "list",
                        panels: awards$5({ strings }).panels,
                        title: {
                            align: "center",
                            content: "Join 12,000+ leading organizations.",
                            heading: "h2",
                            theme: "blue",
                            type: "page-title"
                        },
                        visible: true
                    }
                ],
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "industry-construction") {
        pageConfig = {
            page,
            eloquaPage: "construction",
            helmet: {
                meta_title: "Language Training for Construction | Rosetta Stone",
                meta_description: "Delivering language training solutions across your construction organization helps alleviate costs due to employee productivity, safety compliance, and overall employee retention.",
                canonical_url: "https://www.rosettastone.com/enterprise/industry/construction/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        dataQa: "1",
                        panels: [
                            {
                                dataQa: "1",
                                body: {
                                    content: "Investing in language training can have a huge impact on your construction organization—from reduced safety incidents to lower turnover costs. When your employees understand each other regardless of their native language, your job sites will become safer, more productive, and ultimately more profitable."
                                },
                                custom: {
                                    cta: {
                                        destination: "/enterprise/resources/content/forbes-insights-reducing-the-impact-of-language-barriers/",
                                        new_window: false,
                                        size: "regular",
                                        text: "Read Report",
                                        theme: "blue_white"
                                    },
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/construction/",
                                        button: {
                                            internal: true,
                                            destination: "/pricing-request/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                direction: "image-right",
                                title: {
                                    align: "left",
                                    content: "Improve job site operations.",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                hasCtaRedirect: true
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "2",
                        layout: "list",
                        panels: [
                            {
                                image: {
                                    type: "static",
                                    alt: "Caterpillar",
                                    src: logosTiles.logosTilesCaterpillarSvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "DPR Construction",
                                    src: logosTiles.logosTilesDprSvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "Tishman Speyer",
                                    src: logosTiles.logosTilesTishSvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "Crowder",
                                    src: logosTiles.logosTilesCrowderSvg
                                }
                            }
                        ],
                        title: {
                            align: "center",
                            content: "Proven language solutions for leading construction organizations.",
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Every job site safety incident is expensive, costing some construction organizations hundreds of thousands of dollars in compliance penalties a year. By equipping your non-English speaking employees with language training, you can reduce safety incidents caused by language barriers."
                                },
                                direction: "image-left",
                                image: {},
                                title: {
                                    align: "left",
                                    content: "Reduce risk.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Language differences across the modern job site can lead to loss of productivity and detrimental drops in quality—often fueled by poor communication across multiple languages. An investment in language training streamlines communication in a way that engages your employees to do their best work."
                                },
                                direction: "image-right",
                                image: {},
                                title: {
                                    align: "left",
                                    content: "See your crews’ best work.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Investing in employee language training can go a long way to bolster retention initiatives within your organization—reducing turnover costs while making you an industry leader."
                                },
                                direction: "image-left",
                                image: {},
                                title: {
                                    align: "left",
                                    content: "Drive down turnover costs.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: false
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings }),
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "industry-consulting") {
        pageConfig = {
            page,
            eloquaPage: "consulting",
            helmet: {
                meta_title: "Language Training for Consulting | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.com/enterprise/industry/consulting/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        dataQa: "1",
                        panels: [
                            {
                                body: {
                                    content: "There are plenty of barriers that limit consulting firms from expanding into new markets—chief among them is the language barrier. By providing your entire organization with language training you greatly improve the prospects of profitable expansion into new regions."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/consulting/",
                                        button: {
                                            internal: true,
                                            destination: "/pricing-request/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                video: {
                                    currentVideoUrl: "https://player.vimeo.com/video/591202724",
                                    playing: false,
                                    controls: true
                                },
                                direction: "content-right",
                                title: {
                                    align: "left",
                                    content: "Speak every new client’s language.",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                hasCtaRedirect: false,
                                thanks: "Thanks for your interest! Someone will follow up with you shortly."
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "2",
                        layout: "list",
                        panels: [],
                        title: {
                            align: "center",
                            content: "Proven language solutions for leading hospitality organizations.",
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    },
                    {
                        dataQa: "3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Your organization may have some of the industry’s brightest consultants, but a lack of language skills may be causing significant work inefficiencies. Improve productivity with a broader multilingual talent pool."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Collaborate globally.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "The best and brightest are hard to retain because top talent in the professional consulting industry is on every firm’s radar. Adding language training to your professional development mix can help you differentiate from your competitors and alleviate the strain of turnover costs."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Drive down turnover.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Corporations lose millions each year from employee turnover, making it a top organisational challenge. Investing in language training for employees can enhance your retention initiatives by enabling your staff to grow in their careers."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "80%",
                                    width: "80%"
                                },
                                title: {
                                    align: "left",
                                    content: "Attract and retain top talent.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: "Keep Exploring",
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                copyData: copyData$5(),
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings }),
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "industry-foodservice") {
        pageConfig = {
            page,
            eloquaPage: "foodservice",
            helmet: {
                meta_title: "Language Training for Food Service | Rosetta Stone",
                meta_description: "Flexible language training solutions help large food service organizations reduce communication barriers that get in the way of serving each customer effectively. Everyone from the front-of-house to back-of-house is better equipped to deliver amazing experiences regardless of language barriers.",
                canonical_url: "https://www.rosettastone.com/enterprise/industry/foodservice/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                dataQa: "1",
                                body: {
                                    content: "Language training helps you reduce language barriers that get in the way of great customer experiences. Equip everyone from the front-of-house to back-of-house to deliver amazing customer service."
                                },
                                custom: {
                                    cta: {
                                        destination: "/enterprise/resources/content/foodservice-operator-language-training/",
                                        new_window: false,
                                        size: "regular",
                                        text: "View Infographic",
                                        theme: "blue_white"
                                    },
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/foodservice/",
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                title: {
                                    align: "left",
                                    content: "Serve up the right language every time.",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                hasCtaRedirect: true
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "2",
                        layout: "list",
                        panels: [
                            {
                                image: {
                                    type: "static",
                                    alt: "Bar S Foods",
                                    src: logosTiles.logosTilesBarSSvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "Georges",
                                    src: logosTiles.logosTilesGeorgesSvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "Leclerc",
                                    src: logosTiles.logosTilesLeclercSvg
                                }
                            }
                        ],
                        title: {
                            align: "center",
                            content: "Proven language solutions for leading food service organizations.",
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Investing in language training for your Limited English Proficiency (LEP) employees can go a long way toward driving down turnover costs in your organization."
                                },
                                direction: "image-left",
                                image: {},
                                title: {
                                    align: "left",
                                    content: "Retain the best in the food service industry.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "By simply equipping these hourly LEP employees with language training you reduce compliance risk by ensuring that all safety protocols are communicated among all kitchen staff."
                                },
                                direction: "image-right",
                                image: {},
                                title: {
                                    align: "left",
                                    content: "Safer kitchen operations start with better communication.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Removing language barriers is essential for driving productivity, collaboration, and streamlined operations at each of your locations. Bridge the communication gap between your kitchen staff with language training solutions from Rosetta Stone."
                                },
                                direction: "image-left",
                                image: {},
                                title: {
                                    align: "left",
                                    content: "Language barriers: a recipe for disaster.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                copyData: copyData$5(),
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings }),
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "industry-government") {
        pageConfig = {
            page,
            eloquaPage: "government",
            helmet: {
                meta_title: "Language Training for Government | Rosetta Stone",
                meta_description: "Government employees on the federal, state, or local level require an in-depth understanding of the communities they serve—their needs, concerns, cultures, and yes, the languages they speak. Equipping your government employees with effective, online language training can help ensure they are thoughtfully and effectively meeting the needs of the multilingual communities they serve.",
                canonical_url: "https://www.rosettastone.com/enterprise/industry/government/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                dataQa: "1",
                                body: {
                                    content: "Government employees on the federal, state, or local level require an in-depth understanding of the communities they serve—their needs, concerns, cultures, and yes, the languages they speak. Equipping your government employees with effective, online language training can help ensure they are thoughtfully and effectively meeting the needs of the multilingual communities they serve."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/foodservice/",
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                title: {
                                    align: "left",
                                    content: "Effective language solutions for government employees.",
                                    heading: "h1",
                                    theme: "black",
                                    type: "page-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "2",
                        layout: "list",
                        panels: [],
                        title: {
                            align: "center",
                            content: "Proven language solutions for leading hospitality organizations.",
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    },
                    {
                        dataQa: "3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Take full advantage of our globally-recognized assessment standards (CEFR, CLP, and ILR) to identify your team’s diverse language training needs."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Industry-leading assessments.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Rosetta Stone is a GSA-approved vendor serving more than 9,000 public sector organizations across the United States."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "GSA approved.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Use smart, integrated dashboards to monitor each employee’s progress. Then reinforce every team member’s speaking, listening, writing, and everyday conversation skills with daily lessons from certified language experts."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Empower speaking success.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                copyData: copyData$5(),
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings }),
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "industry-healthcare") {
        pageConfig = {
            page,
            eloquaPage: "healthcare",
            helmet: {
                meta_title: "Language Training for Healthcare | Rosetta Stone",
                meta_description: "Build trust and loyalty while improving patient satisfaction by speaking your patients' native language. By eliminating language barriers throughout your organization, you can serve more patients in new locations, while reducing costs associated with compliance risk by delivering critical medical information to each patient clearly and effectively.",
                canonical_url: "https://www.rosettastone.com/enterprise/industry/healthcare/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        dataQa: "1",
                        panels: [
                            {
                                video: {
                                    currentVideoUrl: "https://player.vimeo.com/video/591204981",
                                    playing: false,
                                    controls: true
                                },
                                body: {
                                    content: "When both caregivers and patients truly understand each other—regardless of their native language—patient satisfaction goes up while medical errors and other costly risks go down. Flexible language training helps providers speak, write, listen, and ultimately care for each patient with clarity and purpose.  See language training for healthcare in action."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/healthcare/",
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                title: {
                                    align: "left",
                                    content: "Great care starts with a conversation.",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "2",
                        layout: "list",
                        panels: [
                            {
                                image: {
                                    type: "static",
                                    alt: "Amgen",
                                    src: logosTiles.logosTilesAmgenSvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "CVS Health",
                                    src: logosTiles.logosTilesCvsSvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "NYC Health",
                                    src: logosTiles.logosTilesNycHealthSvg
                                }
                            }
                        ],
                        title: {
                            align: "center",
                            content: "Proven language solutions for leading hospitality organizations.",
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "In the hospitality business, excellent customer care requires delivering the best possible service to each patron, regardless of their native language. Language training can help you launch a business culture of customer obsession as you serve every customer in their own language."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "How do you say ‘enjoy your stay?’",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "While there are plenty of barriers to high-value market growth, chief among them is a language barrier. By providing your entire organization with language training you prepare staff for profitable expansion into a new region without limits."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Don’t let language hinder global expansion.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Investing in language training for your employees can go a long way to bolster retention initiatives within your organization—reducing turnover costs while raising you up as an industry leader."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Retain the best people.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                copyData: copyData$5(),
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings }),
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "industry-hospitality") {
        pageConfig = {
            page,
            eloquaPage: "hospitality",
            helmet: {
                meta_title: "Language Training for Hospitality | Rosetta Stone",
                meta_description: "Hospitality organizations use the power of language training to fuel a customer-obsessed business culture. Since hospitality is a global enterprise, this means speaking the language of every customer. Language training helps your organization deliver these experiences.",
                canonical_url: "https://www.rosettastone.com/enterprise/industry/hospitality/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        dataQa: "1",
                        panels: [
                            {
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                dataQa: "1",
                                body: {
                                    content: "Friendly, helpful conversations live right at the heart of the hospitality industry— where every customer interaction begins with a simple “hello” and often ends with a “thank you.” Speak the global language of customer obsession."
                                },
                                custom: {
                                    cta: {
                                        destination: "/enterprise/resources/content/forbes-insights-reducing-the-impact-of-language-barriers/",
                                        new_window: false,
                                        size: "regular",
                                        text: "Read Report",
                                        theme: "blue_white"
                                    },
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/hospitality/",
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                title: {
                                    align: "left",
                                    content: "White glove service in any language.",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                hasCtaRedirect: true
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "2",
                        layout: "list",
                        panels: [
                            {
                                image: {
                                    type: "static",
                                    alt: "Marriott International",
                                    src: logosTiles.logosTilesMarriottSvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "PPHE Hotel Group",
                                    src: logosTiles.logosTilesPpheSvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "Vi",
                                    src: logosTiles.logosTilesViSvg
                                }
                            }
                        ],
                        title: {
                            align: "center",
                            content: "Proven language solutions for leading hospitality organizations.",
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "In the hospitality business, excellent customer care requires delivering the best possible service to each patron, regardless of their native language. Language training can help you launch a business culture of customer obsession as you serve every customer in their own language."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "How do you say ‘enjoy your stay?’",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "While there are plenty of barriers to high-value market growth, chief among them is a language barrier. By providing your entire organization with language training you prepare staff for profitable expansion into a new region without limits."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Don’t let language hinder global expansion.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Investing in language training for your employees can go a long way to bolster retention initiatives within your organization—reducing turnover costs while raising you up as an industry leader."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Retain the best people.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                copyData: copyData$5(),
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings }),
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "industry-manufacturing") {
        pageConfig = {
            page,
            eloquaPage: "manufacturing",
            helmet: {
                meta_title: "Language Training for Manufacturing | Rosetta Stone",
                meta_description: "There are plenty of barriers that limit manufacturing firms from improving safety, retaining quality talent, and expanding into new, global markets—chief among them is the language barrier. By providing your entire organization with language training you are able to better control out of control operations costs associated with compliance, productivity, and global expansion.",
                canonical_url: "https://www.rosettastone.com/enterprise/industry/manufacturing/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                dataQa: "1",
                                body: {
                                    content: "There are plenty of barriers that limit manufacturing firms from expanding into a new market—chief among them is the language barrier. Providing your entire organization with language training goes a long way toward a profitable expansion into new regions."
                                },
                                custom: {
                                    cta: {
                                        destination: "/enterprise/resources/content/forbes-insights-reducing-the-impact-of-language-barriers/",
                                        new_window: false,
                                        size: "regular",
                                        text: "Read Report",
                                        theme: "blue_white"
                                    },
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/manufacturing/",
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Speak the global language of manufacturing.",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                hasCtaRedirect: true
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "2",
                        layout: "list",
                        panels: [
                            {
                                image: {
                                    type: "static",
                                    alt: "BMW",
                                    src: logosTiles.logosTilesBmwSvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "GM",
                                    src: logosTiles.logosTilesGmSvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "Lam Research",
                                    src: logosTiles.logosTilesLamSvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "Phillip Morris International",
                                    src: logosTiles.logosTilesPmiSvg
                                }
                            }
                        ],
                        title: {
                            align: "center",
                            content: "Proven language solutions for leading manufacturing organizations.",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Safety is on the mind of every manufacturing firm’s HR leader. While not all safety-related incidents are fatal, they are all expensive. One small misinterpretation of a safety protocol can lead to significant losses in just a single incident. Ensure you’re doing all you can to keep each employee safe. Equip them with flexible language training."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Make safety a priority.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Language barriers across the modern warehouse can lead to loss of productivity and drops in quality when a multilingual workforce cannot communicate clearly. See the best work from everyone on the production line with language training."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Reduce productivity barriers.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Voluntary turnover costs the manufacturing industry millions of dollars each year. Add language training to your professional development program to attract and retain the industry’s very best."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Drive down retention costs",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                copyData: copyData$5(),
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings }),
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "industry-retail") {
        pageConfig = {
            page,
            eloquaPage: "retail",
            helmet: {
                meta_title: "Language Training for Retail | Rosetta Stone",
                meta_description: "There are plenty of barriers that limit manufacturing firms from improving safety, retaining quality talent, and expanding into new, global markets—chief among them is the language barrier. By providing your entire organization with language training you are able to better control out of control operations costs associated with compliance, productivity, and global expansion.",
                canonical_url: "https://www.rosettastone.com/enterprise/industry/retail/",
                lang: "en"
            },
            content: {
                sections: [
                    {
                        dataQa: "1",
                        panels: [
                            {
                                body: {
                                    content: "Thoughtful, engaging conversation is the hallmark of award-winning retail experiences. It’s the first line of relationship-building that leads to trust and customer satisfaction. Flexible language training helps retailers reduce language differences that get in the way of great customer experiences."
                                },
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                custom: {
                                    cta: {
                                        destination: "/enterprise/resources/content/customer-spotlight-stella-mccartney/",
                                        new_window: false,
                                        size: "regular",
                                        text: "Read Case Study",
                                        theme: "blue_white"
                                    },
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: "/industry/retail/",
                                        button: {
                                            destination: "/pricing-request/",
                                            internal: true,
                                            new_window: false,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                direction: "image-right",
                                title: {
                                    align: "left",
                                    content: "Speak the universal language of customer service.",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                hasCtaRedirect: true
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "2",
                        layout: "list",
                        panels: [
                            {
                                image: {
                                    type: "static",
                                    alt: "O'Reilly Auto Parts",
                                    src: logosTiles.logosTilesOreillySvg
                                }
                            },
                            {
                                image: {
                                    type: "static",
                                    alt: "Williams Sonoma",
                                    src: logosTiles.logosTilesWsSvg
                                }
                            }
                        ],
                        title: {
                            align: "center",
                            content: "Proven language solutions for leading retail organizations.",
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "3",
                        layout: "list",
                        panels: [
                            {
                                body: {
                                    content: "Retention is a top issue facing all retail establishments. Hourly Limited English Proficiency employees are among the most difficult and costly to attract and retain. Investing in language training for these employees can go a long way to bolster retention initiatives within your organization—setting you apart as an industry leader."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Attract and retain the best staff.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Safety compliance is a top concern for the retail industry, costing it billions of dollars in compliance penalties each year. By equipping your Limited English Proficiency (LEP) employees with language skills you reduce compliance risk, ensuring that all safety protocols are communicated effectively across your team."
                                },
                                data_qa: null,
                                direction: "image-right",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Make retail ops safer.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            },
                            {
                                body: {
                                    content: "Removing language barriers is essential for driving productivity, collaboration, and streamlined operations at each of your physical locations. Bridge the communication gap between your employees with language training solutions from Rosetta Stone."
                                },
                                data_qa: null,
                                direction: "image-left",
                                image: {
                                    src: null,
                                    height: "100%",
                                    width: "100%"
                                },
                                title: {
                                    align: "left",
                                    content: "Bridge the communication gap.",
                                    heading: "h2",
                                    theme: "black",
                                    type: "section-title"
                                }
                            }
                        ],
                        visible: true
                    },
                    {
                        dataQa: "4",
                        sub_title: {
                            align: "center",
                            content: "Please fill out the form below and we'll follow up with you right away.",
                            theme: "white",
                            type: "sub-title"
                        },
                        thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                        title: {
                            align: "center",
                            content: "Get the pricing answers you need.",
                            heading: "h2",
                            theme: "white",
                            type: "section-title"
                        },
                        visible: true
                    },
                    {
                        dataQa: "5",
                        default_button_label: strings.related_resources_button_label,
                        panels: [],
                        resource_ids: [
                            "reciMH1K4BjgQ84fN",
                            "recmSa35M1J9knw1q",
                            "reclFOyT4ITytBqqV",
                            "recQzXnf8QZQc3E8c"
                        ],
                        resources_url: "/resources/",
                        title: {
                            align: "center",
                            content: strings.related_resources_label,
                            heading: "h2",
                            theme: "black",
                            type: "section-title"
                        },
                        visible: false
                    }
                ],
                copyData: copyData$5(),
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings }),
                lead_generation_bar: lead_generation_bar$f()
            }
        };
    }
    if (page === "pricing-request") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.com/enterprise/pricing-request/",
                lang: "en"
            },
            content: {
                title: {
                    type: "section-title",
                    theme: "yellow",
                    content: "Book time with a Language Expert today"
                },
                sub_title: {
                    type: "section-title",
                    theme: "black",
                    content: "Please fill out the form below to schedule time to discuss how we can help."
                },
                lead_generation_form: {
                    title: {
                        theme: "blue",
                        type: "section-title",
                        content: "Almost there!"
                    },
                    fields: {
                        first_name: {
                            field_name: "first_name",
                            field_type: "text",
                            label: "First Name",
                            required: true,
                            required_error: "Please enter your First Name."
                        },
                        last_name: {
                            field_name: "last_name",
                            type: "text",
                            label: "Last Name",
                            required: true,
                            required_error: "Please enter your Last Name."
                        },
                        email: {
                            field_name: "email",
                            field_type: "email",
                            label: "Email Address",
                            required: true,
                            required_error: "Please enter your Email Address.",
                            validation_error: "Please enter a valid Email Address."
                        },
                        phone: {
                            field_name: "phone",
                            field_type: "tel",
                            label: "Phone Number",
                            required: true,
                            required_error: null
                        },
                        organization_name: {
                            field_name: "organization_name",
                            field_type: "text",
                            label: "Company",
                            required: true,
                            required_error: "Please enter your Company Name."
                        },
                        organization_size: {
                            field_name: "organization_size",
                            field_type: "text",
                            label: "Company Size",
                            required: true,
                            required_error: "Please enter your Company Size.",
                            options: [
                                { value: "", label: "" },
                                { value: "100 or Less", label: "100 or Less" },
                                { value: "101 - 500", label: "101 - 500" },
                                {
                                    value: "501 - 1,000",
                                    label: "501 - 1,000"
                                },
                                { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                {
                                    value: "10,001 - 25,000",
                                    label: "10,001 - 25,000"
                                },
                                {
                                    value: "25,001 - 50,000",
                                    label: "25,001 - 50,000"
                                },
                                {
                                    value: "50,001 or More",
                                    label: "50,001 or More"
                                }
                            ]
                        },
                        role: {
                            field_name: "title",
                            field_type: "select",
                            label: "Title",
                            required: true,
                            required_error: "Please enter your Role."
                        }
                    },
                    button: {
                        as: "button",
                        type: "submit",
                        size: "regular",
                        text: "Request Pricing"
                    },
                    labels: {
                        form_privacy1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's",
                        form_privacy2: "Privacy Policy",
                        form_privacy3: "I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at",
                        form_privacy4: ".",
                        form_privacyUrl: "https://www.rosettastone.com/privacy",
                        form_privacyemail: "privacyofficer@rosettastone.com",
                        form_updateagreement1: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
                        form_updateagreement2: "here",
                        form_updateagreement3: "for more information."
                    },
                    domain: ".com",
                    dataQaLocation: "page"
                },
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings }),
                lead_generation_bar: {
                    visible: false
                }
            }
        };
    }
    if (page === "pricing-request-complete") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.com/enterprise/pricing-request/",
                lang: "en"
            },
            content: {
                title: {
                    align: "center",
                    content: "Thanks for your interest!",
                    heading: "h1",
                    theme: "blue",
                    type: "page-title"
                },
                sub_title: {
                    align: "center",
                    heading: "h2",
                    content: "Check out some additional resources before your meeting!",
                    type: "page-sub-title"
                },
                resources_link: {
                    destination: "/resources/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Resources",
                    theme: "blue_white"
                },
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings }),
                lead_generation_bar: {
                    visible: false
                }
            }
        };
    }
    if (page === "pricing-request-schedule") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Pricing Request | Rosetta Stone",
                meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                canonical_url: "https://www.rosettastone.com/enterprise/pricing-request/",
                lang: "en"
            },
            content: {
                awards: awards$5({ strings }),
                branded_quotes: branded_quotes$5({ strings }),
                verticals: verticals$f({ strings })
            }
        };
    }
    return pageConfig;
};

var enterprise_footer_config$5 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_consumer_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/homeschool/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_homeschool_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/k12/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/enterprise/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/about/company/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "https://enterpriseblog.rosettastone.com/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_blog_label
                    },
                    {
                        visible: true,
                        destination: "https://pr.rosettastone.com/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/en/work/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/product/faq/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_faqs_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: false,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.com/legal/agreements/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.com/terms/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.com/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: true,
            label: strings.footer_meta_data_privacy_and_security_label,
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStone",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/rosettastone",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastone",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var us = ({ market, site, page, locale, strings }) => {
    let nav_secondary = null;
    let about_nav = null;
    let page_config = null;
    let footer_config = null;
    switch (site) {
        case "business":
        case "enterprise":
            nav_secondary = enterprise_nav_secondary_config$5({ strings });
            page_config = enterprise_pages_config$5({ page, strings });
            footer_config = enterprise_footer_config$5({ strings });
            break;
        case "consumer":
            page_config = consumer_pages_config$2({ page, strings });
            footer_config = consumer_footer_config$2({ strings });
            break;
        case "consumer-about":
            about_nav = consumer_about_nav_config();
            page_config = consumer_about_pages_config({ page, strings });
            footer_config = consumer_about_footer_config({ strings });
            break;
        case "consumer-discounts":
            page_config = consumer_discounts_pages_config({ page, strings });
            footer_config = consumer_discounts_footer_config({ strings });
            break;
        case "consumer-feature":
            page_config = consumer_feature_pages_config({ page, strings });
            footer_config = consumer_feature_footer_config({ strings });
            break;
        case "consumer-lausd":
            page_config = consumer_lausd_pages_config({ page });
            footer_config = consumer_lausd_footer_config({ strings });
            break;
        case "consumer-product-activation":
            page_config = consumer_product_activation_pages_config$6({ page });
            footer_config = consumer_product_activation_footer_config$6({ strings });
            break;
        case "consumer-legal":
            page_config = consumer_legal_pages_config({ page, strings });
            footer_config = consumer_legal_footer_config({ strings });
            break;
        case "consumer-product":
            page_config = consumer_product_pages_config({ page, strings });
            footer_config = consumer_product_footer_config({ strings });
            break;
        case "consumer-seo":
            page_config = consumer_seo_pages_config$2({ page, strings });
            footer_config = consumer_seo_footer_config$2({ strings });
            break;
        case "hed":
        case "education-secondary":
            nav_secondary = education_secondary_nav_secondary_config$5({ strings });
            page_config = education_secondary_pages_config$5({ page, strings });
            footer_config = education_secondary_footer_config$5({ strings });
            break;
        case "homeschool":
        case "education-homeschool":
            nav_secondary = education_homeschool_nav_secondary_config({ strings });
            page_config = education_homeschool_pages_config({ page, strings });
            footer_config = education_homeschool_footer_config({ strings });
            break;
        case "education-homeschool-seo":
            page_config = education_homeschool_seo_pages_config({ page, strings });
            footer_config = education_homeschool_seo_footer_config({ strings });
            break;
        case "k12":
        case "education-primary":
            nav_secondary = education_primary_nav_secondary_config$5({ strings });
            page_config = education_primary_pages_config$5({ page, strings });
            footer_config = education_primary_footer_config$5({ strings });
            break;
        case "education-students":
            page_config = education_students_pages_config({ page, strings });
            footer_config = education_students_footer_config({ strings });
            break;
    }
    const nav_primary = nav_primary_config$5({ strings });
    return {
        market,
        site,
        vertical: site,
        locale,
        analytics: analytics$7,
        nav: {
            visible: true,
            primary: nav_primary || null,
            secondary: nav_secondary || null,
            about: about_nav || null
        },
        footer: Object.assign({ visible: true }, footer_config),
        page: page_config
    };
};

var analytics$6 = {
    gtm_id: "GTM-NDSR53K"
};

var nav_primary_config$4 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: true,
        destination: "https://www.rosettastone.fr/magazine/",
        external: true,
        new_window: true,
        label: strings.nav_primary_blog_label
    },
    contact: {
        visible: false,
        destination: "/contact/",
        external: true,
        new_window: true,
        label: strings.nav_primary_contact_label
    },
    rs_logo: {
        visible: true,
        image: {
            type: "static",
            src: rsBranding.rsLogoBlackSvg,
            height: "40px",
            width: "93px",
            alt: strings.nav_primary_logo_alt
        },
        link: {
            destination: "/",
            external: false,
            new_window: false
        }
    },
    phone: {
        visible: true,
        external: false,
        new_window: false,
        destination: "tel:18007673882",
        label: strings.nav_primary_phone_label,
        number: strings.nav_primary_phone_number
    },
    select_language: {
        visible: true,
        external: false,
        new_window: false,
        language_options_featured: [
            {
                url: "/l-anglais/",
                title: strings.locale_en_gb_label_primary,
                small: strings.locale_en_gb_label_secondary
            },
            {
                url: "/le-japonais/",
                title: strings.locale_ja_jp_label_primary,
                small: strings.locale_ja_jp_label_secondary
            },
            {
                url: "/l-allemand/",
                title: strings.locale_de_de_label_primary,
                small: strings.locale_de_de_label_secondary
            },
            {
                url: "/le-francais/",
                title: strings.locale_fr_fr_label_primary,
                small: strings.locale_fr_fr_label_secondary
            },
            {
                url: "/l-espagnol/",
                title: strings.locale_es_es_label_primary,
                small: strings.locale_es_es_label_secondary
            },
            {
                url: "/l-italien/",
                title: strings.locale_it_it_label_primary,
                small: strings.locale_it_it_label_secondary
            }
        ],
        language_options_other: [
            {
                url: "/l-arabe/",
                title: strings.locale_ar_ar_label_primary,
                small: strings.locale_ar_ar_label_secondary
            },
            {
                url: "/le-chinois/",
                title: strings.locale_zn_cn_label_primary,
                small: strings.locale_zn_cn_label_secondary
            },
            {
                url: "/le-neerlandais/",
                title: strings.locale_nl_nl_label_primary,
                small: strings.locale_nl_nl_label_secondary
            },
            {
                url: "/l-anglais-americain/",
                title: strings.locale_en_us_label_primary,
                small: strings.locale_en_us_label_secondary
            },
            {
                url: "/le-filipino/",
                title: strings.locale_tl_ph_label_primary,
                small: strings.locale_tl_ph_label_secondary
            },
            {
                url: "/le-grec/",
                title: strings.locale_el_gr_label_primary,
                small: strings.locale_el_gr_label_secondary
            },
            {
                url: "/l-hebreu/",
                title: strings.locale_he_il_label_primary,
                small: strings.locale_he_il_label_secondary
            },
            {
                url: "/l-hindi/",
                title: strings.locale_hi_in_label_primary,
                small: strings.locale_hi_in_label_secondary
            },
            {
                url: "/l-irlandais/",
                title: strings.locale_ga_ie_label_primary,
                small: strings.locale_ga_ie_label_secondary
            },
            {
                url: "/le-coreen/",
                title: strings.locale_ko_kr_label_primary,
                small: strings.locale_ko_kr_label_secondary
            },
            {
                url: "/le-farsi/",
                title: strings.locale_fa_ir_label_primary,
                small: strings.locale_fa_ir_label_secondary
            },
            {
                url: "/le-polonais/",
                title: strings.locale_pl_pl_label_primary,
                small: strings.locale_pl_pl_label_secondary
            },
            {
                url: "/le-portugais/",
                title: strings.locale_pt_br_label_primary,
                small: strings.locale_pt_br_label_secondary
            },
            {
                url: "/le-russe/",
                title: strings.locale_ru_ru_label_primary,
                small: strings.locale_ru_ru_label_secondary
            },
            {
                url: "/l-espagnol-d-amerique-latine/",
                title: strings.locale_es_la_label_primary,
                small: strings.locale_es_la_label_secondary
            },
            {
                url: "/le-suedois/",
                title: strings.locale_sv_se_label_primary,
                small: strings.locale_sv_se_label_secondary
            },
            {
                url: "/le-turc/",
                title: strings.locale_tr_tr_label_primary,
                small: strings.locale_tr_tr_label_secondary
            },
            {
                url: "/le-vietnamien/",
                title: strings.locale_vi_vn_label_primary,
                small: strings.locale_vi_vn_label_secondary
            }
        ],
        select_language_label: strings.nav_primary_catalog_select_language_label,
        label: strings.nav_primary_catalog_label,
        product_title: strings.global_brand_name
    },
    sign_in: {
        visible: true,
        destination: "https://www.rosettastone.com/login",
        external: true,
        new_window: false,
        label: strings.nav_primary_sign_in_label
    },
    switch_language: {
        visible: false,
        destination: "https://espanol.rosettastone.com/",
        external: true,
        new_window: false,
        label: strings.nav_primary_switch_language
    },
    support: {
        visible: true,
        destination: "https://support.rosettastone.com/fr/",
        external: true,
        new_window: false,
        label: strings.nav_primary_support_label
    },
    vertical_consumer: {
        visible: false,
        destination: "/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
        visible: false,
        destination: "/homeschool/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
        visible: true,
        destination: "/ecoles-primaires-secondaires/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
        visible: false,
        destination: "/education-superieure/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
        visible: false,
        destination: "/students/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
        visible: true,
        destination: "/entreprises/",
        external: true,
        new_window: false,
        label: strings.nav_primary_vertical_enterprise_label
    }
});

var education_primary_nav_secondary_config$4 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: "https://enterpriseblog.rosettastone.com/",
        external: true,
        new_window: true,
        label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
        visible: true,
        destination: "/ressources/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
        visible: true,
        destination: "/solutions/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_solutions_label
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_primary_label
    }
});

var awards$4 = ({ strings }) => {
    return {
        visible: true,
        title: {
            content: strings.awards_header_label,
            align: "center",
            type: "section-title"
        },
        panels: [
            {
                image: {
                    type: "static",
                    alt: strings.awards_twitter,
                    src: logosTiles.logosTilesTwitterSvg
                }
            },
            {
                image: {
                    type: "static",
                    alt: strings.awards_bmw,
                    src: logosTiles.logosTilesBmwSvg
                }
            },
            {
                image: {
                    type: "static",
                    alt: strings.awards_uber,
                    src: logosTiles.logosTilesUberSvg
                }
            },
            {
                image: {
                    type: "static",
                    alt: strings.awards_williams_sonoma,
                    src: logosTiles.logosTilesWsSvg
                }
            }
        ]
    };
};

var copyData$4 = () => ({
    about_us: "Rosetta Stone",
    about_us_url: "/a-propos",
    agreements: "Mentions Légales",
    agreements_url: "/mentions-legales",
    almost_there: "Presque fini!",
    american: "(Américain)",
    anti_piracy: "Anti-piratage",
    anti_piracy_url: "/anti-piratage",
    arabic: "Arabe",
    award_section_header: "Reconnu depuis 25+ ans par les plus grandes organisations.",
    blog_url: "https://www.rosettastone.fr/magazine",
    brasil: "Brésil",
    brasil_url: "https://www.rosettastonebrasil.com/",
    brazil: "(Brésil)",
    british: "(Britannique)",
    business_contact_title: "Entreprise - Demande de Tarifs",
    careers: "Carrières",
    careers_url: "https://www.rosettastone.com/careers",
    cart_checkout: "Check-out",
    cart_checkout_url: "https://secure.rosettastone.fr/fr_store_view/checkout/cart",
    cart_discount: "Remise:",
    cart_empty: "Votre carte est actuellement vide.",
    cart_in_your_cart: "in your cart.",
    cart_subtotal: "Sous-Total:",
    cart_summary: "Récapitulatif de la commande:",
    cart_total: "Total (avant impôt):",
    cart_you_have: "Vous avez",
    change_region: "Changer de région:",
    china: "中国",
    china_url: "http://www.rosettastone.cn/",
    combined_resources_url: "https://www.rosettastone.fr/entreprises/ressources/",
    company: "À PROPOS",
    connect: "Connecte-toi avec nous:",
    consumer_home: "Particuliers",
    contact: "Contactez-nous",
    contact_description: "Formulaire de demande de prix",
    contact_ee_url: "/contact/",
    contact_url: "https://www.rosettastone.fr/contact",
    cta_bar: "Prêt pour la prochaine étape?",
    cta_h2: "Vous cherchez une liste de pas?",
    cta_text: "Demande de tarifs",
    currency: "€",
    demo_pricing_subtitle_business: "Découvrez comment nos solutions métier peuvent aider votre entreprise à attirer des talents et à améliorer sa productivité. Remplissez le formulaire ci-dessous et nous vous contacterons bientôt.",
    demo_pricing_subtitle_hed: "Découvrez comment nos solutions d'enseignement supérieur peuvent aider vos apprenants à parler une nouvelle langue avec confiance. Remplissez le formulaire ci-dessous et nous vous contacterons bientôt.",
    demo_pricing_subtitle_k12: "Découvrez comment nos solutions pédagogiques peuvent aider vos apprenants de l'anglais et de la langue mondiale à parler avec confiance. Remplissez le formulaire ci-dessous et nous vous contacterons bientôt.",
    demo_pricing_subtitle_pub: "Découvrez comment nos solutions du secteur public peuvent améliorer les communications avec ceux que vous desservez. Remplissez le formulaire ci-dessous et nous vous contacterons bientôt.",
    demo_pricing_title: "Obtenez une consultation gratuite",
    deutschland: "Deutschland",
    deutschland_url: "https://www.rosettastone.de/",
    download_pdf: "Télécharger le PDF",
    dutch: "Néerlandais",
    english: "Anglais",
    espana: "España",
    espana_url: "https://www.rosettastone.es/",
    europe: "L'Europe",
    europe_url: "https://www.rosettastone.eu/",
    facebook_url: "http://www.facebook.com/RosettaStoneFR",
    faq_url: "/faq",
    faqs: "FAQ",
    farsi: " (Farsi)",
    filipino: "Philippin",
    for_business: "Pour Les Entreprises",
    for_business_resources_url: "https://www.rosettastone.fr/entreprises/ressources/",
    for_business_solutions_url: "https://www.rosettastone.fr/entreprises/solutions/",
    for_business_url: "https://www.rosettastone.fr/entreprises/accueil/",
    for_educators: "Pour Les Éducateurs",
    for_educators_resources_url: "https://www.rosettastone.fr/entreprises/ressources/",
    for_educators_solutions_url: "https://www.rosettastone.fr/ecoles-primaires-secondaires/solutions/",
    for_educators_url: "https://www.rosettastone.fr/ecoles-primaires-secondaires/accueil/",
    for_hed: "Pour les Éducateurs Supérieurs",
    for_homeschool: null,
    for_homeschool_url: null,
    for_individuals: "Essayez gratuitement",
    for_individuals_url: "/demo",
    for_organizations: "Organisations",
    for_public_sector: "Applications Mobiles",
    for_public_sector_url: "/mobile-apps",
    for_you: "Pour Vous",
    form_100: "100 ou Moins",
    form_500: "101 - 500",
    form_1000: "501 - 1,000",
    form_5000: "1,001 - 5,000",
    form_10000: "5,001 - 10,000",
    form_25000: "10,001 - 25,000",
    form_50000: "25,001 - 50,000",
    form_boardmember: "Membre d'Équipage",
    form_curriculumdirector: "Directeur du curriculum / coordinateur de l'instruction",
    form_director: "Réalisateur",
    form_email: "Email",
    form_executive: "Direction Générale / Executive",
    form_firstname: "Prénom",
    form_how_blog: "Blog",
    form_how_email: "Email",
    form_how_event: "Event",
    form_how_online: "En ligne",
    form_how_other: "Autre",
    form_how_referral: "Référence",
    form_how_search: "Moteur de recherche",
    form_how_social: "Médias sociaux",
    form_how_title: "Comment avez-vous entendu parler de nous? (Optionnel)",
    form_how_webinar: "Séminaire en ligne",
    form_individualcontributor: "Contributeur Individuel",
    form_lastname: "Nom",
    form_manager: "Directeur",
    form_more: "50,001 - Plus",
    form_organization: "Nom de l'Organisation",
    form_organizationsize: "Taille de l'Organisation",
    form_phone: "Numéro de Téléphone (Facultatif)",
    form_principal: "Directeur d'École",
    form_privacy1: "Rosetta Stone s'engage à protéger votre vie privée. Notre politique de confidentialité complète est disponible ",
    form_privacy2: "ici.",
    form_privacy3: "Je comprends que je peux choisir à tout moment de ne pas participer à de telles communications en cliquant sur le lien fourni dans la communication ou en contactant Rosetta Stone à l'adresse",
    form_privacy4: ".",
    form_privacyUrl: "https://resources.rosettastone.com/CDN/fr/pdfs/France_Privacy_Policy.pdf",
    form_privacyemail: "privacyofficer@rosettastone.com",
    form_role: "Rôle (ou titre)",
    form_submit: "Consultation Gratuite",
    form_superintendent: "Surintendant / Administrateur de district",
    form_teacher: "Professeur",
    form_techcoordinator: "Coordinateur Technologique",
    form_updateagreement1: "Oui! J'aimerais recevoir les mises à jour et le marketing du produit de Rosetta Stone. Cliquez ",
    form_updateagreement2: "ici",
    form_updateagreement3: "pour plus d'informations.",
    form_vicepresident: "Vice-Président",
    france: "France",
    france_url: "https://www.rosettastone.fr/",
    google_plus_url: "https://plus.google.com/105195149850491722010",
    greek: "Grec",
    gtm_id: "GTM-KCH7LJ",
    has_combined_resources: true,
    has_resources: null,
    hebrew: "Hébreu",
    helpful_links: "Veuillez corriger l'URL ou essayez l'un de ces liens utiles:",
    hide_cart: true,
    hide_contact: true,
    hide_espanol: true,
    hide_language: null,
    hide_search: true,
    hide_support: null,
    hindi: "Hindi",
    home: "Accueil",
    home_link: "/accueil/",
    home_url: "https://www.rosettastone.fr/",
    instagram_url: "https://www.instagram.com/rosettastone",
    investors: "Relations Investisseurs",
    investors_url: "https://investors.rosettastone.com/",
    irish: "Irlandais",
    italia: "Italia",
    italia_url: "https://www.rosettastone.it/",
    item: "article",
    item_plural: "articles",
    japan: "日本",
    japan_url: "http://www.rosettastone.co.jp",
    japanese: "Japonais",
    k12_contact_title: "Éducation - Demande de Tarifs",
    keep_exploring: "Continuer à explorer",
    korea: "대한민국",
    korea_url: "https://www.rosettakorea.com/",
    korean: "Coréen",
    latin: null,
    latin_america: "(Amérique latine)",
    latin_america_region: "America Latina",
    latin_america_region_url: "https://espanol.rosettastone.com/",
    learn_arabic_url: "/apprendre-l-arabe/",
    learn_chinese: "Chinois",
    learn_chinese_url: "/apprendre-le-chinois/",
    learn_dutch_url: "/apprendre-le-neerlandais/",
    learn_english: "Apprendre l'Anglais",
    learn_english_british_url: "/apprendre-l-anglais/",
    learn_english_url: "/apprendre-l-anglais/",
    learn_french: "Apprendre le Français",
    learn_french_url: "/apprendre-le-francais/",
    learn_german: "Apprendre l'Allemand",
    learn_german_url: "/apprendre-l-allemand/",
    learn_greek_url: "/apprendre-le-grec/",
    learn_hebrew_url: "/apprendre-l-hebreu/",
    learn_hindi_url: "/apprendre-l-hindi/",
    learn_irish_url: "/apprendre-l-irlandais/",
    learn_italian: "Apprendre l'Italien",
    learn_italian_url: "/apprendre-l-italien/",
    learn_japanese_url: "/apprendre-le-japonais/",
    learn_korean_url: "/apprendre-le-coreen/",
    learn_latin_url: null,
    learn_more: "En savoir plus",
    learn_persian_url: "/apprendre-le-farsi/",
    learn_polish_url: "/apprendre-le-polonais/",
    learn_portuguese_url: "/apprendre-le-portugais/",
    learn_russian_url: "/apprendre-le-russe/",
    learn_spanish: "Apprendre l'Espagnol",
    learn_spanish_spain_url: "/apprendre-l-espagnol/",
    learn_spanish_url: "/apprendre-l-espagnol-d-amerique-latine/",
    learn_swedish_url: "/apprendre-le-suedois/",
    learn_tagalog_url: "/apprendre-le-tagalog/",
    learn_turkish_url: "/apprendre-le-turc/",
    learn_vietnamese_url: "/apprendre-le-vietnamien/",
    lexia_learning: "Avis Clients",
    lexia_learning_url: "/avis",
    listen_now: "En savoir plus",
    madarin: "(Mandarin)",
    market: ["FR"],
    media_quote_1: "”J'adore le logiciel de Rosetta Stone et je pense que",
    media_quote_1_bold: "l’approche de l'apprentissage linguistique fonctionne.",
    media_quote_1_end: "”",
    media_quote_2: "“Grâce à l’excellente interface utilisateur, des instructions claires, la grande variété de jeux et défis, ",
    media_quote_2_bold: "Rosetta Stone est très attrayant.",
    media_quote_2_end: "”",
    media_quote_3: "“",
    media_quote_3_bold: "L'étalon d’or",
    media_quote_3_end: "de l'apprentissage interactif des langues.\"",
    more_resources_title: "Ressources supplémentaires",
    more_specify: "Veuillez préciser",
    no_support_dropdown: true,
    persian: "Persan",
    polish: "Polonais",
    portuguese: "Portugais",
    press: "Presse",
    press_url: "/presse",
    pricing_subtitle: "S'il vous plaît compléter et nous vous contacterons immédiatement.",
    pricing_thanks: "Merci de votre intérêt! Quelqu'un vous suivra sous peu.",
    pricing_title: "Obtenez les informations sur nos tarifs.",
    privacy_policy: "Politique de confidentialité",
    privacy_policy_url: "/privacy",
    products: "PAR OÙ COMMENCER",
    questions_call: "Avoir des questions? Appelez nous:",
    read_article: "Lire l'article",
    read_case_study: "En savoir plus",
    read_ebook: "Lire l'eBook",
    read_fact_sheet: "Lire la suite",
    read_guide: "Lire le guide",
    read_more: "Lire la suite",
    read_report: "Lire le dossier",
    read_white_paper: "Lire la suite",
    related_resources_title: "Ressources associées",
    request_pricing: "Demande de Tarifs",
    resources: "Ressources",
    resources_link: "/ressources/",
    rosetta_copyright: "1999-2019 Rosetta Stone LLC. Tous droits réservés. Ce site utilise des cookies. En poursuivant votre navigation sur ce site vous acceptez les cookies utilisés. En savoir plus sur notre Politique de Cookie.",
    rosetta_stone: "Rosetta Stone",
    russian: "Russe",
    search: "Chercher...",
    search_rosetta_url: "https://search.rosettastone.com/",
    select_lang: "Sélectionnez une langue:",
    services: null,
    services_url: null,
    shop_now: null,
    sign_in: "Se Connecter",
    sign_in_url: "https://launch.rosettastone.com/fr/osub/authenticate",
    similar_resources: "Ressources Similaires",
    site_not_found: "Site non trouvé - 404",
    sitemap: "Plan du site",
    sitemap_url: "/carte-du-site",
    solutions: "Solutions",
    solutions_link: "/solutions/",
    spain: "(Espagne)",
    spanish: "Espagnol",
    support: "Assistance",
    support_business_url: "https://support.rosettastone.com/fr/entreprises",
    support_chat: "Chat en direct avec le support technique",
    support_chat_live: "Chat en direct avec le support technique",
    support_chat_live_url: "https://rosettastone.secure.force.com/apex/PreLiveChatForm",
    support_chat_url: "https://support.rosettastone.com/fr/chat",
    support_classrooms: "Soutien aux salles de classe et aux entreprises:",
    support_faq_btn: "Voir toutes les FAQ",
    support_faq_title: "Foire Aux Questions",
    support_faq_url_1: "/faq#q1",
    support_faq_url_1_title: "En quoi consiste la Solution Rosetta Stone?",
    support_faq_url_2: "/faq#q2",
    support_faq_url_2_title: "Que comprend la solution Rosetta Stone abonnement en ligne?",
    support_faq_url_3: "/faq#q3",
    support_faq_url_3_title: "Comment et où se procurer les mobile apps pour mon iPhone, iPad, ou appareil Androïde?",
    support_faq_url_4: "/faq#q4",
    support_faq_url_4_title: "Comment fonctionne la méthode Rosetta Stone?",
    support_for_you: "Personnel",
    support_home: "ASSISTANCE",
    support_site: "Site de support",
    support_site_url: "https://support.rosettastone.com/fr/",
    swedish: "Suédois",
    switch_lang: "Español",
    switch_lang_url: "https://espanol.rosettastone.com/",
    system_reqs: "Configurations Requises",
    system_reqs_url: "/configurations-recquises",
    tagalog: " (Tagalog)",
    telephone_atr: "+ 44 (0) 20 7 749 2979",
    telephone_text: "1-(800)-ROSETTA",
    terms_conditions: "Modalités et Conditions",
    terms_conditions_url: "/modalites-et-conditions",
    title: "fr-copy",
    turkish: "Turc",
    twitter_url: "https://twitter.com/rosettastone",
    united_kingdom: "United Kingdom",
    united_kingdom_url: "https://www.rosettastone.co.uk/",
    united_states: "United States",
    united_states_url: "https://www.rosettastone.com",
    use_new_header: null,
    vertical: ["recECBjZxFEWVVls8"],
    vertical_business: "Entreprise",
    vertical_business_link: "/entreprises/accueil/",
    vertical_healthcare: null,
    vertical_healthcare_link: null,
    vertical_hed: "Éducation Supérieur",
    vertical_hed_link: "/education-superieure/accueil/",
    vertical_k12: "Éducation",
    vertical_k12_link: "/ecoles-primaires-secondaires/accueil/",
    vertical_pub: "Secteur Public",
    vertical_pub_link: "/secteur-public/",
    verticals_subtitle: "Nos solutions linguistiques primées conviennent à tous les types d'apprenants.",
    verticals_title: "Quel type d'apprenant êtes-vous?",
    vietnamese: "Vietnamien",
    view_infographic: "Lire la suite",
    watch_video: "En savoir plus",
    watch_webinar: "En savoir plus",
    youtube_url: "http://www.youtube.com/user/RosettaStoneFR"
});

var branded_quotes$4 = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.branded_quotes_header_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            name: strings.branded_quotes_macworld_name,
            type: strings.branded_quotes_macworld_type,
            quote: strings.branded_quotes_macworld_quote,
            logo: {
                type: "static",
                src: logos.logoMacworldSvg
            },
            backdrop: logos.logoMacworldBgSvg
        },
        {
            name: strings.branded_quotes_techcrunch_name,
            type: strings.branded_quotes_techcrunch_type,
            quote: strings.branded_quotes_techcrunch_quote,
            logo: {
                type: "static",
                src: logos.logoTechcrunchSvg
            },
            backdrop: logos.logoTechcrunchBgSvg
        },
        {
            name: strings.branded_quotes_cnn_name,
            type: strings.branded_quotes_cnn_type,
            quote: strings.branded_quotes_cnn_quote,
            logo: {
                type: "static",
                src: logos.logoCnnSvg
            },
            backdrop: logos.logoCnnBgSvg
        }
    ]
});

var lead_generation_bar$e = () => {
    return {
        visible: true,
        dataQa: "lead generation bar",
        lead_generation_button: {
            schedule_appointment: false,
            button: {
                destination: "/demande-de-prix/",
                new_window: false,
                size: "regular",
                text: "Demande de tarification",
                theme: "yellow_black"
            }
        },
        subtitle: {
            content: "",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        title: {
            content: "Vous cherchez une liste de pas?",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        }
    };
};

var verticals$e = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_education_primary,
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/ecoles-primaires-secondaires/"
            },
            name: strings.verticals_education_primary,
            title: {
                content: strings.verticals_education_primary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_education_secondary,
                src: verticals$q.educationSecondaryCirclePng
            },
            link: {
                destination: "/education-superieure/"
            },
            name: strings.verticals_education_secondary,
            title: {
                content: strings.verticals_education_secondary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_enterprise,
                src: verticals$q.enterpriseCirclePng
            },
            link: {
                destination: "/entreprises/"
            },
            name: strings.verticals_enterprise,
            title: {
                content: strings.verticals_enterprise,
                type: "card-title"
            }
        }
    ]
});

const education_primary_pages_config$4 = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "dynamic-content") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "fr"
            },
            content: {
                copyData: copyData$4(),
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$e({ strings }),
                lead_generation_bar: lead_generation_bar$e()
            }
        };
    }
    if (page === "dynamic-resources") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "fr"
            },
            content: {
                hero: {
                    layout: "list",
                    panels: [
                        {
                            layout: "image-right",
                            alignItems: "center",
                            image: {
                                src: null
                            },
                            title: {
                                content: "Ressources"
                            },
                            body: {
                                content: "Laissez les apprenants parler pour eux-mêmes"
                            },
                            custom: {
                                lead_generation_button: {
                                    destination: "/demande-de-prix/",
                                    new_window: false,
                                    size: "regular",
                                    text: "Demande de tarification",
                                    theme: "yellow_black"
                                }
                            }
                        }
                    ]
                },
                copyData: copyData$4(),
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$e({ strings }),
                lead_generation_bar: lead_generation_bar$e()
            }
        };
    }
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "L’apprentissage des langues de la maternelle au lycée | Rosetta Stone",
                meta_description: "Rosetta Stone training solutions help employees develop language skills in English for business and many in-demand business languages. Request pricing.  ",
                canonical_url: "https://www.rosettastone.fr/ecoles-primaires-secondaires/",
                lang: "fr"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                data_qa: "section1",
                                layout: "list",
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/demande-de-prix/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Demande de tarification",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                image: {
                                    src: null
                                },
                                direction: "content-right",
                                title: {
                                    align: "left",
                                    content: "Mettez l’apprentissage des langues en ligne.",
                                    heading: "h1",
                                    type: "page-title"
                                },
                                body: {
                                    content: "Le but est de parler une autre langue, et les professeurs savent le temps et les efforts que cela demande. Rosetta Stone est un modèle d’apprentissage unique, capable de faire parler vos élèves l’anglais ou une autre langue étrangère dès le début de la formation. Grâce à cette méthode, ils seront prêts à parler d’eux-mêmes, en classe comme ailleurs."
                                }
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                visible: true,
                                dataQa: "2",
                                layout: "list",
                                product_sample_panels: [
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.bicicletaAzulPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.bicicletaAmarillaPng
                                            }
                                        },
                                        challenge_text: "Una bicicleta azul"
                                    },
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.dosBicicletasAzulesPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.dosBicicletasDiferentesPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules"
                                    },
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.verdesPorUnDiaPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.azulesPorUnDiaPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules por un día por favor"
                                    }
                                ],
                                content: [
                                    {
                                        body: {
                                            content: "Dès la première leçon, tous les mots que les élèves entendent, prononcent et lisent sont ceux de leur nouvelle langue. C’est le principe de l’immersion, qui reste la manière la plus naturelle d’apprendre une langue. Le passage des mots isolés aux phrases se fait sans crainte. Et quand le moment vient de poser des questions, les enseignants peuvent compter sur les réponses d’étudiants mis en confiance."
                                        },
                                        direction: "image-left",
                                        title: {
                                            content: "Exposez vos étudiants à d’autres formes d’apprentissage",
                                            type: "section-title",
                                            heading: "h2",
                                            theme: "black",
                                            align: "left"
                                        }
                                    }
                                ],
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/ecoles-primaires-secondaires/ressources/content/case-study-pueblo-city-schools/",
                                    align: "left"
                                },
                                quote: "« Les élèves sont séduits par la technologie et par ce fait ils aiment le programme. Advantage nous permet ainsi de toucher des étudiants auparavant inaccessibles. »",
                                attribution: "Assistant de liaison, Pueblo City Schools, Colorado"
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                layout: "list",
                                direction: "image-right",
                                title: {
                                    content: "Dites adieu aux « bouches cousues ».",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                body: {
                                    content: "Lorsque l’on commence à parler une autre langue, on ressent parfois une certaine gêne. La crainte de faire des erreurs devant toute la classe peut même rendre les élèves muets. Notre moteur de reconnaissance vocale TruAccent™ est aussi un guide de prononciation, et il n’émet aucun jugement ; son utilisation renforce l’apprentissage de la langue en éliminant la crainte de l’élève de mal prononcer un mot."
                                },
                                image: {
                                    src: null
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/ecoles-primaires-secondaires/ressources/content/case-study-corona-norco-unified-school-district/",
                                    align: "left"
                                },
                                quote: "« Le programme de Rosetta Stone permet de renforcer la confiance des apprenants dans l’expression orale, qui ont l’occasion de s’écouter parler et de se corriger eux-mêmes ; ceci réduit leur timidité. »",
                                attribution: "Administrateur des services d’enseignement, Département anglais, Commission scolaire des villes de Corona-Norco, Californie"
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                layout: "list",
                                direction: "image-left",
                                title: {
                                    content: "Le tutorat en ligne donne à la conversation son réalisme.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                body: {
                                    content: "Les professeurs veulent faire en sorte que leurs élèves se sentent à l’aise pour parler leur nouvelle langue. Mais il y a un pas entre l’apprentissage en classe et le fait de s’exprimer face à face avec un locuteur natif. Nos sessions de tutorat en ligne permettent justement aux élèves de pratiquer leur nouvelle langue à leur propre niveau, et avec des locuteurs natifs. Ceci permet d’apprendre « intelligemment », dans un environnement sécurisé."
                                },
                                image: {
                                    src: null
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/ecoles-primaires-secondaires/ressources/content/customer-spotlight-bethel-public-schools/",
                                    align: "left"
                                },
                                quote: "« Les réactions des élèves ont été extrêmement positives.  Notre approche collaborative en classe évoque un peu l’ambiance d’une grande famille. . . »",
                                attribution: "Coordinatrice du programme et professeure d’espagnol, Lycée de Bethel, Spanaway, État de Washington"
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                layout: "list",
                                direction: "image-right",
                                title: {
                                    content: "Les élèves emportent l’apprentissage de la langue avec eux.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                body: {
                                    content: "Les cours en classe sont encore de nos jours la norme. Mais les écoles facilitent également l’apprentissage à distance de la classe. Notre application mobile offre à vos élèves l’accès aux leçons et au matériel sur demande. Ceci leur donne la liberté de transformer toute heure de leur journée en heure de cours."
                                },
                                image: {
                                    src: null
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/ecoles-primaires-secondaires/ressources/content/customer-spotlight-phoenix-union-high-school-district/",
                                    align: "left"
                                },
                                quote: "« Nous avons pu voir nos élèves suivant le programme Rosetta Stone® devenir plus motivés, plus confiants en eux-mêmes, plus désireux de participer en classe ; ils ont aussi acquis du vocabulaire beaucoup plus rapidement. »",
                                attribution: "Professeure, département d’anglais, District scolaire Union High School, Phoenix, Arizona"
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                pageData: {
                                    learner_feature_1_icon_name: "icon_24",
                                    learner_feature_1_subtitle: "L’anglais et les langues du monde qui correspondent aux objectifs d’apprentissage.",
                                    learner_feature_1_title: "24 Langues",
                                    learner_feature_2_icon_name: "icon_dynamic",
                                    learner_feature_2_subtitle: "Les apprenants sont plongés dans un environnement unilingue pour accélérer l’apprentissage. ",
                                    learner_feature_2_title: "Immersion selon un rythme personnel",
                                    learner_feature_3_icon_name: "icon_games",
                                    learner_feature_3_subtitle: "Les étudiants se divertissent tout en se remémorant la matière apprise.",
                                    learner_feature_3_title: "Jeux et activités",
                                    learner_feature_4_icon_name: "icon_truaccent",
                                    learner_feature_4_subtitle: "Aide à la prononciation disponible aux apprenants de tous les niveaux.",
                                    learner_feature_4_title: "Reconnaissance vocale TruAccent™",
                                    learner_feature_5_icon_name: "icon_tutoring",
                                    learner_feature_5_subtitle: "Au sein d’un environnement en ligne sécurisant, opérant au niveau de chacun.",
                                    learner_feature_5_title: "Tutorat en direct",
                                    learner_feature_6_icon_name: "icon_mobile",
                                    learner_feature_6_subtitle: "L’accès à l’apprentissage dans le téléphone mobile ou la tablette de l’étudiant.",
                                    learner_feature_6_title: "Application mobile",
                                    learner_feature_title: "Fonctions Destinées À L’apprenant – Primaire Et Secondaire"
                                }
                            }
                        ]
                    }
                ],
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$e({ strings }),
                lead_generation_bar: lead_generation_bar$e()
            }
        };
    }
    if (page === "demande-de-prix") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Demande de prix | Rosetta Stone",
                meta_description: "Les services professionnels mondiaux et les cabinets de conseil se heurtent à des barrières linguistiques qui limitent leur capacité à servir les clients, à engager les employés et à développer leurs activités à l'échelle mondiale. Les solutions de formation linguistique aident les cabinets de conseil professionnels à maximiser les heures facturables par employé, ce qui prouve notre retour sur investissement significatif dans la formation linguistique dans toute l'organisation.",
                canonical_url: "https://www.rosettastone.fr/ecoles-primaires-secondaires/demande-de-prix/",
                lang: "fr"
            },
            content: {
                title: {
                    type: "section-title",
                    theme: "yellow",
                    content: "Réservez du temps avec un expert linguistique dès aujourd'hui."
                },
                sub_title: {
                    type: "section-sub-title",
                    theme: "white",
                    content: "Veuillez remplir le formulaire ci-dessous pour planifier un créneau afin de discuter de la façon dont nous pouvons vous aider."
                },
                lead_generation_form: {
                    title: {
                        theme: "blue",
                        type: "section-title",
                        content: "Vous y êtes presque!"
                    },
                    fields: {
                        first_name: {
                            field_name: "first_name",
                            field_type: "text",
                            label: "Prénom",
                            required: true,
                            required_error: "Veuillez entrer votre prénom."
                        },
                        last_name: {
                            field_name: "last_name",
                            type: "text",
                            label: "Nom",
                            required: true,
                            required_error: "Veuillez entrer votre nom."
                        },
                        email: {
                            field_name: "email",
                            field_type: "email",
                            label: "Adresse e-mail",
                            required: true,
                            required_error: "Veuillez entrer votre adresse e-mail.",
                            validation_error: "Please enter a valid Email Address."
                        },
                        phone: {
                            field_name: "phone",
                            field_type: "tel",
                            label: "Numéro de téléphone*",
                            required: true,
                            required_error: null
                        },
                        organization_name: {
                            field_name: "organization_name",
                            field_type: "text",
                            label: "Société",
                            required: true,
                            required_error: "Veuillez entrer le nom de votre société."
                        },
                        organization_size: {
                            field_name: "organization_size",
                            field_type: "text",
                            label: "Taille de la société",
                            required: true,
                            required_error: "Veuillez entrer la taille de votre société.",
                            options: [
                                { value: "", label: "" },
                                { value: "100 ou Moins", label: "100 ou Moins" },
                                { value: "101 - 500", label: "101 - 500" },
                                {
                                    value: "501 - 1,000",
                                    label: "501 - 1,000"
                                },
                                { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                {
                                    value: "10,001 - 25,000",
                                    label: "10,001 - 25,000"
                                },
                                {
                                    value: "25,001 - 50,000",
                                    label: "25,001 - 50,000"
                                },
                                {
                                    value: "50,001 ou Plus",
                                    label: "50,001 ou Plus"
                                }
                            ]
                        },
                        role: {
                            field_name: "title",
                            field_type: "select",
                            label: "Titre",
                            required: true,
                            required_error: "Veuillez entrer votre fonction."
                        },
                        explicitOptIn: {
                            field_name: "explicitOptIn",
                            required: false
                        }
                    },
                    button: {
                        as: "button",
                        type: "submit",
                        size: "regular",
                        text: "Demande de tarification"
                    },
                    labels: {
                        form_privacy1: "Rosetta Stone s'engage à protéger votre vie privée. Notre politique de confidentialité complète est disponible ",
                        form_privacy2: "ici.",
                        form_privacy3: "Je comprends que je peux choisir à tout moment de ne pas participer à de telles communications en cliquant sur le lien fourni dans la communication ou en contactant Rosetta Stone à l'adresse",
                        form_privacy4: ".",
                        form_privacyUrl: "https://resources.rosettastone.com/CDN/fr/pdfs/France_Privacy_Policy.pdf",
                        form_privacyemail: "privacyofficer@rosettastone.com",
                        form_updateagreement1: "Oui! J'aimerais recevoir les mises à jour et le marketing du produit de Rosetta Stone. Cliquez ",
                        form_updateagreement2: "ici",
                        form_updateagreement3: "pour plus d'informations."
                    },
                    domain: ".fr",
                    dataQaLocation: "page"
                },
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$e({ strings })
            }
        };
    }
    if (page === "demande-de-prix-terminee") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Demande de prix terminee | Rosetta Stone",
                meta_description: "Les services professionnels mondiaux et les cabinets de conseil se heurtent à des barrières linguistiques qui limitent leur capacité à servir les clients, à engager les employés et à développer leurs activités à l'échelle mondiale. Les solutions de formation linguistique aident les cabinets de conseil professionnels à maximiser les heures facturables par employé, ce qui prouve notre retour sur investissement significatif dans la formation linguistique dans toute l'organisation.",
                canonical_url: "https://www.rosettastone.fr/ecoles-primaires-secondaires/demande-de-prix-terminee/",
                lang: "fr"
            },
            content: {
                title: {
                    align: "center",
                    content: "Nous vous remercions pour votre intérêt !",
                    heading: "h1",
                    theme: "blue",
                    type: "page-title"
                },
                sub_title: {
                    align: "center",
                    heading: "h2",
                    content: "Découvrez quelques ressources supplémentaires avant votre réunion!",
                    type: "page-sub-title"
                },
                resources_link: {
                    destination: "/ressources/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Ressources",
                    theme: "blue_white"
                },
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$e({ strings })
            }
        };
    }
    if (page === "solutions") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Programmes d’apprentissage des langues en ligne pour l´Education primaire et secondaire| Rosetta Stone",
                meta_description: "Les programmes d’apprentissage des langues en ligne de Rosetta Stone motivent les étudiants en anglais et les apprenants des langues étrangères en leur donnant la confiance nécessaire pour commencer à s’exprimer. Demandez nos tarifs",
                canonical_url: "https://www.rosettastone.fr/ecoles-primaires-secondaires/solutions/",
                lang: "fr"
            },
            content: {
                sections: [
                    {
                        layout: "list",
                        panels: [
                            {
                                direction: "image-right",
                                video: {
                                    currentVideoUrl: "https://vimeo.com/616188813",
                                    controls: true
                                },
                                title: {
                                    content: "Nos solutions pour l’enseignement primaire et secondaire prennent en charge tous les types d’apprenants des langues.",
                                    align: "left",
                                    heading: "h2",
                                    type: "section-title"
                                },
                                justifyContent: "space-between",
                                body: {
                                    content: "Les étudiants des langues ont chacun leurs raisons pour apprendre une nouvelle langue. L’un commence par la langue anglaise pour débutantet espère être capable de parler à ses ses camarades. L’autre s’inscrit dans un cours de langue donné en classe, espérant vivre un jour dans un autre pays. Quels que soient leurs objectifs en apprenant une langue, les élèves auront les moyens de converser en confiance avec nos solutions d’apprentissage pour l’enseignement primaire et secondaire."
                                },
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/demande-de-prix/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Demande de tarification",
                                            theme: "yellow_black"
                                        }
                                    }
                                }
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                body: {
                                    content: "Les étudiants presque, ou totalement ignorants de l’anglais hésitent souvent à s’intégrer à un programme d’apprentissage. Ce sentiment d’isolement peut perdurer jusqu’à ce qu’ils soient plus confiants en leur aptitude à parler l’anglais. Les cours d’anglais de Rosetta Stone® pour l’enseignement incluent toutes les ressources nécessaires pour les apprenants de l’anglais, leurs professeurs et leurs familles. Il s´aligne avec les programmes d’équité visant à permettre à tous les élèves et étudiants les mêmes outils nécessaires pour réussir leurs études."
                                },
                                direction: "image-left",
                                layout: "list",
                                title: {
                                    content: "Ajoutez les apprenants de l’anglais à votre programme d’équité en éducation.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                image: {
                                    src: null
                                }
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                body: {
                                    content: "Leur intérêt peut naître d’un film qu’ils ont vu, d’un livre, d’un ami de rencontre en ligne ou d’un voisin. Quelles que soient les circonstances et les raisons de cette prise de conscience globale, apprendre une autre langue est l’étape suivante la plus significative. Le choix du programme de Rosetta Stone pour les écoles aide les élèves à acquérir les compétences linguistiques nécessaires pour satisfaire leur soif de connaître un autre pays, une autre culture."
                                },
                                direction: "image-right",
                                layout: "list",
                                title: {
                                    content: "Mettez vos élèves en contact avec de nouvelles langues et cultures.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                image: {
                                    src: null
                                }
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                body: {
                                    content: "Lorsque les élèves ont soif d’apprendre, chacune des journées passées en classe compte. Pour ceux d’entre eux qui apprennent l’anglais, il est essentiel de rester sur la bonne voie. Le programme « English for Education » de Rosetta Stone® implique les membres de leur famille dans l’apprentissage de l’anglais de l’étudiant. Ce soutien les entoure de toutes parts et les aide à maintenir le contact avec leurs professeurs et leurs camarades de classe et à atteindre de plus francs succès dans leurs études."
                                },
                                direction: "image-left",
                                layout: "list",
                                title: {
                                    content: "Faites de l’apprentissage de l’anglais une affaire de famille.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                image: {
                                    src: null
                                }
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                data_qa: "5",
                                img_bg_top: images.solSection_7StoneBlueSvg,
                                img_bg_bottom: images.solSection_7StoneYellowSvg,
                                data: {
                                    feature_1_img: "icon_dynamic",
                                    feature_1_subtitle: "Active le processus d’autoapprentissage avec des leçons au rythme individuel de l’apprenant et des activités se déroulant dans la langue qu’ils apprennent ; ainsi entourés, ils apprennent à parler, lire, écouter et penser dans cette langue d’une toute nouvelle manière.",
                                    feature_1_title: "Immersion dynamique. ",
                                    feature_2_img: "icon_truaccent",
                                    feature_2_subtitle: "Un guide de la prononciation avec retour immédiat permet aux élèves de parler leur nouvelle langue plus correctement, leur donnant ainsi rapidement l’assurance nécessaire pour s’exprimer correctement.",
                                    feature_2_title: "TruAccent.",
                                    feature_3_img: "icon_tutoring",
                                    feature_3_subtitle: "Les exercices structurés et la conversation avec des locuteurs natifs sont adaptés au niveau de l’étudiant et l’aident à se familiariser avec la langue qu’il apprend.",
                                    feature_3_title: "Tutorat en direct. ",
                                    feature_4_img: "icon_24",
                                    feature_4_subtitle: "Intégrez l’anglais, mais aussi d’autres langues dans votre programme d’enseignement des langues pour mettre au point et affiner les compétences de vos élèves, qu’ils soient débutants ou étudiants chevronnés.",
                                    feature_4_title: "24 langues.",
                                    feature_5_img: "icon_assessments",
                                    feature_5_subtitle: "Le module « English for Education » comporte des conseils hebdomadaires et des outils aidant les familles à acquérir des connaissances en langue anglaise et des séminaires mensuels en espagnol mettant en avant le soutien des familles aux apprenants de l’anglais.",
                                    feature_5_title: "Ressources pour le contact avec les proches. ",
                                    feature_6_img: "icon_placement",
                                    feature_6_subtitle: "Les guides du professeur, livrets de travail et guides d’activités en classe donnent aux enseignants des ressources qui les aident à enseigner en classe et complètent les leçons données en ligne.",
                                    feature_6_title: "Aide à la préparation des leçons. ",
                                    feature_7_img: "icon_proficiency",
                                    feature_7_subtitle: "« English for Education » comporte un classement et des examens des connaissances pour les élèves de l’enseignement primaire et secondaire, permettant aux professeurs de préciser le niveau de base de chaque élève.",
                                    feature_7_title: "Examen des connaissances.",
                                    feature_8_img: "icon_foundational",
                                    feature_8_subtitle: "Les apprenants sont instantanément confrontés à un contenu riche, adapté au rythme de progression de chaque élève, au sein d’un environnement interactif axé sur l’expression orale de l’étudiant.",
                                    feature_8_title: "Notions de base et contenu avancé.",
                                    feature_9_img: "icon_games",
                                    feature_9_subtitle: "L’acquisition de nouveau vocabulaire, des notions de grammaire et de prononciation se font de manière divertissante, entraînante, apte à faire progresser lecture, écoute et expression orale. ",
                                    feature_9_title: "Jeux et activités.",
                                    feature_10_img: "icon_reading",
                                    feature_10_subtitle: "Les activités prévues pour chaque niveau comprennent la lecture à haute voix avec retour instantané par le guide de prononciation (Reading Aloud), l’écriture sur des sujets bien précis ainsi que l’écoute et la compréhension écrite.  ",
                                    feature_10_title: "Lecture – écriture. ",
                                    feature_11_img: "icon_mobile",
                                    feature_11_subtitle: "Elles permettant aux étudiants d’utiliser leurs téléphones intelligents et leurs tablettes en classe et ailleurs pour suivre des leçons et participer à des activités qui renforcent leurs compétences et leur permettent d’augmenter leur vocabulaire.",
                                    feature_11_title: "Applications mobiles. ",
                                    feature_12_img: "icon_reporting",
                                    feature_12_subtitle: "Aperçus immédiats des  performances individuelles, de groupes et de classe, avec suivi de la progression et des compétences permettant aux enseignants et aux administrateurs d’établir rapidement des rapports faisant état des résultats des élèves. ",
                                    feature_12_title: "Outils de rédaction de rapports. ",
                                    feature_13_img: "icon_transferable",
                                    feature_13_subtitle: "Un système de gestion simple des licences permet aux enseignants et aux administrateurs de réassigner les licences  aux étudiants, pour assurer que la totalité des licences soit utilisée, assurant le retour sur investissement  optimal du programme",
                                    feature_13_title: "Les licences sont transférables.",
                                    feature_14_img: "icon_implementation",
                                    feature_14_subtitle: "Notre équipe rassemble les objectifs d’apprentissage de la langue en plusieurs modules efficaces et vous apporte son aide dans la préparation, la mise en œuvre et la promotion du programme dans les écoles. ",
                                    feature_14_title: "Appui à la mise en œuvre. ",
                                    feature_15_img: "icon_training",
                                    feature_15_subtitle: "Plusieurs niveaux de formation des administrateurs et enseignants sont proposés ; ils contribuent au lancement efficace du programme, l’intégrant à l’enseignement donné par le professeur en classe.",
                                    feature_15_title: "Services de formation.",
                                    feature_section_title: "Le programme présente de Multiples Avantages"
                                }
                            }
                        ]
                    }
                ],
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$e({ strings }),
                lead_generation_bar: lead_generation_bar$e()
            }
        };
    }
    return pageConfig;
};

var education_primary_footer_config$4 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/lp/l1/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_demo_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/ecoles-primaires-secondaires/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/education-superieure/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_secondary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/entreprises/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/mobile-apps/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_products_mobile_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/avis",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_products_reviews_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/lp/a-propos/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/magazine/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_blog_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/presse",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/lp/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/fr/work",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/faq/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/configurations-recquises/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_system_requirements_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.fr/mentions-legales/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.fr/modalites-et-conditions/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.co.uk/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: false,
            label: "",
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStoneEU",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/RosettaStoneUK",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastoneUK",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var education_secondary_nav_secondary_config$4 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: "https://enterpriseblog.rosettastone.com/",
        external: true,
        new_window: true,
        label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
        visible: true,
        destination: "/ressources/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
        visible: false,
        destination: "/solutions/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_education_secondary_label
    }
});

var lead_generation_bar$d = () => {
    return {
        visible: true,
        dataQa: "lead generation bar",
        lead_generation_button: {
            schedule_appointment: false,
            button: {
                destination: "/demande-de-prix/",
                new_window: false,
                size: "regular",
                text: "Demande de tarification",
                theme: "yellow_black"
            }
        },
        subtitle: {
            content: "",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        title: {
            content: "Vous cherchez une liste de pas?",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        }
    };
};

var verticals$d = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_education_primary,
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/ecoles-primaires-secondaires/"
            },
            name: strings.verticals_education_primary,
            title: {
                content: strings.verticals_education_primary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_education_secondary,
                src: verticals$q.educationSecondaryCirclePng
            },
            link: {
                destination: "/education-superieure/"
            },
            name: strings.verticals_education_secondary,
            title: {
                content: strings.verticals_education_secondary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_enterprise,
                src: verticals$q.enterpriseCirclePng
            },
            link: {
                destination: "/entreprises/"
            },
            name: strings.verticals_enterprise,
            title: {
                content: strings.verticals_enterprise,
                type: "card-title"
            }
        }
    ]
});

const education_secondary_pages_config$4 = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "dynamic-content") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "fr"
            },
            content: {
                copyData: copyData$4(),
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$d({ strings }),
                lead_generation_bar: lead_generation_bar$d()
            }
        };
    }
    if (page === "dynamic-resources") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "fr"
            },
            content: {
                hero: {
                    layout: "list",
                    panels: [
                        {
                            layout: "image-right",
                            alignItems: "center",
                            image: {
                                src: null
                            },
                            title: {
                                content: "Ressources"
                            },
                            body: {
                                content: "Laissez les apprenants parler pour eux-mêmes"
                            },
                            custom: {
                                lead_generation_button: {
                                    destination: "/demande-de-prix/",
                                    new_window: false,
                                    size: "regular",
                                    text: "Demande de tarification",
                                    theme: "yellow_black"
                                }
                            }
                        }
                    ]
                },
                copyData: copyData$4(),
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$d({ strings }),
                lead_generation_bar: lead_generation_bar$d()
            }
        };
    }
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Apprentissage des langues en ligne pourl'enseignemente supérieur | Rosetta Stone",
                meta_description: "Les solutions d’apprentissage des langues Rosetta Stone pour l’enseignement supérieur donnent aux étudiants un accès direct, en ligne, à l’apprentissage de l’anglais et des langues parlées dans le monde.",
                canonical_url: "https://www.rosettastone.fr/education-superieure/",
                lang: "fr"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                layout: "list",
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/demande-de-prix/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Demande de tarification",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                hero: {
                                    subtext: "Essayez une leçon"
                                },
                                image: {
                                    src: null
                                },
                                direction: "content-right",
                                title: {
                                    align: "left",
                                    content: "Mettez l’apprentissage des langues à la portée de tous les étudiants.",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                body: {
                                    content: "D’un glissement du doigt sur leur smartphone, les étudiants créent des connexions avec le monde entier. Pourtant, les écoles sont confrontées à des contraintes budgétaires en terme de programme linguistique Ceci limite le potentiel académique et les perspectives de carrière des élèves et rétrécit leur vision du monde. Dans l’économie globale du XXe siècle, les compétences linguistiques mondiales sont une exigence de recrutement."
                                }
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                visible: true,
                                dataQa: "2",
                                layout: "list",
                                product_sample_panels: [
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.bicicletaAzulPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.bicicletaAmarillaPng
                                            }
                                        },
                                        challenge_text: "Una bicicleta azul"
                                    },
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.dosBicicletasAzulesPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.dosBicicletasDiferentesPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules"
                                    },
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.verdesPorUnDiaPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.azulesPorUnDiaPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules por un día por favor"
                                    }
                                ],
                                content: [
                                    {
                                        body: {
                                            content: "Bien des étudiants des cycles supérieurs sont capables de passer un examen standardisé d'aptitude linguistique en anglais ; toutefois, les compétences linguistiques nécessaires pour réussir dans le monde universitaire sont souvent très différentes Les solutions d’apprentissage des langues de Rosetta Stone permettent aux étudiants non anglo-saxons d’aborder leurs études supérieures avec confiance et de les doter de la compétence linguistique nécessaire au succès."
                                        },
                                        direction: "image-left",
                                        title: {
                                            content: "Accélérez l’apprentissage de l'anglais.",
                                            type: "section-title",
                                            heading: "h2",
                                            theme: "black",
                                            align: "left"
                                        }
                                    }
                                ],
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/education-superieure/ressources/content/case-study-northern-border-university/",
                                    align: "left"
                                },
                                quote: "« À l´ère d´internet, , l’anglais étant la langue universelle, les étudiants se doivent de le maîtriser afin de se maintenir à niveau au cours de leurs études, et plus tard, de leur carrière. »",
                                attribution: "Doyen, décanat des   études préparatoires et des études secondaires , Northern Border University, Arar, Arabie Saoudite "
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                layout: "list",
                                direction: "image-right",
                                title: {
                                    content: "L’apprentissage des langues en ligne est adapté au mode de vie des étudiants.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                body: {
                                    content: "La culture, les distractions, les sports, la littérature – tout est désormais à portée d´un clic. En intégrant un programme de Rosetta Stone à votre cursus linguistique, vous offrez à vos étudiants une ressource pour la prononciation disponible 24 h sur 24 – une chose que les cours ex cathedra ne peuvent leur apporter."
                                },
                                image: {
                                    src: null
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/education-superieure/ressources/content/etude-de-cas-liberty-university/",
                                    align: "left"
                                },
                                quote: "« Une fois les cours pilotes pour la conversation mis en place, nos étudiants se sont  présentés à l’entretien d’évaluation (OPIc) du Conseil américain pour l'apprentissage des langues étrangères (American Council on the Teaching of Foreign Languages, ACTFL®). Après un seul semestre Ad’études, les étudiants des cours de premier niveau obtinrent des résultats de niveau “novice-moyen” ou supérieur à l’OPIc. »",
                                attribution: "Directeur du département, Études générales, Liberty University"
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                layout: "list",
                                direction: "image-left",
                                title: {
                                    content: "Le tutorat en ligne fait parler les apprenants",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                body: {
                                    content: "Les étudiants, mais aussi les enseignants et les membres du personnel n désirent tous se sentir à l’aise dans leur nouvelle langue. Passer de l'environnement de l’apprentissage d’une langue au contexte réel demande de la pratique. Nos sessions de tutorats permettent aux apprenants de pratiquer leur nouvelle langue à leur propre niveau avec des locuteurs natifs. Ceci permet d’apprendre « intelligemment », dans un environnement en ligne sécurisé"
                                },
                                image: {
                                    src: null
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/education-superieure/ressources/content/case-study-canterbury-christ-church-university/",
                                    align: "left"
                                },
                                quote: "« Les solutions offertes par Rosetta Stone se sont avérées un excellent outil pour aider les participants à estimer eux-mêmes leur niveau de connaissances et à s’exposer à divers niveaux d’expérience interactive, ce qui les a fait progresser de façon indépendante. »",
                                attribution: "Coordinateur de programme, Université Canterbury Christ Church, Cantorbéry, Royaume-Uni"
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                layout: "list",
                                direction: "image-right",
                                title: {
                                    content: "Tirez parti du mobile.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                body: {
                                    content: "Il est souvent difficile de passer des heures en salle de classe. Notre application mobile offre à vos élèves l’accès aux leçons et au matériel sur demande. De cette manière, tout moment de la journée peut être consacré à l’étude."
                                },
                                image: {
                                    src: null
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/education-superieure/ressources/content/case-study-humboldt-state-university/",
                                    align: "left"
                                },
                                quote: "« [Le test de placement adaptatif, auquel l’élève est soumis en début de semestre et à nouveau en fin de semestre] permet à l’élève de mesurer ses progrès dans l’apprentissage de la langue. »",
                                attribution: "Directeur, Laboratoire des langues étrangères et de la culture, Université d'État de Humboldt, Arcata, Californie"
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                pageData: {
                                    learner_feature_1_icon_name: "icon_24",
                                    learner_feature_1_subtitle: "L’anglais et les langues du monde qui correspondent aux objectifs d’apprentissage de l´étudiant.",
                                    learner_feature_1_title: "24 Langues",
                                    learner_feature_2_icon_name: "icon_dynamic",
                                    learner_feature_2_subtitle: "Les apprenants sont plongés dans un environnement unilingue pour accélérer l’apprentissage. ",
                                    learner_feature_2_title: "Immersion selon un rythme personnel",
                                    learner_feature_3_icon_name: "icon_games",
                                    learner_feature_3_subtitle: "Les étudiants se divertissent tout en se remémorant la matière apprise.",
                                    learner_feature_3_title: "Jeux et activités",
                                    learner_feature_4_icon_name: "icon_truaccent",
                                    learner_feature_4_subtitle: "Aide à la prononciation disponible aux apprenants de tous les niveaux.",
                                    learner_feature_4_title: "Reconnaissance vocale TruAccent™",
                                    learner_feature_5_icon_name: "icon_tutoring",
                                    learner_feature_5_subtitle: "Au sein d’un environnement en ligne sécurisant, opérant au niveau de chacun.",
                                    learner_feature_5_title: "Tutorat en direct",
                                    learner_feature_6_icon_name: "icon_mobile",
                                    learner_feature_6_subtitle: "L’accès à l’apprentissage dans le téléphone mobile de l’étudiant.",
                                    learner_feature_6_title: "Application mobile",
                                    learner_feature_title: null
                                }
                            }
                        ]
                    }
                ],
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$d({ strings }),
                lead_generation_bar: lead_generation_bar$d()
            }
        };
    }
    if (page === "demande-de-prix") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Demande de prix | Rosetta Stone",
                meta_description: "Les services professionnels mondiaux et les cabinets de conseil se heurtent à des barrières linguistiques qui limitent leur capacité à servir les clients, à engager les employés et à développer leurs activités à l'échelle mondiale. Les solutions de formation linguistique aident les cabinets de conseil professionnels à maximiser les heures facturables par employé, ce qui prouve notre retour sur investissement significatif dans la formation linguistique dans toute l'organisation.",
                canonical_url: "https://www.rosettastone.fr/education-superieure/demande-de-prix/",
                lang: "fr"
            },
            content: {
                title: {
                    type: "section-title",
                    theme: "yellow",
                    content: "Réservez du temps avec un expert linguistique dès aujourd'hui."
                },
                sub_title: {
                    type: "section-sub-title",
                    theme: "white",
                    content: "Veuillez remplir le formulaire ci-dessous pour planifier un créneau afin de discuter de la façon dont nous pouvons vous aider."
                },
                lead_generation_form: {
                    title: {
                        theme: "blue",
                        type: "section-title",
                        content: "Vous y êtes presque!"
                    },
                    fields: {
                        first_name: {
                            field_name: "first_name",
                            field_type: "text",
                            label: "Prénom",
                            required: true,
                            required_error: "Veuillez entrer votre prénom."
                        },
                        last_name: {
                            field_name: "last_name",
                            type: "text",
                            label: "Nom",
                            required: true,
                            required_error: "Veuillez entrer votre nom."
                        },
                        email: {
                            field_name: "email",
                            field_type: "email",
                            label: "Adresse e-mail",
                            required: true,
                            required_error: "Veuillez entrer votre adresse e-mail.",
                            validation_error: "Please enter a valid Email Address."
                        },
                        phone: {
                            field_name: "phone",
                            field_type: "tel",
                            label: "Numéro de téléphone*",
                            required: true,
                            required_error: null
                        },
                        organization_name: {
                            field_name: "organization_name",
                            field_type: "text",
                            label: "Société",
                            required: true,
                            required_error: "Veuillez entrer le nom de votre société."
                        },
                        organization_size: {
                            field_name: "organization_size",
                            field_type: "text",
                            label: "Taille de la société",
                            required: true,
                            required_error: "Veuillez entrer la taille de votre société.",
                            options: [
                                { value: "", label: "" },
                                { value: "100 ou Moins", label: "100 ou Moins" },
                                { value: "101 - 500", label: "101 - 500" },
                                {
                                    value: "501 - 1,000",
                                    label: "501 - 1,000"
                                },
                                { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                {
                                    value: "10,001 - 25,000",
                                    label: "10,001 - 25,000"
                                },
                                {
                                    value: "25,001 - 50,000",
                                    label: "25,001 - 50,000"
                                },
                                {
                                    value: "50,001 ou Plus",
                                    label: "50,001 ou Plus"
                                }
                            ]
                        },
                        role: {
                            field_name: "title",
                            field_type: "select",
                            label: "Titre",
                            required: true,
                            required_error: "Veuillez entrer votre fonction."
                        },
                        explicitOptIn: {
                            field_name: "explicitOptIn",
                            required: false
                        }
                    },
                    button: {
                        as: "button",
                        type: "submit",
                        size: "regular",
                        text: "Demande de tarification"
                    },
                    labels: {
                        form_privacy1: "Rosetta Stone s'engage à protéger votre vie privée. Notre politique de confidentialité complète est disponible ",
                        form_privacy2: "ici.",
                        form_privacy3: "Je comprends que je peux choisir à tout moment de ne pas participer à de telles communications en cliquant sur le lien fourni dans la communication ou en contactant Rosetta Stone à l'adresse",
                        form_privacy4: ".",
                        form_privacyUrl: "https://resources.rosettastone.com/CDN/fr/pdfs/France_Privacy_Policy.pdf",
                        form_privacyemail: "privacyofficer@rosettastone.com",
                        form_updateagreement1: "Oui! J'aimerais recevoir les mises à jour et le marketing du produit de Rosetta Stone. Cliquez ",
                        form_updateagreement2: "ici",
                        form_updateagreement3: "pour plus d'informations."
                    },
                    domain: ".fr",
                    dataQaLocation: "page"
                },
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$d({ strings })
            }
        };
    }
    if (page === "demande-de-prix-terminee") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Demande de prix terminee | Rosetta Stone",
                meta_description: "Les services professionnels mondiaux et les cabinets de conseil se heurtent à des barrières linguistiques qui limitent leur capacité à servir les clients, à engager les employés et à développer leurs activités à l'échelle mondiale. Les solutions de formation linguistique aident les cabinets de conseil professionnels à maximiser les heures facturables par employé, ce qui prouve notre retour sur investissement significatif dans la formation linguistique dans toute l'organisation.",
                canonical_url: "https://www.rosettastone.fr/education-superieure/demande-de-prix-terminee/",
                lang: "fr"
            },
            content: {
                title: {
                    align: "center",
                    content: "Nous vous remercions pour votre intérêt !",
                    heading: "h1",
                    theme: "blue",
                    type: "page-title"
                },
                sub_title: {
                    align: "center",
                    heading: "h2",
                    content: "Découvrez quelques ressources supplémentaires avant votre réunion!",
                    type: "page-sub-title"
                },
                resources_link: {
                    destination: "/ressources/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Ressources",
                    theme: "blue_white"
                },
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$d({ strings })
            }
        };
    }
    return pageConfig;
};

var education_secondary_footer_config$4 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/lp/l1/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_demo_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/ecoles-primaires-secondaires/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/education-superieure/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_secondary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/entreprises/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/mobile-apps",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_products_mobile_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/avis",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_products_reviews_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/lp/a-propos/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/magazine/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_blog_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/presse",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/lp/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/fr/work",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/faq",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/configurations-recquises",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_system_requirements_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.fr/mentions-legales/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.fr/modalites-et-conditions/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.co.uk/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: false,
            label: "",
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStoneEU",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/RosettaStoneUK",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastoneUK",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var enterprise_nav_secondary_config$4 = ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: "https://enterpriseblog.rosettastone.com/",
        external: true,
        new_window: true,
        label: strings.nav_secondary_enterprise_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_home_label
    },
    resources: {
        visible: true,
        destination: "/ressources/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
        visible: true,
        destination: "/solutions/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_solutions_label
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,
        label: strings.nav_secondary_enterprise_label
    }
});

var lead_generation_bar$c = () => {
    return {
        visible: true,
        dataQa: "lead generation bar",
        lead_generation_button: {
            schedule_appointment: false,
            button: {
                destination: "/demande-de-prix/",
                new_window: false,
                size: "regular",
                text: "Demande de tarification",
                theme: "yellow_black"
            }
        },
        subtitle: {
            content: "",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-sub-title"
        },
        title: {
            content: "Vous cherchez une liste de pas?",
            align: "left",
            theme: "white",
            heading: "div",
            type: "banner-title"
        }
    };
};

var verticals$c = ({ strings }) => ({
    visible: true,
    title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
    },
    panels: [
        {
            image: {
                type: "static",
                alt: strings.verticals_education_primary,
                src: verticals$q.educationPrimaryCirclePng
            },
            link: {
                destination: "/ecoles-primaires-secondaires/"
            },
            name: strings.verticals_education_primary,
            title: {
                content: strings.verticals_education_primary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_education_secondary,
                src: verticals$q.educationSecondaryCirclePng
            },
            link: {
                destination: "/education-superieure/"
            },
            name: strings.verticals_education_secondary,
            title: {
                content: strings.verticals_education_secondary,
                type: "card-title"
            }
        },
        {
            image: {
                type: "static",
                alt: strings.verticals_enterprise,
                src: verticals$q.enterpriseCirclePng
            },
            link: {
                destination: "/entreprises/"
            },
            name: strings.verticals_enterprise,
            title: {
                content: strings.verticals_enterprise,
                type: "card-title"
            }
        }
    ]
});

const enterprise_pages_config$4 = ({ page, strings }) => {
    let pageConfig = null;
    if (page === "dynamic-content") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Formation en langues  des affaires | Rosetta Stone",
                meta_description: "Les solutions de formation de Rosetta Stone aident les employés à acquérir des compétences linguistiques en anglais des affaires et bien d’autres langues étrangères.",
                canonical_url: "https://www.rosettastone.fr/entreprises/",
                lang: "fr"
            },
            content: {
                copyData: copyData$4(),
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$c({ strings }),
                lead_generation_bar: lead_generation_bar$c()
            }
        };
    }
    if (page === "dynamic-resources") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "",
                meta_description: "",
                canonical_url: "",
                lang: "fr"
            },
            content: {
                hero: {
                    layout: "list",
                    panels: [
                        {
                            layout: "image-right",
                            alignItems: "center",
                            image: {
                                src: null
                            },
                            title: {
                                content: ""
                            },
                            body: {
                                content: ""
                            },
                            custom: {
                                lead_generation_button: {
                                    destination: "/demande-de-prix/",
                                    new_window: false,
                                    size: "regular",
                                    text: "Demande de tarification",
                                    theme: "yellow_black"
                                }
                            }
                        }
                    ]
                },
                copyData: copyData$4(),
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$c({ strings }),
                lead_generation_bar: lead_generation_bar$c()
            }
        };
    }
    if (page === "home") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Formation en langues  des affaires | Rosetta Stone",
                meta_description: "Les solutions de formation de Rosetta Stone aident les employés à acquérir des compétences linguistiques en anglais des affaires et bien d’autres langues étrangères.",
                canonical_url: "https://www.rosettastone.fr/entreprises/",
                lang: "fr"
            },
            content: {
                sections: [
                    {
                        panels: [
                            {
                                layout: "list",
                                custom: {
                                    lead_generation_button: {
                                        schedule_appointment: false,
                                        completion_redirect: null,
                                        button: {
                                            destination: "/demande-de-prix/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Demande de tarification",
                                            theme: "yellow_black"
                                        }
                                    }
                                },
                                hero: {
                                    subtext: "Vous vous demandez comment une telle chose est possible. Essayez une leçon gratuite."
                                },
                                image: {
                                    src: null
                                },
                                direction: "content-right",
                                title: {
                                    align: "left",
                                    content: "Les employés accomplis connaissent les langues du monde des affaires.",
                                    heading: "h1",
                                    type: "page-title",
                                    theme: "black"
                                },
                                body: {
                                    content: "Apprendre une nouvelle langue des affaires demande du temps et des efforts. Rosetta Stone donne aux employés la possibilité de s’exprimer et de corriger immédiatement leur prononciation. Ils seront très rapidement prêts à parler, contribuant ainsi au succès de vos affaires.Apprendre une nouvelle langue des affaires demande du temps et des efforts. Rosetta Stone donne aux employés la possibilité de s’exprimer et de corriger immédiatement leur prononciation. Ils seront très rapidement prêts à parler, contribuant ainsi au succès de vos affaires."
                                }
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                visible: true,
                                dataQa: "2",
                                layout: "list",
                                product_sample_panels: [
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.bicicletaAzulPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.bicicletaAmarillaPng
                                            }
                                        },
                                        challenge_text: "Una bicicleta azul"
                                    },
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.dosBicicletasAzulesPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.dosBicicletasDiferentesPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules"
                                    },
                                    {
                                        left_option: {
                                            is_correct: true,
                                            image: {
                                                src: productSample.verdesPorUnDiaPng
                                            }
                                        },
                                        right_option: {
                                            is_correct: false,
                                            image: {
                                                src: productSample.azulesPorUnDiaPng
                                            }
                                        },
                                        challenge_text: "Dos bicicletas azules por un día por favor"
                                    }
                                ],
                                content: [
                                    {
                                        body: {
                                            content: "Les employés apprennent le plus facilement lorsque tout ce qu´ils entendent, parlent, lisent et écrivent est dans leur nouvelle langue. Donner confiance à l’étudiant dès la première leçon : c’est ce que permet notre méthode « Dynamic Immersion® »."
                                        },
                                        direction: "image-left",
                                        title: {
                                            content: "Apprenez de façon naturelle.",
                                            type: "section-title",
                                            heading: "h2",
                                            theme: "black",
                                            align: "left"
                                        }
                                    }
                                ],
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/entreprises/ressources/content/hitachi-data-systems-etude-de-cas/",
                                    align: "left"
                                },
                                quote: "« Rosetta Stone nous aide à niveler les obstacles et stimule l’engagement de nos employés. »",
                                attribution: "Vice-président, Apprentissage et collaboration, Hitachi Data Systems."
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                layout: "list",
                                direction: "image-right",
                                title: {
                                    content: "Commencez à parler.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                body: {
                                    content: "La crainte de commettre des erreurs fait que les apprenants sont gênés de parler la langue qu’ils apprennent. Notre moteur de reconnaissance et de synthèse vocale TruAccent™ permet aux employés de confirmer leur prononciation, ce qui les aidera à être plus confiants en parlant r affaires dans leur nouvelle langue."
                                },
                                image: {
                                    src: null
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/entreprises/ressources/content/e-on/",
                                    align: "left"
                                },
                                quote: "« L’un des principaux avantages de l’apprentissage des langues avec Rosetta Stone est la possibilité d’apprendre à tous les moments de la journée, n’importe où, et à son propre rythme .  »",
                                attribution: "Directeur, RH, CoC, Centre mondial de formation, E.ON."
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                layout: "list",
                                direction: "image-left",
                                title: {
                                    content: "Faites-vous entendre.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                body: {
                                    content: "Il y a un pas entre la connaissance d’une langue apprise en cours et le fait de tenir une conversation avec des collègues étrangers et des clients . Les sessions de tutorat données par des locuteurs natifs comprennent des conversations, permettant aux apprenants de se familiariser avec les expressions usuelles de leur nouvelle langue."
                                },
                                image: {
                                    src: null
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/entreprises/ressources/content/case-study-kimberly-clark-corporation/",
                                    align: "left"
                                },
                                quote: "« L’instauration d’un programme à l’échelle de l’entreprise nous a permis de réaliser des économies significatives. »",
                                attribution: "Principal conseiller en management, Kimberly-Clark Corporation."
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                layout: "list",
                                direction: "image-right",
                                title: {
                                    content: "Tirez parti du mobile.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                body: {
                                    content: "Il est souvent difficile de passer des heures en salle de classe. Notre application mobile offre à vos élèves l’accès aux leçons et au matériel sur demande. De cette manière, tout moment de la journée peut être consacré à l’étude."
                                },
                                image: {
                                    src: null
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/entreprises/ressources/content/etude-de-cas-tripadvisor",
                                    align: "left"
                                },
                                quote: "« J’ADORE CETTE MÉTHODE ! Rosetta Stone me permet d’apprendre une nouvelle langue moi-même, à mon propre rythme, après mon travail. »",
                                attribution: "Un employé de TripAdvisor, Singapour."
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                pageData: {
                                    learner_feature_1_icon_name: "icon_24",
                                    learner_feature_1_subtitle: "Parmi elles, il y a une langue qui répondra aux besoins de chacun de vos employés.",
                                    learner_feature_1_title: "24 langues",
                                    learner_feature_2_icon_name: "icon_dynamic",
                                    learner_feature_2_subtitle: "Il est plus facile d’apprendre une langue rapidement lorsqu’elle est omniprésente.",
                                    learner_feature_2_title: "Immersion selon un rythme personnel",
                                    learner_feature_3_icon_name: "icon_foundational",
                                    learner_feature_3_subtitle: "Les leçons s’adaptent aux élèves, et non le contraire.",
                                    learner_feature_3_title: "Contenu attrayant",
                                    learner_feature_4_icon_name: "icon_truaccent",
                                    learner_feature_4_subtitle: "Les employés peuvent vérifier leur prononciation à leur guise, à tout instant.",
                                    learner_feature_4_title: "Reconnaissance vocale TruAccent™",
                                    learner_feature_5_icon_name: "icon_tutoring",
                                    learner_feature_5_subtitle: "Pouvoir converser avec des locuteurs natifs est un gage de succès.",
                                    learner_feature_5_title: "Tutorat en direct ",
                                    learner_feature_6_icon_name: "icon_mobile",
                                    learner_feature_6_subtitle: "Apprendre et pratiquer la nouvelle langue à tout instant.",
                                    learner_feature_6_title: "Application mobile",
                                    learner_feature_title: "Obtenez des réponses à vos questions sur nos tarifs."
                                }
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                pageData: {
                                    admin_feature_1_icon_name: "icon_placement",
                                    admin_feature_1_subtitle: "Il fait correspondre les objectifs avec le rythme choisi par l'apprenant. ",
                                    admin_feature_1_title: "Placement personnalisé",
                                    admin_feature_2_icon_name: "icon_assessments",
                                    admin_feature_2_subtitle: "Pour prendre un bon départ, il faut connaître le niveau de connaissances des employés.",
                                    admin_feature_2_title: "Évaluation",
                                    admin_feature_3_icon_name: "icon_proficiency",
                                    admin_feature_3_subtitle: "Il s’utilise au début et tout au long du cours pour évaluer les progrès réalisés.",
                                    admin_feature_3_title: "Test des connaissances de l’anglais",
                                    admin_feature_4_icon_name: "icon_reporting",
                                    admin_feature_4_subtitle: "Les rapports en temps réel aident à déterminer le rendement de l’investissement.",
                                    admin_feature_4_title: "Rapports",
                                    admin_feature_5_icon_name: "icon_implementation",
                                    admin_feature_5_subtitle: "Les services de nos experts aident les administrateurs à bien commencer les cours.",
                                    admin_feature_5_title: "Soutien à la mise en place",
                                    admin_feature_6_icon_name: "icon_training",
                                    admin_feature_6_subtitle: "Taillés sur mesure pour la taille et les besoins de votre organisation.",
                                    admin_feature_6_title: "Services de formation",
                                    admin_feature_title: "Fonctions destinées à l’administrateur"
                                },
                                img_bg: null
                            }
                        ]
                    }
                ],
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$c({ strings }),
                lead_generation_bar: lead_generation_bar$c()
            }
        };
    }
    if (page === "demande-de-prix") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Demande de prix | Rosetta Stone",
                meta_description: "Les services professionnels mondiaux et les cabinets de conseil se heurtent à des barrières linguistiques qui limitent leur capacité à servir les clients, à engager les employés et à développer leurs activités à l'échelle mondiale. Les solutions de formation linguistique aident les cabinets de conseil professionnels à maximiser les heures facturables par employé, ce qui prouve notre retour sur investissement significatif dans la formation linguistique dans toute l'organisation.",
                canonical_url: "https://www.rosettastone.fr/enterprises/demande-de-prix/",
                lang: "fr"
            },
            content: {
                title: {
                    type: "section-title",
                    theme: "yellow",
                    content: "Réservez du temps avec un expert linguistique dès aujourd'hui."
                },
                sub_title: {
                    type: "section-sub-title",
                    theme: "white",
                    content: "Veuillez remplir le formulaire ci-dessous pour planifier un créneau afin de discuter de la façon dont nous pouvons vous aider."
                },
                lead_generation_form: {
                    title: {
                        theme: "blue",
                        type: "section-title",
                        content: "Vous y êtes presque!"
                    },
                    fields: {
                        first_name: {
                            field_name: "first_name",
                            field_type: "text",
                            label: "Prénom",
                            required: true,
                            required_error: "Veuillez entrer votre prénom."
                        },
                        last_name: {
                            field_name: "last_name",
                            type: "text",
                            label: "Nom",
                            required: true,
                            required_error: "Veuillez entrer votre nom."
                        },
                        email: {
                            field_name: "email",
                            field_type: "email",
                            label: "Adresse e-mail",
                            required: true,
                            required_error: "Veuillez entrer votre adresse e-mail.",
                            validation_error: "Please enter a valid Email Address."
                        },
                        phone: {
                            field_name: "phone",
                            field_type: "tel",
                            label: "Numéro de téléphone*",
                            required: true,
                            required_error: null
                        },
                        organization_name: {
                            field_name: "organization_name",
                            field_type: "text",
                            label: "Société",
                            required: true,
                            required_error: "Veuillez entrer le nom de votre société."
                        },
                        organization_size: {
                            field_name: "organization_size",
                            field_type: "text",
                            label: "Taille de la société",
                            required: true,
                            required_error: "Veuillez entrer la taille de votre société.",
                            options: [
                                { value: "", label: "" },
                                { value: "100 ou Moins", label: "100 ou Moins" },
                                { value: "101 - 500", label: "101 - 500" },
                                {
                                    value: "501 - 1,000",
                                    label: "501 - 1,000"
                                },
                                { value: "1,001 - 5,000", label: "1,001 - 5,000" },
                                { value: "5,001 - 10,000", label: "5,001 - 10,000" },
                                {
                                    value: "10,001 - 25,000",
                                    label: "10,001 - 25,000"
                                },
                                {
                                    value: "25,001 - 50,000",
                                    label: "25,001 - 50,000"
                                },
                                {
                                    value: "50,001 ou Plus",
                                    label: "50,001 ou Plus"
                                }
                            ]
                        },
                        role: {
                            field_name: "title",
                            field_type: "select",
                            label: "Titre",
                            required: true,
                            required_error: "Veuillez entrer votre fonction."
                        },
                        explicitOptIn: {
                            field_name: "explicitOptIn",
                            required: false
                        }
                    },
                    button: {
                        as: "button",
                        type: "submit",
                        size: "regular",
                        text: "Demande de tarification"
                    },
                    labels: {
                        form_privacy1: "Rosetta Stone s'engage à protéger votre vie privée. Notre politique de confidentialité complète est disponible ",
                        form_privacy2: "ici.",
                        form_privacy3: "Je comprends que je peux choisir à tout moment de ne pas participer à de telles communications en cliquant sur le lien fourni dans la communication ou en contactant Rosetta Stone à l'adresse",
                        form_privacy4: ".",
                        form_privacyUrl: "https://resources.rosettastone.com/CDN/fr/pdfs/France_Privacy_Policy.pdf",
                        form_privacyemail: "privacyofficer@rosettastone.com",
                        form_updateagreement1: "Oui! J'aimerais recevoir les mises à jour et le marketing du produit de Rosetta Stone. Cliquez ",
                        form_updateagreement2: "ici",
                        form_updateagreement3: "pour plus d'informations."
                    },
                    domain: ".fr",
                    dataQaLocation: "page"
                },
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$c({ strings })
            }
        };
    }
    if (page === "demande-de-prix-terminee") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Demande de prix terminee | Rosetta Stone",
                meta_description: "Les services professionnels mondiaux et les cabinets de conseil se heurtent à des barrières linguistiques qui limitent leur capacité à servir les clients, à engager les employés et à développer leurs activités à l'échelle mondiale. Les solutions de formation linguistique aident les cabinets de conseil professionnels à maximiser les heures facturables par employé, ce qui prouve notre retour sur investissement significatif dans la formation linguistique dans toute l'organisation.",
                canonical_url: "https://www.rosettastone.fr/enterprises/demande-de-prix-terminee/",
                lang: "fr"
            },
            content: {
                title: {
                    align: "center",
                    content: "Nous vous remercions pour votre intérêt !",
                    heading: "h1",
                    theme: "blue",
                    type: "page-title"
                },
                sub_title: {
                    align: "center",
                    heading: "h2",
                    content: "Découvrez quelques ressources supplémentaires avant votre réunion!",
                    type: "page-sub-title"
                },
                resources_link: {
                    destination: "/ressources/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Ressources",
                    theme: "blue_white"
                },
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$c({ strings })
            }
        };
    }
    if (page === "solutions") {
        pageConfig = {
            page,
            helmet: {
                meta_title: "Formation globale linguistique pour les affaires | Rosetta Stone Catalyst",
                meta_description: "La formation globale linguistique pour les affaires de Rosetta Stone Catalyst offre des cours dans les principales langues des affaires que les employés peuvent apprendre où qu’ils se trouvent.  Demandez nos tarifs pour entreprises.",
                canonical_url: "https://www.rosettastone.fr/entreprises/solutions/",
                lang: "fr"
            },
            content: {
                sections: [
                    {
                        layout: "list",
                        panels: [
                            {
                                direction: "image-right",
                                video: {
                                    currentVideoUrl: "https://vimeo.com/616188813",
                                    controls: true
                                },
                                title: {
                                    content: "L’acquisition de nouvelles compétences linguistiques permet la collaboration au sein de l´entreprise.",
                                    align: "left",
                                    heading: "h2",
                                    type: "section-title"
                                },
                                justifyContent: "space-between",
                                body: {
                                    content: "L’ignorance de la langue d’un collaborateur signifie souvent une communication imparfaite ou faussée des bonnes idées qu’il pourrait partager. Avec Rosetta Stone® Catalyst™, les employés acquièrent des compétences linguistiques qui transformeront les informations contradictoires en une communication claire entre vos collaborateurs et vos clients."
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/entreprises/ressources/content/amgen-client-spotlight/",
                                    align: "left"
                                },
                                quote: "« Je pense réellement qu’il s’agit d’un atout majeur pour l’apprenant tout comme pour une multinationale comme Amgen. »",
                                attribution: "Manager, Business Performance, Amgen, Thousand Oaks, Californie",
                                custom: {
                                    lead_generation_button: {
                                        destination: "/demande-de-prix/",
                                        new_window: false,
                                        size: "regular",
                                        text: "Demande de tarification",
                                        theme: "yellow_black"
                                    }
                                }
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                body: {
                                    content: "Il est essentiel de pouvoir s’entretenir avec ses collaborateurs et collègues. Avec la formation Catalyst, les instructions deviennent claires, les employés comprennent et suivent les consignes et moins d’erreurs sont commises. Cela débouche sur une meilleure productivité."
                                },
                                direction: "image-left",
                                layout: "list",
                                title: {
                                    content: "Augmenter la productivité.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                image: {
                                    src: null
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/entreprises/ressources/content/language-training-productivity-ebook-snapshot/",
                                    align: "left"
                                },
                                quote: "Lire l’aperçu"
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                body: {
                                    content: "Le fait de se fier à des programmes de formation en langues provenant de fournisseurs locaux utilisant des méthodes et des approches différentes, aboutit à des résultats coûteux et inégaux. L’efficacité de Catalyst apporte le même enseignement primé à tous les employés, où qu’ils se trouvent, et en permanence, 24 h sur 24."
                                },
                                direction: "image-right",
                                layout: "list",
                                title: {
                                    content: "Passez à l’échelle mondiale.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                image: {
                                    src: null
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/entreprises/ressources/content/meet-global-challenges/",
                                    align: "left"
                                },
                                quote: "Lire la fiche descriptive"
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                body: {
                                    content: "La plupart des candidats recherchent les postes qui vont leur permettre de passer au niveau supérieur. Offrir à un candidat la possibilité d’apprendre une langue avec Catalyst sera perçu comme un élément important du poste et le fidélisera, une fois engagé."
                                },
                                direction: "image-left",
                                layout: "list",
                                title: {
                                    content: "Attirez les meilleurs talents.",
                                    type: "section-title",
                                    heading: "h2",
                                    theme: "black",
                                    align: "left"
                                },
                                align: "left",
                                link: {
                                    theme: "black",
                                    destination: "https://www.rosettastone.fr/entreprises/ressources/content/rosetta-playbook-september-2017-final-web/",
                                    align: "left"
                                },
                                image: {
                                    src: null
                                },
                                quote: "Lire le Playbook"
                            }
                        ]
                    },
                    {
                        panels: [
                            {
                                img_bg_top: images.solSection_7StoneBlueSvg,
                                img_bg_bottom: images.solSection_7StoneYellowSvg,
                                data: {
                                    feature_1_img: "icon_dynamic",
                                    feature_1_subtitle: "Activez l’apprentissage avec des leçons et des activités personnalisées en utilisant uniquement la nouvelle langue d’un employé qui apprend à parler, à lire, à écrire, à écouter et à penser d’une toute nouvelle façon.",
                                    feature_1_title: "Immersion dynamique.",
                                    feature_2_img: "icon_truaccent",
                                    feature_2_subtitle: "Les commentaires immédiats sur la prononciation aident les employés à parler correctement la langue, rendent l'apprentissage instantanément enrichissant et construisent les bases d'une plus grande confiance en soi.",
                                    feature_2_title: "TruAccent.",
                                    feature_3_img: "icon_tutoring",
                                    feature_3_subtitle: "Les exercices structurés, les conversations avec des locuteurs natifs et les séances dirigées par un instructeur et 1: 1 correspondent au niveau de compétence actuel des employés et mettent l’accent sur la parole.",
                                    feature_3_title: "Tutorat en direct.",
                                    feature_4_img: "icon_24",
                                    feature_4_subtitle: "Intégrez l'anglais et les langues du monde dans tous les programmes de formation linguistique pour développer et perfectionner les compétences linguistiques des employés à tous les niveaux, de débutant à avancé.",
                                    feature_4_title: "24 langues.",
                                    feature_5_img: "icon_assessments",
                                    feature_5_subtitle: "Les pré-tests en anglais, en espagnol et en français, ainsi que les auto-évaluations d'autres langues du monde, identifient divers besoins linguistiques et garantissent la productivité de la formation dès le début.",
                                    feature_5_title: "Évaluations.",
                                    feature_6_img: "icon_placement",
                                    feature_6_subtitle: "Recomienda una ruta de aprendizaje de idiomas adaptada para cada empleado en función de los objetivos y la competencia del alumno, y ofrece el nivel adecuado de desafío y compromiso.",
                                    feature_6_title: "Placement de l'apprenant.",
                                    feature_7_img: "icon_proficiency",
                                    feature_7_subtitle: "Évaluez les compétences en lecture et en écoute afin de déterminer les compétences linguistiques à l'aide de l'échelle du Cadre européen de référence (CECR).",
                                    feature_7_title: "Tests de compétence en anglais, espagnol et français",
                                    feature_8_img: "icon_foundational",
                                    feature_8_subtitle: "Les cours pour débutants sont consacrés à des sujets de la vie courante, tandis que les cours avancés vont de la culture et de l’histoire à des sujets spécifiques au secteur, avec un contenu sectoriel détaillé.",
                                    feature_8_title: "Contenu de base et avancé.",
                                    feature_9_img: "icon_games",
                                    feature_9_subtitle: "Renforcez le vocabulaire, la grammaire et la prononciation en engageant des activités qui développent la lecture, l’écoute et la parole.",
                                    feature_9_title: "Jeux et activités.",
                                    feature_10_img: "icon_reading",
                                    feature_10_subtitle: "L'apprentissage numérique propose des activités pour tous les niveaux d'apprentissage, y compris la lecture à voix haute avec commentaires de la parole, écriture à des fins spécifiques et compréhension à l'audition et à la lecture.",
                                    feature_10_title: "Lire et écrire.",
                                    feature_11_img: "icon_mobile",
                                    feature_11_subtitle: "Permet aux employés d'utiliser des smartphones et des tablettes à tout moment, n'importe où, pour un accès instantané aux leçons et activités qui renforcent la rétention des compétences et du vocabulaire.",
                                    feature_11_title: "Application mobile.",
                                    feature_12_img: "icon_reporting",
                                    feature_12_subtitle: "Reporting intégré des performances des individus, des groupes et des sites, avec suivi de la progression de l'utilisation et des compétences, permettant aux administrateurs d'aligner la formation sur les objectifs de l'entreprise",
                                    feature_12_title: "Outils de reporting.",
                                    feature_13_img: "icon_transferable",
                                    feature_13_subtitle: "La gestion simplifiée des licences permet aux gestionnaires et aux administrateurs de réaffecter et d’embarquer rapidement les employés et contribue à un retour sur investissement plus fort.",
                                    feature_13_title: "Licences transférables.",
                                    feature_14_img: "icon_implementation",
                                    feature_14_subtitle: "Notre équipe intègre des objectifs d'apprentissage linguistique dans des modèles efficaces et aide à la planification, au déploiement et à la promotion du programme dans l'ensemble de l'organisation.",
                                    feature_14_title: "Support de mise en œuvre.",
                                    feature_15_img: "icon_training",
                                    feature_15_subtitle: "Des niveaux de formation pour les administrateurs sont disponibles pour faciliter le lancement réussi du programme. Les employés commenceront à apprendre et à parler rapidement leur nouvelle langue.",
                                    feature_15_title: "Services de formation.",
                                    feature_section_title: "Toutes les ressources dont vous avez besoin sont à votre disposition."
                                }
                            }
                        ]
                    }
                ],
                awards: awards$4({ strings }),
                branded_quotes: branded_quotes$4({ strings }),
                verticals: verticals$c({ strings }),
                lead_generation_bar: lead_generation_bar$c()
            }
        };
    }
    return pageConfig;
};

var enterprise_footer_config$4 = ({ strings }) => ({
    visible: true,
    menu: {
        visible: true,
        sections: [
            {
                label: strings.footer_menu_products_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/lp/l1/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_demo_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/ecoles-primaires-secondaires/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_primary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/education-superieure/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_education_secondary_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/entreprises/",
                        external: true,
                        new_window: false,
                        label: strings.footer_menu_products_enterprise_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/mobile-apps/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_products_mobile_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/avis",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_products_reviews_label
                    }
                ]
            },
            {
                label: strings.footer_menu_about_label,
                links: [
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/lp/a-propos/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_about_us_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/magazine/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_blog_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/presse",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_press_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.com/careers/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_careers_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/lp/contact/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_about_contact_label
                    }
                ]
            },
            {
                label: strings.footer_menu_support_label,
                links: [
                    {
                        visible: true,
                        destination: "https://support.rosettastone.com/fr/work",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_support_site_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/faq/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_faqs_label
                    },
                    {
                        visible: true,
                        destination: "https://www.rosettastone.fr/configurations-recquises/",
                        external: true,
                        new_window: true,
                        label: strings.footer_menu_support_system_requirements_label
                    }
                ]
            }
        ]
    },
    meta: {
        visible: true,
        copyright: {
            visible: true,
            label: strings.footer_meta_copyright_label,
            IXLLabel: strings.footer_meta_copyright_IXL,
            destination: "/"
        },
        ixl_logo: footerIxlLogo({ strings }),
        rs_logo: footerRsLogo({ strings }),
        ccpa: {
            visible: true,
            label: strings.footer_meta_ccpa_label,
            destination: "https://www.rosettastone.com/legal/ccpa/"
        },
        cookieSettings: {
            visible: true,
            label: strings.footer_meta_cookie_settings_label,
            destination: "#"
        },
        agreements: {
            visible: true,
            label: strings.footer_meta_agreements_label,
            destination: "https://www.rosettastone.fr/mentions-legales/"
        },
        termsConditions: {
            visible: true,
            label: strings.footer_meta_terms_conditions_label,
            destination: "https://www.rosettastone.fr/modalites-et-conditions/"
        },
        privacyPolicy: {
            visible: true,
            label: strings.footer_meta_privacy_policy_label,
            destination: "https://www.rosettastone.co.uk/privacy/"
        },
        dataPrivacyAndSecurity: {
            visible: false,
            label: "",
            destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
        }
    },
    region_social: {
        visible: true,
        region: {
            visible: true,
            label: strings.footer_region_label,
            options: [
                {
                    destination: "https://www.rosettastone.com/",
                    label: strings.footer_region_options_us_label
                },
                {
                    destination: "https://espanol.rosettastone.com/",
                    label: strings.footer_region_options_la_label
                },
                {
                    destination: "https://pt.rosettastone.com/",
                    label: strings.footer_region_options_br_label
                },
                {
                    destination: "https://www.rosettastone.cn/",
                    label: strings.footer_region_options_cn_label
                },
                {
                    destination: "https://www.rosettastone.de/",
                    label: strings.footer_region_options_de_label
                },
                {
                    destination: "https://www.rosettastone.eu/",
                    label: strings.footer_region_options_eu_label
                },
                {
                    destination: "https://www.rosettastone.es/",
                    label: strings.footer_region_options_es_label
                },
                {
                    destination: "https://www.rosettastone.fr/",
                    label: strings.footer_region_options_fr_label
                },
                {
                    destination: "https://www.rosettastone.it/",
                    label: strings.footer_region_options_it_label
                },
                {
                    destination: "https://www.rosettastone.co.uk/",
                    label: strings.footer_region_options_uk_label
                },
                {
                    destination: "https://www.rosettastone.co.jp/",
                    label: strings.footer_region_options_jp_label
                },
                {
                    destination: "https://www.rosettastone.co.kr/",
                    label: strings.footer_region_options_kr_label
                }
            ]
        },
        social: {
            visible: true,
            label: strings.footer_social_label,
            options: [
                {
                    service: "facebook",
                    destination: "https://www.facebook.com/RosettaStoneEU",
                    image: social.facebookDarkSvg
                },
                {
                    service: "twitter",
                    destination: "https://twitter.com/RosettaStoneUK",
                    image: social.twitterDarkSvg
                },
                {
                    service: "instagram",
                    destination: "https://www.instagram.com/rosettastone",
                    image: social.instagramDarkSvg
                },
                {
                    service: "youtube",
                    destination: "https://www.youtube.com/user/rosettastoneUK",
                    image: social.youtubeDarkSvg
                }
            ]
        }
    }
});

var consumer_product_activation_footer_config$5 = (function (_ref) {
  var strings = _ref.strings;
  return {
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.fr/mentions-legales/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.fr/modalites-et-conditions/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.co.uk/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneEU",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var consumer_product_activation_pages_config$5 = (function (_ref) {
  var page = _ref.page;

  switch (page) {
    case "product-activation":
      return {
        page: page,
        helmet: {
          meta_title: "Rosetta Stone® - Online Subscription Product Activation",
          meta_description: "Activate your Rosetta Stone® language learning online subscription products.",
          canonical_url: "https://rosettastone.com/product/product-activation/",
          lang: "fr"
        }
      };

    default:
      return null;
  }
});

var fr = ({ market, site, page, locale, strings }) => {
    let nav_secondary = null;
    let page_config = null;
    let footer_config = null;
    switch (site) {
        case "business":
        case "enterprise":
            nav_secondary = enterprise_nav_secondary_config$4({ strings });
            page_config = enterprise_pages_config$4({ page, strings });
            footer_config = enterprise_footer_config$4({ strings });
            break;
        case "k12":
        case "education-primary":
            nav_secondary = education_primary_nav_secondary_config$4({ strings });
            page_config = education_primary_pages_config$4({ page, strings });
            footer_config = education_primary_footer_config$4({ strings });
            break;
        case "hed":
        case "education-secondary":
            nav_secondary = education_secondary_nav_secondary_config$4({ strings });
            page_config = education_secondary_pages_config$4({ page, strings });
            footer_config = education_secondary_footer_config$4({ strings });
            break;
        case "consumer-product-activation":
            footer_config = consumer_product_activation_footer_config$5({ strings });
            page_config = consumer_product_activation_pages_config$5({ page });
            break;
    }
    const nav_primary = nav_primary_config$4({ strings });
    return {
        market,
        site,
        vertical: site,
        locale,
        analytics: analytics$6,
        nav: {
            visible: true,
            primary: nav_primary || null,
            secondary: nav_secondary || null
        },
        footer: Object.assign({ visible: true }, footer_config),
        page: page_config
    };
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var analytics$5 = {
  gtm_id: "GTM-NDSR53K"
};

var nav_primary_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: true,
      destination: "https://www.rosettastone.es/magazine/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: false,
      destination: "/contact/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: {
      visible: true,
      image: {
        type: "static",
        src: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
      },
      link: {
        destination: "/",
        external: false,
        new_window: false
      }
    },
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:18003063467",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/ingles/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/frances/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/arabe/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/aleman/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }, {
        url: "/espanol/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }, {
        url: "/italiano/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }],
      language_options_other: [{
        url: "/chino/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/coreano/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/espanol-latinoamericano/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/filipino/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/griego/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/hebreo/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/hindu/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/holandes/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, {
        url: "/ingles-americano/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }, {
        url: "/irlandes/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/japones/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }, // {
      //     url: "/buy-latin/",
      //     title: strings.locale_la_va_label_primary,
      //     small: strings.locale_la_va_label_secondary
      // },
      {
        url: "/persa/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/polaco/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/portugues/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/ruso/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/sueco/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/turco/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/vietnamita/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label,
      product_title: strings.global_brand_name
    },
    sign_in: {
      visible: true,
      destination: "https://www.rosettastone.com/login",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: false,
      destination: "https://espanol.rosettastone.com/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_switch_language
    },
    support: {
      visible: true,
      destination: "https://support.rosettastone.com/es",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/educacion-primaria-y-secundaria/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: false,
      destination: "/educacion-superior/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_market_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/students/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/empresas/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var education_primary_nav_secondary_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: true,
      destination: "/soluciones/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var awards$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.awards_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.awards_twitter,
        src: logosTiles.logosTilesTwitterSvg
      }
    }, {
      image: {
        type: "static",
        alt: strings.awards_bmw,
        src: logosTiles.logosTilesBmwSvg
      }
    }, {
      image: {
        type: "static",
        alt: strings.awards_uber,
        src: logosTiles.logosTilesUberSvg
      }
    }, {
      image: {
        type: "static",
        alt: strings.awards_williams_sonoma,
        src: logosTiles.logosTilesWsSvg
      }
    }]
  };
});

var copyData$3 = (function () {
  return {
    about_us: "Rosetta Stone",
    about_us_url: "/a-cerca-de",
    agreements: "Acuerdos",
    agreements_url: "/acuerdos",
    almost_there: "Casi hecho aquí!",
    american: "(Americano)",
    anti_piracy: "Anti-piratería",
    anti_piracy_url: "/antipirateria",
    arabic: "Arabe",
    award_section_header: "Avalada durante 25+ años por las mejores organizaciones.",
    blog_url: "https://www.rosettastone.es/magazine",
    brasil: "Brasil",
    brasil_url: "https://www.rosettastonebrasil.com/",
    brazil: "(Brazil)",
    british: "(Británico)",
    business_contact_title: "Empresa - Consulta de Precios",
    careers: "Carrera profesional",
    careers_url: "https://www.rosettastone.com/careers",
    cart_checkout: "Revisa",
    cart_checkout_url: "https://secure.rosettastone.es/es_store_view/checkout/cart",
    cart_discount: "Descuento:",
    cart_empty: "Su carrito está vacío.",
    cart_in_your_cart: "en tu carrito.",
    cart_subtotal: "Total parcial:",
    cart_summary: "Resumen del pedido:",
    cart_total: "Total (antes de impuestos):",
    cart_you_have: "Tienes",
    change_region: "Cambia Región:",
    china: "中国",
    china_url: "http://www.rosettastone.cn/",
    combined_resources_url: "https://www.rosettastone.es/empresas/recursos/",
    company: "SOBRE",
    connect: "Conectate con nosotros:",
    consumer_home: "Personal",
    contact: "Contacto",
    contact_description: "Formulario de Consulta de Precios",
    contact_ee_url: "/contacto/",
    contact_url: "https://www.rosettastone.es/contacto",
    cta_bar: "Listo para el siguiente paso?",
    cta_h2: "Listo para el siguiente paso?",
    cta_text: "Consulta de Precios",
    currency: "€",
    demo_pricing_subtitle_business: "Descubra cómo nuestras soluciones comerciales pueden ayudar a su empresa a atraer talento y mejorar la productividad. Rellene el siguiente formulario y nos pondremos en contacto en breve.",
    demo_pricing_subtitle_hed: "Descubra cómo nuestras soluciones de educación superior pueden ayudar a sus alumnos a hablar un nuevo idioma con confianza. Rellene el siguiente formulario y nos pondremos en contacto en breve.",
    demo_pricing_subtitle_k12: "Descubra cómo nuestras soluciones educativas pueden ayudar a sus estudiantes de inglés y de World Language a hablar con confianza. Rellene el siguiente formulario y nos pondremos en contacto en breve.",
    demo_pricing_subtitle_pub: "Descubra cómo nuestras soluciones del sector público pueden mejorar las comunicaciones con aquellos a quienes sirve. Rellene el siguiente formulario y nos pondremos en contacto en breve.",
    demo_pricing_title: "Obtenga una consulta gratuita",
    deutschland: "Deutschland",
    deutschland_url: "https://www.rosettastone.de/",
    download_pdf: "Descargar PDF",
    dutch: "Holandés",
    english: "Inglés",
    espana: "España",
    espana_url: "https://www.rosettastone.es/",
    europe: "Europa",
    europe_url: "https://www.rosettastone.eu/",
    facebook_url: "http://www.facebook.com/RosettaStoneEurope",
    faq_url: "/pf",
    faqs: "Preguntas más frecuentes",
    farsi: " (Farsi)",
    filipino: "Filipino",
    for_business: "Para Empresas",
    for_business_resources_url: "https://www.rosettastone.es/empresas/recursos/",
    for_business_solutions_url: "https://www.rosettastone.es/empresas/soluciones/",
    for_business_url: "https://www.rosettastone.es/empresas/inicio/",
    for_educators: "Para Educadores",
    for_educators_resources_url: "https://www.rosettastone.es/empresas/recursos/",
    for_educators_solutions_url: "https://www.rosettastone.es/educacion-primaria-y-secundaria/soluciones/",
    for_educators_url: "https://www.rosettastone.es/educacion-primaria-y-secundaria/inicio/",
    for_hed: "Para educadores superiores",
    for_homeschool: null,
    for_homeschool_url: null,
    for_individuals: "Pruébalo gratis",
    for_individuals_url: "/demo",
    for_organizations: "Organizaciones",
    for_public_sector: "Apps para móvil",
    for_public_sector_url: "/movil",
    for_you: "Para Ti",
    form_100: "100 o Menos",
    form_500: "101 - 500",
    form_1000: "501 - 1,000",
    form_5000: "1,001 - 5,000",
    form_10000: "5,001 - 10,000",
    form_25000: "10,001 - 25,000",
    form_50000: "25,001 - 50,000",
    form_boardmember: "Miembro de la Junta",
    form_curriculumdirector: "Director de Currículo / Coordinador de Instrucción",
    form_director: "Director",
    form_email: "E-mail profesional",
    form_executive: "Dirección General / Ejecutivo",
    form_firstname: "Nombre",
    form_how_blog: "Blog",
    form_how_email: "Email",
    form_how_event: "Evento",
    form_how_online: "En línea",
    form_how_other: "Otro",
    form_how_referral: "Remisión",
    form_how_search: "Buscador",
    form_how_social: "Medios Sociales",
    form_how_title: "¿Como supiste de nosotros? (Opcional)",
    form_how_webinar: "Seminario Web",
    form_individualcontributor: "Colaborador Individual",
    form_lastname: "Apellidos",
    form_manager: "Gerente",
    form_more: "50,001 - Más",
    form_organization: "Nombre de la Organización",
    form_organizationsize: "Tamaño de la organización",
    form_phone: "Numero de Teléfono (Opcional)",
    form_principal: "Director de la Escuela",
    form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
    form_privacy2: "aquí.",
    form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
    form_privacy4: ".",
    form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
    form_privacyemail: "privacyofficer@rosettastone.com",
    form_role: "Rol (o título)",
    form_submit: "Consulta gratuita",
    form_superintendent: "Superintendente / Administrador de Distrito",
    form_teacher: "Profesor",
    form_techcoordinator: "Coordinador de Tecnologia",
    form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
    form_updateagreement2: "aquí",
    form_updateagreement3: "para más información.",
    form_vicepresident: "Vicepresidente",
    france: "France",
    france_url: "https://www.rosettastone.fr/",
    google_plus_url: "https://plus.google.com/105195149850491722010",
    greek: "Griego",
    gtm_id: "GTM-WBX2P8",
    has_combined_resources: true,
    has_resources: null,
    hebrew: "Hebreo",
    helpful_links: "Corrige la URL o prueba uno de estos enlaces útiles:",
    hide_cart: true,
    hide_contact: true,
    hide_espanol: true,
    hide_language: null,
    hide_search: true,
    hide_support: null,
    hindi: "Hindi",
    home: "Inicio",
    home_link: "/inicio/",
    home_url: "https://www.rosettastone.es/",
    instagram_url: "https://www.instagram.com/rosettastone",
    investors: "Relaciones inversionistas",
    investors_url: "https://investors.rosettastone.com/",
    irish: "Irlandés",
    italia: "Italia",
    italia_url: "https://www.rosettastone.it/",
    item: "artículo",
    item_plural: "artículos",
    japan: "日本",
    japan_url: "http://www.rosettastone.co.jp",
    japanese: "Japonés",
    k12_contact_title: "Educación - Consulta de Precios",
    keep_exploring: "Continuar explorando",
    korea: "대한민국",
    korea_url: "https://www.rosettakorea.com/",
    korean: "Coreano",
    latin: null,
    latin_america: "(Latinoamérica)",
    latin_america_region: "America Latina",
    latin_america_region_url: "https://espanol.rosettastone.com/",
    learn_arabic_url: "/aprende-arabe/",
    learn_chinese: "Chino",
    learn_chinese_url: "/aprende-chino/",
    learn_dutch_url: "/aprende-holandes/",
    learn_english: "Aprende Inglés",
    learn_english_british_url: "/aprende-ingles/",
    learn_english_url: "/aprende-ingles-americano/",
    learn_french: "Aprender Francés",
    learn_french_url: "/aprende-frances/",
    learn_german: "Aprender Alemán",
    learn_german_url: "/aprende-aleman/",
    learn_greek_url: "/aprende-griego/",
    learn_hebrew_url: "/aprende-hebreo/",
    learn_hindi_url: "/aprende-hindu/",
    learn_irish_url: "/aprende-irlandes/",
    learn_italian: "Aprender Italiano",
    learn_italian_url: "/aprende-italiano/",
    learn_japanese_url: "/aprende-japones/",
    learn_korean_url: "/aprende-coreano/",
    learn_latin_url: null,
    learn_more: "Saber más",
    learn_persian_url: "/aprende-persa/",
    learn_polish_url: "/aprende-polaco/",
    learn_portuguese_url: "/aprende-portugues/",
    learn_russian_url: "/aprende-ruso/",
    learn_spanish: "Aprender Español",
    learn_spanish_spain_url: "/aprende-espanol/",
    learn_spanish_url: "/aprende-espanol-latinoamericano/",
    learn_swedish_url: "/aprende-sueco/",
    learn_tagalog_url: "/aprende-filipino/",
    learn_turkish_url: "/aprende-turco/",
    learn_vietnamese_url: "/aprende-vietnamita/",
    lexia_learning: "Opiniones",
    lexia_learning_url: "/resenas-clientes",
    listen_now: "Escucha ahora",
    madarin: "(Mandarín)",
    market: ['ES'],
    media_quote_1: "”Me encanta el programa de Rosetta Stone y creo que su método para ",
    media_quote_1_bold: "aprender idiomas funciona.",
    media_quote_1_end: "”",
    media_quote_2: "“Con su interfaz excelente para el usuario, instrucciones claras y una amplia gama de juegos y retos...",
    media_quote_2_bold: "Rosetta Stone sorprende.",
    media_quote_2_end: "\"",
    media_quote_3: "“",
    media_quote_3_bold: "La joya de la corona",
    media_quote_3_end: "entre los métodos de aprendizaje de idiomas por ordenador.\"",
    more_resources_title: "Recursos adicionales",
    more_specify: "Por favor específica",
    no_support_dropdown: true,
    persian: "Persa",
    polish: "Polaco",
    portuguese: "Portugués ",
    press: "Prensa",
    press_url: "/prensa",
    pricing_subtitle: "Por favor complete y nos pondremos en contacto con usted de inmediato.",
    pricing_thanks: "¡Gracias por tu interés! Alguien hará un seguimiento contigo en breve.",
    pricing_title: "Obtenga las respuestas sobre precios que necesita.",
    privacy_policy: "Política de privacidad",
    privacy_policy_url: "/privacidad",
    products: "¿DÓNDE EMPEZAR?",
    questions_call: "¿Tener preguntas? Llámanos",
    read_article: "Lee el artículo",
    read_case_study: "Lee más",
    read_ebook: "Lee el eBook",
    read_fact_sheet: "Lee más",
    read_guide: "Lee la guía",
    read_more: "Lee más",
    read_report: "Lee el informe",
    read_white_paper: "Lee más",
    related_resources_title: "Recursos Relacionados",
    request_pricing: "Consulta de Precios",
    resources: "Recursos",
    resources_link: "/recursos/",
    rosetta_copyright: "1999-2019 Rosetta Stone LLC. Todos los derechos reservados. Este sitio utiliza cookies. Mediante la utilización de este sitio web otorga su consentimiento para el uso de cookies. Saber más.",
    rosetta_stone: "Rosetta Stone",
    russian: "Ruso",
    search: "Buscar...",
    search_rosetta_url: "https://search.rosettastone.com/",
    select_lang: "Selecciona un idioma:",
    services: null,
    services_url: null,
    shop_now: null,
    sign_in: "Ingresar",
    sign_in_url: "https://launch.rosettastone.com/es/osub/authenticate",
    similar_resources: "Recursos Similares",
    site_not_found: "Sitio no encontrado - 404",
    sitemap: "Mapa del sitio",
    sitemap_url: "/mapa-sitio",
    solutions: "Soluciones",
    solutions_link: "/soluciones/",
    spain: "(España)",
    spanish: "Español",
    support: "Asistencia",
    support_business_url: "https://support.rosettastone.com/es/enterprises",
    support_chat: "Chat de soporte técnico en vivo",
    support_chat_live: "Chat de soporte técnico en vivo",
    support_chat_live_url: "https://rosettastone.secure.force.com/apex/PreLiveChatForm",
    support_chat_url: "https://support.rosettastone.com/es/chat",
    support_classrooms: "Apoyo a Aulas y Empresas:",
    support_faq_btn: "Ver todas las preguntas frecuentes",
    support_faq_title: "Preguntas Frecuentes",
    support_faq_url_1: "/pf#pquest1",
    support_faq_url_1_title: "¿Qué es la Solución Rosetta Stone?",
    support_faq_url_2: "/pf#pquest2",
    support_faq_url_2_title: "¿Qué incluye la solución TOTALe online?",
    support_faq_url_3: "/pf#pquest3",
    support_faq_url_3_title: "¿Cómo y dónde consigo las aplicaciones para mi iPhone, iPad o dispositivo Android?",
    support_faq_url_4: "/pf#pquest4",
    support_faq_url_4_title: "¿Cómo funciona el método Rosetta Stone?",
    support_for_you: "Personal",
    support_home: "APOYO",
    support_site: "Sitio de soporte",
    support_site_url: "https://support.rosettastone.com/es/",
    swedish: "Sueco",
    switch_lang: "Español",
    switch_lang_url: "https://espanol.rosettastone.com/",
    system_reqs: "Requisitos del sistema",
    system_reqs_url: "/requerimientos-sistema",
    tagalog: "(Tagalo)",
    telephone_atr: "+ 44 (0) 20 7 749 2979",
    telephone_text: "1-(800)-ROSETTA",
    terms_conditions: "Términos y condiciones",
    terms_conditions_url: "/terminos",
    title: "es-copy",
    turkish: "Turco",
    twitter_url: "https://twitter.com/RosettaStoneUK",
    united_kingdom: "United Kingdom",
    united_kingdom_url: "https://www.rosettastone.co.uk/",
    united_states: "United States",
    united_states_url: "https://www.rosettastone.com",
    use_new_header: null,
    vertical: ['recECBjZxFEWVVls8'],
    vertical_business: "Empresa",
    vertical_business_link: "/empresas/inicio/",
    vertical_healthcare: null,
    vertical_healthcare_link: null,
    vertical_hed: "Educación Superior",
    vertical_hed_link: "/educacion-superior/inicio/",
    vertical_k12: "Educación",
    vertical_k12_link: "/educacion-primaria-y-secundaria/inicio/",
    vertical_pub: "Sector Público",
    vertical_pub_link: "/sector-publico/",
    verticals_subtitle: "Nuestras galardonadas soluciones lingüísticas funcionan para todo tipo de estudiantes.",
    verticals_title: "¿Qué tipo de aprendiz eres?",
    vietnamese: "Vietnamita",
    view_infographic: "Ver más",
    watch_video: "Ver el vídeo",
    watch_webinar: "Ver el webinar",
    youtube_url: "http://www.youtube.com/user/RosettaStoneUK"
  };
});

var branded_quotes$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.branded_quotes_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      name: strings.branded_quotes_macworld_name,
      type: strings.branded_quotes_macworld_type,
      quote: strings.branded_quotes_macworld_quote,
      logo: {
        type: "static",
        src: logos.logoMacworldSvg
      },
      backdrop: logos.logoMacworldBgSvg
    }, {
      name: strings.branded_quotes_techcrunch_name,
      type: strings.branded_quotes_techcrunch_type,
      quote: strings.branded_quotes_techcrunch_quote,
      logo: {
        type: "static",
        src: logos.logoTechcrunchSvg
      },
      backdrop: logos.logoTechcrunchBgSvg
    }, {
      name: strings.branded_quotes_cnn_name,
      type: strings.branded_quotes_cnn_type,
      quote: strings.branded_quotes_cnn_quote,
      logo: {
        type: "static",
        src: logos.logoCnnSvg
      },
      backdrop: logos.logoCnnBgSvg
    }]
  };
});

var lead_generation_bar$b = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitud-de-precios/",
        new_window: false,
        size: "regular",
        text: "Solicitar precios",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$b = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.verticals_education_primary,
        src: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacion-primaria-y-secundaria/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_education_secondary,
        src: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/educacion-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_enterprise,
        src: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var education_primary_pages_config$3 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de aprendizaje de idiomas en línea para K-12 | Rosetta Stone",
          meta_description: "Los programas de aprendizaje de idiomas en línea de Rosetta Stone motivan a los estudiantes de inglés y de otros idiomas internacionales a hablar con confianza. Consulte precios.",
          canonical_url: "https://www.rosettastone.es/educacion-primaria-y-secundaria/",
          lang: "es"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              direction: "image-right",
              image: {
                src: null
              },
              title: {
                content: "Aprenda idiomas en línea.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Hablar un nuevo idioma es el objetivo y los profesores saben que requiere mucha práctica. Rosetta Stone tiene un enfoque único que puede hacer que sus estudiantes hablen inglés u otro idioma internacional desde el primer minuto. De ese modo, se sentirán seguros y listos para hablar por sí solos en el aula y fuera de ella."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              product_sample_panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              content: [{
                body: {
                  dataQa: "2",
                  content: "Desde la primera lección, cada palabra que los alumnos oyen, hablan y leen es en su nuevo idioma. Eso es inmersión: el enfoque más natural para aprender un idioma. Pasar de las palabras a las frases y a las oraciones, sin miedo. Así, cuando llega el momento de hacer preguntas y responder, los profesores pueden estar seguros de que los alumnos estarán preparados."
                },
                data_qa: "2",
                direction: "image-left",
                title: {
                  dataQa: "2",
                  content: "Ofrezca a los alumnos más formas de aprender",
                  type: "section-title",
                  heading: "h2",
                  theme: "black",
                  align: "left"
                }
              }],
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/recursos/content/case-study-pueblo-city-schools/",
                align: "left"
              },
              quote: "«Los niños se sienten motivados con la tecnología, así que les encanta utilizar el programa. Advantage nos permite llegar a los alumnos a los que no hemos podido llegar de otro modo».",
              attribution: "Representante de World Language, Escuelas de Ciudad de Pueblo"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Diga adiós a hablar con timidez.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "Hablar un nuevo idioma puede sonar raro al principio. El temor a cometer un error en el aula puede incluso hacer que los alumnos sientan vergüenza de hablar. Nuestro motor de reconocimiento del discurso TruAccent™ guía la pronunciación, sin juzgar al alumno, para que el aprendizaje del idioma se acelere a medida que el alumno gana más confianza."
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/recursos/content/case-study-corona-norco-unified-school-district/",
                align: "left"
              },
              quote: "«El programa de Rosetta Stone aumenta la confianza oral de los alumnos brindándoles oportunidades de practicar, escuchando su propia pronunciación y reduciendo así su filtro afectivo».",
              attribution: "Administrador de Servicios Pedagógicos, Departamento de Inglés, Distrito Escolar Unificado de Corona-Norco"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "La tutoría en vivo hace que la experiencia de conversación sea real.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Los profesores quieren que sus alumnos se sientan cómodos hablando en su nuevo idioma. Pero pasar del aprendizaje de un idioma al mundo real es un gran salto. Nuestras sesiones de tutoría permiten a los alumnos practicar con hablantes nativos según su propio nivel. La tutoría desde nuestro espacio seguro es otra forma inteligente de aprender."
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/recursos/content/customer-spotlight-bethel-public-schools/",
                align: "left"
              },
              quote: "«La respuesta de los alumnos al programa ha sido extraordinariamente positiva. Nuestra aula se parece a una familia».",
              attribution: "Coordinador de Programas de Estudio y profesor de Inglés, Bethel High School"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Aprender un idioma desde cualquier sitio.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Los horarios de clase continúan siendo la norma para los alumnos. Sin embargo, las escuelas también están facilitando el aprendizaje de los estudiantes fuera del aula. Nuestras aplicaciones móviles permiten a sus alumnos acceder a las lecciones y actividades cuando les resulta más conveniente. Los alumnos tienen así la libertad de convertir cualquier momento en un momento de aprendizaje."
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/recursos/content/customer-spotlight-bethel-public-schools/",
                align: "left"
              },
              quote: "«Observamos que aquellos alumnos que siguen el programa Rosetta Stone® se sienten más motivados y seguros, más dispuestos a participar en las actividades del aula, y adquieren vocabulario mucho más rápido».",
              attribution: "Profesor de Inglés, Distrito de Escuelas Preparatorias de Phoenix Unión"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Inglés y otras lenguas internacionales para adaptarse a los objetivos de los alumnos.",
                learner_feature_1_title: "24 idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Rodear a los alumnos de un idioma acelera el aprendizaje. ",
                learner_feature_2_title: "Inmersión al ritmo de cada alumno",
                learner_feature_3_icon_name: "icon_games",
                learner_feature_3_subtitle: "Los alumnos se divierten mientras refuerzan las lecciones aprendidas.",
                learner_feature_3_title: "Juegos y actividades",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Es el asistente de pronunciación que cualquier estudiante puede usar.",
                learner_feature_4_title: "Reconocimiento del discurso con TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Se ofrece en un espacio en línea seguro, según el nivel de cada estudiante.",
                learner_feature_5_title: "Tutoría en vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Pone el aprendizaje al alcance de la mano de los alumnos.",
                learner_feature_6_title: "Aplicación móvil",
                learner_feature_title: "Obtenga las respuestas sobre precios que necesita."
              },
              data: {}
            }]
          }],
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$b({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$b({
            strings: strings
          })
        }
      };

    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de aprendizaje de idiomas en línea para K-12 | Rosetta Stone",
          meta_description: "Los programas de aprendizaje de idiomas en línea de Rosetta Stone motivan a los estudiantes de inglés y de otros idiomas internacionales a hablar con confianza. Consulte precios.",
          canonical_url: "",
          lang: "es"
        },
        content: {
          copyData: copyData$3(),
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$b({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$b({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de recursos | Rosetta Stone",
          meta_description: "",
          canonical_url: "https://www.rosettastone.es/educacion-primaria-y-secundaria/recursos/",
          lang: "es"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                src: null
              },
              title: {
                content: "Recursos",
                align: "left"
              },
              body: {
                content: "Deje que los estudiantes hablen por sí mismos"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          copyData: copyData$3(),
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$b({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$b({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios | Rosetta Stone",
          meta_description: "Las empresas de asesoramiento y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, motivar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de formación en idiomas ayudan a las empresas de asesoramiento profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en formación lingüística en toda la organización.",
          canonical_url: "https://www.rosettastone.com/educacion-primaria-y-secundaria/solicitud-de-precios/",
          lang: "es"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Reserva hoy tiempo con un experto en aprendizaje de idiomas."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Completa el formulario a continuación para programar un tiempo y analizar cómo podemos ayudarte."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "¡Falta muy poco!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nombre",
                required: true,
                required_error: "Introduce tu nombre."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Apellido",
                required: true,
                required_error: "Introduce tu apellido."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Dirección de correo electrónico*",
                required: true,
                required_error: "Introduce tu dirección de correo electrónico.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Número de teléfono*",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Introduce el nombre de tu empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamaño de la empresa",
                required: true,
                required_error: "Introduce el tamaño de tu empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Menos",
                  label: "100 o Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Más",
                  label: "50,001 o Más"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Título",
                required: true,
                required_error: "Introduce tu función."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar precios"
            },
            labels: {
              form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
              form_privacy2: "aquí.",
              form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
              form_updateagreement2: "aquí",
              form_updateagreement3: "para más información."
            },
            domain: ".es",
            dataQaLocation: "page"
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$b({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios-completa":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios completa | Rosetta Stone",
          meta_description: "Las empresas de asesoramiento y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, motivar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de formación en idiomas ayudan a las empresas de asesoramiento profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en formación lingüística en toda la organización.",
          canonical_url: "https://www.rosettastone.com/educacion-primaria-y-secundaria/solicitud-de-precios-completa/",
          lang: "es"
        },
        content: {
          title: {
            align: "center",
            content: "¡Gracias por tu interés!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "¡Consulta algunos recursos adicionales antes de la reunión!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$b({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de aprendizaje de idiomas en línea para K-12 | Rosetta Stone",
          meta_description: "Los programas de aprendizaje de idiomas en línea de Rosetta Stone motivan a los estudiantes de inglés y de otros idiomas internacionales a hablar con confianza. Consulte precios.",
          canonical_url: "https://www.rosettastone.es/educacion-primaria-y-secundaria/soluciones/",
          lang: "es"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              width: "100%",
              direction: "image-right",
              video: {
                controls: true,
                currentVideoUrl: "https://vimeo.com/594871446"
              },
              title: {
                content: "Nuestras soluciones de aprendizaje para educación primaria y secundaria (K-12) brindan apoyo a los estudiantes de cualquier idioma.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Los estudiantes se sienten inspirados para aprender un nuevo idioma. Algunos eligen programas de aprendizaje de idioma inglés para principiantes y esperan el momento de poder hablar con sus pares. Otros estudian en una clase de lengua extranjera con el anhelo de que un día podrán disfrutar de la experiencia de vivir en una cultura diferente. Cualesquiera sean sus objetivos de idioma, los estudiantes pueden desarrollar su confianza a la hora de hablar a través de nuestras premiadas soluciones de aprendizaje para K-12."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "2",
                content: "Hablar con los compañeros de trabajo resulta crítico. A través de la formación de Catalyst, las instrucciones se vuelven claras, los empleados escuchan y entienden dichas instrucciones y se cometen menos errores. Esto redunda en más tareas completadas."
              },
              data_qa: "2",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "2",
                content: "Aumente la productividad.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/recursos/content/increasing-el-student-equity-infographic/",
                align: "left"
              },
              quote: "“Creo que sin la solución de Rosetta Stone no hubiéramos tenido éxito con nuestros estudiantes EL”",
              attribution: "Asistente del Superintendente, Bullitt County Public Schools"
            }]
          }, {
            panels: [{
              body: {
                dataQa: "3",
                content: "Recurrir a proveedores locales de servicios de idiomas con distintos enfoques produce resultados costosos y heterogéneos. Catalyst ofrece a los empleados una misma experiencia de aprendizaje − galardonada con premios− en cualquier sitio, las 24 horas y los siete días a la semana."
              },
              data_qa: "3",
              direction: "image-right",
              layout: "list",
              title: {
                dataQa: "3",
                content: "Hágase global.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/recursos/content/case-study-pueblo-city-schools/",
                align: "left"
              },
              quote: "“Los niños son impulsados por la tecnología, por lo que les encanta usar el programa.“",
              attribution: "Enlace de Idioma Mundial, Pueblo City Schools"
            }]
          }, {
            panels: [{
              body: {
                dataQa: "4",
                content: "La mayoría de los candidatos buscan aquello que pueda elevarlos al próximo nivel. Ser capaces de aprender un idioma utilizando Catalyst será importante para los empleados al asumir un puesto y decidir si quedarse en su empresa."
              },
              data_qa: "4",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "4",
                content: "Atraiga talento.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/recursos/content/rosetta-playbook-september-2017-final-web/",
                align: "left"
              },
              quote: "“Padres, familias, educadores y comunidades: no hay mejor asociación para asegurar que todos los estudiantes tengan el apoyo y los recursos que necesitan para tener éxito en la escuela y en la vida.”",
              attribution: "NEA Antiguo Presidente"
            }]
          }, {
            panels: [{
              data_qa: "5",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Active el aprendizaje individual a través de lecciones y actividades en el nuevo idioma que rodea a los alumnos mientras aprenden a hablar, leer, escribir, escuchar y pensar de un modo totalmente nuevo.",
                feature_1_title: "Inmersión dinámica.",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "El alumno recibe comentarios sobre su pronunciación al instante, lo cual lo guía para hablar el nuevo idioma de manera correcta, haciendo que la experiencia de aprender resulte satisfactoria y sentando las bases para una mayor confianza la hora de hablar.",
                feature_2_title: "TruAccent.",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Los ejercicios y conversaciones estructurados con hablantes nativos se adaptan al actual nivel de dominio del idioma del alumno, ayudándolo a sentirse más cómodo al hablar la nueva lengua.",
                feature_3_title: "Tutoría en vivo. ",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Integre el inglés y otros idiomas internacionales al programa de lenguas para desarrollar y perfeccionar las competencias lingüísticas de los alumnos en cada nivel de aprendizaje, desde el nivel básico hasta el avanzado.",
                feature_4_title: "24 idiomas.",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "English for Education incluye recursos para ayudar a las familias a desarrollar competencias en inglés todos juntos, así como webinars mensuales en español que destacan el apoyo familiar para los alumnos que estén aprendiendo inglés.",
                feature_5_title: "Recursos de conexión familiar.",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Además del material en línea, existen guías para profesores, libros de ejercicios y guías de actividades en el aula que brindan a los profesores recursos para apoyar la enseñanza en clase y complementar las lecciones en línea.",
                feature_6_title: "Material de apoyo en las aulas. ",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "English for Education incluye una prueba de nivel y progreso para los cursos de 6 a 12 años, para que los profesores puedan establecer el punto de partida en el aprendizaje de inglés de cada estudiante.",
                feature_7_title: "Pruebas. ",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Los alumnos se comprometen con el programa de inmediato a través de contenido variado que se adapta al ritmo de cada uno, en un espacio interactivo que se centra en los estudiantes que están aprendiendo a hablar.",
                feature_8_title: "Contenido básico y avanzado. ",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Reforzar el vocabulario, gramática y pronunciación es divertido con métodos que desarrollan las habilidades de los alumnos para leer, escuchar y hablar. ",
                feature_9_title: "Juegos y actividades. ",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Las actividades para cada nivel de alumno incluyen la lectura en voz alta con comentarios al instante sobre el discurso, escritura con fines específicos, escucha y comprensión de textos. ",
                feature_10_title: "Lectura y escritura. ",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Permiten a los alumnos utilizar smartphones y tabletas dentro y fuera del aula para acceder a lecciones y actividades que aumentan la retención de las competencias y el vocabulario adquiridos.",
                feature_11_title: "Aplicaciones móviles. ",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Comentarios al instante sobre el rendimiento individual, grupal y de la clase, con un sistema de seguimiento del avance y control en el uso del idioma, que permite a los profesores y administradores informar fácilmente sobre los resultados del alumno.",
                feature_12_title: "Herramientas de informe. ",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "La gestión simplificada de licencias permite a los profesores y administradores reasignar fácilmente a los alumnos para asegurar que se está utilizando el número completo de licencias y para apoyar la rentabilidad de la inversión en el programa (ROI). ",
                feature_13_title: "Licencias transferibles. ",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "Nuestro equipo incorpora objetivos de aprendizaje de idiomas en modelos eficaces y asiste en la planificación, implantación y promoción del programa en la escuelas y regiones.",
                feature_14_title: "Apoyo en la implantación. ",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Existe formación disponible para administradores y profesores, a fin de contribuir al lanzamiento exitoso de un programa que se combine de manera eficaz con la enseñanza del profesor en clase. ",
                feature_15_title: "Servicios de formación. ",
                feature_section_title: "Todos los recursos que usted necesita al alcance de su mano."
              }
            }]
          }],
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$b({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$b({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_primary_footer_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/educacion-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/empresas/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/movil/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/resenas-clientes/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/a-cerca-de/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/prensa/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/contacto/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/es/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/pf",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/requerimientos-sistema",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: false,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.com/terms/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.com/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_secondary_nav_secondary_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/soluciones/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_label
    }
  };
});

var lead_generation_bar$a = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitud-de-precios/",
        new_window: false,
        size: "regular",
        text: "Solicitar precios",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$a = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.verticals_education_primary,
        src: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacion-primaria-y-secundaria/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_education_secondary,
        src: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/educacion-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_enterprise,
        src: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var education_secondary_pages_config$3 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es"
        },
        content: {
          copyData: copyData$3(),
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$a({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$a({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de recursos | Rosetta Stone",
          meta_description: "",
          canonical_url: "https://www.rosettastone.es/educacion-superior/recursos/",
          lang: "es"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                src: null
              },
              title: {
                content: "Recursos",
                align: "left"
              },
              body: {
                content: "Deje que los estudiantes hablen por sí mismos"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          copyData: copyData$3(),
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$a({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$a({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "El aprendizaje de idiomas para la educación superior | Rosetta Stone",
          meta_description: "Las soluciones de aprendizaje de idiomas de Rosetta Stone para la educación superior brinda a los estudiantes acceso en línea al instante para aprender inglés y otros idiomas internacionales. Consulte precios.",
          canonical_url: "https://www.rosettastone.es/educacion-superior/",
          lang: "es"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              direction: "image-right",
              image: {
                src: null
              },
              title: {
                content: "Ponga el aprendizaje de idiomas al alcance de cada estudiante.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Los estudiantes crean conexiones globales con tan solo deslizar la pantalla de sus smartphones. Sin embargo, las escuelas sufren restricciones en los presupuestos destinados a los programas de idiomas. Esto limita las potenciales opciones académicas y de carrera de los alumnos y su visión del mundo. En una economía global, las competencias lingüísticas internacionales son un requisito para conseguir empleo en el siglo XXI."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              product_sample_panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              content: [{
                body: {
                  dataQa: "2",
                  content: "Muchos estudiantes de educación superior pueden aprobar un examen de nivel de inglés estándar; sin embargo, las competencias lingüísticas que se necesitan para tener éxito en el ámbito académico suelen ser muy diferentes. Las soluciones de aprendizaje de idiomas de Rosetta Stone ayudan a desarrollar la confianza de los alumnos en el uso del inglés y los preparan para el éxito."
                },
                data_qa: "2",
                direction: "image-left",
                title: {
                  dataQa: "2",
                  content: "Acelere el aprendizaje del idioma inglés.",
                  type: "section-title",
                  heading: "h2",
                  theme: "black",
                  align: "left"
                }
              }],
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/educacion-superior/recursos/content/caso-de-exito-northern-border-university/",
                align: "left"
              },
              quote: "«En esta era de Internet, y siendo el inglés un idioma global, los estudiantes necesitan dominar esa lengua para sentirse seguros y ser competitivos en sus estudios ahora y más adelante durante su carrera profesional».",
              attribution: "Decano, Decanato de Estudios de Año Preparatorio y de Apoyo de la Universidad Northern Border."
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "El aprendizaje de idiomas en línea se adapta al estilo de vida de los estudiantes.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "Ahora la cultura, el entretenimiento, los deportes y la literatura están a tan solo un clic. Incorporando un programa Rosetta Stone a su programa de aprendizaje de idiomas, usted puede ofrecer a los alumnos acceso en línea a una guía ilimitada de ejercicios de pronunciación y conversación que no son posibles durante las horas de clase en un aula."
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/educacion-superior/recursos/content/caso-de-exito-liberty-university/",
                align: "left"
              },
              quote: "«Después de poner a prueba nuestros cursos de conversación, nuestros estudiantes realizaron la entrevista de competencia oral (OPIc, por sus siglas en inglés) del Consejo Americano para la Enseñanza de Lenguas Extranjeras (ACTFL, por sus siglas en inglés). Al cabo de tan solo un semestre deestudio, los alumnos de 101 cursos obtuvieron una calificación de nivel Principiante-Intermedio o superior en la OPIc».",
              attribution: "Titular de cátedra, Centro Universitario de Estudios Generales, Universidad de Liberty"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "La tutoría en vivo logra que los alumnos de idiomas se atrevan a hablar.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Estudiantes, instructores y el personal en general, todos desean sentirse cómodos a la hora de hablar un nuevo idioma. Pasar del aprendizaje de una lengua al mundo real requiere práctica. Nuestras sesiones de tutoría permiten a los alumnos practicar con hablantes nativos según su propio nivel. Esto hace que nuestro sistema de tutoría −en un espacio seguro en línea− sea otra forma inteligente de aprender."
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/educacion-superior/recursos/content/case-study-canterbury-christ-church-university/",
                align: "left"
              },
              quote: "«Las soluciones de Rosetta Stone han sido una gran herramienta para ayudar a los participantes a evaluar su nivel y acceder a una serie de experiencias de aprendizaje diversas e interactivas que promueven el progreso independiente».",
              attribution: "Coordinador de cursos de la Universidad Canterbury Christ Church"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "El laboratorio de idiomas se traslada a la nube.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Las aplicaciones móviles enriquecen la enseñanza para que sea posible aprender idiomas en cualquier sitio y en cualquier momento. Los alumnos tienen mayor flexibilidad y acceso a los materiales de los cursos, mientras que ahora los profesores pueden destinar el tiempo de clase a la enseñanza individualizada y a actividades de aprendizaje colaborativo."
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/educacion-superior/recursos/content/caso-de-exito-humboldt-state-university/",
                align: "left"
              },
              quote: "«[El examen de nivel realizado al inicio del semestre y que se repite al final] permite a los alumnos saber dónde empezaron y cuán lejos han llegado en el proceso de adquisición de un idioma».",
              attribution: "Director del Laboratorio de Lenguas y Culturas Internacionales, Humboldt State University"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Inglés y otras lenguas internacionales para adaptarse a los objetivos de los alumnos.",
                learner_feature_1_title: "24 idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Rodear a los alumnos de un idioma acelera el aprendizaje. ",
                learner_feature_2_title: "Inmersión al ritmo de cada alumno",
                learner_feature_3_icon_name: "icon_games",
                learner_feature_3_subtitle: "Los alumnos se divierten mientras refuerzan las lecciones aprendidas.",
                learner_feature_3_title: "Juegos y actividades",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Es el asistente de pronunciación que cualquier estudiante puede usar.",
                learner_feature_4_title: "Reconocimiento del discurso con TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Se ofrece en un espacio en línea seguro, según el nivel de cada estudiante.",
                learner_feature_5_title: "Tutoría en vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Pone el aprendizaje al alcance de la mano de los alumnos.",
                learner_feature_6_title: "Aplicación móvil",
                learner_feature_title: "Obtenga las respuestas sobre precios que necesita."
              },
              data: {}
            }]
          }],
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$a({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$a({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios | Rosetta Stone",
          meta_description: "Las empresas de asesoramiento y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, motivar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de formación en idiomas ayudan a las empresas de asesoramiento profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en formación lingüística en toda la organización.",
          canonical_url: "https://www.rosettastone.es/educacion-superior/solicitud-de-precios/",
          lang: "es"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Reserva hoy tiempo con un experto en aprendizaje de idiomas."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Completa el formulario a continuación para programar un tiempo y analizar cómo podemos ayudarte."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "¡Falta muy poco!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nombre",
                required: true,
                required_error: "Introduce tu nombre."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Apellido",
                required: true,
                required_error: "Introduce tu apellido."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Dirección de correo electrónico*",
                required: true,
                required_error: "Introduce tu dirección de correo electrónico.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Número de teléfono*",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Introduce el nombre de tu empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamaño de la empresa",
                required: true,
                required_error: "Introduce el tamaño de tu empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Menos",
                  label: "100 o Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Más",
                  label: "50,001 o Más"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Título",
                required: true,
                required_error: "Introduce tu función."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar precios"
            },
            labels: {
              form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
              form_privacy2: "aquí.",
              form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
              form_updateagreement2: "aquí",
              form_updateagreement3: "para más información."
            },
            domain: ".es",
            dataQaLocation: "page"
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$a({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios-completa":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios completa | Rosetta Stone",
          meta_description: "Las empresas de asesoramiento y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, motivar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de formación en idiomas ayudan a las empresas de asesoramiento profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en formación lingüística en toda la organización.",
          canonical_url: "https://www.rosettastone.es/educacion-superior/solicitud-de-precios-completa/",
          lang: "es"
        },
        content: {
          title: {
            align: "center",
            content: "¡Gracias por tu interés!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "¡Consulta algunos recursos adicionales antes de la reunión!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$a({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_secondary_footer_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/educacion-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/empresas/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/movil/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/resenas-clientes/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/a-cerca-de/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/prensa/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/contacto/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/es/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/pf",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/requerimientos-sistema/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: false,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.com/terms/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.com/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: "/soluciones/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label
    }
  };
});

var lead_generation_bar$9 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      completion_redirect: null,
      button: {
        destination: "/solicitud-de-precios/",
        new_window: false,
        size: "regular",
        text: "Solicitar precios",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$9 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.verticals_education_primary,
        src: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacion-primaria-y-secundaria/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_education_secondary,
        src: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/educacion-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_enterprise,
        src: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var enterprise_pages_config$3 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es"
        },
        content: {
          copyData: copyData$3(),
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$9({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$9({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de recursos | Rosetta Stone",
          meta_description: "Recopilación de informes, infografías, videos, seminarios web y más sobre por qué la capacitación en idiomas es la opción correcta.",
          canonical_url: "https://www.rosettastone.es/empresas/recursos/",
          lang: "es"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                src: null
              },
              title: {
                content: "Recursos",
                align: "left"
              },
              body: {
                content: "Deje que los estudiantes hablen por sí mismos"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          copyData: copyData$3(),
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$9({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$9({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Formación en idiomas de negocios | Rosetta Stone",
          meta_description: "Las soluciones de formación de Rosetta Stone ayudan a los empleados a desarrollar competencias lingüísticas para el mundo de los negocios en inglés y en muchos otros idiomas de negocios en demanda actualmente. Consulte precios.",
          canonical_url: "https://www.rosettastone.es/empresas/",
          lang: "es"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              },
              video: {
                currentVideoUrl: "https://vimeo.com/594871446",
                controls: true
              },
              direction: "image-right",
              title: {
                align: "left",
                content: "Saber idiomas de negocios permite a los empleados hablar claro.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              body: {
                content: "Aprender nuevos idiomas de negocios requiere práctica. Rosetta Stone logra que los empleados hablen y perfeccionen su pronunciación al instante, para que estén preparados para hablar en su nombre y en el de su empresa de inmediato."
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              product_sample_panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              content: [{
                body: {
                  dataQa: "2",
                  content: "Los empleados aprenden mejor cuando todo lo que escuchan, hablan, leen y escriben es en su nuevo idioma. Eso es precisamente lo que hace nuestro método Dynamic Immersion®: fomentar la confianza en el uso de un idioma desde la primera lección."
                },
                data_qa: "2",
                direction: "image-left",
                title: {
                  dataQa: "2",
                  content: "Aprenda de manera natural.",
                  type: "section-title",
                  heading: "h2",
                  theme: "black",
                  align: "left"
                }
              }],
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/empresas/recursos/content/hitachi-data-systems-caso-de-exito/",
                align: "left"
              },
              quote: "«Rosetta Stone nos ayuda a derribar barreras e impulsa el compromiso de los empleados».",
              attribution: "Vicepresidente de Aprendizaje y Colaboración de Hitachi Data Systems"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Comience a hablar.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "El temor a equivocarse puede alimentar la timidez de los alumnos a la hora de aprender un nuevo idioma. Nuestro motor de discurso TruAccent™ permite a los empleados introducir su pronunciación para sentirse seguros cuando llegue el momento de hablar de negocios."
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/empresas/recursos/content/e-on/",
                align: "left"
              },
              quote: "«Los principales beneficios del sistema de aprendizaje de idiomas de Rosetta Stone son la habilidad de aprender en cualquier momento, en cualquier sitio y a tu propio ritmo».",
              attribution: "Director de Recursos Humanos de CoC Global Learning, E.ON"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Sea escuchado.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Pasar de las lecciones a hablar con colegas y clientes es un gran salto. Las sesiones de tutoría con personas nativas ofrecen práctica de conversación para que los alumnos hablen su nuevo idioma de manera natural."
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/empresas/recursos/content/case-study-kimberly-clark-corporation/",
                align: "left"
              },
              quote: "«Hemos observado un ahorro importante en costes tras implementar un único programa en toda la empresa».",
              attribution: "Consultor senior de Gestión del Talento en Kimberly-Clark Corporation"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Aproveche su móvil.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Encontrar tiempo para sentarse en un aula para aprender un idioma es difícil. Nuestras aplicaciones móviles permiten a los alumnos acceder a las lecciones y actividades cuando les resulta más conveniente. De ese modo, cualquier momento puede convertirse en una gran experiencia de aprendizaje."
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/empresas/recursos/content/tripadvisor-com-caso-de-exito/",
                align: "left"
              },
              quote: "«¡ME ENCANTA! Rosetta Stone me permite seleccionar un nuevo idioma por mí mismo y a mi propio ritmo después de las horas de trabajo».",
              attribution: "Empleado de TripAdvisor en Singapur"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Existe una combinación para los objetivos de cada empleado.",
                learner_feature_1_title: "24 idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Estar rodeado de un idioma es la manera más rápida de aprenderlo.",
                learner_feature_2_title: "Inmersión al ritmo de cada alumno",
                learner_feature_3_icon_name: "icon_foundational",
                learner_feature_3_subtitle: "Las lecciones se ajustan al ritmo de los alumnos, y no al revés.",
                learner_feature_3_title: "Contenido atractivo",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Los empleados pueden comprobar su pronunciación en cualquier momento.",
                learner_feature_4_title: "Reconocimiento del discurso TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Ser capaces de hablar con personas nativas es una clara señal de éxito.",
                learner_feature_5_title: "Tutoría en vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Aprender y practicar está a tan solo un deslizar de pantalla.",
                learner_feature_6_title: "Aplicación móvil",
                learner_feature_title: "Obtenga las respuestas de precio que necesita."
              },
              data: {}
            }]
          }, {
            panels: [{
              pageData: {
                admin_feature_1_icon_name: "icon_placement",
                admin_feature_1_subtitle: "Combina los objetivos con la rapidez con la que los alumnos deseen alcanzarlos.",
                admin_feature_1_title: "Asignación personalizada",
                admin_feature_2_icon_name: "icon_assessments",
                admin_feature_2_subtitle: "Averiguar lo que los empleados saben es el mejor lugar donde comenzar.",
                admin_feature_2_title: "Evaluación",
                admin_feature_3_icon_name: "icon_proficiency",
                admin_feature_3_subtitle: "Se utiliza al inicio y a lo largo del proceso para hacer un seguimiento del progreso del alumno.",
                admin_feature_3_title: "Prueba de nivel de inglés",
                admin_feature_4_icon_name: "icon_reporting",
                admin_feature_4_subtitle: "Informes de rendimiento del alumno en tiempo real que ayudan a medir la rentabilidad de la inversión.",
                admin_feature_4_title: "Informes",
                admin_feature_5_icon_name: "icon_implementation",
                admin_feature_5_subtitle: "Servicios de expertos que ayudan a los administradores para que los alumnos partan de una posición fuerte.",
                admin_feature_5_title: "Apoyo en la implementación",
                admin_feature_6_icon_name: "icon_training",
                admin_feature_6_subtitle: "Adaptada al tamaño y las necesidades de su organización.",
                admin_feature_6_title: "Formación",
                admin_feature_title: "Características del alumno administrador"
              },
              img_bg: null
            }]
          }],
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$9({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$9({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios | Rosetta Stone",
          meta_description: "Las empresas de asesoramiento y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, motivar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de formación en idiomas ayudan a las empresas de asesoramiento profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en formación lingüística en toda la organización.",
          canonical_url: "https://www.rosettastone.es/empresas/solicitud-de-precios/",
          lang: "es"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Reserva hoy tiempo con un experto en aprendizaje de idiomas."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Completa el formulario a continuación para programar un tiempo y analizar cómo podemos ayudarte."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "¡Falta muy poco!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nombre",
                required: true,
                required_error: "Introduce tu nombre."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Apellido",
                required: true,
                required_error: "Introduce tu apellido."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Dirección de correo electrónico*",
                required: true,
                required_error: "Introduce tu dirección de correo electrónico.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Número de teléfono*",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Introduce el nombre de tu empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamaño de la empresa",
                required: true,
                required_error: "Introduce el tamaño de tu empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Menos",
                  label: "100 o Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Más",
                  label: "50,001 o Más"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Título",
                required: true,
                required_error: "Introduce tu función."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar precios"
            },
            labels: {
              form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
              form_privacy2: "aquí.",
              form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
              form_updateagreement2: "aquí",
              form_updateagreement3: "para más información."
            },
            domain: ".es",
            dataQaLocation: "page"
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$9({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios-completa":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios completa | Rosetta Stone",
          meta_description: "Las empresas de asesoramiento y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, motivar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de formación en idiomas ayudan a las empresas de asesoramiento profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en formación lingüística en toda la organización.",
          canonical_url: "https://www.rosettastone.es/empresas/solicitud-de-precios-completa/",
          lang: "es"
        },
        content: {
          title: {
            align: "center",
            content: "¡Gracias por tu interés!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "¡Consulta algunos recursos adicionales antes de la reunión!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$9({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Formación global en idiomas de negocios | Rosetta Stone",
          meta_description: "La formación global en idiomas de negocios de Rosetta Stone Catalyst ofrece a los empleados la posibilidad de aprender los principales idiomas utilizados en el mundo empresarial desde cualquier sitio. Consulte precios para empresas.",
          canonical_url: "https://www.rosettastone.es/empresas/soluciones/",
          lang: "es"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              width: "100%",
              direction: "image-right",
              video: {
                controls: true,
                currentVideoUrl: "https://vimeo.com/594871446"
              },
              title: {
                content: "Las nuevas competencias lingüísticas para el mundo empresarial hace que trabajar todos juntos sea posible.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Las brechas lingüísticas dejan muchas buenas ideas sin expresar o poco claras. A través de Rosetta Stone® Catalyst™, los empleados aprenden competencias lingüísticas que convertirán las señales confusas en una clara comunicación con sus compañeros de trabajo y clientes."
              },
              quote: {
                quote: "«Creo realmente que aporta un gran beneficio tanto para el alumno como para una empresa global como Amgen.» --Director de Rendimiento Comercial de Amgen",
                link: "https://www.rosettastone.es/empresas/recursos/content/amgen-client-spotlight/",
                resourcesLink: "/recursos/",
                market: ["ES"],
                vertical: ["recECBjZxFEWVVls8"]
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "2",
                content: "Hablar con los compañeros de trabajo resulta crítico. A través de la formación de Catalyst, las instrucciones se vuelven claras, los empleados escuchan y entienden dichas instrucciones y se cometen menos errores. Esto redunda en más tareas completadas."
              },
              data_qa: "2",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "2",
                content: "Aumente la productividad.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/empresas/recursos/content/empresa-5razones/",
                align: "left"
              },
              quote: "Leer imagen"
            }]
          }, {
            panels: [{
              body: {
                dataQa: "3",
                content: "Recurrir a proveedores locales de servicios de idiomas con distintos enfoques produce resultados costosos y heterogéneos. Catalyst ofrece a los empleados una misma experiencia de aprendizaje − galardonada con premios− en cualquier sitio, las 24 horas y los siete días a la semana."
              },
              data_qa: "3",
              direction: "image-right",
              layout: "list",
              title: {
                dataQa: "3",
                content: "Hágase global.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/empresas/recursos/content/empresa-5razones/",
                align: "left"
              },
              quote: "Ver hojas de datos"
            }]
          }, {
            panels: [{
              body: {
                dataQa: "4",
                content: "La mayoría de los candidatos buscan aquello que pueda elevarlos al próximo nivel. Ser capaces de aprender un idioma utilizando Catalyst será importante para los empleados al asumir un puesto y decidir si quedarse en su empresa."
              },
              data_qa: "4",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "4",
                content: "Atraiga talento.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              align: "left",
              link: {
                theme: "black",
                destination: "https://www.rosettastone.es/empresas/recursos/content/rosetta-playbook-september-2017-final-web/",
                align: "left"
              },
              quote: "Leer guía"
            }]
          }, {
            panels: [{
              data_qa: "5",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Active el aprendizaje con lecciones y actividades a su propio ritmo utilizando solo el nuevo idioma de un empleado mientras aprenden a hablar, leer, escribir, escuchar y pensar de una manera completamente nueva.",
                feature_1_title: "Inmersión dinámica.",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "La respuesta inmediata a la pronunciación guía a los empleados a hablar el idioma correctamente, hace que el aprendizaje sea gratificante al instante y sienta las bases para una mayor confianza en el habla.",
                feature_2_title: "TruAccent.",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Los ejercicios estructurados, las conversaciones con hablantes nativos y las sesiones guiadas por un instructor y 1: 1 se alinean con el nivel de competencia actual de un empleado y se enfocan en hablar.",
                feature_3_title: "Tutoría en vivo.",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Integre os idiomas inglês e mundial em qualquer programa de treinamento de idiomas para desenvolver e aperfeiçoar as habilidades de linguagem dos funcionários em todos os níveis de aprendizado, do iniciante ao avançado.",
                feature_4_title: "24 idiomas.",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "Las pruebas previas de inglés, español y francés y otras autoevaluaciones de idiomas del mundo identifican diversas necesidades lingüísticas y garantizan que la capacitación sea productiva desde el principio.",
                feature_5_title: "Valoraciones",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Recomienda una ruta de aprendizaje de idiomas adaptada para cada empleado en función de los objetivos y la competencia del alumno, y ofrece el nivel adecuado de desafío y compromiso.",
                feature_6_title: "Colocación de aprendiz.",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "Evalúe las habilidades de lectura y audición para determinar la competencia lingüística utilizando la escala del Marco Común Europeo de Referencia (MCER).",
                feature_7_title: "Pruebas de aptitud en inglés, español y francés.",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Las lecciones para principiantes se centran en temas cotidianos, mientras que las lecciones avanzadas van desde cultura e historia a temas específicos de la industria con contenido de sectores en profundidad.",
                feature_8_title: "Contenido fundacional y avanzado.",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Reforzar el vocabulario, la gramática y la pronunciación en actividades atractivas que desarrollan las habilidades de lectura, comprensión auditiva y expresión oral.",
                feature_9_title: "Juegos y actividades.",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "El aprendizaje digital tiene actividades para cada nivel de aprendiz, incluyendo Lectura en voz alta con comentarios del habla, escritura para propósitos específicos y comprensión auditiva y de lectura.",
                feature_10_title: "Leyendo y escribiendo.",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Permite a los empleados usar teléfonos inteligentes y tabletas en cualquier momento y en cualquier lugar para tener acceso a las lecciones y actividades que aumentan la retención de habilidades y vocabulario.",
                feature_11_title: "Aplicaciones móviles.",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Informes integrados del rendimiento individual, grupal y de ubicación, con progreso de uso y seguimiento de competencia que permite a los administradores alinear la capacitación con los objetivos comerciales.",
                feature_12_title: "Herramientas de reporte.",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "La administración simplificada de licencias permite a los gerentes y administradores reasignar e incorporar a los empleados rápidamente y contribuye a un retorno de la inversión más sólido.",
                feature_13_title: "Licencias transferibles.",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "Nuestro equipo incorpora objetivos de aprendizaje de idiomas en modelos efectivos y asiste en la planificación, implementación y promoción del programa en toda la organización.",
                feature_14_title: "Apoyo a la implementación.",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Los niveles de capacitación para administradores están disponibles para ayudar a un lanzamiento exitoso del programa, uno en el que los empleados comenzarán a aprender y hablar su nuevo idioma rápidamente.",
                feature_15_title: "Servicios de entrenamiento.",
                feature_section_title: "Todos los recursos que usted necesita al alcance de su mano."
              }
            }]
          }],
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$9({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$9({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var enterprise_footer_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/educacion-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/empresas/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/movil/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/resenas-clientes/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/a-cerca-de/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/prensa/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/contacto/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/es/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/pf",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/requerimientos-sistema",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: false,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.com/terms/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.com/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var consumer_product_activation_footer_config$4 = (function (_ref) {
  var strings = _ref.strings;
  return {
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: false,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.com/terms/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.com/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var consumer_product_activation_pages_config$4 = (function (_ref) {
  var page = _ref.page;

  switch (page) {
    case "product-activation":
      return {
        page: page,
        helmet: {
          meta_title: "Rosetta Stone® - Online Subscription Product Activation",
          meta_description: "Activate your Rosetta Stone® language learning online subscription products.",
          canonical_url: "https://rosettastone.com/product/product-activation/",
          lang: "es"
        }
      };

    default:
      return null;
  }
});

var es = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "business":
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config$3({
        strings: strings
      });
      page_config = enterprise_pages_config$3({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config$3({
        strings: strings
      });
      break;

    case "k12":
    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config$3({
        strings: strings
      });
      page_config = education_primary_pages_config$3({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config$3({
        strings: strings
      });
      break;

    case "consumer-product-activation":
      footer_config = consumer_product_activation_footer_config$4({
        strings: strings
      });
      page_config = consumer_product_activation_pages_config$4({
        page: page,
        strings: strings
      });
      break;

    case "hed":
    case "education-secondary":
      nav_secondary = education_secondary_nav_secondary_config$3({
        strings: strings
      });
      page_config = education_secondary_pages_config$3({
        page: page,
        strings: strings
      });
      footer_config = education_secondary_footer_config$3({
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config$3({
    strings: strings
  });
  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$5,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var analytics$4 = {
  gtm_id: "GTM-NDSR53K"
};

var nav_primary_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://blog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: true,
      destination: "/contatti/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: {
      visible: true,
      image: {
        type: "static",
        src: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
      },
      link: {
        destination: "/",
        external: false,
        new_window: false
      }
    },
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:18007673882",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/inglese/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/il-francese/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/arabo/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/il-tedesco/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }, {
        url: "/lo-spagnolo/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }, {
        url: "/italiano/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }],
      language_options_other: [{
        url: "/il-cinese/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/il-coreano/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/lo-spagnolo-america-latina/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/il-tagalog/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/il-greco/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/ebraico/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/lhindi/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/lolandese/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, {
        url: "/inglese-americano/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }, {
        url: "/irlandese/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/Giapponese/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }, {
        url: "/il-farsi/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/il-polacco/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/il-portoghese/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/il-russo/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/lo-svedese/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/il-turco/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/il-vietnamita/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      for_young_learners_label: strings.nav_primary_vertical_for_young_learners_label,
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label
    },
    sign_in: {
      visible: true,
      destination: "https://www.rosettastone.com/login",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: false,
      destination: "https://espanol.rosettastone.com/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_switch_language
    },
    support: {
      visible: true,
      destination: "https://support.rosettastone.com/it-IT/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/istruzione-primaria-e-secondaria/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: false,
      destination: "/istruzione-superiore/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/students/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/aziende/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var education_primary_nav_secondary_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/risorse/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: true,
      destination: "/soluzioni/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var awards$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.awards_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.awards_twitter,
        src: logosTiles.logosTilesTwitterSvg
      }
    }, {
      image: {
        type: "static",
        alt: strings.awards_bmw,
        src: logosTiles.logosTilesBmwSvg
      }
    }, {
      image: {
        type: "static",
        alt: strings.awards_uber,
        src: logosTiles.logosTilesUberSvg
      }
    }, {
      image: {
        type: "static",
        alt: strings.awards_williams_sonoma,
        src: logosTiles.logosTilesWsSvg
      }
    }]
  };
});

var branded_quotes$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.branded_quotes_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      name: strings.branded_quotes_macworld_name,
      type: strings.branded_quotes_macworld_type,
      quote: strings.branded_quotes_macworld_quote,
      logo: {
        type: "static",
        src: logos.logoMacworldSvg
      },
      backdrop: logos.logoMacworldBgSvg
    }, {
      name: strings.branded_quotes_techcrunch_name,
      type: strings.branded_quotes_techcrunch_type,
      quote: strings.branded_quotes_techcrunch_quote,
      logo: {
        type: "static",
        src: logos.logoTechcrunchSvg
      },
      backdrop: logos.logoTechcrunchBgSvg
    }, {
      name: strings.branded_quotes_cnn_name,
      type: strings.branded_quotes_cnn_type,
      quote: strings.branded_quotes_cnn_quote,
      logo: {
        type: "static",
        src: logos.logoCnnSvg
      },
      backdrop: logos.logoCnnBgSvg
    }]
  };
});

var lead_generation_bar$8 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/richiesta-prezzi/",
        new_window: false,
        size: "regular",
        text: "Richiedi prezzi",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Pronto per il prossimo passo?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$8 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.verticals_education_primary,
        src: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacaobasica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_education_secondary,
        src: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/ensino-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_enterprise,
        src: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var copyData$2 = (function () {
  return {
    about_us: "Rosetta Stone",
    about_us_url: "/chi-siamo",
    agreements: "Accordi",
    agreements_url: "https://www.rosettastone.it/accordi",
    almost_there: "Quasi fatto!",
    american: "(Americano)",
    anti_piracy: "Antipirateria ",
    anti_piracy_url: "https://www.rosettastone.it/antipirateria",
    arabic: "Arabo",
    award_section_header: "Approvato per 25+ anni dalle migliori organizzazioni.",
    blog_url: null,
    brasil: "Brasil",
    brasil_url: "https://www.rosettastonebrasil.com/",
    brazil: "(Brasile)",
    british: "(Britannico)",
    business_contact_title: "Aziende - Consultazione dei prezzi",
    careers: "Lavora Con Noi",
    careers_url: "https://www.rosettastone.com/careers",
    cart_checkout: "Recensione",
    cart_checkout_url: "https://secure.rosettastone.it/it_store_view/checkout/cart",
    cart_discount: "Sconto:",
    cart_empty: "Il tuo carrello è vuoto.",
    cart_in_your_cart: "nel tuo carrello.",
    cart_subtotal: "Totale parziale:",
    cart_summary: "Riepilogo dell'ordine:",
    cart_total: "Totale (prima delle imposte):",
    cart_you_have: "Hai",
    change_region: "Cambia regione:",
    china: "中国",
    china_url: "http://www.rosettastone.cn/",
    combined_resources_url: "https://www.rosettastone.it/aziende/risorse/",
    company: "Chi Siamo",
    connect: "Connettiti con noi:",
    consumer_home: "Personale",
    contact: "Contatti",
    contact_description: "Modulo di richiesta del prezzo",
    contact_ee_url: "/contatti/",
    contact_url: "https://www.rosettastone.it/contatti",
    cta_bar: "Pronto per il prossimo passo?",
    cta_h2: "Pronto per il prossimo passo?",
    cta_text: "Consultazione dei prezzi",
    currency: "€",
    demo_pricing_subtitle_business: "Scopri come le nostre soluzioni aziendali possono aiutare la tua azienda ad attrarre talenti e a migliorare la produttività. Compila il modulo sottostante e ci metteremo in contatto presto.",
    demo_pricing_subtitle_hed: "Scopri come le nostre soluzioni di istruzione superiore possono aiutare i tuoi studenti a parlare una nuova lingua con sicurezza. Compila il modulo sottostante e ci metteremo in contatto presto.",
    demo_pricing_subtitle_k12: "Scopri come le nostre soluzioni didattiche possono aiutare i tuoi studenti di lingua inglese e mondiale a parlare con sicurezza. Compila il modulo sottostante e ci metteremo in contatto presto.",
    demo_pricing_subtitle_pub: "Scopri come le nostre soluzioni del settore pubblico possono migliorare le comunicazioni con quelle che servi. Compila il modulo sottostante e ci metteremo in contatto presto.",
    demo_pricing_title: "Richiedi una consulenza gratuita",
    deutschland: "Deutschland",
    deutschland_url: "https://www.rosettastone.de/",
    download_pdf: "Scarica PDF",
    dutch: "Olandese",
    english: "Inglese",
    espana: "España",
    espana_url: "https://www.rosettastone.es/",
    europe: "Europa",
    europe_url: "https://www.rosettastone.eu/",
    facebook_url: "http://www.facebook.com/RosettaStoneEurope",
    faq_url: "/faq",
    faqs: "Domande frequenti",
    farsi: "(Farsi)",
    filipino: "Filippino",
    for_business: "Per le Aziende",
    for_business_resources_url: "https://www.rosettastone.it/aziende/risorse/",
    for_business_solutions_url: "https://www.rosettastone.it/aziende/soluzioni/",
    for_business_url: "https://www.rosettastone.it/aziende/home/",
    for_educators: "Per gli Educatori",
    for_educators_resources_url: "https://www.rosettastone.it/aziende/risorse/",
    for_educators_solutions_url: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/soluzioni/",
    for_educators_url: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/home/",
    for_hed: "Per gli Educatori Superiori",
    for_homeschool: null,
    for_homeschool_url: null,
    for_individuals: "Demo",
    for_individuals_url: "/demo",
    for_organizations: "Organizzazioni",
    for_public_sector: "Applicazioni Mobili",
    for_public_sector_url: "/mobili",
    for_you: "Per te",
    form_100: "100 o meno",
    form_500: "101 - 500",
    form_1000: "501 - 1,000",
    form_5000: "1,001 - 5,000",
    form_10000: "1,001 - 5,000",
    form_25000: "10,001 - 25,000",
    form_50000: "25,001 - 50,000",
    form_boardmember: "Membro di bordo",
    form_curriculumdirector: "Direttore del Curriculum / Coordinatore delle Istruzioni",
    form_director: "Direttore",
    form_email: "Email Professionale",
    form_executive: "Gestione Generale / Esecutiva",
    form_firstname: "Nome",
    form_how_blog: null,
    form_how_email: "Email",
    form_how_event: "Evento",
    form_how_online: "In linea",
    form_how_other: "Altro",
    form_how_referral: "Remissione",
    form_how_search: "Cercatore",
    form_how_social: "Social Media",
    form_how_title: "Come hai saputo di noi? (Opzionale)",
    form_how_webinar: "Seminario web",
    form_individualcontributor: "Collaboratore individuale",
    form_lastname: "Cognome",
    form_manager: "Manager",
    form_more: "50,001 - Altro",
    form_organization: "Nome dell'istituto",
    form_organizationsize: "Dimensione dell'organizzazione",
    form_phone: "Numero di telefono (facoltativo)",
    form_principal: "Direttore della Scuola",
    form_privacy1: "Rosetta Stone si impegna a proteggere la tua privacy. La nostra completa informativa sulla privacy è disponibile",
    form_privacy2: "qui.",
    form_privacy3: "Comprendo che posso scegliere di non ricevere tali comunicazioni in qualsiasi momento facendo clic sul collegamento fornito nella comunicazione o contattando Rosetta Stone all'indirizzo",
    form_privacy4: ".",
    form_privacyUrl: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf",
    form_privacyemail: "privacyofficer@rosettastone.com",
    form_role: "Ruolo (o titolo)",
    form_submit: "Consulenza Gratuita",
    form_superintendent: "Sovrintendente / Amministratore Distrettuale",
    form_teacher: "Professore",
    form_techcoordinator: "Coordinatore Tecnologico",
    form_updateagreement1: "Sì! Desidero ricevere aggiornamenti su prodotti e marketing da Rosetta Stone. Clicca ",
    form_updateagreement2: "qui",
    form_updateagreement3: "per maggiori informazioni.",
    form_vicepresident: "Vice Presidente",
    france: "France",
    france_url: "https://www.rosettastone.fr/",
    google_plus_url: "https://plus.google.com/105195149850491722010",
    greek: "Greco",
    gtm_id: "GTM-T7XMQN",
    has_combined_resources: true,
    has_resources: null,
    hebrew: "Ebraico",
    helpful_links: "Correggi l'URL o prova uno di questi link utili:",
    hide_cart: true,
    hide_contact: true,
    hide_espanol: true,
    hide_language: null,
    hide_search: true,
    hide_support: null,
    hindi: "Hindi",
    home: "Home",
    home_link: "/home/",
    home_url: "https://www.rosettastone.it/",
    instagram_url: "https://www.instagram.com/rosettastone",
    investors: "Relazioni con investitori",
    investors_url: "https://investors.rosettastone.com/",
    irish: "Irlandese",
    italia: "Italia",
    italia_url: "https://www.rosettastone.it/",
    item: "articolo",
    item_plural: "articoli",
    japan: "日本",
    japan_url: "http://www.rosettastone.co.jp",
    japanese: "Giapponese",
    k12_contact_title: "Istruzione - Consultazione dei prezzi",
    keep_exploring: "Continua ad esplorare",
    korea: "대한민국",
    korea_url: "https://www.rosettakorea.com/",
    korean: "Coreano",
    latin: null,
    latin_america: "(America Latina)",
    latin_america_region: "America Latina",
    latin_america_region_url: "https://espanol.rosettastone.com/",
    learn_arabic_url: "/impara-arabo/",
    learn_chinese: "Cinese",
    learn_chinese_url: "/impara-il-cinese/",
    learn_dutch_url: "/impara-lolandese/",
    learn_english: "Impara l'Inglese",
    learn_english_british_url: "/impara-inglese/",
    learn_english_url: "/impara-inglese-americano/",
    learn_french: "Impara il Francese",
    learn_french_url: "/impara-il-francese/",
    learn_german: "Impara il tedesco",
    learn_german_url: "/impara-il-tedesco/",
    learn_greek_url: "/impara-il-greco/",
    learn_hebrew_url: "/impara-ebraico/",
    learn_hindi_url: "/impara-lhindi/",
    learn_irish_url: "/impara-irlandese/",
    learn_italian: "Impara l'Italiano",
    learn_italian_url: "/impara-italiano/",
    learn_japanese_url: "/impara-il-giapponese/",
    learn_korean_url: "/impara-il-coreano/",
    learn_latin_url: null,
    learn_more: "Saperne di più",
    learn_persian_url: "/impara-il-farsi/",
    learn_polish_url: "/impara-il-polacco/",
    learn_portuguese_url: "/impara-il-portoghese/",
    learn_russian_url: "/impara-il-russo/",
    learn_spanish: "Impara lo Spagnolo",
    learn_spanish_spain_url: "/impara-lo-spagnolo/",
    learn_spanish_url: "/impara-lo-spagnolo-america-latina/",
    learn_swedish_url: "/impara-lo-svedese/",
    learn_tagalog_url: "/impara-il-tagalog/",
    learn_turkish_url: "/impara-il-turco/",
    learn_vietnamese_url: "/impara-il-vietnamita/",
    lexia_learning: "Recensioni",
    lexia_learning_url: "/recensioni",
    listen_now: "Ascolta ora",
    madarin: "(Mandarino)",
    market: ["IT"],
    media_quote_1: "“Adoro il programma Rosetta Stone e penso che il tuo metodo per",
    media_quote_1_bold: "L'apprendimento delle lingue funziona.",
    media_quote_1_end: "”",
    media_quote_2: "\"Con la sua eccellente interfaccia per l'utente, istruzioni chiare e una vasta gamma di giochi e sfide ...",
    media_quote_2_bold: "Rosetta Stone sorprende.",
    media_quote_2_end: "”",
    media_quote_3: "“",
    media_quote_3_bold: "Il gioiello della corona",
    media_quote_3_end: "tra i metodi di apprendimento linguistico del computer.”",
    more_resources_title: "Risorse aggiuntive",
    more_specify: "Per favore specifico",
    no_support_dropdown: true,
    persian: "Persiano",
    polish: "Polacco",
    portuguese: "Portoghese",
    press: "Stampa",
    press_url: "/stampa",
    pricing_subtitle: "Si prega di completare e ti contatteremo immediatamente.",
    pricing_thanks: "Grazie per il tuo interesse! Qualcuno ti seguirà a breve.",
    pricing_title: "Ottieni informazioni sulle nostre tariffe.",
    privacy_policy: "Politica sulla privacy",
    privacy_policy_url: "https://www.rosettastone.co.uk/docs/terms/RS-UK_Website%20Privacy%20Policy_05252018.pdf",
    products: "Per Conoscerci Meglio",
    questions_call: "Hai domande? Chiamaci",
    read_article: "Leggi l'articolo",
    read_case_study: "Leggi di più",
    read_ebook: "Leggi l'eBook",
    read_fact_sheet: "Leggi di più",
    read_guide: "Leggi la guida",
    read_more: "Leggi di più",
    read_report: "Leggi di più",
    read_white_paper: "Leggi di più",
    related_resources_title: "Risorse correlate",
    request_pricing: "Consultazione dei prezzi",
    resources: "Risorse",
    resources_link: "/risorse/",
    rosetta_copyright: "1999-2019 Rosetta Stone LLC. Tutti i diritti riservati.",
    rosetta_stone: "Rosetta Stone",
    russian: "Russo",
    search: "Ricerca...",
    search_rosetta_url: "https://search.rosettastone.com/",
    select_lang: "Scegli la tua lingua:",
    services: null,
    services_url: null,
    shop_now: null,
    sign_in: "Accedi",
    sign_in_url: "https://launch.rosettastone.com/it/osub/authenticate",
    similar_resources: "Risorse Simili",
    site_not_found: "Sito non trovato - 404",
    sitemap: "Mappa del Sito",
    sitemap_url: "/mappa-del-sito",
    solutions: "Soluzioni",
    solutions_link: "/soluzioni/",
    spain: "(Spagna)",
    spanish: "Spagnolo",
    support: "Assistenza",
    support_business_url: "https://support.rosettastone.com/it/work",
    support_chat: "Chat dal vivo di supporto tecnico",
    support_chat_live: "Chat dal vivo di supporto tecnico",
    support_chat_live_url: "https://rosettastone.secure.force.com/apex/PreLiveChatForm",
    support_chat_url: "https://support.rosettastone.com/it-IT/chat",
    support_classrooms: "Supporto per aule e aziende:",
    support_faq_btn: "Vedi tutte le domande più frequenti",
    support_faq_title: "Domande Frequenti",
    support_faq_url_1: "/faq#pquest1",
    support_faq_url_1_title: "Che cos'è la soluzione Rosetta Stone?",
    support_faq_url_2: "/faq#pquest2",
    support_faq_url_2_title: "Cos'è incluso nel corso TOTALe online?",
    support_faq_url_3: "/faq#pquest3",
    support_faq_url_3_title: "In che modo e dove posso scaricare le applicazioni mobili per l' iPhone®, iPad® o Android®?",
    support_faq_url_4: "/faq#pquest4",
    support_faq_url_4_title: "Come funziona il metodo Rosetta Stone?",
    support_for_you: "Personale",
    support_home: "Supporto",
    support_site: "Sito di Supporto",
    support_site_url: "https://support.rosettastone.com/it-IT/",
    swedish: "Svedese",
    switch_lang: "Español",
    switch_lang_url: "https://espanol.rosettastone.com/",
    system_reqs: "Requisiti di Sistema",
    system_reqs_url: "/requisiti-di-sistema",
    tagalog: "Tagalog",
    telephone_atr: "+ 44 (0) 20 7 749 2979",
    telephone_text: "1-(800)-ROSETTA",
    terms_conditions: "Termini e Condizioni ",
    terms_conditions_url: "http://resources.rosettastone.com/CDN/it/pdfs/Italy_Terms_And_Conditions.pdf",
    title: "it-copy",
    turkish: "Turco",
    twitter_url: "https://twitter.com/RosettaStoneUK",
    united_kingdom: "United Kingdom",
    united_kingdom_url: "https://www.rosettastone.co.uk/",
    united_states: "United States",
    united_states_url: "https://www.rosettastone.com",
    use_new_header: null,
    vertical: ["recECBjZxFEWVVls8"],
    vertical_business: "Aziende",
    vertical_business_link: "/aziende/home/",
    vertical_healthcare: null,
    vertical_healthcare_link: null,
    vertical_hed: "Istruzione Superiore",
    vertical_hed_link: "/istruzione-superiore/home/",
    vertical_k12: "Scuola Primaria e Secondaria",
    vertical_k12_link: "/istruzione-primaria-e-secondaria/home/",
    vertical_pub: "Istituzioni",
    vertical_pub_link: "/istituzioni/",
    verticals_subtitle: "Le nostre soluzioni linguistiche pluripremiate funzionano per tutti i tipi di studenti.",
    verticals_title: "Che tipo di apprendista sei?",
    vietnamese: "Vietnamita",
    view_infographic: "Leggi di più",
    watch_video: "Guarda il video",
    watch_webinar: "Vedi il webinar",
    youtube_url: "http://www.youtube.com/user/RosettaStoneUK"
  };
});

var education_primary_pages_config$2 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "it"
        },
        content: {
          copyData: copyData$2(),
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$8({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$8({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "it"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                src: null
              },
              title: {
                content: "Risorse",
                align: "left"
              },
              body: {
                content: "Lascia che gli studenti parlino da soli"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          copyData: copyData$2(),
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$8({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$8({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "L’apprendimento delle lingue  dalla scuola materna alla scuola secondaria superiore | Rosetta Stone",
          meta_description: "Le soluzioni di apprendimento linguistico di Rosetta Stone per la scuola primaria e secondaria  vanno di pari passo e si integrano con l'insegnamento in classe e sono disponibili in qualsiasi momento per gli studenti che desiderano apprendere  o migliorare la propria conoscenza dell'inglese e di altre lingue straniere.",
          canonical_url: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/",
          lang: "it"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              direction: "image-right",
              image: {
                src: null
              },
              title: {
                content: "Apprendere le lingue online.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              hero: {
                subtext: "Il modo migliore per comprendere come funziona il metodo è quello di provarlo. Vi offriamo una prima lezione gratuita."
              },
              justifyContent: "space-between",
              body: {
                content: "L’ obiettivo è parlare un'altra lingua e gli insegnanti sanno bene quanta pratica, tempo ed impegno ciò richieda. Rosetta Stone è un modello di apprendimento unico, in grado di far esprimere oralmente gli studenti in inglese o in un'altra lingua straniera sin dall'inizio della formazione. Grazie a questo metodo, acquisiranno fiducia e sicurezza e saranno pronti ad esprimersi da soli, in classe così come in altri contesti."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              product_sample_panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              content: [{
                body: {
                  dataQa: "2",
                  content: "Sin dalla prima lezione, tutti i termini che gli studenti ascoltano, pronunciano e leggono sono quelle della nuova lingua. E’ il principio dell’immersione totale nela lingua, che resta il modo più naturale di apprendere una lingua. Si passa senza timori dalle singole parole alle frasi più articolate. Pertanto quando arriverà il momento di porre domande e fornire risposte, gli insegnanti potranno essere certi che gli studenti saranno pronti."
                },
                data_qa: "2",
                direction: "image-left",
                title: {
                  dataQa: "2",
                  content: "Fornire ai propri studenti diverse modalità di apprendimento",
                  type: "section-title",
                  heading: "h2",
                  theme: "black",
                  align: "left"
                }
              }],
              link: {
                destination: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/risorse/content/case-study-pueblo-city-schools/",
                theme: "black",
                align: "left"
              },
              quote: "«Gli studenti sono rapiti dalla tecnologia e, di conseguenza, adorano utilizzare il programma. Pertanto   Advantage ci permette anche di arrivare a studenti  ai quali non avremmo mai avuto accesso in passato.»",
              attribution: "Responsabile dei programmi di apprendimento delle lingue straniere, Scuole di Pueblo City"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Dire addio alla timidezza per il timore di esprimersi in una lingua straniera.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "Quando s’inizia a parlare un'altra lingua, ci si sente a volte un po’ a disagio. Il timore di commettere errori di fronte a tutta la classe può persino rendere gli studenti troppo timidi nell’esprimersi. Il nostro motore di riconoscimento vocale TruAccent ™ è anche una guida alla pronuncia e lo studente non si sente affatto giudicato. Pertanto il suo utilizzo migliora ed accellera l'apprendimento della lingua, facendo acquisire allo studente maggiore fiducia e sicurezza nelle sue capacità di espressione orale."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/risorse/content/case-study-corona-norco-unified-school-district/",
                theme: "black",
                align: "left"
              },
              quote: "« Il programma di Rosetta Stone consente di accrescere la fiducia e la sicurezza degli studenti nell’espressione orale, fornendo loro l’opportunità di ascoltarsi mentre parlano e correggersi. Ciò li rende meno timidi.»",
              attribution: "Amministratore responsabile dei servizi d’insegnamento, Dipartmento d’inglese, Distretto scolastico unitario delle città di Corona-Norco"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Il tutoring online rende reale la conversazione",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Gli insegnanti vogliono che i loro studenti si sentano a proprio agio nel parlare la nuova lingua. Ma c’è una bella differenza fra l’apprendimento in classe ed il mondo reale in cui ci si deve esprimere faccia faccia con dei madrelingua. Le nostre sessioni di tutoring online consentono giustamente agli studenti di praticare la nuova lingua al loro livello, e con madrelingua. Ciò consente di apprendere « in modo intelligenet», in un ambiente sicuro."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/risorse/content/customer-spotlight-bethel-public-schools/",
                theme: "black",
                align: "left"
              },
              quote: "«Le reazioni degli studenti sono state molto positive. Il nostro approccio collaborativo in classe ricorda un po’ l’ambiente e l’atmosfera di una grande famiglia. . . »",
              attribution: "Coordinatrice del programma e professoressa di spagnolo, Liceo Bethel"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Gli studenti hanno la possibilità di apprendere la lingua ovunque.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Ancora oggi le lezioni in classe sono la regola per gli studenti. Ma le scuole facilitano anche l'apprendimento a distanza, non necessariamente in classe. La nostra appllicazione mobile consente agli studenti di accedere a lezioni e materiali al momento giusto. Questo dà loro la libertà di trasformare ogni ora del giorno in una lezione in classe."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/risorse/content/case-study-humboldt-state-university/",
                theme: "black",
                align: "left"
              },
              quote: "« Abbiamo riscontrato che i nostri studenti che seguono il programma Rosetta Stone® sono più motivati, hanno più sicurezza e fiducia in loro stessi, e sono anche più desiderosi di partecipare alle lezioni ed alle attività in classe. Hanno anche acquisito il vocabolario molto più rapidamente.»",
              attribution: "Professoressa d’inglese, Distretto scolastico Union High School "
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "L’inglese e le lingue straniere che corrispondono agli obiettivi di apprendimento.",
                learner_feature_1_title: "24 lingue",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Gli studenti sono immersi in un ambiente monolingua per accellerare l’apprendimento. ",
                learner_feature_2_title: "Immersione totale nella lingua secondo un ritmo personalizzato",
                learner_feature_3_icon_name: "icon_foundational",
                learner_feature_3_subtitle: "Gli studenti si divertono, rimemorizzando e rafforzando al contempo quanto appreso.",
                learner_feature_3_title: "Giochi ed attività",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Ausilio per la pronuncia a disposizione degli studenti di ogni livello.",
                learner_feature_4_title: "Riconoscimento vocale TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Offerto in un ambiente online sicuro, che opera al livello di ciascuno studente.",
                learner_feature_5_title: "Tutoring in diretta",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Accesso all’apprendimento sul telefono mobile o sul tablet dello studente.",
                learner_feature_6_title: "Applicazione mobile",
                learner_feature_title: "Funzioni destinate all’apprendimento – livello prmario e secondario"
              },
              data: {}
            }]
          }],
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$8({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$8({
            strings: strings
          })
        }
      };

    case "richiesta-prezzi":
      return {
        page: page,
        helmet: {
          meta_title: "Richiesta prezzi | Rosetta Stone",
          meta_description: "Le società di consulenza e servizi professionali globali devono affrontare barriere linguistiche che limitano la loro capacità di servire i clienti, coinvolgere i dipendenti e far crescere la loro attività a livello globale. Le soluzioni per la formazione linguistica aiutano le società di consulenza professionale a ottimizzare le ore fatturabili per dipendente, dimostrando l'importante ROI della formazione linguistica in tutta l'organizzazione.",
          canonical_url: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/richiesta-prezzi/",
          lang: "it"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Prenota subito un incontro con un esperto di apprendimento delle lingue."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Compila il modulo in basso per prenotare un incontro e capire come possiamo aiutarti."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Ci sei quasi!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nome",
                required: true,
                required_error: "Immetti il tuo nome."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Cognome",
                required: true,
                required_error: "Immetti il tuo cognome."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Indirizzo e-mail",
                required: true,
                required_error: "Immetti il tuo indirizzo e-mail.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Numero di telefono",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Azienda",
                required: true,
                required_error: "Immetti il nome della tua azienda."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Dimensioni azienda",
                required: true,
                required_error: "Immetti le dimensioni della tua azienda.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Meno",
                  label: "100 o Meno"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Più",
                  label: "50,001 o Più"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Qualifica",
                required: true,
                required_error: "Immetti il tuo ruolo."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Richiedi prezzi"
            },
            labels: {
              form_privacy1: "Rosetta Stone si impegna a proteggere la tua privacy. La nostra completa informativa sulla privacy è disponibile",
              form_privacy2: "qui.",
              form_privacy3: "Comprendo che posso scegliere di non ricevere tali comunicazioni in qualsiasi momento facendo clic sul collegamento fornito nella comunicazione o contattando Rosetta Stone all'indirizzo",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Sì! Desidero ricevere aggiornamenti su prodotti e marketing da Rosetta Stone. Clicca ",
              form_updateagreement2: "qui",
              form_updateagreement3: "per maggiori informazioni."
            },
            domain: ".it",
            dataQaLocation: "page"
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$8({
            strings: strings
          })
        }
      };

    case "richiesta-prezzi-completata":
      return {
        page: page,
        helmet: {
          meta_title: "Richiesta prezzi completa | Rosetta Stone",
          meta_description: "Le società di consulenza e servizi professionali globali devono affrontare barriere linguistiche che limitano la loro capacità di servire i clienti, coinvolgere i dipendenti e far crescere la loro attività a livello globale. Le soluzioni per la formazione linguistica aiutano le società di consulenza professionale a ottimizzare le ore fatturabili per dipendente, dimostrando l'importante ROI della formazione linguistica in tutta l'organizzazione.",
          canonical_url: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/richiesta-prezzi-completata/",
          lang: "it"
        },
        content: {
          title: {
            align: "center",
            content: "Ti ringraziamo per l'interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Consulta alcune risorse aggiuntive prima dell'incontro.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/risorse/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Risorse",
            theme: "blue_white"
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$8({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programmi di apprendimento linguistico online per l´istruzione primaria e secondaria | Rosetta Stone",
          meta_description: "I programmi di apprendimento linguistico on line di Rosetta Stone motivano gli studenti d’inglese  e delle altre lingue straniere, dando loro la fiducia e la sicurezza necessarie per esprimersi. Richiedi le nostre tariffe.",
          canonical_url: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/soluzioni/",
          lang: "it"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              direction: "image-right",
              image: {
                src: null
              },
              title: {
                content: "Le nostre soluzioni per l’insegnamento primario e secondario supportano tutti gli studenti di lingue.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Ogni studente di lingue ha le proprie motivazioni per decidere di apprendere una nuova lingua. Vi è quello che inizia con la lingua inglese per principianti e spera di poter parlare con i suoi compagni di classe. Un altro s’iscrive ad un corso di lingua impartito in classe, sperando di vivere un giorno in un altro paese. Qualunque siano i loro obiettivi di apprendimento di una lingua, gli studenti avranno i mezzi per esprimersi con fiducia e sicurezza grazie alle nostre soluzioni di apprendimento per l'istruzione primaria e secondaria."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "2",
                content: "Gli studenti che conoscono poco o non conoscono affatto l’inglese sono spesso restii ad inserirsi in un programma di apprendimento. Questa sensazione di isolamento può perdurare fino a quando non abbiano maggiore fiducia nelle loro capacità di esprimersi in inglese. I corsi per l'insegnamento dell’inglese di Rosetta Stone® comprendono tutte le risorse necessarie per gli studenti d’inglese, i loro insegnanti e le loro famiglie. Si allineano ai programmi per la parità di accesso all’istruzione, volti ad offrire a tutti gli studenti gli stessi strumenti necessari per avere successo negli studi."
              },
              data_qa: "2",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "2",
                content: "Inserire gli studenti d’inglese nel vostro programma di parità di accesso all’istruzione.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "3",
                content: "Il loro interesse può nascere da un film visto, da un libro letto, da un amico online o dall’incontro con un vicino. Indipendentemente dalle circostanze e dalle le ragioni di questa presa di coscienza a livello mondiale, l'apprendimento di un'altra lingua è oer loro il passo più significativo. La scelta del programma di Rosetta Stone per le scuole aiuta gli studenti ad acquisire le competenze linguistiche necessarie per soddisfare il desiderio di conoscere altri paesi ed altre culture."
              },
              data_qa: "3",
              direction: "image-right",
              layout: "list",
              title: {
                dataQa: "3",
                content: "Mettere gli studenti a contatto con nuove lingue e culture.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "4",
                content: "Quando gli studenti sono desiderosi di apprendere, ogni giorno trascorso in classe conta. Anche per quelli che stanno apprendendo l'inglese, è essenziale rimanere in carreggiata sulla giusta via. Il programma « English for Education » di Rosetta Stone® consente di coinvolgere i membri della famiglia dello studente nell'apprendimento dell'inglese. Questo supporto a 360 gradi aiuta lo studente a mantenere rapidamente i contatti con i propri insegnanti e compagni di classe e ad ottenere maggiore successo negli studi."
              },
              data_qa: "4",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "4",
                content: "Fare dell’apprendimento dell’inglese un affare di famiglia.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              }
            }]
          }, {
            panels: [{
              data_qa: "5",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Attiva il processo di auto-apprendimento con lezioni a ritmo personalizzato per lo studente e con attività che si svolgono nella nuova lingua; così supportato, lo studente apprende a parlare, leggere, ascoltare e pensare in questa lingua in modo completamente nuovo. ",
                feature_1_title: "Immersione dinamica nela lingua.",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "Una guida alla pronuncia con feedback immediato consente agli studenti di parlare la  nuova lingua in modo più corretto, dando loro quella fiducia e sicurezza di cui hanno bisogno per esprimersi correttamente.",
                feature_2_title: "TruAccent.",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Gli esercizi strutturati e la conversazione con madrelingua sono adattati al livello dello studente e lo aiutano a familiarizzare con la lingua che sta apprendendo.",
                feature_3_title: "Tutoring in diretta. ",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Integrare l'inglese, ma anche altre lingue, nei programmi di studio limguistico per sviluppare e perfezionare le competenze degli studenti di ogni livello, da quello principianti a quello avanzato.",
                feature_4_title: "24 lingue. ",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "Il modulo « English for Education » comprende risorse  settimanali e strumenti per aiutare le famiglie ad acquisireinsieme  competenze linguistiche in inglese e webinar in spagnolo che mettono in risalto il supporto familiare per gli studenti d’inglese.",
                feature_5_title: "Risorse per il contatto con i familiari.",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Le Guide offline per l'insegnante, i libri di esercizi e le guide alle attività didattiche offrono agli insegnanti le risorse per aiutarli ad insegnare in classe e per integrare e completare le lezioni online. ",
                feature_6_title: "Ausili per l’insegnamento in classe.",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "« English for Education » comprende esami di valutazione del posizionamento iniziale e di analisi dei progressi registrati dagli studenti delle scuole primarie e secondarie, consentendo agli insegnanti di determinare il livello iniziale di apprendimento e conoscenza della lingua inglese di ogni studente.",
                feature_7_title: "Esame delle conoscenze. ",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Gli studenti affrontano immediatamente contenuti ricchi ed interessanti, che si adattano al ritmo di apperndimento di ogni studente, all'interno di un ambiente interattivo incentrato sull'espressione orale dello studente. ",
                feature_8_title: "Nozioni di base e contenuti avanzati.",
                feature_9_img: "icon_games",
                feature_9_subtitle: "L'acquisizione ed il rafforzamento di nuovo vocabolario, di nozioni di grammatica e di pronuncia vengono effettuati in modo divertente ed accattivante, in grado di migliorare la lettura, l'ascolto e l’espressione orale. ",
                feature_9_title: "Giochi ed attività.",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Le attività previste per ogni livello comprendono la lettura ad alta voce con feedback istantaneo tramite la guida alla pronuncia (Reading Aloud), l’espressione scritta per fini specifici e la comprensione dell'ascolto e della lettura di testi.  ",
                feature_10_title: "Lettura – Espressione scritta. ",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Consentono agli studenti di utilizzare i loro smartphone e tablet in classe ed in altri contesti per seguire le lezioni e partecipare alle attività che migliorano le loro competenze e potenziano il loro vocabolario.",
                feature_11_title: "Applicazioni mobili. ",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Resoconti immediati dei risultati individuali, di gruppo e di classe, con monitoraggio dei progressi e delle competenze che consentono agli insegnanti ed agli amministratori di elaborare rapidamente rapporti sui risultati degli studenti.",
                feature_12_title: "Strumenti per il reporting.",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "Un semplice sistema di gestione delle licenze consente a insegnanti ed amministratori di riassegnare rapidamente le licenze agli studenti per garantire che tutte le licenze vengano utilizzate, garantendo un ritorno ottimale sull'investimento del programma.",
                feature_13_title: "Le  licenze sono trasferibili. ",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "Il nostro team inserisce gli obiettivi di apprendimento linguistico in moduli efficaci e fornisce assistenza nella preparazione, realizzazione e promozione del programma nelle scuole. ",
                feature_14_title: "Sostegno all’applicazione ed all’utilizzo. ",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Vengono proposti diversi livelli di formazione per amministratori ed insegnanti che contribuiscono al varo efficace del programma, integrandolo con l'insegnamento impartito dal docente in classe.",
                feature_15_title: "Servizi di formazione.",
                feature_section_title: "Tutte le risorse di cui avete bisogno sono a portata di mano"
              }
            }]
          }],
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$8({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$8({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_primary_footer_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.it/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/istruzione-superiore/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/aziende/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/mobili/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/recensioni/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.it/chi-siamo/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/stampa/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/contatti/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/it-IT/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/requisiti-di-sistema/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      // TODO: Make Cookies Instead of Antipircacy
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.it/accordi/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.it/termini/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.it/privacy-policy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneEU",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_secondary_nav_secondary_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
      visible: true,
      destination: "/risorse/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/soluzioni/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_label
    }
  };
});

var lead_generation_bar$7 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/richiesta-prezzi/",
        new_window: false,
        size: "regular",
        text: "Richiedi prezzi",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Pronto per il prossimo passo?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$7 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.verticals_education_primary,
        src: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacaobasica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_education_secondary,
        src: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/ensino-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_enterprise,
        src: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var education_secondary_pages_config$2 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "it"
        },
        content: {
          copyData: copyData$2(),
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$7({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$7({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "it"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                src: null
              },
              title: {
                content: "",
                align: "left"
              },
              body: {
                content: ""
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          copyData: copyData$2(),
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$7({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$7({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Apprendimento linguistico online per l'istruzione superiore | Rosetta Stone",
          meta_description: "Le soluzioni d’apprendimento linguistico Rosetta Stone per la f’istruzione superiore forniscono agli studenti accesso diretto online all’apprendimento dell’inglese e delle lingue parlate nel mondo. ",
          canonical_url: "https://www.rosettastone.it/istruzione-superiore/",
          lang: "it"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              direction: "image-right",
              image: {
                src: null
              },
              title: {
                content: "Rendere l’apprendimento delle lingue alla portata di tutti gli studenti.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Con un semplice tocco di dita sullo smartphone, gli studenti creano connessioni con il mondo intero. Tuttavia, le scuole devono affrontare limiti di budget in termini di programmi linguistici. Ciò limita le potenzialità accademiche e le prospettive di carriera degli studenti, nonché la loro visione del mondo. Nell'economia globale del ventesimo secolo, le competenze linguistiche sono un requisito fondamentale per inserirsi nel mondo del lavoro."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              product_sample_panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              content: [{
                body: {
                  dataQa: "2",
                  content: "Molti studenti dei cicli d’istruzione superiore sono in grado di sostenere un esame standard di conoscenza linguistica in inglese; tuttavia, le abilità e competenze linguistiche richieste per avere successo nel mondo accademico sono spesso molto diverse. Le soluzioni di apprendimento linguistico di Rosetta Stone consentono agli studenti non anglofoni di acquisire fiducia e sicurezza nella pratica della lingua inglese, nonché le competenze linguistiche necessarie per avere successo."
                },
                data_qa: "2",
                direction: "image-left",
                title: {
                  dataQa: "2",
                  content: "Accelerare l’apprendimento dell’inglese.",
                  type: "section-title",
                  heading: "h2",
                  theme: "black",
                  align: "left"
                }
              }],
              link: {
                destination: "https://www.rosettastone.it/istruzione-superiore/risorse/content/case-study-northern-border-university/",
                theme: "black",
                align: "left"
              },
              quote: "«Nell'era di Internet, considerato che l'inglese è la lingua universale, gli studenti devono padroneggiarlo per restare competitivi nel corso dei loro studi e successivamente nella professione. » ",
              attribution: "Preside, Dipartimento degli studi preparatori e degli studi secondari , Northern Border University"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "L’apprendimento linguistico online si adatta allo stile di vita degli studenti.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "Cultura, intrattenimento, sport, letteratura: tutto è ormai a portata di clic. Inserire un programma Rosetta Stone nei corsi di apprendimento linguistico, offre agli studenti accesso online ad una risorsa di guida alla pronuncia e di pratica della lingua parlata disponibile 24 ore su 24, che non è possibile fornire durante le classiche lezioni in presenza."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://www.rosettastone.it/istruzione-superiore/risorse/content/case-study-liberty-university/",
                theme: "black",
                align: "left"
              },
              quote: "« Una volta avviati i corsi pilota per la conversazione, i nostri studenti si sono presentati al colloquio di valutazione della conoscenza della lingua orale (OPIc) del Consiglio americano per l’insegnamento delle lingue straniere  (American Council on the Teaching of Foreogn languages, AFTCL). Dopo un solo semestre, gli studenti dei corsi  hanno ottenuto risultati nei livelli" + "principiante-medio" + "o superiori all'OPIc.» ",
              attribution: "Direttore del Dipartimento di Studi generali, Liberty University"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Il tutoring online fa parlare gli studenti",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Gli studenti, gli insegnanti ed il resto del personale vogliono sentirsi a proprio agio nel parlare una nuova lingua. Passare dall’apprendimento di una lingua al mondo reale richiede pratica. Le nostre sessioni di tutoring consentono agli studenti di praticare la nuova lingua al proprio livello con dei madrelingua. Ciò consente di apprendere" + "in modo intelligente" + "in un ambiente online sicuro."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://www.rosettastone.it/istruzione-superiore/risorse/content/case-study-canterbury-christ-church-university/",
                theme: "black",
                align: "left"
              },
              quote: "« Le soluzioni offerte da Rosetta Stone si sono rivelate un ottimo strumento per aiutare gli studenti  a valutare autonomamente il proprio grado di conoscenza e ad avere eccesso a vari livelli di esperienze interattive, che li hanno portati a progredire in modo indipendente ed autonomo.»",
              attribution: "Coordinatore del corso, Università Canterbury Christ Church"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Il laboratorio linguistico in ambiente e modalità cloud",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Le applicazioni mobili arricchiscono l’apprendimento linguistico consentendo agli studenti di apprendere ovunque ed in qualsiasi momento. Ciò offre agli studenti una maggiore flessibilità ed un accesso diretto ai materiali, mentre in classe gli insegnanti possono concentrarsi sull'apprendimento individuale e sulle attività di apprendimento collaborativo."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://www.rosettastone.it/istruzione-superiore/risorse/content/case-study-humboldt-state-university/",
                theme: "black",
                align: "left"
              },
              quote: "« [Il test adattivo di posizionamento (adaptive placement test), a cui lo studente si sottopone all'inizio del semestre e di nuovo alla fine del semestre] consente allo studente di misurare i suoi progressi nell'apprendimento della lingua.»",
              attribution: "Direttore del Laboratorio di lingue e culture straniere, Università di Stato di Humboldt "
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "L’inglese e le lingue straniere che corrispondono agli obiettivi di apprendimento dello studente.",
                learner_feature_1_title: "24 Lingue",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Gli studenti vengono praticamente immersi in un ambiente monolingue per accelerare l’apprendimento. ",
                learner_feature_2_title: "Immersion selon un rythme personnel",
                learner_feature_3_icon_name: "icon_games",
                learner_feature_3_subtitle: "Gli studenti si divertono rimemorizzando e rafforzando, al contempo,  quanto appreso.",
                learner_feature_3_title: "Giochi ed attività ",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Ausilio alla pronuncia a disposizione degli studenti di ogni livello.",
                learner_feature_4_title: "Riconoscimento vocale TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Offerto online, in un ambiente sicuro, agli studenti di ogni livello.",
                learner_feature_5_title: "Tutoring in diretta",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Accesso all’apprendimento a portata di mano di ogni studente sul proprio telefono mobile.",
                learner_feature_6_title: "Application mobile"
              },
              data: {}
            }]
          }],
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$7({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$7({
            strings: strings
          })
        }
      };

    case "richiesta-prezzi":
      return {
        page: page,
        helmet: {
          meta_title: "Richiesta prezzi | Rosetta Stone",
          meta_description: "Le società di consulenza e servizi professionali globali devono affrontare barriere linguistiche che limitano la loro capacità di servire i clienti, coinvolgere i dipendenti e far crescere la loro attività a livello globale. Le soluzioni per la formazione linguistica aiutano le società di consulenza professionale a ottimizzare le ore fatturabili per dipendente, dimostrando l'importante ROI della formazione linguistica in tutta l'organizzazione.",
          canonical_url: "https://www.rosettastone.it/istruzione-superiore/richiesta-prezzi/",
          lang: "it"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Prenota subito un incontro con un esperto di apprendimento delle lingue."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Compila il modulo in basso per prenotare un incontro e capire come possiamo aiutarti."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Ci sei quasi!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nome",
                required: true,
                required_error: "Immetti il tuo nome."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Cognome",
                required: true,
                required_error: "Immetti il tuo cognome."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Indirizzo e-mail",
                required: true,
                required_error: "Immetti il tuo indirizzo e-mail.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Numero di telefono",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Azienda",
                required: true,
                required_error: "Immetti il nome della tua azienda."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Dimensioni azienda",
                required: true,
                required_error: "Immetti le dimensioni della tua azienda.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Meno",
                  label: "100 o Meno"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Più",
                  label: "50,001 o Più"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Qualifica",
                required: true,
                required_error: "Immetti il tuo ruolo."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Richiedi prezzi"
            },
            labels: {
              form_privacy1: "Rosetta Stone si impegna a proteggere la tua privacy. La nostra completa informativa sulla privacy è disponibile",
              form_privacy2: "qui.",
              form_privacy3: "Comprendo che posso scegliere di non ricevere tali comunicazioni in qualsiasi momento facendo clic sul collegamento fornito nella comunicazione o contattando Rosetta Stone all'indirizzo",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Sì! Desidero ricevere aggiornamenti su prodotti e marketing da Rosetta Stone. Clicca ",
              form_updateagreement2: "qui",
              form_updateagreement3: "per maggiori informazioni."
            },
            domain: ".it",
            dataQaLocation: "page"
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$7({
            strings: strings
          })
        }
      };

    case "richiesta-prezzi-completata":
      return {
        page: page,
        helmet: {
          meta_title: "Richiesta prezzi completa | Rosetta Stone",
          meta_description: "Le società di consulenza e servizi professionali globali devono affrontare barriere linguistiche che limitano la loro capacità di servire i clienti, coinvolgere i dipendenti e far crescere la loro attività a livello globale. Le soluzioni per la formazione linguistica aiutano le società di consulenza professionale a ottimizzare le ore fatturabili per dipendente, dimostrando l'importante ROI della formazione linguistica in tutta l'organizzazione.",
          canonical_url: "https://www.rosettastone.it/istruzione-superiore/richiesta-prezzi-completata/",
          lang: "it"
        },
        content: {
          title: {
            align: "center",
            content: "Ti ringraziamo per l'interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Consulta alcune risorse aggiuntive prima dell'incontro.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/risorse/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Risorse",
            theme: "blue_white"
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$7({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_secondary_footer_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.it/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/istruzione-superiore/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/aziende/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/mobili/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/recensioni/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.it/chi-siamo/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/stampa/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/contatti/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/it-IT/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/faq",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/requisiti-di-sistema",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      // TODO: Make Cookies Instead of Antipircacy
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.it/accordi/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.it/termini/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.it/privacy-policy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneEU",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/risorse/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: "/soluzioni/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label
    }
  };
});

var lead_generation_bar$6 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/richiesta-prezzi/",
        new_window: false,
        size: "regular",
        text: "Richiedi prezzi",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Pronto per il prossimo passo?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$6 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.verticals_education_primary,
        src: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacaobasica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_education_secondary,
        src: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/ensino-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_enterprise,
        src: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var enterprise_pages_config$2 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "it"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                src: null
              },
              title: {
                content: "",
                align: "left"
              },
              body: {
                content: ""
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          copyData: copyData$2(),
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$6({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$6({
            strings: strings
          })
        }
      };

    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "it"
        },
        content: {
          copyData: copyData$2(),
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$6({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$6({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Formazione linguistica per le imprese | Rosetta Stone",
          meta_description: "Le soluzioni di formazione Rosetta Stone aiutano i dipendenti ad acquisire competenze linguistiche in inglese per le imprese ed in molte altre lingue straniere. Richiedete le nostre tariffe.",
          canonical_url: "https://www.rosettastone.it/aziende/",
          lang: "it"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              direction: "image-right",
              image: {
                src: null
              },
              title: {
                content: "Conoscere la lingua business permette ai dipendenti di far sentire la propria voce.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Apprendere nuove lingue commerciali richiede pratica, tempo ed impegno. Rosetta Stone offre ai dipendenti l'opportunità di esprimersi e correggere immediatamente la propria pronuncia. Pertanto saranno subito pronti ad esprimersi, contribuendo così al successo della vostra attività commerciale."
              },
              hero: {
                subtext: "Vi chiedete come ciò sia possibile ? Provate una lezione gratuita"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              product_sample_panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              content: [{
                body: {
                  dataQa: "2",
                  content: "I dipendenti apprendono più facilmente quando tutto ciò che ascoltano, parlano, leggono e scrivono è nella nuova lingua. Il nostro metodo" + "Dynamic Immersion®" + "consente di dare fiducia allo studente sin dalla prima lezione.»'"
                },
                data_qa: "2",
                direction: "image-left",
                title: {
                  dataQa: "2",
                  content: "Apprendere in modo naturale",
                  type: "section-title",
                  heading: "h2",
                  theme: "black",
                  align: "left"
                }
              }],
              link: {
                destination: "https://www.rosettastone.it/aziende/risorse/content/hitachi-data-systems-case-study/",
                theme: "black",
                align: "left"
              },
              quote: "« Rosetta Stone ci aiuta ad eliminare le barriere ed a superare gli ostacoli e stimola l’impegno degi nostri dipendenti. »",
              attribution: "Vice-Presidente, Apprendimento e collaborazione, Hitachi Data Systems."
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Iniziare a parlare",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "Il timore di commettere errori fa sì che gli studenti si sentano in imbarazzo nel parlare la lingua che stanno apprendendo. Il nostro motore di riconoscimento vocale e sintesi TruAccent™ consente ai dipendenti di esercitare e verificare la loro pronuncia, il che li aiuterà ad avere più fiducia e sicurezza nel parlare di business nella nuova lingua."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://www.rosettastone.it/aziende/risorse/content/e-on/",
                theme: "black",
                align: "left"
              },
              quote: "«Uno dei principali vantaggi dell'apprendimento linguistico con Rosetta Stone è la possibilità di apprendere in qualsiasi momento della giornata, ovunque e secondo il proprio ritmo...»",
              attribution: "Direttore, HR, CoC, Centro mondiale di formazione, E.ON."
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Farsi ascoltare",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "C'è notevole differenza fra conoscere una lingua appresa in classe e conversare con colleghi e clienti stranieri. Le sessioni di tutoring con madrelingua prevedono pratica in materia di conversazione, consentendo agli studenti di familiarizzare con le espressioni tipiche della nuova lingua."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://www.rosettastone.it/aziende/risorse/content/case-study-kimberly-clark-corporation/",
                theme: "black",
                align: "left"
              },
              quote: "« L’attuazione di un programmaunico  a livello d’impresa ci ha consentito diconseguire risparmi significativi. »",
              attribution: "Consulente principale in materia di gestione del talento, Kimberly-Clark Corporation."
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Sfruttare i dispositivi mobili",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "È spesso difficile trovare il tempo per studiare una lingua in classe. Le nostre applicazioni mobili consentono agli studenti di aver accesso a lezioni e materiali al momento giusto. In questo modo, qualsiasi momento della giornata può essere dedicato allo studio e trasformarsi in una grande esperienza di apprendimento."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://www.rosettastone.it/aziende/risorse/content/tripadvisor-com-case-study/",
                theme: "black",
                align: "left"
              },
              quote: "«ADORO QUESTO METODO! Rosetta Stone mi consente di apprendere una nuova lingua da solo, con i miei ritmi, dopo il lavorol.»",
              attribution: "Un dipendente di TripAdvisor, Singapore."
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Tra tutte queste lingue, ve ne sarà una che soddisfarà le esigenze di ciascun dipendente.",
                learner_feature_1_title: "24 lingue",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "E’ più facile apprendere una lingua rapidamente quando  essa è onnipresente.",
                learner_feature_2_title: "Immersione nella lingua secondo un ritmo personalizzato ",
                learner_feature_3_icon_name: "icon_foundational",
                learner_feature_3_subtitle: "Le lezioni si adattano agli studenti e non viceversa.",
                learner_feature_3_title: "Contenuti interessanti ed accattivanti",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "I dipendenti possono verificare la loro pronuncia in qualsiasi momento.",
                learner_feature_4_title: "Riconoscimento vocale TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Poter conversare con madrelingua è una garanzia di successo.",
                learner_feature_5_title: "Tutoring in diretta  ",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Apprendere e praticare la nuova lingua in qualsiasi momento.",
                learner_feature_6_title: "Applicazioni mobili"
              },
              data: {}
            }]
          }, {
            panels: [{
              pageData: {
                admin_feature_1_icon_name: "icon_placement",
                admin_feature_1_subtitle: "Fa corrispondere gli obiettivi al ritmo di apprendimento scelto dallo studente. ",
                admin_feature_1_title: "Posizionamento personalizzato",
                admin_feature_2_icon_name: "icon_assessments",
                admin_feature_2_subtitle: "Per iniziare bene, bisogna sapere qual è il livello di conoscenza dei dipendenti.",
                admin_feature_2_title: "Valutazione",
                admin_feature_3_icon_name: "icon_proficiency",
                admin_feature_3_subtitle: "Viene utilizzato all’inizio e durante il corso al fine di valutare i progressi realizzati.",
                admin_feature_3_title: "Esame di valutazone della conoscenza dell’inglese",
                admin_feature_4_icon_name: "icon_reporting",
                admin_feature_4_subtitle: "Il reporting in tempo reale aiuta a determinare il rendimento dell’investimento.",
                admin_feature_4_title: "Reporting",
                admin_feature_5_icon_name: "icon_implementation",
                admin_feature_5_subtitle: "I servizi specialistici dei nostri esperti aiutano gli amministratori a ben iniziare i corsi.",
                admin_feature_5_title: "Sostegno all’applicazione ed all’utilizzo ",
                admin_feature_6_icon_name: "icon_training",
                admin_feature_6_subtitle: "Tarata sulle dimensioni e sulle necessità della vostra organizzazione.",
                admin_feature_6_title: "Formazione",
                admin_feature_title: "Funzioni destinate all’amministratore"
              },
              img_bg: null
            }]
          }],
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$6({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$6({
            strings: strings
          })
        }
      };

    case "richiesta-prezzi":
      return {
        page: page,
        helmet: {
          meta_title: "Richiesta prezzi | Rosetta Stone",
          meta_description: "Le società di consulenza e servizi professionali globali devono affrontare barriere linguistiche che limitano la loro capacità di servire i clienti, coinvolgere i dipendenti e far crescere la loro attività a livello globale. Le soluzioni per la formazione linguistica aiutano le società di consulenza professionale a ottimizzare le ore fatturabili per dipendente, dimostrando l'importante ROI della formazione linguistica in tutta l'organizzazione.",
          canonical_url: "https://www.rosettastone.it/aziende/richiesta-prezzi/",
          lang: "it"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Prenota subito un incontro con un esperto di apprendimento delle lingue."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Compila il modulo in basso per prenotare un incontro e capire come possiamo aiutarti."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Ci sei quasi!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nome",
                required: true,
                required_error: "Immetti il tuo nome."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Cognome",
                required: true,
                required_error: "Immetti il tuo cognome."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Indirizzo e-mail",
                required: true,
                required_error: "Immetti il tuo indirizzo e-mail.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Numero di telefono",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Azienda",
                required: true,
                required_error: "Immetti il nome della tua azienda."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Dimensioni azienda",
                required: true,
                required_error: "Immetti le dimensioni della tua azienda.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Meno",
                  label: "100 o Meno"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Più",
                  label: "50,001 o Più"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Qualifica",
                required: true,
                required_error: "Immetti il tuo ruolo."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Richiedi prezzi"
            },
            labels: {
              form_privacy1: "Rosetta Stone si impegna a proteggere la tua privacy. La nostra completa informativa sulla privacy è disponibile",
              form_privacy2: "qui.",
              form_privacy3: "Comprendo che posso scegliere di non ricevere tali comunicazioni in qualsiasi momento facendo clic sul collegamento fornito nella comunicazione o contattando Rosetta Stone all'indirizzo",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Sì! Desidero ricevere aggiornamenti su prodotti e marketing da Rosetta Stone. Clicca ",
              form_updateagreement2: "qui",
              form_updateagreement3: "per maggiori informazioni."
            },
            domain: ".it",
            dataQaLocation: "page"
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$6({
            strings: strings
          })
        }
      };

    case "richiesta-prezzi-completata":
      return {
        page: page,
        helmet: {
          meta_title: "Richiesta prezzi completa | Rosetta Stone",
          meta_description: "Le società di consulenza e servizi professionali globali devono affrontare barriere linguistiche che limitano la loro capacità di servire i clienti, coinvolgere i dipendenti e far crescere la loro attività a livello globale. Le soluzioni per la formazione linguistica aiutano le società di consulenza professionale a ottimizzare le ore fatturabili per dipendente, dimostrando l'importante ROI della formazione linguistica in tutta l'organizzazione.",
          canonical_url: "https://www.rosettastone.it/aziende/richiesta-prezzi-completata/",
          lang: "it"
        },
        content: {
          title: {
            align: "center",
            content: "Ti ringraziamo per l'interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Consulta alcune risorse aggiuntive prima dell'incontro.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/risorse/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Risorse",
            theme: "blue_white"
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$6({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Formazione linguistica per le imprese  mondiali | Rosetta Stone Catalyst",
          meta_description: "La Formazione linguistica per le imprese mondiali con Rosetta Stone Catalyst offre corsi nelle principali lingue commerciali che i dipendenti possono apprendere ovunque si trovino. Richiedi le nostre tariffe per le aziende.",
          canonical_url: "https://www.rosettastone.it/aziende/soluzioni/",
          lang: "it"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              direction: "image-right",
              image: {
                src: null
              },
              title: {
                content: "L’acquisizione di nuove competenze linguistiche consente la collaborazione all’interno dell’impresa.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "La non conoscenza delle lingue spesso comporta una comunicazione imperfetta o distorta di buone idee che potrebbero essere condivise. Con Rosetta Stone® Catalyst ™, i dipendenti acquisiscono competenze linguistiche che trasformano informazioni e messaggi contrastanti in comunicazioni chiare con colleghi, dipendenti e clienti."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "2",
                content: "È essenziale poter parlare con collaboratori e colleghi. Con la formazione Catalyst, le istruzioni diventano chiare, i dipendenti le ascoltano e comprendono, commettendo così meno errori. Ciò porta ad una migliore produttività."
              },
              data_qa: "2",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "2",
                content: "Aumentare la produttività.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              align: "left",
              quote: "Leggi il resoconto",
              link: {
                destination: "https://www.rosettastone.it/aziende/risorse/content/language-training-productivity-ebook-snapshot/",
                theme: "black",
                align: "left"
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "3",
                content: "Il ricorso a programmi di formazione linguistica di fornitori locali che utilizzano metodi ed approcci diversi porta a risultati costosi e disomogenei. L'efficacia di Catalyst sta nell’offrire la stessa pluripremiata esperienza formativa a tutti i dipendenti, indipendentemente da dove si trovino, costantemente 24 ore su 24."
              },
              data_qa: "3",
              direction: "image-right",
              layout: "list",
              title: {
                dataQa: "3",
                content: "Internazionalizzarsi",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              align: "left",
              quote: "Leggi la scheda descrittiva",
              link: {
                destination: "https://www.rosettastone.it/aziende/risorse/content/meet-global-challenges/",
                theme: "black",
                align: "left"
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "4",
                content: "La maggior parte dei candidati cercano posti di lavoro che consentano loro di progredire nella carriera e passare a livelli superiori. Offrire ad un candidato l'opportunità di apprendere una lingua con Catalyst sarà considerato un elemento importante e rafforzerà la fidelizzazione del soggetto una volta assunto."
              },
              data_qa: "4",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "4",
                content: "Attirare i migliori talenti.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              align: "left",
              quote: "Leggi il Playbook",
              link: {
                destination: "https://www.rosettastone.it/aziende/risorse/content/rosetta-playbook-september-2017-final-web/",
                theme: "black",
                align: "left"
              }
            }]
          }, {
            panels: [{
              data_qa: "5",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Attiva il processo di auto-apprendimento con lezioni a ritmo personalizzato per lo studente e con attività che si svolgono nella nuova lingua; così supportato, lo studente apprende a parlare, leggere, ascoltare e pensare in questa lingua in modo completamente nuovo. ",
                feature_1_title: "Immersione dinamica nela lingua.",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "Una guida alla pronuncia con feedback immediato consente agli studenti di parlare la  nuova lingua in modo più corretto, dando loro quella fiducia e sicurezza di cui hanno bisogno per esprimersi correttamente.",
                feature_2_title: "TruAccent.",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Gli esercizi strutturati e la conversazione con madrelingua sono adattati al livello dello studente e lo aiutano a familiarizzare con la lingua che sta apprendendo.",
                feature_3_title: "Tutoring in diretta. ",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Integrare l'inglese, ma anche altre lingue, nei programmi di studio limguistico per sviluppare e perfezionare le competenze degli studenti di ogni livello, da quello principianti a quello avanzato.",
                feature_4_title: "24 lingue. ",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "Il modulo « English for Education » comprende risorse  settimanali e strumenti per aiutare le famiglie ad acquisireinsieme  competenze linguistiche in inglese e webinar in spagnolo che mettono in risalto il supporto familiare per gli studenti d’inglese.",
                feature_5_title: "Risorse per il contatto con i familiari.",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Le Guide offline per l'insegnante, i libri di esercizi e le guide alle attività didattiche offrono agli insegnanti le risorse per aiutarli ad insegnare in classe e per integrare e completare le lezioni online. ",
                feature_6_title: "Ausili per l’insegnamento in classe.",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "« English for Education » comprende esami di valutazione del posizionamento iniziale e di analisi dei progressi registrati dagli studenti delle scuole primarie e secondarie, consentendo agli insegnanti di determinare il livello iniziale di apprendimento e conoscenza della lingua inglese di ogni studente.",
                feature_7_title: "Esame delle conoscenze. ",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Gli studenti affrontano immediatamente contenuti ricchi ed interessanti, che si adattano al ritmo di apperndimento di ogni studente, all'interno di un ambiente interattivo incentrato sull'espressione orale dello studente. ",
                feature_8_title: "Nozioni di base e contenuti avanzati.",
                feature_9_img: "icon_games",
                feature_9_subtitle: "L'acquisizione ed il rafforzamento di nuovo vocabolario, di nozioni di grammatica e di pronuncia vengono effettuati in modo divertente ed accattivante, in grado di migliorare la lettura, l'ascolto e l’espressione orale. ",
                feature_9_title: "Giochi ed attività.",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Le attività previste per ogni livello comprendono la lettura ad alta voce con feedback istantaneo tramite la guida alla pronuncia (Reading Aloud), l’espressione scritta per fini specifici e la comprensione dell'ascolto e della lettura di testi.  ",
                feature_10_title: "Lettura – Espressione scritta. ",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Consentono agli studenti di utilizzare i loro smartphone e tablet in classe ed in altri contesti per seguire le lezioni e partecipare alle attività che migliorano le loro competenze e potenziano il loro vocabolario.",
                feature_11_title: "Applicazioni mobili. ",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Resoconti immediati dei risultati individuali, di gruppo e di classe, con monitoraggio dei progressi e delle competenze che consentono agli insegnanti ed agli amministratori di elaborare rapidamente rapporti sui risultati degli studenti.",
                feature_12_title: "Strumenti per il reporting.",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "Un semplice sistema di gestione delle licenze consente a insegnanti ed amministratori di riassegnare rapidamente le licenze agli studenti per garantire che tutte le licenze vengano utilizzate, garantendo un ritorno ottimale sull'investimento del programma.",
                feature_13_title: "Le  licenze sono trasferibili. ",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "Il nostro team inserisce gli obiettivi di apprendimento linguistico in moduli efficaci e fornisce assistenza nella preparazione, realizzazione e promozione del programma nelle scuole. ",
                feature_14_title: "Sostegno all’applicazione ed all’utilizzo. ",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Vengono proposti diversi livelli di formazione per amministratori ed insegnanti che contribuiscono al varo efficace del programma, integrandolo con l'insegnamento impartito dal docente in classe.",
                feature_15_title: "Servizi di formazione.",
                feature_section_title: "Tutte le risorse di cui avete bisogno sono a portata di mano"
              }
            }]
          }],
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$6({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$6({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var enterprise_footer_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.it/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/istruzione-superiore/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/aziende/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/mobili/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/recensioni/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.it/chi-siamo/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/stampa/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/contatti/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/it-IT/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/requisiti-di-sistema/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      // TODO: Make Cookies Instead of Antipircacy
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.it/accordi/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.it/termini/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.it/privacy-policy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneEU",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var consumer_product_activation_footer_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      // TODO: Make Cookies Instead of Antipircacy
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.it/accordi/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.it/termini/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.it/privacy-policy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneEU",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var consumer_product_activation_pages_config$3 = (function (_ref) {
  var page = _ref.page;

  switch (page) {
    case "product-activation":
      return {
        page: page,
        helmet: {
          meta_title: "Rosetta Stone® - Online Subscription Product Activation",
          meta_description: "Activate your Rosetta Stone® language learning online subscription products.",
          canonical_url: "https://rosettastone.com/product/product-activation/",
          lang: "it"
        }
      };

    default:
      return null;
  }
});

var it = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "business":
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config$2({
        strings: strings
      });
      page_config = enterprise_pages_config$2({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config$2({
        strings: strings
      });
      break;

    case "k12":
    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config$2({
        strings: strings
      });
      page_config = education_primary_pages_config$2({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config$2({
        strings: strings
      });
      break;

    case "hed":
    case "education-secondary":
      nav_secondary = education_secondary_nav_secondary_config$2({
        strings: strings
      });
      page_config = education_secondary_pages_config$2({
        page: page,
        strings: strings
      });
      footer_config = education_secondary_footer_config$2({
        strings: strings
      });
      break;

    case "consumer-product-activation":
      footer_config = consumer_product_activation_footer_config$3({
        strings: strings
      });
      page_config = consumer_product_activation_pages_config$3({
        page: page,
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config$2({
    strings: strings
  });
  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$4,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var consumer_product_activation_footer_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "https://www.rosettastone.com/anti-piracy/"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.com/terms/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.com/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: true,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      // region was deleted
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var consumer_product_activation_pages_config$2 = (function (_ref) {
  var page = _ref.page;

  switch (page) {
    case "product-activation":
      return {
        page: page,
        helmet: {
          meta_title: "Rosetta Stone® - Online Subscription Product Activation",
          meta_description: "Activate your Rosetta Stone® language learning online subscription products.",
          canonical_url: "https://rosettastone.com/product/product-activation/",
          lang: "ja"
        }
      };

    default:
      return null;
  }
});

var analytics$3 = {
  gtm_id: "GTM-NDSR53K"
};

var ja = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "consumer-product-activation":
      footer_config = consumer_product_activation_footer_config$2({
        strings: strings
      });
      page_config = consumer_product_activation_pages_config$2({
        page: page,
        strings: strings
      });
      break;
  }

  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$3,
    nav: {
      visible: true,
      primary: null,
      secondary: null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var consumer_product_activation_footer_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "https://www.rosettastone.com/anti-piracy/"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.com/terms/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.com/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: true,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      // region was deleted
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneKR",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/Rosettastonekorea",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var consumer_product_activation_pages_config$1 = (function (_ref) {
  var page = _ref.page;

  switch (page) {
    case "product-activation":
      return {
        page: page,
        helmet: {
          meta_title: "Rosetta Stone® - Online Subscription Product Activation",
          meta_description: "Activate your Rosetta Stone® language learning online subscription products.",
          canonical_url: "https://rosettastone.com/product/product-activation/",
          lang: "ko"
        }
      };

    default:
      return null;
  }
});

var analytics$2 = {
  gtm_id: "GTM-NDSR53K"
};

var ko = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "consumer-product-activation":
      footer_config = consumer_product_activation_footer_config$1({
        strings: strings
      });
      page_config = consumer_product_activation_pages_config$1({
        page: page,
        strings: strings
      });
      break;
  }

  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$2,
    nav: {
      visible: true,
      primary: null,
      secondary: null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var analytics$1 = {
  gtm_id: "GTM-TLH67WS"
};

var nav_primary_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://blog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: false,
      destination: "/contact/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: {
      visible: true,
      image: {
        type: "static",
        src: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
      },
      link: {
        destination: "/",
        external: false,
        new_window: false
      }
    },
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:18005115689",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/comprar-ingles/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }, {
        url: "/comprar-italiano/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }, {
        url: "/comprar-frances/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/comprar-aleman/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }, {
        url: "/comprar-espanol-espana/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }],
      language_options_other: [{
        url: "/comprar-arabe/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/comprar-chino/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/comprar-holandes/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, {
        url: "/comprar-ingles-britanico/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/comprar-filipino/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/comprar-griego/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/comprar-hebreo/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/comprar-hindi/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/comprar-irlandes/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/comprar-japones/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }, {
        url: "/comprar-latin/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/comprar-coreano/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/comprar-persa/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/comprar-polaco/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/comprar-portugues/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/comprar-ruso/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/comprar-espanol/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/comprar-sueco/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/comprar-turco/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/comprar-vietnamita/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label,
      homeschool_label: strings.nav_primary_vertical_education_homeschool_label,
      homeschool_destination: "https://www.rosettastone.com/homeschool/",
      product_title: strings.global_brand_name
    },
    sign_in: {
      visible: true,
      destination: "https://www.rosettastone.com/login",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: true,
      destination: "https://www.rosettastone.com/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_switch_language
    },
    support: {
      visible: true,
      destination: "https://support.rosettastone.com/es",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/educacion-basica/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: false,
      destination: "/estudiantes/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/estudiantes/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/empresa/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var awards$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.awards_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.awards_twitter,
        src: logosTiles.logosTilesTwitterSvg
      }
    }, {
      image: {
        type: "static",
        alt: strings.awards_bmw,
        src: logosTiles.logosTilesBmwSvg
      }
    }, {
      image: {
        type: "static",
        alt: strings.awards_uber,
        src: logosTiles.logosTilesUberSvg
      }
    }, {
      image: {
        type: "static",
        alt: strings.awards_williams_sonoma,
        src: logosTiles.logosTilesWsSvg
      }
    }]
  };
});

var branded_quotes$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.branded_quotes_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      name: strings.branded_quotes_macworld_name,
      type: strings.branded_quotes_macworld_type,
      quote: strings.branded_quotes_macworld_quote,
      logo: {
        type: "static",
        src: logos.logoMacworldSvg
      },
      backdrop: logos.logoMacworldBgSvg
    }, {
      name: strings.branded_quotes_techcrunch_name,
      type: strings.branded_quotes_techcrunch_type,
      quote: strings.branded_quotes_techcrunch_quote,
      logo: {
        type: "static",
        src: logos.logoTechcrunchSvg
      },
      backdrop: logos.logoTechcrunchBgSvg
    }, {
      name: strings.branded_quotes_cnn_name,
      type: strings.branded_quotes_cnn_type,
      quote: strings.branded_quotes_cnn_quote,
      logo: {
        type: "static",
        src: logos.logoCnnSvg
      },
      backdrop: logos.logoCnnBgSvg
    }]
  };
});

var email_collection_bar$3 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "EH_WEBSITE",
    demo_type: "offer_signup",
    newsletter_type: "footer_signup",
    language: "ENG",
    button: {
      text: "REGÍSTRATE",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "Correo electrónico",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "Obtén noticias y ofertas de Rosetta Stone.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Gracias por registrarte.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "El correo electrónico parece que no es válido.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Regístrate para mantenerte informado.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "Al registrarte, estás de acuerdo con los",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: "https://www.rosettastone.com/terms/",
      label: "términos y condiciones",
      theme: "white",
      underline: "on"
    }
  };
});

var consumer_pages_config$1 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Official Rosetta Stone® - Language Learning - Learn a Language",
          meta_description: "Rosetta Stone is the best way to learn a foreign language. The award-winning language solution combines proven learning methods with the world's best speech recognition technology.",
          canonical_url: "https://espanol.rosettastone.com/",
          lang: "es"
        },
        content: {
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$3({
            strings: strings
          })
        }
      };

    case "locaciones":
      return {
        page: page,
        helmet: {
          meta_title: "Locaciones Retail | Rosetta Stone",
          meta_description: "Descubre locaciones retail donde puedes comprar Rosetta Stone. ¡Vísitanos!",
          canonical_url: "https://espanol.rosettastone.com/locaciones/",
          lang: "es-419"
        },
        content: {
          sections: [{
            panels: [{
              title: {
                align: "left",
                content: "Estas Tiendas Retail de Rosetta Stone Pueden Ayudarte a Hablar Otro Idioma",
                type: "page-title",
                heading: "h1"
              },
              sub_title: {
                type: "page-sub-title",
                heading: "h2",
                align: "center",
                content: "Aprende a pronunciar como un local con nuestro aprendizaje de idiomas que siempre va contigo, disponible en estos sitios retail de Rosetta Stone."
              },
              image: {
                src: null,
                height: "100%",
                width: "100%"
              },
              dangerous: true,
              padding: "50px 0",
              direction: "image-right",
              body: {
                align: "left",
                dangerous: true,
                content: "Visita una de nuestras locaciones retail y descubre porque Rosetta Stone lleva más de 25 años en experiencia ayudando a millones de estudiantes de idiomas a hablar otro idioma. Con más de 24 idiomas para escoger, nuestras lecciones son interactivas, dinámicas y nuestra <a href='https://espanol.rosettastone.com/movil/' target='_blank'>aplicación móvil</a> galardonada te ayudará a sobresalir en conversaciones reales"
              },
              dataQa: "QA"
            }]
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$3({
            strings: strings
          })
        }
      };

    case "mobile-apps":
      return {
        page: page,
        helmet: {
          meta_title: "Aplicación Móvil del Programa de Rosetta Stone®",
          meta_description: "Aprende un nuevo idioma con la aplicación móvil en iOS y Android de Rosetta Stone®. Todo la metodología y las funciones al alcance de tu celular.",
          canonical_url: "https://espanol.rosettastone.es/movil/",
          lang: "es"
        },
        content: {
          topImageTextSections: {
            panels: [{
              dataQa: "1",
              layout: "list",
              justifyContent: "space-between",
              alignItems: {
                mobile: "center"
              },
              direction: "image-right",
              maxWidth: 60,
              padding: "150px 0",
              body: {
                dangerously: true,
                content: strings.mobile_apps_top_section_one_body_content,
                align: "left"
              },
              title: {
                align: "left",
                content: strings.mobile_apps_top_section_one_title_content,
                heading: "h1",
                type: "section-title",
                theme: "black"
              },
              image: {
                type: "static",
                src: images.mobileAppsImage_1Jpg
              },
              custom: {
                cta: {
                  destination: "https://espanol.rosettastone.com/freetrial/",
                  new_window: true,
                  size: "regular",
                  text: strings.mobile_apps_top_section_one_custom_cta_text,
                  theme: "blue_white"
                }
              }
            }, {
              dataQa: "2",
              layout: "list",
              justifyContent: "space-between",
              alignItems: {
                mobile: "center"
              },
              direction: "image-left",
              maxWidth: 60,
              padding: "50px 0",
              title: {
                align: "left",
                content: strings.mobile_apps_top_section_two_title_content,
                heading: "h2",
                type: "section-title",
                theme: "black"
              },
              body: {
                content: strings.mobile_apps_top_section_two_body_content,
                align: "left"
              },
              image: {
                type: "static",
                src: images.mobileAppsImage_2Jpg
              },
              sectionFeatureBullets: [{
                heading: strings.mobile_apps_top_section_two_feature_heading_content_one,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_one
              }, {
                heading: strings.mobile_apps_top_section_two_feature_heading_content_two,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_two
              }, {
                heading: strings.mobile_apps_top_section_two_feature_heading_content_three,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_three
              }, {
                heading: strings.mobile_apps_top_section_two_feature_heading_content_four,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_four
              }, {
                heading: strings.mobile_apps_top_section_two_feature_heading_content_five,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_five
              }, {
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_six
              }]
            }, {
              dataQa: "3",
              layout: "list",
              justifyContent: "space-between",
              alignItems: {
                mobile: "center"
              },
              direction: "image-right",
              maxWidth: 60,
              padding: "50px 0",
              title: {
                align: "left",
                content: strings.mobile_apps_top_section_three_title_content,
                heading: "h2",
                type: "section-title",
                theme: "black"
              },
              body: {
                content: strings.mobile_apps_top_section_three_body_content,
                align: "left"
              },
              image: {
                type: "static",
                src: images.mobileAppsImage_3Png
              },
              sectionFeatureBullets: [{
                heading: strings.mobile_apps_top_section_three_feature_heading_content_one,
                subHeading: strings.mobile_apps_top_section_three_feature_subheading_content_one
              }, {
                heading: strings.mobile_apps_top_section_three_feature_heading_content_two,
                subHeading: strings.mobile_apps_top_section_three_feature_subheading_content_two
              }, {
                heading: strings.mobile_apps_top_section_three_feature_heading_content_three,
                subHeading: strings.mobile_apps_top_section_three_feature_subheading_content_three
              }]
            }]
          },
          mobileOsLogos: {
            layout: "list",
            title: {
              align: "center",
              theme: "black",
              type: "section-title",
              content: strings.mobile_apps_os_logos_title_content,
              heading: "h2"
            },
            subtitle: {
              align: "center",
              theme: "black",
              type: "section-sub-title",
              content: strings.mobile_apps_os_logos_subtitle_content
            },
            padding: "25px 0 100px",
            panels: [{
              image: {
                alt: "",
                type: "static",
                src: logos.logoIosSvg,
                destination: "https://rosettastone.onelink.me/zwaO/f670c3a0",
                new_window: true
              }
            }, {
              image: {
                alt: "",
                src: logos.logoAppleWatchSvg,
                type: "static"
              }
            }, {
              image: {
                alt: "",
                src: logos.logoAndroidSvg,
                type: "static",
                destination: "https://play.google.com/store/apps/details?id=air.com.rosettastone.mobile.CoursePlayer&hl=en_US&gl=US",
                new_window: true
              }
            }, {
              image: {
                alt: "",
                src: logos.logoSamsungSvg,
                type: "static"
              }
            }]
          },
          bottomImageTextSection: {
            panels: [{
              dataQa: "4",
              layout: "list",
              justifyContent: "space-between",
              alignItems: {
                mobile: "center"
              },
              direction: "image-left",
              maxWidth: 60,
              title: {
                align: "left",
                content: strings.mobile_apps_bottom_section_one_title_content,
                heading: "h2",
                type: "section-title",
                theme: "black"
              },
              body: {
                content: strings.mobile_apps_bottom_section_one_body_content,
                align: "left"
              },
              image: {
                type: "static",
                src: images.homepageWomanOnBalconyMobileJpg
              }
            }]
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$3({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var consumer_footer_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: false,
      contact_modal: false,
      email_capture: true,
      market: "la",
      domain: ".espanol",
      vertical: "consumer",
      page: "home",
      // Strings
      main_label: strings.footer_cta_email_main_label,
      sub_label: strings.footer_cta_email_sub_label,
      button_label: strings.footer_cta_email_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      email_placeholder: strings.footer_cta_email_button
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_buy_label,
        links: [{
          visible: true,
          destination: "/comprar-ingles/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_english_label
        }, {
          visible: true,
          destination: "/comprar-frances/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_french_label
        }, {
          visible: true,
          destination: "/comprar-italiano/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_italian_label
        }, {
          visible: true,
          destination: "/comprar-aleman/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_german_label
        }, {
          visible: true,
          destination: "/comprar-espanol-espana/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_spanish_label
        }, {
          visible: true,
          destination: "/comprar-japones/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_japanese_label
        }, {
          visible: true,
          destination: "/comprar-chino/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_chinese_label
        }, {
          visible: true,
          destination: "/regalo/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_gift_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "/pruebaloya/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_demo_label
        }, {
          visible: true,
          destination: "/movil/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_mobile_label
        }, {
          visible: true,
          destination: "/opiniones-clientes/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/about/company/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/locaciones/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_retail_partners_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "//support.rosettastone.com/es/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "/pf/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "/contacto/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.com/terms/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.com/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          label: "Facebook",
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          label: "Twitter",
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          label: "Instagram",
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          label: "^YouTube",
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var email_collection_bar$2 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "EH_WEBSITE",
    demo_type: "offer_signup",
    newsletter_type: "footer_signup",
    language: "ENG",
    button: {
      text: "REGÍSTRATE",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "Correo electrónico",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "Obtén noticias y ofertas de Rosetta Stone.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Gracias por registrarte.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "El correo electrónico parece que no es válido.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Regístrate para mantenerte informado.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "Al registrarte, estás de acuerdo con los",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: "https://www.rosettastone.com/terms/",
      label: "términos y condiciones",
      theme: "white",
      underline: "on"
    }
  };
});

var consumer_seo_pages_config$1 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "seo-basic":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es"
        },
        content: {
          free_trial_banner: {
            visible: true,
            button: {
              theme: "blue_white",
              destination: "https://espanol.rosettastone.com/pruebagratis/?ocid=seo-stickyes",
              text: "PRUEBA NUESTRO DEMO GRATIS"
            }
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$2({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var consumer_seo_footer_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: false,
      contact_modal: false,
      email_capture: true,
      market: "la",
      domain: ".espanol",
      vertical: "consumer",
      page: "home",
      // Strings
      main_label: strings.footer_cta_email_main_label,
      sub_label: strings.footer_cta_email_sub_label,
      button_label: strings.footer_cta_email_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      email_placeholder: strings.footer_cta_email_button
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_buy_label,
        links: [{
          visible: true,
          destination: "/comprar-ingles/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_english_label
        }, {
          visible: true,
          destination: "/comprar-frances/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_french_label
        }, {
          visible: true,
          destination: "/comprar-italiano/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_italian_label
        }, {
          visible: true,
          destination: "/comprar-aleman/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_german_label
        }, {
          visible: true,
          destination: "/comprar-espanol-espana/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_spanish_label
        }, {
          visible: true,
          destination: "/comprar-japones/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_japanese_label
        }, {
          visible: true,
          destination: "/comprar-chino/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_chinese_label
        }, {
          visible: true,
          destination: "/regalo/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_gift_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "/pruebaloya/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_demo_label
        }, {
          visible: true,
          destination: "/movil/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_mobile_label
        }, {
          visible: true,
          destination: "/opiniones-clientes/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/about/company/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/locaciones/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_retail_partners_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "//support.rosettastone.com/es/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "/pf/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "/contacto/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.com/terms/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.com/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          label: "Facebook",
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          label: "Twitter",
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          label: "Instagram",
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          label: "^YouTube",
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_primary_nav_secondary_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://educationblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: true,
      destination: "/soluciones/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var lead_generation_bar$5 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitud-de-precios/",
        new_window: false,
        size: "regular",
        text: "Solicitar de precios",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$5 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.verticals_enterprise,
        src: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresa/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_education_secondary,
        src: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/educacion-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }]
  };
});

var copyData$1 = (function () {
  return {
    about_us: "Rosetta Stone",
    about_us_url: "/acerca",
    agreements: "Acuerdos",
    agreements_url: "/acuerdos",
    almost_there: "Casi hecho aquí!",
    american: "(Americano)",
    anti_piracy: "Anti-piratería",
    anti_piracy_url: "/antipirateria",
    arabic: "Arabe",
    award_section_header: "Avalada durante 25+ años por las mejores organizaciones.",
    blog_url: "https://www.rosettastone.es/magazine",
    brasil: "Brasil",
    brasil_url: "https://www.rosettastonebrasil.com/",
    brazil: "(Brasil)",
    british: "(Británico)",
    business_contact_title: "Empresa - Consulta de Precios",
    careers: "Carrera profesional",
    careers_url: "https://www.rosettastone.com/careers",
    cart_checkout: "Revisa",
    cart_checkout_url: "https://secure.rosettastone.es/es_store_view/checkout/cart",
    cart_discount: "Descuento:",
    cart_empty: "Su carrito está vacío.",
    cart_in_your_cart: "en tu carrito.",
    cart_subtotal: "Total parcial:",
    cart_summary: "Resumen del pedido:",
    cart_total: "Total (antes de impuestos):",
    cart_you_have: "Tienes",
    change_region: "Cambia Región:",
    china: "中国",
    china_url: "http://www.rosettastone.cn/",
    combined_resources_url: "https://espanol.rosettastone.com/empresa/recursos/",
    company: "SOBRE",
    connect: "Conectate con nosotros:",
    consumer_home: "Personal",
    contact: "Contáctanos",
    contact_description: "Formulario de Consulta de Precios",
    contact_ee_url: "/contacto/",
    contact_url: "https://espanol.rosettastone.com/contacto",
    cta_bar: "Listo para el siguiente paso?",
    cta_h2: "Listo para el siguiente paso?",
    cta_text: "Consulta de Precios",
    currency: "$",
    demo_pricing_subtitle_business: "Descubra cómo nuestras soluciones comerciales pueden ayudar a su empresa a atraer talento y mejorar la productividad. Rellene el siguiente formulario y nos pondremos en contacto en breve.",
    demo_pricing_subtitle_hed: "Descubra cómo nuestras soluciones de educación superior pueden ayudar a sus alumnos a hablar un nuevo idioma con confianza. Rellene el siguiente formulario y nos pondremos en contacto en breve.",
    demo_pricing_subtitle_k12: "Descubra cómo nuestras soluciones educativas pueden ayudar a sus estudiantes de inglés y de World Language a hablar con confianza. Rellene el siguiente formulario y nos pondremos en contacto en breve.",
    demo_pricing_subtitle_pub: "Descubra cómo nuestras soluciones del sector público pueden mejorar las comunicaciones con aquellos a quienes sirve. Rellene el siguiente formulario y nos pondremos en contacto en breve.",
    demo_pricing_title: "Obtenez une consultation gratuite",
    deutschland: "Deutschland",
    deutschland_url: "https://www.rosettastone.de/",
    download_pdf: "Descargar PDF",
    dutch: "Holandés",
    english: "Inglés",
    espana: "España",
    espana_url: "https://www.rosettastone.es/",
    europe: "Europa",
    europe_url: "https://www.rosettastone.eu/",
    facebook_url: "https://www.facebook.com/RosettaStoneLatino/",
    faq_url: "/pf",
    faqs: "Preguntas más frecuentes",
    farsi: " (Farsi)",
    filipino: "Filipino",
    for_business: "Para Empresa",
    for_business_resources_url: "https://espanol.rosettastone.com/empresa/recursos/",
    for_business_solutions_url: "https://espanol.rosettastone.com/empresa/soluciones/",
    for_business_url: "https://espanol.rosettastone.com/empresa/inicio/",
    for_educators: "Para Educadores",
    for_educators_resources_url: "https://espanol.rosettastone.com/empresa/recursos/",
    for_educators_solutions_url: "https://espanol.rosettastone.com/educacion-basica/soluciones/",
    for_educators_url: "https://espanol.rosettastone.com/educacion-basica/inicio/",
    for_hed: "Para Educadores Superiores",
    for_homeschool: null,
    for_homeschool_url: null,
    for_individuals: "Pruébalo gratis",
    for_individuals_url: "/demo",
    for_organizations: "Organizaciones",
    for_public_sector: "Apps para móvil",
    for_public_sector_url: "/movil",
    for_you: "Para Ti",
    form_100: "100 o Menos",
    form_500: "101 - 500",
    form_1000: "501 - 1,000",
    form_5000: "1,001 - 5,000",
    form_10000: "5,001 - 10,000",
    form_25000: "10,001 - 25,000",
    form_50000: "25,001 - 50,000",
    form_boardmember: "Miembro de la Junta",
    form_curriculumdirector: "Director de Currículo / Coordinador de Instrucción",
    form_director: "Director",
    form_email: "E-mail profesional",
    form_executive: "Dirección General / Ejecutivo",
    form_firstname: "Nombre",
    form_how_blog: "Blog",
    form_how_email: "Email",
    form_how_event: "Evento",
    form_how_online: "En línea",
    form_how_other: "Otro",
    form_how_referral: "Remisión",
    form_how_search: "Buscador",
    form_how_social: "Medios Sociales",
    form_how_title: "¿Como supiste de nosotros? (Opcional)",
    form_how_webinar: "Seminario Web",
    form_individualcontributor: "Colaborador Individual",
    form_lastname: "Apellidos",
    form_manager: "Gerente",
    form_more: "50,001 - Más",
    form_organization: "Nombre de la Organización",
    form_organizationsize: "Tamaño de la organización",
    form_phone: "Numero de Teléfono (Opcional)",
    form_principal: "Director de la Escuela",
    form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
    form_privacy2: "aquí.",
    form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
    form_privacy4: ".",
    form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
    form_privacyemail: "privacyofficer@rosettastone.com",
    form_role: "Rol (o título)",
    form_submit: "Consulta gratuita",
    form_superintendent: "Superintendente / Administrador de Distrito",
    form_teacher: "Profesor",
    form_techcoordinator: "Coordinador de Tecnologia",
    form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
    form_updateagreement2: "aquí",
    form_updateagreement3: "para más información.",
    form_vicepresident: "Vicepresidente",
    france: "France",
    france_url: "https://www.rosettastone.fr/",
    google_plus_url: "https://plus.google.com/105195149850491722010",
    greek: "Griego",
    gtm_id: null,
    has_combined_resources: true,
    has_resources: null,
    hebrew: "Hebreo",
    helpful_links: "Corrige la URL o prueba uno de estos enlaces útiles:",
    hide_cart: null,
    hide_contact: null,
    hide_espanol: null,
    hide_language: null,
    hide_search: null,
    hide_support: null,
    hindi: "Hindi",
    home: "Inicio",
    home_link: "/inicio/",
    home_url: "https://espanol.rosettastone.com/",
    instagram_url: "https://www.instagram.com/rosettastone",
    investors: "Relaciones inversionistas",
    investors_url: "https://investors.rosettastone.com/",
    irish: "Irlandés",
    italia: "Italia",
    italia_url: "https://www.rosettastone.it/",
    item: "artículo",
    item_plural: "artículos",
    japan: "日本",
    japan_url: "http://www.rosettastone.co.jp",
    japanese: "Japonés",
    k12_contact_title: "Educación - Consulta de Precios",
    keep_exploring: "Continuar explorando",
    korea: "대한민국",
    korea_url: "https://www.rosettakorea.com/",
    korean: "Coreano",
    latin: "Latín",
    latin_america: "(Latinoamérica)",
    latin_america_region: "America Latina",
    latin_america_region_url: "https://espanol.rosettastone.com/",
    learn_arabic_url: "/aprende-arabe/",
    learn_chinese: "Chino",
    learn_chinese_url: "/aprende-chino/",
    learn_dutch_url: "/aprende-holandes/",
    learn_english: "Aprende Inglés",
    learn_english_british_url: "/aprende-ingles/",
    learn_english_url: "/aprende-ingles-americano/",
    learn_french: "Aprende Francés",
    learn_french_url: "/aprende-frances/",
    learn_german: "Aprende Alemán",
    learn_german_url: "/aprende-aleman/",
    learn_greek_url: "/aprende-griego/",
    learn_hebrew_url: "/aprende-hebreo/",
    learn_hindi_url: "/aprende-hindu/",
    learn_irish_url: "/aprende-irlandes/",
    learn_italian: "Aprende Italiano",
    learn_italian_url: "/aprende-italiano/",
    learn_japanese_url: "/aprende-japones/",
    learn_korean_url: "/aprende-coreano/",
    learn_latin_url: "/aprende-latin/",
    learn_more: "Aprende más",
    learn_persian_url: "/aprende-persa/",
    learn_polish_url: "/aprende-polaco/",
    learn_portuguese_url: "/aprende-portugues/",
    learn_russian_url: "/aprende-ruso/",
    learn_spanish: "Aprende Español",
    learn_spanish_spain_url: "/aprende-espanol/",
    learn_spanish_url: "/aprende-espanol-latinoamericano/",
    learn_swedish_url: "/aprende-sueco/",
    learn_tagalog_url: "/aprende-filipino/",
    learn_turkish_url: "/aprende-turco/",
    learn_vietnamese_url: "/aprende-vietnamita/",
    lexia_learning: "Opiniones",
    lexia_learning_url: "/resenas-clientes",
    listen_now: "Escucha ahora",
    madarin: "(Mandarín)",
    market: ["LA"],
    media_quote_1: "”Me encanta el programa de Rosetta Stone y creo que su método para ",
    media_quote_1_bold: "aprender idiomas funciona.",
    media_quote_1_end: "”",
    media_quote_2: "“Con su interfaz excelente para el usuario, instrucciones claras y una amplia gama de juegos y retos...",
    media_quote_2_bold: "Rosetta Stone sorprende.",
    media_quote_2_end: "”",
    media_quote_3: "“",
    media_quote_3_bold: "La joya de la corona",
    media_quote_3_end: "entre los métodos de aprendizaje de idiomas por ordenador.”",
    more_resources_title: "Recursos adicionales",
    more_specify: "Por favor específica",
    no_support_dropdown: true,
    persian: "Persa",
    polish: "Polaco",
    portuguese: "Portugués ",
    press: "Prensa",
    press_url: "https://pr.rosettastone.com/",
    pricing_subtitle: "Por favor complete y nos pondremos en contacto con usted de inmediato.",
    pricing_thanks: "¡Gracias por tu interés! Alguien hará un seguimiento contigo en breve.",
    pricing_title: "Obtenga las respuestas de precios que necesita.",
    privacy_policy: "Política de privacidad",
    privacy_policy_url: "/privacidad",
    products: "¿DÓNDE EMPEZAR?",
    questions_call: "¿Tener preguntas? Llámanos",
    read_article: "Lee el artículo",
    read_case_study: "Lee más",
    read_ebook: "Lee el eBook",
    read_fact_sheet: "Lee más",
    read_guide: "Lee la guía",
    read_more: "Lee más",
    read_report: "Lee el informe",
    read_white_paper: "Lee más",
    related_resources_title: "Recursos Relacionados",
    request_pricing: "Consulta de Precios",
    resources: "Recursos",
    resources_link: "/recursos/",
    rosetta_copyright: "1999-2019 Rosetta Stone LLC. Todos los derechos reservados. Este sitio utiliza cookies. Mediante la utilización de este sitio web otorga su consentimiento para el uso de cookies. Saber más.",
    rosetta_stone: "Rosetta Stone",
    russian: "Ruso",
    search: "Buscar...",
    search_rosetta_url: "https://search.rosettastone.com/",
    select_lang: "Selecciona un idioma:",
    services: null,
    services_url: null,
    shop_now: "Compra ahora",
    sign_in: "Ingresar",
    sign_in_url: "https://launch.rosettastone.com/es/osub/authenticate",
    similar_resources: "Recursos Similares",
    site_not_found: "Sitio no encontrado - 404",
    sitemap: "Mapa del sitio",
    sitemap_url: "/mapa-sitio",
    solutions: "Soluciones",
    solutions_link: "/soluciones/",
    spain: "(España)",
    spanish: "Español",
    support: "Soporte",
    support_business_url: "https://support.rosettastone.com/es/enterprises",
    support_chat: "Chat de soporte técnico en vivo",
    support_chat_live: "Chat de soporte técnico en vivo",
    support_chat_live_url: "https://rosettastone.secure.force.com/apex/PreLiveChatForm",
    support_chat_url: "https://support.rosettastone.com/es/chat",
    support_classrooms: "Apoyo a Aulas y Empresas:",
    support_faq_btn: "Ver todas las preguntas frecuentes",
    support_faq_title: "Preguntas Frecuentes",
    support_faq_url_1: "/pf#pquest1",
    support_faq_url_1_title: "¿Qué es la Solución Rosetta Stone?",
    support_faq_url_2: "/pf#pquest2",
    support_faq_url_2_title: "¿Qué incluye la solución TOTALe online?",
    support_faq_url_3: "/pf#pquest3",
    support_faq_url_3_title: "¿Cómo y dónde consigo las aplicaciones para mi iPhone, iPad o dispositivo Android?",
    support_faq_url_4: "/pf#pquest4",
    support_faq_url_4_title: "¿Cómo funciona el método Rosetta Stone?",
    support_for_you: "Personal",
    support_home: "APOYO",
    support_site: "Sitio de soporte",
    support_site_url: "https://support.rosettastone.com/es/",
    swedish: "Sueco",
    switch_lang: "English",
    switch_lang_url: "https://www.rosettastone.com/",
    system_reqs: "Requisitos del sistema",
    system_reqs_url: "/requerimientos-sistema",
    tagalog: "(Tagalo)",
    telephone_atr: "tel:+18007673882",
    telephone_text: "1-(800)-ROSETTA",
    terms_conditions: "Términos y condiciones",
    terms_conditions_url: "/terminos",
    title: "la-copy",
    turkish: "Turco",
    twitter_url: "https://twitter.com/RosettaStoneUK",
    united_kingdom: "United Kingdom",
    united_kingdom_url: "https://www.rosettastone.co.uk/",
    united_states: "United States",
    united_states_url: "https://www.rosettastone.com",
    use_new_header: true,
    vertical: ["recECBjZxFEWVVls8"],
    vertical_business: "Empresa",
    vertical_business_link: "/empresa/inicio/",
    vertical_healthcare: null,
    vertical_healthcare_link: null,
    vertical_hed: "Educación Superior",
    vertical_hed_link: "/educacion-superior/inicio/",
    vertical_k12: "Educación",
    vertical_k12_link: "/educacion-basica/inicio/",
    vertical_pub: "Sector Público",
    vertical_pub_link: "/sector-publico/",
    verticals_subtitle: "Nuestras galardonadas soluciones lingüísticas funcionan para todo tipo de estudiantes.",
    verticals_title: "¿Qué tipo de aprendiz eres?",
    vietnamese: "Vietnamita",
    view_infographic: "Ver más",
    watch_video: "Ver el vídeo",
    watch_webinar: "Ver el webinar",
    youtube_url: "https://www.youtube.com/user/rosettastone"
  };
});

var education_primary_pages_config$1 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es-419"
        },
        content: {
          copyData: copyData$1(),
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$5({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$5({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es-419"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                src: null
              },
              title: {
                content: "",
                align: "left"
              },
              body: {
                content: ""
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          copyData: copyData$1(),
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$5({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$5({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Aprendizaje de Idiomas en línea para K-12 | Rosetta Stone",
          meta_description: "Las soluciones para el aprendizaje de idiomas K-12 de Rosetta Stone se fusionan con la instrucción del profesor en el salón de clase y el acceso en cualquier momento en que los estudiantes deseen aprender o mejorar su conocimiento del idioma inglés o su competencia lingüística a nivel mundial.  ",
          canonical_url: "https://espanol.rosettastone.com/educacion-basica/",
          lang: "es-419"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                content: "Aprendizaje de idiomas en línea",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Hablar un idioma nuevo es el objetivo y los profesores saben que se requiere bastante práctica. Rosetta Stone tiene un enfoque único que puede lograr que sus estudiantes hablen inglés o un idioma del mundo desde el principio, de manera que se sientan confiados y listos para expresarse tanto dentro como fuera del salón de clase."
              },
              image: {
                src: null
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              product_sample_panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              content: [{
                body: {
                  dataQa: "2",
                  content: "Desde la primera lección, cada palabra que los estudiantes escuchan, dicen y leen es en su idioma nuevo. Eso es inmersión, el enfoque más natural para el aprendizaje de idiomas: ir de las palabras a las frases a las oraciones sin miedo, de manera que cuando llegue el momento de hacer preguntas y ofrecer respuestas, los profesores tengan la confianza de saber que sus estudiantes van a estar listos."
                },
                data_qa: "2",
                direction: "image-left",
                title: {
                  dataQa: "2",
                  content: "Proporciona a los estudiantes más maneras de aprender.",
                  type: "section-title",
                  heading: "h2",
                  theme: "black",
                  align: "left"
                }
              }],
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/educacion-basica/recursos/content/customer-spotlight-phoenix-union-high-school-district/",
                align: "left"
              },
              quote: "«A los niños los impulsa la tecnología, de manera que a ellos les encanta usar el programa. Esa ventaja nos permite llegar a aquellos estudiantes a los que no podríamos llegar de otra manera».",
              attribution: "Enlace de Idiomas del Mundo, Escuelas de la Ciudad Pueblo"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Diga adiós al miedo a hablar",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "Hablar un idioma nuevo puede sonar extraño al principio. El miedo a cometer errores en el salón de clase puede incluso inhibir totalmente a los estudiantes al momento de hablar. Nuestro motor de reconocimiento del habla TruAccent™ guía la pronunciación, sin ningún tipo de juzgamiento, de manera que el aprendizaje de idiomas se acelera a medida que crece la confianza al hablar."
              },
              image: {
                src: null
              },
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/educacion-basica/recursos/content/equity-for-english-learners-snapshot/",
                align: "left"
              },
              quote: "«El programa de Rosetta Stone aumenta la confianza en la expresión oral de los estudiantes proporcionándoles oportunidades para practicar, escuchando su propia pronunciación y reduciendo su filtro afectivo».",
              attribution: "Administrador de Servicios Educacionales, Departamento de Inglés, Distrito Escolar Unificado Corona-Norco."
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Tutoría en vivo permite mantener una conversación real.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Los profesores desean que sus estudiantes se sientan cómodos al hablar su idioma nuevo, pero es un gran salto ir del aprendizaje de idiomas al mundo real. Nuestras sesiones de tutoría proporcionan a los estudiantes la oportunidad de practicar con hablantes nativos en su propio nivel de conocimiento. La tutoría en nuestro espacio seguro es otra manera inteligente de aprender."
              },
              image: {
                src: null
              },
              quote: "«La respuesta de los estudiantes al programa ha sido abrumadoramente positiva. Nuestro salón de clase participativo es más como una familia . . .»",
              attribution: "Coordinador de Currículo y Profesor de Español, Colegio Bethel",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/educacion-basica/recursos/content//implementing-online-language-learning/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Aprendizaje de idiomas que los estudiantes pueden llevar a todo lado.",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Los horarios de clase son aún la norma para los estudiantes, pero las escuelas están también facilitando la enseñanza fuera del salón de clase. Nuestra aplicación móvil permite a sus estudiantes tener acceso a lecciones y actividades en el momento adecuado, dándoles libertad para que ellos la conviertan en una experiencia de aprendizaje."
              },
              image: {
                src: null
              },
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/educacion-basica/recursos/content/case-study-guthrie-virtual-school/",
                align: "left"
              },
              quote: "«“El método Rosetta Stone es la herramienta de aprendizaje de idiomas más potente del mercado. Tras analizar la oferta disponible, consideramos que dicha metodología es pertinente y utiliza la tecnología en la educación de manera eficaz. Es un método comprobado, que funciona; la mejor opción a nuestro alcance.”»",
              attribution: "Dra. Alexandra Bogarín, Secretaria de Educación, Cultura y Deporte"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Idiomas inglés y del mundo que se ajustan a los objetivos del estudiante.",
                learner_feature_1_title: "24 Idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Envolver a los estudiantes con un idioma acelera el aprendizaje.",
                learner_feature_2_title: "Inmersión lingüística a ritmo propio",
                learner_feature_3_icon_name: "icon_games",
                learner_feature_3_subtitle: "Los estudiantes se divierten a la vez que refuerzan las lecciones aprendidas. ",
                learner_feature_3_title: "Juegos y Actividades",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "El asistente de pronunciación que cada estudiante puede utilizar.",
                learner_feature_4_title: "Reconocimiento de Voz TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "En un espacio en línea, seguro, en cada nivel de aprendizaje del estudiante.",
                learner_feature_5_title: "Tutoría en Vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Pone el acceso al aprendizaje en la mano del estudiante.",
                learner_feature_6_title: "Aplicación móvil",
                learner_feature_title: "Online or off, our award-winning app speaks for itself"
              },
              data: {}
            }]
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$5({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$5({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de Aprendizaje de Idiomas K-12 en línea | Rosetta Stone",
          meta_description: "Los programas de aprendizaje de idiomas de Rosetta Stone motivan a los estudiantes del idioma inglés y de los idiomas del mundo a hablar con confianza y seguridad. Pregunte sobre nuestros precios.",
          canonical_url: "https://espanol.rosettastone.com/educacion-basica/soluciones/",
          lang: "es-419"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              width: "100%",
              direction: "image-right",
              video: {
                controls: true,
                currentVideoUrl: "https://vimeo.com/594888236"
              },
              title: {
                content: "Nuestras soluciones de aprendizaje K-12 brindan apoyo a cualquier estudiante de idiomas.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Los estudiantes tienen su propia motivación para aprender un idioma nuevo. Unos toman cursos de aprendizaje del idioma inglés para principiantes y esperan poder hablar con sus compañeros. Otros estudian en una clase de idioma extranjero esperando algún día vivir en una cultura diferente. Cualesquiera que sean sus objetivos de idiomas, los estudiantes pueden desarrollar confianza y seguridad al hablar con nuestras soluciones galardonadas de aprendizaje K-12."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "2",
                content: "Los estudiantes que hablan poco o nada de inglés pueden titubear al momento de entrar a clases. Ese sentimiento de aislamiento puede durar hasta que aprendan a hablar inglés confiadamente. Inglés Educativo de Rosetta Stone® incluye recursos completos para los estudiantes del idioma inglés, sus profesores y sus familias. El programa va en línea con los programas de equidad que apuntan a dar a cada estudiante igual acceso a las herramientas de aprendizaje para lograr el éxito académico."
              },
              data_qa: "2",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "2",
                content: "Incluya estudiantes del idioma inglés en su programa de equidad.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              quote: "Leer la instantánea",
              align: "left",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/educacion-basica/recursos/content/la-influencia-del-ingles-en-los-empleados/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "3",
                content: "El interés puede empezar con una película, un libro, un amigo por Internet o a la vuelta de la esquina. No importa la manera cómo los estudiantes se interesen a nivel mundial, el siguiente paso más importante es que ellos aprendan un idioma del mundo. Escoger un programa escolar Rosetta Stone Educativo ayuda a los estudiantes a desarrollar la capacitación lingüística que necesitan para llegar tan lejos como sus intereses globales los lleve."
              },
              data_qa: "3",
              direction: "image-right",
              layout: "list",
              title: {
                dataQa: "3",
                content: "Conecte a los estudiantes con los idiomas y las culturas.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              quote: "Ver hoja de datos",
              align: "left",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/educacion-basica/recursos/content/empresa-5razones/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "4",
                content: "Cada día en el salón de clase cuenta cuando los estudiantes desean aprender. Para aquellos estudiantes que también están aprendiendo inglés, es muy importante que continúen por el buen camino. Inglés Educativo de Rosetta Stone® hace posible que las familias se involucren en el aprendizaje del idioma inglés del estudiante. El apoyo total que proporciona ayuda a los estudiantes a conectarse más rápidamente con los profesores y compañeros y a lograr un mejor éxito académico."
              },
              data_qa: "4",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "4",
                content: "Convierta el aprendizaje del idioma inglés en un esfuerzo familiar.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              }
            }]
          }, {
            panels: [{
              data_qa: "5",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Activa el aprendizaje con lecciones y actividades en el idioma nuevo, a un ritmo propio, que envuelven a los estudiantes a medida que ellos aprenden a hablar, leer, escribir, escuchar y pensar de una manera totalmente diferente. ",
                feature_1_title: "Inmersión Dinámica.",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "Una realimentación inmediata de la pronunciación sirve de guía a los estudiantes para que hablen el idioma nuevo de una manera correcta, haciendo que el aprendizaje se convierta en una experiencia gratificante y construya la base para lograr una mayor confianza al hablar. ",
                feature_2_title: "TruAccent.",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Ejercicios y conversaciones estructuradas con hablantes nativos se ajustan al nivel actual de conocimiento del idioma de los estudiantes y los ayuda a sentirse cómodos al hablar su idioma nuevo. ",
                feature_3_title: "Tutoría en Vivo. ",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Integra el idioma inglés y los idiomas del mundo en un programa de idiomas para desarrollar y perfeccionar la capacidad lingüística de los estudiantes en cada nivel de aprendizaje, desde el nivel de principiante hasta el nivel avanzado. ",
                feature_4_title: "24 idiomas. ",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "Inglés Educativo incluye recursos semanales para ayudar a las familias a desarrollar una capacidad lingüística en inglés de manera conjunta y seminarios web mensuales en español, resaltando el apoyo familiar a los servicios del idioma inglés.  ",
                feature_5_title: "Recursos para conexión familiar. ",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Las Guías de Enseñanza fuera de línea, los Libros de trabajo y las Guías de actividades en el salón de clase proporcionan a los profesores los recursos que apoyan la instrucción en el salón de clase y complementan las lecciones en línea.  ",
                feature_6_title: "Dinámica del salón de clase. ",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "Inglés Educativo incluye una prueba de ubicación y progreso para los grados 6-12 que permite a los profesores determinar el punto inicial de aprendizaje del idioma inglés para cada estudiante. ",
                feature_7_title: "Prueba. ",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Los estudiantes se involucran inmediatamente con un contenido dinámico que se adapta al ritmo y progreso de cada estudiante en un espacio interactivo que se enfoca en el aprendizaje de los estudiantes a expresarse oralmente. ",
                feature_8_title: "Contenido fundacional y avanzado. ",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Refuerzo de vocabulario, gramática y pronunciación de una manera divertida y participativa que desarrolla la capacidad de lectura, audición y expresión oral de los estudiantes. ",
                feature_9_title: "Juegos y actividades.",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Las actividades para cada nivel del estudiante incluyen Leer en Voz Alta con realimentación instantánea de la pronunciación, escritura para propósitos específicos y comprensión auditiva y de lectura.",
                feature_10_title: "Lectura y escritura.",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Permite a los estudiantes utilizar teléfonos inteligentes y tabletas, tanto dentro como fuera del salón de clase, para tener acceso a lecciones y actividades que aumentan la retención de habilidades y el vocabulario.",
                feature_11_title: "Aplicaciones móviles. ",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Revisión instantánea del rendimiento individual, grupal y a nivel del salón de clase con seguimiento del progreso y conocimiento que permite a los profesores y a los administradores informar los resultados obtenidos por los estudiantes de una manera fácil.",
                feature_12_title: "Herramientas de informe.",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "El manejo simplificado de licencias permite a los profesores y administradores a reasignar estudiantes rápidamente a fin de asegurar la utilización total del número de licencias y apoyar el programa de retorno de la inversión (ROI).",
                feature_13_title: "Licencias transferibles. ",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "Nuestro equipo incorpora objetivos de aprendizaje de idiomas en modelos efectivos y asiste en la planificación, despliegue y promoción del programa en escuelas y distritos escolares.",
                feature_14_title: "Apoyo durante la implementación. ",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Existen niveles de capacitación disponibles para el administrador y los profesores que contribuyen al lanzamiento exitoso del programa, el mismo que se fusionará de manera efectiva con la instrucción del profesor en el salón de clase.",
                feature_15_title: "Servicios de capacitación. ",
                feature_section_title: "Cada recurso que necesita está a su alcance"
              }
            }]
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$5({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$5({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios | Rosetta Stone",
          meta_description: "Las empresas de consultoría y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación lingüística ayudan a las empresas de consultoría profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en capacitación lingüística en toda la organización.",
          canonical_url: "https://espanol.rosettastone.com/educacion-basica/solicitud-de-precios/",
          lang: "es-419"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Reserve hoy mismo tiempo con un experto en el aprendizaje de idiomas."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Complete el formulario a continuación para programar un horario para analizar cómo podemos ayudarlo."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "¡Falta poco!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nombre",
                required: true,
                required_error: "Introduzca su nombre."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Apellido",
                required: true,
                required_error: "Introduzca su apellido."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Dirección de correo electrónico",
                required: true,
                required_error: "Introduzca su dirección de correo electrónico.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Número de teléfono",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Introduzca el nombre de su empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamaño de la empresa",
                required: true,
                required_error: "Introduzca el tamaño de su empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Menos",
                  label: "100 o Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Más",
                  label: "50,001 o Más"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Título*",
                required: true,
                required_error: "Introduzca su función."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar precios"
            },
            labels: {
              form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
              form_privacy2: "aquí.",
              form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
              form_updateagreement2: "aquí",
              form_updateagreement3: "para más información."
            },
            domain: ".espanol",
            dataQaLocation: "page"
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$5({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios-completa":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios completa | Rosetta Stone",
          meta_description: "Las empresas de consultoría y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación lingüística ayudan a las empresas de consultoría profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en capacitación lingüística en toda la organización.",
          canonical_url: "https://espanol.rosettastone.com/educacion-basica/solicitud-de-precios-completa/",
          lang: "es-419"
        },
        content: {
          title: {
            align: "center",
            content: "¡Gracias por su interés!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Consulte algunos recursos adicionales antes de la reunión.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$5({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_primary_footer_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://espanol.rosettastone.com/demo/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/educacion-basica/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/educacion-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/empresa/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/movil/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/resenas-clientes/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://espanol.rosettastone.com/acerca/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/contacto/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/es/school/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/pf/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/requerimientos-sistema/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.com/terms/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.com/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_secondary_nav_secondary_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://educationblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/soluciones/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_label
    }
  };
});

var lead_generation_bar$4 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitud-de-precios/",
        new_window: false,
        size: "regular",
        text: "Solicitar de precios",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$4 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.verticals_enterprise,
        src: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresa/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_education_secondary,
        src: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/educacion-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }]
  };
});

var education_secondary_pages_config$1 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "AAprendizaje de Idiomas en línea para educación superior | Rosetta Stone",
          meta_description: "Las soluciones de aprendizaje de idiomas de Rosetta Stone para educación superior proporcionan a los estudiantes acceso instantáneo en línea para que aprendan inglés y los idiomas del mundo. Pregunte sobre nuestros precios. ",
          canonical_url: "https://espanol.rosettastone.com/educacion-superior/",
          lang: "es"
        },
        content: {
          copyData: copyData$1(),
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$4({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$4({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                src: null
              },
              title: {
                content: "",
                align: "left"
              },
              body: {
                content: ""
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          copyData: copyData$1(),
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$4({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$4({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "AAprendizaje de Idiomas en línea para educación superior | Rosetta Stone",
          meta_description: "Las soluciones de aprendizaje de idiomas de Rosetta Stone para educación superior proporcionan a los estudiantes acceso instantáneo en línea para que aprendan inglés y los idiomas del mundo. Pregunte sobre nuestros precios. ",
          canonical_url: "https://espanol.rosettastone.com/educacion-superior/",
          lang: "es"
        },
        content: {
          sections: [{
            panels: [{
              width: "100%",
              direction: "image-right",
              video: {
                controls: true,
                currentVideoUrl: "https://vimeo.com/594871446"
              },
              title: {
                content: "Saber idiomas empresariales permite a los empleados expresarse eficazmente",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Aprender nuevos idiomas empresariales requiere práctica. Rosetta Stone logra que los empleados hablen y perfeccionen su pronunciación rápidamente de manera que estén listos para comunicarse y hablar sobre su negocio en poco tiempo.Aprender nuevos idiomas empresariales requiere práctica. Rosetta Stone logra que los empleados hablen y perfeccionen su pronunciación rápidamente de manera que estén listos para comunicarse y hablar sobre su negocio en poco tiempo."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              product_sample_panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              content: [{
                body: {
                  dataQa: "2",
                  content: "Los empleados aprenden con mayor eficacia cuando pueden escuchar, hablar, leer y escribir en su nuevo idioma. Eso es lo que nuestro método Dynamic Immersion® logra: desarrolla confianza en el idioma desde la primera lección."
                },
                data_qa: "2",
                direction: "image-left",
                title: {
                  dataQa: "2",
                  content: "Aprenda de manera natural",
                  type: "section-title",
                  heading: "h2",
                  theme: "black",
                  align: "left"
                }
              }],
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/educacion-superior/recursos/content/hitachi-data-systems-caso-de-exito",
                align: "left"
              },
              quote: "“Rosetta Stone nos ayuda a romper barreras y a lograr la participación del empleado.“",
              attribution: "VP de Aprendizaje y Colaboración, Hitachi Data Systems"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Empiece a hablar",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "El miedo de los estudiantes a cometer errores los puede inhibir al hablar un idioma nuevo. Nuestro motor del habla TruAccent™ permite a los empleados mejorar su pronunciación de manera que se sientan seguros y confiados cuando tengan que hablar de negocios."
              },
              image: {
                src: null
              },
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/educacion-superior/recursos/content/catalyst-overview/",
                align: "left"
              },
              quote: "“Los beneficios clave del aprendizaje de idiomas de Rosetta Stone son la posibilidad de aprender a cualquier hora, en cualquier lugar, a su propio ritmo. . .”",
              attribution: "Director, HR CoC Global Learning, E.ON"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Que le escuchen",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Pasar de las lecciones a hablar con los compañeros de trabajo y los clientes es un gran salto. Las sesiones de tutoría con hablantes nativos proporcionan práctica de conversación de manera que los estudiantes hablan su nuevo idioma de una manera natural."
              },
              image: {
                src: null
              },
              quote: "“Al implementar un programa empresarial global, hemos visto un ahorro significativo en los costos . . .”",
              attribution: "Asesor Senior de Talento Humano, Kimberly-Clark Corporation",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/educacion-superior/recursos/content/implementing-online-language-learning/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Acceso móvil",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Es difícil encontrar tiempo para sentarse en una clase y aprender un idioma. Nuestras aplicaciones móviles proporcionan a los estudiantes acceso a lecciones y actividades en el momento adecuado. Así, cualquier momento puede convertirse en una gran experiencia de aprendizaje."
              },
              image: {
                src: null
              },
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/educacion-superior/recursos/content/tripadvisor-com-caso-de-exito/",
                align: "left"
              },
              quote: "“¡ME ENCANTA! Rosetta Stone me permite aprender un idioma nuevo a mi propio ritmo de aprendizaje después de las horas de trabajo!”",
              attribution: "Empleado de TripAdvisor, Singapur"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Hay un idioma que se ajusta a los objetivos de cada empleado.",
                learner_feature_1_title: "24 Idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Rodearse del idioma es la manera más rápida de aprender.",
                learner_feature_2_title: "Inmersión lingüística a su propio ritmo",
                learner_feature_3_icon_name: "icon_foundational",
                learner_feature_3_subtitle: "Lecciones que siguen el ritmo de los estudiantes y no al revés.",
                learner_feature_3_title: "Contenido que Atrae",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Los empleados pueden revisar su pronunciación en cualquier momento.",
                learner_feature_4_title: "Reconocimiento de Habla TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Mantener una conversación con hablantes nativos es, definitivamente, una señal de éxito. ",
                learner_feature_5_title: "Tutoría en vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "El aprendizaje y la practica van tomados de la mano. ",
                learner_feature_6_title: "Aplicación Móvil",
                learner_feature_title: "Características del aprendizaje empresarial"
              },
              data: {}
            }]
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$4({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$4({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios | Rosetta Stone",
          meta_description: "Las empresas de consultoría y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación lingüística ayudan a las empresas de consultoría profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en capacitación lingüística en toda la organización.",
          canonical_url: "https://espanol.rosettastone.com/educacion-superior/solicitud-de-precios/",
          lang: "es-419"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Reserve hoy mismo tiempo con un experto en el aprendizaje de idiomas."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Complete el formulario a continuación para programar un horario para analizar cómo podemos ayudarlo."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "¡Falta poco!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nombre",
                required: true,
                required_error: "Introduzca su nombre."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Apellido",
                required: true,
                required_error: "Introduzca su apellido."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Dirección de correo electrónico",
                required: true,
                required_error: "Introduzca su dirección de correo electrónico.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Número de teléfono",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Introduzca el nombre de su empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamaño de la empresa",
                required: true,
                required_error: "Introduzca el tamaño de su empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Menos",
                  label: "100 o Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Más",
                  label: "50,001 o Más"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Título*",
                required: true,
                required_error: "Introduzca su función."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar precios"
            },
            labels: {
              form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
              form_privacy2: "aquí.",
              form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
              form_updateagreement2: "aquí",
              form_updateagreement3: "para más información."
            },
            domain: ".espanol",
            dataQaLocation: "page"
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$4({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios-completa":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios completa | Rosetta Stone",
          meta_description: "Las empresas de consultoría y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación lingüística ayudan a las empresas de consultoría profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en capacitación lingüística en toda la organización.",
          canonical_url: "https://espanol.rosettastone.com/educacion-superior/solicitud-de-precios-completa/",
          lang: "es-419"
        },
        content: {
          title: {
            align: "center",
            content: "¡Gracias por su interés!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Consulte algunos recursos adicionales antes de la reunión.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$4({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_secondary_footer_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://espanol.rosettastone.com/demo/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/educacion-basica/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/educacion-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/empresa/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/movil/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/resenas-clientes/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://espanol.rosettastone.com/acerca/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/contacto/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/es/school/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/pf/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/requerimientos-sistema/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.com/terms/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.com/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://educationblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label,
      title: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label,
      title: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label,
      title: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: "/soluciones/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label,
      title: strings.nav_secondary_enterprise_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label,
      title: strings.nav_secondary_enterprise_label
    }
  };
});

var lead_generation_bar$3 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitud-de-precios/",
        new_window: false,
        size: "regular",
        text: "Solicitar de precios",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.verticals_education_primary,
        src: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacion-basica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_education_secondary,
        src: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/educacion-superior/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var enterprise_pages_config$1 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es-419"
        },
        content: {
          copyData: copyData$1(),
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es-419"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                src: null
              },
              title: {
                content: "",
                align: "left"
              },
              body: {
                content: ""
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          copyData: copyData$1(),
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Capacitación Lingüística Empresarial | Rosetta Stone",
          meta_description: "Las soluciones de capacitación lingüística de Rosetta Stone ayudan a los empleados a desarrollar una competencia lingüística empresarial en el idioma inglés y en muchos otros idiomas de alta demanda. Solicite precios.",
          canonical_url: "https://espanol.rosettastone.com/empresa/",
          lang: "es-419"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              direction: "image-right",
              video: {
                currentVideoUrl: "https://vimeo.com/594871446",
                controls: true
              },
              title: {
                content: "Saber idiomas empresariales permite a los empleados expresarse eficazmente",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Aprender nuevos idiomas empresariales requiere práctica. Rosetta Stone logra que los empleados hablen y perfeccionen su pronunciación rápidamente de manera que estén listos para comunicarse y hablar sobre su negocio en poco tiempo."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              title: {
                dataQa: "2",
                content: "Aprenda de manera natural",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              body: {
                dataQa: "2",
                content: "Los empleados aprenden con mayor eficacia cuando pueden escuchar, hablar, leer y escribir en su nuevo idioma. Eso es lo que nuestro método Dynamic Immersion® logra: desarrolla confianza en el idioma desde la primera lección."
              },
              data_qa: "2",
              direction: "image-left",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/hitachi-data-systems-caso-de-exito",
                align: "left"
              },
              quote: "“Rosetta Stone nos ayuda a romper barreras y a lograr la participación del empleado.“",
              attribution: "VP de Aprendizaje y Colaboración, Hitachi Data Systems"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Empiece a hablar",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "El miedo de los estudiantes a cometer errores los puede inhibir al hablar un idioma nuevo. Nuestro motor del habla TruAccent™ permite a los empleados mejorar su pronunciación de manera que se sientan seguros y confiados cuando tengan que hablar de negocios."
              },
              image: {
                src: null
              },
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/catalyst-overview/",
                align: "left"
              },
              quote: "“Los beneficios clave del aprendizaje de idiomas de Rosetta Stone son la posibilidad de aprender a cualquier hora, en cualquier lugar, a su propio ritmo. . .”",
              attribution: "Director, HR CoC Global Learning, E.ON"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Que le escuchen",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Pasar de las lecciones a hablar con los compañeros de trabajo y los clientes es un gran salto. Las sesiones de tutoría con hablantes nativos proporcionan práctica de conversación de manera que los estudiantes hablan su nuevo idioma de una manera natural."
              },
              image: {
                src: null
              },
              quote: "“Al implementar un programa empresarial global, hemos visto un ahorro significativo en los costos . . .”",
              attribution: "Asesor Senior de Talento Humano, Kimberly-Clark Corporation",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/implementing-online-language-learning/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Acceso móvil",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Es difícil encontrar tiempo para sentarse en una clase y aprender un idioma. Nuestras aplicaciones móviles proporcionan a los estudiantes acceso a lecciones y actividades en el momento adecuado. Así, cualquier momento puede convertirse en una gran experiencia de aprendizaje."
              },
              image: {
                src: null
              },
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/tripadvisor-com-caso-de-exito/",
                align: "left"
              },
              quote: "“¡ME ENCANTA! Rosetta Stone me permite aprender un idioma nuevo a mi propio ritmo de aprendizaje después de las horas de trabajo!”",
              attribution: "Empleado de TripAdvisor, Singapur"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Hay un idioma que se ajusta a los objetivos de cada empleado.",
                learner_feature_1_title: "24 Idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Rodearse del idioma es la manera más rápida de aprender.",
                learner_feature_2_title: "Inmersión lingüística a su propio ritmo",
                learner_feature_3_icon_name: "icon_foundational",
                learner_feature_3_subtitle: "Lecciones que siguen el ritmo de los estudiantes y no al revés.",
                learner_feature_3_title: "Contenido que Atrae",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Los empleados pueden revisar su pronunciación en cualquier momento.",
                learner_feature_4_title: "Reconocimiento de Habla TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Mantener una conversación con hablantes nativos es, definitivamente, una señal de éxito. ",
                learner_feature_5_title: "Tutoría en vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "El aprendizaje y la practica van tomados de la mano. ",
                learner_feature_6_title: "Aplicación Móvil",
                learner_feature_title: "Características del aprendizaje empresarial"
              }
            }]
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Capacitación Global Lingüística Empresarial | Rosetta Stone Catalyst",
          meta_description: "La capacitación global lingüística empresarial de Rosetta Stone Catalyst ofrece los idiomas empresariales más utilizados que los empleados pueden aprender desde cualquier lugar.  Solicite nuestros precios corporativos.",
          canonical_url: "https://espanol.rosettastone.com/empresa/soluciones/",
          lang: "es-419"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              layout: "list",
              direction: "image-right",
              video: {
                currentVideoUrl: "https://vimeo.com/594888918",
                controls: true
              },
              title: {
                content: "Nuevas competencias lingüísticas empresariales hacen posible trabajar en conjunto",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Poder comunicarse con los compañeros de trabajo es muy importante. Con la capacitación lingüística Catalyst, las instrucciones son claras, los empleados escuchan y entienden las directrices y cometen menos errores. Eso significa que se logra una mayor productividad en el trabajo."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "2",
                content: "Poder comunicarse con los compañeros de trabajo es muy importante. Con la capacitación lingüística Catalyst, las instrucciones son claras, los empleados escuchan y entienden las directrices y cometen menos errores. Eso significa que se logra una mayor productividad en el trabajo."
              },
              data_qa: "2",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "2",
                content: "Aumento de la productividad",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              quote: "Leer la instantánea",
              align: "left",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/la-influencia-del-ingles-en-los-empleados/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "3",
                content: "Depender de los proveedores de idiomas locales con enfoques diferentes produce resultados costosos y desiguales. Catalyst proporciona, de manera eficiente, la misma excelente experiencia de aprendizaje a todos los empleados en cualquier sitio, las 24 horas del día."
              },
              data_qa: "3",
              direction: "image-right",
              layout: "list",
              title: {
                dataQa: "3",
                content: "Globalización",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              },
              quote: "Ver hoja de datos",
              align: "left",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/empresa-5razones/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "4",
                content: "La mayoría de candidatos busca el camino para avanzar al siguiente nivel. Poder hablar un idioma usando Catalyst será importante para los empleados al momento de aceptar un trabajo y de decidir quedarse con su negocio."
              },
              data_qa: "4",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "4",
                content: "Atrae talento",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                src: null
              }
            }]
          }, {
            panels: [{
              data_qa: "5",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Active el aprendizaje con lecciones y actividades a su propio ritmo utilizando solo el nuevo idioma de un empleado mientras aprenden a hablar, leer, escribir, escuchar y pensar de una manera completamente nueva.",
                feature_1_title: "Inmersión dinámica.",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "La respuesta inmediata a la pronunciación guía a los empleados a hablar el idioma correctamente, hace que el aprendizaje sea gratificante al instante y sienta las bases para una mayor confianza en el habla.",
                feature_2_title: "TruAccent.",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Los ejercicios estructurados, las conversaciones con hablantes nativos y las sesiones guiadas por un instructor y 1: 1 se alinean con el nivel de competencia actual de un empleado y se enfocan en hablar.",
                feature_3_title: "Tutoría en vivo.",
                feature_4_img: "icon_24",
                feature_4_subtitle: "ntegre el inglés y los idiomas del mundo en cualquier programa de capacitación en idiomas para desarrollar y refinar las habilidades lingüísticas de los empleados en todos los niveles de aprendizaje, desde principiantes hasta avanzados.",
                feature_4_title: "24 idiomas.",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "Las pruebas previas de inglés, español y francés y otras autoevaluaciones de idiomas del mundo identifican diversas necesidades lingüísticas y garantizan que la capacitación sea productiva desde el principio.",
                feature_5_title: "Valoraciones",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Recomienda una ruta de aprendizaje de idiomas adaptada para cada empleado en función de los objetivos y la competencia del alumno, y ofrece el nivel adecuado de desafío y compromiso.",
                feature_6_title: "Colocación de aprendiz.",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "Evalúe las habilidades de lectura y audición para determinar la competencia lingüística utilizando la escala del Marco Común Europeo de Referencia (MCER).",
                feature_7_title: "Pruebas de aptitud en inglés, español y francés.",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Las lecciones para principiantes se centran en temas cotidianos, mientras que las lecciones avanzadas van desde cultura e historia a temas específicos de la industria con contenido de sectores en profundidad.",
                feature_8_title: "Contenido fundacional y avanzado.",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Reforzar el vocabulario, la gramática y la pronunciación en actividades atractivas que desarrollan las habilidades de lectura, comprensión auditiva y expresión oral.",
                feature_9_title: "Juegos y actividades.",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "El aprendizaje digital tiene actividades para cada nivel de aprendiz, incluyendo Lectura en voz alta con comentarios del habla, escritura para propósitos específicos y comprensión auditiva y de lectura.",
                feature_10_title: "Leyendo y escribiendo.",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Permite a los empleados usar teléfonos inteligentes y tabletas en cualquier momento y en cualquier lugar para tener acceso a las lecciones y actividades que aumentan la retención de habilidades y vocabulario.",
                feature_11_title: "Aplicaciones móviles.",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Informes integrados del rendimiento individual, grupal y de ubicación, con progreso de uso y seguimiento de competencia que permite a los administradores alinear la capacitación con los objetivos comerciales.",
                feature_12_title: "Herramientas de reporte.",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "La administración simplificada de licencias permite a los gerentes y administradores reasignar e incorporar a los empleados rápidamente y contribuye a un retorno de la inversión más sólido.",
                feature_13_title: "Licencias transferibles.",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "Nuestro equipo incorpora objetivos de aprendizaje de idiomas en modelos efectivos y asiste en la planificación, implementación y promoción del programa en toda la organización.",
                feature_14_title: "Apoyo a la implementación.",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Los niveles de capacitación para administradores están disponibles para ayudar a un lanzamiento exitoso del programa, uno en el que los empleados comenzarán a aprender y hablar su nuevo idioma rápidamente.",
                feature_15_title: "Servicios de entrenamiento.",
                feature_section_title: "Todos los recursos que necesita a su alcance"
              }
            }]
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios | Rosetta Stone",
          meta_description: "Las empresas de consultoría y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación lingüística ayudan a las empresas de consultoría profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en capacitación lingüística en toda la organización.",
          canonical_url: "https://espanol.rosettastone.com/empresa/solicitud-de-precios/",
          lang: "es-419"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Reserve hoy mismo tiempo con un experto en el aprendizaje de idiomas."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Complete el formulario a continuación para programar un horario para analizar cómo podemos ayudarlo."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "¡Falta poco!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nombre",
                required: true,
                required_error: "Introduzca su nombre."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Apellido",
                required: true,
                required_error: "Introduzca su apellido."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Dirección de correo electrónico",
                required: true,
                required_error: "Introduzca su dirección de correo electrónico.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Número de teléfono",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Introduzca el nombre de su empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamaño de la empresa",
                required: true,
                required_error: "Introduzca el tamaño de su empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Menos",
                  label: "100 o Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Más",
                  label: "50,001 o Más"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Título*",
                required: true,
                required_error: "Introduzca su función."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar precios"
            },
            labels: {
              form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
              form_privacy2: "aquí.",
              form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
              form_updateagreement2: "aquí",
              form_updateagreement3: "para más información."
            },
            domain: ".espanol",
            dataQaLocation: "page"
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios-completa":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios completa | Rosetta Stone",
          meta_description: "Las empresas de consultoría y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación lingüística ayudan a las empresas de consultoría profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en capacitación lingüística en toda la organización.",
          canonical_url: "https://espanol.rosettastone.com/empresas/solicitud-de-precios-completa/",
          lang: "es-419"
        },
        content: {
          title: {
            align: "center",
            content: "¡Gracias por su interés!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Consulte algunos recursos adicionales antes de la reunión.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var enterprise_footer_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://espanol.rosettastone.com/demo/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/educacion-basica/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/educacion-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/empresa/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/movil/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/resenas-clientes/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://espanol.rosettastone.com/acerca/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/contacto/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/es/school/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/pf/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/requerimientos-sistema/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.com/terms/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://www.rosettastone.com/privacy/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var la = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "consumer":
      page_config = consumer_pages_config$1({
        page: page,
        strings: strings
      });
      footer_config = consumer_footer_config$1({
        strings: strings
      });
      break;

    case "consumer-seo":
      page_config = consumer_seo_pages_config$1({
        page: page,
        strings: strings
      });
      footer_config = consumer_seo_footer_config$1({
        strings: strings
      });
      break;

    case "business":
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config$1({
        strings: strings
      });
      page_config = enterprise_pages_config$1({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config$1({
        strings: strings
      });
      break;

    case "k12":
    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config$1({
        strings: strings
      });
      page_config = education_primary_pages_config$1({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config$1({
        strings: strings
      });
      break;

    case "hed":
    case "education-secondary":
      nav_secondary = education_secondary_nav_secondary_config$1({
        strings: strings
      });
      page_config = education_secondary_pages_config$1({
        page: page,
        strings: strings
      });
      footer_config = education_secondary_footer_config$1({
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config$1({
    strings: strings
  });
  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$1,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var analytics = {
  gtm_id: "GTM-TLH67WS"
};

var nav_primary_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://blog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: false,
      destination: "/contact/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: {
      visible: true,
      image: {
        type: "static",
        src: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
      },
      link: {
        destination: "/",
        external: false,
        new_window: false
      }
    },
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:18007673882",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: false,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/buy-spanish/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/buy-french/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/buy-italian/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }, {
        url: "/buy-german/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }, {
        url: "/buy-english/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }],
      language_options_other: [{
        url: "/buy-arabic/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/buy-chinese/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/buy-dutch/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, {
        url: "/buy-english-british/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/buy-tagalog/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/buy-greek/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/buy-hebrew/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/buy-hindi/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/buy-irish/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/buy-japanese/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }, {
        url: "/buy-korean/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/buy-farsi/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/buy-polish/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/buy-portuguese/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/buy-russian/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/buy-spanish-spain/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }, {
        url: "/buy-swedish/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/buy-turkish/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/buy-vietnamese/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label
    },
    sign_in: {
      visible: true,
      destination: "https://www.rosettastone.com/login",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: true,
      destination: "https://www.rosettastone.com/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_switch_language
    },
    support: {
      visible: true,
      destination: "https://support.rosettastone.com/pt/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/educacaobasica/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: false,
      destination: "/ensino-superior/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/students/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/empresas/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var awards = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.awards_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.awards_twitter,
        src: logosTiles.logosTilesTwitterSvg
      }
    }, {
      image: {
        type: "static",
        alt: strings.awards_bmw,
        src: logosTiles.logosTilesBmwSvg
      }
    }, {
      image: {
        type: "static",
        alt: strings.awards_uber,
        src: logosTiles.logosTilesUberSvg
      }
    }, {
      image: {
        type: "static",
        alt: strings.awards_williams_sonoma,
        src: logosTiles.logosTilesWsSvg
      }
    }]
  };
});

var branded_quotes = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.branded_quotes_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      name: strings.branded_quotes_macworld_name,
      type: strings.branded_quotes_macworld_type,
      quote: strings.branded_quotes_macworld_quote,
      logo: {
        type: "static",
        src: logos.logoMacworldSvg
      },
      backdrop: logos.logoMacworldBgSvg
    }, {
      name: strings.branded_quotes_techcrunch_name,
      type: strings.branded_quotes_techcrunch_type,
      quote: strings.branded_quotes_techcrunch_quote,
      logo: {
        type: "static",
        src: logos.logoTechcrunchSvg
      },
      backdrop: logos.logoTechcrunchBgSvg
    }, {
      name: strings.branded_quotes_cnn_name,
      type: strings.branded_quotes_cnn_type,
      quote: strings.branded_quotes_cnn_quote,
      logo: {
        type: "static",
        src: logos.logoCnnSvg
      },
      backdrop: logos.logoCnnBgSvg
    }]
  };
});

var email_collection_bar$1 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "PT_WEBSITE",
    demo_type: "offer_signup",
    newsletter_type: "footer_signup",
    language: "POR",
    button: {
      text: "Inscreva-se",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "E-mail",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "Receba notícias e ofertas da Rosetta Stone.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Obrigado por registra-se.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "Este email é inválido.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Inscreva-se para saber mais.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "Ao me inscrever, eu aceito os\n",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: "https://www.rosettastone.com/terms/",
      label: "termos e condições",
      theme: "white",
      underline: "on"
    }
  };
});

var consumer_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Rosetta Stone® Oficial - O Melhor Curso de Idiomas Online",
          meta_description: "Rosetta Stone é a melhor maneira de aprender Inglês e outros idiomas. Com a melhor ferramenta de reconhecimento de voz do mundo, on-line ou off-line, nosso aplicativo premiado fala por si.",
          canonical_url: "https://pt.rosettastone.com/",
          lang: "pt"
        },
        content: {
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$1({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var consumer_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: true,
      contact_modal: false,
      email_capture: true,
      market: "br",
      domain: ".br",
      vertical: "business",
      page: "home",
      // Strings
      main_label: strings.footer_cta_email_main_label,
      sub_label: strings.footer_cta_email_sub_label,
      button_label: strings.footer_cta_email_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      email_placeholder: strings.footer_cta_email_button
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_buy_label,
        links: [{
          visible: true,
          destination: "/buy-spanish/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_spanish_label
        }, {
          visible: true,
          destination: "/buy-french/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_french_label
        }, {
          visible: true,
          destination: "/buy-italian/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_italian_label
        }, {
          visible: true,
          destination: "/buy-german/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_german_label
        }, {
          visible: true,
          destination: "/buy-english/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_english_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/comprar-ingles/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_ingles_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_espanol_label
        }, {
          visible: true,
          destination: "/homeschool/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_homeschool_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "/demo/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_demo_label
        }, {
          visible: true,
          destination: "/product-activation/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_activation_label
        }, {
          visible: true,
          destination: "/product/mobile-apps/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_mobile_label
        }, {
          visible: true,
          destination: "/product/reviews/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_reviews_label
        }, {
          visible: true,
          destination: "/enterprise/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_enterprise_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_education_primary_label
        }, {
          visible: true,
          destination: "//blog.rosettastone.com/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_blog_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "/about/company/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_k12_reading_label
        }, {
          visible: true,
          destination: "/lp/military/military-discount/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/careers/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "//pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "//support.rosettastone.com/en/work/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "/product/faq/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "/contact/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }, {
          visible: false,
          destination: "/legal/accessibility/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_accessibility_statement_label
        }]
      }]
    },
    meta: {
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: false,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://pt.rosettastone.com/termos/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://pt.rosettastone.com/privacidade/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var email_collection_bar = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "PT_WEBSITE",
    demo_type: "offer_signup",
    newsletter_type: "footer_signup",
    language: "POR",
    button: {
      text: "Inscreva-se",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "E-mail",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "Receba notícias e ofertas da Rosetta Stone.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Obrigado por registra-se.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "Este email é inválido.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Inscreva-se para saber mais.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "Ao me inscrever, eu aceito os\n",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: "https://www.rosettastone.com/terms/",
      label: "termos e condições",
      theme: "white",
      underline: "on"
    }
  };
});

var consumer_seo_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "seo-basic":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "en"
        },
        content: {
          free_trial_banner: {
            visible: true,
            button: {
              theme: "blue_white",
              destination: "https://www.rosettastone.com/tryitnow/?ocid=seo-sticky",
              text: "Comece o teste grátis"
            }
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          email_collection_bar: email_collection_bar({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var consumer_seo_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: true,
      contact_modal: false,
      email_capture: true,
      market: "br",
      domain: ".br",
      vertical: "business",
      page: "home",
      // Strings
      main_label: strings.footer_cta_email_main_label,
      sub_label: strings.footer_cta_email_sub_label,
      button_label: strings.footer_cta_email_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      email_placeholder: strings.footer_cta_email_button
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_buy_label,
        links: [{
          visible: true,
          destination: "/buy-spanish/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_spanish_label
        }, {
          visible: true,
          destination: "/buy-french/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_french_label
        }, {
          visible: true,
          destination: "/buy-italian/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_italian_label
        }, {
          visible: true,
          destination: "/buy-german/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_german_label
        }, {
          visible: true,
          destination: "/buy-english/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_english_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_espanol_label
        }, {
          visible: true,
          destination: "/homeschool/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_homeschool_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "/demo/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_demo_label
        }, {
          visible: true,
          destination: "/product-activation/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_activation_label
        }, {
          visible: true,
          destination: "/product/mobile-apps/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_mobile_label
        }, {
          visible: true,
          destination: "/product/reviews/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_reviews_label
        }, {
          visible: true,
          destination: "/enterprise/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_enterprise_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_education_primary_label
        }, {
          visible: true,
          destination: "//blog.rosettastone.com/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_blog_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "/about/company/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_k12_reading_label
        }, {
          visible: true,
          destination: "/careers/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "//pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "//support.rosettastone.com/en/work/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "/product/faq/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "/contact/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }, {
          visible: false,
          destination: "/legal/accessibility/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_accessibility_statement_label
        }]
      }]
    },
    meta: {
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: false,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://pt.rosettastone.com/termos/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://pt.rosettastone.com/privacidade/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_primary_nav_secondary_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: null,
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/solucoes/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label,
      options: null
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var lead_generation_bar$2 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitacao-de-precos/",
        new_window: false,
        size: "regular",
        text: "Solicitar preços",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.verticals_education_primary,
        src: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacaobasica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_education_secondary,
        src: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/ensino-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_enterprise,
        src: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var copyData = (function () {
  return {
    about_us: null,
    about_us_url: "/sobre-nos",
    agreements: "Acordos",
    agreements_url: "https://www.rosettastone.com/legal/agreements",
    almost_there: "Quase pronto!",
    american: "(Americano)",
    anti_piracy: "Antipirataria",
    anti_piracy_url: "https://www.rosettastone.com/anti-piracy",
    arabic: "Árabe",
    award_section_header: "Aprovado há 25+ anos pelas melhores organizações.",
    blog_url: "https://www.rosettastone.es/magazine/",
    brasil: "Brasil",
    brasil_url: "https://www.rosettastonebrasil.com/",
    brazil: "Brasil",
    british: " (Britânico)",
    business_contact_title: "Empresa - Consulta de Preços",
    careers: "Carreiras",
    careers_url: "https://www.rosettastone.com/careers",
    cart_checkout: "Confira",
    cart_checkout_url: "XXX",
    cart_discount: "Desconto:",
    cart_empty: "Seu carrinho está vazio no momento.",
    cart_in_your_cart: "no seu carrinho.",
    cart_subtotal: "Subtotal:",
    cart_summary: "Resumo do pedido:",
    cart_total: "Total (antes de impostos):",
    cart_you_have: "Você tem",
    change_region: "Mudar de região:",
    china: "中国",
    china_url: "http://www.rosettastone.cn/",
    combined_resources_url: "https://www.rosettastonebrasil.com/empresas/recursos/",
    company: "Sobre",
    connect: "Conecte-se conosco:",
    consumer_home: "Cajado",
    contact: "Contato",
    contact_description: "Formulário de consulta de preços",
    contact_ee_url: "/contato/",
    contact_url: "http://edu.rosettastonebrasil.com/forms/educacaobasicacontatofomulario",
    cta_bar: "Pronto para o próximo passo?",
    cta_h2: "Listo para el siguiente paso?",
    cta_text: "Consulta de Preços",
    currency: "R$",
    demo_pricing_subtitle_business: "Descubra como nossas soluções de negócios podem ajudar sua empresa a atrair talentos e melhorar a produtividade. Preencha o formulário abaixo e entraremos em contato em breve.",
    demo_pricing_subtitle_hed: "Descubra como nossas soluções de ensino superior podem ajudar seus alunos a falar um novo idioma com confiança. Preencha o formulário abaixo e entraremos em contato em breve.",
    demo_pricing_subtitle_k12: "Descubra como nossas soluções educacionais podem ajudar seus alunos de inglês e de idiomas do mundo a falar com confiança. Preencha o formulário abaixo e entraremos em contato em breve.",
    demo_pricing_subtitle_pub: "Descubra como nossas soluções para o setor público podem melhorar as comunicações com aqueles que você atende. Preencha o formulário abaixo e entraremos em contato em breve.",
    demo_pricing_title: "Receba uma consulta gratuita",
    deutschland: "Deutschland",
    deutschland_url: "https://www.rosettastone.de/",
    download_pdf: "Baixar PDF",
    dutch: "Holandês",
    english: "Inglês",
    espana: "España",
    espana_url: "https://www.rosettastone.es/",
    europe: "Europa",
    europe_url: "https://www.rosettastone.eu/",
    facebook_url: "https://www.facebook.com/RosettaStoneLatino/",
    faq_url: "/pf",
    faqs: null,
    farsi: " (Farsi)",
    filipino: "Filipino",
    for_business: "Para Empresas",
    for_business_resources_url: "https://www.rosettastonebrasil.com/empresas/recursos/",
    for_business_solutions_url: "https://www.rosettastonebrasil.com/empresas/solucoes/",
    for_business_url: "https://www.rosettastonebrasil.com/empresas/inicial/",
    for_educators: "Para Educadores",
    for_educators_resources_url: "https://www.rosettastonebrasil.com/empresas/recursos/",
    for_educators_solutions_url: "https://www.rosettastonebrasil.com/educacaobasica/solucoes/",
    for_educators_url: "https://www.rosettastonebrasil.com/educacaobasica/inicial/",
    for_hed: "Para Educadores Superiores",
    for_homeschool: null,
    for_homeschool_url: null,
    for_individuals: null,
    for_individuals_url: "/demo",
    for_organizations: "Organizações",
    for_public_sector: null,
    for_public_sector_url: "/moveis",
    for_you: "Para Voce",
    form_100: "100 ou Menos",
    form_500: "101 - 500",
    form_1000: "501 - 1,000",
    form_5000: "1,001 - 5,000",
    form_10000: "5,001 - 10,000",
    form_25000: "10,001 - 25,000",
    form_50000: "25,001 - 50,000",
    form_boardmember: "Membro do Conselho",
    form_curriculumdirector: "Diretor de Currículo / Coordenador de Instrução",
    form_director: "Diretor",
    form_email: "Email",
    form_executive: "Gerência Geral / Executiva",
    form_firstname: "Nome",
    form_how_blog: "Blog",
    form_how_email: "O email",
    form_how_event: "Evento",
    form_how_online: "Conectados",
    form_how_other: "De outros",
    form_how_referral: "Referência",
    form_how_search: "Motor de pesquisa",
    form_how_social: "Mídia social",
    form_how_title: "Como você ficou sabendo sobre nós? (Opcional)",
    form_how_webinar: "Webinar",
    form_individualcontributor: "Contribuidor Individual",
    form_lastname: "Sobrenome",
    form_manager: "Gerente",
    form_more: "50,001 - Mais",
    form_organization: "Nome da Organização",
    form_organizationsize: "Tamanho da Organização",
    form_phone: "Número de Telefone (Opcional)",
    form_principal: "Diretor da Escola",
    form_privacy1: "A Rosetta Stone tem o compromisso de salvaguardar a sua privacidade. A nossa Política de Privacidade completa está disponível ",
    form_privacy2: "aqui.",
    form_privacy3: "Entendo que posso optar por não receber essas comunicações a qualquer momento clicando no link fornecido na comunicação ou entrando em contato com a Rosetta Stone em",
    form_privacy4: ".",
    form_privacyUrl: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf",
    form_privacyemail: "privacyofficer@rosettastone.com",
    form_role: "Função (ou título)",
    form_submit: "Consulta de preços",
    form_superintendent: "Superintendente / Administrador Distrital",
    form_teacher: "Professor",
    form_techcoordinator: "Coordenador de Tecnologia",
    form_updateagreement1: "Sim! Eu gostaria de receber atualizações de produtos e marketing da Rosetta Stone. Clique",
    form_updateagreement2: "aqui",
    form_updateagreement3: "para maiores informações.",
    form_vicepresident: "Vice Presidente",
    france: "France",
    france_url: "https://www.rosettastone.fr/",
    google_plus_url: "https://plus.google.com/105195149850491722010",
    greek: "Grego",
    gtm_id: null,
    has_combined_resources: true,
    has_resources: null,
    hebrew: "Hebraico",
    helpful_links: "Por favor, corrija o URL ou tente um destes links úteis:",
    hide_cart: true,
    hide_contact: true,
    hide_espanol: true,
    hide_language: true,
    hide_search: true,
    hide_support: null,
    hindi: "Hindi",
    home: "Inicial",
    home_link: "/inicial/",
    home_url: "https://www.rosettastone.com/",
    instagram_url: "https://www.instagram.com/rosettastone",
    investors: "Relações com Investidores",
    investors_url: "https://investors.rosettastone.com/",
    irish: "Irlandês",
    italia: "Italia",
    italia_url: "https://www.rosettastone.it/",
    item: "item",
    item_plural: "itens",
    japan: "日本",
    japan_url: "http://www.rosettastone.co.jp",
    japanese: "Japonês",
    k12_contact_title: "Educação - Consulta de Preços",
    keep_exploring: "Continue explorando",
    korea: "대한민국",
    korea_url: "https://www.rosettakorea.com/",
    korean: "Coreano",
    latin: null,
    latin_america: "(América latina)",
    latin_america_region: "America Latina",
    latin_america_region_url: "https://espanol.rosettastone.com/",
    learn_arabic_url: "/aprender-arabe/",
    learn_chinese: "Chinês",
    learn_chinese_url: "/aprenda-chines/",
    learn_dutch_url: "/aprender-holandes/",
    learn_english: "Aprender Inglês",
    learn_english_british_url: "/aprender-ingles/",
    learn_english_url: "/aprender-ingles/",
    learn_french: "Aprender Francês",
    learn_french_url: "/aprender-frances/",
    learn_german: "Aprende Alemão",
    learn_german_url: "/aprende-alemao/",
    learn_greek_url: "/aprenda-grego/",
    learn_hebrew_url: "/aprenda-hebraico/",
    learn_hindi_url: "/aprender-hindi/",
    learn_irish_url: "/aprenda-irlandes/",
    learn_italian: "Aprenda Italiano",
    learn_italian_url: "/aprenda-italiano/",
    learn_japanese_url: "/aprenda-japones/",
    learn_korean_url: "/aprender-coreano/",
    learn_latin_url: null,
    learn_more: "Saber mais",
    learn_persian_url: "/aprenda-persa/",
    learn_polish_url: "/aprenda-polones/",
    learn_portuguese_url: "/aprenda-portugues/",
    learn_russian_url: "/aprenda-russo/",
    learn_spanish: "Aprender espanhol",
    learn_spanish_spain_url: "/aprender-espanhol/",
    learn_spanish_url: "/aprender-espanhol-latino-americano/",
    learn_swedish_url: "/aprenda-sueco/",
    learn_tagalog_url: "/aprenda-tagalog/",
    learn_turkish_url: "/aprenda-turco/",
    learn_vietnamese_url: "/aprenda-vietnamita/",
    lexia_learning: null,
    lexia_learning_url: null,
    listen_now: "Ouça agora",
    madarin: "(Mandarim)",
    market: ["BR"],
    media_quote_1: "“Eu amo o programa Rosetta Stone e acho que",
    media_quote_1_bold: "o método deles de aprender idiomas funciona.”",
    media_quote_1_end: "”",
    media_quote_2: "“Com sua excelente interface para o usuário, instruções claras e uma ampla gama de jogos e desafios ...",
    media_quote_2_bold: "Rosetta Stone surpreende.",
    media_quote_2_end: "”",
    media_quote_3: "“",
    media_quote_3_bold: "A jóia da coroa",
    media_quote_3_end: "entre os métodos de aprendizado de idiomas”",
    more_resources_title: "Recursos adicionais",
    more_specify: "Por favor especifique",
    no_support_dropdown: true,
    persian: "Persa",
    polish: "Polonês",
    portuguese: "Português",
    press: null,
    press_url: "/pressione",
    pricing_subtitle: "Por favor, preencha e entraremos em contato imediatamente.",
    pricing_thanks: "Obrigado pelo seu interesse! Alguém entrará em contato com você em breve.",
    pricing_title: "Receba as informações  que você precisa sobre os preços.",
    privacy_policy: "Política de Privacidade",
    privacy_policy_url: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf",
    products: "Por onde começar?",
    questions_call: "Tem perguntas? Ligue para nós:",
    read_article: "Leia o artigo",
    read_case_study: "Saber mais",
    read_ebook: "Ler eBook",
    read_fact_sheet: "Saber mais",
    read_guide: "Leia o roteiro",
    read_more: "Saber mais",
    read_report: "Leia o relatório",
    read_white_paper: "Saber mais",
    related_resources_title: "Recursos Relacionados",
    request_pricing: "Consulta de Preços",
    resources: "Recursos",
    resources_link: "/recursos/",
    rosetta_copyright: "1999-2019 Rosetta Stone LLC. Todos os direitos reservados.",
    rosetta_stone: "Rosetta Stone",
    russian: "Russo",
    search: "Procurar...",
    search_rosetta_url: "https://search.rosettastone.com/",
    select_lang: "Selecione um idioma:",
    services: null,
    services_url: null,
    shop_now: null,
    sign_in: "Entrar",
    sign_in_url: "https://launch.rosettastone.com/pt/osub/authenticate",
    similar_resources: "Recursos Semelhantes",
    site_not_found: "Site não encontrado - 404",
    sitemap: null,
    sitemap_url: null,
    solutions: "Soluções",
    solutions_link: "/solucoes/",
    spain: "(Spain)",
    spanish: "Spanish",
    support: "Suporte",
    support_business_url: "https://support.rosettastone.com/pt/enterprises",
    support_chat: "Chat de suporte técnico ao vivo",
    support_chat_live: "Chat de suporte técnico ao vivo",
    support_chat_live_url: "https://rosettastone.secure.force.com/apex/PreLiveChatForm",
    support_chat_url: "https://support.rosettastone.com/pt/chat",
    support_classrooms: "Suporte para salas de aula e empresas:",
    support_faq_btn: "Visualizar todas as perguntas frequentes",
    support_faq_title: "Perguntas Frequentes",
    support_faq_url_1: "/pf#pquest1",
    support_faq_url_1_title: "XXX",
    support_faq_url_2: "/pf#pquest2",
    support_faq_url_2_title: "XXX",
    support_faq_url_3: "/faq#what-is-the-rosetta-stone-online-subscription",
    support_faq_url_3_title: "XXX",
    support_faq_url_4: "/faq#how-can-i-cancel-automatic-subscription-renewal",
    support_faq_url_4_title: "How do I cancel my Online Subscription?",
    support_for_you: "Pessoal",
    support_home: "Apoio",
    support_site: "Site de suporte",
    support_site_url: "https://support.rosettastone.com/pt/",
    swedish: "Sueco",
    switch_lang: "Español",
    switch_lang_url: "https://espanol.rosettastone.com/",
    system_reqs: null,
    system_reqs_url: "/requisitos-sistema",
    tagalog: " (Tagalog)",
    telephone_atr: "tel:+18007673882",
    telephone_text: "1-(800)-ROSETTA",
    terms_conditions: "Termos e Condições",
    terms_conditions_url: "https://resources.rosettastone.com/CDN/br/pdfs/br_terms_conditions.pdf",
    title: "br-copy",
    turkish: "Turco",
    twitter_url: "https://twitter.com/RosettaStoneUK",
    united_kingdom: "United Kingdom",
    united_kingdom_url: "https://www.rosettastone.co.uk/",
    united_states: "United States",
    united_states_url: "https://www.rosettastone.com",
    use_new_header: null,
    vertical: ["recECBjZxFEWVVls8"],
    vertical_business: "Empresas",
    vertical_business_link: "/empresas/inicial/",
    vertical_healthcare: null,
    vertical_healthcare_link: null,
    vertical_hed: "Ensino Superior",
    vertical_hed_link: "/ensino-superior/inicial/",
    vertical_k12: "Educação Basica",
    vertical_k12_link: "/educacaobasica/inicial/",
    vertical_pub: null,
    vertical_pub_link: null,
    verticals_subtitle: "Nossas soluções de idiomas premiadas funcionam para todos os tipos de alunos.",
    verticals_title: "Que tipo de aluno você é?",
    vietnamese: "Vietnamita",
    view_infographic: "Saber mais",
    watch_video: "Assista o vídeo",
    watch_webinar: "Assista ao Webinar",
    youtube_url: "https://www.youtube.com/user/rosettastone"
  };
});

var education_primary_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de resources | Rosetta Stone",
          meta_description: "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
          canonical_url: "https://pt.rosettastone.com/educacaobasica/recursos/",
          lang: "en"
        },
        content: {
          copyData: copyData(),
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$2({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$2({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de resources\n | Rosetta Stone",
          meta_description: "Recopilación de informa, infografías, videos, seminários web e mais sóbrios para a capacitação em idiomas é a opção correcta.\n",
          canonical_url: "https://pt.rosettastone.com/educacaobasica/recursos/",
          lang: "pt"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                src: null
              },
              title: {
                content: "Recursos",
                align: "left"
              },
              body: {
                content: "Deixe os alunos falarem por si mesmos"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    internal: true,
                    theme: "yellow_black",
                    size: "regular",
                    text: "Solicitar preços"
                  }
                }
              }
            }]
          },
          copyData: copyData(),
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$2({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$2({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Aprendizado de idiomas on-line para ensino fundamental e médio | Rosetta Stone",
          meta_description: "As soluções de aprendizado de idiomas da Rosetta Stone no ensino fundamental e médio se combinam com o ensino do professor em sala de aula e estão acessíveis sempre que os alunos desejarem aprender ou melhorar as habilidades de inglês ou outros idiomas.",
          canonical_url: "https://pt.rosettastone.com/educacaobasica/",
          lang: "pt"
        },
        content: {
          sections: [{
            panels: [{
              dataQa: "1",
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              },
              video: {
                currentVideoUrl: "https://vimeo.com/591688104",
                controls: true
              },
              direction: "content-right",
              title: {
                align: "left",
                content: "Torne o aprendizado de idiomas on-line.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              body: {
                content: "O objetivo é falar um novo idioma e os professores sabem que isso exige muita prática. A Rosetta Stone tem uma abordagem única que pode fazer com que os alunos falem inglês ou outro idioma desde o princípio. Dessa forma, estarão seguros e prontos para falar por si mesmos na sala de aula e fora dela."
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              body: {
                dataQa: "2",
                content: "Desde a primeira aula, cada palavra que o aluno ouve, fala e lê está no novo idioma. Isso é imersão, a abordagem mais natural de aprendizado de idiomas. Passando de palavras para expressões e frases, sem medo. Então, quando chegar o momento de perguntar e responder, os professores podem ter a segurança de que os alunos estarão prontos."
              },
              data_qa: "2",
              direction: "image-left",
              title: {
                dataQa: "2",
                content: "Proporcione aos alunos mais formas de aprender.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              link: {
                destination: "https://pt.rosettastone.com/educacaobasica/recursos/content/case-study-pueblo-city-schools/",
                theme: "black",
                align: "left"
              },
              quote: "“As crianças se concentram em tecnologia, então adoram usar o programa. O Programa Rosetta Stone permite que cheguemos a alunos aos quais não poderíamos chegar de nenhuma outra forma.”",
              attribution: "– Responsável por idiomas internacionais, Escolas da Cidade de Pueblo"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Diga adeus à timidez na fala.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "Falar um novo idioma pode soar estranho no começo. O medo de cometer um erro na sala de aula pode até fazer com que os alunos não falem absolutamente nada por timidez. O mecanismo de reconhecimento de voz TruAccent™ guia a pronúncia, sem fazer julgamentos, então o aprendizado do idioma acelera conforme cresce a segurança do aluno na fala."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://pt.rosettastone.com/educacaobasica/recursos/content/case-study-corona-norco-unified-school-district/",
                theme: "black",
                align: "left"
              },
              quote: "“O programa da Rosetta Stone aumenta a segurança oral dos alunos ao proporcionar oportunidades de praticar a audição da própria pronúncia e diminuir o seu filtro afetivo.”",
              attribution: "– Administrador de serviços educacionais do Departamento de Estudantes de Inglês, Distrito Escolar Unificado de Corona-Norco"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "As aulas ao vivo tornam a conversa real.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Os professores querem que os alunos se sintam à vontade ao falar no novo idioma. No entanto, é um grande salto do aprendizado de idiomas para o mundo real. As nossas sessões de aulas ao vivo proporcionam aos alunos a chance de praticar no seu próprio nível com falantes nativos. Isso faz da tutoria (aulas ao vivo) no nosso ambiente on-line seguro outra forma inteligente de aprender."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://pt.rosettastone.com/educacaobasica/recursos/content/customer-spotlight-bethel-public-schools/",
                theme: "black",
                align: "left"
              },
              quote: "“A resposta dos alunos ao programa tem sido extremamente positiva. A nossa sala de aula colaborativa parece mais uma família…”",
              attribution: "– Coordenadora de currículo e professora de espanhol, Bethel High School"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Os alunos podem aprender o idioma em qualquer lugar.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "As aulas com horários fixos ainda são a norma para os alunos. No entanto, as escolas também estão facilitando o aprendizado fora da sala de aula. O nosso aplicativo móvel permite que os alunos tenham acesso às lições e atividades sempre que for o momento certo. Isso proporciona a eles a liberdade de transformar qualquer momento em um momento de aprendizado."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://pt.rosettastone.com/educacaobasica/recursos/content/customer-spotlight-phoenix-union-high-school-district/",
                theme: "black",
                align: "left"
              },
              quote: "“Vemos que os alunos que seguem o programa da Rosetta Stone® ficam motivados e seguros, mais dispostos a participar das atividades em sala de aula e adquirem vocabulário a uma velocidade muito maior.”",
              attribution: "– Professora de estudantes de inglês, Distrito Escolar Unificado de Ensino Médio de Phoenix"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Inglês e outros idiomas de acordo com os objetivos dos alunos.",
                learner_feature_1_title: "24 idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Envolver o aluno pelo idioma acelera o aprendizado. ",
                learner_feature_2_title: "Imersão no ritmo do aluno",
                learner_feature_3_icon_name: "icon_games",
                learner_feature_3_subtitle: "Os alunos se divertem enquanto reforçam as lições que aprenderam.",
                learner_feature_3_title: "Jogos e atividades",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "É o auxiliar de pronúncia que qualquer aluno pode usar.",
                learner_feature_4_title: "Reconhecimento de voz TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Oferecidas em um ambiente on-line seguro no nível de cada aluno.",
                learner_feature_5_title: "Aulas ao vivo (tutoria)",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Coloca o acesso ao aprendizado nas mãos de cada aluno.",
                learner_feature_6_title: "Aplicativo móvel",
                learner_feature_title: "Características para o aluno do ensino fundamental e médio"
              }
            }]
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$2({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$2({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de aprendizado de idiomas on-line para ensino fundamental e médio | Rosetta Stone",
          meta_description: "Os programas de aprendizado de idiomas on-line da Rosetta Stone incentivam os alunos de inglês e outros idiomas a falar com segurança. Pergunte os preços.",
          canonical_url: "https://pt.rosettastone.com/educacaobasica/solucoes/",
          lang: "pt"
        },
        content: {
          sections: [{
            panels: [{
              width: "100%",
              video: {
                currentVideoUrl: "https://vimeo.com/594888236",
                controls: true
              },
              title: {
                heading: "h2",
                content: "As nossas soluções de aprendizado no ensino fundamental e médio apoiam qualquer aluno de idiomas.",
                align: "left"
              },
              body: {
                content: "Cada estudante tem a própria motivação para aprender um novo idioma. Um está fazendo um curso de inglês para principiantes e espera poder se comunicar com os colegas. Outro está em um curso de idioma estrangeiro na esperança de um dia ter a experiência de viver em outro país. Quaisquer que sejam os objetivos do aprendizado de idiomas, os alunos podem desenvolver a própria auto-confiança na fala com as nossas premiadas soluções de aprendizado no ensino fundamental e médio."
              },
              direction: "image-right",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                src: null
              },
              title: {
                heading: "h2",
                content: "Inclue os estudantes de inglês no programa de igualdade de oportunidades.",
                align: "left"
              },
              body: {
                content: "Alunos que falam pouco ou nada de inglês podem hesitar ao entrar na sala de aula. Essa sensação de isolamento pode continuar até que aprendam a falar inglês com segurança. O programa English for Education da Rosetta Stone® inclui recursos completos para os estudantes de inglês, seus professores e famílias. Isso se alinha aos programas de igualdade de oportunidades cujo objetivo é proporcionar a todos os alunos o mesmo acesso às ferramentas de aprendizado para o sucesso acadêmico."
              },
              direction: "image-left"
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                src: null
              },
              title: {
                heading: "h2",
                content: "Conecta os alunos a idiomas e culturas.",
                align: "left"
              },
              body: {
                content: "O interesse pode começar com um filme, livro ou amigo na internet ou um vizinho. Não importa como os alunos tomem consciência do mundo, a próxima etapa mais útil para eles é aprender um idioma internacional. Escolher um programa da Rosetta Stone para escolas ajuda os alunos a desenvolver as habilidades linguísticas que precisam para ir tão longe quanto os seus interesses globalizados os levarem."
              },
              direction: "image-right"
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                src: null
              },
              title: {
                heading: "h2",
                content: "Torne o aprendizado de inglês um esforço familiar.",
                align: "left"
              },
              body: {
                content: "Todos os dias na sala de aula contam quando os alunos estão dispostos a aprender. Para aqueles que também estão aprendendo inglês, é fundamental que continuem no caminho certo. O programa English for Education da Rosetta Stone® possibilita o envolvimento das famílias no aprendizado de inglês dos alunos. Este apoio envolvente ajuda os alunos a se conectarem mais rapidamente com professores e colegas e a atingir maior sucesso acadêmico."
              },
              direction: "image-left"
            }]
          }, {
            panels: [{
              data_qa: "4",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Ative o aprendizado com lições no ritmo do aluno e atividades no novo idioma que envolvem os alunos enquanto aprendem a falar, ler, escrever, ouvir e pensar de uma forma totalmente nova.",
                feature_1_title: "Imersão dinâmica. ",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "Feedback imediato da pronúncia guia o aluno a falar corretamente no novo idioma, tornando o aprendizado instantaneamente recompensador e estabelecendo a base para maior segurança na fala.",
                feature_2_title: "TruAccent. ",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Exercícios estruturados e conversas com falantes nativos se alinham com o nível atual de proficiência do aluno e ajudam a que se sinta à vontade para falar no novo idioma.",
                feature_3_title: "Aulas  ao vivo.",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Integra o inglês e outros idiomas em qualquer programa de idiomas para desenvolver e refinar as habilidades linguísticas de alunos de todos os níveis, de principiantes a avançados.",
                feature_4_title: "24 idiomas. ",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "O programa English for Education inclui recursos semanais para ajudar as famílias a desenvolver juntas o domínio de inglês e webinars mensais em portuguêsl realçando o apoio familiar para os aprendizes de inglês.",
                feature_5_title: "Recursos para a conexão das famílias. ",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Guias do professor, livros de exercícios e guias para atividades off-line em sala de aula  proporcionam aos professores recursos que apoiam o ensino na sala de aula e complementam as lições on-line.",
                feature_6_title: "Ferramentas para a sala de aula. ",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "O programa English for Education inclui um teste de nivelamento e progresso para alunos do ensino fundamental II e médio para permitir que os professores determinem o ponto de partida do aprendizado de inglês para cada aluno.",
                feature_7_title: "Testes. ",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Os alunos interagem instantaneamente com conteúdos ricos que se adaptam ao ritmo e progresso de cada um em  ambiente interativo que se concentra em alunos que estão aprendendo a falar.",
                feature_8_title: "Conteúdo básico e avançado. ",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Reforçam vocabulário, gramática e pronúncia de formas divertidas e envolventes que desenvolvem as habilidades de leitura, compreensão oral e fala.",
                feature_9_title: "Jogos e atividades. ",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Atividades para alunos de todos os níveis incluem leitura em voz alta com feedback instantâneo da pronúncia, escrita para fins específicos e compreensão oral e de leitura.",
                feature_10_title: "Leitura e escrita. ",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Permitem que os alunos usem smartphones e tablets dentro e fora da sala de aula para acessar lições e atividades que aumentam a retenção de habilidades e o vocabulário.",
                feature_11_title: "Aplicativos móveis. ",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Uma visão instantânea do desempenho de indivíduos, grupos e classes com acompanhamento do progresso de uso e proficiência que permite que professores e administradores facilmente relatem os resultados dos alunos.",
                feature_12_title: "Ferramentas de relatório. ",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "O gerenciamento simplificado de licenças permite que professores e administradores rapidamente redistribuam os alunos, assegurando que todas as licenças estejam em uso e apoiando o ROI do programa.",
                feature_13_title: "Licenças transferíveis. ",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "A nossa equipe incorpora objetivos de aprendizado de idiomas a modelos eficazes e auxilia no planejamento, implantação e promoção do programa em escolas e redes de ensino. ",
                feature_14_title: "Apoio para a implementação. ",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Níveis de treinamento para administradores e professores estão disponíveis para contribuir para o sucesso no lançamento do programa de maneira que se combine efetivamente com o ensino do professor na sala de aula.",
                feature_15_title: "Serviços de treinamento.",
                feature_section_title: "Todos os recursos que você precisa estão ao seu alcance."
              }
            }]
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$2({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$2({
            strings: strings
          })
        }
      };

    case "solicitacao-de-precos":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitação de preços | Rosetta Stone",
          meta_description: "Serviços profissionais e empresas de consultoria do mundo todo enfrentam barreiras linguísticas que limitam sua capacidade de atender aos clientes, engajar funcionários e expandir seus negócios globalmente. As soluções de treinamento em idiomas ajudam as empresas de consultoria profissional a maximizar as horas faturáveis por funcionário — o que comprova o ROI significativo de nosso treinamento em idiomas em toda a organização.",
          canonical_url: "https://pt.rosettastone.com/educacaobasica/solicitacao-de-precos/",
          lang: "pt"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Marque um horário com um especialista no aprendizado de idiomas hoje mesmo."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Preencha o formulário abaixo para agendar um horário para discutir como podemos ajudar você."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Você está quase lá!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nome",
                required: true,
                required_error: "Insira seu nome."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Sobrenome",
                required: true,
                required_error: "Insira seu sobrenome."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Endereço de email",
                required: true,
                required_error: "Insira seu endereço de email.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Telefone",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Insira o nome da sua empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamanho da empresa",
                required: true,
                required_error: "Insira o tamanho da empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 ou Menos",
                  label: "100 ou Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 ou Mais",
                  label: "50,001 ou Mais"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Cargo",
                required: true,
                required_error: "Insira seu cargo."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar preços"
            },
            labels: {
              form_privacy1: "A Rosetta Stone tem o compromisso de salvaguardar a sua privacidade. A nossa Política de Privacidade completa está disponível ",
              form_privacy2: "aqui.",
              form_privacy3: "Entendo que posso optar por não receber essas comunicações a qualquer momento clicando no link fornecido na comunicação ou entrando em contato com a Rosetta Stone em",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Sim! Eu gostaria de receber atualizações de produtos e marketing da Rosetta Stone. Clique",
              form_updateagreement2: "aqui",
              form_updateagreement3: "para maiores informações."
            },
            domain: ".br",
            dataQaLocation: "page"
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$2({
            strings: strings
          })
        }
      };

    case "solicitacao-de-precos-concluida":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitação de preços concluída | Rosetta Stone",
          meta_description: "Serviços profissionais e empresas de consultoria do mundo todo enfrentam barreiras linguísticas que limitam sua capacidade de atender aos clientes, engajar funcionários e expandir seus negócios globalmente. As soluções de treinamento em idiomas ajudam as empresas de consultoria profissional a maximizar as horas faturáveis por funcionário — o que comprova o ROI significativo de nosso treinamento em idiomas em toda a organização.",
          canonical_url: "https://pt.rosettastone.com/educacaobasica/solicitacao-de-precos-conlcuida/",
          lang: "pt"
        },
        content: {
          title: {
            align: "center",
            content: "Agradecemos seu interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Confira alguns resources adicionais antes da sua reunião.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$2({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_primary_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://pt.rosettastone.com/educacaobasica/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/ensino-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/empresas/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/contato/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/pt/school/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: false,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://pt.rosettastone.com/termos/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://pt.rosettastone.com/privacidade/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_secondary_nav_secondary_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: null,
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/solucoes/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_solutions_label,
      options: null
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_label
    }
  };
});

var lead_generation_bar$1 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitacao-de-precos/",
        new_window: false,
        size: "regular",
        text: "Solicitar preços",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.verticals_education_primary,
        src: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacaobasica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_education_secondary,
        src: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/ensino-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_enterprise,
        src: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var education_secondary_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de resources | Rosetta Stone",
          meta_description: "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
          canonical_url: "https://pt.rosettastone.com/ensino-superior/recursos/",
          lang: "pt"
        },
        content: {
          copyData: copyData(),
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$1({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$1({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de resources | Rosetta Stone",
          meta_description: "Recopilación de informa, infografías, videos, seminários web e mais sóbrios para a capacitação em idiomas é a opção correcta.\n",
          canonical_url: "https://pt.rosettastone.com/ensino-superior/recursos/",
          lang: "pt"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                src: null
              },
              title: {
                content: "Recursos",
                align: "left"
              },
              body: {
                content: "Deixe os alunos falarem por si mesmos"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    internal: true,
                    theme: "yellow_black",
                    size: "regular",
                    text: "Solicitar preços"
                  }
                }
              }
            }]
          },
          copyData: copyData(),
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$1({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$1({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Aprendizado de idiomas on-line no ensino superior | Rosetta Stone",
          meta_description: "As soluções de aprendizado de idiomas da Rosetta Stone no ensino superior oferece aos alunos acesso on-line instantâneo para o aprendizado de inglês e outros idiomas. Solicite informações.",
          canonical_url: "https://pt.rosettastone.com/ensino-superior/",
          lang: "pt"
        },
        content: {
          sections: [{
            panels: [{
              dataQa: "1",
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              },
              video: {
                currentVideoUrl: "https://vimeo.com/591688104",
                controls: true
              },
              direction: "content-right",
              title: {
                align: "left",
                content: "Coloque o aprendizado de idiomas ao alcance de todos os alunos.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              body: {
                content: "Os alunos criam conexões globais deslizando o dedo no smartphone. No entanto, as instituições de ensino enfrentam restrições no orçamento para cursos de idiomas. Isso limita as possíveis opções acadêmicas e profissionais, assim como a visão de mundo dos alunos. Em uma economia global, habilidades linguísticas em idiomas internacionais são uma exigência para o trabalho no século XXI."
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              body: {
                dataQa: "2",
                content: "Diversos alunos do ensino superior podem passar em um teste padrão de proficiência em língua inglesa. No entanto, as habilidades linguísticas necessárias para o sucesso no mundo acadêmico frequentemente são muito diferentes. As soluções de aprendizado de idiomas da Rosetta Stone ajudam a desenvolver a segurança dos alunos estrangeiros com o inglês e a prepará-los para o sucesso."
              },
              data_qa: "2",
              direction: "image-left",
              title: {
                dataQa: "2",
                content: "Acelere o aprendizado de inglês.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              link: {
                destination: "https://pt.rosettastone.com/ensino-superior/recursos/content/case-study-northern-border-university/",
                theme: "black",
                align: "left"
              },
              quote: "“Nesta era da internet, com o inglês sendo o idioma global, os alunos precisam dominar o idioma para que tenham auto-confiança e sejam competitivos nos estudos agora e mais adiante na carreira.”",
              attribution: "– Chefe da reitoria de ano preparatório e estudos de apoio, Northern Border University"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "O aprendizado de idiomas on-line combina com o estilo de vida dos alunos.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "Cultura, entretenimento, esportes e literatura agora estão a apenas um clique de distância. A incorporação de um programa da Rosetta Stone no currículo de ensino de idiomas proporciona aos alunos acesso on-line ilimitado a orientações de pronúncia e prática de fala que não é possível durante as horas de aula."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://pt.rosettastone.com/ensino-superior/recursos/content/etudo-de-caso-liberty-university/",
                theme: "black",
                align: "left"
              },
              quote: "“Após o teste piloto dos cursos de conversação, os alunos fizeram a entrevista de proficiência oral (OPIc) do Conselho Americano de Ensino de Idiomas Estrangeiros (ACTFL). Depois de apenas um semestre de estudo, os alunos dos cursos básicos tiveram resultados pelo menos no nível pré-intermediário na OPIc.”",
              attribution: "– Chefe de departamento na Faculdade de Estudos Gerais, Liberty University"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "A aula ao vivo faz com que os alunos de idiomas falem.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Alunos, professores e funcionários querem se sentir à vontade falando um novo idioma. Passar do aprendizado de idiomas para o mundo real exige prática. As sessões de aulas ao vivo permitem que os alunos pratiquem no seu próprio nível com falantes nativos. Isso faz da aula ao vivo no nosso ambiente on-line seguro outra forma inteligente de aprender."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://pt.rosettastone.com/ensino-superior/recursos/content/case-study-canterbury-christ-church-university/",
                theme: "black",
                align: "left"
              },
              quote: "“As soluções da Rosetta Stone são uma excelente ferramenta para ajudar os participantes a avaliar o próprio nível e a ter acesso a uma gama de experiências de aprendizado interativas e diversificadas que promovem o progresso independente.”",
              attribution: "– Coordenador de cursos, Canterbury Christ Church University"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "O laboratório de idiomas passa para a nuvem.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Aplicativos móveis enriquecem o ensino para que o aprendizado de idiomas possa ocorrer em qualquer lugar, a qualquer hora. Os alunos têm maior flexibilidade e acesso aos materiais do curso, enquanto os professores podem concentrar o período de aulas na orientação individual e atividades colaborativas de aprendizado."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://pt.rosettastone.com/ensino-superior/recursos/content/case-study-humboldt-state-university/",
                theme: "black",
                align: "left"
              },
              quote: "“[O teste de nivelamento adaptativo realizado no início do semestre e novamente no final] permite que os alunos saibam onde começaram e quanto progrediram no processo de aprendizado do idioma.”",
              attribution: "– Diretor do laboratório de cultura e idiomas internacionais, Humboldt State University"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Inglês e outros idiomas de acordo com os objetivos dos alunos.",
                learner_feature_1_title: "24 idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Envolver o aluno pelo idioma acelera o aprendizado. ",
                learner_feature_2_title: "Imersão no ritmo do aluno",
                learner_feature_3_icon_name: "icon_games",
                learner_feature_3_subtitle: "Os alunos se divertem enquanto reforçam as lições que aprenderam.",
                learner_feature_3_title: "Jogos e atividades",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "É o auxiliar de pronúncia que qualquer aluno pode usar.",
                learner_feature_4_title: "Reconhecimento de voz TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Oferecida em um ambiente on-line seguro no nível de cada aluno.",
                learner_feature_5_title: "Aula ao vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Coloca o acesso ao aprendizado nas mãos de cada aluno.",
                learner_feature_6_title: "Aplicativo para dispositivo móvel",
                learner_feature_title: "Online ou offline, nosso aplicativo premiado fala por si."
              }
            }]
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$1({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$1({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de aprendizado de idiomas on-line para ensino fundamental e médio | Rosetta Stone",
          meta_description: "Os programas de aprendizado de idiomas on-line da Rosetta Stone incentivam os alunos de inglês e outros idiomas a falar com segurança. Pergunte os preços.",
          canonical_url: "https://pt.rosettastone.com/ensino-superior/solucoes/",
          lang: "pt"
        },
        content: {
          sections: [{
            panels: [{
              width: "100%",
              video: {
                currentVideoUrl: "https://vimeo.com/594888236",
                controls: true
              },
              title: {
                heading: "h2",
                content: "As nossas soluções de aprendizado no ensino fundamental e médio apoiam qualquer aluno de idiomas.",
                align: "left"
              },
              body: {
                content: "Cada estudante tem a própria motivação para aprender um novo idioma. Um está fazendo um curso de inglês para principiantes e espera poder se comunicar com os colegas. Outro está em um curso de idioma estrangeiro na esperança de um dia ter a experiência de viver em outro país. Quaisquer que sejam os objetivos do aprendizado de idiomas, os alunos podem desenvolver a própria auto-confiança na fala com as nossas premiadas soluções de aprendizado no ensino fundamental e médio."
              },
              direction: "image-right",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                src: null
              },
              title: {
                heading: "h2",
                content: "Inclue os estudantes de inglês no programa de igualdade de oportunidades.",
                align: "left"
              },
              body: {
                content: "Alunos que falam pouco ou nada de inglês podem hesitar ao entrar na sala de aula. Essa sensação de isolamento pode continuar até que aprendam a falar inglês com segurança. O programa English for Education da Rosetta Stone® inclui recursos completos para os estudantes de inglês, seus professores e famílias. Isso se alinha aos programas de igualdade de oportunidades cujo objetivo é proporcionar a todos os alunos o mesmo acesso às ferramentas de aprendizado para o sucesso acadêmico."
              },
              direction: "image-left"
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                src: null
              },
              title: {
                heading: "h2",
                content: "Conecta os alunos a idiomas e culturas.",
                align: "left"
              },
              body: {
                content: "O interesse pode começar com um filme, livro ou amigo na internet ou um vizinho. Não importa como os alunos tomem consciência do mundo, a próxima etapa mais útil para eles é aprender um idioma internacional. Escolher um programa da Rosetta Stone para escolas ajuda os alunos a desenvolver as habilidades linguísticas que precisam para ir tão longe quanto os seus interesses globalizados os levarem."
              },
              direction: "image-right"
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                src: null
              },
              title: {
                heading: "h2",
                content: "Torne o aprendizado de inglês um esforço familiar.",
                align: "left"
              },
              body: {
                content: "Todos os dias na sala de aula contam quando os alunos estão dispostos a aprender. Para aqueles que também estão aprendendo inglês, é fundamental que continuem no caminho certo. O programa English for Education da Rosetta Stone® possibilita o envolvimento das famílias no aprendizado de inglês dos alunos. Este apoio envolvente ajuda os alunos a se conectarem mais rapidamente com professores e colegas e a atingir maior sucesso acadêmico."
              },
              direction: "image-left"
            }]
          }, {
            panels: [{
              data_qa: "4",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Ative o aprendizado com lições no ritmo do aluno e atividades no novo idioma que envolvem os alunos enquanto aprendem a falar, ler, escrever, ouvir e pensar de uma forma totalmente nova.",
                feature_1_title: "Imersão dinâmica. ",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "Feedback imediato da pronúncia guia o aluno a falar corretamente no novo idioma, tornando o aprendizado instantaneamente recompensador e estabelecendo a base para maior segurança na fala.",
                feature_2_title: "TruAccent. ",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Exercícios estruturados e conversas com falantes nativos se alinham com o nível atual de proficiência do aluno e ajudam a que se sinta à vontade para falar no novo idioma.",
                feature_3_title: "Aulas  ao vivo.",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Integra o inglês e outros idiomas em qualquer programa de idiomas para desenvolver e refinar as habilidades linguísticas de alunos de todos os níveis, de principiantes a avançados.",
                feature_4_title: "24 idiomas. ",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "O programa English for Education inclui recursos semanais para ajudar as famílias a desenvolver juntas o domínio de inglês e webinars mensais em portuguêsl realçando o apoio familiar para os aprendizes de inglês.",
                feature_5_title: "Recursos para a conexão das famílias. ",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Guias do professor, livros de exercícios e guias para atividades off-line em sala de aula  proporcionam aos professores recursos que apoiam o ensino na sala de aula e complementam as lições on-line.",
                feature_6_title: "Ferramentas para a sala de aula. ",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "O programa English for Education inclui um teste de nivelamento e progresso para alunos do ensino fundamental II e médio para permitir que os professores determinem o ponto de partida do aprendizado de inglês para cada aluno.",
                feature_7_title: "Testes. ",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Os alunos interagem instantaneamente com conteúdos ricos que se adaptam ao ritmo e progresso de cada um em  ambiente interativo que se concentra em alunos que estão aprendendo a falar.",
                feature_8_title: "Conteúdo básico e avançado. ",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Reforçam vocabulário, gramática e pronúncia de formas divertidas e envolventes que desenvolvem as habilidades de leitura, compreensão oral e fala.",
                feature_9_title: "Jogos e atividades. ",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Atividades para alunos de todos os níveis incluem leitura em voz alta com feedback instantâneo da pronúncia, escrita para fins específicos e compreensão oral e de leitura.",
                feature_10_title: "Leitura e escrita. ",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Permitem que os alunos usem smartphones e tablets dentro e fora da sala de aula para acessar lições e atividades que aumentam a retenção de habilidades e o vocabulário.",
                feature_11_title: "Aplicativos móveis. ",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Uma visão instantânea do desempenho de indivíduos, grupos e classes com acompanhamento do progresso de uso e proficiência que permite que professores e administradores facilmente relatem os resultados dos alunos.",
                feature_12_title: "Ferramentas de relatório. ",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "O gerenciamento simplificado de licenças permite que professores e administradores rapidamente redistribuam os alunos, assegurando que todas as licenças estejam em uso e apoiando o ROI do programa.",
                feature_13_title: "Licenças transferíveis. ",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "A nossa equipe incorpora objetivos de aprendizado de idiomas a modelos eficazes e auxilia no planejamento, implantação e promoção do programa em escolas e redes de ensino. ",
                feature_14_title: "Apoio para a implementação. ",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Níveis de treinamento para administradores e professores estão disponíveis para contribuir para o sucesso no lançamento do programa de maneira que se combine efetivamente com o ensino do professor na sala de aula.",
                feature_15_title: "Serviços de treinamento.",
                feature_section_title: "Todos os recursos que você precisa estão ao seu alcance."
              }
            }]
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$1({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$1({
            strings: strings
          })
        }
      };

    case "solicitacao-de-precos":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitação de preços | Rosetta Stone",
          meta_description: "Serviços profissionais e empresas de consultoria do mundo todo enfrentam barreiras linguísticas que limitam sua capacidade de atender aos clientes, engajar funcionários e expandir seus negócios globalmente. As soluções de treinamento em idiomas ajudam as empresas de consultoria profissional a maximizar as horas faturáveis por funcionário — o que comprova o ROI significativo de nosso treinamento em idiomas em toda a organização.",
          canonical_url: "https://pt.rosettastone.com/ensino-superior/solicitacao-de-precos/",
          lang: "pt"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Marque um horário com um especialista no aprendizado de idiomas hoje mesmo."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Preencha o formulário abaixo para agendar um horário para discutir como podemos ajudar você."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Você está quase lá!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nome",
                required: true,
                required_error: "Insira seu nome."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Sobrenome",
                required: true,
                required_error: "Insira seu sobrenome."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Endereço de email",
                required: true,
                required_error: "Insira seu endereço de email.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Telefone",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Insira o nome da sua empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamanho da empresa",
                required: true,
                required_error: "Insira o tamanho da empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 ou Menos",
                  label: "100 ou Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 ou Mais",
                  label: "50,001 ou Mais"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Cargo",
                required: true,
                required_error: "Insira seu cargo."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar preços"
            },
            labels: {
              form_privacy1: "A Rosetta Stone tem o compromisso de salvaguardar a sua privacidade. A nossa Política de Privacidade completa está disponível ",
              form_privacy2: "aqui.",
              form_privacy3: "Entendo que posso optar por não receber essas comunicações a qualquer momento clicando no link fornecido na comunicação ou entrando em contato com a Rosetta Stone em",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Sim! Eu gostaria de receber atualizações de produtos e marketing da Rosetta Stone. Clique",
              form_updateagreement2: "aqui",
              form_updateagreement3: "para maiores informações."
            },
            domain: ".br",
            dataQaLocation: "page"
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$1({
            strings: strings
          })
        }
      };

    case "solicitacao-de-precos-concluida":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitação de preços concluída | Rosetta Stone",
          meta_description: "Serviços profissionais e empresas de consultoria do mundo todo enfrentam barreiras linguísticas que limitam sua capacidade de atender aos clientes, engajar funcionários e expandir seus negócios globalmente. As soluções de treinamento em idiomas ajudam as empresas de consultoria profissional a maximizar as horas faturáveis por funcionário — o que comprova o ROI significativo de nosso treinamento em idiomas em toda a organização.",
          canonical_url: "https://pt.rosettastone.com/ensino-superior/solicitacao-de-precos-conluida/",
          lang: "pt"
        },
        content: {
          title: {
            align: "center",
            content: "Agradecemos seu interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Confira alguns resources adicionais antes da sua reunião.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$1({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_secondary_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://pt.rosettastone.com/educacaobasica/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/ensino-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/empresas/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/contato/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/pt/school",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: false,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://pt.rosettastone.com/termos/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://pt.rosettastone.com/privacidade/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: null,
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: "/solucoes/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label,
      options: null
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label
    }
  };
});

var lead_generation_bar = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitacao-de-precos/",
        new_window: false,
        size: "regular",
        text: "Solicitar preços",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        type: "static",
        alt: strings.verticals_education_primary,
        src: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacaobasica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_education_secondary,
        src: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/ensino-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        type: "static",
        alt: strings.verticals_enterprise,
        src: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var enterprise_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de resources | Rosetta Stone",
          meta_description: "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
          canonical_url: "https://pt.rosettastone.com/empresas/recursos/",
          lang: "pt"
        },
        content: {
          copyData: copyData(),
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de resources | Rosetta Stone",
          meta_description: "Recopilación de informa, infografías, videos, seminários web e mais sóbrios para a capacitação em idiomas é a opção correcta.\n",
          canonical_url: "https://pt.rosettastone.com/empresas/recursos/",
          lang: "pt"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                src: null
              },
              title: {
                content: "Recursos",
                align: "left"
              },
              body: {
                content: "Deixe os alunos falarem por si mesmos"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          copyData: copyData(),
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Treinamento em idiomas para negócios | Rosetta Stone",
          meta_description: "As soluções de treinamento da Rosetta Stone ajudam os funcionários a desenvolver as habilidades linguísticas para os negócios em inglês e em diversos idiomas requisitados para os negócios. Solicite informações.",
          canonical_url: "https://pt.rosettastone.com/empresas/",
          lang: "pt"
        },
        content: {
          sections: [{
            panels: [{
              dataQa: "1",
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              },
              video: {
                currentVideoUrl: "https://resources.rosettastone.com/CDN/us/rs-i-demo-6/demos/br-en/movies/RS-BrazilVO-English-Demo-480p.mp4",
                controls: true
              },
              direction: "content-right",
              title: {
                align: "left",
                content: "Saber idiomas para os negócios permite que os funcionários se expressem.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              body: {
                content: "Aprender novos idiomas para os negócios exige prática. A Rosetta Stone faz com que os profissionais falem e aperfeiçoem a pronúncia imediatamente. Dessa forma, estarão prontos para falar por si mesmos e pela sua empresa sem perda de tempo."
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    src: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    src: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              body: {
                dataQa: "2",
                content: "Os funcionários aprendem melhor quando tudo o que ouvem, falam, leem e escrevem está no novo idioma. É isso que o nosso método de Dynamic Immersion® proporciona, desenvolvendo a segurança no idioma desde a primeira aula."
              },
              data_qa: "2",
              direction: "image-left",
              title: {
                dataQa: "2",
                content: "Aprenda naturalmente.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/hitachi-data-systems-estudo-de-caso/",
                theme: "black",
                align: "left"
              },
              quote: "“A Rosetta Stone ajuda a romper barreiras e a impulsionar o engajamento dos funcionários.”",
              attribution: "– Vice-Presidente de Aprendizado e Colaboração, Hitachi Data Systems"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Comece a falar.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "O medo de errar pode fazer com que os alunos sintam timidez de falar em um novo idioma. O nosso mecanismo de reconhecimento de voz TruAccent™ permite que os funcionários equilibrem a própria pronúncia, então terão mais segurança quando chegar na hora de discutir negócios."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/e-on/",
                theme: "black",
                align: "left"
              },
              quote: "“Os principais benefícios do ensino de idiomas da Rosetta Stone são a capacidade de aprender a qualquer hora, em qualquer lugar, no seu próprio ritmo…”",
              attribution: "– Diretor de R.H., Código de Conduta e Aprendizado Global, E.ON"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Seja ouvido.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "É um grande salto das aulas para falar com colegas de trabalho e clientes. As sessões de aulas ao vivo com falantes nativos proporcionam prática de conversação para que os alunos falem naturalmente no novo idioma."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/case-study-kimberly-clark-corporation/",
                theme: "black",
                align: "left"
              },
              quote: "“Observamos uma economia significativa com a implementação de um programa em toda a empresa…”",
              attribution: "– Consultor Sênior de Gestão de Talentos, Kimberly-Clark Corporation"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Passe para os dispositivos móveis.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "É difícil encontrar tempo para sentar em uma sala de aula para estudar um idioma. Os nossos aplicativos móveis oferecem aos alunos acesso a lições e atividades sempre que for o momento certo. Dessa forma, qualquer momento livre pode se tornar uma excelente oportunidade de aprendizado."
              },
              image: {
                src: null
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/tripadvisor-com-case-study/",
                theme: "black",
                align: "left"
              },
              quote: "“ADORO! A Rosetta Stone permite que eu aprenda um novo idioma sozinho no meu próprio ritmo de aprendizado fora do horário de trabalho.”",
              attribution: "– Funcionário da TripAdvisor em Singapura"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Há um idioma que corresponde aos objetivos de cada funcionário.",
                learner_feature_1_title: "24 idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Estar cercado por um idioma é a forma mais rápida de aprender.",
                learner_feature_2_title: "Imersão no ritmo do aluno",
                learner_feature_3_icon_name: "icon_foundational",
                learner_feature_3_subtitle: "As lições acompanham o ritmo dos alunos, não o contrário.",
                learner_feature_3_title: "Conteúdo envolvente",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Os funcionários podem verificar a própria pronúncia  a  qualquer momento.",
                learner_feature_4_title: "Reconhecimento de voz TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Conversar com falantes nativos é um sinal claro de sucesso.",
                learner_feature_5_title: "Aulas ao vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Para aprender e praticar basta passar o dedo.",
                learner_feature_6_title: "Aplicativo para dispositivo móvel",
                learner_feature_title: "Receba as informações que você precisa sobre valores."
              }
            }]
          }, {
            panels: [{
              pageData: {
                admin_feature_1_icon_name: "icon_placement",
                admin_feature_1_subtitle: "Faz a correspondência entre os objetivos e quão rápido os alunos desejam atingi-los. ",
                admin_feature_1_title: "Nivelamento personalizado",
                admin_feature_2_icon_name: "icon_assessments",
                admin_feature_2_subtitle: "Descobrir o que os funcionários sabem é o melhor ponto de partida.",
                admin_feature_2_title: "Avaliação",
                admin_feature_3_icon_name: "icon_proficiency",
                admin_feature_3_subtitle: "Utilizado no início e durante o programa para acompanhar o progresso.",
                admin_feature_3_title: "Testes de proficiência em inglês",
                admin_feature_4_icon_name: "icon_reporting",
                admin_feature_4_subtitle: "Relatórios de desempenho dos alunos em tempo real ajudam a medir o ROI.",
                admin_feature_4_title: "Relatórios",
                admin_feature_5_icon_name: "icon_implementation",
                admin_feature_5_subtitle: "Serviços especializados ajudam os administradores a fazer com que os alunos comecem bem.",
                admin_feature_5_title: "Apoio para a implementação",
                admin_feature_6_icon_name: "icon_training",
                admin_feature_6_subtitle: "Personalizados para o tamanho e as necessidades da sua organização.",
                admin_feature_6_title: "Treinamento",
                admin_feature_title: "Características para o administrador de alunos"
              }
            }]
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de aprendizado de idiomas on-line para ensino fundamental e médio | Rosetta Stone",
          meta_description: "Os programas de aprendizado de idiomas on-line da Rosetta Stone incentivam os alunos de inglês e outros idiomas a falar com segurança. Pergunte os preços.",
          canonical_url: "https://pt.rosettastone.com/empresas/solucoes/",
          lang: "pt"
        },
        content: {
          sections: [{
            panels: [{
              width: "100%",
              align: "left",
              image: {
                src: null
              },
              title: {
                heading: "h2",
                content: "Novas habilidades nos idiomas de negócios fazem com que seja possível trabalhar juntos.",
                align: "left"
              },
              body: {
                content: "As lacunas linguísticas fazem com que boas ideias deixem de ser faladas ou não fiquem claras. Com o Catalyst™ da Rosetta Stone®, os funcionários desenvolvem habilidades linguísticas que transformam sinais contraditórios em uma comunicação clara com colegas de trabalho e clientes."
              },
              quote: "“Realmente acredito que é um benefício enorme para o aluno, assim como para uma corporação global como a Amgen.”",
              attribution: "Gerente de Desempenho Empresarial, Amgen",
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/amgen-client-spotlight/",
                align: "left",
                theme: "black"
              },
              direction: "image-right",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                src: null
              },
              title: {
                heading: "h2",
                content: "Aumente a produtividade.",
                align: "left"
              },
              body: {
                content: "A comunicação com os colegas de trabalho é fundamental. Com o treinamento do Catalyst, as instruções ficam claras, os funcionários ouvem e entendem as diretivas e há menos erros. Isso melhora significativamente qualidade do trabalho realizado."
              },
              quote: "Leia o Snaphot",
              attribution: "",
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/language-training-productivity-ebook-snapshot/",
                align: "left",
                theme: "black"
              },
              direction: "image-left"
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                src: null
              },
              title: {
                heading: "h2",
                content: "Globalize.",
                align: "left"
              },
              body: {
                content: "Depender de fornecedores de idiomas locais com abordagens distintas produz resultados caros e desiguais. O Catalyst oferece de maneira eficaz a mesma experiência de aprendizado premiada para os seus funcionários em qualquer lugar do mundo, 24 horas por dia."
              },
              quote: "Veja a planilha de dados",
              attribution: "",
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/meet-global-challenges/",
                align: "left",
                theme: "black"
              },
              direction: "image-right"
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                src: null
              },
              title: {
                heading: "h2",
                content: "Atraia o talento.",
                align: "left"
              },
              body: {
                content: "A maioria dos candidatos busca por oportunidade de desenvolvimento. A oportunidade de aprender um novo idioma utilizando o Catalyst será um diferencial em sua oferta de trabalho aos profissionais que concorrem a oportunidades de trabalho em sua empresa e também um fator de retenção de talentos."
              },
              quote: "Leia o roteiro",
              attribution: "",
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/rosetta-playbook-september-2017-final-web/",
                align: "left",
                theme: "black"
              },
              direction: "image-left"
            }]
          }, {
            panels: [{
              data_qa: "4",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Ative o aprendizado com lições no ritmo do aluno e atividades no novo idioma que circundam os alunos enquanto aprendem a falar, ler, escrever, ouvir e pensar de uma forma totalmente nova.",
                feature_1_title: "Imersão dinâmica.",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "Feedback imediato da pronúncia guia o aluno a falar corretamente no novo idioma, tornando o aprendizado instantaneamente recompensador e estabelecendo a base para maior segurança na fala.",
                feature_2_title: "TruAccent. ",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Exercícios estruturados e conversas com falantes nativos se alinham com o nível atual de proficiência do aluno e ajudam a que se sinta à vontade para falar no novo idioma.",
                feature_3_title: "Tutoria ao vivo. ",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Integre o inglês e outros idiomas em qualquer programa de idiomas para desenvolver e refinar as habilidades linguísticas de alunos de todos os níveis, de principiantes a avançados.",
                feature_4_title: "24 idiomas. ",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "Os pré-testes em inglês, espanhol e francês e outras autoavaliações em idiomas do mundo identificam necessidades diversas de idiomas e garantem que o treinamento seja produtivo desde o início.",
                feature_5_title: "Assessments. ",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Recomenda um caminho de aprendizado de idiomas adaptado para cada funcionário com base nas metas e proficiência do aluno, oferecendo o nível certo de desafio e engajamento.",
                feature_6_title: "Colocação do aprendiz.",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "Avalie as habilidades de leitura e compreensão auditiva para determinar a proficiência linguística usando a escala do Quadro Europeu Comum de Referência (QECR).",
                feature_7_title: "Testes de proficiência em inglês, espanhol e francês",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Os alunos interagem instantaneamente com conteúdos ricos que se adaptam ao ritmo e progresso de cada aluno em um ambiente interativo que se concentra em alunos que estão aprendendo a falar.",
                feature_8_title: "Conteúdo básico e avançado. ",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Reforçam vocabulário, gramática e pronúncia de formas divertidas e envolventes que desenvolvem as habilidades de leitura, compreensão oral e fala dos alunos. ",
                feature_9_title: "Jogos e atividades. ",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Atividades para alunos de todos os níveis incluem leitura em voz alta com feedback instantâneo da pronúncia, escrita para fins específicos e compreensão oral e de leitura.",
                feature_10_title: "Leitura e escrita. ",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Permitem que os alunos usem smartphones e tablets dentro e fora da sala de aula para acessar lições e atividades que aumentam a retenção de habilidades e o vocabulário.",
                feature_11_title: "Aplicativos móveis. ",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Uma visão instantânea do desempenho de indivíduos, grupos e classes com acompanhamento do progresso de uso e proficiência que permite que professores e administradores facilmente relatem os resultados dos alunos.",
                feature_12_title: "Ferramentas de relatório. ",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "O gerenciamento simplificado de licenças permite que professores e administradores rapidamente redistribuam os alunos, assegurando que todas as licenças estejam em uso e apoiando o ROI do programa.",
                feature_13_title: "Licenças transferíveis. ",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "Nossa equipe incorpora metas de aprendizagem de idiomas em modelos eficazes e auxilia no planejamento, implantação e promoção do programa em toda a organização.",
                feature_14_title: "Suporte à implementação.",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Níveis de treinamento para administradores e professores estão disponíveis para contribuir para o sucesso no lançamento do programa de maneira que se combine eficazmente com o ensino do professor na sala de aula.",
                feature_15_title: "Serviços de treinamento. ",
                feature_section_title: "Todos os recursos que você precisa estão ao seu alcance."
              }
            }]
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "solicitacao-de-precos":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitação de preços | Rosetta Stone",
          meta_description: "Serviços profissionais e empresas de consultoria do mundo todo enfrentam barreiras linguísticas que limitam sua capacidade de atender aos clientes, engajar funcionários e expandir seus negócios globalmente. As soluções de treinamento em idiomas ajudam as empresas de consultoria profissional a maximizar as horas faturáveis por funcionário — o que comprova o ROI significativo de nosso treinamento em idiomas em toda a organização.",
          canonical_url: "https://pt.rosettastone.com/empresas/solicitacao-de-precos/",
          lang: "pt"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Marque um horário com um especialista no aprendizado de idiomas hoje mesmo."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Preencha o formulário abaixo para agendar um horário para discutir como podemos ajudar você."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Você está quase lá!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nome",
                required: true,
                required_error: "Insira seu nome."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Sobrenome",
                required: true,
                required_error: "Insira seu sobrenome."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Endereço de email",
                required: true,
                required_error: "Insira seu endereço de email.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Telefone",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Insira o nome da sua empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamanho da empresa",
                required: true,
                required_error: "Insira o tamanho da empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 ou Menos",
                  label: "100 ou Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 ou Mais",
                  label: "50,001 ou Mais"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Cargo",
                required: true,
                required_error: "Insira seu cargo."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar preços"
            },
            labels: {
              form_privacy1: "A Rosetta Stone tem o compromisso de salvaguardar a sua privacidade. A nossa Política de Privacidade completa está disponível ",
              form_privacy2: "aqui.",
              form_privacy3: "Entendo que posso optar por não receber essas comunicações a qualquer momento clicando no link fornecido na comunicação ou entrando em contato com a Rosetta Stone em",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Sim! Eu gostaria de receber atualizações de produtos e marketing da Rosetta Stone. Clique",
              form_updateagreement2: "aqui",
              form_updateagreement3: "para maiores informações."
            },
            domain: ".br",
            dataQaLocation: "page"
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          })
        }
      };

    case "solicitacao-de-precos-concluida":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitação de preços concluída | Rosetta Stone",
          meta_description: "Serviços profissionais e empresas de consultoria do mundo todo enfrentam barreiras linguísticas que limitam sua capacidade de atender aos clientes, engajar funcionários e expandir seus negócios globalmente. As soluções de treinamento em idiomas ajudam as empresas de consultoria profissional a maximizar as horas faturáveis por funcionário — o que comprova o ROI significativo de nosso treinamento em idiomas em toda a organização.",
          canonical_url: "https://pt.rosettastone.com/empresas/solicitacao-de-precos-concluida/",
          lang: "pt"
        },
        content: {
          title: {
            align: "center",
            content: "Agradecemos seu interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Confira alguns resources adicionais antes da sua reunião.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var enterprise_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://pt.rosettastone.com/educacaobasica/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/ensino-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/empresas/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/contato/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/pt/school",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: false,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://pt.rosettastone.com/termos/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://pt.rosettastone.com/privacidade/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var consumer_product_activation_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/legal/ccpa/"
      },
      cookieSettings: {
        visible: false,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/legal/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://pt.rosettastone.com/termos/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://pt.rosettastone.com/privacidade/"
      },
      dataPrivacyAndSecurity: {
        visible: false,
        label: strings.footer_meta_data_privacy_and_security_label,
        destination: "https://www.rosettastone.com/legal/dataprivacyandsecurity/"
      }
    },
    region_social: {
      visible: true,
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var consumer_product_activation_pages_config = (function (_ref) {
  var page = _ref.page;

  switch (page) {
    case "product-activation":
      return {
        page: page,
        helmet: {
          meta_title: "Rosetta Stone® - Online Subscription Product Activation",
          meta_description: "Activate your Rosetta Stone® language learning online subscription products.",
          canonical_url: "https://rosettastone.com/product/product-activation/",
          lang: "pt"
        }
      };

    default:
      return null;
  }
});

var pt = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "consumer":
      page_config = consumer_pages_config({
        page: page,
        strings: strings
      });
      footer_config = consumer_footer_config({
        strings: strings
      });
      break;

    case "consumer-seo":
      page_config = consumer_seo_pages_config({
        page: page,
        strings: strings
      });
      footer_config = consumer_seo_footer_config({
        strings: strings
      });
      break;

    case "business":
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config({
        strings: strings
      });
      page_config = enterprise_pages_config({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config({
        strings: strings
      });
      break;

    case "k12":
    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config({
        strings: strings
      });
      page_config = education_primary_pages_config({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config({
        strings: strings
      });
      break;

    case "hed":
    case "education-secondary":
      nav_secondary = education_secondary_nav_secondary_config({
        strings: strings
      });
      page_config = education_secondary_pages_config({
        page: page,
        strings: strings
      });
      footer_config = education_secondary_footer_config({
        strings: strings
      });
      break;

    case "consumer-product-activation":
      footer_config = consumer_product_activation_footer_config({
        strings: strings
      });
      page_config = consumer_product_activation_pages_config({
        page: page,
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config({
    strings: strings
  });
  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

const strings_de_DE = {
    global_brand_name: "Rosetta Stone",
    product_name: "Rosetta Stone",
    locale_ar_ar_label_primary: "Arabisch",
    locale_ar_ar_label_secondary: "",
    locale_de_de_label_primary: "Deutsch",
    locale_de_de_label_secondary: "",
    locale_el_gr_label_primary: "Griechisch",
    locale_el_gr_label_secondary: "",
    locale_en_gb_label_primary: "Englisch",
    locale_en_gb_label_secondary: "Britisch",
    locale_en_us_label_primary: "Englisch",
    locale_en_us_label_secondary: "Amerikanisch",
    locale_es_es_label_primary: "Spanisch",
    locale_es_es_label_secondary: "",
    locale_es_la_label_primary: "Spanisch",
    locale_es_la_label_secondary: "Lateinamerika",
    locale_fa_ir_label_primary: "Persisch",
    locale_fa_ir_label_secondary: "Farsi",
    locale_fr_fr_label_primary: "Französisch",
    locale_fr_fr_label_secondary: "",
    locale_ga_ie_label_primary: "Irisch",
    locale_ga_ie_label_secondary: "",
    locale_he_il_label_primary: "Hebräisch",
    locale_he_il_label_secondary: "",
    locale_hi_in_label_primary: "Hindi",
    locale_hi_in_label_secondary: "",
    locale_it_it_label_primary: "Italienisch",
    locale_it_it_label_secondary: "",
    locale_ja_jp_label_primary: "Japanisch",
    locale_ja_jp_label_secondary: "",
    locale_ko_kr_label_primary: "Koreanisch",
    locale_ko_kr_label_secondary: "",
    locale_la_va_label_primary: "Latin",
    locale_la_va_label_secondary: "",
    locale_nl_nl_label_primary: "Niederländisch",
    locale_nl_nl_label_secondary: "",
    locale_pl_pl_label_primary: "Polnisch",
    locale_pl_pl_label_secondary: "",
    locale_pt_br_label_primary: "Portugiesisch",
    locale_pt_br_label_secondary: "Brazil",
    locale_ru_ru_label_primary: "Russisch",
    locale_ru_ru_label_secondary: "",
    locale_sv_se_label_primary: "Schwedisch",
    locale_sv_se_label_secondary: "",
    locale_tl_ph_label_primary: "Philippinisch",
    locale_tl_ph_label_secondary: "Tagalog",
    locale_tr_tr_label_primary: "Türkisch",
    locale_tr_tr_label_secondary: "",
    locale_vi_vn_label_primary: "Vietnamesisch",
    locale_vi_vn_label_secondary: "",
    locale_zn_cn_label_primary: "Chinesisch",
    locale_zn_cn_label_secondary: "Mandarin",
    nav_primary_blog_label: "Magazine",
    nav_primary_catalog_label: "Sprachen Und Preise",
    nav_primary_catalog_select_language_label: "Wähle eine Sprache",
    nav_primary_contact_label: "Kontakt",
    nav_primary_logo_alt: "Rosetta Stone",
    nav_primary_phone_label: "Fragen? Ruf Sie uns an:",
    nav_primary_phone_number: "0800 724 0778",
    nav_primary_sign_in_label: "Login",
    nav_primary_support_label: "Support",
    nav_primary_switch_language: "",
    nav_primary_vertical_consumer_label: "",
    nav_primary_vertical_education_for_homeschool_label: "",
    nav_primary_vertical_education_for_students_label: "",
    nav_primary_vertical_education_homeschool_label: "",
    nav_primary_vertical_education_primary_label: "Bildungseinrichtungen",
    nav_primary_vertical_education_secondary_label: "",
    nav_primary_vertical_education_students_label: "",
    nav_primary_vertical_enterprise_label: "Unternehmen",
    nav_primary_vertical_for_young_learners_label: "",
    nav_secondary_enterprise_blog_label: "",
    nav_secondary_enterprise_custom_1_label: "",
    nav_secondary_enterprise_home_label: "Home",
    nav_secondary_enterprise_label: "Unternehmen",
    nav_secondary_enterprise_resources_label: "Ressourcen",
    nav_secondary_enterprise_solutions_label: "Lösungen",
    nav_secondary_education_primary_blog_label: "",
    nav_secondary_education_primary_home_label: "Home",
    nav_secondary_education_primary_label: "Schulen",
    nav_secondary_education_primary_resources_label: "Ressourcen",
    nav_secondary_education_primary_solutions_label: "Lösungen",
    nav_secondary_education_secondary_blog_label: "",
    nav_secondary_education_secondary_custom_1_label: "",
    nav_secondary_education_secondary_home_label: "",
    nav_secondary_education_secondary_label: "",
    nav_secondary_education_secondary_resources_label: "",
    nav_secondary_education_secondary_solutions_label: "",
    nav_secondary_education_homeschool_blog_label: "",
    nav_secondary_education_homeschool_home_label: "",
    nav_secondary_education_homeschool_label: "",
    nav_secondary_education_homeschool_resources_label: "",
    nav_secondary_education_homeschool_solutions_label: "Solutions",
    nav_secondary_services_blog_label: "",
    nav_secondary_services_home_label: "",
    nav_secondary_services_label: "",
    nav_secondary_services_resources_label: "",
    nav_secondary_services_solutions_label: "",
    awards_header_label: "Seit 25+ Jahren von Top-Organisationen genutzt",
    awards_bmw: "BMW",
    awards_twitter: "Twitter",
    awards_uber: "Uber",
    awards_williams_sonoma: "Williams Sonoma",
    branded_quotes_header_label: "Was die Leute über uns sagen",
    branded_quotes_cnn_name: "CNN",
    branded_quotes_cnn_quote: "&quot;Der <em>Gold-Status</em> an computerbasiertem Sprachenlernen.&quot;",
    branded_quotes_cnn_type: "cnn",
    branded_quotes_macworld_name: "MacWorld",
    branded_quotes_macworld_quote: "&quot;Ich bin von der Rosetta Stone Sprachlernlösung begeistert und fest davon überzeugt, <em>dass der Lernansatz funktioniert.</em>&quot;",
    branded_quotes_macworld_type: "macworld",
    branded_quotes_techcrunch_name: "TechCrunch",
    branded_quotes_techcrunch_quote: "&quot;Mit den benutzerfreundlichen Interfaces, klaren Anweisungen sowie der großen Auswahl an Spielen und sonstigen Lern-Tools hat es <em>Rosetta Stone einfach drauf.</em>&quot;",
    branded_quotes_techcrunch_type: "techcrunch",
    related_resources_label: "",
    related_resources_button_label: "",
    verticals_label: "Welche Art von Lerner bist du?",
    verticals_education_primary: "Schulen",
    verticals_education_secondary: "Hochschulen",
    verticals_enterprise: "Unternehmen",
    verticals_publicsector: "Öffentlicher Sektor",
    footer_cta_email_button: "",
    footer_cta_email_main_label: "",
    footer_cta_email_placeholder: "",
    footer_cta_form_comments: "Wie können wir Ihnen weiter helfen?",
    footer_cta_form_country: "Country",
    footer_cta_form_email: "E-Mail",
    footer_cta_form_firstname: "Vorname",
    footer_cta_form_lastname: "Nachname",
    footer_cta_form_organization: "Unternehmen",
    footer_cta_form_organizationsize: "form_organizationsize",
    footer_cta_form_organizationsize_100: "form_100",
    footer_cta_form_organizationsize_500: "form_500",
    footer_cta_form_organizationsize_1000: "form_1000",
    footer_cta_form_organizationsize_5000: "form_5000",
    footer_cta_form_organizationsize_10000: "form_10000",
    footer_cta_form_organizationsize_25000: "form_25000",
    footer_cta_form_organizationsize_50000: "form_50000",
    footer_cta_form_organizationsize_more: "form_more",
    footer_cta_form_phone: "Telefonnummer (optional)",
    footer_cta_form_pricing_thanks: "Danke für Ihr Interesse! In Kürze wird sich jemand mit Ihnen in Verbindung setzen.",
    footer_cta_form_role: "Rolle (oder Titel)",
    footer_cta_form_role_boardmember: "Vorstandsmitglied",
    footer_cta_form_role_curriculumdirector: "Lehrplanleiter / Instruktionskoordinator",
    footer_cta_form_role_director: "Direktor",
    footer_cta_form_role_executive: "Geschäftsführung / Executive",
    footer_cta_form_role_individualcontributor: "Einzelner Mitwirkender",
    footer_cta_form_role_manager: "Manager",
    footer_cta_form_role_principal: "Auftraggeber / Vizepräsident",
    footer_cta_form_role_superintendent: "Superintendent/District Administrator",
    footer_cta_form_role_teacher: "Lehrer",
    footer_cta_form_role_techcoordinator: "Technologiekoordinator",
    footer_cta_form_role_vicepresident: "Vizepräsident",
    footer_cta_form_submit: "JETZT ANGEBOT ANFORDERN",
    footer_cta_opt_in_learn_more_button_text: "Mehr erfahren",
    footer_cta_opt_in_learn_more_link_text_1: "Datenschutzrichtlinie von Rosetta Stone ",
    footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/de/pdfs/website-privacy-policy-de.pdf",
    footer_cta_opt_in_learn_more_text_1: "Ich stimme dem Erhalt von Info- und Marketingmaterial über Produktneuigkeiten, Angebote oder Einladungen zu Veranstaltungen von Rosetta Stone zu. Es ist mir bewusst, dass meine Daten mit internationalen Partnern, die Dienstleistungen für Rosetta Stone anbieten im Rahmen der",
    footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_text_3: " kontaktiere.",
    footer_cta_opt_in_text_after_button: "",
    footer_cta_opt_in_text_before_button: "Ja, ich möchte Produktneuigkeiten und Angebote von Rosetta Stone erhalten. ",
    footer_cta_pricing_button: "ANGEBOT ANFORDERN",
    footer_cta_pricing_label: "Bereit für den nächsten Schritt?",
    footer_cta_pricing_subtitle: "Haben wir Ihr Interesse geweckt? Fordern Sie Ihr individuelles Angebot an.",
    footer_cta_pricing_title: "Bitte ausfüllen und wir melden uns umgehend bei Ihnen.",
    footer_menu_about_about_us_label: "Über Uns",
    footer_menu_about_blog_label: "Blog",
    footer_menu_about_careers_label: "Karriere",
    footer_menu_about_contact_label: "Kontakt",
    footer_menu_about_label: "Unternehmen",
    footer_menu_about_press_label: "Presse",
    footer_menu_products_consumer_label: "Für Einzelpersonen",
    footer_menu_products_education_primary_label: "Bildungseinrichtungen",
    footer_menu_products_education_secondary_label: "Für Hochschullehrer",
    footer_menu_products_enterprise_label: "Unternehmen",
    footer_menu_products_label: "Überblick",
    footer_menu_products_publicsector_label: "Öffentlicher Sektor",
    footer_menu_support_faqs_label: "FAQs",
    footer_menu_support_label: "Support",
    footer_menu_support_support_site_label: "Support Site",
    footer_menu_support_system_requirements_label: "Systemanforderungen",
    footer_meta_agreements_label: "Vereinbarungen",
    footer_meta_ccpa_label: "Do Not Sell My Information",
    footer_meta_cookie_settings_label: "Cookie-Einstellungen",
    footer_meta_copyright_alt: "Go to home page",
    footer_meta_copyright_IXL: "A division of IXL Learning",
    footer_meta_copyright_label: " Rosetta Stone GmbH. Alle Rechte vorbehalten.",
    footer_meta_privacy_policy_label: "Datenschutzrichtlinie",
    footer_meta_terms_conditions_label: "Nutzungsbedingungen",
    footer_region_label: "Region ändern",
    footer_region_options_br_label: "Brasil",
    footer_region_options_cn_label: "中国",
    footer_region_options_de_label: "Deutschland",
    footer_region_options_es_label: "España",
    footer_region_options_eu_label: "Europe",
    footer_region_options_fr_label: "France",
    footer_region_options_it_label: "Italia",
    footer_region_options_jp_label: "日本",
    footer_region_options_kr_label: "대한민국",
    footer_region_options_la_label: "America Latina",
    footer_region_options_uk_label: "United Kingdom",
    footer_region_options_us_label: "United States",
    footer_social_label: "Kontaktieren Sie uns",
    footer_social_facebook_alt: "Facebook",
    footer_social_instagram_alt: "Instagram",
    footer_social_twitter_alt: "Twitter",
    footer_social_youtube_alt: "Youtube"
};

const strings_en_GB = {
    global_brand_name: "Rosetta Stone",
    product_name: "Rosetta Stone",
    locale_ar_ar_label_primary: "Arabic",
    locale_ar_ar_label_secondary: "",
    locale_de_de_label_primary: "German",
    locale_de_de_label_secondary: "",
    locale_el_gr_label_primary: "Greek",
    locale_el_gr_label_secondary: "",
    locale_en_gb_label_primary: "English",
    locale_en_gb_label_secondary: "",
    locale_en_us_label_primary: "English",
    locale_en_us_label_secondary: "American",
    locale_es_es_label_primary: "Spanish",
    locale_es_es_label_secondary: "",
    locale_es_la_label_primary: "Spanish",
    locale_es_la_label_secondary: "Latin America",
    locale_fa_ir_label_primary: "Persian",
    locale_fa_ir_label_secondary: "",
    locale_fr_fr_label_primary: "French",
    locale_fr_fr_label_secondary: "",
    locale_ga_ie_label_primary: "Irish",
    locale_ga_ie_label_secondary: "",
    locale_he_il_label_primary: "Hebrew",
    locale_he_il_label_secondary: "",
    locale_hi_in_label_primary: "Hindi",
    locale_hi_in_label_secondary: "",
    locale_it_it_label_primary: "Italian",
    locale_it_it_label_secondary: "",
    locale_ja_jp_label_primary: "Japanese",
    locale_ja_jp_label_secondary: "",
    locale_ko_kr_label_primary: "Korean",
    locale_ko_kr_label_secondary: "",
    locale_la_va_label_primary: "Latin",
    locale_la_va_label_secondary: "",
    locale_nl_nl_label_primary: "Dutch",
    locale_nl_nl_label_secondary: "",
    locale_pl_pl_label_primary: "Polish",
    locale_pl_pl_label_secondary: "",
    locale_pt_br_label_primary: "Portuguese",
    locale_pt_br_label_secondary: "",
    locale_ru_ru_label_primary: "Russian",
    locale_ru_ru_label_secondary: "",
    locale_sv_se_label_primary: "Swedish",
    locale_sv_se_label_secondary: "",
    locale_tl_ph_label_primary: "Filipino",
    locale_tl_ph_label_secondary: "",
    locale_tr_tr_label_primary: "Turkish",
    locale_tr_tr_label_secondary: "",
    locale_vi_vn_label_primary: "Vietnamese",
    locale_vi_vn_label_secondary: "",
    locale_zn_cn_label_primary: "Chinese",
    locale_zn_cn_label_secondary: "",
    nav_primary_blog_label: "Magazine",
    nav_primary_contact_label: "Contact",
    nav_primary_catalog_label: "Languages & Pricing",
    nav_primary_catalog_select_language_label: "Select a language",
    nav_primary_logo_alt: "Rosetta Stone",
    nav_primary_phone_label: "Questions?",
    nav_primary_phone_number: "1 (800) 306-3467",
    nav_primary_sign_in_label: "Sign In",
    nav_primary_support_label: "Support",
    nav_primary_switch_language: "",
    nav_primary_vertical_consumer_label: "",
    nav_primary_vertical_education_for_homeschool_label: "",
    nav_primary_vertical_education_for_students_label: "",
    nav_primary_vertical_education_homeschool_label: "",
    nav_primary_vertical_education_primary_label: "For Educators",
    nav_primary_vertical_education_secondary_label: "",
    nav_primary_vertical_education_students_label: "",
    nav_primary_vertical_enterprise_label: "For Enterprise",
    nav_primary_vertical_for_young_learners_label: "",
    nav_secondary_enterprise_blog_label: "Blog",
    nav_secondary_enterprise_custom_1_label: "",
    nav_secondary_enterprise_home_label: "Home",
    nav_secondary_enterprise_label: "Enterprise",
    nav_secondary_enterprise_resources_label: "Resources",
    nav_secondary_enterprise_solutions_label: "Solutions",
    nav_secondary_enterprise_solutions_consulting_label: "Consulting",
    nav_secondary_enterprise_solutions_financial_label: "Financial",
    nav_secondary_enterprise_solutions_logistics_label: "Logistics",
    nav_secondary_enterprise_solutions_manufacturing_label: "Manufacturing",
    nav_secondary_enterprise_solutions_pharmaceutical_label: "Pharmaceutical",
    nav_secondary_enterprise_solutions_retail_label: "Retail",
    nav_secondary_education_primary_blog_label: "",
    nav_secondary_education_primary_home_label: "Home",
    nav_secondary_education_primary_label: "Schools",
    nav_secondary_education_primary_resources_label: "Resources",
    nav_secondary_education_primary_solutions_label: "Solutions",
    nav_secondary_education_secondary_blog_label: "",
    nav_secondary_education_secondary_custom_1_label: "",
    nav_secondary_education_secondary_home_label: "",
    nav_secondary_education_secondary_label: "",
    nav_secondary_education_secondary_resources_label: "",
    nav_secondary_education_secondary_solutions_label: "",
    nav_secondary_education_homeschool_blog_label: "",
    nav_secondary_education_homeschool_home_label: "",
    nav_secondary_education_homeschool_label: "",
    nav_secondary_education_homeschool_resources_label: "",
    nav_secondary_education_homeschool_solutions_label: "",
    nav_secondary_services_blog_label: "",
    nav_secondary_services_home_label: "",
    nav_secondary_services_label: "",
    nav_secondary_services_resources_label: "",
    nav_secondary_services_solutions_label: "",
    awards_header_label: "Trusted for 25+ years by top organizations.",
    awards_bmw: "BMW",
    awards_twitter: "Twitter",
    awards_uber: "Uber",
    awards_williams_sonoma: "Williams Sonoma",
    branded_quotes_header_label: "What people say about us.",
    branded_quotes_cnn_name: "CNN",
    branded_quotes_cnn_quote: "&quot;The <em>gold standard</em> of computer-based language learning.&quot;",
    branded_quotes_cnn_type: "cnn",
    branded_quotes_macworld_name: "MacWorld",
    branded_quotes_macworld_quote: "&quot;I love Rosetta Stone's software, and I think <em>the approach to learning languages works.</em>&quot;",
    branded_quotes_macworld_type: "macworld",
    branded_quotes_techcrunch_name: "TechCrunch",
    branded_quotes_techcrunch_quote: "&quot;With its excellent user interface, clear instructions, wide variety of games and challenges...  <em>Rosetta Stone has got it going on.</em>&quot;",
    branded_quotes_techcrunch_type: "techcrunch",
    related_resources_label: "Keep Exploring",
    related_resources_button_label: "Read more",
    verticals_label: "What type of learner are you?",
    verticals_education_primary: "Schools",
    verticals_education_secondary: "Higher Education",
    verticals_enterprise: "Enterprise",
    verticals_publicsector: "Public Sector",
    footer_cta_email_button: "Sign Up",
    footer_cta_email_main_label: "Sign up to stay in touch.",
    footer_cta_email_placeholder: "Sign Up",
    footer_cta_email_sub_label: "Get Rosetta Stone news and offers.",
    footer_cta_form_comments: "How Can We Help?",
    footer_cta_form_country: "Country",
    footer_cta_form_email: "Email Address",
    footer_cta_form_firstname: "First Name",
    footer_cta_form_lastname: "Surname",
    footer_cta_form_organization: "Institution",
    footer_cta_form_organizationsize: "form_organizationsize",
    footer_cta_form_organizationsize_100: "form_100",
    footer_cta_form_organizationsize_500: "form_500",
    footer_cta_form_organizationsize_1000: "form_1000",
    footer_cta_form_organizationsize_5000: "form_5000",
    footer_cta_form_organizationsize_10000: "form_10000",
    footer_cta_form_organizationsize_25000: "form_25000",
    footer_cta_form_organizationsize_50000: "form_50000",
    footer_cta_form_organizationsize_more: "form_more",
    footer_cta_form_phone: "Phone Number (Optional)",
    footer_cta_form_pricing_thanks: "Thanks for your interest! Someone will follow up with you shortly.",
    footer_cta_form_role: "Role (or title)",
    footer_cta_form_role_boardmember: "Board Member",
    footer_cta_form_role_curriculumdirector: "Curriculum Director/Instruction Coordinator",
    footer_cta_form_role_director: "Director",
    footer_cta_form_role_executive: "General Management/Executive",
    footer_cta_form_role_individualcontributor: "Individual Contributor",
    footer_cta_form_role_manager: "Manager",
    footer_cta_form_role_principal: "Principal/Vice Principal",
    footer_cta_form_role_superintendent: "Superintendent/District Administrator",
    footer_cta_form_role_teacher: "Teacher",
    footer_cta_form_role_techcoordinator: "Technology Coordinator",
    footer_cta_form_role_vicepresident: "Vice President",
    footer_cta_form_submit: "Submit",
    footer_cta_opt_in_learn_more_button_text: "here",
    footer_cta_opt_in_learn_more_link_text_1: "Privacy Policy",
    footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_privacyUrl: "https://www.rosettastone.co.uk/docs/terms/RS-UK_Website%20Privacy%20Policy_05252018.pdf",
    footer_cta_opt_in_learn_more_text_1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's ",
    footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_text_3: ".",
    footer_cta_opt_in_text_after_button: "for more information.",
    footer_cta_opt_in_text_before_button: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
    footer_cta_pricing_button: "Request Pricing",
    footer_cta_pricing_label: "Ready to begin your organisation’s complete language journey?",
    footer_cta_pricing_subtitle: "Please fill out the form below and we'll follow up with you right away.",
    footer_cta_pricing_thanks: "Thanks for your interest! Someone will follow up with you shortly.",
    footer_cta_pricing_title: "Get the pricing answers you need.",
    footer_menu_about_about_us_label: "About Us",
    footer_menu_about_blog_label: "Blog",
    footer_menu_about_careers_label: "Careers",
    footer_menu_about_contact_label: "Contact",
    footer_menu_about_label: "About",
    footer_menu_about_press_label: "Press",
    footer_menu_products_consumer_label: "For Individuals",
    footer_menu_products_education_primary_label: "For Schools",
    footer_menu_products_education_secondary_label: "For Higher Education",
    footer_menu_products_enterprise_label: "For Enterprise",
    footer_menu_products_label: "Products",
    footer_menu_support_faqs_label: "FAQs",
    footer_menu_support_label: "Support",
    footer_menu_support_support_site_label: "Support Site",
    footer_menu_support_system_requirements_label: "System Requirements",
    footer_meta_agreements_label: "Agreements",
    footer_meta_ccpa_label: "Do Not Sell My Information",
    footer_meta_cookie_settings_label: "Cookie Settings",
    footer_meta_copyright_alt: "Go to home page",
    footer_meta_copyright_IXL: "A division of IXL Learning",
    footer_meta_copyright_label: "Rosetta Stone LLC. All Rights Reserved.",
    footer_meta_privacy_policy_label: "Privacy Policy",
    footer_meta_terms_conditions_label: "Terms & Conditions",
    footer_region_label: "Change Region",
    footer_region_options_br_label: "Brasil",
    footer_region_options_cn_label: "中国",
    footer_region_options_de_label: "Deutschland",
    footer_region_options_es_label: "España",
    footer_region_options_eu_label: "Europe",
    footer_region_options_fr_label: "France",
    footer_region_options_it_label: "Italia",
    footer_region_options_jp_label: "日本",
    footer_region_options_kr_label: "대한민국",
    footer_region_options_la_label: "America Latina",
    footer_region_options_uk_label: "United Kingdom",
    footer_region_options_us_label: "United States",
    footer_social_label: "Connect with us",
    footer_social_facebook_alt: "Facebook",
    footer_social_instagram_alt: "Instagram",
    footer_social_twitter_alt: "Twitter",
    footer_social_youtube_alt: "Youtube"
};

const strings_en_US = {
    global_brand_name: "Rosetta Stone",
    product_name: "Rosetta Stone",
    locale_ar_ar_label_primary: "Arabic",
    locale_ar_ar_label_secondary: "",
    locale_de_de_label_primary: "German",
    locale_de_de_label_secondary: "",
    locale_el_gr_label_primary: "Greek",
    locale_el_gr_label_secondary: "",
    locale_en_gb_label_primary: "English",
    locale_en_gb_label_secondary: "British",
    locale_en_us_label_primary: "English",
    locale_en_us_label_secondary: "American",
    locale_es_es_label_primary: "Spanish",
    locale_es_es_label_secondary: "Spain",
    locale_es_la_label_primary: "Spanish",
    locale_es_la_label_secondary: "Latin America",
    locale_fa_ir_label_primary: "Persian",
    locale_fa_ir_label_secondary: "Farsi",
    locale_fr_fr_label_primary: "French",
    locale_fr_fr_label_secondary: "",
    locale_ga_ie_label_primary: "Irish",
    locale_ga_ie_label_secondary: "",
    locale_he_il_label_primary: "Hebrew",
    locale_he_il_label_secondary: "",
    locale_hi_in_label_primary: "Hindi",
    locale_hi_in_label_secondary: "",
    locale_it_it_label_primary: "Italian",
    locale_it_it_label_secondary: "",
    locale_ja_jp_label_primary: "Japanese",
    locale_ja_jp_label_secondary: "",
    locale_ko_kr_label_primary: "Korean",
    locale_ko_kr_label_secondary: "",
    locale_la_va_label_primary: "Latin",
    locale_la_va_label_secondary: "",
    locale_nl_nl_label_primary: "Dutch",
    locale_nl_nl_label_secondary: "",
    locale_pl_pl_label_primary: "Polish",
    locale_pl_pl_label_secondary: "",
    locale_pt_br_label_primary: "Portuguese",
    locale_pt_br_label_secondary: "Brazil",
    locale_ru_ru_label_primary: "Russian",
    locale_ru_ru_label_secondary: "",
    locale_sv_se_label_primary: "Swedish",
    locale_sv_se_label_secondary: "",
    locale_tl_ph_label_primary: "Filipino",
    locale_tl_ph_label_secondary: "Tagalog",
    locale_tr_tr_label_primary: "Turkish",
    locale_tr_tr_label_secondary: "",
    locale_vi_vn_label_primary: "Vietnamese",
    locale_vi_vn_label_secondary: "",
    locale_zn_cn_label_primary: "Chinese",
    locale_zn_cn_label_secondary: "Mandarin",
    nav_primary_blog_label: "Blog",
    nav_primary_catalog_label: "Languages & Pricing",
    nav_primary_catalog_select_language_label: "Select a language",
    nav_primary_contact_label: "Contact",
    nav_primary_logo_alt: "Rosetta Stone",
    nav_primary_phone_label: "Questions?",
    nav_primary_phone_number: "1-800-767-3882",
    nav_primary_sign_in_label: "Sign In",
    nav_primary_support_label: "Support",
    nav_primary_switch_language: "Español",
    nav_primary_vertical_consumer_label: "For You",
    nav_primary_vertical_education_for_homeschool_label: "For Homeschool",
    nav_primary_vertical_education_for_students_label: "For Students",
    nav_primary_vertical_education_homeschool_label: "Homeschool",
    nav_primary_vertical_education_primary_label: "For Schools",
    nav_primary_vertical_education_secondary_label: "For Higher Education",
    nav_primary_vertical_education_students_label: "Students",
    nav_primary_vertical_enterprise_label: "For Enterprise",
    nav_primary_vertical_for_young_learners_label: "For Young Learners",
    nav_secondary_enterprise_blog_label: "Blog",
    nav_secondary_enterprise_custom_1_label: "",
    nav_secondary_enterprise_home_label: "Home",
    nav_secondary_enterprise_label: "Enterprise",
    nav_secondary_enterprise_resources_label: "Resources",
    nav_secondary_enterprise_solutions_label: "Solutions",
    nav_secondary_enterprise_solutions_construction_label: "Construction",
    nav_secondary_enterprise_solutions_consulting_label: "Consulting",
    nav_secondary_enterprise_solutions_foodservice_label: "Food Service",
    nav_secondary_enterprise_solutions_government_label: "Government",
    nav_secondary_enterprise_solutions_healthcare_label: "Healthcare",
    nav_secondary_enterprise_solutions_hospitality_label: "Hospitality",
    nav_secondary_enterprise_solutions_manufacturing_label: "Manufacturing",
    nav_secondary_enterprise_solutions_retail_label: "Retail",
    nav_secondary_education_primary_blog_label: "Blog",
    nav_secondary_education_primary_home_label: "Home",
    nav_secondary_education_primary_label: "Schools",
    nav_secondary_education_primary_resources_label: "Resources",
    nav_secondary_education_primary_solutions_label: "Solutions",
    nav_secondary_education_primary_solutions_k12_english_language: "K12 English Language",
    nav_secondary_education_primary_solutions_world_languages: "World Languages",
    nav_secondary_education_secondary_blog_label: "Blog",
    nav_secondary_education_secondary_custom_1_label: "",
    nav_secondary_education_secondary_home_label: "Home",
    nav_secondary_education_secondary_label: "Higher Education",
    nav_secondary_education_secondary_resources_label: "Resources",
    nav_secondary_education_secondary_solutions_label: "Solutions",
    nav_secondary_education_homeschool_blog_label: "Blog",
    nav_secondary_education_homeschool_home_label: "Home",
    nav_secondary_education_homeschool_label: "Homeschool",
    nav_secondary_education_homeschool_resources_label: "Resources",
    nav_secondary_education_homeschool_solutions_label: "Solutions",
    nav_secondary_services_blog_label: "",
    nav_secondary_services_home_label: "",
    nav_secondary_services_label: "",
    nav_secondary_services_resources_label: "",
    nav_secondary_services_solutions_label: "",
    footer_cta_email_button: "Sign Up",
    footer_cta_email_main_label: "Sign up to stay in touch.",
    footer_cta_email_placeholder: "Sign Up",
    footer_cta_email_sub_label: "Get Rosetta Stone news and offers.",
    footer_cta_form_comments: "",
    footer_cta_form_country: "Country",
    footer_cta_form_email: "Email Address",
    footer_cta_form_firstname: "First Name",
    footer_cta_form_lastname: "Last Name",
    footer_cta_form_organization: "Organization Name",
    footer_cta_form_organizationsize: "form_organizationsize",
    footer_cta_form_organizationsize_100: "form_100",
    footer_cta_form_organizationsize_500: "form_500",
    footer_cta_form_organizationsize_1000: "form_1000",
    footer_cta_form_organizationsize_5000: "form_5000",
    footer_cta_form_organizationsize_10000: "form_10000",
    footer_cta_form_organizationsize_25000: "form_25000",
    footer_cta_form_organizationsize_50000: "form_50000",
    footer_cta_form_organizationsize_more: "form_more",
    footer_cta_form_phone: "Phone Number (Optional)",
    footer_cta_form_pricing_thanks: "Thanks for your interest! Someone will follow up with you shortly.",
    footer_cta_form_role: "Role (or title)",
    footer_cta_form_role_boardmember: "Board Member",
    footer_cta_form_role_curriculumdirector: "Curriculum Director/Instruction Coordinator",
    footer_cta_form_role_director: "Director",
    footer_cta_form_role_executive: "General Management/Executive",
    footer_cta_form_role_individualcontributor: "Individual Contributor",
    footer_cta_form_role_manager: "Manager",
    footer_cta_form_role_principal: "Principal/Vice Principal",
    footer_cta_form_role_superintendent: "Superintendent/District Administrator",
    footer_cta_form_role_teacher: "Teacher",
    footer_cta_form_role_techcoordinator: "Technology Coordinator",
    footer_cta_form_role_vicepresident: "Vice President",
    footer_cta_form_submit: "Submit",
    footer_cta_pricing_button: "Request Pricing",
    footer_cta_pricing_label: "Ready to begin your organization’s complete language journey?",
    footer_cta_pricing_subtitle: "Please fill out the form below and we'll follow up with you right away.",
    footer_cta_pricing_thanks: "Thanks for your interest! Someone will follow up with you shortly.",
    footer_cta_pricing_title: "Get the pricing answers you need.",
    footer_menu_about_about_us_label: "About Us",
    footer_menu_about_blog_label: "Blog",
    footer_menu_about_careers_label: "Careers",
    footer_menu_about_coaches_label: "Meet Our Coaches",
    footer_menu_about_contact_label: "Contact",
    footer_menu_about_endangered_languages_label: "Endangered Languages",
    footer_menu_about_investor_relations_label: "Investor Relations",
    footer_menu_about_investors_label: "Investors",
    footer_menu_about_k12_reading_label: "Reading Solutions for K–12",
    footer_menu_about_label: "About",
    footer_menu_about_press_label: "Press",
    footer_menu_about_retail_partners_label: "Retail Partners",
    footer_menu_buy_all_label: "See All Languages",
    footer_menu_buy_english_label: "English",
    footer_menu_buy_espanol_label: "Rosetta Stone Español",
    footer_menu_buy_french_label: "French",
    footer_menu_buy_german_label: "German",
    footer_menu_buy_homeschool_label: "Rosetta Stone Homeschool",
    footer_menu_buy_ingles_label: "Inglés",
    footer_menu_buy_italian_label: "Italian",
    footer_menu_buy_label: "Buy Now",
    footer_menu_buy_portugues_label: "Rosetta Stone Português",
    footer_menu_buy_spanish_label: "Spanish",
    footer_menu_foreign_curriculum_label: "Homeschool Foreign Language Curriculum",
    footer_menu_homeschool_program_label: "Homeschool Program",
    footer_menu_homeschool_travel_label: "Homeschool Travel",
    footer_menu_learn_chinese_label: "Learn Chinese",
    footer_menu_learn_english_label: "Learn English",
    footer_menu_learn_french_label: "Learn French",
    footer_menu_learn_german_label: "Learn German",
    footer_menu_learn_ingles_label: "Aprende Inglés",
    footer_menu_learn_italian_label: "Learn Italian",
    footer_menu_learn_japanese_label: "Learn Japanese",
    footer_menu_learn_label: "Learn More",
    footer_menu_learn_languages_label: "Learn a Language",
    footer_menu_learn_spanish_label: "Learn Spanish",
    footer_menu_online_curriculum_label: "Online Homeschool Curriculum",
    footer_menu_products_consumer_label: "For Individuals",
    footer_menu_products_education_homeschool_label: "For Homeschool",
    footer_menu_products_education_primary_label: "For Schools",
    footer_menu_products_enterprise_label: "For Enterprise",
    footer_menu_products_label: "Products",
    footer_menu_start_activation_label: "Product Activation",
    footer_menu_start_blog_label: "Blog",
    footer_menu_start_demo_label: "Try it Free",
    footer_menu_start_education_primary_label: "For Schools",
    footer_menu_start_enterprise_label: "For Enterprise",
    footer_menu_start_homeschool_retailers_label: "Authorized Retailers",
    footer_menu_start_homeschool_reviews_label: "Homeschool Reviews",
    footer_menu_start_label: "Where to Start",
    footer_menu_start_mobile_label: "Mobile Apps",
    footer_menu_start_reviews_label: "Reviews",
    footer_menu_start_speech_label: "Speech Recognition",
    footer_menu_start_testamonials_label: "Reviews",
    footer_menu_start_translate_label: "Translate",
    footer_menu_support_accessibility_statement_label: "Accessibility Statement",
    footer_menu_support_contact_us_label: "Contact Us",
    footer_menu_support_faqs_label: "FAQs",
    footer_menu_support_label: "Support",
    footer_menu_support_support_site_label: "Support Site",
    footer_menu_support_system_requirements_label: "System Requirements",
    footer_meta_agreements_label: "Agreements",
    footer_meta_ccpa_label: "Do Not Sell My Information",
    footer_meta_cookie_settings_label: "Cookie Settings",
    footer_meta_copyright_alt: "Go to home page",
    footer_meta_copyright_IXL: "A division of IXL Learning",
    footer_meta_copyright_label: "Rosetta Stone LLC. All Rights Reserved.",
    footer_meta_privacy_policy_label: "Privacy Policy",
    footer_meta_data_privacy_and_security_label: "Data Privacy and Security",
    footer_meta_terms_conditions_label: "Terms & Conditions",
    footer_region_label: "Change Region",
    footer_region_options_br_label: "Brasil",
    footer_region_options_cn_label: "中国",
    footer_region_options_de_label: "Deutschland",
    footer_region_options_es_label: "España",
    footer_region_options_eu_label: "Europe",
    footer_region_options_fr_label: "France",
    footer_region_options_it_label: "Italia",
    footer_region_options_jp_label: "日本",
    footer_region_options_kr_label: "대한민국",
    footer_region_options_la_label: "America Latina",
    footer_region_options_uk_label: "United Kingdom",
    footer_region_options_us_label: "United States",
    footer_social_label: "Connect with us",
    footer_social_facebook_alt: "Facebook",
    footer_social_instagram_alt: "Instagram",
    footer_social_twitter_alt: "Twitter",
    footer_social_youtube_alt: "Youtube",
    awards_header_label: "Trusted for 25+ years by top organizations.",
    awards_bmw: "BMW",
    awards_twitter: "Twitter",
    awards_uber: "Uber",
    awards_williams_sonoma: "Williams Sonoma",
    branded_quotes_header_label: "What people say about us.",
    branded_quotes_cnn_name: "CNN",
    branded_quotes_cnn_quote: "&quot;The <em>gold standard</em> of computer-based language learning.&quot;",
    branded_quotes_cnn_type: "cnn",
    branded_quotes_macworld_name: "MacWorld",
    branded_quotes_macworld_quote: "&quot;I love Rosetta Stone's software, and I think <em>the approach to learning languages works.</em>&quot;",
    branded_quotes_macworld_type: "macworld",
    branded_quotes_techcrunch_name: "TechCrunch",
    branded_quotes_techcrunch_quote: "&quot;With its excellent user interface, clear instructions, wide variety of games and challenges...  <em>Rosetta Stone has got it going on.</em>&quot;",
    branded_quotes_techcrunch_type: "techcrunch",
    related_resources_label: "Keep Exploring",
    related_resources_button_label: "Read more",
    verticals_label: "What type of learner are you?",
    verticals_education_primary: "Schools",
    verticals_education_secondary: "Higher Education",
    verticals_enterprise: "Enterprise",
    verticals_publicsector: "Public Sector",
    consumer_pages_company_about_us_h1: "About us",
    consumer_pages_company_about_us_p1: "Rosetta Stone, Inc., a division of IXL Learning, is dedicated to changing people's lives through the power of language education. The company's innovative digital solutions drive positive learning outcomes for the inspired learner at home or in schools and workplaces around the world.",
    consumer_pages_company_about_us_p2: "Founded in 1992, Rosetta Stone uses cloud-based solutions to help all types of learners read, write, and speak more than 30 languages, including several endangered languages.",
    consumer_pages_company_history_section_one_h2: "History",
    consumer_pages_company_history_section_one_p1: "Rosetta Stone began with one man's dream to find a better way to learn a language. That dream has since evolved into one of the most recognized technology-based learning companies in the world.",
    consumer_pages_company_history_section_one_p2: "After struggling to learn Russian through traditional methods, Founder Allen Stoltzfus set out to develop an effective way to learn a new language through natural immersion in the late 1980s. He envisioned using computer technology to simulate the way that people learn their native language—with pictures and sounds in context, and with no translation—and innovate language education for learners of all ages. Stoltzfus enlisted the help of his brother-in-law, John Fairfield, to explore the possibilities of making his dream a reality and in 1992, CD-ROM technology made the project possible. Together they founded Fairfield Language Technologies in Harrisonburg, VA with Stoltzfus at the helm as the company's first Chairman and President. He recruited his brother, Eugene Stoltzfus, to lend his design expertise to the structural and visual components of the program. The resulting product was then named “Rosetta Stone”, after the artifact that had unlocked the secrets of Egyptian hieroglyphics for linguists. The name certainly fits, as Rosetta Stone products now unlock learning success for millions of users worldwide.",
    consumer_pages_company_history_section_two_p1: "In 2003 Rosetta Stone went global, establishing offices in various major markets around the world, and in 2006, the company was officially renamed after its signature product. Rosetta Stone Inc. (NYSE: RST) became a publicly traded company on the New York Stock Exchange in April 2009, and continues to provide language-learning solutions in 30 different languages.",
    consumer_pages_company_history_section_two_p2_1: "2021 marked a year of transformation for the company as it joined the ",
    consumer_pages_company_history_section_two_p2_a_1: "IXL Learning",
    consumer_pages_company_history_section_two_p2_2: " family of brands, along with ",
    consumer_pages_company_history_section_two_p2_a_2: "IXL",
    consumer_pages_company_history_section_two_p2_a_3: "Vocabulary.com",
    consumer_pages_company_history_section_two_p2_a_4: "Education.com",
    consumer_pages_company_history_section_two_p2_3: ", and ",
    consumer_pages_company_history_section_two_p2_a_5: "Wyzant",
    consumer_pages_company_history_section_two_p3: "Rosetta Stone continues to service clients world-wide and currently has offices in six countries, in addition to various U.S.-based offices. The Company's headquarters are located in Arlington, VA.",
    consumer_pages_about_h1: "Contact us",
    consumer_pages_about_subtext: "Whether you're looking to buy our product, get technical support, or just learn more, getting in touch is only a click away!",
    consumer_pages_about_contact_support_h2: "How to Contact Rosetta Stone Support",
    consumer_pages_about_contact_support_paragraph_1_part_1: "Have questions and need support? Email us",
    consumer_pages_about_contact_support_paragraph_1_link_1: "here",
    consumer_pages_about_contact_support_paragraph_2: "Contact our support telephone number to get help with technical support, billing, and general information in English and Spanish.",
    consumer_pages_about_contact_support_us_header: "US Support: 1-877-211-2367",
    consumer_pages_about_contact_support_us_hours: "Hours:  8am-8pm ET Monday-Friday",
    consumer_pages_about_contact_support_uk_header: "UK Support: 0800.085.3492",
    consumer_pages_about_contact_support_uk_hours: "Hours: 8am-8pm ET Monday-Friday",
    consumer_pages_about_contact_support_collections_header: "Collections 1-855-255-7787",
    consumer_pages_about_contact_support_collections_hours: "Hours: 8:30am-5pm ET Monday-Friday",
    consumer_pages_about_personal_homeschool_h2: "Personal & Homeschool",
    consumer_pages_about_personal_homeschool_paragraph_part_1: "Check out our",
    consumer_pages_about_personal_homeschool_paragraph_link_1: "Frequently Asked Questions",
    consumer_pages_about_personal_homeschool_paragraph_part_2: "search our",
    consumer_pages_about_personal_homeschool_paragraph_link_2: "Customer Support Portal",
    consumer_pages_about_personal_homeschool_paragraph_part_3: "or contact us directly at",
    consumer_pages_about_personal_homeschool_paragraph_link_3: "support@rosettastone.com",
    consumer_pages_about_enterprise_education_h2: "Enterprise & Education",
    consumer_pages_about_enterprise_education_paragraph_part_1: "Interested in learning more? Submit a request for",
    consumer_pages_about_enterprise_education_paragraph_link_1: "K-12",
    consumer_pages_about_enterprise_education_paragraph_link_2: "Higher Education",
    consumer_pages_about_enterprise_education_paragraph_part_2: "or",
    consumer_pages_about_enterprise_education_paragraph_link_3: "organizations",
    consumer_pages_about_enterprise_education_paragraph_part_3: "of any size!",
    pages_consumer_discounts_frontline_meta_title: "Official Rosetta Stone® Frontline Discount",
    pages_consumer_discounts_frontline_meta_description: "Take advantage of our Rosetta Stone® frontline worker discount! Learn to speak a new language with our language-learning software.",
    pages_consumer_discounts_frontline_masthead_h1: "Frontline Heroes Discount",
    pages_consumer_discounts_frontline_masthead_p: "Am I eligible to claim a Frontline Worker discount? Check out these links:<ul><li><a rel='noopener noreferrer' href='https://help.id.me/hc/en-us/articles/360045444314-Am-I-eligible-to-verify-as-a-Medical-Provider-' target='blank'>Medical providers </a></li><li><a rel='noopener noreferrer' href='https://help.id.me/hc/en-us/articles/202293510-Am-I-eligible-to-verify-as-a-First-Responder-' target='_blank'>First responders</a></li></ul>",
    pages_consumer_discounts_frontline_centersection_h2: "Get Started",
    pages_consumer_discounts_frontline_centersection_p: "",
    pages_consumer_discounts_military_meta_title: "Official Rosetta Stone® Military Discount",
    pages_consumer_discounts_military_meta_description: "Rosetta Stone salutes our military heroes everywhere. Discounts available for current and Veteran members of the US Military, National Guard, and Reserves.",
    pages_consumer_discounts_military_masthead_h1: "Military Discount",
    pages_consumer_discounts_military_masthead_p: "Verify your eligibility to receive a special Military Discount",
    pages_consumer_discounts_military_centersection_h2: "Get Started",
    pages_consumer_discounts_military_centersection_p: "Veterans and Military pricing is available to current and Veteran members of the US and Canada Military, National Guard and Reserve immediate family members who reside in the same household",
    pages_consumer_discounts_student_meta_title: "Rosetta Stone® Student Discount",
    pages_consumer_discounts_student_meta_description: "Take advantage of our Rosetta Stone® student discount! Learn to speak a new language with our language-learning software.",
    pages_consumer_discounts_student_masthead_h1: "Student Discount",
    pages_consumer_discounts_student_masthead_p: "Verify your eligibility to receive a special Student Discount",
    pages_consumer_discounts_student_centersection_h2: "Get Started",
    pages_consumer_discounts_student_centersection_p: "Student pricing is available to students currently enrolled in a College or University",
    pages_consumer_discounts_teacher_meta_title: "Official Rosetta Stone® Teacher Discount",
    pages_consumer_discounts_teacher_meta_description: "Take advantage of our Rosetta Stone® teacher discount! Learn to speak a new language with our language-learning software.",
    pages_consumer_discounts_teacher_masthead_h1: "Teacher Discount",
    pages_consumer_discounts_teacher_masthead_p: "Check <a rel='noopener noreferrer' href='https://help.id.me/hc/en-us/articles/202674594-Am-I-eligible-for-the-Teacher-group-affiliation-' target='_blank'>here</a> to see if you are eligible for a teacher discount.",
    pages_consumer_discounts_teacher_centersection_h2: "Get Started",
    pages_consumer_discounts_teacher_centersection_p: "",
    consumer_features_ac_hero_h1: "Audio Companion",
    consumer_features_ac_hero_p_1: "Reinforce your language skills and complement your learning anywhere.",
    consumer_features_ac_lang_selector_p_1: "The Audio Companion, which can be downloaded and played offline on any MP3-capable audio device, enables you to practice course-content anytime—even while on the go. Use Audio Companion to practice pronunciation, vocabulary, phrases and other aspects of your language—wherever and whenever!",
    consumer_features_ac_lang_selector_p_2: "The Audio Companion is designed for convenient, hands-free learning. Whether you’re at home, traveling, or even in line at the grocery store, learning is easy—just plug in your ear buds and soak up the fun!",
    consumer_features_ac_lang_selector_p_3: "For even easier on-the-go learning and instant access to the Audio Companion, download our mobile app.",
    consumer_features_ac_lang_selector_mp3_p_1: "Download the MP3 files to your computer or preferred device:",
    consumer_features_ac_lang_selector_select_language: "Select the language you're learning:",
    consumer_features_ac_fundamentals_column_heading: "Fundamentals & Connection",
    consumer_features_ac_fundamentals_column_text: "Gain confidence by mastering basic conversational skills. This includes greetings, introductions, simple Q&As, and much more.",
    consumer_features_ac_level_1_text: "Level 1",
    consumer_features_ac_level_1_units_text: "Units 1 - 4",
    consumer_features_ac_level_1_language_basics_text: "Language Basics",
    consumer_features_ac_level_1_greetings_and_introductions_text: "Greetings & Introductions",
    consumer_features_ac_level_1_work_and_school_text: "Work & School",
    consumer_features_ac_level_1_shopping_text: "Shopping",
    consumer_features_ac_level_2_text: "Level 2",
    consumer_features_ac_level_2_units_text: "Units 5 - 8",
    consumer_features_ac_level_2_travel_text: "Travel",
    consumer_features_ac_level_2_past_and_future_text: "Past & Future",
    consumer_features_ac_level_2_friends_and_social_text: "Friends & Social",
    consumer_features_ac_level_2_dining_and_vacation_text: "Dining & Vacation",
    consumer_features_ac_exploration_column_heading: "Exploration & Clarity",
    consumer_features_ac_exploration_column_text: "Learn to navigate your environment and handle basic interactions. This includes giving and getting directions, using transportation, telling time, eating out and more.",
    consumer_features_ac_level_3_text: "Level 3",
    consumer_features_ac_level_3_units_text: "Units 9 - 12",
    consumer_features_ac_level_3_home_and_health_text: "Home & Health",
    consumer_features_ac_level_3_life_and_world_text: "Life & World",
    consumer_features_ac_level_3_everyday_things_text: "Everyday Things",
    consumer_features_ac_level_3_places_and_events_text: "Places & Events",
    consumer_features_ac_level_4_text: "Level 4",
    consumer_features_ac_level_4_units_text: "Units 13 - 16",
    consumer_features_ac_level_4_tourism_and_recreation_text: "Tourism & Recreation",
    consumer_features_ac_level_4_professions_and_hobbies_text: "Professions & Hobbies",
    consumer_features_ac_level_4_home_around_town_text: "At Home & Around Town",
    consumer_features_ac_level_4_style_and_wellness_text: "Style & Personal Wellness",
    consumer_features_ac_conversation_column_heading: "Conversation",
    consumer_features_ac_conversation_column_text: "Discuss Entertainment, culture, government, and the marketplace. Level 5 is the place to refine and perfect your conversation skills.",
    consumer_features_ac_level_5_text: "Level 5",
    consumer_features_ac_level_5_units_text: "Units 17 - 20",
    consumer_features_ac_level_5_business_and_industry_text: "Business & Industry",
    consumer_features_ac_level_5_art_and_academics_text: "Art & Academics",
    consumer_features_ac_level_5_emergency_situations_text: "Emergency Situations",
    consumer_features_ac_level_5_family_and_community_text: "Family & Community",
    consumer_features_ac_languages_arabic_name: "Arabic",
    consumer_features_ac_languages_arabic_value: "ARA",
    consumer_features_ac_languages_chinese_name: "Chinese",
    consumer_features_ac_languages_chinese_value: "CHI",
    consumer_features_ac_languages_dutch_name: "Dutch",
    consumer_features_ac_languages_dutch_value: "NED",
    consumer_features_ac_languages_american_english_name: "English (American)",
    consumer_features_ac_languages_american_english_value: "ENG",
    consumer_features_ac_languages_british_english_name: "English (British)",
    consumer_features_ac_languages_british_english_value: "EBR",
    consumer_features_ac_languages_farsi_name: "Farsi",
    consumer_features_ac_languages_farsi_value: "FAR",
    consumer_features_ac_languages_filipino_name: "Filipino (Tagalog)",
    consumer_features_ac_languages_filipino_value: "TGL",
    consumer_features_ac_languages_french_name: "French",
    consumer_features_ac_languages_french_value: "FRA",
    consumer_features_ac_languages_german_name: "German",
    consumer_features_ac_languages_german_value: "DEU",
    consumer_features_ac_languages_greek_name: "Greek",
    consumer_features_ac_languages_greek_value: "GRK",
    consumer_features_ac_languages_hebrew_name: "Hebrew",
    consumer_features_ac_languages_hebrew_value: "HEB",
    consumer_features_ac_languages_hindi_name: "Hindi",
    consumer_features_ac_languages_hindi_value: "HIN",
    consumer_features_ac_languages_irish_name: "Irish",
    consumer_features_ac_languages_irish_value: "GLE",
    consumer_features_ac_languages_italian_name: "Italian",
    consumer_features_ac_languages_italian_value: "ITA",
    consumer_features_ac_languages_japanese_name: "Japanese",
    consumer_features_ac_languages_japanese_value: "JPN",
    consumer_features_ac_languages_korean_name: "Korean",
    consumer_features_ac_languages_korean_value: "KOR",
    consumer_features_ac_languages_latin_name: "Latin",
    consumer_features_ac_languages_latin_value: "LAT",
    consumer_features_ac_languages_polish_name: "Polish",
    consumer_features_ac_languages_polish_value: "POL",
    consumer_features_ac_languages_portuguese_name: "Portuguese",
    consumer_features_ac_languages_portuguese_value: "POR",
    consumer_features_ac_languages_russian_name: "Russian",
    consumer_features_ac_languages_russian_value: "RUS",
    consumer_features_ac_languages_latam_espanol_name: "Spanish (Latin America)",
    consumer_features_ac_languages_latam_espanol_value: "ESP",
    consumer_features_ac_languages_spain_espanol_name: "Spanish (Spain)",
    consumer_features_ac_languages_spain_espanol_value: "ESC",
    consumer_features_ac_languages_swedish_name: "Swedish",
    consumer_features_ac_languages_swedish_value: "SVE",
    consumer_features_ac_languages_turkish_name: "Turkish",
    consumer_features_ac_languages_turkish_value: "TUR",
    consumer_features_ac_languages_vietnamese_name: "Vietnamese",
    consumer_features_ac_languages_vietnamese_value: "VIE",
    opdemo2_hero_heading: "TRY ROSETTA STONE FOR FREE",
    opdemo2_hero_subheading: "Take our language learning demo. Discover the power of Rosetta Stone.",
    opdemo2_button_heading: "Ready for a free demo?",
    opdemo2_button_custom_cta_text: "START FREE TRIAL",
    opdemo2_top_section_one_title_content: "The best way to learn a language is to surround yourself with it, so our Dynamic Immersion® method does just that.",
    opdemo2_top_section_one_body_content: "Our language learning program is the result of 20+ years of extensive research. Meticulously crafted by our expert linguists, each of our courses presents information for optimal impact and performance, leading to quick results.",
    opdemo2_top_section_two_title_content: "TruAccent® speech recognition technology",
    opdemo2_top_section_two_body_content: "Your accent matters. Our patented speech engine instantly compares your voice to thousands of native and non-native speakers, so you get real-time feedback for the most accurate pronunciation. It’s also adjustable, which allows you to fine-tune your accent.",
    opdemo2_top_section_three_title_content: "Speak up before you head out",
    opdemo2_top_section_three_body_content: "It can feel daunting to speak up in public, but confidence comes from practice. That’s why Rosetta Stone has Live Tutoring sessions with native-speaking tutors to help along the way. Available for in-product purchase.",
    opdemo2_top_section_four_title_content: "Audio Companion® lessons",
    opdemo2_top_section_four_body_content: "Conveniently listen and learn offline with downloadable Audio Companion® lessons.",
    opdemo2_top_section_five_title_content: "Anywhere, anytime lessons.",
    opdemo2_top_section_five_body_content: "Pick up where you left off with lessons that never leave your side—from your desktop, tablet, or smartphone. Perfect for learning at your own pace.",
    opdemo2_bottom_section_title_heading: "We're always improving our mobile learning tools.",
    opdemo2_bottom_section_feature_bullet_one_heading: "Don't get lost in translation*.",
    opdemo2_bottom_section_feature_bullet_one_subheading: "If you’re stuck on a word, you can now instantly translate it––so you can get back to learning, fast.",
    opdemo2_bottom_section_feature_bullet_two_heading: "Learn using your surroundings.",
    opdemo2_bottom_section_feature_bullet_two_subheading: "Seek & Speak† turns everyday objects into conversation practice with scavenger-hunt style challenges.",
    opdemo2_bottom_section_feature_bullet_three_heading: "Set your lessons to your lifestyle.**",
    opdemo2_bottom_section_feature_bullet_three_subheading: "Language confidence comes with practice, so Your Plan is designed with you in mind. Focus your lessons on relevant material, get motivational reminders, and keep up the good work.",
    opdemo2_bottom_section_feature_bullet_four_subheading: "* Available for Unit 1 of English, French German, Italian, and Spanish (Latin America)",
    opdemo2_bottom_section_feature_bullet_five_subheading: "** Available on Android devices.",
    opdemo2_bottom_section_feature_bullet_six_subheading: "†Available in select languages on iOS. Android coming soon.",
    opdemo2_unit_card_one_unit_content: "Unit 1",
    opdemo2_unit_card_one_description_content: "Language Basics",
    opdemo2_unit_card_two_unit_content: "Unit 2",
    opdemo2_unit_card_two_description_content: "Greetings and Introductions",
    opdemo2_unit_card_three_unit_content: "Unit 3",
    opdemo2_unit_card_three_description_content: "Work and School",
    opdemo2_unit_card_four_unit_content: "Unit 4",
    opdemo2_unit_card_four_description_content: "Shopping",
    opdemo2_unit_card_five_unit_content: "Unit 5",
    opdemo2_unit_card_five_description_content: "Travel",
    opdemo2_unit_card_six_unit_content: "Unit 6",
    opdemo2_unit_card_six_description_content: "Past & Future",
    opdemo2_unit_card_seven_unit_content: "Unit 7",
    opdemo2_unit_card_seven_description_content: "Friends & Social Life",
    opdemo2_unit_card_eight_unit_content: "Unit 8",
    opdemo2_unit_card_eight_description_content: "Dining & Vacation",
    opdemo2_unit_card_nine_unit_content: "Unit 9",
    opdemo2_unit_card_nine_description_content: "Home & Health",
    opdemo2_unit_card_ten_unit_content: "Unit 10",
    opdemo2_unit_card_ten_description_content: "Life & World",
    opdemo2_unit_card_eleven_unit_content: "Unit 11",
    opdemo2_unit_card_eleven_description_content: "Everyday Things",
    opdemo2_unit_card_twelve_unit_content: "Unit 12",
    opdemo2_unit_card_twelve_description_content: "Places & Events",
    opdemo2_unit_card_thirteen_unit_content: "Unit 13",
    opdemo2_unit_card_thirteen_description_content: "Tourism & Recreation",
    opdemo2_unit_card_fourteen_unit_content: "Unit 14",
    opdemo2_unit_card_fourteen_description_content: "Professions & Hobbies",
    opdemo2_unit_card_fifteen_unit_content: "Unit 15",
    opdemo2_unit_card_fifteen_description_content: "Greetings and Introductions",
    opdemo2_unit_card_sixteen_unit_content: "Unit 16",
    opdemo2_unit_card_sixteen_description_content: "Style & Personal Wellness",
    opdemo2_unit_card_seventeen_unit_content: "Unit 17",
    opdemo2_unit_card_seventeen_description_content: "Business & Industry",
    opdemo2_unit_card_eighteen_unit_content: "Unit 18",
    opdemo2_unit_card_eighteen_description_content: "Arts & Academics",
    opdemo2_unit_card_nineteen_unit_content: "Unit 19",
    opdemo2_unit_card_nineteen_description_content: "Emergency Situations",
    opdemo2_unit_card_twenty_unit_content: "Unit 20",
    opdemo2_unit_card_twenty_description_content: "Family & Community",
    consumer_legal_accessibility_title: "Web Accessibility Statement",
    consumer_legal_accessibility_content_1: "Rosetta Stone wants its website to be accessible to all of its customers. As a result, Rosetta Stone makes every effort necessary to meet the online usability and design requirements recommended by the World Wide Web Consortium (W3C) in its Web Content Accessibility Guidelines 2.0 Level AA (WCAG 2.0 AA).",
    consumer_legal_accessibility_content_2: "Rosetta Stone's website will be tested on a periodic basis with various assistive technologies such as screen readers and screen magnifiers, and with users with disabilities who use these technologies.",
    consumer_legal_accessibility_content_3: "Please be aware that our efforts are ongoing. If information on a Rosetta Stone web page is not accessible to you, please contact us at <a href='tel:+18007673882'>1-800-767-3882</a> or <a href='mailto:accessibility@rosettastone.com'>accessibility@rosettastone.com</a>. Rosetta Stone will make all reasonable efforts to make that page accessible for you.",
    consumer_legal_agreements_hero_heading: "Agreements",
    consumer_legal_agreements_hero_p_1: "Most files are in PDF format. You will need Acrobat Reader in order to view or print them. Download it <a rel='nofollow' target='_blank' href='https://get.adobe.com/reader/'>here</a>.",
    consumer_legal_agreements_section_1_title: "Agreements",
    consumer_legal_agreements_section_1_link_1_title: "Privacy Policy",
    consumer_legal_agreements_section_1_link_1_url: "https://rosettastone.com/privacy/",
    consumer_legal_agreements_section_1_link_2_title: "Purchase Terms & Conditions",
    consumer_legal_agreements_section_1_link_2_url: "https://www.rosettastone.com/purchase-terms/",
    consumer_legal_agreements_section_1_link_3_title: "Website Terms & Conditions",
    consumer_legal_agreements_section_1_link_3_url: "https://www.rosettastone.com/terms/",
    consumer_legal_agreements_section_1_link_4_title: "Purchase Order Terms & Conditions",
    consumer_legal_agreements_section_1_link_4_url: "https://www.rosettastone.com/purchase-order-terms/",
    consumer_legal_agreements_section_1_link_5_title: "Trademark Usage Guidelines",
    consumer_legal_agreements_section_1_link_5_url: "https://www.rosettastone.com/trademark-guidelines/",
    consumer_legal_agreements_section_1_link_6_title: "Social Media and Community Guidelines",
    consumer_legal_agreements_section_1_link_6_url: "https://www.rosettastone.com/social-media-guidelines/",
    consumer_legal_agreements_section_2_title: "Product Agreements",
    consumer_legal_agreements_section_2_link_1_title: "Terms of Use",
    consumer_legal_agreements_section_2_link_1_url: "https://rosettastone.com/termsonline/",
    consumer_legal_agreements_section_2_link_2_title: "Online Interactive Product Privacy Policy",
    consumer_legal_agreements_section_2_link_2_url: "https://www.rosettastone.com/interactiveproductprivacy/",
    consumer_legal_agreements_section_2_link_3_title: "End User License Agreement",
    consumer_legal_agreements_section_2_link_3_url: "https://www.rosettastone.com/rseula/",
    consumer_legal_agreements_section_2_link_4_title: "Enterprise License Agreement",
    consumer_legal_agreements_section_2_link_4_url: "https://www.rosettastone.com/rsela/",
    consumer_legal_agreements_section_2_link_5_title: "K-12 Education License Agreement",
    consumer_legal_agreements_section_2_link_5_url: "https://www.rosettastone.com/k12-license/",
    consumer_legal_agreements_section_2_link_6_title: "Rosetta Stone E&E Data Processing Addendum",
    consumer_legal_agreements_section_2_link_6_url: "https://www.rosettastone.com/rs-dpa/",
    consumer_legal_agreements_section_2_link_7_title: "Student Records Privacy Statement",
    consumer_legal_agreements_section_2_link_7_url: "https://www.rosettastone.com/student-records/",
    consumer_legal_ccpa_heading: "CALIFORNIA <br /> DO NOT SELL MY PERSONAL INFORMATION PAGE",
    consumer_legal_ccpa_heading_p_1: "This page applies to Consumers residing in California as defined by the California Consumer Privacy Act (CCPA)",
    consumer_legal_ccpa_heading_p_2: "If you reside in California, we are required to provide additional information to you about how we use and disclose your information. We have included this California-specific information in our Privacy Policy, accessible <a href='https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf#page=5' target='_blank' rel='noreferrer'>here</a> or using the link showing below.",
    consumer_legal_ccpa_cookie_heading: "Cookies",
    consumer_legal_ccpa_cookie_p_1: "<p>When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience.</p>",
    consumer_legal_ccpa_cookie_p_2: "<p>Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.</p>",
    consumer_legal_ccpa_cookie_p_3: "<p>You can also disable the use of cookies via your browser, but please note that our website may no longer work properly.</p>",
    consumer_legal_ccpa_cookie_p_4: "<p>If you are a California resident and want to exercise the right to opt out of the sale of your personal information by Rosetta Stone to third parties or want to exercise other rights granted to California residents, please click here: <a href='https://privacyportal-cdn.onetrust.com/dsarwebform/27aac3ab-c36e-4457-81d4-9773ba27887e/a4611d02-cd40-4c80-8efb-af97324e0cc4.html' target='_blank' rel='noreferrer'>OneTrust Data Subject Access Request</a></p>",
    consumer_legal_ccpa_cookie_p_5: "<p>This link allows you to make a verifiable opt-out request</p>",
    consumer_legal_ccpa_cookie_p_6: "<p>We will not ask you to create an account in order to complete the opt-out process, and we will use information gathered during the opt-out process from you for the purpose of complying with the opt-out request.</p>",
    consumer_legal_privacy_shield_heading: "EU — US AND SWISS — US PRIVACY SHIELD",
    consumer_legal_privacy_shield_heading_p_1: "EU—US AND SWISS—US PRIVACY SHIELD FRAMEWORKS & THE GENERAL DATA PROTECTION REGULATION",
    consumer_legal_privacy_shield_body_p_1: "Rosetta Stone LLC (the \"Company\") participates in the EU-US and Swiss-US Privacy Shield Frameworks (the \"Frameworks\"). Company's participation in the Frameworks applies to personal data received in the United States from the European Union and Switzerland (collectively, \"Europe\") about employees/contractors/job applicants (\"European Human Resources Data\"), corporate customer contacts and consumers (\"European Customer Data\"), and corporate customer's end-users (\"European End User Data\") (collectively, \"European Personal Data\"). We are committed to meeting the requirements of the GDPR and to subjecting such European Personal Data to the Frameworks, including its Principles of Notice, Choice, Accountability for Onward Transfer, Security, Data Integrity and Purpose Limitation, Access, and Recourse, Enforcement and Liability. To learn more about the Frameworks, visit the US Department of Commerce's Privacy Shield <a href='https://www.privacyshield.gov/welcome' target='_blank' rel='noreferrer'>here</a>.",
    consumer_legal_privacy_shield_heading_p_2: "European Personal Data Collection, Use, and Disclosure",
    consumer_legal_privacy_shield_body_p_2_1: "European Customer Data: The types of European Customer Data that we collect, the purposes for which we collect and use such data, and the types of third parties to which we disclose such data and the purposes of such disclosures, are the same as specified in our <a href='https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf' target='_blank' rel='noreferrer'>Website Privacy Policy</a>.",
    consumer_legal_privacy_shield_body_p_2_2: "European End User Data: We operate as a processor acting on behalf of our corporate customers regarding the collection, use, and disclosure of European End User Data. If you are an end user of one of our corporate customers, please consult the privacy policies of that entity for information about its privacy practices.",
    consumer_legal_privacy_shield_body_p_2_3: "European Human Resources Data: We provide notice to European employees and other covered individuals about the collection, use, and disclosure of their European Human Resources Data through internal company policies.",
    consumer_legal_privacy_shield_heading_p_3: "Rights of European Data Subjects - GDPR",
    consumer_legal_privacy_shield_body_p_3_1: "If you are a European data subject, you have the right to obtain confirmation of the existence of certain Personal Data relating to you, to verify its content, origin, and accuracy, as well as the right to access, review, port, delete, or to block or withdraw consent to the processing of certain Personal Data (without affecting the lawfulness of processing based on consent before its withdrawal), subject to certain limitations, such as where the legitimate rights of other persons would be infringed or where the burden or expense, for example, of providing access, would be disproportionate. If you wish to exercise such rights, please contact us as described below. In particular, you have the right to object to our use of Personal Data for direct marketing and in certain other situations at any time. Contact us below for more details. Please note that certain Personal Data may be retained as required or permitted by applicable law.",
    consumer_legal_privacy_shield_body_p_3_2: "Please note that if you are an End User receiving access to our services through a Corporate, Governmental, Educational or other Organizational Enterprise Client of Rosetta Stone, and you wish to request access, limit use, limit disclosure or remove your End User Personal Data, please contact the Enterprise Client organization that submitted your personal data to us, and we will support them as needed in responding to your request.",
    consumer_legal_privacy_shield_heading_p_4: "Choices of European Data",
    consumer_legal_privacy_shield_body_p_4_1: "You can access or update your personal information by sending an email to the privacy team at <a target='_blank' href='mailto:privacyofficer@rosettastone.com'>privacyofficer@rosettastone.com</a>. If you are a European resident with questions regarding your rights in your European Personal Data under GDPR, please contact the Rosetta Stone Data Protection Officer, Sofia Simoes, by email at <a target='_blank' href='mailto:DPO@rosettastone.com'>DPO@rosettastone.com</a>. Corporate customer contacts and individual consumers have the right to exercise choice (opt-out) from our use of their European Customer Data for direct marketing purposes. To exercise this right, please follow the instructions in any direct marketing message you may have received or contact us at <a target='_blank' href='mailto:privacyofficer@rosettastone.com'>privacyofficer@rosettastone.com</a>. We do not otherwise use or disclose European Customer Data and European End User Data in a manner that is subject to choice requirements under the Frameworks unless noted. We describe the choices for European Human Resources Data through internal company policies.",
    consumer_legal_privacy_shield_heading_p_5: "Recourse, Enforcement, and Liability",
    consumer_legal_privacy_shield_body_p_5_1: "Please contact us as specified below if you have any questions, need access to your European Personal Data, or otherwise need assistance. We remain responsible for our collection, use and disclosure of European Personal Data in accordance with the Frameworks. We also are responsible for third party agents that are processing such data on our behalf, unless we prove that we are not responsible for the event giving rise to the damage. In certain situations, we may be required to disclose European Personal Data in response to lawful requests by public authorities, including meeting national security or law enforcement requirements.",
    consumer_legal_privacy_shield_body_p_5_2: "If you have an unresolved concern about European Personal Data that we have not addressed satisfactorily, we have committed to cooperate with the panels established by the EU data protection authorities (DPAs) and the Swiss Federal Data Protection and Information Commissioner (FDPIC) to serve as our independent dispute resolution bodies for the Frameworks. We are also subject to the investigatory and enforcement powers of the Federal Trade Commission with respect to the Frameworks. In addition, under certain conditions, more fully described on the Privacy <a href='https://www.privacyshield.gov/article?id=How-to-Submit-a-Complaint' target='_blank' rel='noreferrer'>website</a>, European residents may invoke binding arbitration for non-monetary issues when other dispute resolution procedures have been exhausted.",
    consumer_legal_privacy_shield_heading_p_6: "Contact Us\n",
    consumer_legal_privacy_shield_body_p_6_1: "Please contact us at <a target='_blank' href='mailto:privacyofficer@rosettastone.com'>privacyofficer@rosettastone.com</a> if you have any questions, wish to exercise your rights of access, or seek other assistance as described above.",
    consumer_legal_dpas_hero_heading: "Data Privacy and Security",
    consumer_legal_dpas_hero_heading_body: "<p>The privacy of our customers and users is important to us.</p>" +
        "<p>We’ve broken down the basics of our data privacy and security practices here, so you can be better informed about them.</p>",
    consumer_legal_dpas_our_commitment_title: "Our Commitment.",
    consumer_legal_dpas_our_commitment_body: "At Rosetta Stone, we are committed to safeguarding our customers' privacy while providing a personalized and valuable  service. As reflected in our privacy policies, we use personal data of our customers and users to provide support and continually improve our language and literacy products and services, and to inform our customers and users about those products and services. We are committed to protecting the privacy and security of the personal data of our customers and users, and to working with service provider partners that are similarly committed to the protection and privacy of personal data they process on our behalf.",
    consumer_legal_dpas_info_tech_title: "Information Technology and Security Practices and Protection",
    consumer_legal_dpas_info_tech_body_1: "A robust information security program is integral to any company-wide commitment to data privacy. Our information security program is designed to reflect our commitment to safeguarding the personal information we receive in an appropriate manner while providing tailored and valuable services. We review our information security program at least annually, with the goal of continually updating or modifying our policies, procedures, and/or the security measures within our information security program to enable us to continue to improve the overall security of our products, services, information systems and operations.",
    consumer_legal_dpas_info_tech_body_2: "Our information security program is designed to incorporate and address physical, administrative, and technical and organizational security measures in a manner appropriate to the size and complexity of our company, the nature and scope of our services and activities, and the sensitivity of the personal data we process.  Under our program, technical and organizational measures for protecting data within our systems include: (i) firewalls and threat detections systems to identify malicious connection attempts to block spam, viruses and unauthorized intrusion: (ii) physical networking technology designed to resist attacks by malicious users or malicious code;and (iii) encryption of data while in transit over public networks using industry standard protocols.",
    consumer_legal_dpas_info_tech_body_3: "As part of our information security program, we undergo various annual corporate audits and reviews (e.g., PCI-DSS certifications, etc.), and our overall information security program and our technical and organizational security measures are SOC 2 audited annually  to assess and confirm the design and implementation of our information security program. A report detailing the results of our SOC 2 audit is available <a target='_blank' href='https://resources.rosettastone.com/CDN/us/pdfs/Rosetta%20Stone-2020-Type%202%20SOC%203-Final%20Report.pdf'>here</a>. In addition, we continually monitor for compliance and conduct additional internal reviews to identify potential gaps or areas of improvement to protect against reasonably foreseeable internal and external threats to the security, confidentiality, and integrity of the personal data that could result in the loss, misuse, unauthorized access, disclosure, alteration, or destruction of the personal data and/or Rosetta Stone's hardware or software on which such personal data resides.",
    consumer_legal_dpas_info_tech_body_4: "We require the data center, colocation and cloud hosting providers that we utilize to deliver and support our products and services to our customers and users to maintain ISO 27000 series certification and/or undergo SOC 2 or successor standard information security audits annually, confirming their implementation of  appropriate solutions and approaches to providing layered security and monitoring, including policies, procedures, and physical and logical controls to protect the security, integrity and availability of data.",
    consumer_legal_dpas_training_title: "Training",
    consumer_legal_dpas_training_body_1: "To ensure that data privacy and security remain a top priority, all employees receive mandatory data privacy and security awareness training annually, with additional targeted data privacy and security training provided to specific practice groups and individuals throughout the year.",
    consumer_legal_dpas_oversight_title: "Oversight",
    consumer_legal_dpas_oversight_body_1: "To help enhance and ensure oversight and accountability within our organization, we’ve appointed a Data Protection Officer responsible for the oversight of data privacy and security awareness and leading our compliance efforts. Our Data Protection Officer reports directly to the Rosetta Stone executive management team, where information security is regularly discussed.",
    consumer_legal_dpas_faq_item_1_title: "<h4>Resources</h4>",
    consumer_legal_dpas_faq_item_1_content_title: "<h4>Privacy Policy</h4>",
    consumer_legal_dpas_faq_item_1_content_1_body: "<p>Further detailed information on data processing, cookies, and our practices for data privacy and security is available from the privacy policy found on each Rosetta Stone website and within the applicable Rosetta Stone product or application. We review our privacy policies and commitments at least annually, and, if we should make any material changes to those privacy commitments, we will notify our customers and users by email, prominent notice on the website, or as otherwise provided in the policy.</p>",
    consumer_legal_dpas_faq_item_2_title: "<h4>Subject Access Requests</h4>",
    consumer_legal_dpas_faq_item_2_content_1_body: "<p>As provided under applicable laws, (notably, as examples, under the E.U. General Data Protection Regulation (GDPR) and/or the California Consumer Privacy Act (CCPA), individuals (“data subjects”) subject to such laws have  specific rights  with respect to controlling their own personal data, which rights may include, but not be limited to, the right to request access to, correction, deletion or export of, or restriction on certain uses of, their personal information.</p>",
    consumer_legal_dpas_faq_item_2_content_2_body: "<p>We have implemented procedures to efficiently intake, track, and address these Subject Access Requests, in accordance with legal requirements. Information, instructions, and links to submit a Subject Access Request are available on our websites and in our privacy policies.</p>",
    consumer_legal_dpas_faq_item_3_title: "<h4>Enterprise Accounts</h4>",
    consumer_legal_dpas_faq_item_3_content_1_body: "<p>In addition to licensing product subscriptions directly to individual consumer users, Rosetta Stone has designed and licenses certain of its language-learning solutions for use under an Enterprise licensing model.</p>",
    consumer_legal_dpas_faq_item_3_content_2_title: "<h4>Data Controller / Data Processor</h4>",
    consumer_legal_dpas_faq_item_3_content_2_body: "<p>If you are a corporate, educational, government and other institution that licenses access to our products for your users under an enterprise model, your organization is and remains the controller of the personal data of all of your organization’s users.  Rosetta Stone acts and complies with its obligations as a data processor, under the direction and instructions of our enterprise clients as reflected in our Enterprise license and service agreement, and our Data Processing Addendum, which is incorporated into our Enterprise license terms.</p>",
    consumer_legal_dpas_faq_item_3_content_3_title: "<h4>Rosetta Stone Enterprise Solutions: subprocessors</h4>",
    consumer_legal_dpas_faq_item_3_content_3_body: "<p>Rosetta Stone utilizes certain service provider subprocessors and/or affiliates to enable us to provision and support our enterprise products and services to all of our enterprise licensees and their learners.  Our service providers are carefully selected and engaged under contractual commitments of data privacy, security and data processing, and compliance obligations that support our obligations to our enterprise clients. Consistent with our own obligations, we remain responsible to our enterprise clients for our service provider subprocessors with respect to their role in supporting our products and services to our clients. If you are an enterprise client and would like to see the current list of subprocessors for our Rosetta Stone Language Enterprise products and services, please <a href='https://support.rosettastone.com/s/article/Enterprise-and-Education-Subprocessors?language=en_US' target='_blank'>Click Here.</a> If you would like to subscribe to receive notifications to any update to this list, please <a href='https://support.rosettastone.com/s/subscribetosubprocessors?language=en_US' target='_blank'>Click Here</a>.</p>",
    consumer_legal_dpas_faq_item_4_title: "<h4>Government Information Requests</h4>",
    consumer_legal_dpas_faq_item_4_content_1_body: "<p>We are committed to maintaining the privacy of our customers while also honoring proper legal requests for data and cooperating with the appropriate law enforcement. Rosetta Stone will only respond to formal, legitimate, and mandatory legal orders for production of data by the appropriate official law enforcement entity or agency. Rosetta Stone reviews all requests to ensure that procedures have been followed and the request includes all requisite identifying information to accurately and narrowly identify the information to be produced.</p>",
    consumer_legal_dpas_faq_item_4_content_2_body: "<p>If proper procedure and support is presented, Rosetta Stone will strictly limit the disclosure of information to the scope of the order, and may choose to redact portions where appropriate or request a protective order if necessary to keep the information confidential.</p>",
    consumer_legal_dpas_faq_item_4_content_3_body: "<p>To the extent legally permitted, Rosetta Stone shall promptly notify an individual if it receives a legally binding request or demand from any law enforcement agency, governmental agency, court, or other authority for any Personal Data provided to us.</p>",
    consumer_legal_dpas_faq_item_5_title: "<h4>Helpful Tips to Maintain Account Security</h4>",
    consumer_legal_dpas_faq_item_5_content_1_body: "<p>We encourage all of our customers to take precautions to protect their accounts and personal information.</p>",
    consumer_legal_dpas_faq_item_5_content_2_title: "<h4>Phishing</h4>",
    consumer_legal_dpas_faq_item_5_content_2_body: "<ul><li>Do not click on links or attachments in an email that seem questionable to you</li><li>Keep your antivirus software up to date as it will help to detect and block malware</li></ul>",
    consumer_legal_dpas_faq_item_5_content_3_title: "<h4>Passwords<h4>",
    consumer_legal_dpas_faq_item_5_content_3_body: "<ul><li>Keep your passwords private and do not share them with anyone</li><li>When creating a password, do not use anything that could be easily determined from information on your social media or other public information</li><li>Do not repeat the same password for multiple accounts</li></ul>",
    consumer_legal_dpas_faq_item_5_content_4_body: "<p>Visit the <a target='_blank' href='https://www.consumer.ftc.gov/articles/0272-how-keep-your-personal-information-secure'>Federal Trade Commission</a> website for even more in-depth tips and resources on keeping your information and technology secure.</p>",
    consumer_legal_dpas_faq_item_5_content_5_body: "<p><a target='_blank' href='https://staysafeonline.org/stay-safe-online/'>StaySafeOnline</a> provides practical tips and resources from the federal government and the technology industry.</p>",
    consumer_legal_dpas_faq_item_5_content_6_body: "<p>For practical tips for businesses on creating and implementing a plan for safeguarding personal information, the Federal Trade Commission has provided helpful guidance, available at <a target='_blank' href='https://www.ftc.gov/tips-advice/business-center/guidance/protecting-personal-information-guide-business'>https://www.ftc.gov/tips-advice/business-center/guidance/protecting-personal-information-guide-business</a>.</p>",
    consumer_legal_dpas_faq_item_6_title: "<h4>Contact</h4>",
    consumer_legal_dpas_faq_item_6_content_1_body: "<p>If you have questions or would like additional information regarding Rosetta Stone’s privacy and security practices you may email us at <a target='_blank' href='mailto:privacyofficer@rosettastone.com'>privacyofficer@rosettastone.com</a>.</p>",
    consumer_product_awards_title_content: "Recent Awards",
    consumer_product_awards_body_content: "Rosetta Stone’s acclaimed program has helped millions of people learn how to speak new languages confidently.",
    consumer_product_awards_pcmag_imageLink: "https://www.pcmag.com/picks/the-best-language-learning-software",
    consumer_product_awards_pcmag_text: "PC Magazine’s Editors’ Choice Winner <br /> BEST LANGUAGE LEARNING SOFTWARE.",
    consumer_product_awards_pcmag_yearsInARow: "7 YEARS IN A ROW",
    consumer_product_awards_awardContent_h2: "Technology and education experts laud our program on iOS and Android.",
    consumer_product_awards_awardContent_h3: "Rosetta Stone app awards.",
    consumer_product_awards_awardContent_p: "Technology and education experts laud our program on iOS and Android.",
    consumer_product_awards_awardBoxes_redirect1: "https://edtechbreakthrough.com/2021-winners/",
    consumer_product_awards_awardBoxes_text1: "<p><b>2021 EdTech Breakthrough Awards</b> <br>Language Learning App of the Year</p>",
    consumer_product_awards_awardBoxes_redirect2: "https://bestmobileappawards.com/app-submission/rosetta-stone-learn-languages",
    consumer_product_awards_awardBoxes_text2: "<p><b>Best Designed Mobile App</b> <br>Best Mobile App Awards (Winter 2020)</p>",
    consumer_product_awards_awardBoxes_redirect3: "https://bestmobileappawards.com/app-submission/rosetta-stone-learn-language",
    consumer_product_awards_awardBoxes_text3: "<p><b>Platinum Award for Best Educational App</b> <br>Best Mobile App Awards (March 2019)</p>",
    consumer_product_awards_awardBoxes_redirect4: "https://edtechbreakthrough.com/2019-winners/",
    consumer_product_awards_awardBoxes_text4: "<p><b>2019 EdTech Breakthrough Awards</b> <br>Overall Language Learning Company of the Year</p>",
    consumer_product_awards_awardBoxes_redirect5: "https://bestmobileappawards.com/app-submission/rosetta-stone-learn-language",
    consumer_product_awards_awardBoxes_text5: "<p><b>Platinum Award for Best Educational App</b> <br>Best Mobile App Awards (March 2018)</p>",
    consumer_product_awards_awardBoxes_redirect6: "https://www.globenewswire.com/news-release/2019/01/17/1701233/0/en/The-Tabby-Awards-Recognize-Rosetta-Stone-for-Mobile-Innovation-Two-Years-in-a-Row.html",
    consumer_product_awards_awardBoxes_text6: "<p><b>2018 Tabby Awards</b> <br>iPhone &amp; Android App Education <br>Category Winner</p>",
    basics_faq_box_bullet_1_heading: "Does it work? What will I be able to do?",
    basics_faq_box_bullet_1_content: "<p>Yes, but with one small catch. You have to put in the work.<p><p>You’ll get help from our tried-and-true Dynamic Immersion® technology and a suite of tools designed to get you off the app and thriving in real life. The rest is up to you. </p>",
    basics_faq_box_bullet_2_heading: "I leave for my trip in two weeks. Is it too late to start using Rosetta Stone?",
    basics_faq_box_bullet_2_content: "<p>Not at all! In general, a slow and steady approach to learning beats cramming, but the most important thing is to start. </p> <p>Here’s what we recommend:</p><ul><li>First, check out Phrasebook, available with our most popular languages. Use it to access essential phrases and words and get instant feedback on your accent. We know you’ll nail it!  </li><li>Next, download a few units, so you can knock them out on the plane. Scared of disturbing a sleeping seatmate? You can temporarily turn off the speaking component. </li><li>Trying the language out in the real world is just as important as trying it out on the app. So be bold! Make friends. Ask to jump in. </li><li>Finally, have fun!</li></ul>",
    basics_faq_box_bullet_3_heading: "Can I change languages?",
    basics_faq_box_bullet_3_content: "<p>Rosetta Stone Unlimited members get full access to all our languages. You can find out how to sign up <a href='https://www.rosettastone.com/lp/sbsr/sitewide/'>here</a>. </p>",
    basics_faq_box_bullet_4_heading: "Why should I get Rosetta Stone when there are other, free alternatives?",
    basics_faq_box_bullet_4_content: "<p>If you made it to our FAQ page, chances are you already tried free, quick and easy. </p>" +
        "<p>With us, you’ll get useful content that’s crafted by linguists instead of crowd-sourced. You’ll get an immersive experience that mimics real life, instead of flashcards. And by pushing yourself during the lessons themselves, you’ll get to breathe easy when it comes to actual conversations.</p>",
    basics_faq_box_bullet_5_heading: "How much will I need to know in advance? Is there a placement test?",
    basics_faq_box_bullet_5_content: "<p>Join at any level. The first time you open the app, you’ll get a chance to choose a plan based on your experience and what you hope to get out of learning. </p>",
    basics_faq_box_bullet_6_heading: "How do I switch between the app and desktop?",
    basics_faq_box_bullet_6_content: "<p>Your progress syncs automatically across devices. All you need to do is sign in, and you can pick up wherever you left off. </p>",
    basics_faq_box_bullet_7_heading: "What comes with my subscription?",
    basics_faq_box_bullet_7_content: "<p>In addition to useful content and an immersive experience, you’ll also get a suite of tools developed to help you succeed in the real world. </p>",
    basics_faq_box_bullet_8_heading: "What is a Lifetime subscription?",
    basics_faq_box_bullet_8_content: "<ul><li>Our “Lifetime” subscription product means you can access the Rosetta Stone language product and services that you purchased, for as long as they’re available and supported by us. Read our <a href='https://resources.rosettastone.com/CDN/us/pdfs/US_Product_Purchase_Terms_and_Conditions_090116.pdf' target='_blank'>Terms &amp; Conditions</a> for details.</li><li>We’ll make sure you’ll know which products are marked as “Lifetime” before you check out.</li><li>Each license is for one person and cannot be transferred.</li></ul>" +
        "<ul style='list-style-type:none;'><li>Questions? Customer support is always here for you.</li><li> Contact <a target='_blank' href='mailto:help@rosettastone.com'>help@rosettastone.com</a> or 1-800-ROSETTA.</li></ul>",
    basics_faq_box_bullet_9_heading: "What is Seek & Speak®️ and why is it asking me to find a fruit?",
    basics_faq_box_bullet_9_content: "<p>Seek &amp; Speak®️ is a scavenger hunt powered by augmented reality. When you feel like you’ve been sitting down for too long, open it up and choose a challenge. It will send you on a hunt for something like fruit or tech devices. You snap a pic, it delivers a translation, and together you start building a conversation.</p>",
    basics_faq_box_bullet_10_heading: "How do I access lessons offline?",
    basics_faq_box_bullet_10_content: "<p>Once you open a Unit, you should see an option to “use offline” in the lower right-hand corner. Give that a tap, and you’ll have access anywhere, whether it’s a long flight or that part of your house that never seems to get service.</p>",
    basics_faq_box_bullet_11_heading: "I’d like to practice with a real person. How do I sign up for tutoring?",
    basics_faq_box_bullet_11_content: "<p>Once you’ve logged enough lessons, you’ll get a prompt to schedule a tutoring session. The first session is free. After that, they cost either $14 or $19 per session. No need to do anything special to prepare, just participate. This is currently available on desktop only. </p>",
    basics_faq_box_bullet_12_heading: "How often should I use Rosetta Stone?",
    basics_faq_box_bullet_12_content: "<p>We recommend five days a week, 30 minutes a day as part of our <a target='_blank' href='https://blog.rosettastone.com/learn-whats-most-relevant-first-with-your-plan/'>guided course</a>. </p>" +
        "<p>But you can go at whatever pace you’d like. </p>",
    basics_faq_box_bullet_13_heading: "What if I’m really bad at it? Like bowling. I’m terrible at bowling.",
    basics_faq_box_bullet_13_content: "<p>You might be! At first. Learning a new language is a skill, so it’s something you grow over time. We’ll be coaching you throughout the process with a personalized game plan, nuanced feedback on your accent, and even live tutoring. </p>" +
        "<p>And if you are a little bad at first? So what! Small mistakes are just good stories waiting to happen. </p>",
    free_trial_faq_box_bullet_1_heading: "I'm ready to get started! Where do I go?",
    free_trial_faq_box_bullet_1_content: "<p>Right <a href='https://www.rosettastone.com'>here!</a></p>",
    free_trial_faq_box_bullet_2_heading: "Will I get full access?",
    free_trial_faq_box_bullet_2_content: "You bet.",
    free_trial_faq_box_bullet_3_heading: "I got my subscription. Where do I go?",
    free_trial_faq_box_bullet_3_content: "<p><a href='https://www.rosettastone.com/product-activation/'>Right this way.</a></p>",
    free_trial_faq_box_bullet_4_heading: "Will I be charged after the trial is up? How much?",
    free_trial_faq_box_bullet_4_content: "<p>If you shared credit card information before starting your free trial, at the end of your trial, your credit card will be automatically charged for a 12-month subscription at MSRP. </p>" +
        "<p>Your subscription will automatically renew at the end of your subscription period, and you can  <a target='_blank' href='https://support.rosettastone.com/en/language-learning/articles/How-to-enroll-into-auto-renew'>opt-out of auto-renewal</a> at any time. Purchase terms of the respective app store apply to mobile app subscriptions.</p>",
    free_trial_faq_box_bullet_5_heading: "How do I cancel my free trial?",
    free_trial_faq_box_bullet_5_content: "<p>You can cancel at any time. More on that <a target='_blank' href='https://support.rosettastone.com/en/language-learning/articles/How-to-enroll-into-auto-renew/'>here.</a></p>",
    free_trial_faq_box_bullet_6_heading: "I didn't get a chance to use my free trial. Can I extend it?",
    free_trial_faq_box_bullet_6_content: "<p>Give our help center a call, and we’ll see what we can do.</p>" + "<p>1 (800) 767-3882</p>",
    free_trial_faq_box_bullet_7_heading: "Will I get a discount on my purchase after this trial?",
    free_trial_faq_box_bullet_7_content: "<p>You can find our current offers <a href='https://www.rosettastone.com/lp/sbsr/sitewide/'>here</a>.</p>",
    pricingAndReturns_faq_box_bullet_1_heading: "How much does this actually cost?",
    pricingAndReturns_faq_box_bullet_1_content: "<p>You can find the MSRP for each subscription and current offers <a href='https://www.rosettastone.com/lp/sbsr/sitewide/'>here</a>.</p>" +
        "<p>You can either pay the full cost up front, or pay over time with our 3-pay and 5-pay options available for certain subscriptions.  Pricing and payment options vary for mobile app purchases.</p>",
    pricingAndReturns_faq_box_bullet_2_heading: "What if I change my mind?",
    pricingAndReturns_faq_box_bullet_2_content: "<p>You can cancel your subscription within 30 days of purchase for a full refund or cancel before your subscription auto-renews.</p>" +
        "<p>Love Rosetta Stone, just don't have enough time to learn? You can always upgrade to our Lifetime Subscription, which offers the freedom to start and stop as often as you need.</p>",
    pricingAndReturns_faq_box_bullet_3_heading: "Can I change languages?",
    pricingAndReturns_faq_box_bullet_3_content: "<p>Rosetta Stone Unlimited members get full access to all our languages. You can find out how to sign up <a href='https://www.rosettastone.com/lp/sbsr/sitewide/'>here</a>. </p>",
    pricingAndReturns_faq_box_bullet_4_heading: "How does 3-pay work? 5-pay?",
    pricingAndReturns_faq_box_bullet_4_content: "<p>Our Easy Payment plans allow you to break down the cost of the product into as many as three smaller payments, rather than paying the total cost of the product at once. The plan is eligible when you purchase a product that is $99 or more.</p>" +
        "<p>The first payment (including any applicable shipping and tax on the total purchase price) will be charged at the time your order is placed. Thereafter, your account will be charged the appropriate amount every month until you have reached the end of the payment plan. Our Easy Payment plan offers 0% APR and no interest charged from Rosetta Stone. You can select the Easy Payment plan option at the time of purchase.</p>",
    pricingAndReturns_faq_box_bullet_5_heading: "What is Automatic Renewal?",
    pricingAndReturns_faq_box_bullet_5_content: "<p>By enrolling in automatic renewal, you authorize Rosetta Stone to automatically renew your online product subscription for additional subscription terms of the same length as the initial term purchased. </p>" +
        "<p>Contact Customer Service at <a target='_blank' href='https://support.rosettastone.com'>https://support.rosettastone.com</a> to cancel automatic renewal and stop additional charges from being made to your account at any time. Cancel within 30 days of automatic renewal to receive a refund of your renewal term purchase. Group Tutoring sessions will not automatically renew for additional periods and cannot be “rolled over.”</p>",
    pricingAndReturns_faq_box_bullet_6_heading: "I didn't mean to automatically enroll for a new subscription. Help!",
    pricingAndReturns_faq_box_bullet_6_content: "<p>You can unsubscribe at any time.</p>" +
        "<p>To disable the automatic renewal of your online subscription, simply follow these steps.</p>" +
        "<ul><li>Log in to your Rosetta Stone program.</li><li>On the top toolbar, click on your name, and select “My Account”.</li><li>The Summary tab will appear. This is where you will opt out of the auto-renewal feature. To do so, simply click “Cancel Subscription”. Once completed, your subscription will not renew after the expiration date.</li></ul>",
    technical_faq_box_bullet_1_heading: "Walk me through first time set-up.",
    technical_faq_box_bullet_1_content: "<p>If you are on desktop:</p>" +
        "<ul><li>Go to <a href='https://language.rosettastone.com'>https://language.rosettastone.com</a></li><li>Type in your email address and new password</li><li>Press set up</li><li>You will get a prompt to connect with your laptop or computer’s microphone</li><li>After that, you’re free to explore</li></ul>" +
        "<p>If you are on mobile:</p>" +
        "<ul><li>Search for Rosetta Stone on the Apple App Store or Google Play store</li><li>Tap Rosetta Stone</li><li>Tap Install to download the app</li><li>Follow the sign-in prompt</li></ul>",
    technical_faq_box_bullet_2_heading: "I got an activation code. Where do I enter it?",
    technical_faq_box_bullet_2_content: "<p>Redeem it here:<a href='https://www.rosettastone.com/product-activation'> https://www.rosettastone.com/product-activation</a></p>",
    technical_faq_box_bullet_3_heading: "I forgot my password.",
    technical_faq_box_bullet_3_content: "<p>Go to <a href='https://totale.rosettastone.com/'>totale.rosettastone.com</a> and click the “forgot password” link</p>",
    technical_faq_box_bullet_4_heading: "Do I need Flash?",
    technical_faq_box_bullet_4_content: "Nope!",
    technical_faq_box_bullet_5_heading: "My app is taking forever to open. What's the deal?",
    technical_faq_box_bullet_5_content: "<p>Try closing out a few of your tabs, including Rosetta Stone. If that doesn't work, you may want to restart your phone. And if that doesn't work, you can contact customer support by emailing <a target='_blank' href='mailto:support@rosettastone.com'>support@rosettastone.com</a>. </p>",
    technical_faq_box_bullet_6_heading: "Can I skip ahead?",
    technical_faq_box_bullet_6_content: "<p>Of course! Just click on the lesson you want to start and hop to it. You can always go back if you need to. </p>",
    technical_faq_box_bullet_7_heading: "How do I use the app offline?",
    technical_faq_box_bullet_7_content: "<ol><li>Open the app</li><li>Tap the “Learn” tab at the bottom of the screen.</li><li>Tap the Unit you’d like to download.</li><li>In the lower right-hand corner, you’ll see “use offline”. Tap on that and the prompt to “download”. </li><li>Your lessons should be downloaded and ready to use offline in as little as five seconds.</li></ol>" +
        "<p>In addition to lessons, you can also download features such as Phrasebook. After a month, they’ll undownload (is that a word? Yes, it is!) to free up storage on your phone. </p>",
    technical_faq_box_bullet_8_heading: "TruAccent isn't working. What do I do?",
    technical_faq_box_bullet_8_content: "<p>First, make sure you are in a quiet place. If that isn’t possible, you can always temporarily disable speech by pausing your lesson and tap the “disable” button next to the microphone. </p>" +
        "<p>From there:</p>" +
        "<ul><li>Navigate to the menu</li><li>Open Settings</li><li>Open Speech Settings</li><li>Confirm:<ul><li>Speech Recognition is ON (marked blue)</li><li>Speech Recognition Sensitivity is set to your comfort level</li><li>Voice Type is selected properly (Male/Female/Child)</li></ul></li></ul>",
    technical_faq_box_bullet_9_heading: "How do I save my progress?",
    technical_faq_box_bullet_9_content: "<p>We’ll automatically save your progress as you go, even if you switch devices.</p>",
    technical_faq_box_bullet_10_heading: "I don't see my question here. Help.",
    technical_faq_box_bullet_10_content: "<p>Two options. You can either head to our <a target='_blank' href='https://support.rosettastone.com/en'>Support Pages</a> where we offer far more comprehensive technical support, or you can reach customer support at <a target='_blank' href='mailto:support@rosettastone.com'>support@rosettastone.com</a>. And if you see a chat portal at the bottom of your screen, then you can also hit up one of our specialists right now. So, three options!</p>",
    mobile_apps_top_section_one_title_content: "Rosetta Stone app.",
    mobile_apps_top_section_one_body_content: "With a variety of speaking-focused lessons and features, instantaneous pronunciation feedback with TruAccent, a track record of getting people speaking confidently and a near-five star rating in the app store, the award-winning Rosetta Stone mobile app is the best way to learn new languages.",
    mobile_apps_top_section_one_custom_cta_text: "START PRACTICING",
    mobile_apps_top_section_two_title_content: "Rosetta Stone helps you speak confidently.",
    mobile_apps_top_section_two_body_content: "Why the Rosetta Stone app? Because the best way to learn a new language is to surround yourself with it, and Rosetta Stone’s Dynamic Immersion® method does just that. Interactive and contextual lessons blend with Extended Learning features that are literally at your fingertips–any time, anywhere, any device; online or off.",
    mobile_apps_top_section_two_feature_heading_content_one: "Speak confidently.",
    mobile_apps_top_section_two_feature_subheading_content_one: "TruAccent® technology provides real-time pronunciation feedback.",
    mobile_apps_top_section_two_feature_heading_content_two: "Go beyond memorization.",
    mobile_apps_top_section_two_feature_subheading_content_two: "Learn in context using our Dynamic Immersion® method.",
    mobile_apps_top_section_two_feature_heading_content_three: "Fits any schedule.",
    mobile_apps_top_section_two_feature_subheading_content_three: "Take a 10-minute lesson anywhere-online or off.",
    mobile_apps_top_section_two_feature_heading_content_four: "Never leaves your side.",
    mobile_apps_top_section_two_feature_subheading_content_four: "Practice here, there, and everywhere.",
    mobile_apps_top_section_two_feature_heading_content_five: "Don't get lost in translation.",
    mobile_apps_top_section_two_feature_subheading_content_five: "Touch and hold anything from your Core Lessons to reveal its translation*.",
    mobile_apps_top_section_two_feature_subheading_content_six: "*Available with select languages on the Rosetta Stone: Learn Languages app.",
    mobile_apps_top_section_three_title_content: "Extended Learning Features.",
    mobile_apps_top_section_three_body_content: "Why the Rosetta Stone app? Because the best way to learn a new language is to surround yourself with it, and Rosetta Stone’s Dynamic Immersion® method does just that. Interactive and contextual lessons blend with Extended Learning features that are literally at your fingertips–any time, anywhere, any device; online or off.",
    mobile_apps_top_section_three_feature_heading_content_one: "Say it like a local.",
    mobile_apps_top_section_three_feature_subheading_content_one: "Practice speaking by reading aloud while listening to native speakers with Stories.",
    mobile_apps_top_section_three_feature_heading_content_two: "Always know what to say.",
    mobile_apps_top_section_three_feature_subheading_content_two: "Get easy-to-understand greetings, phrases, expressions, and more with Phrasebook*. *Available on in select languages on the Rosetta Stone: Learn Languages app.",
    mobile_apps_top_section_three_feature_heading_content_three: "Train your ear.",
    mobile_apps_top_section_three_feature_subheading_content_three: "Take a break from the screen by listening to Audio Companion® lessons.",
    mobile_apps_bottom_section_one_title_content: "Need another reason?",
    mobile_apps_bottom_section_one_body_content: "Why the Rosetta Stone app? Because the best way to learn a new language is to surround yourself with it, and Rosetta Stone’s Dynamic Immersion® method does just that. Interactive and contextual lessons blend with Extended Learning features that are literally at your fingertips–any time, anywhere, any device; online or off.",
    mobile_apps_os_logos_title_content: "Get Rosetta Stone on all your devices.",
    mobile_apps_os_logos_subtitle_content: "Web or app, anytime, anywhere, online or off, your lessons are ready.",
    rosetta_stone_for_kids_top_section_one_title_content: "Rosetta Stone Kids®",
    rosetta_stone_for_kids_top_section_one_body_content: "Rosetta Stone Kids® makes language learning fun for kids with interactive reading, listening, speaking, and writing activities.  Choose from over 24 languages to begin your language learning adventure.",
    rosetta_stone_for_kids_top_section_one_custom_cta_text: "START FREE TRIAL",
    rosetta_stone_for_kids_disclaimer_statement: "Rosetta Stone® and Rosetta Stone Kids® are registered trademarks of Rosetta Stone LLC. Rosetta\n" +
        "                        Stone LLC is a division of IXL Learning.",
    rosetta_stone_for_kids_ixl_address: "IXL Learning, 777 Mariners Island Blvd #600, San Mateo, CA 94404"
};

var strings_es_419 = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "Árabe",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "Alemán",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "Griego",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "Inglés",
  locale_en_gb_label_secondary: "",
  locale_en_us_label_primary: "Inglés",
  locale_en_us_label_secondary: "Americano",
  locale_es_es_label_primary: "Español",
  locale_es_es_label_secondary: "España",
  locale_es_la_label_primary: "Español",
  locale_es_la_label_secondary: "Latinoamérica",
  locale_fa_ir_label_primary: "Persa",
  locale_fa_ir_label_secondary: "Farsi",
  locale_fr_fr_label_primary: "Francés",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "Irlandés",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "Hebreo",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "Italiano",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "Japonés",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "Coreano",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "Holandés",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "Polaco",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "Portugués",
  locale_pt_br_label_secondary: "",
  locale_ru_ru_label_primary: "Ruso",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "Sueco",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "Filipino",
  locale_tl_ph_label_secondary: "",
  locale_tr_tr_label_primary: "Turco",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "Vietnamita",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "Chino",
  locale_zn_cn_label_secondary: "Mandarin",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_blog_label: "Blog",
  nav_primary_catalog_label: "Idiomas Y Precios",
  nav_primary_catalog_select_language_label: "Selecciona un idioma:",
  nav_primary_contact_label: "",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "¿Preguntas? Llámenos",
  nav_primary_phone_number: "1 (800) 511-5689",
  nav_primary_sign_in_label: "INGRESAR",
  nav_primary_support_label: "Soporte",
  nav_primary_switch_language: "English",
  nav_primary_vertical_consumer_label: null,
  nav_primary_vertical_education_for_homeschool_label: "",
  nav_primary_vertical_education_for_students_label: "Para Estudiantes",
  nav_primary_vertical_education_homeschool_label: null,
  nav_primary_vertical_education_primary_label: "Para Educadores",
  nav_primary_vertical_education_secondary_label: "",
  nav_primary_vertical_education_students_label: "",
  nav_primary_vertical_enterprise_label: "Para Empresa",
  nav_primary_vertical_for_young_learners_label: "",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "Blog",
  nav_secondary_enterprise_custom_1_label: "Quiero ser Partner",
  nav_secondary_enterprise_home_label: "Inicio",
  nav_secondary_enterprise_label: "Empresa",
  nav_secondary_enterprise_resources_label: "Recursos",
  nav_secondary_enterprise_solutions_label: "Soluciones",
  // Solutions
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "Blog",
  nav_secondary_education_primary_custom_1_label: "Quiero ser Partner",
  nav_secondary_education_primary_home_label: "Inicio",
  nav_secondary_education_primary_label: "Educación",
  nav_secondary_education_primary_resources_label: "Recursos",
  nav_secondary_education_primary_solutions_label: "Soluciones",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "Blog",
  nav_secondary_education_secondary_custom_1_label: "Quiero ser Partner",
  nav_secondary_education_secondary_home_label: "Inicio",
  nav_secondary_education_secondary_label: "Educación Superior",
  nav_secondary_education_secondary_resources_label: "Recursos",
  nav_secondary_education_secondary_solutions_label: "Soluciones",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "",
  nav_secondary_education_homeschool_home_label: "",
  nav_secondary_education_homeschool_label: "",
  nav_secondary_education_homeschool_resources_label: "",
  nav_secondary_education_homeschool_solutions_label: "",
  // ******************************************
  // Nav Secondary - Services
  // ******************************************
  nav_secondary_services_blog_label: "",
  nav_secondary_services_home_label: "",
  nav_secondary_services_label: "",
  nav_secondary_services_resources_label: "",
  nav_secondary_services_solutions_label: "",
  // ******************************************
  // Shared - Awards
  // ******************************************
  awards_header_label: "Avalada durante 25+ años por las mejores organizaciones.",
  awards_bmw: "BMW",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "Qué dice la gente de nosotros.",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;<em>La joya de la corona</em>entre los métodos de aprendizaje de idiomas por ordenador.&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;”Me encanta el programa de Rosetta Stone y creo que su método para <em>aprender idiomas funciona.</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot; “Con su interfaz excelente para el usuario, instrucciones claras y una amplia gama de juegos y retos...  <em>Rosetta Stone sorprende.</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "",
  related_resources_button_label: "",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "¿Qué tipo de aprendiz eres?",
  verticals_education_primary: "Educación",
  verticals_education_secondary: "Educación Superior ",
  verticals_enterprise: "Empresa",
  verticals_publicsector: "",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "Sign Up",
  footer_cta_email_main_label: "Sign up to stay in touch.",
  footer_cta_email_placeholder: "Sign Up",
  footer_cta_email_sub_label: "Get Rosetta Stone news and offers.",
  footer_cta_form_comments: "",
  footer_cta_form_country: "País",
  footer_cta_form_email: "E-mail profesional",
  footer_cta_form_firstname: "Nombre",
  footer_cta_form_lastname: "Apellidos",
  footer_cta_form_organization: "Nombre de la Organización",
  footer_cta_form_organizationsize: "Tamaño de la organización",
  footer_cta_form_organizationsize_100: "100 o Menos",
  footer_cta_form_organizationsize_500: "101 - 500",
  footer_cta_form_organizationsize_1000: "501 - 1,000",
  footer_cta_form_organizationsize_5000: "1,001 - 5,000",
  footer_cta_form_organizationsize_10000: "5,001 - 10,000",
  footer_cta_form_organizationsize_25000: "10,001 - 25,000",
  footer_cta_form_organizationsize_50000: "25,001 - 50,000",
  footer_cta_form_organizationsize_more: "50,001 - Más",
  footer_cta_form_phone: "Numero de Teléfono (Opcional)",
  footer_cta_form_pricing_thanks: "¡Gracias por tu interés! Alguien hará un seguimiento contigo en breve.",
  footer_cta_form_role: "Rol (o título)",
  footer_cta_form_role_boardmember: "Miembro de la Junta",
  footer_cta_form_role_curriculumdirector: "Director de Currículo / Coordinador de Instrucción",
  footer_cta_form_role_director: "Director",
  footer_cta_form_role_executive: "Dirección General / Ejecutivo",
  footer_cta_form_role_individualcontributor: "Colaborador Individual",
  footer_cta_form_role_manager: "Gerente",
  footer_cta_form_role_principal: "Director de la Escuela",
  footer_cta_form_role_superintendent: "Superintendente / Administrador de Distrito",
  footer_cta_form_role_teacher: "Profesor",
  footer_cta_form_role_techcoordinator: "Coordinador de Tecnologia",
  footer_cta_form_role_vicepresident: "Vicepresidente",
  footer_cta_form_submit: "Consulta gratuita",
  footer_cta_how_hear_blog: "Blog",
  footer_cta_how_hear_email: "Email",
  footer_cta_how_hear_event: "Evento",
  footer_cta_how_hear_online: "En línea",
  footer_cta_how_hear_other: "Otro",
  footer_cta_how_hear_referral: "Remisión",
  footer_cta_how_hear_search: "Buscador",
  footer_cta_how_hear_social: "Medios Sociales",
  footer_cta_how_hear_title: "¿Como supiste de nosotros? (Opcional)",
  footer_cta_how_hear_webinar: "Seminario Web",
  footer_cta_opt_in_learn_more_button_text: " aquí",
  footer_cta_opt_in_learn_more_link_text_1: "aquí.",
  footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
  footer_cta_opt_in_learn_more_text_1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
  footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_text_3: ".",
  footer_cta_opt_in_text_after_button: "para más información.",
  footer_cta_opt_in_text_before_button: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic",
  footer_cta_pricing_button: "CONSULTA DE PRECIOS",
  footer_cta_pricing_label: "Listo para el siguiente paso?",
  footer_cta_pricing_subtitle: "Por favor complete y nos pondremos en contacto con usted de inmediato.",
  footer_cta_pricing_thanks: "",
  footer_cta_pricing_title: "Obtenga las respuestas de precios que necesita.",
  // Menu
  footer_menu_about_about_us_label: "Acerca de Nosotros",
  footer_menu_about_blog_label: "Blog",
  footer_menu_about_careers_label: "Empleo",
  footer_menu_about_contact_label: "Contáctanos",
  footer_menu_about_endangered_languages_label: "Idiomas en peligro de extinción",
  footer_menu_about_investor_relations_label: "Investor Relations",
  footer_menu_about_investors_label: "Relaciones con Inversores",
  footer_menu_about_k12_reading_label: "Reading Solutions for K–12",
  footer_menu_about_label: "Acerca de",
  footer_menu_about_press_label: "Prensa",
  footer_menu_about_retail_partners_label: "Tiendas Retail",
  footer_menu_buy_all_label: "Ver todos los idiomas",
  footer_menu_buy_chinese_label: "Comprar Chino",
  footer_menu_buy_english_label: "Comprar Inglés",
  footer_menu_buy_espanol_label: "Rosetta Stone Español",
  footer_menu_buy_french_label: "Comprar Francés",
  footer_menu_buy_german_label: "Comprar Alemán",
  footer_menu_buy_homeschool_label: "Rosetta Stone Homeschool",
  footer_menu_buy_ingles_label: "Inglés",
  footer_menu_buy_italian_label: "Comprar Italiano",
  footer_menu_buy_japanese_label: "Comprar Japonés",
  footer_menu_buy_label: "Comprar Idiomas",
  footer_menu_buy_spanish_label: "Comprar Español",
  footer_menu_learn_chinese_label: "Learn Chinese",
  footer_menu_learn_english_label: "Aprender Ingles",
  footer_menu_learn_french_label: "Aprender Francés",
  footer_menu_learn_german_label: "Aprender Alemán",
  footer_menu_learn_ingles_label: "Aprende Inglés",
  footer_menu_learn_italian_label: "Aprender Italiano",
  footer_menu_learn_japanese_label: "Learn Japanese",
  footer_menu_learn_label: "Aprender Idiomas",
  footer_menu_learn_languages_label: "Learn a Language",
  footer_menu_learn_portuguese_label: "Aprender Portugués",
  footer_menu_products_demo_label: "Pruébalo gratis",
  footer_menu_products_education_primary_label: "Para Educadores",
  footer_menu_products_education_secondary_label: "Para Educadores Superiores",
  footer_menu_products_enterprise_label: "Para Empresa",
  footer_menu_products_label: "¿DÓNDE EMPEZAR?",
  footer_menu_products_mobile_label: "Apps para móvil",
  footer_menu_products_reviews_label: "Opiniones",
  footer_menu_start_activation_label: "Product Activation",
  footer_menu_start_blog_label: "Blog",
  footer_menu_start_demo_label: "Pruébalo Gratis",
  footer_menu_start_education_primary_label: "For Schools",
  footer_menu_start_enterprise_label: "For Enterprise",
  footer_menu_start_label: "Donde comenzar",
  footer_menu_start_mobile_label: "Aplicaciones Móviles",
  footer_menu_start_reviews_label: "Comentarios sobre Rosetta Stone",
  footer_menu_start_speech_label: "Speech Recognition",
  footer_menu_start_testamonials_label: "Testimonios de Rosetta Stone",
  footer_menu_start_translate_label: "Traduce Ahora",
  footer_menu_support_accessibility_statement_label: "Accessibility Statement",
  footer_menu_support_contact_us_label: "Contáctenos",
  footer_menu_support_faqs_label: "Preguntas Frecuentes",
  footer_menu_support_label: "Soporte",
  footer_menu_support_support_site_label: "Soporte Técnico",
  footer_menu_support_system_requirements_label: "Requisitos del sistema",
  // Meta
  footer_meta_agreements_label: "Acuerdos",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Configuración de Cookie",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_copyright_label: "Rosetta Stone LLC. Todos los derechos reservados.",
  footer_meta_privacy_policy_label: "Política de Privacidad",
  footer_meta_terms_conditions_label: "Términos y Condiciones",
  // Region
  footer_region_label: "Cambiar Región",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Conéctate con nosotros",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube",
  // Mobile Apps Page Section Panels
  mobile_apps_top_section_one_title_content: "Aplicación de Rosetta Stone",
  mobile_apps_top_section_one_body_content: "Gracias a su variedad de lecciones y características enfocadas en los ejercicios orales, comentarios al instante sobre tu pronunciación con TruAccent, una amplia trayectoria de historias de éxito de personas que han conseguido hablar con confianza y casi cinco estrellas en la app store, la galardonada aplicación móvil de Rosetta Stone es la mejor forma de aprender nuevos idiomas.",
  mobile_apps_top_section_one_custom_cta_text: "Inicia tu prueba gratuita",
  mobile_apps_top_section_two_title_content: "Rosetta Stone te ayuda a hablar con confianza.",
  mobile_apps_top_section_two_body_content: "¿Por qué elegir la aplicación de Rosetta Stone? Porque la mejor manera de aprender un nuevo idioma es sumergirse en él, y esto es justo lo que puedes conseguir gracias al método Dynamic Immersion® de Rosetta Stone. Las lecciones interactivas y contextuales se combinan con las características de Aprendizaje extendido, que están literalmente al alcance de tu mano, en cualquier momento, en cualquier lugar y en cualquier dispositivo; ya sea en línea o sin conexión.",
  mobile_apps_top_section_two_feature_heading_content_one: "Habla con confianza.",
  mobile_apps_top_section_two_feature_subheading_content_one: "La tecnología TruAccent® proporciona comentarios sobre tu pronunciación en tiempo real.",
  mobile_apps_top_section_two_feature_heading_content_two: "No te limites a memorizar.",
  mobile_apps_top_section_two_feature_subheading_content_two: "Aprende en contexto utilizando nuestro método Dynamic Immersion®.",
  mobile_apps_top_section_two_feature_heading_content_three: "Se adapta a cualquier horario.",
  mobile_apps_top_section_two_feature_subheading_content_three: "Toma una lección de 10 minutos en cualquier lugar, ya sea en línea o sin conexión.",
  mobile_apps_top_section_two_feature_heading_content_four: "Siempre está a tu lado.",
  mobile_apps_top_section_two_feature_subheading_content_four: "Practica aquí, allí o en cualquier lugar.",
  mobile_apps_top_section_two_feature_heading_content_five: "No te pierdas en la traducción.",
  mobile_apps_top_section_two_feature_subheading_content_five: "Mantén pulsado cualquier elemento de tus Lecciones principales para mostrar su traducción*.",
  mobile_apps_top_section_two_feature_subheading_content_six: "* Disponible con determinados idiomas en la aplicación Rosetta Stone: Aprende idiomas.",
  mobile_apps_top_section_three_title_content: "Características del Aprendizaje extendido.",
  mobile_apps_top_section_three_body_content: "¿Por qué elegir la aplicación de Rosetta Stone? Porque la mejor manera de aprender un nuevo idioma es sumergirse en él, y esto es justo lo que puedes conseguir gracias al método Dynamic Immersion® de Rosetta Stone. Las lecciones interactivas y contextuales se combinan con las características de Aprendizaje extendido, que están literalmente al alcance de tu mano, en cualquier momento, en cualquier lugar y en cualquier dispositivo; ya sea en línea o sin conexión.",
  mobile_apps_top_section_three_feature_heading_content_one: "Aprende a hablar como un nativo.",
  mobile_apps_top_section_three_feature_subheading_content_one: "Practica tu pronunciación leyendo en voz alta mientras escuchas a hablantes nativos con las Historias.",
  mobile_apps_top_section_three_feature_heading_content_two: "Siempre sabrás qué decir.",
  mobile_apps_top_section_three_feature_subheading_content_two: "Aprende saludos, frases, expresiones, etc. fáciles de entender con la Guía de Conversación *. * Disponible en determinados idiomas en la aplicación Rosetta Stone: Aprende idiomas.",
  mobile_apps_top_section_three_feature_heading_content_three: "Entrena tu oído.",
  mobile_apps_top_section_three_feature_subheading_content_three: "Descansa la vista escuchando las lecciones de Audio Companion®.",
  mobile_apps_bottom_section_one_title_content: "¿Necesitas alguna otra razón más?",
  mobile_apps_bottom_section_one_body_content: "¿Por qué elegir la aplicación de Rosetta Stone? Porque la mejor manera de aprender un nuevo idioma es sumergirse en él, y esto es justo lo que puedes conseguir gracias al método Dynamic Immersion® de Rosetta Stone. Las lecciones interactivas y contextuales se combinan con las características de Aprendizaje extendido, que están literalmente al alcance de tu mano, en cualquier momento, en cualquier lugar y en cualquier dispositivo; ya sea en línea o sin conexión.",
  // Mobile Apps Page Os Logos
  mobile_apps_os_logos_title_content: "Consigue Rosetta Stone en todos tus dispositivos.",
  mobile_apps_os_logos_subtitle_content: "Tus lecciones te están esperando en la web o la aplicación, en cualquier momento y en cualquier lugar, en línea o sin conexión."
};

var strings_es_ES = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "Árabe",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "Alemán",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "Griego",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "Inglés",
  locale_en_gb_label_secondary: "británico",
  locale_en_us_label_primary: "Inglés",
  locale_en_us_label_secondary: "americano",
  locale_es_es_label_primary: "Español",
  locale_es_es_label_secondary: "",
  locale_es_la_label_primary: "Español",
  locale_es_la_label_secondary: "latinoamérica",
  locale_fa_ir_label_primary: "Persa",
  locale_fa_ir_label_secondary: "farsi",
  locale_fr_fr_label_primary: "Francés",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "Irlandés",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "Hebreo",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "Italiano",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "Japonés",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "Coreano",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "Holandés",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "Polaco",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "Portugués",
  locale_pt_br_label_secondary: "brasil",
  locale_ru_ru_label_primary: "Ruso",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "Sueco",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "Filipino",
  locale_tl_ph_label_secondary: "tagalo",
  locale_tr_tr_label_primary: "Turco",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "Vietnamita",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "Chino",
  locale_zn_cn_label_secondary: "",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_blog_label: "Magazine",
  nav_primary_catalog_label: "Idiomas Y Precios",
  nav_primary_catalog_select_language_label: "Selecciona un idioma:",
  nav_primary_contact_label: "",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "¿Tener preguntas? Llámanos",
  nav_primary_phone_number: "1 (800) ROSETTA",
  nav_primary_sign_in_label: "INGRESAR",
  nav_primary_support_label: "Asistencia",
  nav_primary_switch_language: "",
  nav_primary_vertical_consumer_label: "For You",
  nav_primary_vertical_education_for_homeschool_label: "",
  nav_primary_vertical_education_for_students_label: "",
  nav_primary_vertical_education_homeschool_label: "",
  nav_primary_vertical_education_primary_label: "Para Educadores",
  nav_primary_vertical_education_secondary_label: "",
  nav_primary_vertical_education_students_label: "",
  nav_primary_vertical_enterprise_label: "Para Empresas",
  nav_primary_vertical_for_young_learners_label: "",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "",
  nav_secondary_enterprise_custom_1_label: "",
  nav_secondary_enterprise_home_label: "Inicio",
  nav_secondary_enterprise_label: "Empresa",
  nav_secondary_enterprise_resources_label: "Recursos",
  nav_secondary_enterprise_solutions_label: "Soluciones",
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "",
  nav_secondary_education_primary_home_label: "Inicio",
  nav_secondary_education_primary_label: "Educación",
  nav_secondary_education_primary_resources_label: "Recursos",
  nav_secondary_education_primary_solutions_label: "Soluciones",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "",
  nav_secondary_education_secondary_custom_1_label: "",
  nav_secondary_education_secondary_home_label: "Inicio",
  nav_secondary_education_secondary_label: "Educación Superior",
  nav_secondary_education_secondary_resources_label: "Recursos",
  nav_secondary_education_secondary_solutions_label: "Soluciones",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "",
  nav_secondary_education_homeschool_home_label: "",
  nav_secondary_education_homeschool_label: "",
  nav_secondary_education_homeschool_resources_label: "",
  nav_secondary_education_homeschool_solutions_label: "",
  // ******************************************
  // Nav Secondary - Services
  // ******************************************
  nav_secondary_services_blog_label: "",
  nav_secondary_services_home_label: "",
  nav_secondary_services_label: "",
  nav_secondary_services_resources_label: "",
  nav_secondary_services_solutions_label: "",
  // ******************************************
  // Shared - Awards
  // ******************************************
  awards_header_label: "Avalada durante 25+ años por las mejores organizaciones.",
  awards_bmw: "BMW",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "Qué dice la gente de nosotros.",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;<em>La joya de la corona</em> entre los métodos de aprendizaje de idiomas por ordenador.&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;Me encanta el programa de Rosetta Stone y creo que su método para <em>aprender idiomas funciona.</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot;Con su interfaz excelente para el usuario, instrucciones claras y una amplia gama de juegos y retos...  <em>Rosetta Stone sorprende.</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "",
  related_resources_button_label: "",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "Que tipo de aluno você é?",
  verticals_education_primary: "Educação Basica",
  verticals_education_secondary: "Ensino Superior",
  verticals_enterprise: "Empresas",
  verticals_publicsector: "",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "",
  footer_cta_email_main_label: "",
  footer_cta_email_placeholder: "",
  footer_cta_email_sub_label: "",
  footer_cta_form_comments: "",
  footer_cta_form_country: "",
  footer_cta_form_email: "E-mail profesional",
  footer_cta_form_firstname: "Nombre",
  footer_cta_form_lastname: "Apellidos",
  footer_cta_form_organization: "Nombre de la Organización",
  footer_cta_form_organizationsize: "Tamaño de la organización",
  footer_cta_form_organizationsize_100: "100 o Menos",
  footer_cta_form_organizationsize_500: "101 - 500",
  footer_cta_form_organizationsize_1000: "501 - 1,000",
  footer_cta_form_organizationsize_5000: "1,001 - 5,000",
  footer_cta_form_organizationsize_10000: "5,001 - 10,000",
  footer_cta_form_organizationsize_25000: "10,001 - 25,000",
  footer_cta_form_organizationsize_50000: "25,001 - 50,000",
  footer_cta_form_organizationsize_more: "50,001 - Más",
  footer_cta_form_phone: "Numero de Teléfono (Opcional)",
  footer_cta_form_pricing_thanks: "¡Gracias por tu interés! Alguien hará un seguimiento contigo en breve.",
  footer_cta_form_role: "Rol (o título)",
  footer_cta_form_role_boardmember: "Miembro de la Junta",
  footer_cta_form_role_curriculumdirector: "Director de Currículo / Coordinador de Instrucción",
  footer_cta_form_role_director: "Director",
  footer_cta_form_role_executive: "Dirección General / Ejecutivo",
  footer_cta_form_role_individualcontributor: "Colaborador Individual",
  footer_cta_form_role_manager: "Gerente",
  footer_cta_form_role_principal: "Director de la Escuela",
  footer_cta_form_role_superintendent: "Superintendente / Administrador de Distrito",
  footer_cta_form_role_teacher: "Profesor",
  footer_cta_form_role_techcoordinator: "Coordinador de Tecnologia",
  footer_cta_form_role_vicepresident: "Vicepresidente",
  footer_cta_form_submit: "CONSULTA GRATUITA",
  footer_cta_how_hear_blog: "Blog",
  footer_cta_how_hear_email: "Email",
  footer_cta_how_hear_event: "Evento",
  footer_cta_how_hear_online: "En línea",
  footer_cta_how_hear_other: "Otro",
  footer_cta_how_hear_referral: "Remisión",
  footer_cta_how_hear_search: "Buscador",
  footer_cta_how_hear_social: "Medios Sociales",
  footer_cta_how_hear_title: "¿Como supiste de nosotros? (Opcional)",
  footer_cta_how_hear_webinar: "Seminario Web",
  footer_cta_opt_in_learn_more_button_text: "aquí",
  footer_cta_opt_in_learn_more_link_text_1: "aquí.",
  footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf",
  footer_cta_opt_in_learn_more_text_1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
  footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_text_3: ".",
  footer_cta_opt_in_text_after_button: "para más información.",
  footer_cta_opt_in_text_before_button: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
  footer_cta_pricing_button: "CONSULTA DE PRECIOS",
  footer_cta_pricing_label: "Listo para el siguiente paso?",
  footer_cta_pricing_subtitle: "Por favor complete y nos pondremos en contacto con usted de inmediato.",
  footer_cta_pricing_title: "Obtenga las respuestas sobre precios que necesita.",
  // Menu
  footer_menu_about_about_us_label: "Rosetta Stone",
  footer_menu_about_blog_label: "Blog",
  footer_menu_about_careers_label: "Carrera profesional",
  footer_menu_about_contact_label: "Contacto",
  footer_menu_about_label: "SOBRE",
  footer_menu_about_press_label: "Prensa",
  footer_menu_products_demo_label: "Pruébalo gratis",
  footer_menu_products_education_primary_label: "Para Educadores",
  footer_menu_products_education_secondary_label: "Para Educadores Superiores",
  footer_menu_products_enterprise_label: "Para Empresas",
  footer_menu_products_label: "¿DÓNDE EMPEZAR?",
  footer_menu_products_mobile_label: "Apps Para Móvil",
  footer_menu_products_reviews_label: "Opiniones",
  footer_menu_support_faqs_label: "Preguntas más frecuentes",
  footer_menu_support_label: "Asistencia",
  footer_menu_support_support_site_label: "APOYO",
  footer_menu_support_system_requirements_label: "Requisitos del sistema",
  // Meta
  footer_meta_agreements_label: "Acuerdos",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Configuración de cookies",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_label: "Rosetta Stone LLC. Todos los derechos reservados",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_privacy_policy_label: "Política de privacidad",
  footer_meta_terms_conditions_label: "Términos y condiciones",
  // Region
  footer_region_label: "Cambia Región",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Conectate con nosotros",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube"
};

const strings_fr_FR = {
    global_brand_name: "Rosetta Stone",
    product_name: "Rosetta Stone",
    locale_ar_ar_label_primary: "l'Arabe",
    locale_ar_ar_label_secondary: "",
    locale_de_de_label_primary: "l'Allemand",
    locale_de_de_label_secondary: "",
    locale_el_gr_label_primary: "le Grec",
    locale_el_gr_label_secondary: "",
    locale_en_gb_label_primary: "l'Anglais",
    locale_en_gb_label_secondary: "",
    locale_en_us_label_primary: "l'Anglais",
    locale_en_us_label_secondary: "Américain",
    locale_es_es_label_primary: "l'Espagnol",
    locale_es_es_label_secondary: "",
    locale_es_la_label_primary: "l'Espagnol",
    locale_es_la_label_secondary: "Amérique latine",
    locale_fa_ir_label_primary: "le Farsi",
    locale_fa_ir_label_secondary: "",
    locale_fr_fr_label_primary: "le Français",
    locale_fr_fr_label_secondary: "",
    locale_ga_ie_label_primary: "l'Irlandais",
    locale_ga_ie_label_secondary: "",
    locale_he_il_label_primary: "l'Hébreu",
    locale_he_il_label_secondary: "",
    locale_hi_in_label_primary: "l'Hindi",
    locale_hi_in_label_secondary: "",
    locale_it_it_label_primary: "l'Italien",
    locale_it_it_label_secondary: "",
    locale_ja_jp_label_primary: "le Japonais",
    locale_ja_jp_label_secondary: "",
    locale_ko_kr_label_primary: "le Coréen",
    locale_ko_kr_label_secondary: "",
    locale_la_va_label_primary: "Latin",
    locale_la_va_label_secondary: "",
    locale_nl_nl_label_primary: "le Néerlandais",
    locale_nl_nl_label_secondary: "",
    locale_pl_pl_label_primary: "le Polonais",
    locale_pl_pl_label_secondary: "",
    locale_pt_br_label_primary: "le Portugais",
    locale_pt_br_label_secondary: "",
    locale_ru_ru_label_primary: "le Russe",
    locale_ru_ru_label_secondary: "",
    locale_sv_se_label_primary: "le Suédois",
    locale_sv_se_label_secondary: "",
    locale_tl_ph_label_primary: "le Filipino",
    locale_tl_ph_label_secondary: "",
    locale_tr_tr_label_primary: "le Turc",
    locale_tr_tr_label_secondary: "",
    locale_vi_vn_label_primary: "le Vietnamien",
    locale_vi_vn_label_secondary: "",
    locale_zn_cn_label_primary: "le Chinois",
    locale_zn_cn_label_secondary: "",
    nav_primary_blog_label: "Magazine",
    nav_primary_catalog_label: "Langues Et Tarification",
    nav_primary_catalog_select_language_label: "Sélectionnez une langue:",
    nav_primary_contact_label: "Contact",
    nav_primary_logo_alt: "Rosetta Stone",
    nav_primary_phone_label: "Avoir des questions? Appelez nous:",
    nav_primary_phone_number: "1 (800) ROSETTA",
    nav_primary_sign_in_label: "SE CONNECTER",
    nav_primary_support_label: "Assistance",
    nav_primary_switch_language: "Español",
    nav_primary_vertical_consumer_label: "",
    nav_primary_vertical_education_for_homeschool_label: "",
    nav_primary_vertical_education_for_students_label: "",
    nav_primary_vertical_education_homeschool_label: "",
    nav_primary_vertical_education_primary_label: "Pour Les Éducateurs",
    nav_primary_vertical_education_secondary_label: "",
    nav_primary_vertical_education_students_label: "",
    nav_primary_vertical_enterprise_label: "Pour Les Entreprises",
    nav_primary_vertical_for_young_learners_label: "",
    nav_secondary_enterprise_blog_label: "",
    nav_secondary_enterprise_custom_1_label: "",
    nav_secondary_enterprise_home_label: "Accueil",
    nav_secondary_enterprise_label: "Entreprise",
    nav_secondary_enterprise_resources_label: "Ressources",
    nav_secondary_enterprise_solutions_label: "Solutions",
    nav_secondary_education_primary_blog_label: "",
    nav_secondary_education_primary_home_label: "Accueil",
    nav_secondary_education_primary_label: "Éducation",
    nav_secondary_education_primary_resources_label: "Ressources",
    nav_secondary_education_primary_solutions_label: "Solutions",
    nav_secondary_education_secondary_blog_label: "",
    nav_secondary_education_secondary_custom_1_label: "",
    nav_secondary_education_secondary_home_label: "Accueil",
    nav_secondary_education_secondary_label: "Éducation Supérieur",
    nav_secondary_education_secondary_resources_label: "Ressources",
    nav_secondary_education_secondary_solutions_label: "Solutions",
    nav_secondary_education_homeschool_blog_label: "",
    nav_secondary_education_homeschool_home_label: "",
    nav_secondary_education_homeschool_label: "",
    nav_secondary_education_homeschool_resources_label: "",
    nav_secondary_education_homeschool_solutions_label: "",
    nav_secondary_services_blog_label: "",
    nav_secondary_services_home_label: "",
    nav_secondary_services_label: "",
    nav_secondary_services_resources_label: "",
    nav_secondary_services_solutions_label: "",
    awards_header_label: "Reconnu depuis 25+ ans par les plus grandes organisations,",
    awards_bmw: "BMW",
    awards_twitter: "Twitter",
    awards_uber: "Uber",
    awards_williams_sonoma: "Williams Sonoma",
    branded_quotes_header_label: "Que disent les gens à notre propos.",
    branded_quotes_cnn_name: "CNN",
    branded_quotes_cnn_quote: "&quot;<em>L'étalon d’or</em> de l'apprentissage interactif des langues.&quot;",
    branded_quotes_cnn_type: "cnn",
    branded_quotes_macworld_name: "MacWorld",
    branded_quotes_macworld_quote: "&quot;J'adore le logiciel de Rosetta Stone et je pense que <em>tl’approche de l'apprentissage linguistique fonctionne.</em>&quot;",
    branded_quotes_macworld_type: "macworld",
    branded_quotes_techcrunch_name: "TechCrunch",
    branded_quotes_techcrunch_quote: "&quot;Grâce à l’excellente interface utilisateur, des instructions claires, la grande variété de jeux et défis,<em>Rosetta Stone est très attrayant.</em>&quot;",
    branded_quotes_techcrunch_type: "techcrunch",
    related_resources_label: "Keep Exploring",
    related_resources_button_label: "Read more",
    verticals_label: "Quel type d'apprenant êtes-vous?",
    verticals_education_primary: "Éducation",
    verticals_education_secondary: "Éducation Supérieur",
    verticals_enterprise: "Entreprise",
    verticals_publicsector: "",
    footer_cta_email_button: "",
    footer_cta_email_main_label: "",
    footer_cta_email_placeholder: "",
    footer_cta_email_sub_label: "",
    footer_cta_form_comments: "",
    footer_cta_form_country: "",
    footer_cta_form_email: "Email",
    footer_cta_form_firstname: "Prénom",
    footer_cta_form_lastname: "Nom",
    footer_cta_form_organization: "Nom de l'Organisation",
    footer_cta_form_organizationsize: "Taille de l'Organisation",
    footer_cta_form_organizationsize_100: "100 ou Moins",
    footer_cta_form_organizationsize_500: "101 - 500",
    footer_cta_form_organizationsize_1000: "501 - 1,000",
    footer_cta_form_organizationsize_5000: "1,001 - 5,000",
    footer_cta_form_organizationsize_10000: "5,001 - 10,000",
    footer_cta_form_organizationsize_25000: "10,001 - 25,000",
    footer_cta_form_organizationsize_50000: "25,001 - 50,000",
    footer_cta_form_organizationsize_more: "50,001 - Plus",
    footer_cta_form_phone: "Numéro de Téléphone (Facultatif)",
    footer_cta_form_pricing_thanks: "Merci de votre intérêt! Quelqu'un vous suivra sous peu.",
    footer_cta_form_role: "Rôle (ou titre)",
    footer_cta_form_role_boardmember: "Membre d'Équipage",
    footer_cta_form_role_curriculumdirector: "Directeur du curriculum / coordinateur de l'instruction",
    footer_cta_form_role_director: "Réalisateur",
    footer_cta_form_role_executive: "Direction Générale / Executive",
    footer_cta_form_role_individualcontributor: "Contributeur Individuel",
    footer_cta_form_role_manager: "Directeur",
    footer_cta_form_role_principal: "Directeur d'École",
    footer_cta_form_role_superintendent: "Surintendant / Administrateur de district",
    footer_cta_form_role_teacher: "Professeur",
    footer_cta_form_role_techcoordinator: "Coordinateur Technologique",
    footer_cta_form_role_vicepresident: "Vice-Président",
    footer_cta_form_submit: "CONSULTATION GRATUITE",
    footer_cta_how_hear_blog: "Blog",
    footer_cta_how_hear_email: "Email",
    footer_cta_how_hear_event: "Event",
    footer_cta_how_hear_online: "En ligne",
    footer_cta_how_hear_other: "Autre",
    footer_cta_how_hear_referral: "Référence",
    footer_cta_how_hear_search: "Moteur de recherche",
    footer_cta_how_hear_social: "Médias sociaux",
    footer_cta_how_hear_title: "Comment avez-vous entendu parler de nous? (Optionnel)",
    footer_cta_how_hear_webinar: "Séminaire en ligne",
    footer_cta_opt_in_learn_more_button_text: "ici",
    footer_cta_opt_in_learn_more_link_text_1: "ici.",
    footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/de/pdfs/website-privacy-policy-de.pdf",
    footer_cta_opt_in_learn_more_text_1: "Rosetta Stone s'engage à protéger votre vie privée. Notre politique de confidentialité complète est disponible ",
    footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_text_3: ".",
    footer_cta_opt_in_text_after_button: "pour plus d'informations.",
    footer_cta_opt_in_text_before_button: "Oui! J'aimerais recevoir les mises à jour et le marketing du produit de Rosetta Stone. Cliquez ",
    footer_cta_pricing_button: "DEMANDE DE TARIFS",
    footer_cta_pricing_label: "Vous cherchez une liste de pas?",
    footer_cta_pricing_subtitle: "S'il vous plaît compléter et nous vous contacterons immédiatement.",
    footer_cta_pricing_title: "Obtenez les informations sur nos tarifs.",
    footer_menu_about_about_us_label: "Rosetta Stone",
    footer_menu_about_blog_label: "Blog",
    footer_menu_about_careers_label: "Carrières",
    footer_menu_about_contact_label: "Contactez-nous",
    footer_menu_about_label: "À PROPOS",
    footer_menu_about_press_label: "Presse",
    footer_menu_products_demo_label: "Essayez gratuitement",
    footer_menu_products_education_primary_label: "Pour Les Éducateurs",
    footer_menu_products_education_secondary_label: "Pour les Éducateurs Supérieurs",
    footer_menu_products_enterprise_label: "Pour Les Entreprises",
    footer_menu_products_label: "PAR OÙ COMMENCER",
    footer_menu_products_mobile_label: "Applications Mobiles",
    footer_menu_products_reviews_label: "Avis Clients",
    footer_menu_support_faqs_label: "FAQ",
    footer_menu_support_label: "Assistance",
    footer_menu_support_support_site_label: "ASSISTANCE",
    footer_menu_support_system_requirements_label: "Configurations Requises",
    footer_meta_agreements_label: "Mentions Légales",
    footer_meta_ccpa_label: "Do Not Sell My Information",
    footer_meta_cookie_settings_label: "Paramètres des cookies",
    footer_meta_copyright_alt: "Go to home page",
    footer_meta_copyright_IXL: "A division of IXL Learning",
    footer_meta_copyright_label: "Rosetta Stone LLC. Tous droits réservés",
    footer_meta_privacy_policy_label: "Politique de confidentialité",
    footer_meta_terms_conditions_label: "Modalités et Conditions",
    footer_region_label: "Changer de région",
    footer_region_options_br_label: "Brasil",
    footer_region_options_cn_label: "中国",
    footer_region_options_de_label: "Deutschland",
    footer_region_options_es_label: "España",
    footer_region_options_eu_label: "Europe",
    footer_region_options_fr_label: "France",
    footer_region_options_it_label: "Italia",
    footer_region_options_jp_label: "日本",
    footer_region_options_kr_label: "대한민국",
    footer_region_options_la_label: "America Latina",
    footer_region_options_uk_label: "United Kingdom",
    footer_region_options_us_label: "United States",
    footer_social_label: "Connecte-toi avec nous",
    footer_social_facebook_alt: "Facebook",
    footer_social_instagram_alt: "Instagram",
    footer_social_twitter_alt: "Twitter",
    footer_social_youtube_alt: "Youtube"
};

var strings_it_IT = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "Arabo",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "Tedesco",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "Greco",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "Inglese",
  locale_en_gb_label_secondary: "",
  locale_en_us_label_primary: "Inglese",
  locale_en_us_label_secondary: "Americano",
  locale_es_es_label_primary: "Spagnolo",
  locale_es_es_label_secondary: "",
  locale_es_la_label_primary: "Spagnolo",
  locale_es_la_label_secondary: "America Latina",
  locale_fa_ir_label_primary: "Persiano",
  locale_fa_ir_label_secondary: "Farsi",
  locale_fr_fr_label_primary: "Francese",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "Irlandese",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "Ebraico",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "Italiano",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "Giapponese",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "Coreano",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "Olandese",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "Polacco",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "Portoghese",
  locale_pt_br_label_secondary: "Brasile",
  locale_ru_ru_label_primary: "Russo",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "Svedese",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "Tagalog",
  locale_tl_ph_label_secondary: "Filippino",
  locale_tr_tr_label_primary: "Turco",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "Vietnamita",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "Cinese",
  locale_zn_cn_label_secondary: "Mandarino",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_blog_label: "Blog",
  nav_primary_catalog_label: "Lingue E Prezzi",
  nav_primary_catalog_select_language_label: "Seleziona una Lingua",
  nav_primary_contact_label: "Contatti",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "Hai domande? Chiamaci",
  nav_primary_phone_number: "1 (800) ROSETTA",
  nav_primary_sign_in_label: "ACCEDI",
  nav_primary_support_label: "Assistenza",
  nav_primary_vertical_education_primary_label: "Per Gli Educatori",
  nav_primary_vertical_enterprise_label: "Per Le Aziende",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "",
  nav_secondary_enterprise_custom_1_label: "",
  nav_secondary_enterprise_home_label: "Home",
  nav_secondary_enterprise_label: "Aziende",
  nav_secondary_enterprise_resources_label: "Risorse",
  nav_secondary_enterprise_solutions_label: "Soluzioni",
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "",
  nav_secondary_education_primary_home_label: "Home",
  nav_secondary_education_primary_label: "Scuola Primaria e Secondaria",
  nav_secondary_education_primary_resources_label: "Risorse",
  nav_secondary_education_primary_solutions_label: "Soluzioni",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "",
  nav_secondary_education_secondary_custom_1_label: "",
  nav_secondary_education_secondary_home_label: "Home",
  nav_secondary_education_secondary_label: "Istruzione Superiore",
  nav_secondary_education_secondary_resources_label: "Risorse",
  nav_secondary_education_secondary_solutions_label: "Risorse",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "",
  nav_secondary_education_homeschool_home_label: "",
  nav_secondary_education_homeschool_label: "",
  nav_secondary_education_homeschool_resources_label: "",
  nav_secondary_education_homeschool_solutions_label: "",
  // ******************************************
  // Nav Secondary - Services
  // ******************************************
  nav_secondary_services_blog_label: "",
  nav_secondary_services_home_label: "",
  nav_secondary_services_label: "",
  nav_secondary_services_resources_label: "",
  nav_secondary_services_solutions_label: "",
  // ******************************************
  // Shared - Awards
  // ******************************************
  awards_header_label: "Approvato per 25+ anni dalle migliori organizzazioni",
  awards_bmw: "BMW",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "Cosa dicono di noi.",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;<em>Il gioiello della corona</em> tra i metodi di apprendimento linguistico del computer.&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;Adoro il programma Rosetta Stone e penso che il tuo metodo per <em>L'apprendimento delle lingue funziona.</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot;Con la sua eccellente interfaccia per l'utente, istruzioni chiare e una vasta gamma di giochi e sfide ...  <em>Rosetta Stone sorprende.</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "",
  related_resources_button_label: "",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "Che tipo di apprendista sei?",
  verticals_education_primary: "Scuola Primaria e Secondaria",
  verticals_education_secondary: "Istruzione Superiore",
  verticals_enterprise: "Aziende",
  verticals_publicsector: "",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "",
  footer_cta_email_main_label: "",
  footer_cta_email_placeholder: "",
  footer_cta_email_sub_label: "",
  footer_cta_form_comments: "",
  footer_cta_form_country: "",
  footer_cta_form_email: "Email Professionale",
  footer_cta_form_firstname: "Nome",
  footer_cta_form_lastname: "Cognome",
  footer_cta_form_organization: "Nome dell'istituto",
  footer_cta_form_organizationsize: "Dimensione dell'organizzazione",
  footer_cta_form_organizationsize_100: "100 o meno",
  footer_cta_form_organizationsize_500: "101 - 500",
  footer_cta_form_organizationsize_1000: "501 - 1,000",
  footer_cta_form_organizationsize_5000: "1,001 - 5,000",
  footer_cta_form_organizationsize_10000: "5,001 - 10,000",
  footer_cta_form_organizationsize_25000: "10,001 - 25,000",
  footer_cta_form_organizationsize_50000: "25,001 - 50,000",
  footer_cta_form_organizationsize_more: "50,001 - Altro",
  footer_cta_form_phone: "Numero di telefono (facoltativo)",
  footer_cta_form_pricing_thanks: "Grazie per il tuo interesse! Qualcuno ti seguirà a breve.",
  footer_cta_form_role: "Ruolo (o titolo)",
  footer_cta_form_role_boardmember: "Membro di bordo",
  footer_cta_form_role_curriculumdirector: "Direttore del Curriculum / Coordinatore delle Istruzioni",
  footer_cta_form_role_director: "Direttore",
  footer_cta_form_role_executive: "Gestione Generale / Esecutiva",
  footer_cta_form_role_individualcontributor: "Collaboratore individuale",
  footer_cta_form_role_manager: "Manager",
  footer_cta_form_role_principal: "Direttore della Scuola",
  footer_cta_form_role_superintendent: "Sovrintendente / Amministratore Distrettuale",
  footer_cta_form_role_teacher: "Professore",
  footer_cta_form_role_techcoordinator: "Coordinatore Tecnologico",
  footer_cta_form_role_vicepresident: "Vice Presidente",
  footer_cta_form_submit: "CONSULENZA GRATUITA",
  footer_cta_how_hear_blog: "Blog",
  footer_cta_how_hear_email: "Email",
  footer_cta_how_hear_event: "Evento",
  footer_cta_how_hear_online: "In linea",
  footer_cta_how_hear_other: "Altro",
  footer_cta_how_hear_referral: "Remissione",
  footer_cta_how_hear_search: "Cercatore",
  footer_cta_how_hear_social: "Social Media",
  footer_cta_how_hear_title: "Come hai saputo di noi? (Opzionale)",
  footer_cta_how_hear_webinar: "Seminario Web",
  footer_cta_opt_in_learn_more_button_text: " qui",
  footer_cta_opt_in_learn_more_link_text_1: "qui.",
  footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf",
  footer_cta_opt_in_learn_more_text_1: "Rosetta Stone si impegna a proteggere la tua privacy. La nostra completa informativa sulla privacy è disponibile",
  footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_text_3: ".",
  footer_cta_opt_in_text_after_button: "per maggiori informazioni.",
  footer_cta_opt_in_text_before_button: "Sì! Desidero ricevere aggiornamenti su prodotti e marketing da Rosetta Stone. Clicca",
  footer_cta_pricing_button: "CONSULTAZIONE DEI PREZZI",
  footer_cta_pricing_label: "Pronto per il prossimo passo?",
  footer_cta_pricing_subtitle: "Si prega di completare e ti contatteremo immediatamente.",
  footer_cta_pricing_title: "Ottieni informazioni sulle nostre tariffe.",
  // Menu
  footer_menu_about_about_us_label: "Rosetta Stone",
  footer_menu_about_careers_label: "Lavora Con Noi",
  footer_menu_about_contact_label: "Contatti",
  footer_menu_about_label: "Chi Siamo",
  footer_menu_about_press_label: "Stampa",
  footer_menu_products_demo_label: "Demo",
  footer_menu_products_education_primary_label: "Per gli Educatori",
  footer_menu_products_education_secondary_label: "Per gli Educatori Superiori",
  footer_menu_products_enterprise_label: "Per le Aziende",
  footer_menu_products_label: "Per Conoscerci Meglio",
  footer_menu_products_mobile_label: "Applicazioni Mobili",
  footer_menu_products_reviews_label: "Recensioni",
  footer_menu_support_faqs_label: "Domande frequenti",
  footer_menu_support_label: "Assistenza",
  footer_menu_support_support_site_label: "Supporto",
  footer_menu_support_system_requirements_label: "Requisiti di Sistema",
  // Meta
  footer_meta_agreements_label: "Condizioni generali di contratto",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Impostazioni cookie",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_copyright_label: "Rosetta Stone GmbH. Tutti i diritti riservati.",
  footer_meta_privacy_policy_label: "Protezione dei dati",
  footer_meta_terms_conditions_label: "Informazioni legali",
  // Region
  footer_region_label: "Scegli il tuo paese",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Connettiti con noi",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube"
};

var strings_ja_JP = {
  // Meta
  footer_meta_agreements_label: "ご利用規約",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Cookie 設定",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "IXL Learning 部門",
  footer_meta_copyright_label: "Rosetta Stone Ltd. All Rights Reserved.",
  footer_meta_privacy_policy_label: "個人情報保護方針",
  footer_meta_terms_conditions_label: "ウェブサイトご利用規約",
  // Social
  footer_social_label: "フォローする",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube"
};

var strings_ko_KR = {
  // Meta
  footer_meta_agreements_label: "사용규정 계약",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "쿠키 설정",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "IXL Learning의 사업부",
  footer_meta_copyright_label: "Rosetta Stone Ltd. All Rights Reserved.",
  footer_meta_privacy_policy_label: "개인정보 취급방침",
  footer_meta_terms_conditions_label: "이용약관 및 기타규정",
  // Social
  footer_social_label: "팔로우하기",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube"
};

var strings_pt_BR = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "Arabic",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "German",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "Greek",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "English",
  locale_en_gb_label_secondary: "British",
  locale_en_us_label_primary: "English",
  locale_en_us_label_secondary: "American",
  locale_es_es_label_primary: "Spanish",
  locale_es_es_label_secondary: "Spain",
  locale_es_la_label_primary: "Spanish",
  locale_es_la_label_secondary: "Latin America",
  locale_fa_ir_label_primary: "Persian",
  locale_fa_ir_label_secondary: "Farsi",
  locale_fr_fr_label_primary: "French",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "Irish",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "Hebrew",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "Italian",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "Japanese",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "Korean",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "Dutch",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "Polish",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "Portuguese",
  locale_pt_br_label_secondary: "Brazil",
  locale_ru_ru_label_primary: "Russian",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "Swedish",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "Filipino",
  locale_tl_ph_label_secondary: "Tagalog",
  locale_tr_tr_label_primary: "Turkish",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "Vietnamese",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "Chinese",
  locale_zn_cn_label_secondary: "Mandarin",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_blog_label: "Blog",
  nav_primary_catalog_label: "Começar agora",
  nav_primary_catalog_select_language_label: "Selecione um idioma",
  nav_primary_contact_label: "",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "Tem perguntas? Ligue para nós:",
  nav_primary_phone_number: "1-(800)-ROSETTA",
  nav_primary_sign_in_label: "ENTRAR",
  nav_primary_support_label: "Suporte",
  nav_primary_switch_language: "English",
  nav_primary_vertical_consumer_label: "Para Você",
  nav_primary_vertical_education_for_homeschool_label: "",
  nav_primary_vertical_education_for_students_label: "",
  nav_primary_vertical_education_homeschool_label: "",
  nav_primary_vertical_education_primary_label: "Para Professores",
  nav_primary_vertical_education_secondary_label: "",
  nav_primary_vertical_education_students_label: "",
  nav_primary_vertical_enterprise_label: "Para Empresas",
  nav_primary_vertical_for_young_learners_label: "",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "Blog",
  nav_secondary_enterprise_custom_1_label: "Seja um Parceiro",
  nav_secondary_enterprise_home_label: "Inicial",
  nav_secondary_enterprise_label: "Empresas",
  nav_secondary_enterprise_resources_label: "Recursos",
  nav_secondary_enterprise_solutions_label: "Soluções",
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "",
  nav_secondary_education_primary_custom_1_label: "Seja um Parceiro",
  nav_secondary_education_primary_home_label: "Inicial",
  nav_secondary_education_primary_label: "Educação Basica",
  nav_secondary_education_primary_resources_label: "Recursos",
  nav_secondary_education_primary_solutions_label: "Soluções",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "Blog",
  nav_secondary_education_secondary_custom_1_label: "Seja um Parceiro",
  nav_secondary_education_secondary_home_label: "Inicial",
  nav_secondary_education_secondary_label: "Ensino Superior",
  nav_secondary_education_secondary_resources_label: "Recursos",
  nav_secondary_education_secondary_solutions_label: "Soluções",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "",
  nav_secondary_education_homeschool_home_label: "",
  nav_secondary_education_homeschool_label: "",
  nav_secondary_education_homeschool_resources_label: "",
  nav_secondary_education_homeschool_solutions_label: "",
  // ******************************************
  // Nav Secondary - Services
  // ******************************************
  nav_secondary_services_blog_label: "",
  nav_secondary_services_home_label: "",
  nav_secondary_services_label: "",
  nav_secondary_services_resources_label: "",
  nav_secondary_services_solutions_label: "",
  // ******************************************
  // Shared - Awards
  // ******************************************
  awards_header_label: "Aprovado há 25+ anos pelas melhores organizações.",
  awards_bmw: "BMW",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "O que as pessoas falam sobre nós.",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;<em>A jóia da coroa</em> entre os métodos de aprendizado de idiomas.&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;Eu amo o programa Rosetta Stone e acho que <em>o método deles de aprender idiomas funciona.</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot;Com sua excelente interface para o usuário, instruções claras e uma ampla gama de jogos e desafios ...  <em>Rosetta Stone surpreende.</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "",
  related_resources_button_label: "",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "Que tipo de aluno você é?",
  verticals_education_primary: "Educação Basica",
  verticals_education_secondary: "Ensino Superior",
  verticals_enterprise: "Empresas",
  verticals_publicsector: "",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "",
  footer_cta_email_main_label: "",
  footer_cta_email_placeholder: "",
  footer_cta_email_sub_label: "",
  footer_cta_form_comments: "",
  footer_cta_form_country: "",
  footer_cta_form_email: "Email",
  footer_cta_form_firstname: "Nome",
  footer_cta_form_lastname: "Sobrenome",
  footer_cta_form_organization: "Nome da Organização",
  footer_cta_form_organizationsize: "Tamanho da Organização",
  footer_cta_form_organizationsize_100: "100 ou Menos",
  footer_cta_form_organizationsize_500: "101 - 500",
  footer_cta_form_organizationsize_1000: "501 - 1,000",
  footer_cta_form_organizationsize_5000: "1,001 - 5,000",
  footer_cta_form_organizationsize_10000: "5,001 - 10,000",
  footer_cta_form_organizationsize_25000: "10,001 - 25,000",
  footer_cta_form_organizationsize_50000: "25,001 - 50,000",
  footer_cta_form_organizationsize_more: "50,001 - Mais",
  footer_cta_form_phone: "Número de Telefone (Opcional)",
  footer_cta_form_pricing_thanks: "Obrigado pelo seu interesse! Alguém entrará em contato com você em breve.",
  footer_cta_form_role: "Função (ou título)",
  footer_cta_form_role_boardmember: "Membro do Conselho",
  footer_cta_form_role_curriculumdirector: "Diretor de Currículo / Coordenador de Instrução",
  footer_cta_form_role_director: "Diretor",
  footer_cta_form_role_executive: "Gerência Geral / Executiva",
  footer_cta_form_role_individualcontributor: "Contribuidor Individual",
  footer_cta_form_role_manager: "Gerente",
  footer_cta_form_role_principal: "Diretor da Escola",
  footer_cta_form_role_superintendent: "Superintendente / Administrador Distrital",
  footer_cta_form_role_teacher: "Professor",
  footer_cta_form_role_techcoordinator: "Coordenador de Tecnologia",
  footer_cta_form_role_vicepresident: "Vice Presidente",
  footer_cta_form_submit: "Consulta de preços",
  footer_cta_how_hear_blog: "Blog",
  footer_cta_how_hear_email: "O email",
  footer_cta_how_hear_event: "Evento",
  footer_cta_how_hear_online: "Conectados",
  footer_cta_how_hear_other: "De outros",
  footer_cta_how_hear_referral: "Referência",
  footer_cta_how_hear_search: "Motor de pesquisa",
  footer_cta_how_hear_social: "Mídia social",
  footer_cta_how_hear_title: "Como você ficou sabendo sobre nós? (Opcional)",
  footer_cta_how_hear_webinar: "Webinar",
  footer_cta_opt_in_learn_more_button_text: "aqui",
  footer_cta_opt_in_learn_more_link_text_1: "aqui.",
  footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf",
  footer_cta_opt_in_learn_more_text_1: "A Rosetta Stone tem o compromisso de salvaguardar a sua privacidade. A nossa Política de Privacidade completa está disponível ",
  footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_text_3: ".",
  footer_cta_opt_in_text_after_button: "para maiores informações.",
  footer_cta_opt_in_text_before_button: "Sim! Eu gostaria de receber atualizações de produtos e marketing da Rosetta Stone. Clique",
  footer_cta_pricing_button: "CONSULTA DE PREÇOS",
  footer_cta_pricing_label: "Listo para el siguiente paso?",
  footer_cta_pricing_subtitle: "Por favor, preencha e entraremos em contato imediatamente.",
  footer_cta_pricing_title: "Receba as informações que você precisa sobre os preços.",
  // Menu
  footer_menu_about_blog_label: "Blog",
  footer_menu_about_careers_label: "Carreiras",
  footer_menu_about_contact_label: "Contato",
  footer_menu_about_label: "Sobre",
  footer_menu_products_consumer_label: "Por onde começar?",
  footer_menu_products_education_primary_label: "Para Educadores",
  footer_menu_products_education_secondary_label: "Para Educadores Superiores",
  footer_menu_products_enterprise_label: "Para Empresas",
  footer_menu_products_label: "Por onde começar?",
  footer_menu_support_label: "Suporte",
  footer_menu_support_support_site_label: "Apoio",
  // Meta
  footer_meta_agreements_label: "Acordos",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Configurações de cookies",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_copyright_label: "Rosetta Stone LLC. Todos os direitos reservados.",
  footer_meta_privacy_policy_label: "Política de Privacidade",
  footer_meta_terms_conditions_label: "Termos e Condições",
  // Region
  footer_region_label: "Mudar de região",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Conecte-se conosco",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube"
};

const strings_zh_cn = {
    global_brand_name: "Rosetta Stone",
    product_name: "Rosetta Stone",
    locale_ar_ar_label_primary: "Arabic",
    locale_ar_ar_label_secondary: "",
    locale_de_de_label_primary: "German",
    locale_de_de_label_secondary: "",
    locale_el_gr_label_primary: "Greek",
    locale_el_gr_label_secondary: "",
    locale_en_gb_label_primary: "English",
    locale_en_gb_label_secondary: "British",
    locale_en_us_label_primary: "English",
    locale_en_us_label_secondary: "American",
    locale_es_es_label_primary: "Spanish",
    locale_es_es_label_secondary: "Spain",
    locale_es_la_label_primary: "Spanish",
    locale_es_la_label_secondary: "Latin America",
    locale_fa_ir_label_primary: "Persian",
    locale_fa_ir_label_secondary: "Farsi",
    locale_fr_fr_label_primary: "French",
    locale_fr_fr_label_secondary: "",
    locale_ga_ie_label_primary: "Irish",
    locale_ga_ie_label_secondary: "",
    locale_he_il_label_primary: "Hebrew",
    locale_he_il_label_secondary: "",
    locale_hi_in_label_primary: "Hindi",
    locale_hi_in_label_secondary: "",
    locale_it_it_label_primary: "Italian",
    locale_it_it_label_secondary: "",
    locale_ja_jp_label_primary: "Japanese",
    locale_ja_jp_label_secondary: "",
    locale_ko_kr_label_primary: "Korean",
    locale_ko_kr_label_secondary: "",
    locale_la_va_label_primary: "Latin",
    locale_la_va_label_secondary: "",
    locale_nl_nl_label_primary: "Dutch",
    locale_nl_nl_label_secondary: "",
    locale_pl_pl_label_primary: "Polish",
    locale_pl_pl_label_secondary: "",
    locale_pt_br_label_primary: "Portuguese",
    locale_pt_br_label_secondary: "Brazil",
    locale_ru_ru_label_primary: "Russian",
    locale_ru_ru_label_secondary: "",
    locale_sv_se_label_primary: "Swedish",
    locale_sv_se_label_secondary: "",
    locale_tl_ph_label_primary: "Filipino",
    locale_tl_ph_label_secondary: "Tagalog",
    locale_tr_tr_label_primary: "Turkish",
    locale_tr_tr_label_secondary: "",
    locale_vi_vn_label_primary: "Vietnamese",
    locale_vi_vn_label_secondary: "",
    locale_zn_cn_label_primary: "Chinese",
    locale_zn_cn_label_secondary: "Mandarin",
    nav_primary_catalog_label: "",
    nav_primary_catalog_select_language_label: "",
    nav_primary_contact_label: "",
    nav_primary_logo_alt: "Rosetta Stone",
    nav_primary_phone_label: "你有问题吗？ 打电话给我们",
    nav_primary_phone_number: "Beijing (+86 10 5634 1576)",
    nav_primary_sign_in_label: "",
    nav_primary_support_label: "",
    nav_primary_switch_language: "",
    nav_primary_vertical_consumer_label: "",
    nav_primary_vertical_education_for_homeschool_label: "",
    nav_primary_vertical_education_for_students_label: "",
    nav_primary_vertical_education_homeschool_label: "",
    nav_primary_vertical_education_primary_label: "高等教育",
    nav_primary_vertical_education_secondary_label: "培训中心",
    nav_primary_vertical_education_students_label: "",
    nav_primary_vertical_enterprise_label: "企业",
    nav_primary_vertical_for_young_learners_label: "",
    nav_secondary_enterprise_blog_label: "",
    nav_secondary_enterprise_custom_1_label: "",
    nav_secondary_enterprise_home_label: "主页",
    nav_secondary_enterprise_label: "企业",
    nav_secondary_enterprise_resources_label: "资源",
    nav_secondary_enterprise_solutions_label: "语言解决方案",
    nav_secondary_education_primary_blog_label: "",
    nav_secondary_education_primary_home_label: "主页",
    nav_secondary_education_primary_label: "高等教育",
    nav_secondary_education_primary_resources_label: "资源",
    nav_secondary_education_primary_solutions_label: "语言解决方案",
    nav_secondary_education_secondary_blog_label: "",
    nav_secondary_education_secondary_home_label: "主页",
    nav_secondary_education_secondary_label: "培训中心",
    nav_secondary_education_secondary_resources_label: "资源",
    nav_secondary_education_secondary_solutions_label: "语言解决方案",
    nav_secondary_education_homeschool_blog_label: "",
    nav_secondary_education_homeschool_home_label: "",
    nav_secondary_education_homeschool_label: "",
    nav_secondary_education_homeschool_resources_label: "",
    nav_secondary_education_homeschool_solutions_label: "",
    nav_secondary_services_blog_label: "",
    nav_secondary_services_home_label: "",
    nav_secondary_services_label: "",
    nav_secondary_services_resources_label: "",
    nav_secondary_services_solutions_label: "",
    awards_header_label: "受到顶级组织信任超过25年",
    awards_bmw: "BMW",
    awards_twitter: "Twitter",
    awards_uber: "Uber",
    awards_williams_sonoma: "Williams Sonoma",
    branded_quotes_header_label: "人们对我们的评价.",
    branded_quotes_cnn_name: "CNN",
    branded_quotes_cnn_quote: "&quot;“基于计算机的语言学习的<em>黄金标准。</em>&quot;",
    branded_quotes_cnn_type: "cnn",
    branded_quotes_macworld_name: "MacWorld",
    branded_quotes_macworld_quote: "&quot;“我喜欢Rosetta Stone的软件，<em>我认为他们学习语言的方法很有效。</em>&quot;",
    branded_quotes_macworld_type: "macworld",
    branded_quotes_techcrunch_name: "TechCrunch",
    branded_quotes_techcrunch_quote: "&quot;“凭借其出色的用户界面，清晰的指令，各种各样的游戏和挑战......<em>Rosetta Stone提供了这么多。</em>&quot;",
    branded_quotes_techcrunch_type: "techcrunch",
    related_resources_label: "",
    related_resources_button_label: "",
    verticals_label: "你是什​​么类型的学习者？",
    verticals_education_primary: "培训中心",
    verticals_education_secondary: "高等教育",
    verticals_enterprise: "企业",
    verticals_publicsector: "",
    footer_cta_email_button: "",
    footer_cta_email_main_label: "",
    footer_cta_email_placeholder: "",
    footer_cta_email_sub_label: "",
    footer_cta_form_comments: "",
    footer_cta_form_country: "国家",
    footer_cta_form_email: "电子邮箱（学校）",
    footer_cta_form_firstname: "名",
    footer_cta_form_lastname: "姓",
    footer_cta_form_organization: "企业／机构名称",
    footer_cta_form_organizationsize: "组织规模",
    footer_cta_form_organizationsize_100: "100或更少",
    footer_cta_form_organizationsize_500: "101 - 500",
    footer_cta_form_organizationsize_1000: "501 - 1,000",
    footer_cta_form_organizationsize_5000: "1,001 - 5,000",
    footer_cta_form_organizationsize_10000: "5,001 - 10,000",
    footer_cta_form_organizationsize_25000: "10,001 - 25,000",
    footer_cta_form_organizationsize_50000: "25,001 - 50,000",
    footer_cta_form_organizationsize_more: "50,001  - 更多",
    footer_cta_form_phone: "电话 （可选的）",
    footer_cta_form_pricing_thanks: "感谢您对Rosetta Stone的关注！ 有人会尽快与您联系并提供有用的信息。",
    footer_cta_form_role: "角色（或头衔）",
    footer_cta_form_role_boardmember: "董事会成员",
    footer_cta_form_role_curriculumdirector: "课程总监/指导协调员",
    footer_cta_form_role_director: "主管",
    footer_cta_form_role_executive: "经理",
    footer_cta_form_role_individualcontributor: "独立工作员工",
    footer_cta_form_role_manager: "总经理",
    footer_cta_form_role_principal: "校长",
    footer_cta_form_role_superintendent: "学监/区行政长官",
    footer_cta_form_role_teacher: "老师",
    footer_cta_form_role_techcoordinator: "技术协调员",
    footer_cta_form_role_vicepresident: "副总裁",
    footer_cta_form_submit: "免费咨询",
    footer_cta_how_hear_blog: "",
    footer_cta_how_hear_email: "电子邮件",
    footer_cta_how_hear_event: "事件",
    footer_cta_how_hear_online: "线上",
    footer_cta_how_hear_other: "其他",
    footer_cta_how_hear_referral: "推荐",
    footer_cta_how_hear_search: "搜索引擎",
    footer_cta_how_hear_social: "社交媒体",
    footer_cta_how_hear_title: "您是怎么知道我们的？ （可选的）",
    footer_cta_how_hear_webinar: "网络研讨会",
    footer_cta_opt_in_learn_more_button_text: "更多信息在這裡。",
    footer_cta_opt_in_learn_more_link_text_1: "隐私政策",
    footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_privacyUrl: "https://www.rosettastone.com/privacy",
    footer_cta_opt_in_learn_more_text_1: "通过确认，我同意接收有关Rosetta Stone产品和服务的新闻，更新以及Rosetta Stone活动邀请的信息和营销，我理解并同意Rosetta Stone可以处理并将我的信息传输给全球的附属公司 以及根据Rosetta Stone的规定，为Rosetta Stone提供服务的第三方实体",
    footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_text_3: "。",
    footer_cta_opt_in_text_after_button: "",
    footer_cta_opt_in_text_before_button: "是! 我想收到Rosetta Stone的产品更新和营销。",
    footer_cta_pricing_button: "价格 ",
    footer_cta_pricing_label: "准备好下一步了吗？",
    footer_cta_pricing_subtitle: "请完成，我们会立即与您联系。",
    footer_cta_pricing_title: "了解您所需要的价格信息。",
    footer_menu_about_careers_label: "职业发展",
    footer_menu_about_contact_label: "联系我们",
    footer_menu_about_investors_label: "投资者关系",
    footer_menu_about_label: "关于我们",
    footer_menu_about_press_label: "新闻",
    footer_menu_products_consumer_label: "从哪里开始？",
    footer_menu_products_education_primary_label: "高等教育",
    footer_menu_products_education_secondary_label: "培训中心",
    footer_menu_products_enterprise_label: "企业",
    footer_menu_products_label: "从哪里开始？",
    footer_menu_support_label: "支持",
    footer_menu_support_support_site_label: "支持网站",
    footer_meta_agreements_label: "协议",
    footer_meta_ccpa_label: "Do Not Sell My Information",
    footer_meta_cookie_settings_label: "Cookie设置",
    footer_meta_copyright_alt: "Go to home page",
    footer_meta_copyright_IXL: "A division of IXL Learning",
    footer_meta_copyright_label: "Rosetta Stone LLC.保留所有权利。 本网站使用cookies。 继续使用本网站即表示同意使用cookie。",
    footer_meta_icp_label: "京ICP备09009396号-7",
    footer_meta_icp_link: "https://beian.miit.gov.cn",
    footer_meta_privacy_policy_label: "隐私政策",
    footer_meta_terms_conditions_label: "条款和条件",
    footer_region_label: "变更地区",
    footer_region_options_br_label: "Brasil",
    footer_region_options_cn_label: "中国",
    footer_region_options_de_label: "Deutschland",
    footer_region_options_es_label: "España",
    footer_region_options_eu_label: "Europe",
    footer_region_options_fr_label: "France",
    footer_region_options_it_label: "Italia",
    footer_region_options_jp_label: "日本",
    footer_region_options_kr_label: "대한민국",
    footer_region_options_la_label: "America Latina",
    footer_region_options_uk_label: "United Kingdom",
    footer_region_options_us_label: "United States",
    footer_social_label: "Conecte-se conosco",
    footer_social_facebook_alt: "Facebook",
    footer_social_instagram_alt: "Instagram",
    footer_social_twitter_alt: "Twitter",
    footer_social_youtube_alt: "Youtube"
};

var configGenerator = ({ market, site, page, locale }) => {
    let strings;
    switch (locale) {
        case "de-DE":
            strings = strings_de_DE;
            break;
        case "en-GB":
            strings = strings_en_GB;
            break;
        case "es-419":
            strings = strings_es_419;
            break;
        case "es-ES":
            strings = strings_es_ES;
            break;
        case "fr-FR":
            strings = strings_fr_FR;
            break;
        case "it-IT":
            strings = strings_it_IT;
            break;
        case "ja-JP":
            strings = strings_ja_JP;
            break;
        case "ko-KR":
            strings = strings_ko_KR;
            break;
        case "pt-BR":
            strings = strings_pt_BR;
            break;
        case "zh-CN":
            strings = strings_zh_cn;
            break;
        default:
            strings = strings_en_US;
    }
    switch (market.toString().toLowerCase()) {
        case "cn":
            return (cn({ market, site, page, locale, strings }));
        case "de":
            return (de({ market, site, page, locale, strings }));
        case "es":
            return (es({ market, site, page, locale, strings }));
        case "fr":
            return (fr({ market, site, page, locale, strings }));
        case "it":
            return (it({ market, site, page, locale, strings }));
        case "la":
            return (la({ market, site, page, locale, strings }));
        case "ja":
            return (ja({ market, site, page, locale, strings }));
        case "ko":
            return (ko({ market, site, page, locale, strings }));
        case "pt":
            return (pt({ market, site, page, locale, strings }));
        case "uk":
            return (uk({ market, site, page, locale, strings }));
        case "us":
            return (us({ market, site, page, locale, strings }));
        default:
            return null;
    }
};

export { configGenerator as default };
//# sourceMappingURL=index.esm.js.map
